// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/brand/background-oillusion.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27><path fill=%27#fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27#fff%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23292b2c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --blue: #5e72e4;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #2dce89;
  --teal: #11cdef;
  --cyan: #2bffc6;
  --white: #fff;
  --gray: #8898aa;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #5e72e4;
  --secondary: #f7fafc;
  --success: #2dce89;
  --info: #11cdef;
  --warning: #fb6340;
  --danger: #f5365c;
  --light: #adb5bd;
  --dark: #212529;
  --default: #172b4d;
  --white: #fff;
  --neutral: #fff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: Open Sans, sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  background-color: #f8f9fe;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #5e72e4;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #233dd2;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #8898aa;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  color: #32325d;
}

h1, .h1 {
  font-size: 1.625rem;
}

h2, .h2 {
  font-size: 1.25rem;
}

h3, .h3 {
  font-size: 1.0625rem;
}

h4, .h4 {
  font-size: 0.9375rem;
}

h5, .h5 {
  font-size: 0.8125rem;
}

h6, .h6 {
  font-size: 0.625rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.5;
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8898aa;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f9fe;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8898aa;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #525f7f;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 1px solid #e9ecef;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
}
.table tbody + tbody {
  border-top: 2px solid #e9ecef;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem;
}

.table-bordered {
  border: 1px solid #e9ecef;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #e9ecef;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #525f7f;
  background-color: #f6f9fc;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #d2d8f7;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #abb6f1;
}

.table-hover .table-primary:hover {
  background-color: #bcc5f3;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #bcc5f3;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #fdfefe;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #fbfcfd;
}

.table-hover .table-secondary:hover {
  background-color: #ecf6f6;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #ecf6f6;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c4f1de;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #92e6c2;
}

.table-hover .table-success:hover {
  background-color: #afecd2;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #afecd2;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bcf1fb;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #83e5f7;
}

.table-hover .table-info:hover {
  background-color: #a4ecfa;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a4ecfa;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fed3ca;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fdae9c;
}

.table-hover .table-warning:hover {
  background-color: #febeb1;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #febeb1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fcc7d1;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #fa96aa;
}

.table-hover .table-danger:hover {
  background-color: #fbafbd;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #fbafbd;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #e8eaed;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #d4d9dd;
}

.table-hover .table-light:hover {
  background-color: #dadde2;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #dadde2;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c1c2c3;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #8c8e90;
}

.table-hover .table-dark:hover {
  background-color: #b4b5b6;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b4b5b6;
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: #bec4cd;
}
.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody + tbody {
  border-color: #8691a2;
}

.table-hover .table-default:hover {
  background-color: #b0b7c2;
}
.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: #b0b7c2;
}

.table-white,
.table-white > th,
.table-white > td {
  background-color: white;
}
.table-white th,
.table-white td,
.table-white thead th,
.table-white tbody + tbody {
  border-color: white;
}

.table-hover .table-white:hover {
  background-color: #f2f2f2;
}
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: #f2f2f2;
}

.table-neutral,
.table-neutral > th,
.table-neutral > td {
  background-color: white;
}
.table-neutral th,
.table-neutral td,
.table-neutral thead th,
.table-neutral tbody + tbody {
  border-color: white;
}

.table-hover .table-neutral:hover {
  background-color: #f2f2f2;
}
.table-hover .table-neutral:hover > td,
.table-hover .table-neutral:hover > th {
  background-color: #f2f2f2;
}

.table-darker,
.table-darker > th,
.table-darker > td {
  background-color: #b8b8b8;
}
.table-darker th,
.table-darker td,
.table-darker thead th,
.table-darker tbody + tbody {
  border-color: #7a7a7a;
}

.table-hover .table-darker:hover {
  background-color: #ababab;
}
.table-hover .table-darker:hover > td,
.table-hover .table-darker:hover > th {
  background-color: #ababab;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #f6f9fc;
}

.table-hover .table-active:hover {
  background-color: #e3ecf6;
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: #e3ecf6;
}

.table .thead-dark th {
  color: #f8f9fe;
  background-color: #172b4d;
  border-color: #1f3a68;
}
.table .thead-light th {
  color: #8898aa;
  background-color: #f6f9fc;
  border-color: #e9ecef;
}

.table-dark {
  color: #f8f9fe;
  background-color: #172b4d;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #1f3a68;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #f8f9fe;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  -webkit-appearance: none;
          appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}
select.form-control:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.625rem + 1px);
  padding-bottom: calc(0.625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.625rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #8898aa;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #2dce89;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(45, 206, 137, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #2dce89;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #2dce89;
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #2dce89;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #2dce89;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: #93e7c3;
  border-color: #93e7c3;
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: #54daa1;
  border-color: #93e7c3;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #2dce89;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #fb6340;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(251, 99, 64, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #fb6340;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #fb6340;
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #fb6340;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #fb6340;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: #fec9bd;
  border-color: #fec9bd;
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: #fc8c72;
  border-color: #fec9bd;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #fb6340;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #525f7f;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(94, 114, 228, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #324cdd;
  border-color: #5e72e4;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #d2e3ee;
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(45, 206, 137, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #24a46d;
  border-color: #2dce89;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(17, 205, 239, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0da5c0;
  border-color: #11cdef;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-warning {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #fa3a0e;
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #ec0c38;
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-light {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #fff;
  background-color: #919ca6;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #0a0c0d;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-default {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-default:focus, .btn-default.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(23, 43, 77, 0.5);
}
.btn-default.disabled, .btn-default:disabled {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {
  color: #fff;
  background-color: #0b1526;
  border-color: #172b4d;
}
.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-white:focus, .btn-white.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-white.disabled, .btn-white:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}
.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-neutral {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-neutral:focus, .btn-neutral.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-neutral.disabled, .btn-neutral:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: white;
}
.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-darker {
  color: #fff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:focus, .btn-darker.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-darker.disabled, .btn-darker:disabled {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-primary {
  color: #5e72e4;
  background-color: transparent;
  background-image: none;
  border-color: #5e72e4;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #5e72e4;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);
}

.btn-outline-secondary {
  color: #f7fafc;
  background-color: transparent;
  background-image: none;
  border-color: #f7fafc;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #f7fafc;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-outline-success {
  color: #2dce89;
  background-color: transparent;
  background-image: none;
  border-color: #2dce89;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #2dce89;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #2dce89;
  border-color: #2dce89;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);
}

.btn-outline-info {
  color: #11cdef;
  background-color: transparent;
  background-image: none;
  border-color: #11cdef;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #11cdef;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #11cdef;
  border-color: #11cdef;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);
}

.btn-outline-warning {
  color: #fb6340;
  background-color: transparent;
  background-image: none;
  border-color: #fb6340;
}
.btn-outline-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fb6340;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-outline-danger {
  color: #f5365c;
  background-color: transparent;
  background-image: none;
  border-color: #f5365c;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f5365c;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  background-color: transparent;
  background-image: none;
  border-color: #adb5bd;
}
.btn-outline-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #172b4d;
  background-color: transparent;
  background-image: none;
  border-color: #172b4d;
}
.btn-outline-default:hover {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-outline-default:focus, .btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}
.btn-outline-default.disabled, .btn-outline-default:disabled {
  color: #172b4d;
  background-color: transparent;
}
.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {
  color: #fff;
  background-color: #172b4d;
  border-color: #172b4d;
}
.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);
}

.btn-outline-white {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-white:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:focus, .btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white.disabled, .btn-outline-white:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-neutral:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:focus, .btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  background-color: transparent;
  background-image: none;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:focus, .btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker.disabled, .btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}
.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #5e72e4;
  text-decoration: none;
}
.btn-link:hover {
  color: #233dd2;
  text-decoration: none;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #8898aa;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.375rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.4375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #5e72e4;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #8898aa;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1.75rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 3rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.25rem;
  height: 1.375rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none, none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgba(50, 151, 211, 0.25);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
  box-shadow: none;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #8898aa;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #cad1d7;
  box-shadow: none;
}
.custom-control-label::after {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #5e72e4;
  background-color: #5e72e4;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-switch {
  padding-left: 3.9375rem;
}
.custom-switch .custom-control-label::before {
  left: -3.9375rem;
  width: 2.1875rem;
  pointer-events: all;
  border-radius: 0.625rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.125rem + 2px);
  left: calc(-3.9375rem + 2px);
  width: calc(1.25rem - 4px);
  height: calc(1.25rem - 4px);
  background-color: #cad1d7;
  border-radius: 0.625rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.9375rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(94, 114, 228, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 1.75rem 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  -webkit-appearance: none;
          appearance: none;
}
.custom-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #5e72e4;
}
.custom-select:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #8898aa;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(50, 151, 211, 0.25);
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  content: "Browse";
  background-color: #fff;
  border-left: inherit;
  border-radius: 0 0.375rem 0.375rem 0;
}

.custom-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #5e72e4;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #f7f8fe;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.25rem 0.75rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #8898aa;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #8898aa;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #f8f9fe;
  border-color: #dee2e6 #dee2e6 #f8f9fe;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.375rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5e72e4;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.0625rem;
  padding-bottom: 0.0625rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.375rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8898aa;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #8898aa;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.375rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #8898aa;
  text-decoration: none;
  background-color: #dee2e6;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.page-item.disabled .page-link {
  color: #8898aa;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4375rem;
  border-bottom-right-radius: 0.4375rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.badge {
  display: inline-block;
  padding: 0.35rem 0.375rem;
  font-size: 66%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 10rem;
}

.badge-primary {
  color: #2643e9;
  background-color: rgba(203, 210, 246, 0.5);
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #324cdd;
}

.badge-secondary {
  color: #cfe3f1;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #d2e3ee;
}

.badge-success {
  color: #1aae6f;
  background-color: rgba(147, 231, 195, 0.5);
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #24a46d;
}

.badge-info {
  color: #03acca;
  background-color: rgba(136, 230, 247, 0.5);
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0da5c0;
}

.badge-warning {
  color: #ff3709;
  background-color: rgba(254, 201, 189, 0.5);
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #fa3a0e;
}

.badge-danger {
  color: #f80031;
  background-color: rgba(251, 175, 190, 0.5);
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #ec0c38;
}

.badge-light {
  color: #879cb0;
  background-color: rgba(244, 245, 246, 0.5);
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #919ca6;
}

.badge-dark {
  color: #090c0e;
  background-color: rgba(90, 101, 112, 0.5);
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0a0c0d;
}

.badge-default {
  color: #091428;
  background-color: rgba(52, 98, 175, 0.5);
}
.badge-default[href]:hover, .badge-default[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: #0b1526;
}

.badge-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-white[href]:hover, .badge-white[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e6e6e6;
}

.badge-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-neutral[href]:hover, .badge-neutral[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: #e6e6e6;
}

.badge-darker {
  color: black;
  background-color: rgba(57, 64, 71, 0.5);
}
.badge-darker[href]:hover, .badge-darker[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: black;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4375rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 4.5rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1.5rem;
  color: inherit;
}

.alert-primary {
  color: #fff;
  background-color: #7889e8;
  border-color: #7889e8;
}
.alert-primary hr {
  border-top-color: #6276e4;
}
.alert-primary .alert-link {
  color: #324cdd;
}

.alert-secondary {
  color: #212529;
  background-color: #f8fbfc;
  border-color: #f8fbfc;
}
.alert-secondary hr {
  border-top-color: #e6f1f4;
}
.alert-secondary .alert-link {
  color: #d2e3ee;
}

.alert-success {
  color: #fff;
  background-color: #4fd69c;
  border-color: #4fd69c;
}
.alert-success hr {
  border-top-color: #3ad190;
}
.alert-success .alert-link {
  color: #24a46d;
}

.alert-info {
  color: #fff;
  background-color: #37d5f2;
  border-color: #37d5f2;
}
.alert-info hr {
  border-top-color: #1fd0f0;
}
.alert-info .alert-link {
  color: #0da5c0;
}

.alert-warning {
  color: #fff;
  background-color: #fc7c5f;
  border-color: #fc7c5f;
}
.alert-warning hr {
  border-top-color: #fc6846;
}
.alert-warning .alert-link {
  color: #fa3a0e;
}

.alert-danger {
  color: #fff;
  background-color: #f75676;
  border-color: #f75676;
}
.alert-danger hr {
  border-top-color: #f63e62;
}
.alert-danger .alert-link {
  color: #ec0c38;
}

.alert-light {
  color: #fff;
  background-color: #bac1c8;
  border-color: #bac1c8;
}
.alert-light hr {
  border-top-color: #acb4bd;
}
.alert-light .alert-link {
  color: #919ca6;
}

.alert-dark {
  color: #fff;
  background-color: #45484b;
  border-color: #45484b;
}
.alert-dark hr {
  border-top-color: #393b3e;
}
.alert-dark .alert-link {
  color: #0a0c0d;
}

.alert-default {
  color: #fff;
  background-color: #3c4d69;
  border-color: #3c4d69;
}
.alert-default hr {
  border-top-color: #334159;
}
.alert-default .alert-link {
  color: #0b1526;
}

.alert-white {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-white hr {
  border-top-color: #f2f2f2;
}
.alert-white .alert-link {
  color: #e6e6e6;
}

.alert-neutral {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-neutral hr {
  border-top-color: #f2f2f2;
}
.alert-neutral .alert-link {
  color: #e6e6e6;
}

.alert-darker {
  color: #fff;
  background-color: #292929;
  border-color: #292929;
}
.alert-darker hr {
  border-top-color: #1c1c1c;
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.375rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #5e72e4;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.375rem;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  background-color: #fff;
  border: 1px solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #8898aa;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #5e72e4;
  border-color: #5e72e4;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.375rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #313b77;
  background-color: #d2d8f7;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #313b77;
  background-color: #bcc5f3;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #313b77;
  border-color: #313b77;
}

.list-group-item-secondary {
  color: #808283;
  background-color: #fdfefe;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #808283;
  background-color: #ecf6f6;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #808283;
  border-color: #808283;
}

.list-group-item-success {
  color: #176b47;
  background-color: #c4f1de;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #176b47;
  background-color: #afecd2;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #176b47;
  border-color: #176b47;
}

.list-group-item-info {
  color: #096b7c;
  background-color: #bcf1fb;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #096b7c;
  background-color: #a4ecfa;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #096b7c;
  border-color: #096b7c;
}

.list-group-item-warning {
  color: #833321;
  background-color: #fed3ca;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #833321;
  background-color: #febeb1;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #833321;
  border-color: #833321;
}

.list-group-item-danger {
  color: #7f1c30;
  background-color: #fcc7d1;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #7f1c30;
  background-color: #fbafbd;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #7f1c30;
  border-color: #7f1c30;
}

.list-group-item-light {
  color: #5a5e62;
  background-color: #e8eaed;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #5a5e62;
  background-color: #dadde2;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #5a5e62;
  border-color: #5a5e62;
}

.list-group-item-dark {
  color: #111315;
  background-color: #c1c2c3;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #111315;
  background-color: #b4b5b6;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #111315;
  border-color: #111315;
}

.list-group-item-default {
  color: #0c1628;
  background-color: #bec4cd;
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: #0c1628;
  background-color: #b0b7c2;
}
.list-group-item-default.list-group-item-action.active {
  color: #fff;
  background-color: #0c1628;
  border-color: #0c1628;
}

.list-group-item-white {
  color: #858585;
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}
.list-group-item-white.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-neutral {
  color: #858585;
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: #858585;
  background-color: #f2f2f2;
}
.list-group-item-neutral.list-group-item-action.active {
  color: #fff;
  background-color: #858585;
  border-color: #858585;
}

.list-group-item-darker {
  color: black;
  background-color: #b8b8b8;
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: black;
  background-color: #ababab;
}
.list-group-item-darker.list-group-item-action.active {
  color: #fff;
  background-color: black;
  border-color: black;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}
.close:hover {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: -webkit-min-content;
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.2);
  border-radius: 0.4375rem;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 0 solid #e9ecef;
  border-top-left-radius: 0.4375rem;
  border-top-right-radius: 0.4375rem;
}
.modal-header .close {
  padding: 1.25rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1.25rem;
  border-top: 0 solid #e9ecef;
  border-bottom-right-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: -webkit-min-content;
    height: min-content;
  }
  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  }
  .modal-sm {
    max-width: 380px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.375rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4375rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
  margin: 0 0.4375rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.75rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.75rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: transparent;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.75rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: transparent;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.75rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.75rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: transparent;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.75rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: transparent;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.95rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #32325d;
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
  border-top-left-radius: calc(0.4375rem - 1px);
  border-top-right-radius: calc(0.4375rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.95rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #5e72e4 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #324cdd !important;
}

.bg-secondary {
  background-color: #f7fafc !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #d2e3ee !important;
}

.bg-success {
  background-color: #2dce89 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #24a46d !important;
}

.bg-info {
  background-color: #11cdef !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0da5c0 !important;
}

.bg-warning {
  background-color: #fb6340 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #fa3a0e !important;
}

.bg-danger {
  background-color: #f5365c !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #ec0c38 !important;
}

.bg-light {
  background-color: #adb5bd !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #919ca6 !important;
}

.bg-dark {
  background-color: #212529 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0a0c0d !important;
}

.bg-default {
  background-color: #172b4d !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-default:hover, a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: #0b1526 !important;
}

.bg-white {
  background-color: #fff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-neutral {
  background-color: #fff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-neutral:hover, a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: #e6e6e6 !important;
}

.bg-darker {
  background-color: black !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-darker:hover, a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #e9ecef !important;
}

.border-top {
  border-top: 1px solid #e9ecef !important;
}

.border-right {
  border-right: 1px solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.border-left {
  border-left: 1px solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #5e72e4 !important;
}

.border-secondary {
  border-color: #f7fafc !important;
}

.border-success {
  border-color: #2dce89 !important;
}

.border-info {
  border-color: #11cdef !important;
}

.border-warning {
  border-color: #fb6340 !important;
}

.border-danger {
  border-color: #f5365c !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #172b4d !important;
}

.border-white {
  border-color: #fff !important;
}

.border-neutral {
  border-color: #fff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.375rem !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}

.rounded-right {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-left {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-lg {
  border-radius: 0.4375rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow, .card-profile-image img {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m--9 {
  margin: -10rem !important;
}

.mt--9,
.my--9 {
  margin-top: -10rem !important;
}

.mr--9,
.mx--9 {
  margin-right: -10rem !important;
}

.mb--9,
.my--9 {
  margin-bottom: -10rem !important;
}

.ml--9,
.mx--9 {
  margin-left: -10rem !important;
}

.m--8 {
  margin: -8rem !important;
}

.mt--8,
.my--8 {
  margin-top: -8rem !important;
}

.mr--8,
.mx--8 {
  margin-right: -8rem !important;
}

.mb--8,
.my--8 {
  margin-bottom: -8rem !important;
}

.ml--8,
.mx--8 {
  margin-left: -8rem !important;
}

.m--7 {
  margin: -6rem !important;
}

.mt--7,
.my--7 {
  margin-top: -6rem !important;
}

.mr--7,
.mx--7 {
  margin-right: -6rem !important;
}

.mb--7,
.my--7 {
  margin-bottom: -6rem !important;
}

.ml--7,
.mx--7 {
  margin-left: -6rem !important;
}

.m--6 {
  margin: -4.5rem !important;
}

.mt--6,
.my--6 {
  margin-top: -4.5rem !important;
}

.mr--6,
.mx--6 {
  margin-right: -4.5rem !important;
}

.mb--6,
.my--6 {
  margin-bottom: -4.5rem !important;
}

.ml--6,
.mx--6 {
  margin-left: -4.5rem !important;
}

.m--5 {
  margin: -3rem !important;
}

.mt--5,
.my--5 {
  margin-top: -3rem !important;
}

.mr--5,
.mx--5 {
  margin-right: -3rem !important;
}

.mb--5,
.my--5 {
  margin-bottom: -3rem !important;
}

.ml--5,
.mx--5 {
  margin-left: -3rem !important;
}

.m--4 {
  margin: -1.5rem !important;
}

.mt--4,
.my--4 {
  margin-top: -1.5rem !important;
}

.mr--4,
.mx--4 {
  margin-right: -1.5rem !important;
}

.mb--4,
.my--4 {
  margin-bottom: -1.5rem !important;
}

.ml--4,
.mx--4 {
  margin-left: -1.5rem !important;
}

.m--3 {
  margin: -1rem !important;
}

.mt--3,
.my--3 {
  margin-top: -1rem !important;
}

.mr--3,
.mx--3 {
  margin-right: -1rem !important;
}

.mb--3,
.my--3 {
  margin-bottom: -1rem !important;
}

.ml--3,
.mx--3 {
  margin-left: -1rem !important;
}

.m--2 {
  margin: -0.5rem !important;
}

.mt--2,
.my--2 {
  margin-top: -0.5rem !important;
}

.mr--2,
.mx--2 {
  margin-right: -0.5rem !important;
}

.mb--2,
.my--2 {
  margin-bottom: -0.5rem !important;
}

.ml--2,
.mx--2 {
  margin-left: -0.5rem !important;
}

.m--1 {
  margin: -0.25rem !important;
}

.mt--1,
.my--1 {
  margin-top: -0.25rem !important;
}

.mr--1,
.mx--1 {
  margin-right: -0.25rem !important;
}

.mb--1,
.my--1 {
  margin-bottom: -0.25rem !important;
}

.ml--1,
.mx--1 {
  margin-left: -0.25rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.mt-6,
.my-6 {
  margin-top: 4.5rem !important;
}

.mr-6,
.mx-6 {
  margin-right: 4.5rem !important;
}

.mb-6,
.my-6 {
  margin-bottom: 4.5rem !important;
}

.ml-6,
.mx-6 {
  margin-left: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.mt-7,
.my-7 {
  margin-top: 6rem !important;
}

.mr-7,
.mx-7 {
  margin-right: 6rem !important;
}

.mb-7,
.my-7 {
  margin-bottom: 6rem !important;
}

.ml-7,
.mx-7 {
  margin-left: 6rem !important;
}

.m-8 {
  margin: 8rem !important;
}

.mt-8,
.my-8 {
  margin-top: 8rem !important;
}

.mr-8,
.mx-8 {
  margin-right: 8rem !important;
}

.mb-8,
.my-8 {
  margin-bottom: 8rem !important;
}

.ml-8,
.mx-8 {
  margin-left: 8rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.mt-9,
.my-9 {
  margin-top: 10rem !important;
}

.mr-9,
.mx-9 {
  margin-right: 10rem !important;
}

.mb-9,
.my-9 {
  margin-bottom: 10rem !important;
}

.ml-9,
.mx-9 {
  margin-left: 10rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p--9 {
  padding: -10rem !important;
}

.pt--9,
.py--9 {
  padding-top: -10rem !important;
}

.pr--9,
.px--9 {
  padding-right: -10rem !important;
}

.pb--9,
.py--9 {
  padding-bottom: -10rem !important;
}

.pl--9,
.px--9 {
  padding-left: -10rem !important;
}

.p--8 {
  padding: -8rem !important;
}

.pt--8,
.py--8 {
  padding-top: -8rem !important;
}

.pr--8,
.px--8 {
  padding-right: -8rem !important;
}

.pb--8,
.py--8 {
  padding-bottom: -8rem !important;
}

.pl--8,
.px--8 {
  padding-left: -8rem !important;
}

.p--7 {
  padding: -6rem !important;
}

.pt--7,
.py--7 {
  padding-top: -6rem !important;
}

.pr--7,
.px--7 {
  padding-right: -6rem !important;
}

.pb--7,
.py--7 {
  padding-bottom: -6rem !important;
}

.pl--7,
.px--7 {
  padding-left: -6rem !important;
}

.p--6 {
  padding: -4.5rem !important;
}

.pt--6,
.py--6 {
  padding-top: -4.5rem !important;
}

.pr--6,
.px--6 {
  padding-right: -4.5rem !important;
}

.pb--6,
.py--6 {
  padding-bottom: -4.5rem !important;
}

.pl--6,
.px--6 {
  padding-left: -4.5rem !important;
}

.p--5 {
  padding: -3rem !important;
}

.pt--5,
.py--5 {
  padding-top: -3rem !important;
}

.pr--5,
.px--5 {
  padding-right: -3rem !important;
}

.pb--5,
.py--5 {
  padding-bottom: -3rem !important;
}

.pl--5,
.px--5 {
  padding-left: -3rem !important;
}

.p--4 {
  padding: -1.5rem !important;
}

.pt--4,
.py--4 {
  padding-top: -1.5rem !important;
}

.pr--4,
.px--4 {
  padding-right: -1.5rem !important;
}

.pb--4,
.py--4 {
  padding-bottom: -1.5rem !important;
}

.pl--4,
.px--4 {
  padding-left: -1.5rem !important;
}

.p--3 {
  padding: -1rem !important;
}

.pt--3,
.py--3 {
  padding-top: -1rem !important;
}

.pr--3,
.px--3 {
  padding-right: -1rem !important;
}

.pb--3,
.py--3 {
  padding-bottom: -1rem !important;
}

.pl--3,
.px--3 {
  padding-left: -1rem !important;
}

.p--2 {
  padding: -0.5rem !important;
}

.pt--2,
.py--2 {
  padding-top: -0.5rem !important;
}

.pr--2,
.px--2 {
  padding-right: -0.5rem !important;
}

.pb--2,
.py--2 {
  padding-bottom: -0.5rem !important;
}

.pl--2,
.px--2 {
  padding-left: -0.5rem !important;
}

.p--1 {
  padding: -0.25rem !important;
}

.pt--1,
.py--1 {
  padding-top: -0.25rem !important;
}

.pr--1,
.px--1 {
  padding-right: -0.25rem !important;
}

.pb--1,
.py--1 {
  padding-bottom: -0.25rem !important;
}

.pl--1,
.px--1 {
  padding-left: -0.25rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.pt-6,
.py-6 {
  padding-top: 4.5rem !important;
}

.pr-6,
.px-6 {
  padding-right: 4.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 4.5rem !important;
}

.pl-6,
.px-6 {
  padding-left: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.pt-7,
.py-7 {
  padding-top: 6rem !important;
}

.pr-7,
.px-7 {
  padding-right: 6rem !important;
}

.pb-7,
.py-7 {
  padding-bottom: 6rem !important;
}

.pl-7,
.px-7 {
  padding-left: 6rem !important;
}

.p-8 {
  padding: 8rem !important;
}

.pt-8,
.py-8 {
  padding-top: 8rem !important;
}

.pr-8,
.px-8 {
  padding-right: 8rem !important;
}

.pb-8,
.py-8 {
  padding-bottom: 8rem !important;
}

.pl-8,
.px-8 {
  padding-left: 8rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.pt-9,
.py-9 {
  padding-top: 10rem !important;
}

.pr-9,
.px-9 {
  padding-right: 10rem !important;
}

.pb-9,
.py-9 {
  padding-bottom: 10rem !important;
}

.pl-9,
.px-9 {
  padding-left: 10rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-n-9 {
  margin: 10rem !important;
}

.mt-n-9,
.my-n-9 {
  margin-top: 10rem !important;
}

.mr-n-9,
.mx-n-9 {
  margin-right: 10rem !important;
}

.mb-n-9,
.my-n-9 {
  margin-bottom: 10rem !important;
}

.ml-n-9,
.mx-n-9 {
  margin-left: 10rem !important;
}

.m-n-8 {
  margin: 8rem !important;
}

.mt-n-8,
.my-n-8 {
  margin-top: 8rem !important;
}

.mr-n-8,
.mx-n-8 {
  margin-right: 8rem !important;
}

.mb-n-8,
.my-n-8 {
  margin-bottom: 8rem !important;
}

.ml-n-8,
.mx-n-8 {
  margin-left: 8rem !important;
}

.m-n-7 {
  margin: 6rem !important;
}

.mt-n-7,
.my-n-7 {
  margin-top: 6rem !important;
}

.mr-n-7,
.mx-n-7 {
  margin-right: 6rem !important;
}

.mb-n-7,
.my-n-7 {
  margin-bottom: 6rem !important;
}

.ml-n-7,
.mx-n-7 {
  margin-left: 6rem !important;
}

.m-n-6 {
  margin: 4.5rem !important;
}

.mt-n-6,
.my-n-6 {
  margin-top: 4.5rem !important;
}

.mr-n-6,
.mx-n-6 {
  margin-right: 4.5rem !important;
}

.mb-n-6,
.my-n-6 {
  margin-bottom: 4.5rem !important;
}

.ml-n-6,
.mx-n-6 {
  margin-left: 4.5rem !important;
}

.m-n-5 {
  margin: 3rem !important;
}

.mt-n-5,
.my-n-5 {
  margin-top: 3rem !important;
}

.mr-n-5,
.mx-n-5 {
  margin-right: 3rem !important;
}

.mb-n-5,
.my-n-5 {
  margin-bottom: 3rem !important;
}

.ml-n-5,
.mx-n-5 {
  margin-left: 3rem !important;
}

.m-n-4 {
  margin: 1.5rem !important;
}

.mt-n-4,
.my-n-4 {
  margin-top: 1.5rem !important;
}

.mr-n-4,
.mx-n-4 {
  margin-right: 1.5rem !important;
}

.mb-n-4,
.my-n-4 {
  margin-bottom: 1.5rem !important;
}

.ml-n-4,
.mx-n-4 {
  margin-left: 1.5rem !important;
}

.m-n-3 {
  margin: 1rem !important;
}

.mt-n-3,
.my-n-3 {
  margin-top: 1rem !important;
}

.mr-n-3,
.mx-n-3 {
  margin-right: 1rem !important;
}

.mb-n-3,
.my-n-3 {
  margin-bottom: 1rem !important;
}

.ml-n-3,
.mx-n-3 {
  margin-left: 1rem !important;
}

.m-n-2 {
  margin: 0.5rem !important;
}

.mt-n-2,
.my-n-2 {
  margin-top: 0.5rem !important;
}

.mr-n-2,
.mx-n-2 {
  margin-right: 0.5rem !important;
}

.mb-n-2,
.my-n-2 {
  margin-bottom: 0.5rem !important;
}

.ml-n-2,
.mx-n-2 {
  margin-left: 0.5rem !important;
}

.m-n-1 {
  margin: 0.25rem !important;
}

.mt-n-1,
.my-n-1 {
  margin-top: 0.25rem !important;
}

.mr-n-1,
.mx-n-1 {
  margin-right: 0.25rem !important;
}

.mb-n-1,
.my-n-1 {
  margin-bottom: 0.25rem !important;
}

.ml-n-1,
.mx-n-1 {
  margin-left: 0.25rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.mt-n6,
.my-n6 {
  margin-top: -4.5rem !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -4.5rem !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -4.5rem !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.mt-n7,
.my-n7 {
  margin-top: -6rem !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -6rem !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -6rem !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -6rem !important;
}

.m-n8 {
  margin: -8rem !important;
}

.mt-n8,
.my-n8 {
  margin-top: -8rem !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -8rem !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -8rem !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -8rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.mt-n9,
.my-n9 {
  margin-top: -10rem !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -10rem !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -10rem !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -10rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .m-sm--9 {
    margin: -10rem !important;
  }
  .mt-sm--9,
  .my-sm--9 {
    margin-top: -10rem !important;
  }
  .mr-sm--9,
  .mx-sm--9 {
    margin-right: -10rem !important;
  }
  .mb-sm--9,
  .my-sm--9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm--9,
  .mx-sm--9 {
    margin-left: -10rem !important;
  }
  .m-sm--8 {
    margin: -8rem !important;
  }
  .mt-sm--8,
  .my-sm--8 {
    margin-top: -8rem !important;
  }
  .mr-sm--8,
  .mx-sm--8 {
    margin-right: -8rem !important;
  }
  .mb-sm--8,
  .my-sm--8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm--8,
  .mx-sm--8 {
    margin-left: -8rem !important;
  }
  .m-sm--7 {
    margin: -6rem !important;
  }
  .mt-sm--7,
  .my-sm--7 {
    margin-top: -6rem !important;
  }
  .mr-sm--7,
  .mx-sm--7 {
    margin-right: -6rem !important;
  }
  .mb-sm--7,
  .my-sm--7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm--7,
  .mx-sm--7 {
    margin-left: -6rem !important;
  }
  .m-sm--6 {
    margin: -4.5rem !important;
  }
  .mt-sm--6,
  .my-sm--6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm--6,
  .mx-sm--6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm--6,
  .my-sm--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm--6,
  .mx-sm--6 {
    margin-left: -4.5rem !important;
  }
  .m-sm--5 {
    margin: -3rem !important;
  }
  .mt-sm--5,
  .my-sm--5 {
    margin-top: -3rem !important;
  }
  .mr-sm--5,
  .mx-sm--5 {
    margin-right: -3rem !important;
  }
  .mb-sm--5,
  .my-sm--5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm--5,
  .mx-sm--5 {
    margin-left: -3rem !important;
  }
  .m-sm--4 {
    margin: -1.5rem !important;
  }
  .mt-sm--4,
  .my-sm--4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm--4,
  .mx-sm--4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm--4,
  .my-sm--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm--4,
  .mx-sm--4 {
    margin-left: -1.5rem !important;
  }
  .m-sm--3 {
    margin: -1rem !important;
  }
  .mt-sm--3,
  .my-sm--3 {
    margin-top: -1rem !important;
  }
  .mr-sm--3,
  .mx-sm--3 {
    margin-right: -1rem !important;
  }
  .mb-sm--3,
  .my-sm--3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm--3,
  .mx-sm--3 {
    margin-left: -1rem !important;
  }
  .m-sm--2 {
    margin: -0.5rem !important;
  }
  .mt-sm--2,
  .my-sm--2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm--2,
  .mx-sm--2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm--2,
  .my-sm--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm--2,
  .mx-sm--2 {
    margin-left: -0.5rem !important;
  }
  .m-sm--1 {
    margin: -0.25rem !important;
  }
  .mt-sm--1,
  .my-sm--1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm--1,
  .mx-sm--1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm--1,
  .my-sm--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm--1,
  .mx-sm--1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-6,
  .my-sm-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-7 {
    margin: 6rem !important;
  }
  .mt-sm-7,
  .my-sm-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 6rem !important;
  }
  .m-sm-8 {
    margin: 8rem !important;
  }
  .mt-sm-8,
  .my-sm-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 8rem !important;
  }
  .m-sm-9 {
    margin: 10rem !important;
  }
  .mt-sm-9,
  .my-sm-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 10rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .p-sm--9 {
    padding: -10rem !important;
  }
  .pt-sm--9,
  .py-sm--9 {
    padding-top: -10rem !important;
  }
  .pr-sm--9,
  .px-sm--9 {
    padding-right: -10rem !important;
  }
  .pb-sm--9,
  .py-sm--9 {
    padding-bottom: -10rem !important;
  }
  .pl-sm--9,
  .px-sm--9 {
    padding-left: -10rem !important;
  }
  .p-sm--8 {
    padding: -8rem !important;
  }
  .pt-sm--8,
  .py-sm--8 {
    padding-top: -8rem !important;
  }
  .pr-sm--8,
  .px-sm--8 {
    padding-right: -8rem !important;
  }
  .pb-sm--8,
  .py-sm--8 {
    padding-bottom: -8rem !important;
  }
  .pl-sm--8,
  .px-sm--8 {
    padding-left: -8rem !important;
  }
  .p-sm--7 {
    padding: -6rem !important;
  }
  .pt-sm--7,
  .py-sm--7 {
    padding-top: -6rem !important;
  }
  .pr-sm--7,
  .px-sm--7 {
    padding-right: -6rem !important;
  }
  .pb-sm--7,
  .py-sm--7 {
    padding-bottom: -6rem !important;
  }
  .pl-sm--7,
  .px-sm--7 {
    padding-left: -6rem !important;
  }
  .p-sm--6 {
    padding: -4.5rem !important;
  }
  .pt-sm--6,
  .py-sm--6 {
    padding-top: -4.5rem !important;
  }
  .pr-sm--6,
  .px-sm--6 {
    padding-right: -4.5rem !important;
  }
  .pb-sm--6,
  .py-sm--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-sm--6,
  .px-sm--6 {
    padding-left: -4.5rem !important;
  }
  .p-sm--5 {
    padding: -3rem !important;
  }
  .pt-sm--5,
  .py-sm--5 {
    padding-top: -3rem !important;
  }
  .pr-sm--5,
  .px-sm--5 {
    padding-right: -3rem !important;
  }
  .pb-sm--5,
  .py-sm--5 {
    padding-bottom: -3rem !important;
  }
  .pl-sm--5,
  .px-sm--5 {
    padding-left: -3rem !important;
  }
  .p-sm--4 {
    padding: -1.5rem !important;
  }
  .pt-sm--4,
  .py-sm--4 {
    padding-top: -1.5rem !important;
  }
  .pr-sm--4,
  .px-sm--4 {
    padding-right: -1.5rem !important;
  }
  .pb-sm--4,
  .py-sm--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-sm--4,
  .px-sm--4 {
    padding-left: -1.5rem !important;
  }
  .p-sm--3 {
    padding: -1rem !important;
  }
  .pt-sm--3,
  .py-sm--3 {
    padding-top: -1rem !important;
  }
  .pr-sm--3,
  .px-sm--3 {
    padding-right: -1rem !important;
  }
  .pb-sm--3,
  .py-sm--3 {
    padding-bottom: -1rem !important;
  }
  .pl-sm--3,
  .px-sm--3 {
    padding-left: -1rem !important;
  }
  .p-sm--2 {
    padding: -0.5rem !important;
  }
  .pt-sm--2,
  .py-sm--2 {
    padding-top: -0.5rem !important;
  }
  .pr-sm--2,
  .px-sm--2 {
    padding-right: -0.5rem !important;
  }
  .pb-sm--2,
  .py-sm--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-sm--2,
  .px-sm--2 {
    padding-left: -0.5rem !important;
  }
  .p-sm--1 {
    padding: -0.25rem !important;
  }
  .pt-sm--1,
  .py-sm--1 {
    padding-top: -0.25rem !important;
  }
  .pr-sm--1,
  .px-sm--1 {
    padding-right: -0.25rem !important;
  }
  .pb-sm--1,
  .py-sm--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-sm--1,
  .px-sm--1 {
    padding-left: -0.25rem !important;
  }
  .p-sm-6 {
    padding: 4.5rem !important;
  }
  .pt-sm-6,
  .py-sm-6 {
    padding-top: 4.5rem !important;
  }
  .pr-sm-6,
  .px-sm-6 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-sm-6,
  .px-sm-6 {
    padding-left: 4.5rem !important;
  }
  .p-sm-7 {
    padding: 6rem !important;
  }
  .pt-sm-7,
  .py-sm-7 {
    padding-top: 6rem !important;
  }
  .pr-sm-7,
  .px-sm-7 {
    padding-right: 6rem !important;
  }
  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 6rem !important;
  }
  .pl-sm-7,
  .px-sm-7 {
    padding-left: 6rem !important;
  }
  .p-sm-8 {
    padding: 8rem !important;
  }
  .pt-sm-8,
  .py-sm-8 {
    padding-top: 8rem !important;
  }
  .pr-sm-8,
  .px-sm-8 {
    padding-right: 8rem !important;
  }
  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 8rem !important;
  }
  .pl-sm-8,
  .px-sm-8 {
    padding-left: 8rem !important;
  }
  .p-sm-9 {
    padding: 10rem !important;
  }
  .pt-sm-9,
  .py-sm-9 {
    padding-top: 10rem !important;
  }
  .pr-sm-9,
  .px-sm-9 {
    padding-right: 10rem !important;
  }
  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 10rem !important;
  }
  .pl-sm-9,
  .px-sm-9 {
    padding-left: 10rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-n-9 {
    margin: 10rem !important;
  }
  .mt-sm-n-9,
  .my-sm-n-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-n-9,
  .mx-sm-n-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-n-9,
  .my-sm-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-n-9,
  .mx-sm-n-9 {
    margin-left: 10rem !important;
  }
  .m-sm-n-8 {
    margin: 8rem !important;
  }
  .mt-sm-n-8,
  .my-sm-n-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-n-8,
  .mx-sm-n-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-n-8,
  .my-sm-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-n-8,
  .mx-sm-n-8 {
    margin-left: 8rem !important;
  }
  .m-sm-n-7 {
    margin: 6rem !important;
  }
  .mt-sm-n-7,
  .my-sm-n-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-n-7,
  .mx-sm-n-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-n-7,
  .my-sm-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-n-7,
  .mx-sm-n-7 {
    margin-left: 6rem !important;
  }
  .m-sm-n-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-n-6,
  .my-sm-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-n-6,
  .mx-sm-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-n-6,
  .my-sm-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-n-6,
  .mx-sm-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-n-5 {
    margin: 3rem !important;
  }
  .mt-sm-n-5,
  .my-sm-n-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-n-5,
  .mx-sm-n-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-n-5,
  .my-sm-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-n-5,
  .mx-sm-n-5 {
    margin-left: 3rem !important;
  }
  .m-sm-n-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-n-4,
  .my-sm-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-n-4,
  .mx-sm-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-n-4,
  .my-sm-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-n-4,
  .mx-sm-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-n-3 {
    margin: 1rem !important;
  }
  .mt-sm-n-3,
  .my-sm-n-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-n-3,
  .mx-sm-n-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-n-3,
  .my-sm-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-n-3,
  .mx-sm-n-3 {
    margin-left: 1rem !important;
  }
  .m-sm-n-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-n-2,
  .my-sm-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-n-2,
  .mx-sm-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-n-2,
  .my-sm-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-n-2,
  .mx-sm-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-n-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-n-1,
  .my-sm-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-n-1,
  .mx-sm-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-n-1,
  .my-sm-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-n-1,
  .mx-sm-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-n6 {
    margin: -4.5rem !important;
  }
  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -4.5rem !important;
  }
  .m-sm-n7 {
    margin: -6rem !important;
  }
  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -6rem !important;
  }
  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -6rem !important;
  }
  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -6rem !important;
  }
  .m-sm-n8 {
    margin: -8rem !important;
  }
  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -8rem !important;
  }
  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -8rem !important;
  }
  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -8rem !important;
  }
  .m-sm-n9 {
    margin: -10rem !important;
  }
  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -10rem !important;
  }
  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -10rem !important;
  }
  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -10rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .m-md--9 {
    margin: -10rem !important;
  }
  .mt-md--9,
  .my-md--9 {
    margin-top: -10rem !important;
  }
  .mr-md--9,
  .mx-md--9 {
    margin-right: -10rem !important;
  }
  .mb-md--9,
  .my-md--9 {
    margin-bottom: -10rem !important;
  }
  .ml-md--9,
  .mx-md--9 {
    margin-left: -10rem !important;
  }
  .m-md--8 {
    margin: -8rem !important;
  }
  .mt-md--8,
  .my-md--8 {
    margin-top: -8rem !important;
  }
  .mr-md--8,
  .mx-md--8 {
    margin-right: -8rem !important;
  }
  .mb-md--8,
  .my-md--8 {
    margin-bottom: -8rem !important;
  }
  .ml-md--8,
  .mx-md--8 {
    margin-left: -8rem !important;
  }
  .m-md--7 {
    margin: -6rem !important;
  }
  .mt-md--7,
  .my-md--7 {
    margin-top: -6rem !important;
  }
  .mr-md--7,
  .mx-md--7 {
    margin-right: -6rem !important;
  }
  .mb-md--7,
  .my-md--7 {
    margin-bottom: -6rem !important;
  }
  .ml-md--7,
  .mx-md--7 {
    margin-left: -6rem !important;
  }
  .m-md--6 {
    margin: -4.5rem !important;
  }
  .mt-md--6,
  .my-md--6 {
    margin-top: -4.5rem !important;
  }
  .mr-md--6,
  .mx-md--6 {
    margin-right: -4.5rem !important;
  }
  .mb-md--6,
  .my-md--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md--6,
  .mx-md--6 {
    margin-left: -4.5rem !important;
  }
  .m-md--5 {
    margin: -3rem !important;
  }
  .mt-md--5,
  .my-md--5 {
    margin-top: -3rem !important;
  }
  .mr-md--5,
  .mx-md--5 {
    margin-right: -3rem !important;
  }
  .mb-md--5,
  .my-md--5 {
    margin-bottom: -3rem !important;
  }
  .ml-md--5,
  .mx-md--5 {
    margin-left: -3rem !important;
  }
  .m-md--4 {
    margin: -1.5rem !important;
  }
  .mt-md--4,
  .my-md--4 {
    margin-top: -1.5rem !important;
  }
  .mr-md--4,
  .mx-md--4 {
    margin-right: -1.5rem !important;
  }
  .mb-md--4,
  .my-md--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md--4,
  .mx-md--4 {
    margin-left: -1.5rem !important;
  }
  .m-md--3 {
    margin: -1rem !important;
  }
  .mt-md--3,
  .my-md--3 {
    margin-top: -1rem !important;
  }
  .mr-md--3,
  .mx-md--3 {
    margin-right: -1rem !important;
  }
  .mb-md--3,
  .my-md--3 {
    margin-bottom: -1rem !important;
  }
  .ml-md--3,
  .mx-md--3 {
    margin-left: -1rem !important;
  }
  .m-md--2 {
    margin: -0.5rem !important;
  }
  .mt-md--2,
  .my-md--2 {
    margin-top: -0.5rem !important;
  }
  .mr-md--2,
  .mx-md--2 {
    margin-right: -0.5rem !important;
  }
  .mb-md--2,
  .my-md--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md--2,
  .mx-md--2 {
    margin-left: -0.5rem !important;
  }
  .m-md--1 {
    margin: -0.25rem !important;
  }
  .mt-md--1,
  .my-md--1 {
    margin-top: -0.25rem !important;
  }
  .mr-md--1,
  .mx-md--1 {
    margin-right: -0.25rem !important;
  }
  .mb-md--1,
  .my-md--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md--1,
  .mx-md--1 {
    margin-left: -0.25rem !important;
  }
  .m-md-6 {
    margin: 4.5rem !important;
  }
  .mt-md-6,
  .my-md-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-6,
  .mx-md-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-6,
  .my-md-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-6,
  .mx-md-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-7 {
    margin: 6rem !important;
  }
  .mt-md-7,
  .my-md-7 {
    margin-top: 6rem !important;
  }
  .mr-md-7,
  .mx-md-7 {
    margin-right: 6rem !important;
  }
  .mb-md-7,
  .my-md-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-7,
  .mx-md-7 {
    margin-left: 6rem !important;
  }
  .m-md-8 {
    margin: 8rem !important;
  }
  .mt-md-8,
  .my-md-8 {
    margin-top: 8rem !important;
  }
  .mr-md-8,
  .mx-md-8 {
    margin-right: 8rem !important;
  }
  .mb-md-8,
  .my-md-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-8,
  .mx-md-8 {
    margin-left: 8rem !important;
  }
  .m-md-9 {
    margin: 10rem !important;
  }
  .mt-md-9,
  .my-md-9 {
    margin-top: 10rem !important;
  }
  .mr-md-9,
  .mx-md-9 {
    margin-right: 10rem !important;
  }
  .mb-md-9,
  .my-md-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-9,
  .mx-md-9 {
    margin-left: 10rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .p-md--9 {
    padding: -10rem !important;
  }
  .pt-md--9,
  .py-md--9 {
    padding-top: -10rem !important;
  }
  .pr-md--9,
  .px-md--9 {
    padding-right: -10rem !important;
  }
  .pb-md--9,
  .py-md--9 {
    padding-bottom: -10rem !important;
  }
  .pl-md--9,
  .px-md--9 {
    padding-left: -10rem !important;
  }
  .p-md--8 {
    padding: -8rem !important;
  }
  .pt-md--8,
  .py-md--8 {
    padding-top: -8rem !important;
  }
  .pr-md--8,
  .px-md--8 {
    padding-right: -8rem !important;
  }
  .pb-md--8,
  .py-md--8 {
    padding-bottom: -8rem !important;
  }
  .pl-md--8,
  .px-md--8 {
    padding-left: -8rem !important;
  }
  .p-md--7 {
    padding: -6rem !important;
  }
  .pt-md--7,
  .py-md--7 {
    padding-top: -6rem !important;
  }
  .pr-md--7,
  .px-md--7 {
    padding-right: -6rem !important;
  }
  .pb-md--7,
  .py-md--7 {
    padding-bottom: -6rem !important;
  }
  .pl-md--7,
  .px-md--7 {
    padding-left: -6rem !important;
  }
  .p-md--6 {
    padding: -4.5rem !important;
  }
  .pt-md--6,
  .py-md--6 {
    padding-top: -4.5rem !important;
  }
  .pr-md--6,
  .px-md--6 {
    padding-right: -4.5rem !important;
  }
  .pb-md--6,
  .py-md--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-md--6,
  .px-md--6 {
    padding-left: -4.5rem !important;
  }
  .p-md--5 {
    padding: -3rem !important;
  }
  .pt-md--5,
  .py-md--5 {
    padding-top: -3rem !important;
  }
  .pr-md--5,
  .px-md--5 {
    padding-right: -3rem !important;
  }
  .pb-md--5,
  .py-md--5 {
    padding-bottom: -3rem !important;
  }
  .pl-md--5,
  .px-md--5 {
    padding-left: -3rem !important;
  }
  .p-md--4 {
    padding: -1.5rem !important;
  }
  .pt-md--4,
  .py-md--4 {
    padding-top: -1.5rem !important;
  }
  .pr-md--4,
  .px-md--4 {
    padding-right: -1.5rem !important;
  }
  .pb-md--4,
  .py-md--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-md--4,
  .px-md--4 {
    padding-left: -1.5rem !important;
  }
  .p-md--3 {
    padding: -1rem !important;
  }
  .pt-md--3,
  .py-md--3 {
    padding-top: -1rem !important;
  }
  .pr-md--3,
  .px-md--3 {
    padding-right: -1rem !important;
  }
  .pb-md--3,
  .py-md--3 {
    padding-bottom: -1rem !important;
  }
  .pl-md--3,
  .px-md--3 {
    padding-left: -1rem !important;
  }
  .p-md--2 {
    padding: -0.5rem !important;
  }
  .pt-md--2,
  .py-md--2 {
    padding-top: -0.5rem !important;
  }
  .pr-md--2,
  .px-md--2 {
    padding-right: -0.5rem !important;
  }
  .pb-md--2,
  .py-md--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-md--2,
  .px-md--2 {
    padding-left: -0.5rem !important;
  }
  .p-md--1 {
    padding: -0.25rem !important;
  }
  .pt-md--1,
  .py-md--1 {
    padding-top: -0.25rem !important;
  }
  .pr-md--1,
  .px-md--1 {
    padding-right: -0.25rem !important;
  }
  .pb-md--1,
  .py-md--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-md--1,
  .px-md--1 {
    padding-left: -0.25rem !important;
  }
  .p-md-6 {
    padding: 4.5rem !important;
  }
  .pt-md-6,
  .py-md-6 {
    padding-top: 4.5rem !important;
  }
  .pr-md-6,
  .px-md-6 {
    padding-right: 4.5rem !important;
  }
  .pb-md-6,
  .py-md-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-md-6,
  .px-md-6 {
    padding-left: 4.5rem !important;
  }
  .p-md-7 {
    padding: 6rem !important;
  }
  .pt-md-7,
  .py-md-7 {
    padding-top: 6rem !important;
  }
  .pr-md-7,
  .px-md-7 {
    padding-right: 6rem !important;
  }
  .pb-md-7,
  .py-md-7 {
    padding-bottom: 6rem !important;
  }
  .pl-md-7,
  .px-md-7 {
    padding-left: 6rem !important;
  }
  .p-md-8 {
    padding: 8rem !important;
  }
  .pt-md-8,
  .py-md-8 {
    padding-top: 8rem !important;
  }
  .pr-md-8,
  .px-md-8 {
    padding-right: 8rem !important;
  }
  .pb-md-8,
  .py-md-8 {
    padding-bottom: 8rem !important;
  }
  .pl-md-8,
  .px-md-8 {
    padding-left: 8rem !important;
  }
  .p-md-9 {
    padding: 10rem !important;
  }
  .pt-md-9,
  .py-md-9 {
    padding-top: 10rem !important;
  }
  .pr-md-9,
  .px-md-9 {
    padding-right: 10rem !important;
  }
  .pb-md-9,
  .py-md-9 {
    padding-bottom: 10rem !important;
  }
  .pl-md-9,
  .px-md-9 {
    padding-left: 10rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-n-9 {
    margin: 10rem !important;
  }
  .mt-md-n-9,
  .my-md-n-9 {
    margin-top: 10rem !important;
  }
  .mr-md-n-9,
  .mx-md-n-9 {
    margin-right: 10rem !important;
  }
  .mb-md-n-9,
  .my-md-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-n-9,
  .mx-md-n-9 {
    margin-left: 10rem !important;
  }
  .m-md-n-8 {
    margin: 8rem !important;
  }
  .mt-md-n-8,
  .my-md-n-8 {
    margin-top: 8rem !important;
  }
  .mr-md-n-8,
  .mx-md-n-8 {
    margin-right: 8rem !important;
  }
  .mb-md-n-8,
  .my-md-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-n-8,
  .mx-md-n-8 {
    margin-left: 8rem !important;
  }
  .m-md-n-7 {
    margin: 6rem !important;
  }
  .mt-md-n-7,
  .my-md-n-7 {
    margin-top: 6rem !important;
  }
  .mr-md-n-7,
  .mx-md-n-7 {
    margin-right: 6rem !important;
  }
  .mb-md-n-7,
  .my-md-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-n-7,
  .mx-md-n-7 {
    margin-left: 6rem !important;
  }
  .m-md-n-6 {
    margin: 4.5rem !important;
  }
  .mt-md-n-6,
  .my-md-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-n-6,
  .mx-md-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-n-6,
  .my-md-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-n-6,
  .mx-md-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-n-5 {
    margin: 3rem !important;
  }
  .mt-md-n-5,
  .my-md-n-5 {
    margin-top: 3rem !important;
  }
  .mr-md-n-5,
  .mx-md-n-5 {
    margin-right: 3rem !important;
  }
  .mb-md-n-5,
  .my-md-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-n-5,
  .mx-md-n-5 {
    margin-left: 3rem !important;
  }
  .m-md-n-4 {
    margin: 1.5rem !important;
  }
  .mt-md-n-4,
  .my-md-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-n-4,
  .mx-md-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-n-4,
  .my-md-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-n-4,
  .mx-md-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-n-3 {
    margin: 1rem !important;
  }
  .mt-md-n-3,
  .my-md-n-3 {
    margin-top: 1rem !important;
  }
  .mr-md-n-3,
  .mx-md-n-3 {
    margin-right: 1rem !important;
  }
  .mb-md-n-3,
  .my-md-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-n-3,
  .mx-md-n-3 {
    margin-left: 1rem !important;
  }
  .m-md-n-2 {
    margin: 0.5rem !important;
  }
  .mt-md-n-2,
  .my-md-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-n-2,
  .mx-md-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-n-2,
  .my-md-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-n-2,
  .mx-md-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-n-1 {
    margin: 0.25rem !important;
  }
  .mt-md-n-1,
  .my-md-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-n-1,
  .mx-md-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-n-1,
  .my-md-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-n-1,
  .mx-md-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-n6 {
    margin: -4.5rem !important;
  }
  .mt-md-n6,
  .my-md-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -4.5rem !important;
  }
  .m-md-n7 {
    margin: -6rem !important;
  }
  .mt-md-n7,
  .my-md-n7 {
    margin-top: -6rem !important;
  }
  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -6rem !important;
  }
  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -6rem !important;
  }
  .m-md-n8 {
    margin: -8rem !important;
  }
  .mt-md-n8,
  .my-md-n8 {
    margin-top: -8rem !important;
  }
  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -8rem !important;
  }
  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -8rem !important;
  }
  .m-md-n9 {
    margin: -10rem !important;
  }
  .mt-md-n9,
  .my-md-n9 {
    margin-top: -10rem !important;
  }
  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -10rem !important;
  }
  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -10rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .m-lg--9 {
    margin: -10rem !important;
  }
  .mt-lg--9,
  .my-lg--9 {
    margin-top: -10rem !important;
  }
  .mr-lg--9,
  .mx-lg--9 {
    margin-right: -10rem !important;
  }
  .mb-lg--9,
  .my-lg--9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg--9,
  .mx-lg--9 {
    margin-left: -10rem !important;
  }
  .m-lg--8 {
    margin: -8rem !important;
  }
  .mt-lg--8,
  .my-lg--8 {
    margin-top: -8rem !important;
  }
  .mr-lg--8,
  .mx-lg--8 {
    margin-right: -8rem !important;
  }
  .mb-lg--8,
  .my-lg--8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg--8,
  .mx-lg--8 {
    margin-left: -8rem !important;
  }
  .m-lg--7 {
    margin: -6rem !important;
  }
  .mt-lg--7,
  .my-lg--7 {
    margin-top: -6rem !important;
  }
  .mr-lg--7,
  .mx-lg--7 {
    margin-right: -6rem !important;
  }
  .mb-lg--7,
  .my-lg--7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg--7,
  .mx-lg--7 {
    margin-left: -6rem !important;
  }
  .m-lg--6 {
    margin: -4.5rem !important;
  }
  .mt-lg--6,
  .my-lg--6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg--6,
  .mx-lg--6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg--6,
  .my-lg--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg--6,
  .mx-lg--6 {
    margin-left: -4.5rem !important;
  }
  .m-lg--5 {
    margin: -3rem !important;
  }
  .mt-lg--5,
  .my-lg--5 {
    margin-top: -3rem !important;
  }
  .mr-lg--5,
  .mx-lg--5 {
    margin-right: -3rem !important;
  }
  .mb-lg--5,
  .my-lg--5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg--5,
  .mx-lg--5 {
    margin-left: -3rem !important;
  }
  .m-lg--4 {
    margin: -1.5rem !important;
  }
  .mt-lg--4,
  .my-lg--4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg--4,
  .mx-lg--4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg--4,
  .my-lg--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg--4,
  .mx-lg--4 {
    margin-left: -1.5rem !important;
  }
  .m-lg--3 {
    margin: -1rem !important;
  }
  .mt-lg--3,
  .my-lg--3 {
    margin-top: -1rem !important;
  }
  .mr-lg--3,
  .mx-lg--3 {
    margin-right: -1rem !important;
  }
  .mb-lg--3,
  .my-lg--3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg--3,
  .mx-lg--3 {
    margin-left: -1rem !important;
  }
  .m-lg--2 {
    margin: -0.5rem !important;
  }
  .mt-lg--2,
  .my-lg--2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg--2,
  .mx-lg--2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg--2,
  .my-lg--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg--2,
  .mx-lg--2 {
    margin-left: -0.5rem !important;
  }
  .m-lg--1 {
    margin: -0.25rem !important;
  }
  .mt-lg--1,
  .my-lg--1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg--1,
  .mx-lg--1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg--1,
  .my-lg--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg--1,
  .mx-lg--1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-6,
  .my-lg-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-7 {
    margin: 6rem !important;
  }
  .mt-lg-7,
  .my-lg-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 6rem !important;
  }
  .m-lg-8 {
    margin: 8rem !important;
  }
  .mt-lg-8,
  .my-lg-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 8rem !important;
  }
  .m-lg-9 {
    margin: 10rem !important;
  }
  .mt-lg-9,
  .my-lg-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 10rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .p-lg--9 {
    padding: -10rem !important;
  }
  .pt-lg--9,
  .py-lg--9 {
    padding-top: -10rem !important;
  }
  .pr-lg--9,
  .px-lg--9 {
    padding-right: -10rem !important;
  }
  .pb-lg--9,
  .py-lg--9 {
    padding-bottom: -10rem !important;
  }
  .pl-lg--9,
  .px-lg--9 {
    padding-left: -10rem !important;
  }
  .p-lg--8 {
    padding: -8rem !important;
  }
  .pt-lg--8,
  .py-lg--8 {
    padding-top: -8rem !important;
  }
  .pr-lg--8,
  .px-lg--8 {
    padding-right: -8rem !important;
  }
  .pb-lg--8,
  .py-lg--8 {
    padding-bottom: -8rem !important;
  }
  .pl-lg--8,
  .px-lg--8 {
    padding-left: -8rem !important;
  }
  .p-lg--7 {
    padding: -6rem !important;
  }
  .pt-lg--7,
  .py-lg--7 {
    padding-top: -6rem !important;
  }
  .pr-lg--7,
  .px-lg--7 {
    padding-right: -6rem !important;
  }
  .pb-lg--7,
  .py-lg--7 {
    padding-bottom: -6rem !important;
  }
  .pl-lg--7,
  .px-lg--7 {
    padding-left: -6rem !important;
  }
  .p-lg--6 {
    padding: -4.5rem !important;
  }
  .pt-lg--6,
  .py-lg--6 {
    padding-top: -4.5rem !important;
  }
  .pr-lg--6,
  .px-lg--6 {
    padding-right: -4.5rem !important;
  }
  .pb-lg--6,
  .py-lg--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-lg--6,
  .px-lg--6 {
    padding-left: -4.5rem !important;
  }
  .p-lg--5 {
    padding: -3rem !important;
  }
  .pt-lg--5,
  .py-lg--5 {
    padding-top: -3rem !important;
  }
  .pr-lg--5,
  .px-lg--5 {
    padding-right: -3rem !important;
  }
  .pb-lg--5,
  .py-lg--5 {
    padding-bottom: -3rem !important;
  }
  .pl-lg--5,
  .px-lg--5 {
    padding-left: -3rem !important;
  }
  .p-lg--4 {
    padding: -1.5rem !important;
  }
  .pt-lg--4,
  .py-lg--4 {
    padding-top: -1.5rem !important;
  }
  .pr-lg--4,
  .px-lg--4 {
    padding-right: -1.5rem !important;
  }
  .pb-lg--4,
  .py-lg--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-lg--4,
  .px-lg--4 {
    padding-left: -1.5rem !important;
  }
  .p-lg--3 {
    padding: -1rem !important;
  }
  .pt-lg--3,
  .py-lg--3 {
    padding-top: -1rem !important;
  }
  .pr-lg--3,
  .px-lg--3 {
    padding-right: -1rem !important;
  }
  .pb-lg--3,
  .py-lg--3 {
    padding-bottom: -1rem !important;
  }
  .pl-lg--3,
  .px-lg--3 {
    padding-left: -1rem !important;
  }
  .p-lg--2 {
    padding: -0.5rem !important;
  }
  .pt-lg--2,
  .py-lg--2 {
    padding-top: -0.5rem !important;
  }
  .pr-lg--2,
  .px-lg--2 {
    padding-right: -0.5rem !important;
  }
  .pb-lg--2,
  .py-lg--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-lg--2,
  .px-lg--2 {
    padding-left: -0.5rem !important;
  }
  .p-lg--1 {
    padding: -0.25rem !important;
  }
  .pt-lg--1,
  .py-lg--1 {
    padding-top: -0.25rem !important;
  }
  .pr-lg--1,
  .px-lg--1 {
    padding-right: -0.25rem !important;
  }
  .pb-lg--1,
  .py-lg--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-lg--1,
  .px-lg--1 {
    padding-left: -0.25rem !important;
  }
  .p-lg-6 {
    padding: 4.5rem !important;
  }
  .pt-lg-6,
  .py-lg-6 {
    padding-top: 4.5rem !important;
  }
  .pr-lg-6,
  .px-lg-6 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-lg-6,
  .px-lg-6 {
    padding-left: 4.5rem !important;
  }
  .p-lg-7 {
    padding: 6rem !important;
  }
  .pt-lg-7,
  .py-lg-7 {
    padding-top: 6rem !important;
  }
  .pr-lg-7,
  .px-lg-7 {
    padding-right: 6rem !important;
  }
  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 6rem !important;
  }
  .pl-lg-7,
  .px-lg-7 {
    padding-left: 6rem !important;
  }
  .p-lg-8 {
    padding: 8rem !important;
  }
  .pt-lg-8,
  .py-lg-8 {
    padding-top: 8rem !important;
  }
  .pr-lg-8,
  .px-lg-8 {
    padding-right: 8rem !important;
  }
  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 8rem !important;
  }
  .pl-lg-8,
  .px-lg-8 {
    padding-left: 8rem !important;
  }
  .p-lg-9 {
    padding: 10rem !important;
  }
  .pt-lg-9,
  .py-lg-9 {
    padding-top: 10rem !important;
  }
  .pr-lg-9,
  .px-lg-9 {
    padding-right: 10rem !important;
  }
  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 10rem !important;
  }
  .pl-lg-9,
  .px-lg-9 {
    padding-left: 10rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-n-9 {
    margin: 10rem !important;
  }
  .mt-lg-n-9,
  .my-lg-n-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-n-9,
  .mx-lg-n-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-n-9,
  .my-lg-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-n-9,
  .mx-lg-n-9 {
    margin-left: 10rem !important;
  }
  .m-lg-n-8 {
    margin: 8rem !important;
  }
  .mt-lg-n-8,
  .my-lg-n-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-n-8,
  .mx-lg-n-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-n-8,
  .my-lg-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-n-8,
  .mx-lg-n-8 {
    margin-left: 8rem !important;
  }
  .m-lg-n-7 {
    margin: 6rem !important;
  }
  .mt-lg-n-7,
  .my-lg-n-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-n-7,
  .mx-lg-n-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-n-7,
  .my-lg-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-n-7,
  .mx-lg-n-7 {
    margin-left: 6rem !important;
  }
  .m-lg-n-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-n-6,
  .my-lg-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-n-6,
  .mx-lg-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-n-6,
  .my-lg-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-n-6,
  .mx-lg-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-n-5 {
    margin: 3rem !important;
  }
  .mt-lg-n-5,
  .my-lg-n-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-n-5,
  .mx-lg-n-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-n-5,
  .my-lg-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-n-5,
  .mx-lg-n-5 {
    margin-left: 3rem !important;
  }
  .m-lg-n-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-n-4,
  .my-lg-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-n-4,
  .mx-lg-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-n-4,
  .my-lg-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-n-4,
  .mx-lg-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-n-3 {
    margin: 1rem !important;
  }
  .mt-lg-n-3,
  .my-lg-n-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-n-3,
  .mx-lg-n-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-n-3,
  .my-lg-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-n-3,
  .mx-lg-n-3 {
    margin-left: 1rem !important;
  }
  .m-lg-n-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-n-2,
  .my-lg-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-n-2,
  .mx-lg-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-n-2,
  .my-lg-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-n-2,
  .mx-lg-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-n-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-n-1,
  .my-lg-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-n-1,
  .mx-lg-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-n-1,
  .my-lg-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-n-1,
  .mx-lg-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-n6 {
    margin: -4.5rem !important;
  }
  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -4.5rem !important;
  }
  .m-lg-n7 {
    margin: -6rem !important;
  }
  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -6rem !important;
  }
  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -6rem !important;
  }
  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -6rem !important;
  }
  .m-lg-n8 {
    margin: -8rem !important;
  }
  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -8rem !important;
  }
  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -8rem !important;
  }
  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -8rem !important;
  }
  .m-lg-n9 {
    margin: -10rem !important;
  }
  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -10rem !important;
  }
  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -10rem !important;
  }
  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -10rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .m-xl--9 {
    margin: -10rem !important;
  }
  .mt-xl--9,
  .my-xl--9 {
    margin-top: -10rem !important;
  }
  .mr-xl--9,
  .mx-xl--9 {
    margin-right: -10rem !important;
  }
  .mb-xl--9,
  .my-xl--9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl--9,
  .mx-xl--9 {
    margin-left: -10rem !important;
  }
  .m-xl--8 {
    margin: -8rem !important;
  }
  .mt-xl--8,
  .my-xl--8 {
    margin-top: -8rem !important;
  }
  .mr-xl--8,
  .mx-xl--8 {
    margin-right: -8rem !important;
  }
  .mb-xl--8,
  .my-xl--8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl--8,
  .mx-xl--8 {
    margin-left: -8rem !important;
  }
  .m-xl--7 {
    margin: -6rem !important;
  }
  .mt-xl--7,
  .my-xl--7 {
    margin-top: -6rem !important;
  }
  .mr-xl--7,
  .mx-xl--7 {
    margin-right: -6rem !important;
  }
  .mb-xl--7,
  .my-xl--7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl--7,
  .mx-xl--7 {
    margin-left: -6rem !important;
  }
  .m-xl--6 {
    margin: -4.5rem !important;
  }
  .mt-xl--6,
  .my-xl--6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl--6,
  .mx-xl--6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl--6,
  .my-xl--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl--6,
  .mx-xl--6 {
    margin-left: -4.5rem !important;
  }
  .m-xl--5 {
    margin: -3rem !important;
  }
  .mt-xl--5,
  .my-xl--5 {
    margin-top: -3rem !important;
  }
  .mr-xl--5,
  .mx-xl--5 {
    margin-right: -3rem !important;
  }
  .mb-xl--5,
  .my-xl--5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl--5,
  .mx-xl--5 {
    margin-left: -3rem !important;
  }
  .m-xl--4 {
    margin: -1.5rem !important;
  }
  .mt-xl--4,
  .my-xl--4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl--4,
  .mx-xl--4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl--4,
  .my-xl--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl--4,
  .mx-xl--4 {
    margin-left: -1.5rem !important;
  }
  .m-xl--3 {
    margin: -1rem !important;
  }
  .mt-xl--3,
  .my-xl--3 {
    margin-top: -1rem !important;
  }
  .mr-xl--3,
  .mx-xl--3 {
    margin-right: -1rem !important;
  }
  .mb-xl--3,
  .my-xl--3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl--3,
  .mx-xl--3 {
    margin-left: -1rem !important;
  }
  .m-xl--2 {
    margin: -0.5rem !important;
  }
  .mt-xl--2,
  .my-xl--2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl--2,
  .mx-xl--2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl--2,
  .my-xl--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl--2,
  .mx-xl--2 {
    margin-left: -0.5rem !important;
  }
  .m-xl--1 {
    margin: -0.25rem !important;
  }
  .mt-xl--1,
  .my-xl--1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl--1,
  .mx-xl--1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl--1,
  .my-xl--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl--1,
  .mx-xl--1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-6,
  .my-xl-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-7 {
    margin: 6rem !important;
  }
  .mt-xl-7,
  .my-xl-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 6rem !important;
  }
  .m-xl-8 {
    margin: 8rem !important;
  }
  .mt-xl-8,
  .my-xl-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 8rem !important;
  }
  .m-xl-9 {
    margin: 10rem !important;
  }
  .mt-xl-9,
  .my-xl-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 10rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .p-xl--9 {
    padding: -10rem !important;
  }
  .pt-xl--9,
  .py-xl--9 {
    padding-top: -10rem !important;
  }
  .pr-xl--9,
  .px-xl--9 {
    padding-right: -10rem !important;
  }
  .pb-xl--9,
  .py-xl--9 {
    padding-bottom: -10rem !important;
  }
  .pl-xl--9,
  .px-xl--9 {
    padding-left: -10rem !important;
  }
  .p-xl--8 {
    padding: -8rem !important;
  }
  .pt-xl--8,
  .py-xl--8 {
    padding-top: -8rem !important;
  }
  .pr-xl--8,
  .px-xl--8 {
    padding-right: -8rem !important;
  }
  .pb-xl--8,
  .py-xl--8 {
    padding-bottom: -8rem !important;
  }
  .pl-xl--8,
  .px-xl--8 {
    padding-left: -8rem !important;
  }
  .p-xl--7 {
    padding: -6rem !important;
  }
  .pt-xl--7,
  .py-xl--7 {
    padding-top: -6rem !important;
  }
  .pr-xl--7,
  .px-xl--7 {
    padding-right: -6rem !important;
  }
  .pb-xl--7,
  .py-xl--7 {
    padding-bottom: -6rem !important;
  }
  .pl-xl--7,
  .px-xl--7 {
    padding-left: -6rem !important;
  }
  .p-xl--6 {
    padding: -4.5rem !important;
  }
  .pt-xl--6,
  .py-xl--6 {
    padding-top: -4.5rem !important;
  }
  .pr-xl--6,
  .px-xl--6 {
    padding-right: -4.5rem !important;
  }
  .pb-xl--6,
  .py-xl--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-xl--6,
  .px-xl--6 {
    padding-left: -4.5rem !important;
  }
  .p-xl--5 {
    padding: -3rem !important;
  }
  .pt-xl--5,
  .py-xl--5 {
    padding-top: -3rem !important;
  }
  .pr-xl--5,
  .px-xl--5 {
    padding-right: -3rem !important;
  }
  .pb-xl--5,
  .py-xl--5 {
    padding-bottom: -3rem !important;
  }
  .pl-xl--5,
  .px-xl--5 {
    padding-left: -3rem !important;
  }
  .p-xl--4 {
    padding: -1.5rem !important;
  }
  .pt-xl--4,
  .py-xl--4 {
    padding-top: -1.5rem !important;
  }
  .pr-xl--4,
  .px-xl--4 {
    padding-right: -1.5rem !important;
  }
  .pb-xl--4,
  .py-xl--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-xl--4,
  .px-xl--4 {
    padding-left: -1.5rem !important;
  }
  .p-xl--3 {
    padding: -1rem !important;
  }
  .pt-xl--3,
  .py-xl--3 {
    padding-top: -1rem !important;
  }
  .pr-xl--3,
  .px-xl--3 {
    padding-right: -1rem !important;
  }
  .pb-xl--3,
  .py-xl--3 {
    padding-bottom: -1rem !important;
  }
  .pl-xl--3,
  .px-xl--3 {
    padding-left: -1rem !important;
  }
  .p-xl--2 {
    padding: -0.5rem !important;
  }
  .pt-xl--2,
  .py-xl--2 {
    padding-top: -0.5rem !important;
  }
  .pr-xl--2,
  .px-xl--2 {
    padding-right: -0.5rem !important;
  }
  .pb-xl--2,
  .py-xl--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-xl--2,
  .px-xl--2 {
    padding-left: -0.5rem !important;
  }
  .p-xl--1 {
    padding: -0.25rem !important;
  }
  .pt-xl--1,
  .py-xl--1 {
    padding-top: -0.25rem !important;
  }
  .pr-xl--1,
  .px-xl--1 {
    padding-right: -0.25rem !important;
  }
  .pb-xl--1,
  .py-xl--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-xl--1,
  .px-xl--1 {
    padding-left: -0.25rem !important;
  }
  .p-xl-6 {
    padding: 4.5rem !important;
  }
  .pt-xl-6,
  .py-xl-6 {
    padding-top: 4.5rem !important;
  }
  .pr-xl-6,
  .px-xl-6 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-xl-6,
  .px-xl-6 {
    padding-left: 4.5rem !important;
  }
  .p-xl-7 {
    padding: 6rem !important;
  }
  .pt-xl-7,
  .py-xl-7 {
    padding-top: 6rem !important;
  }
  .pr-xl-7,
  .px-xl-7 {
    padding-right: 6rem !important;
  }
  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 6rem !important;
  }
  .pl-xl-7,
  .px-xl-7 {
    padding-left: 6rem !important;
  }
  .p-xl-8 {
    padding: 8rem !important;
  }
  .pt-xl-8,
  .py-xl-8 {
    padding-top: 8rem !important;
  }
  .pr-xl-8,
  .px-xl-8 {
    padding-right: 8rem !important;
  }
  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 8rem !important;
  }
  .pl-xl-8,
  .px-xl-8 {
    padding-left: 8rem !important;
  }
  .p-xl-9 {
    padding: 10rem !important;
  }
  .pt-xl-9,
  .py-xl-9 {
    padding-top: 10rem !important;
  }
  .pr-xl-9,
  .px-xl-9 {
    padding-right: 10rem !important;
  }
  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 10rem !important;
  }
  .pl-xl-9,
  .px-xl-9 {
    padding-left: 10rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-n-9 {
    margin: 10rem !important;
  }
  .mt-xl-n-9,
  .my-xl-n-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-n-9,
  .mx-xl-n-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-n-9,
  .my-xl-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-n-9,
  .mx-xl-n-9 {
    margin-left: 10rem !important;
  }
  .m-xl-n-8 {
    margin: 8rem !important;
  }
  .mt-xl-n-8,
  .my-xl-n-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-n-8,
  .mx-xl-n-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-n-8,
  .my-xl-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-n-8,
  .mx-xl-n-8 {
    margin-left: 8rem !important;
  }
  .m-xl-n-7 {
    margin: 6rem !important;
  }
  .mt-xl-n-7,
  .my-xl-n-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-n-7,
  .mx-xl-n-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-n-7,
  .my-xl-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-n-7,
  .mx-xl-n-7 {
    margin-left: 6rem !important;
  }
  .m-xl-n-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-n-6,
  .my-xl-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-n-6,
  .mx-xl-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-n-6,
  .my-xl-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-n-6,
  .mx-xl-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-n-5 {
    margin: 3rem !important;
  }
  .mt-xl-n-5,
  .my-xl-n-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-n-5,
  .mx-xl-n-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-n-5,
  .my-xl-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-n-5,
  .mx-xl-n-5 {
    margin-left: 3rem !important;
  }
  .m-xl-n-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-n-4,
  .my-xl-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-n-4,
  .mx-xl-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-n-4,
  .my-xl-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-n-4,
  .mx-xl-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-n-3 {
    margin: 1rem !important;
  }
  .mt-xl-n-3,
  .my-xl-n-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-n-3,
  .mx-xl-n-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-n-3,
  .my-xl-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-n-3,
  .mx-xl-n-3 {
    margin-left: 1rem !important;
  }
  .m-xl-n-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-n-2,
  .my-xl-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-n-2,
  .mx-xl-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-n-2,
  .my-xl-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-n-2,
  .mx-xl-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-n-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-n-1,
  .my-xl-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-n-1,
  .mx-xl-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-n-1,
  .my-xl-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-n-1,
  .mx-xl-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-n6 {
    margin: -4.5rem !important;
  }
  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -4.5rem !important;
  }
  .m-xl-n7 {
    margin: -6rem !important;
  }
  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -6rem !important;
  }
  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -6rem !important;
  }
  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -6rem !important;
  }
  .m-xl-n8 {
    margin: -8rem !important;
  }
  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -8rem !important;
  }
  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -8rem !important;
  }
  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -8rem !important;
  }
  .m-xl-n9 {
    margin: -10rem !important;
  }
  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -10rem !important;
  }
  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -10rem !important;
  }
  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -10rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #5e72e4 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #233dd2 !important;
}

.text-secondary {
  color: #f7fafc !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #bfd7e7 !important;
}

.text-success {
  color: #2dce89 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #1f8f5f !important;
}

.text-info {
  color: #11cdef !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0b90a8 !important;
}

.text-warning {
  color: #fb6340 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ea3005 !important;
}

.text-danger {
  color: #f5365c !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #d40b33 !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover, a.text-light:focus {
  color: #838f9b !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-default {
  color: #172b4d !important;
}

a.text-default:hover, a.text-default:focus {
  color: #050a12 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-neutral {
  color: #fff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
  color: #d9d9d9 !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover, a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #8898aa !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #e9ecef;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e9ecef;
  }
}
iframe {
  border: 0;
}

figcaption,
figure,
main {
  display: block;
}

main {
  overflow: hidden;
}

.bg-blue {
  background-color: #5e72e4 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-blue:hover, a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  background-color: #324cdd !important;
}

.bg-indigo {
  background-color: #5603ad !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: #3d027b !important;
}

.bg-purple {
  background-color: #8965e0 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  background-color: #683bd7 !important;
}

.bg-pink {
  background-color: #f3a4b5 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  background-color: #ed7790 !important;
}

.bg-red {
  background-color: #f5365c !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-red:hover, a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  background-color: #ec0c38 !important;
}

.bg-orange {
  background-color: #fb6340 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  background-color: #fa3a0e !important;
}

.bg-yellow {
  background-color: #ffd600 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-yellow:hover, a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  background-color: #ccab00 !important;
}

.bg-green {
  background-color: #2dce89 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-green:hover, a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  background-color: #24a46d !important;
}

.bg-teal {
  background-color: #11cdef !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-teal:hover, a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  background-color: #0da5c0 !important;
}

.bg-cyan {
  background-color: #2bffc6 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-cyan:hover, a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  background-color: #00f7b5 !important;
}

.bg-white {
  background-color: #fff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: #e6e6e6 !important;
}

.bg-gray {
  background-color: #8898aa !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: #6a7e95 !important;
}

.bg-gray-dark {
  background-color: #32325d !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-gray-dark:hover, a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  background-color: #20203c !important;
}

.bg-light {
  background-color: #ced4da !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #b1bbc4 !important;
}

.bg-lighter {
  background-color: #e9ecef !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.bg-lighter:hover, a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: #cbd3da !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.bg-gradient-blue {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-indigo {
  background: linear-gradient(87deg, #5603ad 0, #9d03ad 100%) !important;
}

.bg-gradient-purple {
  background: linear-gradient(87deg, #8965e0 0, #bc65e0 100%) !important;
}

.bg-gradient-pink {
  background: linear-gradient(87deg, #f3a4b5 0, #f3b4a4 100%) !important;
}

.bg-gradient-red {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-orange {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-yellow {
  background: linear-gradient(87deg, #ffd600 0, #beff00 100%) !important;
}

.bg-gradient-green {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-teal {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-cyan {
  background: linear-gradient(87deg, #2bffc6 0, #2be0ff 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-gray {
  background: linear-gradient(87deg, #8898aa 0, #888aaa 100%) !important;
}

.bg-gradient-gray-dark {
  background: linear-gradient(87deg, #32325d 0, #44325d 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #ced4da 0, #cecfda 100%) !important;
}

.bg-gradient-lighter {
  background: linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important;
}

.bg-translucent-primary {
  background-color: rgba(63, 87, 223, 0.6) !important;
}

a.bg-translucent-primary:hover, a.bg-translucent-primary:focus,
button.bg-translucent-primary:hover,
button.bg-translucent-primary:focus {
  background-color: rgba(42, 68, 219, 0.6) !important;
}

.bg-translucent-secondary {
  background-color: rgba(221, 234, 242, 0.6) !important;
}

a.bg-translucent-secondary:hover, a.bg-translucent-secondary:focus,
button.bg-translucent-secondary:hover,
button.bg-translucent-secondary:focus {
  background-color: rgba(202, 222, 235, 0.6) !important;
}

.bg-translucent-success {
  background-color: rgba(39, 177, 118, 0.6) !important;
}

a.bg-translucent-success:hover, a.bg-translucent-success:focus,
button.bg-translucent-success:hover,
button.bg-translucent-success:focus {
  background-color: rgba(34, 156, 104, 0.6) !important;
}

.bg-translucent-info {
  background-color: rgba(14, 177, 206, 0.6) !important;
}

a.bg-translucent-info:hover, a.bg-translucent-info:focus,
button.bg-translucent-info:hover,
button.bg-translucent-info:focus {
  background-color: rgba(12, 156, 183, 0.6) !important;
}

.bg-translucent-warning {
  background-color: rgba(250, 70, 29, 0.6) !important;
}

a.bg-translucent-warning:hover, a.bg-translucent-warning:focus,
button.bg-translucent-warning:hover,
button.bg-translucent-warning:focus {
  background-color: rgba(249, 51, 5, 0.6) !important;
}

.bg-translucent-danger {
  background-color: rgba(243, 20, 64, 0.6) !important;
}

a.bg-translucent-danger:hover, a.bg-translucent-danger:focus,
button.bg-translucent-danger:hover,
button.bg-translucent-danger:focus {
  background-color: rgba(227, 11, 54, 0.6) !important;
}

.bg-translucent-light {
  background-color: rgba(153, 163, 173, 0.6) !important;
}

a.bg-translucent-light:hover, a.bg-translucent-light:focus,
button.bg-translucent-light:hover,
button.bg-translucent-light:focus {
  background-color: rgba(139, 150, 162, 0.6) !important;
}

.bg-translucent-dark {
  background-color: rgba(17, 19, 21, 0.6) !important;
}

a.bg-translucent-dark:hover, a.bg-translucent-dark:focus,
button.bg-translucent-dark:hover,
button.bg-translucent-dark:focus {
  background-color: rgba(6, 6, 7, 0.6) !important;
}

.bg-translucent-default {
  background-color: rgba(15, 28, 50, 0.6) !important;
}

a.bg-translucent-default:hover, a.bg-translucent-default:focus,
button.bg-translucent-default:hover,
button.bg-translucent-default:focus {
  background-color: rgba(9, 17, 30, 0.6) !important;
}

.bg-translucent-white {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-white:hover, a.bg-translucent-white:focus,
button.bg-translucent-white:hover,
button.bg-translucent-white:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-neutral {
  background-color: rgba(237, 237, 237, 0.6) !important;
}

a.bg-translucent-neutral:hover, a.bg-translucent-neutral:focus,
button.bg-translucent-neutral:hover,
button.bg-translucent-neutral:focus {
  background-color: rgba(224, 224, 224, 0.6) !important;
}

.bg-translucent-darker {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

a.bg-translucent-darker:hover, a.bg-translucent-darker:focus,
button.bg-translucent-darker:hover,
button.bg-translucent-darker:focus {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.section-primary {
  background-color: #f8f9fe !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.section-primary:hover, a.section-primary:focus,
button.section-primary:hover,
button.section-primary:focus {
  background-color: #cbd3f8 !important;
}

.section-secondary {
  background-color: #f7fafc !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.section-secondary:hover, a.section-secondary:focus,
button.section-secondary:hover,
button.section-secondary:focus {
  background-color: #d2e3ee !important;
}

.section-light {
  background-color: #ced4da !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.section-light:hover, a.section-light:focus,
button.section-light:hover,
button.section-light:focus {
  background-color: #b1bbc4 !important;
}

.section-dark {
  background-color: #212529 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.section-dark:hover, a.section-dark:focus,
button.section-dark:hover,
button.section-dark:focus {
  background-color: #0a0c0d !important;
}

.section-darker {
  background-color: black !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

a.section-darker:hover, a.section-darker:focus,
button.section-darker:hover,
button.section-darker:focus {
  background-color: black !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.fill-primary {
  fill: #5e72e4;
}

.stroke-primary {
  stroke: #5e72e4;
}

.fill-secondary {
  fill: #f7fafc;
}

.stroke-secondary {
  stroke: #f7fafc;
}

.fill-success {
  fill: #2dce89;
}

.stroke-success {
  stroke: #2dce89;
}

.fill-info {
  fill: #11cdef;
}

.stroke-info {
  stroke: #11cdef;
}

.fill-warning {
  fill: #fb6340;
}

.stroke-warning {
  stroke: #fb6340;
}

.fill-danger {
  fill: #f5365c;
}

.stroke-danger {
  stroke: #f5365c;
}

.fill-light {
  fill: #adb5bd;
}

.stroke-light {
  stroke: #adb5bd;
}

.fill-dark {
  fill: #212529;
}

.stroke-dark {
  stroke: #212529;
}

.fill-default {
  fill: #172b4d;
}

.stroke-default {
  stroke: #172b4d;
}

.fill-white {
  fill: #fff;
}

.stroke-white {
  stroke: #fff;
}

.fill-neutral {
  fill: #fff;
}

.stroke-neutral {
  stroke: #fff;
}

.fill-darker {
  fill: black;
}

.stroke-darker {
  stroke: black;
}

.fill-opacity-8 {
  fill-opacity: 0.8;
}

.floating {
  animation: floating 3s ease infinite;
  will-change: transform;
}
.floating:hover {
  animation-play-state: paused;
}

.floating-lg {
  animation: floating-lg 3s ease infinite;
}

.floating-sm {
  animation: floating-sm 3s ease infinite;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(15px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.floatfix:before, .floatfix:after {
  content: "";
  display: table;
}
.floatfix:after {
  clear: both;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-8 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-1 {
  top: 0.25rem;
}

.right-1 {
  right: 0.25rem;
}

.bottom-1 {
  bottom: 0.25rem;
}

.left-1 {
  left: 0.25rem;
}

.top-2 {
  top: 0.5rem;
}

.right-2 {
  right: 0.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.left-2 {
  left: 0.5rem;
}

.top-3 {
  top: 1rem;
}

.right-3 {
  right: 1rem;
}

.bottom-3 {
  bottom: 1rem;
}

.left-3 {
  left: 1rem;
}

.top-4 {
  top: 1.5rem;
}

.right-4 {
  right: 1.5rem;
}

.bottom-4 {
  bottom: 1.5rem;
}

.left-4 {
  left: 1.5rem;
}

.top-5 {
  top: 3rem;
}

.right-5 {
  right: 3rem;
}

.bottom-5 {
  bottom: 3rem;
}

.left-5 {
  left: 3rem;
}

.top--9 {
  top: -10rem;
}

.right--9 {
  right: -10rem;
}

.bottom--9 {
  bottom: -10rem;
}

.left--9 {
  left: -10rem;
}

.top--8 {
  top: -8rem;
}

.right--8 {
  right: -8rem;
}

.bottom--8 {
  bottom: -8rem;
}

.left--8 {
  left: -8rem;
}

.top--7 {
  top: -6rem;
}

.right--7 {
  right: -6rem;
}

.bottom--7 {
  bottom: -6rem;
}

.left--7 {
  left: -6rem;
}

.top--6 {
  top: -4.5rem;
}

.right--6 {
  right: -4.5rem;
}

.bottom--6 {
  bottom: -4.5rem;
}

.left--6 {
  left: -4.5rem;
}

.top--5 {
  top: -3rem;
}

.right--5 {
  right: -3rem;
}

.bottom--5 {
  bottom: -3rem;
}

.left--5 {
  left: -3rem;
}

.top--4 {
  top: -1.5rem;
}

.right--4 {
  right: -1.5rem;
}

.bottom--4 {
  bottom: -1.5rem;
}

.left--4 {
  left: -1.5rem;
}

.top--3 {
  top: -1rem;
}

.right--3 {
  right: -1rem;
}

.bottom--3 {
  bottom: -1rem;
}

.left--3 {
  left: -1rem;
}

.top--2 {
  top: -0.5rem;
}

.right--2 {
  right: -0.5rem;
}

.bottom--2 {
  bottom: -0.5rem;
}

.left--2 {
  left: -0.5rem;
}

.top--1 {
  top: -0.25rem;
}

.right--1 {
  right: -0.25rem;
}

.bottom--1 {
  bottom: -0.25rem;
}

.left--1 {
  left: -0.25rem;
}

.top-6 {
  top: 4.5rem;
}

.right-6 {
  right: 4.5rem;
}

.bottom-6 {
  bottom: 4.5rem;
}

.left-6 {
  left: 4.5rem;
}

.top-7 {
  top: 6rem;
}

.right-7 {
  right: 6rem;
}

.bottom-7 {
  bottom: 6rem;
}

.left-7 {
  left: 6rem;
}

.top-8 {
  top: 8rem;
}

.right-8 {
  right: 8rem;
}

.bottom-8 {
  bottom: 8rem;
}

.left-8 {
  left: 8rem;
}

.top-9 {
  top: 10rem;
}

.right-9 {
  right: 10rem;
}

.bottom-9 {
  bottom: 10rem;
}

.left-9 {
  left: 10rem;
}

.center {
  left: 50%;
  transform: translateX(-50%);
}

.h-100vh {
  height: 100vh !important;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {
    margin-top: 0;
  }
}
@media (min-width: 768px) {
  .row.row-grid > [class*=col-md-] + [class*=col-md-] {
    margin-top: 0;
  }
}
@media (min-width: 576px) {
  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {
    margin-top: 0;
  }
}
.row-grid + .row-grid {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .mt--100 {
    margin-top: -100px !important;
  }
  .mr--100 {
    margin-right: -100px !important;
  }
  .mb--100 {
    margin-bottom: -100px !important;
  }
  .ml--100 {
    margin-left: -100px !important;
  }
  .mt--150 {
    margin-top: -150px !important;
  }
  .mb--150 {
    margin-bottom: -150px !important;
  }
  .mt--200 {
    margin-top: -200px !important;
  }
  .mb--200 {
    margin-bottom: -200px !important;
  }
  .mt--300 {
    margin-top: -300px !important;
  }
  .mb--300 {
    margin-bottom: -300px !important;
  }
  .pt-100 {
    padding-top: 100px !important;
  }
  .pb-100 {
    padding-bottom: 100px !important;
  }
  .pt-150 {
    padding-top: 150px !important;
  }
  .pb-150 {
    padding-bottom: 150px !important;
  }
  .pt-200 {
    padding-top: 200px !important;
  }
  .pb-200 {
    padding-bottom: 200px !important;
  }
  .pt-250 {
    padding-top: 250px !important;
  }
  .pb-250 {
    padding-bottom: 250px !important;
  }
  .pt-300 {
    padding-top: 300px !important;
  }
  .pb-300 {
    padding-bottom: 300px !important;
  }
}
[class*=shadow] {
  transition: all 0.15s ease;
}

.shadow-sm--hover:hover {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow--hover:hover {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg--hover:hover {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none--hover:hover {
  box-shadow: none !important;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.text-underline {
  text-decoration: underline;
}

.text-through {
  text-decoration: line-through;
}

.text-xs {
  font-size: 0.75rem !important;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-lg {
  font-size: 1.25rem !important;
}

.text-xl {
  font-size: 1.5rem !important;
}

.lh-100 {
  line-height: 1;
}

.lh-110 {
  line-height: 1.1;
}

.lh-120 {
  line-height: 1.2;
}

.lh-130 {
  line-height: 1.3;
}

.lh-140 {
  line-height: 1.4;
}

.lh-150 {
  line-height: 1.5;
}

.lh-160 {
  line-height: 1.6;
}

.lh-170 {
  line-height: 1.7;
}

.lh-180 {
  line-height: 1.8;
}

.ls-1 {
  letter-spacing: 0.0625rem;
}

.ls-15 {
  letter-spacing: 0.09375rem;
}

.ls-2 {
  letter-spacing: 0.125rem;
}

.text-blue {
  color: #5e72e4 !important;
}

a.text-blue:hover, a.text-blue:focus {
  color: #233dd2 !important;
}

.text-indigo {
  color: #5603ad !important;
}

a.text-indigo:hover, a.text-indigo:focus {
  color: #310262 !important;
}

.text-purple {
  color: #8965e0 !important;
}

a.text-purple:hover, a.text-purple:focus {
  color: #5a2acf !important;
}

.text-pink {
  color: #f3a4b5 !important;
}

a.text-pink:hover, a.text-pink:focus {
  color: #ea607e !important;
}

.text-red {
  color: #f5365c !important;
}

a.text-red:hover, a.text-red:focus {
  color: #d40b33 !important;
}

.text-orange {
  color: #fb6340 !important;
}

a.text-orange:hover, a.text-orange:focus {
  color: #ea3005 !important;
}

.text-yellow {
  color: #ffd600 !important;
}

a.text-yellow:hover, a.text-yellow:focus {
  color: #b39600 !important;
}

.text-green {
  color: #2dce89 !important;
}

a.text-green:hover, a.text-green:focus {
  color: #1f8f5f !important;
}

.text-teal {
  color: #11cdef !important;
}

a.text-teal:hover, a.text-teal:focus {
  color: #0b90a8 !important;
}

.text-cyan {
  color: #2bffc6 !important;
}

a.text-cyan:hover, a.text-cyan:focus {
  color: #00dea2 !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important;
}

.text-gray {
  color: #8898aa !important;
}

a.text-gray:hover, a.text-gray:focus {
  color: #607286 !important;
}

.text-gray-dark {
  color: #32325d !important;
}

a.text-gray-dark:hover, a.text-gray-dark:focus {
  color: #17172b !important;
}

.text-light {
  color: #ced4da !important;
}

a.text-light:hover, a.text-light:focus {
  color: #a2aeb9 !important;
}

.text-lighter {
  color: #e9ecef !important;
}

a.text-lighter:hover, a.text-lighter:focus {
  color: #bdc6cf !important;
}

@media (min-width: 992px) {
  .transform-perspective-right {
    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);
  }
  .transform-perspective-left {
    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);
  }
}
.alert {
  font-size: 0.875rem;
}

.alert-heading {
  font-weight: 600;
  font-size: 0.9375rem;
  margin-top: 0.15rem;
}

.alert-icon {
  font-size: 1.25rem;
  margin-right: 1.25rem;
  display: inline-block;
  vertical-align: middle;
}
.alert-icon i.ni {
  position: relative;
  top: 1px;
}

.alert-text {
  display: inline-block;
  vertical-align: middle;
}

[class*=alert-] .alert-link {
  color: #fff;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
}

.alert-dismissible .close {
  top: 50%;
  right: 1.5rem;
  padding: 0;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}

.avatar {
  color: #fff;
  background-color: #adb5bd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  border-radius: 50%;
  height: 48px;
  width: 48px;
}
.avatar img {
  width: 100%;
  border-radius: 50%;
}
.avatar + .avatar-content {
  display: inline-block;
  margin-left: 0.75rem;
}

.avatar-lg {
  width: 58px;
  height: 58px;
  font-size: 0.875rem;
}

.avatar-sm {
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.avatar-group .avatar {
  position: relative;
  z-index: 2;
  border: 2px solid #fff;
}
.avatar-group .avatar:hover {
  z-index: 3;
}
.avatar-group .avatar + .avatar {
  margin-left: -1rem;
}

.badge {
  text-transform: uppercase;
}
.badge a {
  color: #fff;
}

.badge-md {
  padding: 0.65em 1em;
}

.badge-lg {
  padding: 0.85em 1.375em;
}

.badge-inline {
  margin-right: 0.625rem;
}
.badge-inline + span {
  top: 2px;
  position: relative;
}
.badge-inline + span > a {
  text-decoration: underline;
}

.btn .badge:not(:first-child) {
  margin-left: 0.5rem;
}
.btn .badge:not(:last-child) {
  margin-right: 0.5rem;
}

.badge-circle {
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  font-size: 0.875rem;
}

.badge-dot {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
  font-weight: 400;
  font-size: 0.875rem;
  text-transform: none;
}
.badge-dot strong {
  color: #32325d;
}
.badge-dot i {
  display: inline-block;
  vertical-align: middle;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  margin-right: 0.375rem;
}
.badge-dot.badge-md i {
  width: 0.5rem;
  height: 0.5rem;
}
.badge-dot.badge-lg i {
  width: 0.625rem;
  height: 0.625rem;
}

.btn {
  position: relative;
  text-transform: none;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  font-size: 0.875rem;
  will-change: transform;
}
.btn:hover {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.btn:not(:last-child) {
  margin-right: 0.5rem;
}
.btn i:not(:first-child),
.btn svg:not(:first-child) {
  margin-left: 0.5rem;
}
.btn i:not(:last-child),
.btn svg:not(:last-child) {
  margin-right: 0.5rem;
}

.btn-group .btn,
.input-group .btn {
  margin-right: 0;
  transform: translateY(0);
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.75rem;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
}

[class*=btn-outline-] {
  border-width: 1px;
}

.btn-outline-secondary {
  color: #4385b1;
}

.btn-inner--icon i:not(.fa) {
  position: relative;
  top: 2px;
}

.btn-link {
  font-weight: 600;
  box-shadow: none;
}
.btn-link:hover {
  box-shadow: none;
  transform: none;
}

.btn-neutral {
  color: #5e72e4;
}

.btn-icon .btn-inner--icon img {
  width: 20px;
}
.btn-icon .btn-inner--text:not(:first-child) {
  margin-left: 0.75em;
}
.btn-icon .btn-inner--text:not(:last-child) {
  margin-right: 0.75em;
}

.btn-icon-only {
  width: 2.375rem;
  height: 2.375rem;
  padding: 0;
}

a.btn-icon-only {
  line-height: 2.5;
}

.btn-icon-only.btn-sm, .btn-group-sm > .btn-icon-only.btn {
  width: 2rem;
  height: 2rem;
}

.btn-icon-clipboard {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: #5e72e4;
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.btn-facebook {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-facebook:hover {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:focus, .btn-facebook.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 89, 153, 0.5);
}
.btn-facebook.disabled, .btn-facebook:disabled {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {
  color: #fff;
  background-color: #2d4474;
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);
}

.btn-twitter {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-twitter:hover {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:focus, .btn-twitter.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 161, 242, 0.5);
}
.btn-twitter.disabled, .btn-twitter:disabled {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {
  color: #fff;
  background-color: #0c85d0;
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);
}

.btn-google-plus {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-google-plus:hover {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:focus, .btn-google-plus.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(221, 75, 57, 0.5);
}
.btn-google-plus.disabled, .btn-google-plus:disabled {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active, .btn-google-plus:not(:disabled):not(.disabled).active, .show > .btn-google-plus.dropdown-toggle {
  color: #fff;
  background-color: #c23321;
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active:focus, .btn-google-plus:not(:disabled):not(.disabled).active:focus, .show > .btn-google-plus.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);
}

.btn-instagram {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-instagram:hover {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:focus, .btn-instagram.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(228, 64, 95, 0.5);
}
.btn-instagram.disabled, .btn-instagram:disabled {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {
  color: #fff;
  background-color: #d31e40;
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);
}

.btn-pinterest {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-pinterest:hover {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:focus, .btn-pinterest.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(189, 8, 28, 0.5);
}
.btn-pinterest.disabled, .btn-pinterest:disabled {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {
  color: #fff;
  background-color: #8c0615;
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);
}

.btn-youtube {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-youtube:hover {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:focus, .btn-youtube.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(205, 32, 31, 0.5);
}
.btn-youtube.disabled, .btn-youtube:disabled {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active, .btn-youtube:not(:disabled):not(.disabled).active, .show > .btn-youtube.dropdown-toggle {
  color: #fff;
  background-color: #a11918;
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn-youtube:not(:disabled):not(.disabled).active:focus, .show > .btn-youtube.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);
}

.btn-slack {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-slack:hover {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:focus, .btn-slack.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 175, 133, 0.5);
}
.btn-slack.disabled, .btn-slack:disabled {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active, .btn-slack:not(:disabled):not(.disabled).active, .show > .btn-slack.dropdown-toggle {
  color: #fff;
  background-color: #2d8968;
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active:focus, .btn-slack:not(:disabled):not(.disabled).active:focus, .show > .btn-slack.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);
}

.btn-dribbble {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dribbble:hover {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:focus, .btn-dribbble.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(234, 76, 137, 0.5);
}
.btn-dribbble.disabled, .btn-dribbble:disabled {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active, .btn-dribbble:not(:disabled):not(.disabled).active, .show > .btn-dribbble.dropdown-toggle {
  color: #fff;
  background-color: #e51e6b;
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn-dribbble:not(:disabled):not(.disabled).active:focus, .show > .btn-dribbble.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);
}

.btn-github {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-github:hover {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:focus, .btn-github.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(34, 34, 34, 0.5);
}
.btn-github.disabled, .btn-github:disabled {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {
  color: #fff;
  background-color: #090909;
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);
}

.card-translucent {
  background-color: rgba(18, 91, 152, 0.08);
}

.card-profile-image {
  position: relative;
}
.card-profile-image img {
  max-width: 180px;
  border-radius: 0.375rem;
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  transition: all 0.15s ease;
}
.card-profile-image img:hover {
  transform: translate(-50%, -33%);
}

.card-profile-stats {
  padding: 1rem 0;
}
.card-profile-stats > div {
  text-align: center;
  margin-right: 1rem;
  padding: 0.875rem;
}
.card-profile-stats > div:last-child {
  margin-right: 0;
}
.card-profile-stats > div .heading {
  font-size: 1.1rem;
  font-weight: bold;
  display: block;
}
.card-profile-stats > div .description {
  font-size: 0.875rem;
  color: #adb5bd;
}

.card-profile-actions {
  padding: 0.875rem;
}

.card-lift--hover:hover {
  transform: translateY(-20px);
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .card-lift--hover:hover {
    transition: none;
  }
}

.card-stats .card-body {
  padding: 1rem 1.5rem;
}
.card-stats .card-status-bullet {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.chart {
  position: relative;
  height: 350px;
}

.chart-sm {
  height: 230px;
}

.chart-legend {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  font-size: 0.875rem;
  text-align: center;
  color: #8898aa;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
}
.chart-legend-item + .chart-legend-item {
  margin-left: 1rem;
}

.chart-legend-indicator {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.375rem;
  border-radius: 50%;
}

#chart-tooltip {
  z-index: 0;
}
#chart-tooltip .arrow {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateX(-0.5rem);
}

.chart-info-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  max-width: 350px;
  padding: 20px;
  z-index: 1;
}

.close {
  transition: all 0.15s ease;
}
.close > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  font-size: 1.25rem;
  display: block;
  transition: all 0.15s ease;
}
.close:hover, .close:focus {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.9);
  outline: none;
}
.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {
  background-color: transparent;
}

.main-content {
  position: relative;
}
.main-content .navbar-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  background-color: transparent;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
@media (min-width: 768px) {
  .main-content .container-fluid, .main-content .container-sm, .main-content .container-md, .main-content .container-lg, .main-content .container-xl {
    padding-left: 39px !important;
    padding-right: 39px !important;
  }
}

.navbar-vertical.navbar-expand-xs.fixed-left + .main-content {
  margin-left: 250px;
}
.navbar-vertical.navbar-expand-xs.fixed-right + .main-content {
  margin-right: 250px;
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-sm.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-md.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-lg.fixed-right + .main-content {
    margin-right: 250px;
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left + .main-content {
    margin-left: 250px;
  }
  .navbar-vertical.navbar-expand-xl.fixed-right + .main-content {
    margin-right: 250px;
  }
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-control-label::before {
  border: 1px solid #cad1d7;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.custom-control-label span {
  position: relative;
  top: 2px;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-control-alternative .custom-control-label::before {
  border: 0;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}
.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-radio .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5e72e4;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-radio .custom-control-input:disabled:checked::before {
  border-color: rgba(94, 114, 228, 0.5);
}

.custom-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 1.5rem;
}
.custom-toggle input {
  display: none;
}
.custom-toggle input:checked + .custom-toggle-slider {
  border: 1px solid #5e72e4;
}
.custom-toggle input:checked + .custom-toggle-slider:before {
  background: #5e72e4;
  transform: translateX(1.625rem);
}
.custom-toggle input:disabled + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider:before {
  background-color: #8a98eb;
}

.custom-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #cad1d7;
  border-radius: 34px !important;
  background-color: transparent;
}
.custom-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  border-radius: 50% !important;
  background-color: #e9ecef;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.dropdown,
.dropup,
.dropright,
.dropleft {
  display: inline-block;
}

.dropdown-menu {
  min-width: 12rem;
}
.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}
.dropdown-menu .dropdown-item > i,
.dropdown-menu .dropdown-item > svg {
  margin-right: 1rem;
  font-size: 1rem;
  vertical-align: -17%;
}

.dropdown-header {
  padding-left: 1rem;
  padding-right: 1rem;
  color: #f6f9fc;
  font-size: 0.625rem;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu a.media > div:first-child {
  line-height: 1;
}
.dropdown-menu a.media p {
  color: #8898aa;
}
.dropdown-menu a.media:hover .heading,
.dropdown-menu a.media:hover p {
  color: #172b4d !important;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4375rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4375rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4375rem;
}

.footer {
  background: #f7fafc;
  padding: 2.5rem 0;
}
.footer .col-footer .heading {
  color: #8898aa;
  letter-spacing: 0;
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 1rem;
}
.footer .nav .nav-item .nav-link,
.footer .footer-link {
  color: #8898aa !important;
}
.footer .nav .nav-item .nav-link:hover,
.footer .footer-link:hover {
  color: #525f7f !important;
}
.footer .list-unstyled li a {
  display: inline-block;
  padding: 0.125rem 0;
  color: #8898aa;
  font-size: 0.85rem;
}
.footer .list-unstyled li a:hover {
  color: #525f7f;
}
.footer .copyright {
  font-size: 0.875rem;
}

.footer-dark .col-footer .heading {
  color: #fff;
}

.nav-footer .nav-link {
  font-size: 0.875rem;
}
.nav-footer .nav-item:last-child .nav-link {
  padding-right: 0;
}

.footer.has-cards {
  overflow: hidden;
  padding-top: 500px;
  margin-top: -420px;
  position: relative;
  background: transparent;
  pointer-events: none;
}
.footer.has-cards:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 600px;
  height: 2000px;
  background: #f7fafc;
  transform: skew(0, -8deg);
}
.footer.has-cards .container {
  pointer-events: auto;
  position: relative;
}

.form-control-label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}

.form-control {
  font-size: 0.875rem;
}
.form-control:focus::placeholder {
  color: #adb5bd;
}

textarea[resize=none] {
  resize: none !important;
}

textarea[resize=both] {
  resize: both !important;
}

textarea[resize=vertical] {
  resize: vertical !important;
}

textarea[resize=horizontal] {
  resize: horizontal !important;
}

.form-control-muted {
  background-color: #F7FAFE;
  border-color: #F7FAFE;
  box-shadow: none;
}
.form-control-muted:focus {
  background-color: #fcfdff;
}

.form-control-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.form-control-alternative:focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.form-control-lg {
  font-size: 1rem;
}

.has-success,
.has-danger {
  position: relative;
}
.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 2px;
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.has-success:after {
  content: "\\ea26";
  color: daken(#2dce89, 18%);
  background-color: #69deac;
}
.has-success .form-control {
  background-color: #fff;
}
.has-success .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-success .form-control::placeholder {
  color: #2dce89;
}

.has-danger:after {
  content: "\\ea53";
  color: daken(#fb6340, 18%);
  background-color: #fda08b;
}
.has-danger .form-control {
  background-color: #fff;
}
.has-danger .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-danger .form-control::placeholder {
  color: #fb6340;
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.header {
  position: relative;
}

.icon {
  width: 3rem;
  height: 3rem;
}
.icon i, .icon svg {
  font-size: 2.25rem;
}
.icon + .icon-text {
  padding-left: 1rem;
  width: calc(100% - 3rem - 1);
}

.icon-xl {
  width: 5rem;
  height: 5rem;
}
.icon-xl i, .icon-xl svg {
  font-size: 4.25rem;
}
.icon-xl + .icon-text {
  width: calc(100% - 5rem - 1);
}

.icon-lg {
  width: 4rem;
  height: 4rem;
}
.icon-lg i, .icon-lg svg {
  font-size: 3.25rem;
}
.icon-lg + .icon-text {
  width: calc(100% - 4rem - 1);
}

.icon-sm {
  width: 2rem;
  height: 2rem;
}
.icon-sm i, .icon-sm svg {
  font-size: 1.25rem;
}
.icon-sm + .icon-text {
  width: calc(100% - 2rem - 1);
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.icon-shape i, .icon-shape svg {
  font-size: 1.25rem;
}
.icon-shape.icon-lg i, .icon-shape.icon-lg svg {
  font-size: 1.625rem;
}
.icon-shape.icon-sm i, .icon-shape.icon-sm svg {
  font-size: 0.875rem;
}
.icon-shape svg {
  width: 30px;
  height: 30px;
}

.icon-shape-primary {
  color: #2643e9;
  background-color: rgba(138, 152, 235, 0.5);
}

.icon-shape-secondary {
  color: #cfe3f1;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-success {
  color: #1aae6f;
  background-color: rgba(84, 218, 161, 0.5);
}

.icon-shape-info {
  color: #03acca;
  background-color: rgba(65, 215, 242, 0.5);
}

.icon-shape-warning {
  color: #ff3709;
  background-color: rgba(252, 140, 114, 0.5);
}

.icon-shape-danger {
  color: #f80031;
  background-color: rgba(247, 103, 131, 0.5);
}

.icon-shape-light {
  color: #879cb0;
  background-color: rgba(201, 207, 212, 0.5);
}

.icon-shape-dark {
  color: #090c0e;
  background-color: rgba(56, 63, 69, 0.5);
}

.icon-shape-default {
  color: #091428;
  background-color: rgba(35, 65, 116, 0.5);
}

.icon-shape-white {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-neutral {
  color: #e8e3e3;
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-darker {
  color: black;
  background-color: rgba(23, 26, 28, 0.5);
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.list-group-space .list-group-item {
  margin-bottom: 1.5rem;
  border-radius: 0.375rem;
}

.list-group-img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  vertical-align: top;
  margin: -0.1rem 1.2rem 0 -0.2rem;
}

.list-group-content {
  flex: 1 1;
  min-width: 0;
}
.list-group-content > p {
  color: #adb5bd;
  line-height: 1.5;
  margin: 0.2rem 0 0;
}

.list-group-heading {
  font-size: 1rem;
  color: #32325d;
}
.list-group-heading > small {
  float: right;
  color: #adb5bd;
  font-weight: 500;
}

.map-canvas {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 0.375rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .mask {
    transition: none;
  }
}

.modal-fluid .modal-dialog {
  margin-top: 0;
  margin-bottom: 0;
}
.modal-fluid .modal-content {
  border-radius: 0;
}

.modal-primary .modal-title {
  color: #fff;
}
.modal-primary .modal-header,
.modal-primary .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-primary .modal-content {
  background-color: #5e72e4;
  color: #fff;
}
.modal-primary .modal-content .heading {
  color: #fff;
}
.modal-primary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-secondary .modal-title {
  color: #212529;
}
.modal-secondary .modal-header,
.modal-secondary .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-secondary .modal-content {
  background-color: #f7fafc;
  color: #212529;
}
.modal-secondary .modal-content .heading {
  color: #212529;
}
.modal-secondary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-success .modal-title {
  color: #fff;
}
.modal-success .modal-header,
.modal-success .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-success .modal-content {
  background-color: #2dce89;
  color: #fff;
}
.modal-success .modal-content .heading {
  color: #fff;
}
.modal-success .close > span:not(.sr-only) {
  color: #fff;
}

.modal-info .modal-title {
  color: #fff;
}
.modal-info .modal-header,
.modal-info .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-info .modal-content {
  background-color: #11cdef;
  color: #fff;
}
.modal-info .modal-content .heading {
  color: #fff;
}
.modal-info .close > span:not(.sr-only) {
  color: #fff;
}

.modal-warning .modal-title {
  color: #fff;
}
.modal-warning .modal-header,
.modal-warning .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-warning .modal-content {
  background-color: #fb6340;
  color: #fff;
}
.modal-warning .modal-content .heading {
  color: #fff;
}
.modal-warning .close > span:not(.sr-only) {
  color: #fff;
}

.modal-danger .modal-title {
  color: #fff;
}
.modal-danger .modal-header,
.modal-danger .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-danger .modal-content {
  background-color: #f5365c;
  color: #fff;
}
.modal-danger .modal-content .heading {
  color: #fff;
}
.modal-danger .close > span:not(.sr-only) {
  color: #fff;
}

.modal-light .modal-title {
  color: #fff;
}
.modal-light .modal-header,
.modal-light .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-light .modal-content {
  background-color: #adb5bd;
  color: #fff;
}
.modal-light .modal-content .heading {
  color: #fff;
}
.modal-light .close > span:not(.sr-only) {
  color: #fff;
}

.modal-dark .modal-title {
  color: #fff;
}
.modal-dark .modal-header,
.modal-dark .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-dark .modal-content {
  background-color: #212529;
  color: #fff;
}
.modal-dark .modal-content .heading {
  color: #fff;
}
.modal-dark .close > span:not(.sr-only) {
  color: #fff;
}

.modal-default .modal-title {
  color: #fff;
}
.modal-default .modal-header,
.modal-default .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-default .modal-content {
  background-color: #172b4d;
  color: #fff;
}
.modal-default .modal-content .heading {
  color: #fff;
}
.modal-default .close > span:not(.sr-only) {
  color: #fff;
}

.modal-white .modal-title {
  color: #212529;
}
.modal-white .modal-header,
.modal-white .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-white .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-white .modal-content .heading {
  color: #212529;
}
.modal-white .close > span:not(.sr-only) {
  color: #fff;
}

.modal-neutral .modal-title {
  color: #212529;
}
.modal-neutral .modal-header,
.modal-neutral .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-neutral .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-neutral .modal-content .heading {
  color: #212529;
}
.modal-neutral .close > span:not(.sr-only) {
  color: #fff;
}

.modal-darker .modal-title {
  color: #fff;
}
.modal-darker .modal-header,
.modal-darker .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-darker .modal-content {
  background-color: black;
  color: #fff;
}
.modal-darker .modal-content .heading {
  color: #fff;
}
.modal-darker .close > span:not(.sr-only) {
  color: #fff;
}

.nav-wrapper {
  padding: 1rem 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-wrapper + .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.nav-link {
  color: #525f7f;
}
.nav-link:hover {
  color: #5e72e4;
}
.nav-link i.ni {
  position: relative;
  top: 2px;
}

@media (min-width: 992px) {
  .nav-item.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
    background: #f6f9fc;
  }
}
.nav-pills .nav-item:not(:last-child) {
  padding-right: 1rem;
}
.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #5e72e4;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  transition: all 0.15s ease;
}
.nav-pills .nav-link:hover {
  color: #485fe0;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5e72e4;
}
@media (max-width: 575.98px) {
  .nav-pills .nav-item {
    margin-bottom: 1rem;
  }
}

@media (max-width: 767.98px) {
  .nav-pills:not(.nav-pills-circle) .nav-item {
    padding-right: 0;
  }
}
.nav-pills-circle .nav-link {
  text-align: center;
  height: 60px;
  width: 60px;
  padding: 0;
  line-height: 60px;
  border-radius: 50%;
}
.nav-pills-circle .nav-link-icon i, .nav-pills-circle .nav-link-icon svg {
  font-size: 1rem;
}

.navbar-horizontal .navbar-nav .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: normal;
  letter-spacing: 0;
  transition: all 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-horizontal .navbar-nav .nav-link {
    transition: none;
  }
}
.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0.25rem;
}
.navbar-horizontal .navbar-brand {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.05px;
}
.navbar-horizontal .navbar-brand img {
  height: 30px;
}
.navbar-horizontal .navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-horizontal .navbar-light .navbar-brand {
  color: #32325d;
}
.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {
  margin-bottom: 1.5rem;
}
@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav .nav-item {
    margin-right: 0.5rem;
  }
  .navbar-horizontal .navbar-nav .nav-item [data-toggle=dropdown]::after {
    transition: all 0.15s ease;
  }
  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=dropdown]::after {
    transform: rotate(180deg);
  }
  .navbar-horizontal .navbar-nav .nav-link {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link i {
    margin-right: 0.625rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-size: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon i {
    margin-right: 0;
  }
}
.navbar-horizontal .navbar-transparent {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: transparent;
  border: 0;
  box-shadow: none;
}
.navbar-horizontal .navbar-transparent .navbar-brand {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
@media (min-width: 768px) {
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:hover, .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .show > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .active > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.show,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.active {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand:hover, .navbar-horizontal .navbar-transparent .navbar-brand:focus {
    color: rgba(255, 255, 255, 0.95);
  }
}

.navbar-vertical {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.navbar-vertical .navbar {
  border-width: 0 0 1px 0;
  border-style: solid;
}
.navbar-vertical .navbar-light {
  background-color: transparent;
  border-color: #f6f9fc;
}
.navbar-vertical .navbar-brand {
  margin-right: 0;
}
.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand > img {
  max-width: 100%;
  max-height: 20rem;
}
@media (min-width: 768px) {
  .navbar-vertical .navbar-collapse {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.navbar-vertical .navbar-nav {
  margin-left: -1rem;
  margin-right: -1rem;
}
.navbar-vertical .navbar-nav .nav-link {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.9rem;
}
.navbar-vertical .navbar-nav .nav-link.active {
  position: relative;
}
.navbar-vertical .navbar-nav .nav-link.active:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.25rem;
  bottom: 0.25rem;
  border-left: 2px solid #5e72e4;
}
.navbar-vertical .navbar-nav .nav-link > i {
  min-width: 2.25rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
}
.navbar-vertical .navbar-nav .nav-link .dropdown-menu {
  border: none;
}
.navbar-vertical .navbar-nav .nav-link .dropdown-menu .dropdown-menu {
  margin-left: 0.75rem;
}
.navbar-vertical .navbar-nav .nav-link {
  display: flex;
  align-items: center;
}
.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse]:after {
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  content: "\\f105";
  margin-left: auto;
  color: #8898aa;
  transition: all 0.15s ease;
}
.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(90deg);
}
.navbar-vertical .navbar-nav .nav .nav-link {
  padding-left: 3.25rem;
}
.navbar-vertical .navbar-nav .nav .nav .nav-link {
  padding-left: 3.75rem;
}
.navbar-vertical .navbar-heading {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.navbar-vertical.navbar-expand-xs {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: 250px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  overflow-y: auto;
}
.navbar-vertical.navbar-expand-xs > [class*=container] {
  flex-direction: column;
  align-items: stretch;
  min-height: 100%;
  padding-left: 0;
  padding-right: 0;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xs > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
.navbar-vertical.navbar-expand-xs.fixed-left {
  left: 0;
  border-width: 0 1px 0 0;
}
.navbar-vertical.navbar-expand-xs.fixed-right {
  right: 0;
  border-width: 0 0 0 1px;
}
.navbar-vertical.navbar-expand-xs .navbar-collapse {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-collapse > * {
  min-width: 100%;
}
.navbar-vertical.navbar-expand-xs .navbar-nav {
  flex-direction: column;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
  padding: 0.65rem 1.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link.active:before {
  top: 0.25rem;
  bottom: 0.25rem;
  left: 0;
  right: auto;
  border-left: 2px solid #5e72e4;
  border-bottom: 0;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link {
  padding-left: 3.75rem;
}
.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav .nav-link {
  padding-left: 4.5rem;
}
.navbar-vertical.navbar-expand-xs .navbar-brand {
  display: block;
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.navbar-vertical.navbar-expand-xs .navbar-brand-img {
  max-height: 40rem;
}
.navbar-vertical.navbar-expand-xs .navbar-user {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-top: 1rem;
  padding-bottom: 0rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-top: 1px solid #e9ecef;
}
.navbar-vertical.navbar-expand-xs .navbar-user .dropup .dropdown-menu {
  left: 50%;
  transform: translateX(-50%);
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-sm > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 576px) and (-ms-high-contrast: none), (min-width: 576px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-sm > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 576px) {
  .navbar-vertical.navbar-expand-sm.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-sm.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-sm .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-brand-img {
    max-height: 40rem;
  }
  .navbar-vertical.navbar-expand-sm .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-sm .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-md > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 768px) and (-ms-high-contrast: none), (min-width: 768px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-md > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-md.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-md .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-brand-img {
    max-height: 40rem;
  }
  .navbar-vertical.navbar-expand-md .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-md .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-lg > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 992px) and (-ms-high-contrast: none), (min-width: 992px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-lg > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 992px) {
  .navbar-vertical.navbar-expand-lg.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-lg.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-lg .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-brand-img {
    max-height: 40rem;
  }
  .navbar-vertical.navbar-expand-lg .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-lg .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 250px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    overflow-y: auto;
  }
  .navbar-vertical.navbar-expand-xl > [class*=container] {
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1200px) and (-ms-high-contrast: none), (min-width: 1200px) and (-ms-high-contrast: active) {
  .navbar-vertical.navbar-expand-xl > [class*=container] {
    min-height: none;
    height: 100%;
  }
}
@media (min-width: 1200px) {
  .navbar-vertical.navbar-expand-xl.fixed-left {
    left: 0;
    border-width: 0 1px 0 0;
  }
  .navbar-vertical.navbar-expand-xl.fixed-right {
    right: 0;
    border-width: 0 0 0 1px;
  }
  .navbar-vertical.navbar-expand-xl .navbar-collapse {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-collapse > * {
    min-width: 100%;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav {
    flex-direction: column;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link {
    padding: 0.65rem 1.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link.active:before {
    top: 0.25rem;
    bottom: 0.25rem;
    left: 0;
    right: auto;
    border-left: 2px solid #5e72e4;
    border-bottom: 0;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link {
    padding-left: 3.75rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav .nav-link {
    padding-left: 4.5rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-brand {
    display: block;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-brand-img {
    max-height: 40rem;
  }
  .navbar-vertical.navbar-expand-xl .navbar-user {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-top: 1rem;
    padding-bottom: 0rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    border-top: 1px solid #e9ecef;
  }
  .navbar-vertical.navbar-expand-xl .navbar-user .dropup .dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
  }
}

.search-container {
  position: relative;
}
.search-container input {
  width: 200px;
  padding-right: 40px;
  padding-left: 15px;
}
.search-container .search_btn {
  position: absolute;
  padding: 5px;
  background-color: transparent;
  box-shadow: none;
  border: 0;
  right: 10px;
  top: 5px;
}

.navbar-search .input-group {
  border-radius: 2rem;
  border: 2px solid;
  background-color: transparent;
}
.navbar-search .input-group .input-group-text {
  background-color: transparent;
  padding-left: 1rem;
}
.navbar-search .form-control {
  width: 270px;
  background-color: transparent;
}

.navbar-search-dark .input-group {
  border-color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .input-group-text {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .form-control {
  color: rgba(255, 255, 255, 0.9);
}
.navbar-search-dark .form-control::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .focused .input-group {
  border-color: rgba(255, 255, 255, 0.9);
}

.navbar-search-light .input-group {
  border-color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .input-group-text {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .form-control {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-search-light .form-control::placeholder {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .focused .input-group {
  border-color: rgba(0, 0, 0, 0.9);
}

@media (min-width: 768px) {
  .navbar .dropdown-menu {
    opacity: 0;
    pointer-events: none;
    margin: 0;
  }
  .navbar .dropdown-menu-arrow:before {
    background: #fff;
    box-shadow: none;
    content: "";
    display: block;
    height: 12px;
    width: 12px;
    left: 20px;
    position: absolute;
    bottom: 100%;
    transform: rotate(-45deg) translateY(12px);
    z-index: -5;
    border-radius: 2px;
  }
  .navbar .dropdown-menu-right:before {
    right: 20px;
    left: auto;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.show {
    opacity: 1;
    pointer-events: auto;
    animation: show-navbar-dropdown 0.25s ease forwards;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.close {
    display: block;
    animation: hide-navbar-dropdown 0.15s ease backwards;
  }
  .navbar.navbar-nav-hover .dropdown-menu {
    opacity: 0;
    display: block;
    pointer-events: none;
    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }
  .navbar.navbar-nav-hover .nav-item.dropdown:hover > .dropdown-menu {
    display: block;
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    transform: translate(0, 0);
    animation: none;
  }
  .navbar .dropdown-menu-inner {
    position: relative;
    padding: 1rem;
  }
  @keyframes show-navbar-dropdown {
    0% {
      opacity: 0;
      transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
      transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes hide-navbar-dropdown {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translate(0, 10px);
    }
  }
}
.navbar-collapse-header {
  display: none;
}

@media (max-width: 767.98px) {
  .navbar-nav .nav-link {
    padding: 0.625rem 0;
    color: #172b4d !important;
  }
  .navbar-nav .dropdown-menu {
    box-shadow: none;
    min-width: auto;
  }
  .navbar-nav .dropdown-menu .media svg {
    width: 30px;
  }
  .navbar-collapse {
    width: calc(100% - 1.4rem);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    margin: 0.7rem;
    overflow-y: auto;
    height: auto !important;
    opacity: 0;
  }
  .navbar-collapse .navbar-toggler {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    padding: 0;
  }
  .navbar-collapse .navbar-toggler span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    opacity: 1;
    background: #283448;
  }
  .navbar-collapse .navbar-toggler :nth-child(1) {
    transform: rotate(135deg);
  }
  .navbar-collapse .navbar-toggler :nth-child(2) {
    transform: rotate(-135deg);
  }
  .navbar-collapse .navbar-collapse-header {
    display: block;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .navbar-collapse .collapse-brand img {
    height: 36px;
  }
  .navbar-collapse .collapse-close {
    text-align: right;
  }
  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    padding: 1.5rem;
    border-radius: 0.375rem;
    background: #FFF;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    animation: show-navbar-collapse 0.2s ease forwards;
  }
  .navbar-collapse.collapsing-out {
    animation: hide-navbar-collapse 0.2s ease forwards;
  }
}
@keyframes show-navbar-collapse {
  0% {
    opacity: 0;
    transform: scale(0.95);
    transform-origin: 100% 0;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes hide-navbar-collapse {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: 100% 0;
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}
.page-item.active .page-link {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.page-item .page-link,
.page-item span {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 3px;
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.pagination-lg .page-item .page-link,
.pagination-lg .page-item span {
  width: 46px;
  height: 46px;
  line-height: 46px;
}

.pagination-sm .page-item .page-link,
.pagination-sm .page-item span {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.popover {
  border: 0;
}

.popover-header {
  font-weight: 600;
}

.popover-primary {
  background-color: #5e72e4;
}
.popover-primary .popover-header {
  background-color: #5e72e4;
  color: #fff;
}
.popover-primary .popover-body {
  color: #fff;
}
.popover-primary .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #5e72e4;
}
.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #5e72e4;
}
.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #5e72e4;
}
.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #5e72e4;
}

.popover-secondary {
  background-color: #f7fafc;
}
.popover-secondary .popover-header {
  background-color: #f7fafc;
  color: #212529;
}
.popover-secondary .popover-body {
  color: #212529;
}
.popover-secondary .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f7fafc;
}
.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f7fafc;
}
.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f7fafc;
}
.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f7fafc;
}

.popover-success {
  background-color: #2dce89;
}
.popover-success .popover-header {
  background-color: #2dce89;
  color: #fff;
}
.popover-success .popover-body {
  color: #fff;
}
.popover-success .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #2dce89;
}
.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #2dce89;
}
.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #2dce89;
}
.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #2dce89;
}

.popover-info {
  background-color: #11cdef;
}
.popover-info .popover-header {
  background-color: #11cdef;
  color: #fff;
}
.popover-info .popover-body {
  color: #fff;
}
.popover-info .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #11cdef;
}
.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #11cdef;
}
.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #11cdef;
}
.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #11cdef;
}

.popover-warning {
  background-color: #fb6340;
}
.popover-warning .popover-header {
  background-color: #fb6340;
  color: #fff;
}
.popover-warning .popover-body {
  color: #fff;
}
.popover-warning .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fb6340;
}
.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fb6340;
}
.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fb6340;
}
.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fb6340;
}

.popover-danger {
  background-color: #f5365c;
}
.popover-danger .popover-header {
  background-color: #f5365c;
  color: #fff;
}
.popover-danger .popover-body {
  color: #fff;
}
.popover-danger .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f5365c;
}
.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f5365c;
}
.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f5365c;
}
.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f5365c;
}

.popover-light {
  background-color: #adb5bd;
}
.popover-light .popover-header {
  background-color: #adb5bd;
  color: #fff;
}
.popover-light .popover-body {
  color: #fff;
}
.popover-light .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #adb5bd;
}
.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #adb5bd;
}
.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #adb5bd;
}
.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #adb5bd;
}

.popover-dark {
  background-color: #212529;
}
.popover-dark .popover-header {
  background-color: #212529;
  color: #fff;
}
.popover-dark .popover-body {
  color: #fff;
}
.popover-dark .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #212529;
}
.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #212529;
}
.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #212529;
}
.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #212529;
}

.popover-default {
  background-color: #172b4d;
}
.popover-default .popover-header {
  background-color: #172b4d;
  color: #fff;
}
.popover-default .popover-body {
  color: #fff;
}
.popover-default .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #172b4d;
}
.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #172b4d;
}
.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #172b4d;
}
.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #172b4d;
}

.popover-white {
  background-color: #fff;
}
.popover-white .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-white .popover-body {
  color: #212529;
}
.popover-white .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-neutral {
  background-color: #fff;
}
.popover-neutral .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-neutral .popover-body {
  color: #212529;
}
.popover-neutral .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-darker {
  background-color: black;
}
.popover-darker .popover-header {
  background-color: black;
  color: #fff;
}
.popover-darker .popover-body {
  color: #fff;
}
.popover-darker .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: black;
}
.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: black;
}
.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: black;
}
.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: black;
}

.progress-wrapper {
  position: relative;
  padding-top: 1.5rem;
}

.progress {
  height: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress .sr-only {
  width: auto;
  height: 20px;
  margin: 0 0 0 30px;
  left: 0;
  clip: auto;
  line-height: 20px;
  font-size: 13px;
}

.progress-heading {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  padding: 0;
}

.progress-bar {
  box-shadow: none;
  border-radius: 0;
  height: auto;
}

.progress-info {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-label span {
  display: inline-block;
  color: #5e72e4;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgba(94, 114, 228, 0.1);
  padding: 0.25rem 1rem;
  border-radius: 30px;
}

.progress-percentage {
  text-align: right;
}
.progress-percentage span {
  display: inline-block;
  color: #8898aa;
  font-size: 0.875rem;
  font-weight: 600;
}

.separator {
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 150px;
  transform: translateZ(0);
  overflow: hidden;
  pointer-events: none;
}
.separator svg {
  position: absolute;
  pointer-events: none;
}

.separator-top {
  top: 0;
  bottom: auto;
}
.separator-top svg {
  top: 0;
}

.separator-bottom {
  top: auto;
  bottom: 0;
}
.separator-bottom svg {
  bottom: 0;
}

.separator-inverse {
  transform: rotate(180deg);
}

.separator-skew {
  height: 60px;
}
@media (min-width: 1200px) {
  .separator-skew {
    height: 70px;
  }
}

.table thead th {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid #e9ecef;
}
.table th {
  font-weight: 600;
}
.table td .progress {
  height: 3px;
  width: 120px;
  margin: 0;
}
.table td,
.table th {
  font-size: 0.8125rem;
  white-space: nowrap;
}
.table.align-items-center td,
.table.align-items-center th {
  vertical-align: middle;
}
.table .thead-dark th {
  background-color: #1c345d;
  color: #4d7bca;
}
.table .thead-light th {
  background-color: #f6f9fc;
  color: #8898aa;
}

.table-hover tr {
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .table-hover tr {
    transition: none;
  }
}

.table-flush td,
.table-flush th {
  border-left: 0;
  border-right: 0;
}
.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}
.table-flush tbody tr:last-child td,
.table-flush tbody tr:last-child th {
  border-bottom: 0;
}

.card .table {
  margin-bottom: 0;
}
.card .table td,
.card .table th {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  white-space: break-spaces;
}

p {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.7;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.7;
  margin-top: 1.5rem;
}
.lead + .btn-wrapper {
  margin-top: 3rem;
}

.description {
  font-size: 0.875rem;
}

.heading {
  letter-spacing: 0.025em;
  font-size: 0.95rem;
  text-transform: uppercase;
  font-weight: 600;
}

.heading-small {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.heading-title {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}

.heading-section {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}
.heading-section img {
  display: block;
  width: 72px;
  height: 72px;
  margin-bottom: 1.5rem;
}
.heading-section.text-center img {
  margin-left: auto;
  margin-right: auto;
}

.display-1 span,
.display-2 span,
.display-3 span,
.display-4 span {
  display: block;
  font-weight: 300;
}

article h4:not(:first-child),
article h5:not(:first-child) {
  margin-top: 3rem;
}
article h4, article h5 {
  margin-bottom: 1.5rem;
}
article figure {
  margin: 3rem 0;
}
article h5 + figure {
  margin-top: 0;
}

.datepicker {
  border-radius: 0.375rem;
  direction: ltr;
}
.datepicker-inline {
  width: 220px;
}
.datepicker-rtl {
  direction: rtl;
}
.datepicker-rtl.dropdown-menu {
  left: auto;
}
.datepicker-rtl table tr td span {
  float: right;
}
.datepicker-dropdown {
  top: 0;
  left: 0;
  padding: 20px 22px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.datepicker-dropdown.datepicker-orient-left:before {
  left: 6px;
}
.datepicker-dropdown.datepicker-orient-left:after {
  left: 7px;
}
.datepicker-dropdown.datepicker-orient-right:before {
  right: 6px;
}
.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}
.datepicker-dropdown.datepicker-orient-bottom:before {
  top: -7px;
}
.datepicker-dropdown.datepicker-orient-bottom:after {
  top: -6px;
}
.datepicker-dropdown.datepicker-orient-top:before {
  bottom: -7px;
  border-bottom: 0;
  border-top: 7px solid white;
}
.datepicker-dropdown.datepicker-orient-top:after {
  bottom: -6px;
  border-bottom: 0;
  border-top: 6px solid #fff;
}
.datepicker table {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.datepicker table tr td {
  border-radius: 50%;
}
.datepicker table tr th {
  border-radius: 0.375rem;
  font-weight: 500;
}
.datepicker table tr td,
.datepicker table tr th {
  transition: all 0.15s ease;
  width: 36px;
  height: 36px;
  border: none;
  text-align: center;
  font-size: 0.875rem;
}
.table-striped .datepicker table tr td,
.table-striped .datepicker table tr th {
  background-color: transparent;
}
.datepicker table tr td.old, .datepicker table tr td.new {
  color: #adb5bd;
}
.datepicker table tr td.day:hover, .datepicker table tr td.focused {
  background: white;
  cursor: pointer;
}
.datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td.highlighted {
  border-radius: 0;
}
.datepicker table tr td.highlighted.focused {
  background: #5e72e4;
}
.datepicker table tr td.highlighted.disabled, .datepicker table tr td.highlighted.disabled:active {
  background: #5e72e4;
  color: #ced4da;
}
.datepicker table tr td.today {
  background: white;
}
.datepicker table tr td.today.focused {
  background: white;
}
.datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:active {
  background: white;
  color: #8898aa;
}
.datepicker table tr td.range {
  background: #5e72e4;
  color: #fff;
  border-radius: 0;
}
.datepicker table tr td.range.focused {
  background: #3b53de;
}
.datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:active, .datepicker table tr td.range.day.disabled:hover {
  background: #324cdd;
  color: #8a98eb;
}
.datepicker table tr td.range.highlighted.focused {
  background: #cbd3da;
}
.datepicker table tr td.range.highlighted.disabled, .datepicker table tr td.range.highlighted.disabled:active {
  background: #e9ecef;
  color: #dee2e6;
}
.datepicker table tr td.range.today.disabled, .datepicker table tr td.range.today.disabled:active {
  background: #5e72e4;
  color: #fff;
}
.datepicker table tr td.day.range-start {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.datepicker table tr td.day.range-end {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.datepicker table tr td.day.range-start.range-end {
  border-radius: 50%;
}
.datepicker table tr td.selected, .datepicker table tr td.selected.highlighted, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.highlighted:hover, .datepicker table tr td.day.range:hover {
  background: #5e72e4;
  color: #fff;
}
.datepicker table tr td.active, .datepicker table tr td.active.highlighted, .datepicker table tr td.active:hover, .datepicker table tr td.active.highlighted:hover {
  background: #5e72e4;
  color: #fff;
  box-shadow: none;
}
.datepicker table tr td span {
  display: block;
  width: 23%;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 1%;
  cursor: pointer;
  border-radius: 4px;
}
.datepicker table tr td span:hover, .datepicker table tr td span.focused {
  background: #e9ecef;
}
.datepicker table tr td span.disabled, .datepicker table tr td span.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td span.active, .datepicker table tr td span.active:hover, .datepicker table tr td span.active.disabled, .datepicker table tr td span.active.disabled:hover {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.datepicker table tr td span.old, .datepicker table tr td span.new {
  color: #8898aa;
}
.datepicker .datepicker-switch {
  width: 145px;
}
.datepicker .datepicker-switch,
.datepicker .prev,
.datepicker .next,
.datepicker tfoot tr th {
  cursor: pointer;
}
.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
  background: #e9ecef;
}
.datepicker .prev.disabled,
.datepicker .next.disabled {
  visibility: hidden;
}
.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

/*! nouislider - 14.0.1 - 6/21/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 18px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  left: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -17px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #E8E7E6;
  left: 14px;
  top: 6px;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  background: #eceeef;
  border-radius: 5px;
  border: 0;
  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);
  margin: 15px 0;
  cursor: pointer;
}

.noUi-horizontal {
  height: 5px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -10px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-connect {
  background: #5e72e4;
  box-shadow: none;
}

.noUi-handle:after, .noUi-handle:before {
  content: none;
}
.noUi-handle:focus {
  outline: none;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  top: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  box-shadow: none;
  cursor: pointer;
  background-color: #5e72e4;
  border: 0;
  transition: box-shadow 0.15s, transform 0.15s;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
  box-shadow: 0px 0px 0px 2px #5e72e4;
}

.input-slider--cyan .noUi-connect {
  background: #2bffc6;
}

/* Disabled state */
[disabled] .noUi-connect,
[disabled].noUi-connect {
  background: #b2b2b2;
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
  cursor: not-allowed;
}

/* Range slider value labels */
.range-slider-value {
  font-size: 0.75rem;
  font-weight: 500;
  background-color: rgba(33, 37, 41, 0.7);
  color: #fff;
  border-radius: 10px;
  padding: 0.4em 0.8em 0.3em 0.85em;
}

.range-slider-wrapper .upper-info {
  font-weight: 400;
  margin-bottom: 5px;
}

.input-slider-value-output {
  background: #333;
  color: #fff;
  padding: 4px 8px;
  position: relative;
  top: 12px;
  font-size: 11px;
  border-radius: 2px;
}

.input-slider-value-output:after {
  bottom: 100%;
  left: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #333;
  border-width: 4px;
  margin-left: -4px;
}

.input-slider-value-output.left:after {
  left: 10px;
  right: auto;
}

.input-slider-value-output.right:after {
  right: 10px;
  left: auto;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-navbar {
  background-color: #5e72e4;
  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
@media (max-width: 991.98px) {
  .ct-navbar {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .ct-navbar .navbar-nav-scroll {
    max-width: 100%;
    height: 2.5rem;
    margin-top: 0.25rem;
    overflow: hidden;
    font-size: 0.875rem;
  }
  .ct-navbar .navbar-nav-scroll .navbar-nav {
    padding-bottom: 2rem;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
}
@media (min-width: 768px) {
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-navbar {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 1071;
    }
  }
}
.ct-navbar .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: rgba(255, 255, 255, 0.9) !important;
}
.ct-navbar .navbar-nav .nav-link.active, .ct-navbar .navbar-nav .nav-link:hover {
  color: #fff !important;
  background-color: transparent !important;
}
.ct-navbar .navbar-nav .nav-link.active {
  font-weight: 500;
}
.ct-navbar .navbar-nav-svg {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-top;
}
.ct-navbar .dropdown-menu {
  font-size: 0.875rem;
}
.ct-navbar .dropdown-item.active {
  font-weight: 500;
  color: #212529;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-position: 0.4rem 0.87rem;
  background-size: 0.75rem 0.75rem;
  padding-left: 25px;
}

.github-corner {
  position: fixed;
  right: 0;
  z-index: 1080;
}
.github-corner:hover .octo-arm {
  animation: octocat-wave 560ms ease-in-out;
}
.github-corner svg {
  fill: #fff;
  color: #5e72e4;
}

@keyframes octocat-wave {
  0%, 100% {
    transform: rotate(0);
  }
  20%, 60% {
    transform: rotate(-25deg);
  }
  40%, 80% {
    transform: rotate(10deg);
  }
}
.ct-clipboard {
  position: relative;
  display: none;
  float: right;
}
.ct-clipboard + .highlight {
  margin-top: 0;
}

.btn-clipboard {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 75%;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  border-radius: 0.25rem;
  color: #fff;
  background-color: #5e72e4;
}
.btn-clipboard:hover {
  color: #fff;
  background-color: #324cdd;
}

@media (min-width: 768px) {
  .ct-clipboard {
    display: block;
  }
}
.ct-example-row .row > .col span,
.ct-example-row .row > [class^=col-] span {
  display: block;
  padding: 0.75rem;
  color: rgb(57, 63, 73);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  margin: 1rem 0;
}
.ct-example-row .no-gutters > .col span,
.ct-example-row .no-gutters > [class^=col-] span {
  border-radius: 0;
}
.ct-example-row .flex-items-top,
.ct-example-row .flex-items-middle,
.ct-example-row .flex-items-bottom {
  min-height: 6rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.ct-example-row-flex-cols .row {
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1);
}
.ct-example-row-flex-cols .row + .row {
  margin-top: 1rem;
}

.ct-highlight {
  background-color: rgba(94, 114, 228, 0.15);
  border: 1px solid rgba(94, 114, 228, 0.15);
}

.example-container {
  width: 800px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.example-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.example-content-main {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-main {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-main {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
}

.example-content-secondary {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-secondary {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-secondary {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
}

.ct-example-container {
  min-width: 16rem;
  max-width: 25rem;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-container-header {
  height: 3rem;
  margin-bottom: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
}

.ct-example-container-sidebar {
  float: right;
  width: 4rem;
  height: 8rem;
  background-color: #cbd2f6;
  border-radius: 0.25rem;
}

.ct-example-container-body {
  height: 8rem;
  margin-right: 4.5rem;
  background-color: #cbd2f6;
  border-radius: 0.25rem;
}

.ct-example-container-fluid {
  max-width: none;
}

.ct-example {
  position: relative;
  margin: 1rem -15px 0;
}
.ct-example::after {
  display: block;
  clear: both;
  content: "";
}
@media (min-width: 576px) {
  .ct-example {
    margin-right: 0;
    margin-left: 0;
  }
}
.ct-example + .highlight,
.ct-example + .clipboard + .highlight {
  margin-top: 0;
}
.ct-example + p {
  margin-top: 2rem;
}
.ct-example .pos-f-t {
  position: relative;
  margin: -1rem;
}
@media (min-width: 576px) {
  .ct-example .pos-f-t {
    margin: -1.5rem;
  }
}
.ct-example .custom-file-input:lang(es) ~ .custom-file-label::after {
  content: "Elegir";
}
.ct-example > .form-control + .form-control {
  margin-top: 0.5rem;
}
.ct-example > .nav + .nav,
.ct-example > .alert + .alert,
.ct-example > .navbar + .navbar,
.ct-example > .progress + .progress,
.ct-example > .progress + .btn,
.ct-example .badge,
.ct-example .btn {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group .btn {
  margin: 0;
}
.ct-example .alert {
  margin: 0;
}
.ct-example .alert + .alert {
  margin-top: 1.25rem;
}
.ct-example .badge {
  margin-right: 0.5rem;
}
.ct-example > .dropdown-menu:first-child {
  position: static;
  display: block;
}
.ct-example > .form-group:last-child {
  margin-bottom: 0;
}
.ct-example > .close {
  float: none;
}

.ct-example-type .table .type-info {
  color: #999;
  vertical-align: middle;
}
.ct-example-type .table td {
  padding: 1rem 0;
  border-color: #eee;
}
.ct-example-type .table tr:first-child td {
  border-top: 0;
}
.ct-example-type h1,
.ct-example-type h2,
.ct-example-type h3,
.ct-example-type h4,
.ct-example-type h5,
.ct-example-type h6 {
  margin-top: 0;
  margin-bottom: 0;
}

.ct-example-bg-classes p {
  padding: 1rem;
}

.ct-example > img + img {
  margin-left: 0.5rem;
}

.ct-example > .btn-group {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.ct-example > .btn-toolbar + .btn-toolbar {
  margin-top: 0.5rem;
}

.ct-example-control-sizing select,
.ct-example-control-sizing input[type=text] + input[type=text] {
  margin-top: 0.5rem;
}

.ct-example-form .input-group {
  margin-bottom: 0.5rem;
}

.ct-example > textarea.form-control {
  resize: vertical;
}

.ct-example > .list-group {
  max-width: 400px;
}

.ct-example .fixed-top,
.ct-example .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem;
}
.ct-example .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem;
}
@media (min-width: 576px) {
  .ct-example .fixed-top,
  .ct-example .sticky-top {
    margin: -1.5rem -1.5rem 1rem;
  }
  .ct-example .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem;
  }
}

.ct-example .pagination {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.modal {
  z-index: 1072;
}
.modal .tooltip,
.modal .popover {
  z-index: 1073;
}

.modal-backdrop {
  z-index: 1071;
}

.ct-example-modal {
  background-color: #fafafa;
}
.ct-example-modal .modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.ct-example-modal .modal-dialog {
  left: auto;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-tabs .nav-tabs {
  margin-bottom: 1rem;
}

.ct-example-popover-static {
  padding-bottom: 1.5rem;
  background-color: #f9f9f9;
}
.ct-example-popover-static .popover {
  position: relative;
  display: block;
  float: left;
  width: 260px;
  margin: 1.25rem;
}

.tooltip-demo a {
  white-space: nowrap;
}

.ct-example-tooltip-static .tooltip {
  position: relative;
  display: inline-block;
  margin: 10px 20px;
  opacity: 1;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 350px;
  overflow: auto;
}

.ct-example-border-utils [class^=border] {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #f5f5f5;
}

.ct-example-border-utils-0 [class^=border] {
  border: 1px solid #e9ecef;
}

.highlight {
  padding: 0;
  margin-top: 1rem;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
@media (min-width: 576px) {
  .highlight {
    padding: 0;
  }
}

.ct-content .highlight {
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 576px) {
  .ct-content .highlight {
    margin-right: 0;
    margin-left: 0;
  }
}

.ct-example {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}
.ct-example .tab-content .tab-example-result {
  background-color: #f5f7f9;
  border: 1px solid #e6ecf1;
  padding: 1.25rem;
  border-radius: 0.25rem;
}
.ct-example .nav-tabs-code {
  margin-bottom: 0.375rem;
}
.ct-example .nav-tabs-code .nav-link {
  font-size: 0.875rem;
}
.ct-example .nav-tabs-code .nav-link:active, .ct-example .nav-tabs-code .nav-link.active {
  color: #5e72e4;
}

.icon-examples {
  margin-top: 1rem;
}

.btn-icon-clipboard {
  margin: 0px;
  padding: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  color: rgb(57, 63, 73);
  background-color: rgb(248, 249, 250);
  border-radius: 4px;
  border: 0px none;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: rgb(57, 63, 73);
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgb(57, 63, 73);
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

code[class*=language-],
pre[class*=language-] {
  font-family: Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace;
  font-size: 14px;
  line-height: 1.375;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  tab-size: 4;
  -webkit-hyphens: none;
  hyphens: none;
  background: #f5f7ff;
  color: #5e6687;
  border-radius: 0.25rem;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #dfe2f1;
}

/* Code blocks */
pre[class*=language-] {
  padding: 1.25rem;
  margin: 0;
  overflow: auto;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #898ea4;
}

.token.punctuation {
  color: #5e6687;
}

.token.namespace {
  opacity: 0.7;
}

.token.operator,
.token.boolean,
.token.number {
  color: #c76b29;
}

.token.property {
  color: #c08b30;
}

.token.tag {
  color: #3d8fd1;
}

.token.string {
  color: #22a2c9;
}

.token.selector {
  color: #6679cc;
}

.token.attr-name {
  color: #c76b29;
}

.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #22a2c9;
}

.token.attr-value,
.token.keyword,
.token.control,
.token.directive,
.token.unit {
  color: #ac9739;
}

.token.statement,
.token.regex,
.token.atrule {
  color: #22a2c9;
}

.token.placeholder,
.token.variable {
  color: #3d8fd1;
}

.token.deleted {
  text-decoration: line-through;
}

.token.inserted {
  border-bottom: 1px dotted #202746;
  text-decoration: none;
}

.token.italic {
  font-style: italic;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.important {
  color: #c94922;
}

.token.entity {
  cursor: help;
}

pre > code.highlight {
  outline: 0.4em solid #c94922;
  outline-offset: 0.4em;
}

/* overrides color-values for the Line Numbers plugin
 * http://prismjs.com/plugins/line-numbers/
 */
.line-numbers .line-numbers-rows {
  border-right-color: #dfe2f1;
}

.line-numbers-rows > span:before {
  color: #979db4;
}

/* overrides color-values for the Line Highlight plugin
 * http://prismjs.com/plugins/line-highlight/
 */
.line-highlight {
  background: rgba(107, 115, 148, 0.2);
  background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));
}

.docs {
  background: #FFF;
}
.docs h6 {
  font-size: 1rem;
  font-weight: 600;
}

.ct-content {
  order: 1;
}
.ct-content > h2[id],
.ct-content > h3[id],
.ct-content > h4[id] {
  pointer-events: none;
}
.ct-content > h2[id] > div,
.ct-content > h2[id] > a,
.ct-content > h3[id] > div,
.ct-content > h3[id] > a,
.ct-content > h4[id] > div,
.ct-content > h4[id] > a {
  pointer-events: auto;
}
.ct-content > h2[id]::before,
.ct-content > h3[id]::before,
.ct-content > h4[id]::before {
  display: block;
  height: 6rem;
  margin-top: -6rem;
  visibility: hidden;
  content: "";
}
.ct-content > table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
}
@media (max-width: 991.98px) {
  .ct-content > table {
    display: block;
    overflow-x: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .ct-content > table.table-bordered {
    border: 0;
  }
}
.ct-content > table > thead > tr > th,
.ct-content > table > thead > tr > td,
.ct-content > table > tbody > tr > th,
.ct-content > table > tbody > tr > td,
.ct-content > table > tfoot > tr > th,
.ct-content > table > tfoot > tr > td {
  padding: 1rem;
  vertical-align: top;
  border: 1px solid #e9ecef;
}
.ct-content > table > thead > tr > th > p:last-child,
.ct-content > table > thead > tr > td > p:last-child,
.ct-content > table > tbody > tr > th > p:last-child,
.ct-content > table > tbody > tr > td > p:last-child,
.ct-content > table > tfoot > tr > th > p:last-child,
.ct-content > table > tfoot > tr > td > p:last-child {
  margin-bottom: 0;
}
.ct-content > table td:first-child > code {
  white-space: nowrap;
}

.ct-content > h2:not(:first-child) {
  margin-top: 3rem;
  font-size: 1.5rem;
  font-weight: 600;
}
.ct-content > h3 {
  margin-top: 2.5rem;
  font-size: 1.25rem;
  font-weight: 600;
}
.ct-content > ul li,
.ct-content > ol li {
  margin-bottom: 0.25rem;
}
@media (min-width: 992px) {
  .ct-content > ul,
  .ct-content > ol,
  .ct-content > p {
    max-width: 80%;
  }
}

.ct-page-title {
  padding-left: 1.25rem;
  border-left: 2px solid #5e72e4;
  margin-bottom: 1.5rem;
}

.ct-title {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 300;
}
@media (min-width: 576px) {
  .ct-title {
    font-size: 1.5rem;
    font-weight: 600;
  }
}

.ct-lead {
  color: rgb(59, 69, 78);
  font-weight: 500;
}
@media (min-width: 576px) {
  .ct-lead {
    max-width: 80%;
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }
}

.ct-text-purple {
  color: #5e72e4;
}

.ct-text-purple-bright {
  color: #9da9f2;
}

.ct-tabs-example .nav-link i {
  margin-right: 5px;
}

.color-swatch {
  margin: 1rem 0;
  border-radius: 0.25rem;
  background-color: #F4F5F7;
}

.color-swatch:after {
  content: " ";
  display: table;
  clear: both;
}

.color-swatch-header {
  position: relative;
  height: 0;
  padding-bottom: 50%;
  border-radius: 0.25rem 0.25rem 0 0;
  border: 1px solid transparent;
}

.color-swatch-header.is-light {
  border-color: #C1C7D0;
}

.color-swatch-header .pass-fail {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.color-swatch-header .pass-fail-item-wrap {
  position: relative;
  float: left;
  left: 50%;
  transform: translateX(-50%);
}

.color-swatch-header .pass-fail-item-group {
  display: inline-block;
  padding: 0 5px;
}

.color-swatch-header .pass-fail-item {
  float: left;
  display: inline-block;
  text-align: center;
  padding: 2px;
}

.color-swatch-header .pass-fail-item.white .example {
  color: #fff;
}

.color-swatch-header .pass-fail-item.small .example {
  font-size: 10px;
}

.color-swatch-header .pass-fail-item .lozenge {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  background: #000;
  color: #fff;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.color-swatch-body {
  position: relative;
  left: 50%;
  float: left;
  padding: 10px 0;
  transform: translateX(-50%);
}

.color-swatch-body .prop-item-wrap {
  float: left;
  padding: 0 15px;
  min-width: 65px;
}

.color-swatch-body .prop-item {
  padding: 15px 0;
}

.color-swatch-body .prop-item .label {
  font-size: 11px;
  color: #62748C;
  text-transform: uppercase;
  line-height: 16px;
}

.color-swatch-body .prop-item .value {
  font-size: 14px;
}

.table-colors {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
}

.table-colors td,
.table-colors:first-child td,
.table-colors td:first-child,
.table-colors:first-child td:first-child,
.table-colors td:last-child,
.table-colors:first-child td:last-child {
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.table-colors tr:last-child td,
.table-colors:first-child tr:last-child td {
  border-bottom: none;
}

.table-colors td:nth-child(1),
.table-colors:first-child td:nth-child(1) {
  line-height: 40px;
}

.table-colors .swatch,
.table-colors:first-child .swatch {
  float: left;
  height: 40px;
  width: 40px;
  margin-right: 20px;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid transparent;
}

.table-colors .swatch.is-light,
.table-colors:first-child .swatch.is-light {
  border-color: #C1C7D0;
}

.table-colors .lozenge,
.table-colors:first-child .lozenge {
  float: left;
  margin: 5px 10px 0 0;
  font-size: 10px;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  background: #97A0AF;
  color: #042A53;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.ct-toc {
  order: 2;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
  font-size: 0.875rem;
}
@supports ((position: -webkit-sticky) or (position: sticky)) {
  .ct-toc {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    height: calc(100vh - 4rem);
    overflow-y: auto;
  }
}

.section-nav {
  padding-left: 0;
  border-left: 1px solid #eee;
}
.section-nav ul {
  padding-left: 1rem;
}
.section-nav ul ul {
  display: none;
}

.toc-entry {
  display: block;
  font-size: 1rem;
}
.toc-entry a {
  display: block;
  padding: 0.125rem 1.5rem;
  color: #99979c;
  font-size: 90%;
}
.toc-entry a:hover {
  color: #5e72e4;
  text-decoration: none;
}

.ct-sidebar {
  order: 0;
  border-bottom: 1px solid #e6ecf1;
  background-color: #f5f7f9;
}
@media (min-width: 768px) {
  .ct-sidebar {
    border-right: 1px solid #e6ecf1;
  }
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-sidebar {
      position: -webkit-sticky;
      position: sticky;
      top: 4rem;
      z-index: 1000;
      height: calc(100vh - 4rem);
    }
  }
}
@media (min-width: 1200px) {
  .ct-sidebar {
    flex: 0 1 320px;
  }
}

.ct-links {
  padding-top: 2rem;
  padding-bottom: 1rem;
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .ct-links {
      max-height: calc(100vh - 5rem);
      overflow-y: auto;
    }
  }
}
@media (min-width: 768px) {
  .ct-links {
    display: block !important;
  }
}

.ct-search {
  position: relative;
  padding: 1rem 15px;
  margin-right: -15px;
  margin-left: -15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.ct-search .form-control:focus {
  border-color: #9da9f2;
  box-shadow: 0 0 0 3px rgba(157, 169, 242, 0.25);
}

.ct-search-docs-toggle {
  line-height: 1;
  color: #212529;
}

.ct-sidenav {
  display: none;
}

.ct-toc-link {
  display: block;
  padding: 0.25rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: #0d2b3e;
}
.ct-toc-link:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
}

.ct-toc-item.active {
  margin-bottom: 1rem;
}
.ct-toc-item.active:not(:first-child) {
  margin-top: 1rem;
}
.ct-toc-item.active > .ct-toc-link {
  color: rgba(0, 0, 0, 0.85);
}
.ct-toc-item.active > .ct-toc-link:hover {
  background-color: transparent;
}
.ct-toc-item.active > .ct-sidenav {
  display: block;
}

.ct-sidebar .nav > li > a {
  display: block;
  padding: 0.25rem 1.5rem;
  font-size: 84%;
  color: #4c555a;
}

.ct-sidebar .nav > li > a:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
  background-color: transparent;
}

.ct-sidebar .nav > .active > a {
  font-weight: 500;
  color: #0099e5;
  background-color: transparent;
  padding-left: 2rem;
  position: relative;
}
.ct-sidebar .nav > .active > a:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 2px;
  background-color: #0099e5;
  top: 50%;
  left: 1.5rem;
  transform: translateY(-50%);
}

.ct-sidebar .nav > .active:hover > a {
  color: #0099e5;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-footer {
  font-size: 85%;
  text-align: center;
  background-color: #f7f7f7;
}
.ct-footer a {
  font-weight: 500;
  color: #525f7f;
}
.ct-footer a:hover, .ct-footer a:focus {
  color: #5e72e4;
}
.ct-footer p {
  margin-bottom: 0;
}
@media (min-width: 576px) {
  .ct-footer {
    text-align: left;
  }
}

.ct-footer-links {
  padding-left: 0;
  margin-bottom: 1rem;
}
.ct-footer-links li {
  display: inline-block;
}
.ct-footer-links li + li {
  margin-left: 1rem;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  padding: 20px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  visibility: hidden;
  position: relative;
}
.rdtPicker .rdtTimeToggle:before {
  visibility: visible;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 1em/1 "Nucleo";
  font-size: 18px;
  content: "\\ea5e";
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #fff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover, .rdtDay.start-date, .rdtDay.end-date, .rdtDay.middle-date, .rdtDay.start-date:hover, .rdtDay.end-date:hover, .rdtDay.middle-date:hover {
  background-color: #11cdef !important;
  color: #fff !important;
}
.rdtDay.start-date {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rdtDay.middle-date {
  border-radius: 0;
}
.rdtDay.end-date {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rdtDays tr .dow {
  text-align: center;
  font-size: 12px;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 300;
  font-size: 0.875rem;
  width: 20px;
  height: 20px;
}
.rdtDays tr .rdtDay {
  color: #525f7f;
  font-size: 0.875rem;
}
.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {
  color: #adb5bd;
  font-weight: 300;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover,
.rdtPicker .rdtTimeToggle:hover:before {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker tr .dow {
  width: 14.2857%;
  border-bottom: none;
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  font-weight: 500;
  border-radius: 0.375rem;
}

.rdtPicker th.rdtSwitch {
  font-weight: 500;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  width: 145px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #525f7f;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #11cdef;
  border-radius: 50%;
  border: 1px solid #11cdef;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #adb5bd;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtMonth.start-date, .rdtMonths .rdtMonth.end-date, .rdtMonths .rdtMonth.middle-date,
.rdtMonths .rdtYear.rdtActive,
.rdtMonths .rdtYear.start-date,
.rdtMonths .rdtYear.end-date,
.rdtMonths .rdtYear.middle-date,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtMonth.start-date,
.rdtYears .rdtMonth.end-date,
.rdtYears .rdtMonth.middle-date,
.rdtYears .rdtYear.rdtActive,
.rdtYears .rdtYear.start-date,
.rdtYears .rdtYear.end-date,
.rdtYears .rdtYear.middle-date {
  background-color: #11cdef !important;
  color: #fff;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .rdt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-group .rdt {
  width: 1%;
  margin-bottom: 0;
  flex: 1 1 auto;
}

.btn .btn-inner--icon {
  margin-right: 4px;
}

.btn + .btn {
  margin-left: 4px;
}

button:focus, :focus {
  outline: none;
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transition: visibility 0.25s, opacity 0.25s;
  }
  100% {
    opacity: 1;
  }
}
.navbar .collapsing .navbar-toggler {
  pointer-events: none;
}

.navbar .nav-item .nav-link-icon.nav-link i {
  margin-right: 4px;
}

.table .avatar-group .avatar {
  margin-right: 4px;
}
.table .badge i {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/argon-dashboard-react.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/argon-dashboard/custom/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_backgrounds.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_floating.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_helper.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_image.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_opacity.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_overflow.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_position.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_sizing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_spacing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_shadows.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_text.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_transform.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert-dismissible.scss","webpack://./src/assets/scss/argon-dashboard/custom/avatars/_avatar.scss","webpack://./src/assets/scss/argon-dashboard/custom/avatars/_avatar-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-circle.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-dot.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-brand.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-profile.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-animations.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-stats.scss","webpack://./src/assets/scss/argon-dashboard/custom/charts/_chart.scss","webpack://./src/assets/scss/argon-dashboard/custom/close/_close.scss","webpack://./src/assets/scss/argon-dashboard/custom/_content.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-form.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-control.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-checkbox.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-radio.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-toggle.scss","webpack://./src/assets/scss/argon-dashboard/custom/dropdowns/_dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/footers/_footer.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form-validation.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_input-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/headers/_header.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon-shape.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/list-groups/_list-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/maps/_map.scss","webpack://./src/assets/scss/argon-dashboard/custom/masks/_mask.scss","webpack://./src/assets/scss/argon-dashboard/custom/modals/_modal.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_modals.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav-pills.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-vertical.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-search.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-collapse.scss","webpack://./src/assets/scss/argon-dashboard/custom/paginations/_pagination.scss","webpack://./src/assets/scss/argon-dashboard/custom/popovers/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/progresses/_progress.scss","webpack://./src/assets/scss/argon-dashboard/custom/separators/_separator.scss","webpack://./src/assets/scss/argon-dashboard/custom/tables/_table.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_type.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_heading.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_display.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_article.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_bootstrap-datepicker.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_nouislider.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_scrollbar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/docs/_variables.scss","webpack://./src/assets/scss/argon-dashboard/docs/_clipboard-js.scss","webpack://./src/assets/scss/argon-dashboard/docs/_component-examples.scss","webpack://./src/assets/scss/argon-dashboard/docs/_prism.scss","webpack://./src/assets/scss/argon-dashboard/docs/_content.scss","webpack://./src/assets/scss/argon-dashboard/docs/_sidebar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_footer.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/_buttons.scss","webpack://./src/assets/scss/react/_mixins.scss","webpack://./src/assets/scss/react/_navbar-dropdown.scss","webpack://./src/assets/scss/react/_navbar.scss","webpack://./src/assets/scss/react/_tables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,aAAA;EAAA,eAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,+CAAA;EACA,6GAAA;ADmBF;;AElBA;;;EAGE,sBAAA;AFqBF;;AElBA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AFqBF;;AEfA;EACE,cAAA;AFkBF;;AERA;EACE,SAAA;EACA,kCC8SuB;ECzKnB,eAAA;EFnIJ,gBCsT4B;EDrT5B,gBC0T4B;EDzT5B,cCCS;EDAT,gBAAA;EACA,yBCqLQ;AH1KV;;AECA;EACE,qBAAA;AFEF;;AEOA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AFJF;;AEiBA;EACE,aAAA;EACA,qBC2R4B;AHzS9B;;AEqBA;EACE,aAAA;EACA,mBGoF0B;ALtG5B;;AE6BA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;UAAA,8BAAA;AF1BF;;AE6BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AF1BF;;AE6BA;;;EAGE,aAAA;EACA,mBAAA;AF1BF;;AE6BA;;;;EAIE,gBAAA;AF1BF;;AE6BA;EACE,gBCyN4B;AHnP9B;;AE6BA;EACE,qBAAA;EACA,cAAA;AF1BF;;AE6BA;EACE,gBAAA;AF1BF;;AE6BA;;EAEE,mBGqI4B;AL/J9B;;AE6BA;EEII,cAAA;AJ7BJ;;AEkCA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AF/BF;;AEkCA;EAAM,eAAA;AF9BN;;AE+BA;EAAM,WAAA;AF3BN;;AEkCA;EACE,cCrFc;EDsFd,qBCkE0B;EDjE1B,6BAAA;AF/BF;AMjJE;EJmLE,cC+DwB;ED9DxB,qBC+DwB;AH9F5B;;AEwCA;EACE,cAAA;EACA,qBAAA;AFrCF;AM1JE;EJkME,cAAA;EACA,qBAAA;AFrCJ;;AE8CA;;;;EAIE,iGG0D4B;EDlH1B,cAAA;AJcJ;;AE8CA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AFhDF;;AEwDA;EAEE,gBAAA;AFtDF;;AE8DA;EACE,sBAAA;EACA,kBAAA;AF3DF;;AE8DA;EAGE,gBAAA;EACA,sBAAA;AF7DF;;AEqEA;EACE,yBAAA;AFlEF;;AEqEA;EACE,iBC6K4B;ED5K5B,oBC4K4B;ED3K5B,cChOS;EDiOT,gBAAA;EACA,oBAAA;AFlEF;;AEyEA;EAEE,mBAAA;EACA,gCAAA;AFvEF;;AE+EA;EAEE,qBAAA;EACA,qBG4JsC;ALzOxC;;AEmFA;EAEE,gBAAA;AFjFF;;AEyFA;EACE,UAAA;AFtFF;;AEyFA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AFtFF;;AEyFA;;EAEE,iBAAA;AFtFF;;AEyFA;;EAEE,oBAAA;AFtFF;;AE4FA;EACE,eAAA;AFzFF;;AE+FA;EACE,iBAAA;AF5FF;;AEmGA;;;;EAIE,0BAAA;AFhGF;;AEyGI;;;;EACE,eAAA;AFnGN;;AEyGA;;;;EAIE,UAAA;EACA,kBAAA;AFtGF;;AEyGA;;EAEE,sBAAA;EACA,UAAA;AFtGF;;AE0GA;EACE,cAAA;EAEA,gBAAA;AFxGF;;AE2GA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AF9GF;;AEmHA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AFhHF;;AEmHA;EACE,wBAAA;AFhHF;;AEoHA;;EAEE,YAAA;AFjHF;;AEoHA;EAKE,oBAAA;EACA,wBAAA;AFrHF;;AE4HA;EACE,wBAAA;AFzHF;;AEiIA;EACE,aAAA;EACA,0BAAA;AF9HF;;AEqIA;EACE,qBAAA;AFlIF;;AEqIA;EACE,kBAAA;EACA,eAAA;AFlIF;;AEqIA;EACE,aAAA;AFlIF;;AEuIA;EACE,wBAAA;AFpIF;;AOxVA;;EAEE,qBJgX4B;EI/W5B,oBJgX4B;EI/W5B,gBJ8V4B;EI7V5B,gBJgX4B;EI/W5B,cJyCS;AHkTX;;AOxVA;EHqKM,mBAAA;AJuLN;;AO3VA;EHoKM,kBAAA;AJ2LN;;AO9VA;EHmKM,oBAAA;AJ+LN;;AOjWA;EHkKM,oBAAA;AJmMN;;AOpWA;EHiKM,oBAAA;AJuMN;;AOvWA;EHgKM,mBAAA;AJ2MN;;AOzWA;EH8JM,kBAAA;EG5JJ,gBJqY4B;AHzB9B;;AOxWA;EHwJM,iBAAA;EGtJJ,gBJ0U4B;EIzU5B,gBJ4V4B;AHe9B;;AOzWA;EHmJM,kBAAA;EGjJJ,gBJqU4B;EIpU5B,gBJuV4B;AHqB9B;;AO1WA;EH8IM,oBAAA;EG5IJ,gBJgU4B;EI/T5B,gBJkV4B;AH2B9B;;AO3WA;EHyIM,oBAAA;EGvIJ,gBJ2T4B;EI1T5B,gBJ6U4B;AHiC9B;;AOtWA;EACE,gBJ0X4B;EIzX5B,mBJyX4B;EIxX5B,SAAA;EACA,wCAAA;APyWF;;AOjWA;;EHkGI,cAAA;EG/FF,gBJkS4B;AHkE9B;;AOjWA;;EAEE,cJ+V4B;EI9V5B,yBJoW4B;AHA9B;;AO5VA;EC/EE,eAAA;EACA,gBAAA;AR+aF;;AO5VA;ECpFE,eAAA;EACA,gBAAA;ARobF;;AO9VA;EACE,qBAAA;APiWF;AO/VE;EACE,oBJ8U0B;AHmB9B;;AOvVA;EH2DI,cAAA;EGzDF,yBAAA;AP0VF;;AOtVA;EACE,mBJuKO;ECnGH,kBAAA;AJsRN;;AOtVA;EACE,cAAA;EH+CE,cAAA;EG7CF,cJpES;AH6ZX;AOvVE;EACE,aAAA;APyVJ;;AS5cA;ECIE,eAAA;EAGA,YAAA;AV0cF;;AS3cA;EACE,gBJqgCkC;EIpgClC,yBN2NQ;EM1NR,yBAAA;EEEE,uBAAA;ECFE,0CHEJ;ECPA,eAAA;EAGA,YAAA;AVodF;;AStcA;EAEE,qBAAA;ATwcF;;ASrcA;EACE,qBAAA;EACA,cAAA;ATwcF;;ASrcA;EL8HI,cAAA;EK5HF,cNWS;AH6bX;;Aa/eA;ETmKI,gBAAA;ESjKF,cVsEQ;EUrER,qBAAA;AbkfF;Aa/eE;EACE,cAAA;AbifJ;;Aa5eA;EACE,sBAAA;ETsJE,gBAAA;ESpJF,WV6BS;EU5BT,yBVqCS;EQpCP,sBAAA;ECFE,iDCGJ;Ab+eF;Aa7eE;EACE,UAAA;ET8IA,eAAA;ES5IA,gBVgV0B;ESxVxB,gBCSF;Ab+eJ;;Aa1eA;EACE,cAAA;ETqIE,gBAAA;ESnIF,cVqBS;AHwdX;Aa1eE;ETgIE,kBAAA;ES9HA,cAAA;EACA,kBAAA;Ab4eJ;;AaveA;EACE,iBRikCkC;EQhkClC,kBAAA;Ab0eF;;AclhBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Af4hBF;;AgBzeI;EFzCE;IACE,gBT8Le;ELwVrB;AACF;AgB/eI;EFzCE;IACE,gBT8Le;EL6VrB;AACF;AgBpfI;EFzCE;IACE,gBT8Le;ELkWrB;AACF;AgBzfI;EFzCE;IACE,iBT8Le;ELuWrB;AACF;Ac1gBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AfgjBF;;Ac1gBE;EACE,eAAA;EACA,cAAA;Ad6gBJ;Ac3gBI;;EAEE,gBAAA;EACA,eAAA;Ad6gBN;;AiBnkBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AjB2kBJ;;AiBrjBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjBwjBR;;Ae5hBE;EACE,cAAA;EACA,eAAA;Af+hBJ;;AejiBE;EACE,aAAA;EACA,cAAA;AfoiBJ;;AetiBE;EACE,wBAAA;EACA,yBAAA;AfyiBJ;;Ae3iBE;EACE,aAAA;EACA,cAAA;Af8iBJ;;AehjBE;EACE,aAAA;EACA,cAAA;AfmjBJ;;AerjBE;EACE,wBAAA;EACA,yBAAA;AfwjBJ;;AiB3kBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;Af8kBF;;AiB3kBU;EFbR,qBAAA;EAIA,sBAAA;AfylBF;;AiBhlBU;EFbR,sBAAA;EAIA,uBAAA;Af8lBF;;AiBrlBU;EFbR,aAAA;EAIA,cAAA;AfmmBF;;AiB1lBU;EFbR,sBAAA;EAIA,uBAAA;AfwmBF;;AiB/lBU;EFbR,sBAAA;EAIA,uBAAA;Af6mBF;;AiBpmBU;EFbR,aAAA;EAIA,cAAA;AfknBF;;AiBzmBU;EFbR,sBAAA;EAIA,uBAAA;AfunBF;;AiB9mBU;EFbR,sBAAA;EAIA,uBAAA;Af4nBF;;AiBnnBU;EFbR,aAAA;EAIA,cAAA;AfioBF;;AiBxnBU;EFbR,sBAAA;EAIA,uBAAA;AfsoBF;;AiB7nBU;EFbR,sBAAA;EAIA,uBAAA;Af2oBF;;AiBloBU;EFbR,cAAA;EAIA,eAAA;AfgpBF;;AiBjoBM;EAAwB,SAAA;AjBqoB9B;;AiBnoBM;EAAuB,SAAA;AjBuoB7B;;AiBpoBQ;EAAwB,QADb;AjByoBnB;;AiBxoBQ;EAAwB,QADb;AjB6oBnB;;AiB5oBQ;EAAwB,QADb;AjBipBnB;;AiBhpBQ;EAAwB,QADb;AjBqpBnB;;AiBppBQ;EAAwB,QADb;AjBypBnB;;AiBxpBQ;EAAwB,QADb;AjB6pBnB;;AiB5pBQ;EAAwB,QADb;AjBiqBnB;;AiBhqBQ;EAAwB,QADb;AjBqqBnB;;AiBpqBQ;EAAwB,QADb;AjByqBnB;;AiBxqBQ;EAAwB,QADb;AjB6qBnB;;AiB5qBQ;EAAwB,SADb;AjBirBnB;;AiBhrBQ;EAAwB,SADb;AjBqrBnB;;AiBprBQ;EAAwB,SADb;AjByrBnB;;AiBjrBY;EFhBV,wBAAA;AfqsBF;;AiBrrBY;EFhBV,yBAAA;AfysBF;;AiBzrBY;EFhBV,gBAAA;Af6sBF;;AiB7rBY;EFhBV,yBAAA;AfitBF;;AiBjsBY;EFhBV,yBAAA;AfqtBF;;AiBrsBY;EFhBV,gBAAA;AfytBF;;AiBzsBY;EFhBV,yBAAA;Af6tBF;;AiB7sBY;EFhBV,yBAAA;AfiuBF;;AiBjtBY;EFhBV,gBAAA;AfquBF;;AiBrtBY;EFhBV,yBAAA;AfyuBF;;AiBztBY;EFhBV,yBAAA;Af6uBF;;AgBxuBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBuwBN;Ee3uBA;IACE,cAAA;IACA,eAAA;Ef6uBF;Ee/uBA;IACE,aAAA;IACA,cAAA;EfivBF;EenvBA;IACE,wBAAA;IACA,yBAAA;EfqvBF;EevvBA;IACE,aAAA;IACA,cAAA;EfyvBF;Ee3vBA;IACE,aAAA;IACA,cAAA;Ef6vBF;Ee/vBA;IACE,wBAAA;IACA,yBAAA;EfiwBF;EiBpxBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfsxBA;EiBnxBQ;IFbR,qBAAA;IAIA,sBAAA;EfgyBA;EiBvxBQ;IFbR,sBAAA;IAIA,uBAAA;EfoyBA;EiB3xBQ;IFbR,aAAA;IAIA,cAAA;EfwyBA;EiB/xBQ;IFbR,sBAAA;IAIA,uBAAA;Ef4yBA;EiBnyBQ;IFbR,sBAAA;IAIA,uBAAA;EfgzBA;EiBvyBQ;IFbR,aAAA;IAIA,cAAA;EfozBA;EiB3yBQ;IFbR,sBAAA;IAIA,uBAAA;EfwzBA;EiB/yBQ;IFbR,sBAAA;IAIA,uBAAA;Ef4zBA;EiBnzBQ;IFbR,aAAA;IAIA,cAAA;Efg0BA;EiBvzBQ;IFbR,sBAAA;IAIA,uBAAA;Efo0BA;EiB3zBQ;IFbR,sBAAA;IAIA,uBAAA;Efw0BA;EiB/zBQ;IFbR,cAAA;IAIA,eAAA;Ef40BA;EiB7zBI;IAAwB,SAAA;EjBg0B5B;EiB9zBI;IAAuB,SAAA;EjBi0B3B;EiB9zBM;IAAwB,QADb;EjBk0BjB;EiBj0BM;IAAwB,QADb;EjBq0BjB;EiBp0BM;IAAwB,QADb;EjBw0BjB;EiBv0BM;IAAwB,QADb;EjB20BjB;EiB10BM;IAAwB,QADb;EjB80BjB;EiB70BM;IAAwB,QADb;EjBi1BjB;EiBh1BM;IAAwB,QADb;EjBo1BjB;EiBn1BM;IAAwB,QADb;EjBu1BjB;EiBt1BM;IAAwB,QADb;EjB01BjB;EiBz1BM;IAAwB,QADb;EjB61BjB;EiB51BM;IAAwB,SADb;EjBg2BjB;EiB/1BM;IAAwB,SADb;EjBm2BjB;EiBl2BM;IAAwB,SADb;EjBs2BjB;EiB91BU;IFhBV,cAAA;Efi3BA;EiBj2BU;IFhBV,wBAAA;Efo3BA;EiBp2BU;IFhBV,yBAAA;Efu3BA;EiBv2BU;IFhBV,gBAAA;Ef03BA;EiB12BU;IFhBV,yBAAA;Ef63BA;EiB72BU;IFhBV,yBAAA;Efg4BA;EiBh3BU;IFhBV,gBAAA;Efm4BA;EiBn3BU;IFhBV,yBAAA;Efs4BA;EiBt3BU;IFhBV,yBAAA;Efy4BA;EiBz3BU;IFhBV,gBAAA;Ef44BA;EiB53BU;IFhBV,yBAAA;Ef+4BA;EiB/3BU;IFhBV,yBAAA;Efk5BA;AACF;AgB94BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB46BN;Eeh5BA;IACE,cAAA;IACA,eAAA;Efk5BF;Eep5BA;IACE,aAAA;IACA,cAAA;Efs5BF;Eex5BA;IACE,wBAAA;IACA,yBAAA;Ef05BF;Ee55BA;IACE,aAAA;IACA,cAAA;Ef85BF;Eeh6BA;IACE,aAAA;IACA,cAAA;Efk6BF;Eep6BA;IACE,wBAAA;IACA,yBAAA;Efs6BF;EiBz7BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ef27BA;EiBx7BQ;IFbR,qBAAA;IAIA,sBAAA;Efq8BA;EiB57BQ;IFbR,sBAAA;IAIA,uBAAA;Efy8BA;EiBh8BQ;IFbR,aAAA;IAIA,cAAA;Ef68BA;EiBp8BQ;IFbR,sBAAA;IAIA,uBAAA;Efi9BA;EiBx8BQ;IFbR,sBAAA;IAIA,uBAAA;Efq9BA;EiB58BQ;IFbR,aAAA;IAIA,cAAA;Efy9BA;EiBh9BQ;IFbR,sBAAA;IAIA,uBAAA;Ef69BA;EiBp9BQ;IFbR,sBAAA;IAIA,uBAAA;Efi+BA;EiBx9BQ;IFbR,aAAA;IAIA,cAAA;Efq+BA;EiB59BQ;IFbR,sBAAA;IAIA,uBAAA;Efy+BA;EiBh+BQ;IFbR,sBAAA;IAIA,uBAAA;Ef6+BA;EiBp+BQ;IFbR,cAAA;IAIA,eAAA;Efi/BA;EiBl+BI;IAAwB,SAAA;EjBq+B5B;EiBn+BI;IAAuB,SAAA;EjBs+B3B;EiBn+BM;IAAwB,QADb;EjBu+BjB;EiBt+BM;IAAwB,QADb;EjB0+BjB;EiBz+BM;IAAwB,QADb;EjB6+BjB;EiB5+BM;IAAwB,QADb;EjBg/BjB;EiB/+BM;IAAwB,QADb;EjBm/BjB;EiBl/BM;IAAwB,QADb;EjBs/BjB;EiBr/BM;IAAwB,QADb;EjBy/BjB;EiBx/BM;IAAwB,QADb;EjB4/BjB;EiB3/BM;IAAwB,QADb;EjB+/BjB;EiB9/BM;IAAwB,QADb;EjBkgCjB;EiBjgCM;IAAwB,SADb;EjBqgCjB;EiBpgCM;IAAwB,SADb;EjBwgCjB;EiBvgCM;IAAwB,SADb;EjB2gCjB;EiBngCU;IFhBV,cAAA;EfshCA;EiBtgCU;IFhBV,wBAAA;EfyhCA;EiBzgCU;IFhBV,yBAAA;Ef4hCA;EiB5gCU;IFhBV,gBAAA;Ef+hCA;EiB/gCU;IFhBV,yBAAA;EfkiCA;EiBlhCU;IFhBV,yBAAA;EfqiCA;EiBrhCU;IFhBV,gBAAA;EfwiCA;EiBxhCU;IFhBV,yBAAA;Ef2iCA;EiB3hCU;IFhBV,yBAAA;Ef8iCA;EiB9hCU;IFhBV,gBAAA;EfijCA;EiBjiCU;IFhBV,yBAAA;EfojCA;EiBpiCU;IFhBV,yBAAA;EfujCA;AACF;AgBnjCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBilCN;EerjCA;IACE,cAAA;IACA,eAAA;EfujCF;EezjCA;IACE,aAAA;IACA,cAAA;Ef2jCF;Ee7jCA;IACE,wBAAA;IACA,yBAAA;Ef+jCF;EejkCA;IACE,aAAA;IACA,cAAA;EfmkCF;EerkCA;IACE,aAAA;IACA,cAAA;EfukCF;EezkCA;IACE,wBAAA;IACA,yBAAA;Ef2kCF;EiB9lCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfgmCA;EiB7lCQ;IFbR,qBAAA;IAIA,sBAAA;Ef0mCA;EiBjmCQ;IFbR,sBAAA;IAIA,uBAAA;Ef8mCA;EiBrmCQ;IFbR,aAAA;IAIA,cAAA;EfknCA;EiBzmCQ;IFbR,sBAAA;IAIA,uBAAA;EfsnCA;EiB7mCQ;IFbR,sBAAA;IAIA,uBAAA;Ef0nCA;EiBjnCQ;IFbR,aAAA;IAIA,cAAA;Ef8nCA;EiBrnCQ;IFbR,sBAAA;IAIA,uBAAA;EfkoCA;EiBznCQ;IFbR,sBAAA;IAIA,uBAAA;EfsoCA;EiB7nCQ;IFbR,aAAA;IAIA,cAAA;Ef0oCA;EiBjoCQ;IFbR,sBAAA;IAIA,uBAAA;Ef8oCA;EiBroCQ;IFbR,sBAAA;IAIA,uBAAA;EfkpCA;EiBzoCQ;IFbR,cAAA;IAIA,eAAA;EfspCA;EiBvoCI;IAAwB,SAAA;EjB0oC5B;EiBxoCI;IAAuB,SAAA;EjB2oC3B;EiBxoCM;IAAwB,QADb;EjB4oCjB;EiB3oCM;IAAwB,QADb;EjB+oCjB;EiB9oCM;IAAwB,QADb;EjBkpCjB;EiBjpCM;IAAwB,QADb;EjBqpCjB;EiBppCM;IAAwB,QADb;EjBwpCjB;EiBvpCM;IAAwB,QADb;EjB2pCjB;EiB1pCM;IAAwB,QADb;EjB8pCjB;EiB7pCM;IAAwB,QADb;EjBiqCjB;EiBhqCM;IAAwB,QADb;EjBoqCjB;EiBnqCM;IAAwB,QADb;EjBuqCjB;EiBtqCM;IAAwB,SADb;EjB0qCjB;EiBzqCM;IAAwB,SADb;EjB6qCjB;EiB5qCM;IAAwB,SADb;EjBgrCjB;EiBxqCU;IFhBV,cAAA;Ef2rCA;EiB3qCU;IFhBV,wBAAA;Ef8rCA;EiB9qCU;IFhBV,yBAAA;EfisCA;EiBjrCU;IFhBV,gBAAA;EfosCA;EiBprCU;IFhBV,yBAAA;EfusCA;EiBvrCU;IFhBV,yBAAA;Ef0sCA;EiB1rCU;IFhBV,gBAAA;Ef6sCA;EiB7rCU;IFhBV,yBAAA;EfgtCA;EiBhsCU;IFhBV,yBAAA;EfmtCA;EiBnsCU;IFhBV,gBAAA;EfstCA;EiBtsCU;IFhBV,yBAAA;EfytCA;EiBzsCU;IFhBV,yBAAA;Ef4tCA;AACF;AgBxtCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBsvCN;Ee1tCA;IACE,cAAA;IACA,eAAA;Ef4tCF;Ee9tCA;IACE,aAAA;IACA,cAAA;EfguCF;EeluCA;IACE,wBAAA;IACA,yBAAA;EfouCF;EetuCA;IACE,aAAA;IACA,cAAA;EfwuCF;Ee1uCA;IACE,aAAA;IACA,cAAA;Ef4uCF;Ee9uCA;IACE,wBAAA;IACA,yBAAA;EfgvCF;EiBnwCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfqwCA;EiBlwCQ;IFbR,qBAAA;IAIA,sBAAA;Ef+wCA;EiBtwCQ;IFbR,sBAAA;IAIA,uBAAA;EfmxCA;EiB1wCQ;IFbR,aAAA;IAIA,cAAA;EfuxCA;EiB9wCQ;IFbR,sBAAA;IAIA,uBAAA;Ef2xCA;EiBlxCQ;IFbR,sBAAA;IAIA,uBAAA;Ef+xCA;EiBtxCQ;IFbR,aAAA;IAIA,cAAA;EfmyCA;EiB1xCQ;IFbR,sBAAA;IAIA,uBAAA;EfuyCA;EiB9xCQ;IFbR,sBAAA;IAIA,uBAAA;Ef2yCA;EiBlyCQ;IFbR,aAAA;IAIA,cAAA;Ef+yCA;EiBtyCQ;IFbR,sBAAA;IAIA,uBAAA;EfmzCA;EiB1yCQ;IFbR,sBAAA;IAIA,uBAAA;EfuzCA;EiB9yCQ;IFbR,cAAA;IAIA,eAAA;Ef2zCA;EiB5yCI;IAAwB,SAAA;EjB+yC5B;EiB7yCI;IAAuB,SAAA;EjBgzC3B;EiB7yCM;IAAwB,QADb;EjBizCjB;EiBhzCM;IAAwB,QADb;EjBozCjB;EiBnzCM;IAAwB,QADb;EjBuzCjB;EiBtzCM;IAAwB,QADb;EjB0zCjB;EiBzzCM;IAAwB,QADb;EjB6zCjB;EiB5zCM;IAAwB,QADb;EjBg0CjB;EiB/zCM;IAAwB,QADb;EjBm0CjB;EiBl0CM;IAAwB,QADb;EjBs0CjB;EiBr0CM;IAAwB,QADb;EjBy0CjB;EiBx0CM;IAAwB,QADb;EjB40CjB;EiB30CM;IAAwB,SADb;EjB+0CjB;EiB90CM;IAAwB,SADb;EjBk1CjB;EiBj1CM;IAAwB,SADb;EjBq1CjB;EiB70CU;IFhBV,cAAA;Efg2CA;EiBh1CU;IFhBV,wBAAA;Efm2CA;EiBn1CU;IFhBV,yBAAA;Efs2CA;EiBt1CU;IFhBV,gBAAA;Efy2CA;EiBz1CU;IFhBV,yBAAA;Ef42CA;EiB51CU;IFhBV,yBAAA;Ef+2CA;EiB/1CU;IFhBV,gBAAA;Efk3CA;EiBl2CU;IFhBV,yBAAA;Efq3CA;EiBr2CU;IFhBV,yBAAA;Efw3CA;EiBx2CU;IFhBV,gBAAA;Ef23CA;EiB32CU;IFhBV,yBAAA;Ef83CA;EiB92CU;IFhBV,yBAAA;Efi4CA;AACF;AkBr7CA;EACE,WAAA;EACA,mBfiRO;EehRP,cf6CS;Ee5CT,6Bfyb4B;AH8/B9B;AkBr7CE;;EAEE,afkb0B;Eejb1B,mBAAA;EACA,6BAAA;AlBu7CJ;AkBp7CE;EACE,sBAAA;EACA,gCAAA;AlBs7CJ;AkBn7CE;EACE,6BAAA;AlBq7CJ;;AkB36CE;;EAEE,ef4Z0B;AHkhC9B;;AkBr6CA;EACE,yBAAA;AlBw6CF;AkBt6CE;;EAEE,yBAAA;AlBw6CJ;AkBp6CI;;EAEE,wBAAA;AlBs6CN;;AkBh6CE;;;;EAIE,SAAA;AlBm6CJ;;AkB15CE;EACE,qCfuX0B;AHsiC9B;;AM59CE;EY2EI,cfnCK;EeoCL,yBf1CK;AH+7CX;;AmBv+CI;;;EAGE,yBD2F+B;AlB+4CrC;AmBt+CM;;;;EAIE,qBDmFyE;AlBq5CjF;;AM7+CE;EaiBM,yBAJe;AnBo+CvB;AmB99CQ;;EAEE,yBARa;AnBw+CvB;;AmB3/CI;;;EAGE,yBD2F+B;AlBm6CrC;AmB1/CM;;;;EAIE,qBDmFyE;AlBy6CjF;;AMjgDE;EaiBM,yBAJe;AnBw/CvB;AmBl/CQ;;EAEE,yBARa;AnB4/CvB;;AmB/gDI;;;EAGE,yBD2F+B;AlBu7CrC;AmB9gDM;;;;EAIE,qBDmFyE;AlB67CjF;;AMrhDE;EaiBM,yBAJe;AnB4gDvB;AmBtgDQ;;EAEE,yBARa;AnBghDvB;;AmBniDI;;;EAGE,yBD2F+B;AlB28CrC;AmBliDM;;;;EAIE,qBDmFyE;AlBi9CjF;;AMziDE;EaiBM,yBAJe;AnBgiDvB;AmB1hDQ;;EAEE,yBARa;AnBoiDvB;;AmBvjDI;;;EAGE,yBD2F+B;AlB+9CrC;AmBtjDM;;;;EAIE,qBDmFyE;AlBq+CjF;;AM7jDE;EaiBM,yBAJe;AnBojDvB;AmB9iDQ;;EAEE,yBARa;AnBwjDvB;;AmB3kDI;;;EAGE,yBD2F+B;AlBm/CrC;AmB1kDM;;;;EAIE,qBDmFyE;AlBy/CjF;;AMjlDE;EaiBM,yBAJe;AnBwkDvB;AmBlkDQ;;EAEE,yBARa;AnB4kDvB;;AmB/lDI;;;EAGE,yBD2F+B;AlBugDrC;AmB9lDM;;;;EAIE,qBDmFyE;AlB6gDjF;;AMrmDE;EaiBM,yBAJe;AnB4lDvB;AmBtlDQ;;EAEE,yBARa;AnBgmDvB;;AmBnnDI;;;EAGE,yBD2F+B;AlB2hDrC;AmBlnDM;;;;EAIE,qBDmFyE;AlBiiDjF;;AMznDE;EaiBM,yBAJe;AnBgnDvB;AmB1mDQ;;EAEE,yBARa;AnBonDvB;;AmBvoDI;;;EAGE,yBD2F+B;AlB+iDrC;AmBtoDM;;;;EAIE,qBDmFyE;AlBqjDjF;;AM7oDE;EaiBM,yBAJe;AnBooDvB;AmB9nDQ;;EAEE,yBARa;AnBwoDvB;;AmB3pDI;;;EAGE,uBD2F+B;AlBmkDrC;AmB1pDM;;;;EAIE,mBDmFyE;AlBykDjF;;AMjqDE;EaiBM,yBAJe;AnBwpDvB;AmBlpDQ;;EAEE,yBARa;AnB4pDvB;;AmB/qDI;;;EAGE,uBD2F+B;AlBulDrC;AmB9qDM;;;;EAIE,mBDmFyE;AlB6lDjF;;AMrrDE;EaiBM,yBAJe;AnB4qDvB;AmBtqDQ;;EAEE,yBARa;AnBgrDvB;;AmBnsDI;;;EAGE,yBD2F+B;AlB2mDrC;AmBlsDM;;;;EAIE,qBDmFyE;AlBinDjF;;AMzsDE;EaiBM,yBAJe;AnBgsDvB;AmB1rDQ;;EAEE,yBARa;AnBosDvB;;AmBvtDI;;;EAGE,yBhBqCK;AHqrDX;;AMvtDE;EaiBM,yBAJe;AnB8sDvB;AmBxsDQ;;EAEE,yBARa;AnBktDvB;;AkB1nDI;EACE,cfwHI;EevHJ,yBfiWwB;EehWxB,qBfmWwB;AH0xC9B;AkBxnDI;EACE,cfvEK;EewEL,yBf7EK;Ee8EL,qBf7EK;AHusDX;;AkBrnDA;EACE,cfwGQ;EevGR,yBfiV4B;AHuyC9B;AkBtnDE;;;EAGE,qBf+U0B;AHyyC9B;AkBrnDE;EACE,SAAA;AlBunDJ;AkBnnDI;EACE,2CfoUwB;AHizC9B;AM1vDE;EY4IM,cfkFE;EejFF,4Cf6TsB;AHozC9B;;AgBjsDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBmmDN;EkBhmDM;IACE,SAAA;ElBkmDR;AACF;AgB7sDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB8mDN;EkB3mDM;IACE,SAAA;ElB6mDR;AACF;AgBxtDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBynDN;EkBtnDM;IACE,SAAA;ElBwnDR;AACF;AgBnuDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBooDN;EkBjoDM;IACE,SAAA;ElBmoDR;AACF;AkB7oDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AlB8oDR;AkB3oDQ;EACE,SAAA;AlB6oDV;;AoB1zDA;EACE,cAAA;EACA,WAAA;EACA,mCf2esC;Ee1etC,yBAAA;EhB0KI,mBAAA;EgBvKJ,gBjB0V4B;EiBzV5B,gBjB+V4B;EiB9V5B,cjBoCS;EiBnCT,sBjB6BS;EiB5BT,4BAAA;EACA,yBAAA;ETAE,uBAAA;ECFE,gBQOJ;ECPI,2DDQJ;ApByzDF;AqB7zDM;EDdN;ICeQ,gBAAA;ErBg0DN;AACF;AoB3zDE;EACE,6BAAA;EACA,SAAA;ApB6zDJ;AsBz1DE;EACE,cnBiDO;EmBhDP,sBnB0CO;EmBzCP,sCnBijBoC;EmBhjBpC,UAAA;EAGE,sBAAA;AtBy1DN;AoB7zDE;EACE,cjBaO;EiBXP,UAAA;ApB8zDJ;AoBtzDE;EAEE,yBjBFO;EiBIP,UAAA;ApBszDJ;;AoB9yDE;;;;EACE,wBAAA;UAAA,gBAAA;ApBozDJ;;AoB9yDE;EACE,kBAAA;EACA,0BAAA;ApBizDJ;AoB9yDE;EAME,cjB1BO;EiB2BP,sBjBjCO;AH40DX;;AoBtyDA;;EAEE,cAAA;EACA,WAAA;ApByyDF;;AoB/xDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EhBiEE,kBAAA;EgB/DF,gBjBwQ4B;AH0hD9B;;AoB/xDA;EACE,iCAAA;EACA,oCAAA;EhB0EI,mBAAA;EgBxEJ,gBjBiN6B;AHilD/B;;AoB/xDA;EACE,gCAAA;EACA,mCAAA;EhBmEI,kBAAA;EgBjEJ,gBjB2M6B;AHulD/B;;AoBzxDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EhBoDI,mBAAA;EgBlDJ,gBjB2O4B;EiB1O5B,cjB/ES;EiBgFT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApB4xDF;AoB1xDE;EAEE,gBAAA;EACA,eAAA;ApB2xDJ;;AoB/wDA;EACE,kCf6VsC;Ee5VtC,uBAAA;EhB2BI,kBAAA;EgBzBJ,gBjBmK6B;EQ5S3B,sBAAA;AX45DJ;;AoB/wDA;EACE,mCfsVsC;EerVtC,sBAAA;EhBmBI,mBAAA;EgBjBJ,gBjB0J6B;EQ3S3B,wBAAA;AXo6DJ;;AoB7wDE;EAEE,YAAA;ApB+wDJ;;AoB3wDA;EACE,YAAA;ApB8wDF;;AoBtwDA;EACE,qBjBsZsC;AHm3CxC;;AoBtwDA;EACE,cAAA;EACA,mBf4TsC;AL68CxC;;AoBjwDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBowDF;AoBlwDE;;EAEE,kBAAA;EACA,iBAAA;ApBowDJ;;AoB3vDA;EACE,kBAAA;EACA,cAAA;EACA,qBfiSsC;AL69CxC;;AoB3vDA;EACE,kBAAA;EACA,kBf6RsC;Ee5RtC,qBAAA;ApB8vDF;AoB3vDE;EAEE,cjBnLO;AH+6DX;;AoBxvDA;EACE,gBAAA;ApB2vDF;;AoBxvDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf8QsC;AL6+CxC;AoBxvDE;EACE,gBAAA;EACA,aAAA;EACA,uBfyQoC;EexQpC,cAAA;ApB0vDJ;;AsBl+DE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnB0Y0B;EmBzY1B,cFgPqC;ApBqvDzC;;AsBl+DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,yCAAA;EACA,qBAAA;AtBq+DJ;;AsBh+DI;;;EAEE,qBF0NmC;ApB0wDzC;AsBl+DM;;;EACE,qBFuNiC;ApB+wDzC;AsBl+DM;;;;;;;EAEE,cAAA;AtBy+DR;;AsBj+DM;EACE,cFwMiC;ApB4xDzC;AsBj+DM;;;EAEE,cAAA;AtBo+DR;;AsB59DM;EACE,cF0LiC;ApBqyDzC;AsB79DQ;EACE,yBAAA;EACA,qBAAA;AtB+9DV;AsB39DM;;;EAEE,cAAA;AtB89DR;AsB19DQ;ECpFJ,yBDqF2B;EACrB,qBAAA;AtB49DV;AsBv9DQ;EACE,+DAAA;AtBy9DV;;AsB/8DM;EACE,qBFyJiC;ApByzDzC;AsBh9DQ;EAAY,qBAAA;AtBm9DpB;AsBh9DM;;;EAEE,cAAA;AtBm9DR;AsB/8DQ;EACE,4CAAA;AtBi9DV;;AsBzjEE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnB0Y0B;EmBzY1B,cFgPqC;ApB40DzC;;AsBzjEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;AtB4jEJ;;AsBvjEI;;;EAEE,qBF0NmC;ApBi2DzC;AsBzjEM;;;EACE,qBFuNiC;ApBs2DzC;AsBzjEM;;;;;;;EAEE,cAAA;AtBgkER;;AsBxjEM;EACE,cFwMiC;ApBm3DzC;AsBxjEM;;;EAEE,cAAA;AtB2jER;;AsBnjEM;EACE,cF0LiC;ApB43DzC;AsBpjEQ;EACE,yBAAA;EACA,qBAAA;AtBsjEV;AsBljEM;;;EAEE,cAAA;AtBqjER;AsBjjEQ;ECpFJ,yBDqF2B;EACrB,qBAAA;AtBmjEV;AsB9iEQ;EACE,8DAAA;AtBgjEV;;AsBtiEM;EACE,qBFyJiC;ApBg5DzC;AsBviEQ;EAAY,qBAAA;AtB0iEpB;AsBviEM;;;EAEE,cAAA;AtB0iER;AsBtiEQ;EACE,2CAAA;AtBwiEV;;AoB/4DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApBk5DF;AoB74DE;EACE,WAAA;ApB+4DJ;AgB9mEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpB64DJ;EoBz4DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpB24DJ;EoBv4DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpBy4DJ;EoBr4DE;IACE,qBAAA;EpBu4DJ;EoBp4DE;;IAEE,WAAA;EpBs4DJ;EoBj4DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpBm4DJ;EoBj4DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfgLkC;Ie/KlC,cAAA;EpBm4DJ;EoBh4DE;IACE,mBAAA;IACA,uBAAA;EpBk4DJ;EoBh4DE;IACE,gBAAA;EpBk4DJ;AACF;;AwBptEA;EACE,qBAAA;EAEA,gBrB4f4B;EqB3f5B,crB0CS;EqBzCT,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8EE,yBAAA;EACA,mBtBkZ0B;EsBjZ1B,gBtB4Q0B;EsB1QtB,uBtBgOsB;EkBnTxB,qIGGJ;AxButEF;AqBttEM;EGdN;IHeQ,gBAAA;ErBytEN;AACF;AMnuEE;EkBUE,crB8BO;EqB7BP,qBAAA;AxB4tEJ;AwBztEE;EAEE,UAAA;EACA,2ErB+e0B;AH2uD9B;AwBttEE;EAEE,anBkZ0B;EOraxB,gBYoBF;AxButEJ;AwBptEE;EACE,eAAA;AxBstEJ;AwBptEI;EZ1BE,gBY4BA;AxBqtEN;AwBntEM;EZ9BA,2EALa;AZyvEnB;;AwB9sEA;;EAEE,oBAAA;AxBitEF;;AwBxsEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB4wEJ;AMpwEE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBqxEvG;AyBzwEI;EAIQ,4GAAA;AzBwwEZ;AyBlwEI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALitEf;AyBhwEI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBkyE1L;AyB3vEQ;EAGQ,iDAAA;AzB2vEhB;;AwBpuEE;EChEE,cAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBwyEJ;AMhyEE;EmBLM,cAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBizEvG;AyBryEI;EAIQ,6GAAA;AzBoyEZ;AyB9xEI;EAEI,cAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL6uEf;AyB5xEI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB8zE1L;AyBvxEQ;EAGQ,kDAAA;AzBuxEhB;;AwBhwEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBo0EJ;AM5zEE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB60EvG;AyBj0EI;EAIQ,4GAAA;AzBg0EZ;AyB1zEI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALywEf;AyBxzEI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB01E1L;AyBnzEQ;EAGQ,iDAAA;AzBmzEhB;;AwB5xEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBg2EJ;AMx1EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBy2EvG;AyB71EI;EAIQ,4GAAA;AzB41EZ;AyBt1EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALqyEf;AyBp1EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBs3E1L;AyB/0EQ;EAGQ,iDAAA;AzB+0EhB;;AwBxzEE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB43EJ;AMp3EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBq4EvG;AyBz3EI;EAIQ,2GAAA;AzBw3EZ;AyBl3EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALi0Ef;AyBh3EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBk5E1L;AyB32EQ;EAGQ,gDAAA;AzB22EhB;;AwBp1EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBw5EJ;AMh5EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBi6EvG;AyBr5EI;EAIQ,2GAAA;AzBo5EZ;AyB94EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;AL61Ef;AyB54EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB86E1L;AyBv4EQ;EAGQ,gDAAA;AzBu4EhB;;AwBh3EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBo7EJ;AM56EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB67EvG;AyBj7EI;EAIQ,6GAAA;AzBg7EZ;AyB16EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALy3Ef;AyBx6EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB08E1L;AyBn6EQ;EAGQ,kDAAA;AzBm6EhB;;AwB54EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzBg9EJ;AMx8EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBy9EvG;AyB78EI;EAIQ,0GAAA;AzB48EZ;AyBt8EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALq5Ef;AyBp8EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBs+E1L;AyB/7EQ;EAGQ,+CAAA;AzB+7EhB;;AwBx6EE;EChEE,WAAA;EFKA,yBlBsEW;EoBzEX,qBpByEW;EO5DT,2EaZF;AzB4+EJ;AMp+EE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBq/EvG;AyBz+EI;EAIQ,0GAAA;AzBw+EZ;AyBl+EI;EAEI,WAAA;EACA,yBpBmDO;EoBlDP,qBpBkDO;ALi7Ef;AyBh+EI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBkgF1L;AyB39EQ;EAGQ,+CAAA;AzB29EhB;;AwBp8EE;EChEE,cAAA;EFKA,sBlBsEW;EoBzEX,kBpByEW;EO5DT,2EaZF;AzBwgFJ;AMhgFE;EmBLM,cAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzBihFvG;AyBrgFI;EAIQ,6GAAA;AzBogFZ;AyB9/EI;EAEI,cAAA;EACA,sBpBmDO;EoBlDP,kBpBkDO;AL68Ef;AyB5/EI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,mBArCkL;AzB8hF1L;AyBv/EQ;EAGQ,kDAAA;AzBu/EhB;;AwBh+EE;EChEE,cAAA;EFKA,sBlBsEW;EoBzEX,kBpByEW;EO5DT,2EaZF;AzBoiFJ;AM5hFE;EmBLM,cAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzB6iFvG;AyBjiFI;EAIQ,6GAAA;AzBgiFZ;AyB1hFI;EAEI,cAAA;EACA,sBpBmDO;EoBlDP,kBpBkDO;ALy+Ef;AyBxhFI;EAGI,cAAA;EACA,yBAjCwI;EAqCxI,mBArCkL;AzB0jF1L;AyBnhFQ;EAGQ,kDAAA;AzBmhFhB;;AwB5/EE;EChEE,WAAA;EFKA,uBlBsEW;EoBzEX,mBpByEW;EO5DT,2EaZF;AzBgkFJ;AMxjFE;EmBLM,WAAA;EFDJ,uBEN2D;EASvD,mBAT+F;AzBykFvG;AyB7jFI;EAIQ,uGAAA;AzB4jFZ;AyBtjFI;EAEI,WAAA;EACA,uBpBmDO;EoBlDP,mBpBkDO;ALqgFf;AyBpjFI;EAGI,WAAA;EACA,uBAjCwI;EAqCxI,mBArCkL;AzBslF1L;AyB/iFQ;EAGQ,4CAAA;AzB+iFhB;;AwBlhFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALohFf;AyBviFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALyhFf;AyBtiFI;EAEI,2CAAA;AzBuiFR;AyBpiFI;EAEI,cpBMO;EoBLP,6BAAA;AzBqiFR;AyBliFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALqiFf;AyBhiFQ;EAMQ,2CAAA;AzB6hFhB;;AwB7iFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL+iFf;AyBlkFI;EACI,cAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALojFf;AyBjkFI;EAEI,4CAAA;AzBkkFR;AyB/jFI;EAEI,cpBMO;EoBLP,6BAAA;AzBgkFR;AyB7jFI;EAGI,cAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALgkFf;AyB3jFQ;EAMQ,4CAAA;AzBwjFhB;;AwBxkFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL0kFf;AyB7lFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL+kFf;AyB5lFI;EAEI,2CAAA;AzB6lFR;AyB1lFI;EAEI,cpBMO;EoBLP,6BAAA;AzB2lFR;AyBxlFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL2lFf;AyBtlFQ;EAMQ,2CAAA;AzBmlFhB;;AwBnmFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALqmFf;AyBxnFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL0mFf;AyBvnFI;EAEI,2CAAA;AzBwnFR;AyBrnFI;EAEI,cpBMO;EoBLP,6BAAA;AzBsnFR;AyBnnFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALsnFf;AyBjnFQ;EAMQ,2CAAA;AzB8mFhB;;AwB9nFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALgoFf;AyBnpFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALqoFf;AyBlpFI;EAEI,0CAAA;AzBmpFR;AyBhpFI;EAEI,cpBMO;EoBLP,6BAAA;AzBipFR;AyB9oFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALipFf;AyB5oFQ;EAMQ,0CAAA;AzByoFhB;;AwBzpFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL2pFf;AyB9qFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALgqFf;AyB7qFI;EAEI,0CAAA;AzB8qFR;AyB3qFI;EAEI,cpBMO;EoBLP,6BAAA;AzB4qFR;AyBzqFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL4qFf;AyBvqFQ;EAMQ,0CAAA;AzBoqFhB;;AwBprFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALsrFf;AyBzsFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;AL2rFf;AyBxsFI;EAEI,4CAAA;AzBysFR;AyBtsFI;EAEI,cpBMO;EoBLP,6BAAA;AzBusFR;AyBpsFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALusFf;AyBlsFQ;EAMQ,4CAAA;AzB+rFhB;;AwB/sFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;ALitFf;AyBpuFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALstFf;AyBnuFI;EAEI,yCAAA;AzBouFR;AyBjuFI;EAEI,cpBMO;EoBLP,6BAAA;AzBkuFR;AyB/tFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;ALkuFf;AyB7tFQ;EAMQ,yCAAA;AzB0tFhB;;AwB1uFE;ECnBE,cpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,qBpBqBW;AL4uFf;AyB/vFI;EACI,WAP4C;EAQ5C,yBpBiBO;EoBhBP,qBpBgBO;ALivFf;AyB9vFI;EAEI,yCAAA;AzB+vFR;AyB5vFI;EAEI,cpBMO;EoBLP,6BAAA;AzB6vFR;AyB1vFI;EAGI,WAAA;EACA,yBpBFO;EoBGP,qBpBHO;AL6vFf;AyBxvFQ;EAMQ,yCAAA;AzBqvFhB;;AwBrwFE;ECnBE,WpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,kBpBqBW;ALuwFf;AyB1xFI;EACI,cAP4C;EAQ5C,sBpBiBO;EoBhBP,kBpBgBO;AL4wFf;AyBzxFI;EAEI,4CAAA;AzB0xFR;AyBvxFI;EAEI,WpBMO;EoBLP,6BAAA;AzBwxFR;AyBrxFI;EAGI,cAAA;EACA,sBpBFO;EoBGP,kBpBHO;ALwxFf;AyBnxFQ;EAMQ,4CAAA;AzBgxFhB;;AwBhyFE;ECnBE,WpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,kBpBqBW;ALkyFf;AyBrzFI;EACI,cAP4C;EAQ5C,sBpBiBO;EoBhBP,kBpBgBO;ALuyFf;AyBpzFI;EAEI,4CAAA;AzBqzFR;AyBlzFI;EAEI,WpBMO;EoBLP,6BAAA;AzBmzFR;AyBhzFI;EAGI,cAAA;EACA,sBpBFO;EoBGP,kBpBHO;ALmzFf;AyB9yFQ;EAMQ,4CAAA;AzB2yFhB;;AwB3zFE;ECnBE,YpBwBW;EoBvBX,6BAAA;EACA,sBAAA;EACA,mBpBqBW;AL6zFf;AyBh1FI;EACI,WAP4C;EAQ5C,uBpBiBO;EoBhBP,mBpBgBO;ALk0Ff;AyB/0FI;EAEI,sCAAA;AzBg1FR;AyB70FI;EAEI,YpBMO;EoBLP,6BAAA;AzB80FR;AyB30FI;EAGI,WAAA;EACA,uBpBFO;EoBGP,mBpBHO;AL80Ff;AyBz0FQ;EAMQ,sCAAA;AzBs0FhB;;AwB30FA;EACE,gBrBoR4B;EqBnR5B,crBiBc;EqBhBd,qBrBwK0B;AHsqF5B;AMv5FE;EkB4EE,crBsKwB;EqBrKxB,qBrBsKwB;AHwqF5B;AwB30FE;EAEE,qBrBiKwB;AH2qF5B;AwBz0FE;EAEE,crBhDO;EqBiDP,oBAAA;AxB00FJ;;AwB/zFA;EChBI,sBAAA;EACA,mBtBmZ6B;EsBlZ7B,gBtB4N2B;EsB1NvB,wBtBkOsB;AHgnF9B;;AwBl0FA;ECpBI,uBAAA;EACA,kBtBiZ0B;EsBhZ1B,gBtB6N2B;EsB3NvB,uBtBgOsB;AHynF9B;;AwBh0FA;EACE,cAAA;EACA,WAAA;AxBm0FF;AwBh0FE;EACE,kBnBwT0B;AL0gF9B;;AwB1zFE;;;EACE,WAAA;AxB+zFJ;;A0B18FA;ELgBM,gCKfJ;A1B68FF;AqB17FM;EKpBN;ILqBQ,gBAAA;ErB67FN;AACF;A0Bh9FE;EACE,UAAA;A1Bk9FJ;;A0B78FE;EACE,aAAA;A1Bg9FJ;;A0B58FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A1B+8FF;AqB78FM;EKNN;ILOQ,gBAAA;ErBg9FN;AACF;A0Bl9FE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A1Bo9FJ;AqBv9FM;EKAJ;ILCM,gBAAA;ErB09FN;AACF;;A2B/+FA;;;;EAIE,kBAAA;A3Bk/FF;;A2B/+FA;EACE,mBAAA;A3Bk/FF;A4B99FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5BigGF;A4B58FI;EACE,cAAA;A5B88FN;;A2Bx/FA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBypBkC;EsBxpBlC,aAAA;EACA,WAAA;EACA,gBtBiuBkC;EsBhuBlC,iBAAA;EACA,oBAAA;EvB2JI,eAAA;EuBzJJ,cxByBS;EwBxBT,gBAAA;EACA,gBAAA;EACA,sBxBeS;EwBdT,4BAAA;EACA,mCAAA;EhBdE,wBAAA;ECFE,iHekBJ;A3B2/FF;;A2Bp/FI;EACE,WAAA;EACA,OAAA;A3Bu/FN;;A2Bp/FI;EACE,QAAA;EACA,UAAA;A3Bu/FN;;AgB3+FI;EWnBA;IACE,WAAA;IACA,OAAA;E3BkgGJ;E2B//FE;IACE,QAAA;IACA,UAAA;E3BigGJ;AACF;AgBt/FI;EWnBA;IACE,WAAA;IACA,OAAA;E3B4gGJ;E2BzgGE;IACE,QAAA;IACA,UAAA;E3B2gGJ;AACF;AgBhgGI;EWnBA;IACE,WAAA;IACA,OAAA;E3BshGJ;E2BnhGE;IACE,QAAA;IACA,UAAA;E3BqhGJ;AACF;AgB1gGI;EWnBA;IACE,WAAA;IACA,OAAA;E3BgiGJ;E2B7hGE;IACE,QAAA;IACA,UAAA;E3B+hGJ;AACF;A2BxhGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB+rBgC;AL21EpC;A4BzjGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5BqlGF;A4BviGI;EACE,cAAA;A5ByiGN;;A2B9hGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBirBgC;ALg3EpC;A4B9kGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A5BmmGF;A4B5jGI;EACE,cAAA;A5B8jGN;A2BziGI;EACE,iBAAA;A3B2iGN;;A2BriGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtBgqBgC;ALw4EpC;A4BtmGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A5BwmGN;A4B7lGM;EACE,aAAA;A5B+lGR;A4B5lGM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5B6nGF;A4B5lGI;EACE,cAAA;A5B8lGN;A2BxjGI;EACE,iBAAA;A3B0jGN;;A2BljGE;EAIE,WAAA;EACA,YAAA;A3BkjGJ;;A2B7iGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A7B+pGF;;A2B7iGA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBxBwO4B;EwBvO5B,cxB1ES;EwB2ET,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3B+iGF;AMpqGE;EqBoIE,ctBonBgC;EsBnnBhC,qBAAA;EJ/IA,yBpByCO;AH0oGX;A2BhiGE;EAEE,WxB9GO;EwB+GP,qBAAA;EJtJA,yBpBuU4B;AHi3FhC;A2B9hGE;EAEE,cxBhHO;EwBiHP,oBAAA;EACA,6BAAA;A3B+hGJ;;A2BvhGA;EACE,cAAA;A3B0hGF;;A2BthGA;EACE,cAAA;EACA,sBtBimBkC;EsBhmBlC,gBAAA;EvBAI,mBAAA;EuBEJ,cxBnIS;EwBoIT,mBAAA;A3ByhGF;;A2BrhGA;EACE,cAAA;EACA,uBAAA;EACA,cxBxIS;AHgqGX;;A8BntGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9BstGF;A8BptGE;;EACE,kBAAA;EACA,cAAA;A9ButGJ;AMttGE;;EwBII,UAAA;A9BstGN;A8BptGI;;;;EAGE,UAAA;A9ButGN;;A8BjtGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9BotGF;A8BltGE;EACE,WAAA;A9BotGJ;;A8B9sGE;;EAEE,iBAAA;A9BitGJ;A8B7sGE;;EnBXE,0BAAA;EACA,6BAAA;AX4tGJ;A8B7sGE;;EnBFE,yBAAA;EACA,4BAAA;AXmtGJ;;A8BhsGA;EACE,wBAAA;EACA,uBAAA;A9BmsGF;A8BjsGE;EAGE,cAAA;A9BisGJ;A8B9rGE;EACE,eAAA;A9BgsGJ;;A8B5rGA;EACE,uBAAA;EACA,sBAAA;A9B+rGF;;A8B5rGA;EACE,sBAAA;EACA,qBAAA;A9B+rGF;;A8BzrGA;ElBhFM,gBkBiFJ;A9B4rGF;A8BzrGE;ElBpFI,gBkBqFF;A9B2rGJ;;A8BlrGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9BqrGF;A8BnrGE;;EAEE,WAAA;A9BqrGJ;A8BlrGE;;EAEE,gBAAA;A9BorGJ;A8BhrGE;;EnBrFE,6BAAA;EACA,4BAAA;AXywGJ;A8BhrGE;;EnBxGE,yBAAA;EACA,0BAAA;AX4xGJ;;A8BjqGE;;EAEE,gBAAA;A9BoqGJ;A8BlqGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9BsqGN;;A+B/zGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/Bk0GF;A+Bh0GE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A/Bk0GJ;A+Bh0GI;;;;;;;;;;;;EAGE,iBAAA;A/B20GN;A+Bt0GE;;;EAGE,UAAA;A/Bw0GJ;A+Bp0GE;EACE,UAAA;A/Bs0GJ;A+Bj0GI;;EpBIA,yBAAA;EACA,4BAAA;AXi0GJ;A+Bj0GE;EACE,aAAA;EACA,mBAAA;A/Bm0GJ;A+Bj0GI;EpBnBA,0BAAA;EACA,6BAAA;AXu1GJ;A+Bn0GI;EpBPA,yBAAA;EACA,4BAAA;AX60GJ;A+Bn0GI;;;;EpBzBA,0BAAA;EACA,6BAAA;AXk2GJ;A+Bj0GI;;;;EpBlCA,0BAAA;EACA,6BAAA;AXy2GJ;;A+BxzGA;;EAEE,aAAA;A/B2zGF;A+BtzGE;;EACE,kBAAA;EACA,UAAA;A/ByzGJ;A+BvzGI;;EACE,UAAA;A/B0zGN;A+BtzGE;;;;;;;;EAIE,iBAAA;A/B4zGJ;;A+BxzGA;EAAuB,kBAAA;A/B4zGvB;;A+B3zGA;EAAsB,iBAAA;A/B+zGtB;;A+BvzGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;E3B2DI,mBAAA;E2BzDJ,gB5B4O4B;E4B3O5B,gB5BiP4B;E4BhP5B,c5B3ES;E4B4ET,kBAAA;EACA,mBAAA;EACA,sB5BnFS;E4BoFT,yBAAA;EpB/GE,uBAAA;AX06GJ;A+BvzGE;;EAEE,aAAA;A/ByzGJ;;A+B/yGA;;EAEE,mC1BmWsC;AL+8FxC;;A+B/yGA;;;;;;EAME,sBAAA;E3BwBI,mBAAA;E2BtBJ,gB5B+J6B;EQ3S3B,wBAAA;AX+7GJ;;A+B/yGA;;EAEE,kC1BiVsC;ALi+FxC;;A+B/yGA;;;;;;EAME,uBAAA;E3BOI,kBAAA;E2BLJ,gB5B+I6B;EQ5S3B,sBAAA;AXg9GJ;;A+B/yGA;;EAEE,sBAAA;A/BkzGF;;A+BvyGA;;;;;;;;EpB9JI,0BAAA;EACA,6BAAA;AXg9GJ;;A+BxyGA;;;;;;EpB3JI,yBAAA;EACA,4BAAA;AX48GJ;;AgCp/GA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;UAAA,yBAAA;AhCu/GF;;AgCp/GA;EACE,oBAAA;EACA,kB7BikBsC;AHs7FxC;;AgCp/GA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,c7B2jBsC;E6B1jBtC,gBAAA;EACA,UAAA;AhCu/GF;AgCr/GE;EACE,W7BaO;E6BZP,qB7B6S4B;EoBxU5B,yBpBuU4B;ES7T1B,gBoBmBF;AhCu/GJ;AgCp/GE;EAGI,sBAAA;AhCo/GN;AgC9+GE;EACE,sC7BqgBoC;AH2+FxC;AgC7+GE;EACE,W7BPO;E6BQP,yB7BwR4B;E6BvR5B,qB7BwR4B;ES9T1B,gBoBuCF;AhC++GJ;AgCz+GI;EACE,c7BXK;AHs/GX;AgCz+GM;EACE,yB7BlBG;AH6/GX;;AgCj+GA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AhCm+GF;AgC/9GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B8foC;E6B7fpC,e7B6foC;E6B5fpC,oBAAA;EACA,WAAA;EACA,sB7B/CO;E6BgDP,yBAAA;EpB7EE,gBoB8EF;AhCi+GJ;AgC79GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B+eoC;E6B9epC,e7B8eoC;E6B7epC,WAAA;EACA,iCAAA;AhC+9GJ;;AgCr9GE;ErBlGE,sBAAA;AX2jHJ;AgCp9GI;EACE,yDAAA;AhCs9GN;AgCj9GI;EACE,qB7B6M0B;EoBvU5B,yBpBuU4B;AHuwGhC;AgCh9GI;EACE,yDAAA;AhCk9GN;AgC78GI;ETpIA,yCpBsmB4C;AH8+FhD;AgC78GI;ETvIA,yCpBsmB4C;AHi/FhD;;AgCr8GE;EAEE,kB3B0Z4C;AL6iGhD;AgCn8GI;EACE,yDAAA;AhCq8GN;AgCh8GI;ET9JA,yCpBsmB4C;AH2/FhD;;AgCx7GA;EACE,uBAAA;AhC27GF;AgCx7GI;EACE,gBAAA;EACA,gB3BkY0C;E2BjY1C,mBAAA;EAEA,uB3BgY0C;ALyjGhD;AgCt7GI;EACE,yBAAA;EACA,4BAAA;EACA,0B3B2X0C;E2B1X1C,2B3B0X0C;E2BzX1C,yB7BgXkC;E6B9WlC,uB3BsX0C;EgBxiB1C,yIWmLA;AhCu7GN;AqBtmHM;EWuKF;IXtKI,gBAAA;ErBymHN;AACF;AgCv7GI;EACE,sB7B5JK;E6B6JL,gCAAA;AhCy7GN;AgCp7GI;ETzMA,yCpBsmB4C;AH0hGhD;;AgC16GA;EACE,qBAAA;EACA,WAAA;EACA,mC3BqRsC;E2BpRtC,0CAAA;E5B5CI,mBAAA;E4B+CJ,gB7BoI4B;E6BnI5B,gB7ByI4B;E6BxI5B,c7BlLS;E6BmLT,sBAAA;EACA,gGAAA;EACA,yBAAA;ErBtNE,uBAAA;ECFE,gDoB0NJ;EACA,wBAAA;UAAA,gBAAA;AhC46GF;AgC16GE;EACE,sC7BuUoC;E6BtUpC,UAAA;EpB/NE,iEALa;AZipHnB;AgCr6GI;EAME,c7B1MK;E6B2ML,sB7BjNK;AHmnHX;AgC95GE;EAEE,YAAA;EACA,sB7B2N0B;E6B1N1B,sBAAA;AhC+5GJ;AgC55GE;EACE,c7BvNO;E6BwNP,yB7B5NO;AH0nHX;AgC15GE;EACE,aAAA;AhC45GJ;AgCx5GE;EACE,kBAAA;EACA,0BAAA;AhC05GJ;;AgCt5GA;EACE,kC3B0NsC;E2BzNtC,oB7B2M4B;E6B1M5B,uB7B0M4B;E6BzM5B,oB7B0M4B;ECpTxB,kBAAA;AJogHN;;AgCt5GA;EACE,mC3BmNsC;E2BlNtC,qB7BuM4B;E6BtM5B,wB7BsM4B;E6BrM5B,kB7BsM4B;ECxTxB,mBAAA;AJ4gHN;;AgCj5GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BiMsC;E2BhMtC,gBAAA;AhCo5GF;;AgCj5GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3ByLsC;E2BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;AhCo5GF;AgCl5GE;EACE,sC7BoPoC;E6BnPpC,gB7BsPoC;AH8pGxC;AgCh5GE;EAEE,yB7BzRO;AH0qHX;AgC74GI;EACE,iB3B2Ta;ALolGnB;AgC34GE;EACE,0BAAA;AhC64GJ;;AgCz4GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BwJsC;E2BvJtC,yBAAA;EACA,gBAAA;EAEA,gB7BO4B;E6BN5B,gB7BY4B;E6BX5B,c7B/SS;E6BgTT,sB7BtTS;E6BuTT,yBAAA;ErBlVE,uBAAA;ECFE,gBoBsVJ;AhC24GF;AgCz4GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BiIoC;E2BhIpC,yBAAA;EACA,gB7BJ0B;E6BK1B,c7B/TO;E6BgUP,iBAAA;ET7WA,sBpBuCO;E6BwUP,oBAAA;ErBnWA,oCAAA;AX+uHJ;;AgCj4GA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AhCo4GF;AgCl4GE;EACE,UAAA;AhCo4GJ;AgCh4GI;EAA0B,mC3BoOe;AL+pG7C;AgCl4GI;EAA0B,mC3BmOe;ALkqG7C;AgCp4GI;EAA0B,mC3BkOe;ALqqG7C;AgCp4GE;EACE,SAAA;AhCs4GJ;AgCn4GE;EACE,W3BoNyC;E2BnNzC,Y3BmNyC;E2BlNzC,oBAAA;ETlZA,yBpBuU4B;E6B6E5B,S3BmNyC;EM3lBzC,mBAAA;ECFE,+CoB4YF;EX5YE,oHW6YF;EX7YE,4GW6YF;EACA,wBAAA;UAAA,gBAAA;AhCq4GJ;AqB/wHM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;ErBkxHN;AACF;AgCx4GI;ET1ZA,yBlB4mByC;ALyrG7C;AgCt4GE;EACE,W3B6LgC;E2B5LhC,c3B6LgC;E2B5LhC,kBAAA;EACA,e3B4LgC;E2B3LhC,yB7B1XO;E6B2XP,yBAAA;ErBzZA,mBAAA;ECFE,sDoB6ZF;AhCw4GJ;AgCr4GE;EACE,W3ByLyC;E2BxLzC,Y3BwLyC;EkBpmBzC,yBpBuU4B;E6BuG5B,S3ByLyC;EM3lBzC,mBAAA;ECFE,+CoBsaF;EXtaE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;AhCu4GJ;AqB3yHM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;ErB8yHN;AACF;AgC14GI;ETpbA,yBlB4mByC;ALqtG7C;AgCx4GE;EACE,W3BmKgC;E2BlKhC,c3BmKgC;E2BlKhC,kBAAA;EACA,e3BkKgC;E2BjKhC,yB7BpZO;E6BqZP,yBAAA;ErBnbA,mBAAA;ECFE,sDoBubF;AhC04GJ;AgCv4GE;EACE,W3B+JyC;E2B9JzC,Y3B8JyC;E2B7JzC,aAAA;EACA,e7ByGoC;E6BxGpC,c7BwGoC;EoBjjBpC,yBpBuU4B;E6BoI5B,S3B4JyC;EM3lBzC,mBAAA;ECFE,+CoBmcF;EXncE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;AhCy4GJ;AqB10HM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;ErB60HN;AACF;AgC54GI;ETjdA,yBlB4mByC;ALovG7C;AgC14GE;EACE,W3BsIgC;E2BrIhC,c3BsIgC;E2BrIhC,kBAAA;EACA,e3BqIgC;E2BpIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;EpBndE,sDoBodF;AhC44GJ;AgCz4GE;EACE,yB7BxbO;EQ9BP,mBAAA;AXk2HJ;AgCx4GE;EACE,kBAAA;EACA,yB7B9bO;EQ9BP,mBAAA;AXu2HJ;AgCt4GI;EACE,yB7BlcK;AH00HX;AgCr4GI;EACE,eAAA;AhCu4GN;AgCp4GI;EACE,yB7B1cK;AHg1HX;AgCn4GI;EACE,eAAA;AhCq4GN;AgCl4GI;EACE,yB7BldK;AHs1HX;;AgC/3GA;;;EXzfM,4GW4fJ;AhCk4GF;AqB13HM;EWqfN;;;IXpfQ,gBAAA;ErB+3HN;AACF;;AiCh5HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjCm5HF;;AiCh5HA;EACE,cAAA;EACA,wBAAA;AjCm5HF;AMl5HE;E2BGE,qBAAA;AjCk5HJ;AiC94HE;EACE,c9B2BO;E8B1BP,oBAAA;EACA,eAAA;AjCg5HJ;;AiCx4HA;EACE,gCAAA;AjC24HF;AiCz4HE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;EtBbA,gCAAA;EACA,iCAAA;AXy5HJ;AMr6HE;E2B6BI,kBAAA;EACA,qC5BipB8B;AL0vGpC;AiCx4HI;EACE,c9BCK;E8BAL,6BAAA;EACA,yBAAA;AjC04HN;AiCt4HE;;EAEE,c9BNO;E8BOP,yB9B+KM;E8B9KN,qC5BsoBgC;ALkwGpC;AiCr4HE;EAEE,gBAAA;EtBtCA,yBAAA;EACA,0BAAA;AX66HJ;;AiC53HE;EACE,gBAAA;EACA,SAAA;EtB7DA,uBAAA;AX67HJ;AiC53HE;;EAEE,W9BqnBgC;E8BpnBhC,yB9BqnBgC;AHywGpC;;AiCp3HE;;EAEE,cAAA;EACA,kBAAA;AjCu3HJ;;AiCl3HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AjCq3HJ;;AiC32HE;EACE,aAAA;AjC82HJ;AiC52HE;EACE,cAAA;AjC82HJ;;AkCv9HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AlC09HF;AkCt9HE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlC69HJ;AkCz8HA;EACE,qBAAA;EACA,sB7BkqBkC;E6BjqBlC,yB7BiqBkC;E6BhqBlC,kB/B2pBkC;EC9hB9B,kBAAA;E8B3HJ,oBAAA;EACA,mBAAA;AlC28HF;AMr/HE;E4B6CE,qBAAA;AlC28HJ;;AkCl8HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCq8HF;AkCn8HE;EACE,gBAAA;EACA,eAAA;AlCq8HJ;AkCl8HE;EACE,gBAAA;EACA,WAAA;AlCo8HJ;;AkC37HA;EACE,qBAAA;EACA,oB/BylBkC;E+BxlBlC,uB/BwlBkC;AHs2GpC;;AkCl7HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlCm7HF;;AkC/6HA;EACE,wBAAA;E9B8DI,kBAAA;E8B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EvBxGE,uBAAA;AX2hIJ;AM7hIE;E4B8GE,qBAAA;AlCk7HJ;;AkC56HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AlC+6HF;;AkC56HA;EACE,gB7BglBkC;E6B/kBlC,gBAAA;AlC+6HF;;AgBr/HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC46HR;AACF;AgB9gII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCi6HN;EkC/5HM;IACE,mBAAA;ElCi6HR;EkC/5HQ;IACE,kBAAA;ElCi6HV;EkC95HQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EHq4GlC;EkC35HM;;;;;;IACE,iBAAA;ElCk6HR;EkCp5HM;IACE,iBAAA;ElCs5HR;EkCn5HM;IACE,wBAAA;IAGA,gBAAA;ElCm5HR;EkCh5HM;IACE,aAAA;ElCk5HR;AACF;AgBniII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCy9HR;AACF;AgB3jII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC88HN;EkC58HM;IACE,mBAAA;ElC88HR;EkC58HQ;IACE,kBAAA;ElC88HV;EkC38HQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EHk7GlC;EkCx8HM;;;;;;IACE,iBAAA;ElC+8HR;EkCj8HM;IACE,iBAAA;ElCm8HR;EkCh8HM;IACE,wBAAA;IAGA,gBAAA;ElCg8HR;EkC77HM;IACE,aAAA;ElC+7HR;AACF;AgBhlII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCsgIR;AACF;AgBxmII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC2/HN;EkCz/HM;IACE,mBAAA;ElC2/HR;EkCz/HQ;IACE,kBAAA;ElC2/HV;EkCx/HQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EH+9GlC;EkCr/HM;;;;;;IACE,iBAAA;ElC4/HR;EkC9+HM;IACE,iBAAA;ElCg/HR;EkC7+HM;IACE,wBAAA;IAGA,gBAAA;ElC6+HR;EkC1+HM;IACE,aAAA;ElC4+HR;AACF;AgB7nII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCmjIR;AACF;AgBrpII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCwiIN;EkCtiIM;IACE,mBAAA;ElCwiIR;EkCtiIQ;IACE,kBAAA;ElCwiIV;EkCriIQ;IACE,mB/B4hBwB;I+B3hBxB,kB/B2hBwB;EH4gHlC;EkCliIM;;;;;;IACE,iBAAA;ElCyiIR;EkC3hIM;IACE,iBAAA;ElC6hIR;EkC1hIM;IACE,wBAAA;IAGA,gBAAA;ElC0hIR;EkCvhIM;IACE,aAAA;ElCyhIR;AACF;AkC1lII;EAoBI,qBAAA;EACA,2BAAA;AlCykIR;AkC5lIQ;;;;;;EACE,gBAAA;EACA,eAAA;AlCmmIV;AkChlIQ;EACE,mBAAA;AlCklIV;AkChlIU;EACE,kBAAA;AlCklIZ;AkC/kIU;EACE,mB/B4hBwB;E+B3hBxB,kB/B2hBwB;AHsjHpC;AkC5kIQ;;;;;;EACE,iBAAA;AlCmlIV;AkCrkIQ;EACE,iBAAA;AlCukIV;AkCpkIQ;EACE,wBAAA;EAGA,gBAAA;AlCokIV;AkCjkIQ;EACE,aAAA;AlCmkIV;;AkCrjIE;EACE,yB/B+gBgC;AHyiHpC;AMhxIE;E4B2NI,yB/B4gB8B;AH4iHpC;AkCnjII;EACE,yB/BogB8B;AHijHpC;AMtxIE;E4BoOM,yB/BkgB4B;AHmjHpC;AkCljIM;EACE,yB/BggB4B;AHojHpC;AkChjII;;;;EAIE,yB/Buf8B;AH2jHpC;AkC9iIE;EACE,yB/BgfgC;E+B/ehC,yB/BmfgC;AH6jHpC;AkC7iIE;EACE,yDAAA;AlC+iIJ;AkC5iIE;EACE,yB/BuegC;AHukHpC;AkC7iII;EACE,yB/Bue8B;AHwkHpC;AM/yIE;E4BmQM,yB/Boe4B;AH2kHpC;;AkCviIE;EACE,gC/B4cgC;AH8lHpC;AMtzIE;E4B+QI,gC/Byc8B;AHimHpC;AkCriII;EACE,gC/Bic8B;AHsmHpC;AM5zIE;E4BwRM,gC/B+b4B;AHwmHpC;AkCpiIM;EACE,gC/B6b4B;AHymHpC;AkCliII;;;;EAIE,gC/Bob8B;AHgnHpC;AkChiIE;EACE,gC/B6agC;E+B5ahC,yB/BgbgC;AHknHpC;AkC/hIE;EACE,yDAAA;AlCiiIJ;AkC9hIE;EACE,gC/BoagC;AH4nHpC;AkC/hII;EACE,gC/Boa8B;AH6nHpC;AMr1IE;E4BuTM,gC/Bia4B;AHgoHpC;;AmCp2IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBhCkCS;EgCjCT,2BAAA;EACA,qCAAA;ExBKE,uBAAA;AXk2IJ;AmCp2IE;EACE,eAAA;EACA,cAAA;AnCs2IJ;AmCn2IE;EACE,mBAAA;EACA,sBAAA;AnCq2IJ;AmCn2II;EACE,mBAAA;ExBCF,4CAAA;EACA,6CAAA;AXq2IJ;AmCn2II;EACE,sBAAA;ExBUF,gDAAA;EACA,+CAAA;AX41IJ;AmCh2IE;;EAEE,aAAA;AnCk2IJ;;AmC91IA;EAGE,cAAA;EAGA,eAAA;EACA,ehCg2BkC;AH6/GpC;;AmCz1IA;EACE,sBhC01BkC;AHkgHpC;;AmCz1IA;EACE,qBAAA;EACA,gBAAA;AnC41IF;;AmCz1IA;EACE,gBAAA;AnC41IF;;AMj5IE;E6B0DE,qBAAA;AnC21IJ;AmCx1IE;EACE,mBhCy0BgC;AHihHpC;;AmCl1IA;EACE,uBAAA;EACA,gBAAA;EAEA,sBhCzCS;EgC0CT,4CAAA;AnCo1IF;AmCl1IE;ExBvEE,4DAAA;AX45IJ;;AmCh1IA;EACE,uBAAA;EAEA,sBhCpDS;EgCqDT,yCAAA;AnCk1IF;AmCh1IE;ExBlFE,4DAAA;AXq6IJ;;AmCz0IA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AnC40IF;;AmCz0IA;EACE,sBAAA;EACA,qBAAA;AnC40IF;;AmCx0IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBhC0xBkC;EQz4BhC,mCAAA;AX27IJ;;AmCx0IA;;;EAGE,cAAA;EACA,WAAA;AnC20IF;;AmCx0IA;;ExBjHI,4CAAA;EACA,6CAAA;AX87IJ;;AmCz0IA;;ExBxGI,gDAAA;EACA,+CAAA;AXs7IJ;;AmCt0IE;EACE,mB9BqrBgC;ALopHpC;AgBx6II;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EnCy0IF;EmCv0IE;IAEE,SAAA;IACA,kB9ByqB8B;I8BxqB9B,gBAAA;IACA,iB9BuqB8B;ELiqHlC;AACF;;AmC5zIE;EACE,mB9BypBgC;ALsqHpC;AgB17II;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EnC+zIF;EmC5zIE;IAEE,SAAA;IACA,gBAAA;EnC6zIJ;EmC3zII;IACE,cAAA;IACA,cAAA;EnC6zIN;EmCxzIM;IxBzKJ,0BAAA;IACA,6BAAA;EXo+IF;EmCzzIQ;;IAGE,0BAAA;EnC0zIV;EmCxzIQ;;IAGE,6BAAA;EnCyzIV;EmCrzIM;IxB1KJ,yBAAA;IACA,4BAAA;EXk+IF;EmCtzIQ;;IAGE,yBAAA;EnCuzIV;EmCrzIQ;;IAGE,4BAAA;EnCszIV;AACF;;AmCzyIE;EACE,sBhC8pBgC;AH8oHpC;AgBp+II;EmBsLJ;IAMI,ehCwqBgC;IgCvqBhC,mBhCwqBgC;IgCvqBhC,UAAA;IACA,SAAA;EnC4yIF;EmC1yIE;IACE,qBAAA;IACA,WAAA;EnC4yIJ;AACF;;AmCnyIA;EACE,qBAAA;AnCsyIF;AmCpyIE;EACE,gBAAA;AnCsyIJ;AmCpyII;EACE,gBAAA;ExBvOF,6BAAA;EACA,4BAAA;AX8gJJ;AmCpyII;ExBzPA,yBAAA;EACA,0BAAA;AXgiJJ;AmCpyII;ExBtQA,gBAAA;EwBwQE,mBAAA;AnCsyIN;;AoChkJA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BqiCkC;E+BniClC,gBAAA;EACA,yBjCwCS;EQ7BP,uBAAA;AXwjJJ;;AoC7jJE;EACE,oB/ByhCgC;ALuiHpC;AoC9jJI;EACE,WAAA;EACA,qB/BqhC8B;E+BphC9B,cjCgCK;EiC/BL,YAAA;ApCgkJN;AoCtjJE;EACE,0BAAA;ApCwjJJ;AoCrjJE;EACE,qBAAA;ApCujJJ;AoCpjJE;EACE,cjCYO;AH0iJX;;AqC7lJA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGaE,uBAAA;AXklJJ;;AqC9lJA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCoxBkC;EgCnxBlC,clCuCS;EkCrCT,sBlC+BS;EkC9BT,yBAAA;ArCgmJF;AqC9lJE;EACE,UAAA;EACA,clCgCO;EkC/BP,qBAAA;EACA,yBlC2BO;EkC1BP,qBlC0BO;AHskJX;AqC7lJE;EACE,UAAA;EACA,UhC4wBgC;EgC3wBhC,gBlCyc0B;AHspI9B;;AqCzlJI;EACE,cAAA;E1BaF,gCAAA;EACA,mCAAA;AXglJJ;AqCzlJI;E1BNA,iCAAA;EACA,oCAAA;AXkmJJ;AqCxlJE;EACE,UAAA;EACA,WlCFO;EkCGP,yBlC6R4B;EkC5R5B,qBlC4R4B;AH8zIhC;AqCvlJE;EACE,clCFO;EkCGP,oBAAA;EAEA,YAAA;EACA,sBlCZO;EkCaP,qBlCVO;AHkmJX;;AsC/oJE;EACE,uBAAA;ElCgLE,kBAAA;EkC9KF,gBjCmO0B;AL+6I9B;AsC7oJM;E3BqCF,iCAAA;EACA,oCAAA;AX2mJJ;AsC5oJM;E3BkBF,kCAAA;EACA,qCAAA;AX6nJJ;;AsC7pJE;EACE,uBAAA;ElCgLE,mBAAA;EkC9KF,gBjCoO0B;AL47I9B;AsC3pJM;E3BqCF,+BAAA;EACA,kCAAA;AXynJJ;AsC1pJM;E3BkBF,gCAAA;EACA,mCAAA;AX2oJJ;;AuCzqJA;EACE,qBAAA;EACA,yBAAA;EnC6JE,cAAA;EmC3JF,gBpC+V4B;EoC9V5B,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BKE,uBAAA;EUFE,qIkBDJ;AvC4qJF;AqBvqJM;EkBfN;IlBgBQ,gBAAA;ErB0qJN;AACF;AMhrJE;EiCGI,qBAAA;AvCgrJN;;AuC3qJE;EACE,aAAA;AvC8qJJ;;AuCzqJA;EACE,kBAAA;EACA,SAAA;AvC4qJF;;AuCrqJA;EACE,sBpCo0BkC;EoCn0BlC,qBpCm0BkC;EQ11BhC,oBAAA;AXgsJJ;;AuChqJE;ECjDD,cAAA;EACG,0CAAA;AxCqtJJ;AMvsJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCotJT;;AuC1qJE;ECjDD,cAAA;EACG,0CAAA;AxC+tJJ;AMjtJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxC8tJT;;AuCprJE;ECjDD,cAAA;EACG,0CAAA;AxCyuJJ;AM3tJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCwuJT;;AuC9rJE;ECjDD,cAAA;EACG,0CAAA;AxCmvJJ;AMruJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCkvJT;;AuCxsJE;ECjDD,cAAA;EACG,0CAAA;AxC6vJJ;AM/uJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxC4vJT;;AuCltJE;ECjDD,cAAA;EACG,0CAAA;AxCuwJJ;AMzvJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCswJT;;AuC5tJE;ECjDD,cAAA;EACG,0CAAA;AxCixJJ;AMnwJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCgxJT;;AuCtuJE;ECjDD,cAAA;EACG,yCAAA;AxC2xJJ;AM7wJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxC0xJT;;AuChvJE;ECjDD,cAAA;EACG,wCAAA;AxCqyJJ;AMvxJE;EkCVO,WAAA;EACA,qBAAA;EACA,yBAAA;AxCoyJT;;AuC1vJE;ECjDD,cAAA;EACG,0CAAA;AxC+yJJ;AMjyJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxC8yJT;;AuCpwJE;ECjDD,cAAA;EACG,0CAAA;AxCyzJJ;AM3yJE;EkCVO,cAAA;EACA,qBAAA;EACA,yBAAA;AxCwzJT;;AuC9wJE;ECjDD,YAAA;EACG,uCAAA;AxCm0JJ;AMrzJE;EkCVO,WAAA;EACA,qBAAA;EACA,uBAAA;AxCk0JT;;AyC10JA;EACE,kBAAA;EACA,mBpCyzBkC;EoCvzBlC,yBtC2CS;EQ7BP,wBAAA;AX+zJJ;AgBrxJI;EyB5DJ;IAQI,kBAAA;EzC60JF;AACF;;AyC10JA;EACE,gBAAA;EACA,eAAA;E9BIE,gBAAA;AX00JJ;;A0Cx1JA;EACE,kBAAA;EACA,oBAAA;EACA,mBrCy9BkC;EqCx9BlC,6BAAA;E/BUE,uBAAA;AXk1JJ;;A0Cv1JA;EAEE,cAAA;A1Cy1JF;;A0Cr1JA;EACE,gBvCoV4B;AHogJ9B;;A0Ch1JA;EACE,qBAAA;A1Cm1JF;A0Ch1JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;A1Ck1JJ;;A0Cx0JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C60JvE;A2Cz3JI;EACI,yBAAA;A3C23JR;A2Cx3JI;EACI,cAAA;A3C03JR;;A0Cp1JE;EC/CE,cAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cy1JvE;A2Cr4JI;EACI,yBAAA;A3Cu4JR;A2Cp4JI;EACI,cAAA;A3Cs4JR;;A0Ch2JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cq2JvE;A2Cj5JI;EACI,yBAAA;A3Cm5JR;A2Ch5JI;EACI,cAAA;A3Ck5JR;;A0C52JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ci3JvE;A2C75JI;EACI,yBAAA;A3C+5JR;A2C55JI;EACI,cAAA;A3C85JR;;A0Cx3JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C63JvE;A2Cz6JI;EACI,yBAAA;A3C26JR;A2Cx6JI;EACI,cAAA;A3C06JR;;A0Cp4JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cy4JvE;A2Cr7JI;EACI,yBAAA;A3Cu7JR;A2Cp7JI;EACI,cAAA;A3Cs7JR;;A0Ch5JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Cq5JvE;A2Cj8JI;EACI,yBAAA;A3Cm8JR;A2Ch8JI;EACI,cAAA;A3Ck8JR;;A0C55JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ci6JvE;A2C78JI;EACI,yBAAA;A3C+8JR;A2C58JI;EACI,cAAA;A3C88JR;;A0Cx6JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1C66JvE;A2Cz9JI;EACI,yBAAA;A3C29JR;A2Cx9JI;EACI,cAAA;A3C09JR;;A0Cp7JE;EC/CE,cAAA;EpBKA,uBmB2CuB;EC9CvB,mBD8CmE;A1Cy7JvE;A2Cr+JI;EACI,yBAAA;A3Cu+JR;A2Cp+JI;EACI,cAAA;A3Cs+JR;;A0Ch8JE;EC/CE,cAAA;EpBKA,uBmB2CuB;EC9CvB,mBD8CmE;A1Cq8JvE;A2Cj/JI;EACI,yBAAA;A3Cm/JR;A2Ch/JI;EACI,cAAA;A3Ck/JR;;A0C58JE;EC/CE,WAAA;EpBKA,yBmB2CuB;EC9CvB,qBD8CmE;A1Ci9JvE;A2C7/JI;EACI,yBAAA;A3C+/JR;A2C5/JI;EACI,YAAA;A3C8/JR;;A4CtgKE;EACE;IAAO,2BAAA;E5C0gKT;E4CzgKE;IAAK,wBAAA;E5C4gKP;AACF;A4CzgKA;EACE,aAAA;EACA,YvCk+BkC;EuCj+BlC,gBAAA;EACA,cAAA;ExCwKI,kBAAA;EwCtKJ,yBzCiCS;EQ7BP,uBAAA;ECFE,oDAAA;AZ2gKN;;A4CxgKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WzCqBS;EyCpBT,kBAAA;EACA,mBAAA;EACA,yBvCu9BkC;EgBl+B9B,2BuBYJ;A5C2gKF;AqBnhKM;EuBDN;IvBEQ,gBAAA;ErBshKN;AACF;;A4C7gKA;ErBYE,qMAAA;EqBVA,0BAAA;A5CghKF;;A4C5gKE;EACE,kDAAA;A5C+gKJ;A4C5gKM;EAJJ;IAKM,eAAA;E5C+gKN;AACF;;A6C1jKA;EACE,aAAA;EACA,uBAAA;A7C6jKF;;A6C1jKA;EACE,SAAA;A7C6jKF;;A8C/jKA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EnCQE,uBAAA;AXyjKJ;;A8CvjKA;EACE,WAAA;EACA,c3C8BS;E2C7BT,mBAAA;A9C0jKF;AMjkKE;EwCWE,UAAA;EACA,c3CwBO;E2CvBP,qBAAA;EACA,yB3CgBO;AHyiKX;A8CtjKE;EACE,c3CkBO;E2CjBP,yB3CYO;AH4iKX;;A8C/iKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAGA,sB3CLS;E2CMT,yBAAA;A9CgjKF;A8C9iKE;EnC1BE,+BAAA;EACA,gCAAA;AX2kKJ;A8C9iKE;EnChBE,mCAAA;EACA,kCAAA;AXikKJ;A8C9iKE;EAEE,c3CZO;E2CaP,oBAAA;EACA,sB3CpBO;AHmkKX;A8C3iKE;EACE,UAAA;EACA,W3C1BO;E2C2BP,yB3CqQ4B;E2CpQ5B,qB3CoQ4B;AHyyJhC;A8C1iKE;EACE,mBAAA;A9C4iKJ;A8C1iKI;EACE,gBAAA;EACA,qB3C+OwB;AH6zJ9B;;A8C9hKI;EACE,mBAAA;A9CiiKN;A8C9hKQ;EnC1BJ,mCAAA;EAZA,0BAAA;AXwkKJ;A8C7hKQ;EnC3CJ,iCAAA;EAYA,4BAAA;AXgkKJ;A8C5hKQ;EACE,aAAA;A9C8hKV;A8C3hKQ;EACE,qB3C8MoB;E2C7MpB,oBAAA;A9C6hKV;A8C3hKU;EACE,iBAAA;EACA,sB3CyMkB;AHo1J9B;;AgBxlKI;E8BmCA;IACE,mBAAA;E9CyjKJ;E8CtjKM;InC1BJ,mCAAA;IAZA,0BAAA;EXgmKF;E8CrjKM;InC3CJ,iCAAA;IAYA,4BAAA;EXwlKF;E8CpjKM;IACE,aAAA;E9CsjKR;E8CnjKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9CqjKR;E8CnjKQ;IACE,iBAAA;IACA,sB3CyMkB;EH42J5B;AACF;AgBjnKI;E8BmCA;IACE,mBAAA;E9CilKJ;E8C9kKM;InC1BJ,mCAAA;IAZA,0BAAA;EXwnKF;E8C7kKM;InC3CJ,iCAAA;IAYA,4BAAA;EXgnKF;E8C5kKM;IACE,aAAA;E9C8kKR;E8C3kKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9C6kKR;E8C3kKQ;IACE,iBAAA;IACA,sB3CyMkB;EHo4J5B;AACF;AgBzoKI;E8BmCA;IACE,mBAAA;E9CymKJ;E8CtmKM;InC1BJ,mCAAA;IAZA,0BAAA;EXgpKF;E8CrmKM;InC3CJ,iCAAA;IAYA,4BAAA;EXwoKF;E8CpmKM;IACE,aAAA;E9CsmKR;E8CnmKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9CqmKR;E8CnmKQ;IACE,iBAAA;IACA,sB3CyMkB;EH45J5B;AACF;AgBjqKI;E8BmCA;IACE,mBAAA;E9CioKJ;E8C9nKM;InC1BJ,mCAAA;IAZA,0BAAA;EXwqKF;E8C7nKM;InC3CJ,iCAAA;IAYA,4BAAA;EXgqKF;E8C5nKM;IACE,aAAA;E9C8nKR;E8C3nKM;IACE,qB3C8MoB;I2C7MpB,oBAAA;E9C6nKR;E8C3nKQ;IACE,iBAAA;IACA,sB3CyMkB;EHo7J5B;AACF;A8ChnKA;EnCnHI,gBAAA;AXsuKJ;A8ChnKE;EACE,qBAAA;A9CknKJ;A8ChnKI;EACE,sBAAA;A9CknKN;;A+C3vKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C2mK3C;AMnvKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C6vKR;A+C1vKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9ConK1E;;A+CzwKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CynK3C;AMjwKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C2wKR;A+CxwKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CkoK1E;;A+CvxKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CuoK3C;AM/wKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/CyxKR;A+CtxKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CgpK1E;;A+CryKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CqpK3C;AM7xKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/CuyKR;A+CpyKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C8pK1E;;A+CnzKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CmqK3C;AM3yKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/CqzKR;A+ClzKM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C4qK1E;;A+Cj0KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9CirK3C;AMzzKE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Cm0KR;A+Ch0KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9C0rK1E;;A+C/0KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C+rK3C;AMv0KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Ci1KR;A+C90KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CwsK1E;;A+C71KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C6sK3C;AMr1KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C+1KR;A+C51KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CstK1E;;A+C32KE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C2tK3C;AMn2KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C62KR;A+C12KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CouK1E;;A+Cz3KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A9CyuK3C;AMj3KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/C23KR;A+Cx3KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CkvK1E;;A+Cv4KE;EACE,cDoJsE;ECnJtE,uBDmJuC;A9CuvK3C;AM/3KE;EyCPM,cD+IkE;EC9IlE,yBAAA;A/Cy4KR;A+Ct4KM;EACE,W5C+BG;E4C9BH,yBDyIkE;ECxIlE,qBDwIkE;A9CgwK1E;;A+Cr5KE;EACE,YDoJsE;ECnJtE,yBDmJuC;A9CqwK3C;AM74KE;EyCPM,YD+IkE;EC9IlE,yBAAA;A/Cu5KR;A+Cp5KM;EACE,W5C+BG;E4C9BH,uBDyIkE;ECxIlE,mBDwIkE;A9C8wK1E;;AgDt6KA;EACE,YAAA;E5CmLI,iBAAA;E4CjLJ,gB7CqW4B;E6CpW5B,cAAA;EACA,yB7C+zBkC;E6C9zBlC,iB7Cg0BkC;E6C/zBlC,YAAA;AhDy6KF;AMp6KE;E0CDE,yB7CyzBgC;E6CxzBhC,qBAAA;AhDw6KJ;AMp6KE;E0CCI,aAAA;AhDs6KN;;AgD35KA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AhD85KF;;AgDx5KA;EACE,oBAAA;AhD25KF;;AiD37KA;EAEE,gBAAA;AjD67KF;AiD37KE;EACE,kBAAA;EACA,gBAAA;AjD67KJ;;AiDx7KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C4pBkC;E4C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjDy7KF;;AiDl7KA;EACE,kBAAA;EACA,WAAA;EACA,c5Ci5BkC;E4C/4BlC,oBAAA;AjDo7KF;AiDj7KE;E5B3BI,mC4B4BF;EACA,8B5Cu6BgC;AL4gJpC;AqB58KM;E4BuBJ;I5BtBM,gBAAA;ErB+8KN;AACF;AiDt7KE;EACE,e5Cq6BgC;ALmhJpC;AiDp7KE;EACE,sB5Ck6BgC;ALohJpC;;AiDl7KA;EACE,aAAA;EACA,6BAAA;AjDq7KF;AiDn7KE;EACE,8BAAA;EACA,gBAAA;AjDq7KJ;AiDl7KE;;EAEE,cAAA;AjDo7KJ;AiDj7KE;EACE,gBAAA;AjDm7KJ;;AiD/6KA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjDk7KF;AiD/6KE;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EAAA,mBAAA;EACA,WAAA;AjDi7KJ;AiD76KE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjD+6KJ;AiD76KI;EACE,gBAAA;AjD+6KN;AiD56KI;EACE,aAAA;AjD86KN;;AiDx6KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB9CrES;E8CsET,4BAAA;EACA,kCAAA;EtClGE,wBAAA;ECFE,6EqCsGJ;EAEA,UAAA;AjDw6KF;;AiDp6KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CgjBkC;E4C/iBlC,YAAA;EACA,aAAA;EACA,sB9C5ES;AHm/KX;AiDp6KE;EAAS,UAAA;AjDu6KX;AiDt6KE;EAAS,a9CmzBmB;AHsnJ9B;;AiDp6KA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gB9C+yB4B;E8C9yB5B,8BAAA;EtCtHE,iCAAA;EACA,kCAAA;AX8hLJ;AiDt6KE;EACE,gB9C0yB0B;E8CxyB1B,8BAAA;AjDu6KJ;;AiDl6KA;EACE,gBAAA;EACA,gB9CkxBkC;AHmpJpC;;AiDh6KA;EACE,kBAAA;EAGA,cAAA;EACA,e9CkwBkC;AH+pJpC;;AiD75KA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EtCzIE,qCAAA;EACA,oCAAA;AX0iLJ;AiD55KE;EACE,eAAA;AjD85KJ;;AiDz5KA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjD45KF;;AgBniLI;EiC6IF;IACE,gB9CmuBgC;I8CluBhC,oBAAA;EjD05KF;EiDv5KA;IACE,+BAAA;EjDy5KF;EiDv5KE;IACE,gCAAA;EjDy5KJ;EiDr5KA;IACE,+BAAA;EjDu5KF;EiDr5KE;IACE,4BAAA;IACA,2BAAA;IAAA,mBAAA;EjDu5KJ;EiDn5KA;IrC/MI,6EqCgNF;EjDq5KF;EiDl5KA;IAAY,gB9C2sBsB;EH0sJlC;AACF;AgB7jLI;EiC2KF;;IAEE,gB9CmsBgC;EHktJlC;AACF;AgBnkLI;EiCkLF;IAAY,iB5CiuBsB;ELorJlC;AACF;AkDnoLA;EACE,kBAAA;EACA,a7CgrBkC;E6C/qBlC,cAAA;EACA,S7C61BkC;E8Cj2BlC,kChD4VuB;EgD1VvB,kBAAA;EACA,gBhDmW4B;EgDlW5B,gBhDuW4B;EgDtW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;E8CzKJ,qBAAA;EACA,UAAA;AlD+oLF;AkD7oLE;EAAS,Y7Ci1ByB;AL+zJpC;AkD9oLE;EACE,kBAAA;EACA,cAAA;EACA,a7Ci1BgC;E6Ch1BhC,c7Ci1BgC;AL+zJpC;AkD9oLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlDgpLN;;AkD3oLA;EACE,iBAAA;AlD8oLF;AkD5oLE;EACE,SAAA;AlD8oLJ;AkD5oLI;EACE,MAAA;EACA,6BAAA;EACA,sB/CeK;AH+nLX;;AkDzoLA;EACE,iBAAA;AlD4oLF;AkD1oLE;EACE,OAAA;EACA,a7CmzBgC;E6ClzBhC,c7CizBgC;AL21JpC;AkD1oLI;EACE,QAAA;EACA,oCAAA;EACA,wB/CDK;AH6oLX;;AkDvoLA;EACE,iBAAA;AlD0oLF;AkDxoLE;EACE,MAAA;AlD0oLJ;AkDxoLI;EACE,SAAA;EACA,6BAAA;EACA,yB/CfK;AHypLX;;AkDroLA;EACE,iBAAA;AlDwoLF;AkDtoLE;EACE,QAAA;EACA,a7CqxBgC;E6CpxBhC,c7CmxBgC;ALq3JpC;AkDtoLI;EACE,OAAA;EACA,oCAAA;EACA,uB/C/BK;AHuqLX;;AkDnnLA;EACE,gB7C+uBkC;E6C9uBlC,uBAAA;EACA,W/CjES;E+CkET,kBAAA;EACA,sB/CzDS;EQrCP,uBAAA;AXqtLJ;;AoDvuLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C8qBkC;E+C7qBlC,cAAA;EACA,gBjDu0BkC;EgD50BlC,kChD4VuB;EgD1VvB,kBAAA;EACA,gBhDmW4B;EgDlW5B,gBhDuW4B;EgDtW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,mBAAA;EgDxKJ,qBAAA;EACA,sBjDgCS;EiD/BT,4BAAA;EACA,qCAAA;EzCGE,wBAAA;ECFE,kDwCCJ;ApDovLF;AoDlvLE;EACE,kBAAA;EACA,cAAA;EACA,ajDs0BgC;EiDr0BhC,ejDs0BgC;EiDr0BhC,mBAAA;ApDovLJ;AoDlvLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDmvLN;;AoD9uLA;EACE,sBjDuzBkC;AH07JpC;AoD/uLE;EACE,4BAAA;ApDivLJ;AoD/uLI;EACE,SAAA;EACA,+BAAA;EACA,6BjDkzB8B;AH+7JpC;AoD9uLI;EACE,WjD4xB8B;EiD3xB9B,+BAAA;EACA,sBjDPK;AHuvLX;;AoD3uLA;EACE,oBjDmyBkC;AH28JpC;AoD5uLE;EACE,0BAAA;EACA,cjD+xBgC;EiD9xBhC,cjD6xBgC;EiD5xBhC,mBAAA;ApD8uLJ;AoD5uLI;EACE,OAAA;EACA,uCAAA;EACA,+BjD2xB8B;AHm9JpC;AoD3uLI;EACE,SjDqwB8B;EiDpwB9B,uCAAA;EACA,wBjD9BK;AH2wLX;;AoDxuLA;EACE,mBjD4wBkC;AH+9JpC;AoDzuLE;EACE,yBAAA;ApD2uLJ;AoDzuLI;EACE,MAAA;EACA,uCAAA;EACA,gCjDuwB8B;AHo+JpC;AoDxuLI;EACE,QjDivB8B;EiDhvB9B,uCAAA;EACA,yBjDlDK;AH4xLX;AoDruLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,ajDmvBgC;EiDlvBhC,qBAAA;EACA,WAAA;EACA,6BAAA;ApDuuLJ;;AoDnuLA;EACE,qBjD4uBkC;AH0/JpC;AoDpuLE;EACE,2BAAA;EACA,cjDwuBgC;EiDvuBhC,cjDsuBgC;EiDruBhC,mBAAA;ApDsuLJ;AoDpuLI;EACE,QAAA;EACA,uCAAA;EACA,8BjDouB8B;AHkgKpC;AoDnuLI;EACE,UjD8sB8B;EiD7sB9B,uCAAA;EACA,uBjDrFK;AH0zLX;;AoD/sLA;EACE,uBAAA;EACA,gBAAA;EhD0BI,eAAA;EgDxBJ,cjDvGS;EiDwGT,sBjDhHS;EiDiHT,gCAAA;EzCnIE,6CAAA;EACA,8CAAA;AXs1LJ;AoDjtLE;EACE,aAAA;ApDmtLJ;;AoD/sLA;EACE,uBAAA;EACA,cjDpHS;AHs0LX;;AqD72LA;EACE,kBAAA;ArDg3LF;;AqD72LA;EACE,mBAAA;ArDg3LF;;AqD72LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArDg3LF;AsDv4LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDy4LJ;;AqDj3LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EhClBI,sCgCmBJ;ArDo3LF;AqBn4LM;EgCQN;IhCPQ,gBAAA;ErBs4LN;AACF;;AqDt3LA;;;EAGE,cAAA;ArDy3LF;;AqDt3LA;;EAEE,2BAAA;ArDy3LF;;AqDt3LA;;EAEE,4BAAA;ArDy3LF;;AqDh3LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArDm3LJ;AqDh3LE;;;EAGE,UAAA;EACA,UAAA;ArDk3LJ;AqD/2LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;ArDi3LJ;AqB16LM;EgCqDJ;;IhCpDM,gBAAA;ErB86LN;AACF;;AqD92LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDs9BmC;EgDr9BnC,UAAA;EACA,WlDrDS;EkDsDT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDi9BmC;EgBviC/B,8BgCuFJ;ArDg3LF;AqBn8LM;EgCkEN;;IhCjEQ,gBAAA;ErBu8LN;AACF;AM78LE;;;E+C2FE,WlD9DO;EkD+DP,qBAAA;EACA,UAAA;EACA,YhD08BiC;AL66JrC;;AqDp3LA;EACE,OAAA;ArDu3LF;;AqDl3LA;EACE,QAAA;ArDq3LF;;AqD92LA;;EAEE,qBAAA;EACA,WhDm8BmC;EgDl8BnC,YhDk8BmC;EgDj8BnC,mCAAA;ArDi3LF;;AqD/2LA;EACE,yDAAA;ArDk3LF;;AqDh3LA;EACE,yDAAA;ArDm3LF;;AqD12LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDy5BmC;EgDx5BnC,gBhDw5BmC;EgDv5BnC,gBAAA;ArD42LF;AqD12LE;EACE,uBAAA;EACA,cAAA;EACA,WhDu5BiC;EgDt5BjC,WhDu5BiC;EgDt5BjC,iBhDw5BiC;EgDv5BjC,gBhDu5BiC;EgDt5BjC,mBAAA;EACA,eAAA;EACA,sBlD7HO;EkD8HP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EhC/JE,6BgCgKF;ArD22LJ;AqBvgMM;EgC6IJ;IhC5IM,gBAAA;ErB0gMN;AACF;AqD72LE;EACE,UAAA;ArD+2LJ;;AqDt2LA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WlDxJS;EkDyJT,kBAAA;ArDy2LF;;AuD7iMA;EAAqB,mCAAA;AvDijMrB;;AuDhjMA;EAAqB,8BAAA;AvDojMrB;;AuDnjMA;EAAqB,iCAAA;AvDujMrB;;AuDtjMA;EAAqB,iCAAA;AvD0jMrB;;AuDzjMA;EAAqB,sCAAA;AvD6jMrB;;AuD5jMA;EAAqB,mCAAA;AvDgkMrB;;AwDrkMI;EACI,oCAAA;EACA,yDAAA;AxDwkMR;;AM5jME;;;EkDPU,oCAAA;AxDykMZ;;AwDhlMI;EACI,oCAAA;EACA,yDAAA;AxDmlMR;;AMvkME;;;EkDPU,oCAAA;AxDolMZ;;AwD3lMI;EACI,oCAAA;EACA,yDAAA;AxD8lMR;;AMllME;;;EkDPU,oCAAA;AxD+lMZ;;AwDtmMI;EACI,oCAAA;EACA,yDAAA;AxDymMR;;AM7lME;;;EkDPU,oCAAA;AxD0mMZ;;AwDjnMI;EACI,oCAAA;EACA,yDAAA;AxDonMR;;AMxmME;;;EkDPU,oCAAA;AxDqnMZ;;AwD5nMI;EACI,oCAAA;EACA,yDAAA;AxD+nMR;;AMnnME;;;EkDPU,oCAAA;AxDgoMZ;;AwDvoMI;EACI,oCAAA;EACA,yDAAA;AxD0oMR;;AM9nME;;;EkDPU,oCAAA;AxD2oMZ;;AwDlpMI;EACI,oCAAA;EACA,yDAAA;AxDqpMR;;AMzoME;;;EkDPU,oCAAA;AxDspMZ;;AwD7pMI;EACI,oCAAA;EACA,yDAAA;AxDgqMR;;AMppME;;;EkDPU,oCAAA;AxDiqMZ;;AwDxqMI;EACI,iCAAA;EACA,yDAAA;AxD2qMR;;AM/pME;;;EkDPU,oCAAA;AxD4qMZ;;AwDnrMI;EACI,iCAAA;EACA,yDAAA;AxDsrMR;;AM1qME;;;EkDPU,oCAAA;AxDurMZ;;AwD9rMI;EACI,kCAAA;EACA,yDAAA;AxDisMR;;AMrrME;;;EkDPU,kCAAA;AxDksMZ;;AyD/rMA;EACE,iCAAA;AzDksMF;;AyD/rMA;EACE,wCAAA;AzDksMF;;A0D7sMA;EAAkB,oCAAA;A1DitMlB;;A0DhtMA;EAAkB,wCAAA;A1DotMlB;;A0DntMA;EAAkB,0CAAA;A1DutMlB;;A0DttMA;EAAkB,2CAAA;A1D0tMlB;;A0DztMA;EAAkB,yCAAA;A1D6tMlB;;A0D3tMA;EAAmB,oBAAA;A1D+tMnB;;A0D9tMA;EAAmB,wBAAA;A1DkuMnB;;A0DjuMA;EAAmB,0BAAA;A1DquMnB;;A0DpuMA;EAAmB,2BAAA;A1DwuMnB;;A0DvuMA;EAAmB,yBAAA;A1D2uMnB;;A0DxuME;EACE,gCAAA;A1D2uMJ;;A0D5uME;EACE,gCAAA;A1D+uMJ;;A0DhvME;EACE,gCAAA;A1DmvMJ;;A0DpvME;EACE,gCAAA;A1DuvMJ;;A0DxvME;EACE,gCAAA;A1D2vMJ;;A0D5vME;EACE,gCAAA;A1D+vMJ;;A0DhwME;EACE,gCAAA;A1DmwMJ;;A0DpwME;EACE,gCAAA;A1DuwMJ;;A0DxwME;EACE,gCAAA;A1D2wMJ;;A0D5wME;EACE,6BAAA;A1D+wMJ;;A0DhxME;EACE,6BAAA;A1DmxMJ;;A0DpxME;EACE,8BAAA;A1DuxMJ;;A0DnxMA;EACE,6BAAA;A1DsxMF;;A0D/wMA;EACE,iCAAA;A1DkxMF;;A0D/wMA;EACE,kCAAA;A1DkxMF;;A0D/wMA;EACE,2CAAA;EACA,4CAAA;A1DkxMF;;A0D/wMA;EACE,4CAAA;EACA,+CAAA;A1DkxMF;;A0D/wMA;EACE,+CAAA;EACA,8CAAA;A1DkxMF;;A0D/wMA;EACE,2CAAA;EACA,8CAAA;A1DkxMF;;A0D/wMA;EACE,mCAAA;A1DkxMF;;A0D/wMA;EACE,6BAAA;A1DkxMF;;A0D/wMA;EACE,+BAAA;A1DkxMF;;A0D/wMA;EACE,2BAAA;A1DkxMF;;AsD11ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD61MJ;;A2Dt1MM;EAAwB,wBAAA;A3D01M9B;;A2D11MM;EAAwB,0BAAA;A3D81M9B;;A2D91MM;EAAwB,gCAAA;A3Dk2M9B;;A2Dl2MM;EAAwB,yBAAA;A3Ds2M9B;;A2Dt2MM;EAAwB,yBAAA;A3D02M9B;;A2D12MM;EAAwB,6BAAA;A3D82M9B;;A2D92MM;EAAwB,8BAAA;A3Dk3M9B;;A2Dl3MM;EAAwB,wBAAA;A3Ds3M9B;;A2Dt3MM;EAAwB,+BAAA;A3D03M9B;;AgBz0MI;E2CjDE;IAAwB,wBAAA;E3D+3M5B;E2D/3MI;IAAwB,0BAAA;E3Dk4M5B;E2Dl4MI;IAAwB,gCAAA;E3Dq4M5B;E2Dr4MI;IAAwB,yBAAA;E3Dw4M5B;E2Dx4MI;IAAwB,yBAAA;E3D24M5B;E2D34MI;IAAwB,6BAAA;E3D84M5B;E2D94MI;IAAwB,8BAAA;E3Di5M5B;E2Dj5MI;IAAwB,wBAAA;E3Do5M5B;E2Dp5MI;IAAwB,+BAAA;E3Du5M5B;AACF;AgBv2MI;E2CjDE;IAAwB,wBAAA;E3D45M5B;E2D55MI;IAAwB,0BAAA;E3D+5M5B;E2D/5MI;IAAwB,gCAAA;E3Dk6M5B;E2Dl6MI;IAAwB,yBAAA;E3Dq6M5B;E2Dr6MI;IAAwB,yBAAA;E3Dw6M5B;E2Dx6MI;IAAwB,6BAAA;E3D26M5B;E2D36MI;IAAwB,8BAAA;E3D86M5B;E2D96MI;IAAwB,wBAAA;E3Di7M5B;E2Dj7MI;IAAwB,+BAAA;E3Do7M5B;AACF;AgBp4MI;E2CjDE;IAAwB,wBAAA;E3Dy7M5B;E2Dz7MI;IAAwB,0BAAA;E3D47M5B;E2D57MI;IAAwB,gCAAA;E3D+7M5B;E2D/7MI;IAAwB,yBAAA;E3Dk8M5B;E2Dl8MI;IAAwB,yBAAA;E3Dq8M5B;E2Dr8MI;IAAwB,6BAAA;E3Dw8M5B;E2Dx8MI;IAAwB,8BAAA;E3D28M5B;E2D38MI;IAAwB,wBAAA;E3D88M5B;E2D98MI;IAAwB,+BAAA;E3Di9M5B;AACF;AgBj6MI;E2CjDE;IAAwB,wBAAA;E3Ds9M5B;E2Dt9MI;IAAwB,0BAAA;E3Dy9M5B;E2Dz9MI;IAAwB,gCAAA;E3D49M5B;E2D59MI;IAAwB,yBAAA;E3D+9M5B;E2D/9MI;IAAwB,yBAAA;E3Dk+M5B;E2Dl+MI;IAAwB,6BAAA;E3Dq+M5B;E2Dr+MI;IAAwB,8BAAA;E3Dw+M5B;E2Dx+MI;IAAwB,wBAAA;E3D2+M5B;E2D3+MI;IAAwB,+BAAA;E3D8+M5B;AACF;A2Dr+MA;EAEI;IAAqB,wBAAA;E3Du+MvB;E2Dv+ME;IAAqB,0BAAA;E3D0+MvB;E2D1+ME;IAAqB,gCAAA;E3D6+MvB;E2D7+ME;IAAqB,yBAAA;E3Dg/MvB;E2Dh/ME;IAAqB,yBAAA;E3Dm/MvB;E2Dn/ME;IAAqB,6BAAA;E3Ds/MvB;E2Dt/ME;IAAqB,8BAAA;E3Dy/MvB;E2Dz/ME;IAAqB,wBAAA;E3D4/MvB;E2D5/ME;IAAqB,+BAAA;E3D+/MvB;AACF;A4DrhNA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A5DuhNF;A4DrhNE;EACE,cAAA;EACA,WAAA;A5DuhNJ;A4DphNE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A5DshNJ;;A4D7gNI;EACE,yBAAA;A5DghNN;;A4DjhNI;EACE,mBAAA;A5DohNN;;A4DrhNI;EACE,gBAAA;A5DwhNN;;A4DzhNI;EACE,iBAAA;A5D4hNN;;A6DrjNI;EAAgC,8BAAA;A7DyjNpC;;A6DxjNI;EAAgC,iCAAA;A7D4jNpC;;A6D3jNI;EAAgC,sCAAA;A7D+jNpC;;A6D9jNI;EAAgC,yCAAA;A7DkkNpC;;A6DhkNI;EAA8B,0BAAA;A7DokNlC;;A6DnkNI;EAA8B,4BAAA;A7DukNlC;;A6DtkNI;EAA8B,kCAAA;A7D0kNlC;;A6DzkNI;EAA8B,yBAAA;A7D6kNlC;;A6D5kNI;EAA8B,uBAAA;A7DglNlC;;A6D/kNI;EAA8B,uBAAA;A7DmlNlC;;A6DllNI;EAA8B,yBAAA;A7DslNlC;;A6DrlNI;EAA8B,yBAAA;A7DylNlC;;A6DvlNI;EAAoC,sCAAA;A7D2lNxC;;A6D1lNI;EAAoC,oCAAA;A7D8lNxC;;A6D7lNI;EAAoC,kCAAA;A7DimNxC;;A6DhmNI;EAAoC,yCAAA;A7DomNxC;;A6DnmNI;EAAoC,wCAAA;A7DumNxC;;A6DrmNI;EAAiC,kCAAA;A7DymNrC;;A6DxmNI;EAAiC,gCAAA;A7D4mNrC;;A6D3mNI;EAAiC,8BAAA;A7D+mNrC;;A6D9mNI;EAAiC,gCAAA;A7DknNrC;;A6DjnNI;EAAiC,+BAAA;A7DqnNrC;;A6DnnNI;EAAkC,oCAAA;A7DunNtC;;A6DtnNI;EAAkC,kCAAA;A7D0nNtC;;A6DznNI;EAAkC,gCAAA;A7D6nNtC;;A6D5nNI;EAAkC,uCAAA;A7DgoNtC;;A6D/nNI;EAAkC,sCAAA;A7DmoNtC;;A6DloNI;EAAkC,iCAAA;A7DsoNtC;;A6DpoNI;EAAgC,2BAAA;A7DwoNpC;;A6DvoNI;EAAgC,iCAAA;A7D2oNpC;;A6D1oNI;EAAgC,+BAAA;A7D8oNpC;;A6D7oNI;EAAgC,6BAAA;A7DipNpC;;A6DhpNI;EAAgC,+BAAA;A7DopNpC;;A6DnpNI;EAAgC,8BAAA;A7DupNpC;;AgB3oNI;E6ClDA;IAAgC,8BAAA;E7DksNlC;E6DjsNE;IAAgC,iCAAA;E7DosNlC;E6DnsNE;IAAgC,sCAAA;E7DssNlC;E6DrsNE;IAAgC,yCAAA;E7DwsNlC;E6DtsNE;IAA8B,0BAAA;E7DysNhC;E6DxsNE;IAA8B,4BAAA;E7D2sNhC;E6D1sNE;IAA8B,kCAAA;E7D6sNhC;E6D5sNE;IAA8B,yBAAA;E7D+sNhC;E6D9sNE;IAA8B,uBAAA;E7DitNhC;E6DhtNE;IAA8B,uBAAA;E7DmtNhC;E6DltNE;IAA8B,yBAAA;E7DqtNhC;E6DptNE;IAA8B,yBAAA;E7DutNhC;E6DrtNE;IAAoC,sCAAA;E7DwtNtC;E6DvtNE;IAAoC,oCAAA;E7D0tNtC;E6DztNE;IAAoC,kCAAA;E7D4tNtC;E6D3tNE;IAAoC,yCAAA;E7D8tNtC;E6D7tNE;IAAoC,wCAAA;E7DguNtC;E6D9tNE;IAAiC,kCAAA;E7DiuNnC;E6DhuNE;IAAiC,gCAAA;E7DmuNnC;E6DluNE;IAAiC,8BAAA;E7DquNnC;E6DpuNE;IAAiC,gCAAA;E7DuuNnC;E6DtuNE;IAAiC,+BAAA;E7DyuNnC;E6DvuNE;IAAkC,oCAAA;E7D0uNpC;E6DzuNE;IAAkC,kCAAA;E7D4uNpC;E6D3uNE;IAAkC,gCAAA;E7D8uNpC;E6D7uNE;IAAkC,uCAAA;E7DgvNpC;E6D/uNE;IAAkC,sCAAA;E7DkvNpC;E6DjvNE;IAAkC,iCAAA;E7DovNpC;E6DlvNE;IAAgC,2BAAA;E7DqvNlC;E6DpvNE;IAAgC,iCAAA;E7DuvNlC;E6DtvNE;IAAgC,+BAAA;E7DyvNlC;E6DxvNE;IAAgC,6BAAA;E7D2vNlC;E6D1vNE;IAAgC,+BAAA;E7D6vNlC;E6D5vNE;IAAgC,8BAAA;E7D+vNlC;AACF;AgBpvNI;E6ClDA;IAAgC,8BAAA;E7D0yNlC;E6DzyNE;IAAgC,iCAAA;E7D4yNlC;E6D3yNE;IAAgC,sCAAA;E7D8yNlC;E6D7yNE;IAAgC,yCAAA;E7DgzNlC;E6D9yNE;IAA8B,0BAAA;E7DizNhC;E6DhzNE;IAA8B,4BAAA;E7DmzNhC;E6DlzNE;IAA8B,kCAAA;E7DqzNhC;E6DpzNE;IAA8B,yBAAA;E7DuzNhC;E6DtzNE;IAA8B,uBAAA;E7DyzNhC;E6DxzNE;IAA8B,uBAAA;E7D2zNhC;E6D1zNE;IAA8B,yBAAA;E7D6zNhC;E6D5zNE;IAA8B,yBAAA;E7D+zNhC;E6D7zNE;IAAoC,sCAAA;E7Dg0NtC;E6D/zNE;IAAoC,oCAAA;E7Dk0NtC;E6Dj0NE;IAAoC,kCAAA;E7Do0NtC;E6Dn0NE;IAAoC,yCAAA;E7Ds0NtC;E6Dr0NE;IAAoC,wCAAA;E7Dw0NtC;E6Dt0NE;IAAiC,kCAAA;E7Dy0NnC;E6Dx0NE;IAAiC,gCAAA;E7D20NnC;E6D10NE;IAAiC,8BAAA;E7D60NnC;E6D50NE;IAAiC,gCAAA;E7D+0NnC;E6D90NE;IAAiC,+BAAA;E7Di1NnC;E6D/0NE;IAAkC,oCAAA;E7Dk1NpC;E6Dj1NE;IAAkC,kCAAA;E7Do1NpC;E6Dn1NE;IAAkC,gCAAA;E7Ds1NpC;E6Dr1NE;IAAkC,uCAAA;E7Dw1NpC;E6Dv1NE;IAAkC,sCAAA;E7D01NpC;E6Dz1NE;IAAkC,iCAAA;E7D41NpC;E6D11NE;IAAgC,2BAAA;E7D61NlC;E6D51NE;IAAgC,iCAAA;E7D+1NlC;E6D91NE;IAAgC,+BAAA;E7Di2NlC;E6Dh2NE;IAAgC,6BAAA;E7Dm2NlC;E6Dl2NE;IAAgC,+BAAA;E7Dq2NlC;E6Dp2NE;IAAgC,8BAAA;E7Du2NlC;AACF;AgB51NI;E6ClDA;IAAgC,8BAAA;E7Dk5NlC;E6Dj5NE;IAAgC,iCAAA;E7Do5NlC;E6Dn5NE;IAAgC,sCAAA;E7Ds5NlC;E6Dr5NE;IAAgC,yCAAA;E7Dw5NlC;E6Dt5NE;IAA8B,0BAAA;E7Dy5NhC;E6Dx5NE;IAA8B,4BAAA;E7D25NhC;E6D15NE;IAA8B,kCAAA;E7D65NhC;E6D55NE;IAA8B,yBAAA;E7D+5NhC;E6D95NE;IAA8B,uBAAA;E7Di6NhC;E6Dh6NE;IAA8B,uBAAA;E7Dm6NhC;E6Dl6NE;IAA8B,yBAAA;E7Dq6NhC;E6Dp6NE;IAA8B,yBAAA;E7Du6NhC;E6Dr6NE;IAAoC,sCAAA;E7Dw6NtC;E6Dv6NE;IAAoC,oCAAA;E7D06NtC;E6Dz6NE;IAAoC,kCAAA;E7D46NtC;E6D36NE;IAAoC,yCAAA;E7D86NtC;E6D76NE;IAAoC,wCAAA;E7Dg7NtC;E6D96NE;IAAiC,kCAAA;E7Di7NnC;E6Dh7NE;IAAiC,gCAAA;E7Dm7NnC;E6Dl7NE;IAAiC,8BAAA;E7Dq7NnC;E6Dp7NE;IAAiC,gCAAA;E7Du7NnC;E6Dt7NE;IAAiC,+BAAA;E7Dy7NnC;E6Dv7NE;IAAkC,oCAAA;E7D07NpC;E6Dz7NE;IAAkC,kCAAA;E7D47NpC;E6D37NE;IAAkC,gCAAA;E7D87NpC;E6D77NE;IAAkC,uCAAA;E7Dg8NpC;E6D/7NE;IAAkC,sCAAA;E7Dk8NpC;E6Dj8NE;IAAkC,iCAAA;E7Do8NpC;E6Dl8NE;IAAgC,2BAAA;E7Dq8NlC;E6Dp8NE;IAAgC,iCAAA;E7Du8NlC;E6Dt8NE;IAAgC,+BAAA;E7Dy8NlC;E6Dx8NE;IAAgC,6BAAA;E7D28NlC;E6D18NE;IAAgC,+BAAA;E7D68NlC;E6D58NE;IAAgC,8BAAA;E7D+8NlC;AACF;AgBp8NI;E6ClDA;IAAgC,8BAAA;E7D0/NlC;E6Dz/NE;IAAgC,iCAAA;E7D4/NlC;E6D3/NE;IAAgC,sCAAA;E7D8/NlC;E6D7/NE;IAAgC,yCAAA;E7DggOlC;E6D9/NE;IAA8B,0BAAA;E7DigOhC;E6DhgOE;IAA8B,4BAAA;E7DmgOhC;E6DlgOE;IAA8B,kCAAA;E7DqgOhC;E6DpgOE;IAA8B,yBAAA;E7DugOhC;E6DtgOE;IAA8B,uBAAA;E7DygOhC;E6DxgOE;IAA8B,uBAAA;E7D2gOhC;E6D1gOE;IAA8B,yBAAA;E7D6gOhC;E6D5gOE;IAA8B,yBAAA;E7D+gOhC;E6D7gOE;IAAoC,sCAAA;E7DghOtC;E6D/gOE;IAAoC,oCAAA;E7DkhOtC;E6DjhOE;IAAoC,kCAAA;E7DohOtC;E6DnhOE;IAAoC,yCAAA;E7DshOtC;E6DrhOE;IAAoC,wCAAA;E7DwhOtC;E6DthOE;IAAiC,kCAAA;E7DyhOnC;E6DxhOE;IAAiC,gCAAA;E7D2hOnC;E6D1hOE;IAAiC,8BAAA;E7D6hOnC;E6D5hOE;IAAiC,gCAAA;E7D+hOnC;E6D9hOE;IAAiC,+BAAA;E7DiiOnC;E6D/hOE;IAAkC,oCAAA;E7DkiOpC;E6DjiOE;IAAkC,kCAAA;E7DoiOpC;E6DniOE;IAAkC,gCAAA;E7DsiOpC;E6DriOE;IAAkC,uCAAA;E7DwiOpC;E6DviOE;IAAkC,sCAAA;E7D0iOpC;E6DziOE;IAAkC,iCAAA;E7D4iOpC;E6D1iOE;IAAgC,2BAAA;E7D6iOlC;E6D5iOE;IAAgC,iCAAA;E7D+iOlC;E6D9iOE;IAAgC,+BAAA;E7DijOlC;E6DhjOE;IAAgC,6BAAA;E7DmjOlC;E6DljOE;IAAgC,+BAAA;E7DqjOlC;E6DpjOE;IAAgC,8BAAA;E7DujOlC;AACF;A8DlmOI;EAAwB,sBAAA;A9DqmO5B;;A8DpmOI;EAAwB,uBAAA;A9DwmO5B;;A8DvmOI;EAAwB,sBAAA;A9D2mO5B;;AgBvjOI;E8CtDA;IAAwB,sBAAA;E9DknO1B;E8DjnOE;IAAwB,uBAAA;E9DonO1B;E8DnnOE;IAAwB,sBAAA;E9DsnO1B;AACF;AgBnkOI;E8CtDA;IAAwB,sBAAA;E9D6nO1B;E8D5nOE;IAAwB,uBAAA;E9D+nO1B;E8D9nOE;IAAwB,sBAAA;E9DioO1B;AACF;AgB9kOI;E8CtDA;IAAwB,sBAAA;E9DwoO1B;E8DvoOE;IAAwB,uBAAA;E9D0oO1B;E8DzoOE;IAAwB,sBAAA;E9D4oO1B;AACF;AgBzlOI;E8CtDA;IAAwB,sBAAA;E9DmpO1B;E8DlpOE;IAAwB,uBAAA;E9DqpO1B;E8DppOE;IAAwB,sBAAA;E9DupO1B;AACF;A+D7pOE;EAAyB,mCAAA;UAAA,2BAAA;A/DgqO3B;;A+DhqOE;EAAyB,oCAAA;UAAA,4BAAA;A/DoqO3B;;A+DpqOE;EAAyB,oCAAA;UAAA,4BAAA;A/DwqO3B;;AgExqOE;EAAsB,yBAAA;AhE4qOxB;;AgE5qOE;EAAsB,2BAAA;AhEgrOxB;;AiE/qOE;EAAyB,2BAAA;AjEmrO3B;;AiEnrOE;EAAyB,6BAAA;AjEurO3B;;AiEvrOE;EAAyB,6BAAA;AjE2rO3B;;AiE3rOE;EAAyB,0BAAA;AjE+rO3B;;AiE/rOE;EAAyB,mCAAA;EAAA,2BAAA;AjEmsO3B;;AiE9rOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a5DiqBkC;ALgiNpC;;AiE9rOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5DypBkC;ALwiNpC;;AiE7rOE;EADF;IAEI,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a5DipBgC;ELgjNlC;AACF;;AkE3tOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnE6tOF;;AmEntOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AnEqtOJ;;AoElvOA;EAAa,4DAAA;ApEsvOb;;AoErvOA;EAAU,2DAAA;ApEyvOV;;AoExvOA;EAAa,0DAAA;ApE4vOb;;AoE3vOA;EAAe,2BAAA;ApE+vOf;;AqE9vOI;EAAuB,qBAAA;ArEkwO3B;;AqElwOI;EAAuB,qBAAA;ArEswO3B;;AqEtwOI;EAAuB,qBAAA;ArE0wO3B;;AqE1wOI;EAAuB,sBAAA;ArE8wO3B;;AqE9wOI;EAAuB,sBAAA;ArEkxO3B;;AqElxOI;EAAuB,sBAAA;ArEsxO3B;;AqEtxOI;EAAuB,sBAAA;ArE0xO3B;;AqE1xOI;EAAuB,sBAAA;ArE8xO3B;;AqE9xOI;EAAuB,uBAAA;ArEkyO3B;;AqElyOI;EAAuB,uBAAA;ArEsyO3B;;AqElyOA;EAAU,0BAAA;ArEsyOV;;AqEryOA;EAAU,2BAAA;ArEyyOV;;AqEryOA;EAAc,2BAAA;ArEyyOd;;AqExyOA;EAAc,4BAAA;ArE4yOd;;AqE1yOA;EAAU,uBAAA;ArE8yOV;;AqE7yOA;EAAU,wBAAA;ArEizOV;;AsE1zOQ;EAAgC,oBAAA;AtE8zOxC;;AsE7zOQ;;EAEE,wBAAA;AtEg0OV;;AsE9zOQ;;EAEE,0BAAA;AtEi0OV;;AsE/zOQ;;EAEE,2BAAA;AtEk0OV;;AsEh0OQ;;EAEE,yBAAA;AtEm0OV;;AsEl1OQ;EAAgC,0BAAA;AtEs1OxC;;AsEr1OQ;;EAEE,8BAAA;AtEw1OV;;AsEt1OQ;;EAEE,gCAAA;AtEy1OV;;AsEv1OQ;;EAEE,iCAAA;AtE01OV;;AsEx1OQ;;EAEE,+BAAA;AtE21OV;;AsE12OQ;EAAgC,yBAAA;AtE82OxC;;AsE72OQ;;EAEE,6BAAA;AtEg3OV;;AsE92OQ;;EAEE,+BAAA;AtEi3OV;;AsE/2OQ;;EAEE,gCAAA;AtEk3OV;;AsEh3OQ;;EAEE,8BAAA;AtEm3OV;;AsEl4OQ;EAAgC,uBAAA;AtEs4OxC;;AsEr4OQ;;EAEE,2BAAA;AtEw4OV;;AsEt4OQ;;EAEE,6BAAA;AtEy4OV;;AsEv4OQ;;EAEE,8BAAA;AtE04OV;;AsEx4OQ;;EAEE,4BAAA;AtE24OV;;AsE15OQ;EAAgC,yBAAA;AtE85OxC;;AsE75OQ;;EAEE,6BAAA;AtEg6OV;;AsE95OQ;;EAEE,+BAAA;AtEi6OV;;AsE/5OQ;;EAEE,gCAAA;AtEk6OV;;AsEh6OQ;;EAEE,8BAAA;AtEm6OV;;AsEl7OQ;EAAgC,uBAAA;AtEs7OxC;;AsEr7OQ;;EAEE,2BAAA;AtEw7OV;;AsEt7OQ;;EAEE,6BAAA;AtEy7OV;;AsEv7OQ;;EAEE,8BAAA;AtE07OV;;AsEx7OQ;;EAEE,4BAAA;AtE27OV;;AsE18OQ;EAAgC,yBAAA;AtE88OxC;;AsE78OQ;;EAEE,6BAAA;AtEg9OV;;AsE98OQ;;EAEE,+BAAA;AtEi9OV;;AsE/8OQ;;EAEE,gCAAA;AtEk9OV;;AsEh9OQ;;EAEE,8BAAA;AtEm9OV;;AsEl+OQ;EAAgC,wBAAA;AtEs+OxC;;AsEr+OQ;;EAEE,4BAAA;AtEw+OV;;AsEt+OQ;;EAEE,8BAAA;AtEy+OV;;AsEv+OQ;;EAEE,+BAAA;AtE0+OV;;AsEx+OQ;;EAEE,6BAAA;AtE2+OV;;AsE1/OQ;EAAgC,wBAAA;AtE8/OxC;;AsE7/OQ;;EAEE,4BAAA;AtEggPV;;AsE9/OQ;;EAEE,8BAAA;AtEigPV;;AsE//OQ;;EAEE,+BAAA;AtEkgPV;;AsEhgPQ;;EAEE,6BAAA;AtEmgPV;;AsElhPQ;EAAgC,0BAAA;AtEshPxC;;AsErhPQ;;EAEE,8BAAA;AtEwhPV;;AsEthPQ;;EAEE,gCAAA;AtEyhPV;;AsEvhPQ;;EAEE,iCAAA;AtE0hPV;;AsExhPQ;;EAEE,+BAAA;AtE2hPV;;AsE1iPQ;EAAgC,wBAAA;AtE8iPxC;;AsE7iPQ;;EAEE,4BAAA;AtEgjPV;;AsE9iPQ;;EAEE,8BAAA;AtEijPV;;AsE/iPQ;;EAEE,+BAAA;AtEkjPV;;AsEhjPQ;;EAEE,6BAAA;AtEmjPV;;AsElkPQ;EAAgC,0BAAA;AtEskPxC;;AsErkPQ;;EAEE,8BAAA;AtEwkPV;;AsEtkPQ;;EAEE,gCAAA;AtEykPV;;AsEvkPQ;;EAEE,iCAAA;AtE0kPV;;AsExkPQ;;EAEE,+BAAA;AtE2kPV;;AsE1lPQ;EAAgC,wBAAA;AtE8lPxC;;AsE7lPQ;;EAEE,4BAAA;AtEgmPV;;AsE9lPQ;;EAEE,8BAAA;AtEimPV;;AsE/lPQ;;EAEE,+BAAA;AtEkmPV;;AsEhmPQ;;EAEE,6BAAA;AtEmmPV;;AsElnPQ;EAAgC,0BAAA;AtEsnPxC;;AsErnPQ;;EAEE,8BAAA;AtEwnPV;;AsEtnPQ;;EAEE,gCAAA;AtEynPV;;AsEvnPQ;;EAEE,iCAAA;AtE0nPV;;AsExnPQ;;EAEE,+BAAA;AtE2nPV;;AsE1oPQ;EAAgC,2BAAA;AtE8oPxC;;AsE7oPQ;;EAEE,+BAAA;AtEgpPV;;AsE9oPQ;;EAEE,iCAAA;AtEipPV;;AsE/oPQ;;EAEE,kCAAA;AtEkpPV;;AsEhpPQ;;EAEE,gCAAA;AtEmpPV;;AsElqPQ;EAAgC,yBAAA;AtEsqPxC;;AsErqPQ;;EAEE,6BAAA;AtEwqPV;;AsEtqPQ;;EAEE,+BAAA;AtEyqPV;;AsEvqPQ;;EAEE,gCAAA;AtE0qPV;;AsExqPQ;;EAEE,8BAAA;AtE2qPV;;AsE1rPQ;EAAgC,uBAAA;AtE8rPxC;;AsE7rPQ;;EAEE,2BAAA;AtEgsPV;;AsE9rPQ;;EAEE,6BAAA;AtEisPV;;AsE/rPQ;;EAEE,8BAAA;AtEksPV;;AsEhsPQ;;EAEE,4BAAA;AtEmsPV;;AsEltPQ;EAAgC,uBAAA;AtEstPxC;;AsErtPQ;;EAEE,2BAAA;AtEwtPV;;AsEttPQ;;EAEE,6BAAA;AtEytPV;;AsEvtPQ;;EAEE,8BAAA;AtE0tPV;;AsExtPQ;;EAEE,4BAAA;AtE2tPV;;AsE1uPQ;EAAgC,wBAAA;AtE8uPxC;;AsE7uPQ;;EAEE,4BAAA;AtEgvPV;;AsE9uPQ;;EAEE,8BAAA;AtEivPV;;AsE/uPQ;;EAEE,+BAAA;AtEkvPV;;AsEhvPQ;;EAEE,6BAAA;AtEmvPV;;AsElwPQ;EAAgC,qBAAA;AtEswPxC;;AsErwPQ;;EAEE,yBAAA;AtEwwPV;;AsEtwPQ;;EAEE,2BAAA;AtEywPV;;AsEvwPQ;;EAEE,4BAAA;AtE0wPV;;AsExwPQ;;EAEE,0BAAA;AtE2wPV;;AsE1xPQ;EAAgC,2BAAA;AtE8xPxC;;AsE7xPQ;;EAEE,+BAAA;AtEgyPV;;AsE9xPQ;;EAEE,iCAAA;AtEiyPV;;AsE/xPQ;;EAEE,kCAAA;AtEkyPV;;AsEhyPQ;;EAEE,gCAAA;AtEmyPV;;AsElzPQ;EAAgC,0BAAA;AtEszPxC;;AsErzPQ;;EAEE,8BAAA;AtEwzPV;;AsEtzPQ;;EAEE,gCAAA;AtEyzPV;;AsEvzPQ;;EAEE,iCAAA;AtE0zPV;;AsExzPQ;;EAEE,+BAAA;AtE2zPV;;AsE10PQ;EAAgC,wBAAA;AtE80PxC;;AsE70PQ;;EAEE,4BAAA;AtEg1PV;;AsE90PQ;;EAEE,8BAAA;AtEi1PV;;AsE/0PQ;;EAEE,+BAAA;AtEk1PV;;AsEh1PQ;;EAEE,6BAAA;AtEm1PV;;AsEl2PQ;EAAgC,0BAAA;AtEs2PxC;;AsEr2PQ;;EAEE,8BAAA;AtEw2PV;;AsEt2PQ;;EAEE,gCAAA;AtEy2PV;;AsEv2PQ;;EAEE,iCAAA;AtE02PV;;AsEx2PQ;;EAEE,+BAAA;AtE22PV;;AsE13PQ;EAAgC,wBAAA;AtE83PxC;;AsE73PQ;;EAEE,4BAAA;AtEg4PV;;AsE93PQ;;EAEE,8BAAA;AtEi4PV;;AsE/3PQ;;EAEE,+BAAA;AtEk4PV;;AsEh4PQ;;EAEE,6BAAA;AtEm4PV;;AsEl5PQ;EAAgC,0BAAA;AtEs5PxC;;AsEr5PQ;;EAEE,8BAAA;AtEw5PV;;AsEt5PQ;;EAEE,gCAAA;AtEy5PV;;AsEv5PQ;;EAEE,iCAAA;AtE05PV;;AsEx5PQ;;EAEE,+BAAA;AtE25PV;;AsE16PQ;EAAgC,yBAAA;AtE86PxC;;AsE76PQ;;EAEE,6BAAA;AtEg7PV;;AsE96PQ;;EAEE,+BAAA;AtEi7PV;;AsE/6PQ;;EAEE,gCAAA;AtEk7PV;;AsEh7PQ;;EAEE,8BAAA;AtEm7PV;;AsEl8PQ;EAAgC,yBAAA;AtEs8PxC;;AsEr8PQ;;EAEE,6BAAA;AtEw8PV;;AsEt8PQ;;EAEE,+BAAA;AtEy8PV;;AsEv8PQ;;EAEE,gCAAA;AtE08PV;;AsEx8PQ;;EAEE,8BAAA;AtE28PV;;AsE19PQ;EAAgC,2BAAA;AtE89PxC;;AsE79PQ;;EAEE,+BAAA;AtEg+PV;;AsE99PQ;;EAEE,iCAAA;AtEi+PV;;AsE/9PQ;;EAEE,kCAAA;AtEk+PV;;AsEh+PQ;;EAEE,gCAAA;AtEm+PV;;AsEl/PQ;EAAgC,yBAAA;AtEs/PxC;;AsEr/PQ;;EAEE,6BAAA;AtEw/PV;;AsEt/PQ;;EAEE,+BAAA;AtEy/PV;;AsEv/PQ;;EAEE,gCAAA;AtE0/PV;;AsEx/PQ;;EAEE,8BAAA;AtE2/PV;;AsE1gQQ;EAAgC,2BAAA;AtE8gQxC;;AsE7gQQ;;EAEE,+BAAA;AtEghQV;;AsE9gQQ;;EAEE,iCAAA;AtEihQV;;AsE/gQQ;;EAEE,kCAAA;AtEkhQV;;AsEhhQQ;;EAEE,gCAAA;AtEmhQV;;AsEliQQ;EAAgC,yBAAA;AtEsiQxC;;AsEriQQ;;EAEE,6BAAA;AtEwiQV;;AsEtiQQ;;EAEE,+BAAA;AtEyiQV;;AsEviQQ;;EAEE,gCAAA;AtE0iQV;;AsExiQQ;;EAEE,8BAAA;AtE2iQV;;AsE1jQQ;EAAgC,2BAAA;AtE8jQxC;;AsE7jQQ;;EAEE,+BAAA;AtEgkQV;;AsE9jQQ;;EAEE,iCAAA;AtEikQV;;AsE/jQQ;;EAEE,kCAAA;AtEkkQV;;AsEhkQQ;;EAEE,gCAAA;AtEmkQV;;AsEllQQ;EAAgC,4BAAA;AtEslQxC;;AsErlQQ;;EAEE,gCAAA;AtEwlQV;;AsEtlQQ;;EAEE,kCAAA;AtEylQV;;AsEvlQQ;;EAEE,mCAAA;AtE0lQV;;AsExlQQ;;EAEE,iCAAA;AtE2lQV;;AsE1mQQ;EAAgC,0BAAA;AtE8mQxC;;AsE7mQQ;;EAEE,8BAAA;AtEgnQV;;AsE9mQQ;;EAEE,gCAAA;AtEinQV;;AsE/mQQ;;EAEE,iCAAA;AtEknQV;;AsEhnQQ;;EAEE,+BAAA;AtEmnQV;;AsEloQQ;EAAgC,wBAAA;AtEsoQxC;;AsEroQQ;;EAEE,4BAAA;AtEwoQV;;AsEtoQQ;;EAEE,8BAAA;AtEyoQV;;AsEvoQQ;;EAEE,+BAAA;AtE0oQV;;AsExoQQ;;EAEE,6BAAA;AtE2oQV;;AsE1pQQ;EAAgC,wBAAA;AtE8pQxC;;AsE7pQQ;;EAEE,4BAAA;AtEgqQV;;AsE9pQQ;;EAEE,8BAAA;AtEiqQV;;AsE/pQQ;;EAEE,+BAAA;AtEkqQV;;AsEhqQQ;;EAEE,6BAAA;AtEmqQV;;AsElrQQ;EAAgC,yBAAA;AtEsrQxC;;AsErrQQ;;EAEE,6BAAA;AtEwrQV;;AsEtrQQ;;EAEE,+BAAA;AtEyrQV;;AsEvrQQ;;EAEE,gCAAA;AtE0rQV;;AsExrQQ;;EAEE,8BAAA;AtE2rQV;;AsEnrQQ;EAAwB,2BAAA;AtEurQhC;;AsEtrQQ;;EAEE,+BAAA;AtEyrQV;;AsEvrQQ;;EAEE,iCAAA;AtE0rQV;;AsExrQQ;;EAEE,kCAAA;AtE2rQV;;AsEzrQQ;;EAEE,gCAAA;AtE4rQV;;AsE3sQQ;EAAwB,0BAAA;AtE+sQhC;;AsE9sQQ;;EAEE,8BAAA;AtEitQV;;AsE/sQQ;;EAEE,gCAAA;AtEktQV;;AsEhtQQ;;EAEE,iCAAA;AtEmtQV;;AsEjtQQ;;EAEE,+BAAA;AtEotQV;;AsEnuQQ;EAAwB,wBAAA;AtEuuQhC;;AsEtuQQ;;EAEE,4BAAA;AtEyuQV;;AsEvuQQ;;EAEE,8BAAA;AtE0uQV;;AsExuQQ;;EAEE,+BAAA;AtE2uQV;;AsEzuQQ;;EAEE,6BAAA;AtE4uQV;;AsE3vQQ;EAAwB,0BAAA;AtE+vQhC;;AsE9vQQ;;EAEE,8BAAA;AtEiwQV;;AsE/vQQ;;EAEE,gCAAA;AtEkwQV;;AsEhwQQ;;EAEE,iCAAA;AtEmwQV;;AsEjwQQ;;EAEE,+BAAA;AtEowQV;;AsEnxQQ;EAAwB,wBAAA;AtEuxQhC;;AsEtxQQ;;EAEE,4BAAA;AtEyxQV;;AsEvxQQ;;EAEE,8BAAA;AtE0xQV;;AsExxQQ;;EAEE,+BAAA;AtE2xQV;;AsEzxQQ;;EAEE,6BAAA;AtE4xQV;;AsE3yQQ;EAAwB,wBAAA;AtE+yQhC;;AsE9yQQ;;EAEE,4BAAA;AtEizQV;;AsE/yQQ;;EAEE,8BAAA;AtEkzQV;;AsEhzQQ;;EAEE,+BAAA;AtEmzQV;;AsEjzQQ;;EAEE,6BAAA;AtEozQV;;AsEn0QQ;EAAwB,uBAAA;AtEu0QhC;;AsEt0QQ;;EAEE,2BAAA;AtEy0QV;;AsEv0QQ;;EAEE,6BAAA;AtE00QV;;AsEx0QQ;;EAEE,8BAAA;AtE20QV;;AsEz0QQ;;EAEE,4BAAA;AtE40QV;;AsE31QQ;EAAwB,uBAAA;AtE+1QhC;;AsE91QQ;;EAEE,2BAAA;AtEi2QV;;AsE/1QQ;;EAEE,6BAAA;AtEk2QV;;AsEh2QQ;;EAEE,8BAAA;AtEm2QV;;AsEj2QQ;;EAEE,4BAAA;AtEo2QV;;AsEn3QQ;EAAwB,yBAAA;AtEu3QhC;;AsEt3QQ;;EAEE,6BAAA;AtEy3QV;;AsEv3QQ;;EAEE,+BAAA;AtE03QV;;AsEx3QQ;;EAEE,gCAAA;AtE23QV;;AsEz3QQ;;EAEE,8BAAA;AtE43QV;;AsE34QQ;EAAwB,uBAAA;AtE+4QhC;;AsE94QQ;;EAEE,2BAAA;AtEi5QV;;AsE/4QQ;;EAEE,6BAAA;AtEk5QV;;AsEh5QQ;;EAEE,8BAAA;AtEm5QV;;AsEj5QQ;;EAEE,4BAAA;AtEo5QV;;AsEn6QQ;EAAwB,yBAAA;AtEu6QhC;;AsEt6QQ;;EAEE,6BAAA;AtEy6QV;;AsEv6QQ;;EAEE,+BAAA;AtE06QV;;AsEx6QQ;;EAEE,gCAAA;AtE26QV;;AsEz6QQ;;EAEE,8BAAA;AtE46QV;;AsE37QQ;EAAwB,uBAAA;AtE+7QhC;;AsE97QQ;;EAEE,2BAAA;AtEi8QV;;AsE/7QQ;;EAEE,6BAAA;AtEk8QV;;AsEh8QQ;;EAEE,8BAAA;AtEm8QV;;AsEj8QQ;;EAEE,4BAAA;AtEo8QV;;AsEn9QQ;EAAwB,yBAAA;AtEu9QhC;;AsEt9QQ;;EAEE,6BAAA;AtEy9QV;;AsEv9QQ;;EAEE,+BAAA;AtE09QV;;AsEx9QQ;;EAEE,gCAAA;AtE29QV;;AsEz9QQ;;EAEE,8BAAA;AtE49QV;;AsE3+QQ;EAAwB,0BAAA;AtE++QhC;;AsE9+QQ;;EAEE,8BAAA;AtEi/QV;;AsE/+QQ;;EAEE,gCAAA;AtEk/QV;;AsEh/QQ;;EAEE,iCAAA;AtEm/QV;;AsEj/QQ;;EAEE,+BAAA;AtEo/QV;;AsEngRQ;EAAwB,0BAAA;AtEugRhC;;AsEtgRQ;;EAEE,8BAAA;AtEygRV;;AsEvgRQ;;EAEE,gCAAA;AtE0gRV;;AsExgRQ;;EAEE,iCAAA;AtE2gRV;;AsEzgRQ;;EAEE,+BAAA;AtE4gRV;;AsE3hRQ;EAAwB,wBAAA;AtE+hRhC;;AsE9hRQ;;EAEE,4BAAA;AtEiiRV;;AsE/hRQ;;EAEE,8BAAA;AtEkiRV;;AsEhiRQ;;EAEE,+BAAA;AtEmiRV;;AsEjiRQ;;EAEE,6BAAA;AtEoiRV;;AsEnjRQ;EAAwB,wBAAA;AtEujRhC;;AsEtjRQ;;EAEE,4BAAA;AtEyjRV;;AsEvjRQ;;EAEE,8BAAA;AtE0jRV;;AsExjRQ;;EAEE,+BAAA;AtE2jRV;;AsEzjRQ;;EAEE,6BAAA;AtE4jRV;;AsE3kRQ;EAAwB,yBAAA;AtE+kRhC;;AsE9kRQ;;EAEE,6BAAA;AtEilRV;;AsE/kRQ;;EAEE,+BAAA;AtEklRV;;AsEhlRQ;;EAEE,gCAAA;AtEmlRV;;AsEjlRQ;;EAEE,8BAAA;AtEolRV;;AsE9kRI;EAAmB,uBAAA;AtEklRvB;;AsEjlRI;;EAEE,2BAAA;AtEolRN;;AsEllRI;;EAEE,6BAAA;AtEqlRN;;AsEnlRI;;EAEE,8BAAA;AtEslRN;;AsEplRI;;EAEE,4BAAA;AtEulRN;;AgBhmRI;EsDlDI;IAAgC,oBAAA;EtEupRtC;EsEtpRM;;IAEE,wBAAA;EtEwpRR;EsEtpRM;;IAEE,0BAAA;EtEwpRR;EsEtpRM;;IAEE,2BAAA;EtEwpRR;EsEtpRM;;IAEE,yBAAA;EtEwpRR;EsEvqRM;IAAgC,0BAAA;EtE0qRtC;EsEzqRM;;IAEE,8BAAA;EtE2qRR;EsEzqRM;;IAEE,gCAAA;EtE2qRR;EsEzqRM;;IAEE,iCAAA;EtE2qRR;EsEzqRM;;IAEE,+BAAA;EtE2qRR;EsE1rRM;IAAgC,yBAAA;EtE6rRtC;EsE5rRM;;IAEE,6BAAA;EtE8rRR;EsE5rRM;;IAEE,+BAAA;EtE8rRR;EsE5rRM;;IAEE,gCAAA;EtE8rRR;EsE5rRM;;IAEE,8BAAA;EtE8rRR;EsE7sRM;IAAgC,uBAAA;EtEgtRtC;EsE/sRM;;IAEE,2BAAA;EtEitRR;EsE/sRM;;IAEE,6BAAA;EtEitRR;EsE/sRM;;IAEE,8BAAA;EtEitRR;EsE/sRM;;IAEE,4BAAA;EtEitRR;EsEhuRM;IAAgC,yBAAA;EtEmuRtC;EsEluRM;;IAEE,6BAAA;EtEouRR;EsEluRM;;IAEE,+BAAA;EtEouRR;EsEluRM;;IAEE,gCAAA;EtEouRR;EsEluRM;;IAEE,8BAAA;EtEouRR;EsEnvRM;IAAgC,uBAAA;EtEsvRtC;EsErvRM;;IAEE,2BAAA;EtEuvRR;EsErvRM;;IAEE,6BAAA;EtEuvRR;EsErvRM;;IAEE,8BAAA;EtEuvRR;EsErvRM;;IAEE,4BAAA;EtEuvRR;EsEtwRM;IAAgC,yBAAA;EtEywRtC;EsExwRM;;IAEE,6BAAA;EtE0wRR;EsExwRM;;IAEE,+BAAA;EtE0wRR;EsExwRM;;IAEE,gCAAA;EtE0wRR;EsExwRM;;IAEE,8BAAA;EtE0wRR;EsEzxRM;IAAgC,wBAAA;EtE4xRtC;EsE3xRM;;IAEE,4BAAA;EtE6xRR;EsE3xRM;;IAEE,8BAAA;EtE6xRR;EsE3xRM;;IAEE,+BAAA;EtE6xRR;EsE3xRM;;IAEE,6BAAA;EtE6xRR;EsE5yRM;IAAgC,wBAAA;EtE+yRtC;EsE9yRM;;IAEE,4BAAA;EtEgzRR;EsE9yRM;;IAEE,8BAAA;EtEgzRR;EsE9yRM;;IAEE,+BAAA;EtEgzRR;EsE9yRM;;IAEE,6BAAA;EtEgzRR;EsE/zRM;IAAgC,0BAAA;EtEk0RtC;EsEj0RM;;IAEE,8BAAA;EtEm0RR;EsEj0RM;;IAEE,gCAAA;EtEm0RR;EsEj0RM;;IAEE,iCAAA;EtEm0RR;EsEj0RM;;IAEE,+BAAA;EtEm0RR;EsEl1RM;IAAgC,wBAAA;EtEq1RtC;EsEp1RM;;IAEE,4BAAA;EtEs1RR;EsEp1RM;;IAEE,8BAAA;EtEs1RR;EsEp1RM;;IAEE,+BAAA;EtEs1RR;EsEp1RM;;IAEE,6BAAA;EtEs1RR;EsEr2RM;IAAgC,0BAAA;EtEw2RtC;EsEv2RM;;IAEE,8BAAA;EtEy2RR;EsEv2RM;;IAEE,gCAAA;EtEy2RR;EsEv2RM;;IAEE,iCAAA;EtEy2RR;EsEv2RM;;IAEE,+BAAA;EtEy2RR;EsEx3RM;IAAgC,wBAAA;EtE23RtC;EsE13RM;;IAEE,4BAAA;EtE43RR;EsE13RM;;IAEE,8BAAA;EtE43RR;EsE13RM;;IAEE,+BAAA;EtE43RR;EsE13RM;;IAEE,6BAAA;EtE43RR;EsE34RM;IAAgC,0BAAA;EtE84RtC;EsE74RM;;IAEE,8BAAA;EtE+4RR;EsE74RM;;IAEE,gCAAA;EtE+4RR;EsE74RM;;IAEE,iCAAA;EtE+4RR;EsE74RM;;IAEE,+BAAA;EtE+4RR;EsE95RM;IAAgC,2BAAA;EtEi6RtC;EsEh6RM;;IAEE,+BAAA;EtEk6RR;EsEh6RM;;IAEE,iCAAA;EtEk6RR;EsEh6RM;;IAEE,kCAAA;EtEk6RR;EsEh6RM;;IAEE,gCAAA;EtEk6RR;EsEj7RM;IAAgC,yBAAA;EtEo7RtC;EsEn7RM;;IAEE,6BAAA;EtEq7RR;EsEn7RM;;IAEE,+BAAA;EtEq7RR;EsEn7RM;;IAEE,gCAAA;EtEq7RR;EsEn7RM;;IAEE,8BAAA;EtEq7RR;EsEp8RM;IAAgC,uBAAA;EtEu8RtC;EsEt8RM;;IAEE,2BAAA;EtEw8RR;EsEt8RM;;IAEE,6BAAA;EtEw8RR;EsEt8RM;;IAEE,8BAAA;EtEw8RR;EsEt8RM;;IAEE,4BAAA;EtEw8RR;EsEv9RM;IAAgC,uBAAA;EtE09RtC;EsEz9RM;;IAEE,2BAAA;EtE29RR;EsEz9RM;;IAEE,6BAAA;EtE29RR;EsEz9RM;;IAEE,8BAAA;EtE29RR;EsEz9RM;;IAEE,4BAAA;EtE29RR;EsE1+RM;IAAgC,wBAAA;EtE6+RtC;EsE5+RM;;IAEE,4BAAA;EtE8+RR;EsE5+RM;;IAEE,8BAAA;EtE8+RR;EsE5+RM;;IAEE,+BAAA;EtE8+RR;EsE5+RM;;IAEE,6BAAA;EtE8+RR;EsE7/RM;IAAgC,qBAAA;EtEggStC;EsE//RM;;IAEE,yBAAA;EtEigSR;EsE//RM;;IAEE,2BAAA;EtEigSR;EsE//RM;;IAEE,4BAAA;EtEigSR;EsE//RM;;IAEE,0BAAA;EtEigSR;EsEhhSM;IAAgC,2BAAA;EtEmhStC;EsElhSM;;IAEE,+BAAA;EtEohSR;EsElhSM;;IAEE,iCAAA;EtEohSR;EsElhSM;;IAEE,kCAAA;EtEohSR;EsElhSM;;IAEE,gCAAA;EtEohSR;EsEniSM;IAAgC,0BAAA;EtEsiStC;EsEriSM;;IAEE,8BAAA;EtEuiSR;EsEriSM;;IAEE,gCAAA;EtEuiSR;EsEriSM;;IAEE,iCAAA;EtEuiSR;EsEriSM;;IAEE,+BAAA;EtEuiSR;EsEtjSM;IAAgC,wBAAA;EtEyjStC;EsExjSM;;IAEE,4BAAA;EtE0jSR;EsExjSM;;IAEE,8BAAA;EtE0jSR;EsExjSM;;IAEE,+BAAA;EtE0jSR;EsExjSM;;IAEE,6BAAA;EtE0jSR;EsEzkSM;IAAgC,0BAAA;EtE4kStC;EsE3kSM;;IAEE,8BAAA;EtE6kSR;EsE3kSM;;IAEE,gCAAA;EtE6kSR;EsE3kSM;;IAEE,iCAAA;EtE6kSR;EsE3kSM;;IAEE,+BAAA;EtE6kSR;EsE5lSM;IAAgC,wBAAA;EtE+lStC;EsE9lSM;;IAEE,4BAAA;EtEgmSR;EsE9lSM;;IAEE,8BAAA;EtEgmSR;EsE9lSM;;IAEE,+BAAA;EtEgmSR;EsE9lSM;;IAEE,6BAAA;EtEgmSR;EsE/mSM;IAAgC,0BAAA;EtEknStC;EsEjnSM;;IAEE,8BAAA;EtEmnSR;EsEjnSM;;IAEE,gCAAA;EtEmnSR;EsEjnSM;;IAEE,iCAAA;EtEmnSR;EsEjnSM;;IAEE,+BAAA;EtEmnSR;EsEloSM;IAAgC,yBAAA;EtEqoStC;EsEpoSM;;IAEE,6BAAA;EtEsoSR;EsEpoSM;;IAEE,+BAAA;EtEsoSR;EsEpoSM;;IAEE,gCAAA;EtEsoSR;EsEpoSM;;IAEE,8BAAA;EtEsoSR;EsErpSM;IAAgC,yBAAA;EtEwpStC;EsEvpSM;;IAEE,6BAAA;EtEypSR;EsEvpSM;;IAEE,+BAAA;EtEypSR;EsEvpSM;;IAEE,gCAAA;EtEypSR;EsEvpSM;;IAEE,8BAAA;EtEypSR;EsExqSM;IAAgC,2BAAA;EtE2qStC;EsE1qSM;;IAEE,+BAAA;EtE4qSR;EsE1qSM;;IAEE,iCAAA;EtE4qSR;EsE1qSM;;IAEE,kCAAA;EtE4qSR;EsE1qSM;;IAEE,gCAAA;EtE4qSR;EsE3rSM;IAAgC,yBAAA;EtE8rStC;EsE7rSM;;IAEE,6BAAA;EtE+rSR;EsE7rSM;;IAEE,+BAAA;EtE+rSR;EsE7rSM;;IAEE,gCAAA;EtE+rSR;EsE7rSM;;IAEE,8BAAA;EtE+rSR;EsE9sSM;IAAgC,2BAAA;EtEitStC;EsEhtSM;;IAEE,+BAAA;EtEktSR;EsEhtSM;;IAEE,iCAAA;EtEktSR;EsEhtSM;;IAEE,kCAAA;EtEktSR;EsEhtSM;;IAEE,gCAAA;EtEktSR;EsEjuSM;IAAgC,yBAAA;EtEouStC;EsEnuSM;;IAEE,6BAAA;EtEquSR;EsEnuSM;;IAEE,+BAAA;EtEquSR;EsEnuSM;;IAEE,gCAAA;EtEquSR;EsEnuSM;;IAEE,8BAAA;EtEquSR;EsEpvSM;IAAgC,2BAAA;EtEuvStC;EsEtvSM;;IAEE,+BAAA;EtEwvSR;EsEtvSM;;IAEE,iCAAA;EtEwvSR;EsEtvSM;;IAEE,kCAAA;EtEwvSR;EsEtvSM;;IAEE,gCAAA;EtEwvSR;EsEvwSM;IAAgC,4BAAA;EtE0wStC;EsEzwSM;;IAEE,gCAAA;EtE2wSR;EsEzwSM;;IAEE,kCAAA;EtE2wSR;EsEzwSM;;IAEE,mCAAA;EtE2wSR;EsEzwSM;;IAEE,iCAAA;EtE2wSR;EsE1xSM;IAAgC,0BAAA;EtE6xStC;EsE5xSM;;IAEE,8BAAA;EtE8xSR;EsE5xSM;;IAEE,gCAAA;EtE8xSR;EsE5xSM;;IAEE,iCAAA;EtE8xSR;EsE5xSM;;IAEE,+BAAA;EtE8xSR;EsE7ySM;IAAgC,wBAAA;EtEgzStC;EsE/ySM;;IAEE,4BAAA;EtEizSR;EsE/ySM;;IAEE,8BAAA;EtEizSR;EsE/ySM;;IAEE,+BAAA;EtEizSR;EsE/ySM;;IAEE,6BAAA;EtEizSR;EsEh0SM;IAAgC,wBAAA;EtEm0StC;EsEl0SM;;IAEE,4BAAA;EtEo0SR;EsEl0SM;;IAEE,8BAAA;EtEo0SR;EsEl0SM;;IAEE,+BAAA;EtEo0SR;EsEl0SM;;IAEE,6BAAA;EtEo0SR;EsEn1SM;IAAgC,yBAAA;EtEs1StC;EsEr1SM;;IAEE,6BAAA;EtEu1SR;EsEr1SM;;IAEE,+BAAA;EtEu1SR;EsEr1SM;;IAEE,gCAAA;EtEu1SR;EsEr1SM;;IAEE,8BAAA;EtEu1SR;EsE/0SM;IAAwB,2BAAA;EtEk1S9B;EsEj1SM;;IAEE,+BAAA;EtEm1SR;EsEj1SM;;IAEE,iCAAA;EtEm1SR;EsEj1SM;;IAEE,kCAAA;EtEm1SR;EsEj1SM;;IAEE,gCAAA;EtEm1SR;EsEl2SM;IAAwB,0BAAA;EtEq2S9B;EsEp2SM;;IAEE,8BAAA;EtEs2SR;EsEp2SM;;IAEE,gCAAA;EtEs2SR;EsEp2SM;;IAEE,iCAAA;EtEs2SR;EsEp2SM;;IAEE,+BAAA;EtEs2SR;EsEr3SM;IAAwB,wBAAA;EtEw3S9B;EsEv3SM;;IAEE,4BAAA;EtEy3SR;EsEv3SM;;IAEE,8BAAA;EtEy3SR;EsEv3SM;;IAEE,+BAAA;EtEy3SR;EsEv3SM;;IAEE,6BAAA;EtEy3SR;EsEx4SM;IAAwB,0BAAA;EtE24S9B;EsE14SM;;IAEE,8BAAA;EtE44SR;EsE14SM;;IAEE,gCAAA;EtE44SR;EsE14SM;;IAEE,iCAAA;EtE44SR;EsE14SM;;IAEE,+BAAA;EtE44SR;EsE35SM;IAAwB,wBAAA;EtE85S9B;EsE75SM;;IAEE,4BAAA;EtE+5SR;EsE75SM;;IAEE,8BAAA;EtE+5SR;EsE75SM;;IAEE,+BAAA;EtE+5SR;EsE75SM;;IAEE,6BAAA;EtE+5SR;EsE96SM;IAAwB,wBAAA;EtEi7S9B;EsEh7SM;;IAEE,4BAAA;EtEk7SR;EsEh7SM;;IAEE,8BAAA;EtEk7SR;EsEh7SM;;IAEE,+BAAA;EtEk7SR;EsEh7SM;;IAEE,6BAAA;EtEk7SR;EsEj8SM;IAAwB,uBAAA;EtEo8S9B;EsEn8SM;;IAEE,2BAAA;EtEq8SR;EsEn8SM;;IAEE,6BAAA;EtEq8SR;EsEn8SM;;IAEE,8BAAA;EtEq8SR;EsEn8SM;;IAEE,4BAAA;EtEq8SR;EsEp9SM;IAAwB,uBAAA;EtEu9S9B;EsEt9SM;;IAEE,2BAAA;EtEw9SR;EsEt9SM;;IAEE,6BAAA;EtEw9SR;EsEt9SM;;IAEE,8BAAA;EtEw9SR;EsEt9SM;;IAEE,4BAAA;EtEw9SR;EsEv+SM;IAAwB,yBAAA;EtE0+S9B;EsEz+SM;;IAEE,6BAAA;EtE2+SR;EsEz+SM;;IAEE,+BAAA;EtE2+SR;EsEz+SM;;IAEE,gCAAA;EtE2+SR;EsEz+SM;;IAEE,8BAAA;EtE2+SR;EsE1/SM;IAAwB,uBAAA;EtE6/S9B;EsE5/SM;;IAEE,2BAAA;EtE8/SR;EsE5/SM;;IAEE,6BAAA;EtE8/SR;EsE5/SM;;IAEE,8BAAA;EtE8/SR;EsE5/SM;;IAEE,4BAAA;EtE8/SR;EsE7gTM;IAAwB,yBAAA;EtEghT9B;EsE/gTM;;IAEE,6BAAA;EtEihTR;EsE/gTM;;IAEE,+BAAA;EtEihTR;EsE/gTM;;IAEE,gCAAA;EtEihTR;EsE/gTM;;IAEE,8BAAA;EtEihTR;EsEhiTM;IAAwB,uBAAA;EtEmiT9B;EsEliTM;;IAEE,2BAAA;EtEoiTR;EsEliTM;;IAEE,6BAAA;EtEoiTR;EsEliTM;;IAEE,8BAAA;EtEoiTR;EsEliTM;;IAEE,4BAAA;EtEoiTR;EsEnjTM;IAAwB,yBAAA;EtEsjT9B;EsErjTM;;IAEE,6BAAA;EtEujTR;EsErjTM;;IAEE,+BAAA;EtEujTR;EsErjTM;;IAEE,gCAAA;EtEujTR;EsErjTM;;IAEE,8BAAA;EtEujTR;EsEtkTM;IAAwB,0BAAA;EtEykT9B;EsExkTM;;IAEE,8BAAA;EtE0kTR;EsExkTM;;IAEE,gCAAA;EtE0kTR;EsExkTM;;IAEE,iCAAA;EtE0kTR;EsExkTM;;IAEE,+BAAA;EtE0kTR;EsEzlTM;IAAwB,0BAAA;EtE4lT9B;EsE3lTM;;IAEE,8BAAA;EtE6lTR;EsE3lTM;;IAEE,gCAAA;EtE6lTR;EsE3lTM;;IAEE,iCAAA;EtE6lTR;EsE3lTM;;IAEE,+BAAA;EtE6lTR;EsE5mTM;IAAwB,wBAAA;EtE+mT9B;EsE9mTM;;IAEE,4BAAA;EtEgnTR;EsE9mTM;;IAEE,8BAAA;EtEgnTR;EsE9mTM;;IAEE,+BAAA;EtEgnTR;EsE9mTM;;IAEE,6BAAA;EtEgnTR;EsE/nTM;IAAwB,wBAAA;EtEkoT9B;EsEjoTM;;IAEE,4BAAA;EtEmoTR;EsEjoTM;;IAEE,8BAAA;EtEmoTR;EsEjoTM;;IAEE,+BAAA;EtEmoTR;EsEjoTM;;IAEE,6BAAA;EtEmoTR;EsElpTM;IAAwB,yBAAA;EtEqpT9B;EsEppTM;;IAEE,6BAAA;EtEspTR;EsEppTM;;IAEE,+BAAA;EtEspTR;EsEppTM;;IAEE,gCAAA;EtEspTR;EsEppTM;;IAEE,8BAAA;EtEspTR;EsEhpTE;IAAmB,uBAAA;EtEmpTrB;EsElpTE;;IAEE,2BAAA;EtEopTJ;EsElpTE;;IAEE,6BAAA;EtEopTJ;EsElpTE;;IAEE,8BAAA;EtEopTJ;EsElpTE;;IAEE,4BAAA;EtEopTJ;AACF;AgB9pTI;EsDlDI;IAAgC,oBAAA;EtEotTtC;EsEntTM;;IAEE,wBAAA;EtEqtTR;EsEntTM;;IAEE,0BAAA;EtEqtTR;EsEntTM;;IAEE,2BAAA;EtEqtTR;EsEntTM;;IAEE,yBAAA;EtEqtTR;EsEpuTM;IAAgC,0BAAA;EtEuuTtC;EsEtuTM;;IAEE,8BAAA;EtEwuTR;EsEtuTM;;IAEE,gCAAA;EtEwuTR;EsEtuTM;;IAEE,iCAAA;EtEwuTR;EsEtuTM;;IAEE,+BAAA;EtEwuTR;EsEvvTM;IAAgC,yBAAA;EtE0vTtC;EsEzvTM;;IAEE,6BAAA;EtE2vTR;EsEzvTM;;IAEE,+BAAA;EtE2vTR;EsEzvTM;;IAEE,gCAAA;EtE2vTR;EsEzvTM;;IAEE,8BAAA;EtE2vTR;EsE1wTM;IAAgC,uBAAA;EtE6wTtC;EsE5wTM;;IAEE,2BAAA;EtE8wTR;EsE5wTM;;IAEE,6BAAA;EtE8wTR;EsE5wTM;;IAEE,8BAAA;EtE8wTR;EsE5wTM;;IAEE,4BAAA;EtE8wTR;EsE7xTM;IAAgC,yBAAA;EtEgyTtC;EsE/xTM;;IAEE,6BAAA;EtEiyTR;EsE/xTM;;IAEE,+BAAA;EtEiyTR;EsE/xTM;;IAEE,gCAAA;EtEiyTR;EsE/xTM;;IAEE,8BAAA;EtEiyTR;EsEhzTM;IAAgC,uBAAA;EtEmzTtC;EsElzTM;;IAEE,2BAAA;EtEozTR;EsElzTM;;IAEE,6BAAA;EtEozTR;EsElzTM;;IAEE,8BAAA;EtEozTR;EsElzTM;;IAEE,4BAAA;EtEozTR;EsEn0TM;IAAgC,yBAAA;EtEs0TtC;EsEr0TM;;IAEE,6BAAA;EtEu0TR;EsEr0TM;;IAEE,+BAAA;EtEu0TR;EsEr0TM;;IAEE,gCAAA;EtEu0TR;EsEr0TM;;IAEE,8BAAA;EtEu0TR;EsEt1TM;IAAgC,wBAAA;EtEy1TtC;EsEx1TM;;IAEE,4BAAA;EtE01TR;EsEx1TM;;IAEE,8BAAA;EtE01TR;EsEx1TM;;IAEE,+BAAA;EtE01TR;EsEx1TM;;IAEE,6BAAA;EtE01TR;EsEz2TM;IAAgC,wBAAA;EtE42TtC;EsE32TM;;IAEE,4BAAA;EtE62TR;EsE32TM;;IAEE,8BAAA;EtE62TR;EsE32TM;;IAEE,+BAAA;EtE62TR;EsE32TM;;IAEE,6BAAA;EtE62TR;EsE53TM;IAAgC,0BAAA;EtE+3TtC;EsE93TM;;IAEE,8BAAA;EtEg4TR;EsE93TM;;IAEE,gCAAA;EtEg4TR;EsE93TM;;IAEE,iCAAA;EtEg4TR;EsE93TM;;IAEE,+BAAA;EtEg4TR;EsE/4TM;IAAgC,wBAAA;EtEk5TtC;EsEj5TM;;IAEE,4BAAA;EtEm5TR;EsEj5TM;;IAEE,8BAAA;EtEm5TR;EsEj5TM;;IAEE,+BAAA;EtEm5TR;EsEj5TM;;IAEE,6BAAA;EtEm5TR;EsEl6TM;IAAgC,0BAAA;EtEq6TtC;EsEp6TM;;IAEE,8BAAA;EtEs6TR;EsEp6TM;;IAEE,gCAAA;EtEs6TR;EsEp6TM;;IAEE,iCAAA;EtEs6TR;EsEp6TM;;IAEE,+BAAA;EtEs6TR;EsEr7TM;IAAgC,wBAAA;EtEw7TtC;EsEv7TM;;IAEE,4BAAA;EtEy7TR;EsEv7TM;;IAEE,8BAAA;EtEy7TR;EsEv7TM;;IAEE,+BAAA;EtEy7TR;EsEv7TM;;IAEE,6BAAA;EtEy7TR;EsEx8TM;IAAgC,0BAAA;EtE28TtC;EsE18TM;;IAEE,8BAAA;EtE48TR;EsE18TM;;IAEE,gCAAA;EtE48TR;EsE18TM;;IAEE,iCAAA;EtE48TR;EsE18TM;;IAEE,+BAAA;EtE48TR;EsE39TM;IAAgC,2BAAA;EtE89TtC;EsE79TM;;IAEE,+BAAA;EtE+9TR;EsE79TM;;IAEE,iCAAA;EtE+9TR;EsE79TM;;IAEE,kCAAA;EtE+9TR;EsE79TM;;IAEE,gCAAA;EtE+9TR;EsE9+TM;IAAgC,yBAAA;EtEi/TtC;EsEh/TM;;IAEE,6BAAA;EtEk/TR;EsEh/TM;;IAEE,+BAAA;EtEk/TR;EsEh/TM;;IAEE,gCAAA;EtEk/TR;EsEh/TM;;IAEE,8BAAA;EtEk/TR;EsEjgUM;IAAgC,uBAAA;EtEogUtC;EsEngUM;;IAEE,2BAAA;EtEqgUR;EsEngUM;;IAEE,6BAAA;EtEqgUR;EsEngUM;;IAEE,8BAAA;EtEqgUR;EsEngUM;;IAEE,4BAAA;EtEqgUR;EsEphUM;IAAgC,uBAAA;EtEuhUtC;EsEthUM;;IAEE,2BAAA;EtEwhUR;EsEthUM;;IAEE,6BAAA;EtEwhUR;EsEthUM;;IAEE,8BAAA;EtEwhUR;EsEthUM;;IAEE,4BAAA;EtEwhUR;EsEviUM;IAAgC,wBAAA;EtE0iUtC;EsEziUM;;IAEE,4BAAA;EtE2iUR;EsEziUM;;IAEE,8BAAA;EtE2iUR;EsEziUM;;IAEE,+BAAA;EtE2iUR;EsEziUM;;IAEE,6BAAA;EtE2iUR;EsE1jUM;IAAgC,qBAAA;EtE6jUtC;EsE5jUM;;IAEE,yBAAA;EtE8jUR;EsE5jUM;;IAEE,2BAAA;EtE8jUR;EsE5jUM;;IAEE,4BAAA;EtE8jUR;EsE5jUM;;IAEE,0BAAA;EtE8jUR;EsE7kUM;IAAgC,2BAAA;EtEglUtC;EsE/kUM;;IAEE,+BAAA;EtEilUR;EsE/kUM;;IAEE,iCAAA;EtEilUR;EsE/kUM;;IAEE,kCAAA;EtEilUR;EsE/kUM;;IAEE,gCAAA;EtEilUR;EsEhmUM;IAAgC,0BAAA;EtEmmUtC;EsElmUM;;IAEE,8BAAA;EtEomUR;EsElmUM;;IAEE,gCAAA;EtEomUR;EsElmUM;;IAEE,iCAAA;EtEomUR;EsElmUM;;IAEE,+BAAA;EtEomUR;EsEnnUM;IAAgC,wBAAA;EtEsnUtC;EsErnUM;;IAEE,4BAAA;EtEunUR;EsErnUM;;IAEE,8BAAA;EtEunUR;EsErnUM;;IAEE,+BAAA;EtEunUR;EsErnUM;;IAEE,6BAAA;EtEunUR;EsEtoUM;IAAgC,0BAAA;EtEyoUtC;EsExoUM;;IAEE,8BAAA;EtE0oUR;EsExoUM;;IAEE,gCAAA;EtE0oUR;EsExoUM;;IAEE,iCAAA;EtE0oUR;EsExoUM;;IAEE,+BAAA;EtE0oUR;EsEzpUM;IAAgC,wBAAA;EtE4pUtC;EsE3pUM;;IAEE,4BAAA;EtE6pUR;EsE3pUM;;IAEE,8BAAA;EtE6pUR;EsE3pUM;;IAEE,+BAAA;EtE6pUR;EsE3pUM;;IAEE,6BAAA;EtE6pUR;EsE5qUM;IAAgC,0BAAA;EtE+qUtC;EsE9qUM;;IAEE,8BAAA;EtEgrUR;EsE9qUM;;IAEE,gCAAA;EtEgrUR;EsE9qUM;;IAEE,iCAAA;EtEgrUR;EsE9qUM;;IAEE,+BAAA;EtEgrUR;EsE/rUM;IAAgC,yBAAA;EtEksUtC;EsEjsUM;;IAEE,6BAAA;EtEmsUR;EsEjsUM;;IAEE,+BAAA;EtEmsUR;EsEjsUM;;IAEE,gCAAA;EtEmsUR;EsEjsUM;;IAEE,8BAAA;EtEmsUR;EsEltUM;IAAgC,yBAAA;EtEqtUtC;EsEptUM;;IAEE,6BAAA;EtEstUR;EsEptUM;;IAEE,+BAAA;EtEstUR;EsEptUM;;IAEE,gCAAA;EtEstUR;EsEptUM;;IAEE,8BAAA;EtEstUR;EsEruUM;IAAgC,2BAAA;EtEwuUtC;EsEvuUM;;IAEE,+BAAA;EtEyuUR;EsEvuUM;;IAEE,iCAAA;EtEyuUR;EsEvuUM;;IAEE,kCAAA;EtEyuUR;EsEvuUM;;IAEE,gCAAA;EtEyuUR;EsExvUM;IAAgC,yBAAA;EtE2vUtC;EsE1vUM;;IAEE,6BAAA;EtE4vUR;EsE1vUM;;IAEE,+BAAA;EtE4vUR;EsE1vUM;;IAEE,gCAAA;EtE4vUR;EsE1vUM;;IAEE,8BAAA;EtE4vUR;EsE3wUM;IAAgC,2BAAA;EtE8wUtC;EsE7wUM;;IAEE,+BAAA;EtE+wUR;EsE7wUM;;IAEE,iCAAA;EtE+wUR;EsE7wUM;;IAEE,kCAAA;EtE+wUR;EsE7wUM;;IAEE,gCAAA;EtE+wUR;EsE9xUM;IAAgC,yBAAA;EtEiyUtC;EsEhyUM;;IAEE,6BAAA;EtEkyUR;EsEhyUM;;IAEE,+BAAA;EtEkyUR;EsEhyUM;;IAEE,gCAAA;EtEkyUR;EsEhyUM;;IAEE,8BAAA;EtEkyUR;EsEjzUM;IAAgC,2BAAA;EtEozUtC;EsEnzUM;;IAEE,+BAAA;EtEqzUR;EsEnzUM;;IAEE,iCAAA;EtEqzUR;EsEnzUM;;IAEE,kCAAA;EtEqzUR;EsEnzUM;;IAEE,gCAAA;EtEqzUR;EsEp0UM;IAAgC,4BAAA;EtEu0UtC;EsEt0UM;;IAEE,gCAAA;EtEw0UR;EsEt0UM;;IAEE,kCAAA;EtEw0UR;EsEt0UM;;IAEE,mCAAA;EtEw0UR;EsEt0UM;;IAEE,iCAAA;EtEw0UR;EsEv1UM;IAAgC,0BAAA;EtE01UtC;EsEz1UM;;IAEE,8BAAA;EtE21UR;EsEz1UM;;IAEE,gCAAA;EtE21UR;EsEz1UM;;IAEE,iCAAA;EtE21UR;EsEz1UM;;IAEE,+BAAA;EtE21UR;EsE12UM;IAAgC,wBAAA;EtE62UtC;EsE52UM;;IAEE,4BAAA;EtE82UR;EsE52UM;;IAEE,8BAAA;EtE82UR;EsE52UM;;IAEE,+BAAA;EtE82UR;EsE52UM;;IAEE,6BAAA;EtE82UR;EsE73UM;IAAgC,wBAAA;EtEg4UtC;EsE/3UM;;IAEE,4BAAA;EtEi4UR;EsE/3UM;;IAEE,8BAAA;EtEi4UR;EsE/3UM;;IAEE,+BAAA;EtEi4UR;EsE/3UM;;IAEE,6BAAA;EtEi4UR;EsEh5UM;IAAgC,yBAAA;EtEm5UtC;EsEl5UM;;IAEE,6BAAA;EtEo5UR;EsEl5UM;;IAEE,+BAAA;EtEo5UR;EsEl5UM;;IAEE,gCAAA;EtEo5UR;EsEl5UM;;IAEE,8BAAA;EtEo5UR;EsE54UM;IAAwB,2BAAA;EtE+4U9B;EsE94UM;;IAEE,+BAAA;EtEg5UR;EsE94UM;;IAEE,iCAAA;EtEg5UR;EsE94UM;;IAEE,kCAAA;EtEg5UR;EsE94UM;;IAEE,gCAAA;EtEg5UR;EsE/5UM;IAAwB,0BAAA;EtEk6U9B;EsEj6UM;;IAEE,8BAAA;EtEm6UR;EsEj6UM;;IAEE,gCAAA;EtEm6UR;EsEj6UM;;IAEE,iCAAA;EtEm6UR;EsEj6UM;;IAEE,+BAAA;EtEm6UR;EsEl7UM;IAAwB,wBAAA;EtEq7U9B;EsEp7UM;;IAEE,4BAAA;EtEs7UR;EsEp7UM;;IAEE,8BAAA;EtEs7UR;EsEp7UM;;IAEE,+BAAA;EtEs7UR;EsEp7UM;;IAEE,6BAAA;EtEs7UR;EsEr8UM;IAAwB,0BAAA;EtEw8U9B;EsEv8UM;;IAEE,8BAAA;EtEy8UR;EsEv8UM;;IAEE,gCAAA;EtEy8UR;EsEv8UM;;IAEE,iCAAA;EtEy8UR;EsEv8UM;;IAEE,+BAAA;EtEy8UR;EsEx9UM;IAAwB,wBAAA;EtE29U9B;EsE19UM;;IAEE,4BAAA;EtE49UR;EsE19UM;;IAEE,8BAAA;EtE49UR;EsE19UM;;IAEE,+BAAA;EtE49UR;EsE19UM;;IAEE,6BAAA;EtE49UR;EsE3+UM;IAAwB,wBAAA;EtE8+U9B;EsE7+UM;;IAEE,4BAAA;EtE++UR;EsE7+UM;;IAEE,8BAAA;EtE++UR;EsE7+UM;;IAEE,+BAAA;EtE++UR;EsE7+UM;;IAEE,6BAAA;EtE++UR;EsE9/UM;IAAwB,uBAAA;EtEigV9B;EsEhgVM;;IAEE,2BAAA;EtEkgVR;EsEhgVM;;IAEE,6BAAA;EtEkgVR;EsEhgVM;;IAEE,8BAAA;EtEkgVR;EsEhgVM;;IAEE,4BAAA;EtEkgVR;EsEjhVM;IAAwB,uBAAA;EtEohV9B;EsEnhVM;;IAEE,2BAAA;EtEqhVR;EsEnhVM;;IAEE,6BAAA;EtEqhVR;EsEnhVM;;IAEE,8BAAA;EtEqhVR;EsEnhVM;;IAEE,4BAAA;EtEqhVR;EsEpiVM;IAAwB,yBAAA;EtEuiV9B;EsEtiVM;;IAEE,6BAAA;EtEwiVR;EsEtiVM;;IAEE,+BAAA;EtEwiVR;EsEtiVM;;IAEE,gCAAA;EtEwiVR;EsEtiVM;;IAEE,8BAAA;EtEwiVR;EsEvjVM;IAAwB,uBAAA;EtE0jV9B;EsEzjVM;;IAEE,2BAAA;EtE2jVR;EsEzjVM;;IAEE,6BAAA;EtE2jVR;EsEzjVM;;IAEE,8BAAA;EtE2jVR;EsEzjVM;;IAEE,4BAAA;EtE2jVR;EsE1kVM;IAAwB,yBAAA;EtE6kV9B;EsE5kVM;;IAEE,6BAAA;EtE8kVR;EsE5kVM;;IAEE,+BAAA;EtE8kVR;EsE5kVM;;IAEE,gCAAA;EtE8kVR;EsE5kVM;;IAEE,8BAAA;EtE8kVR;EsE7lVM;IAAwB,uBAAA;EtEgmV9B;EsE/lVM;;IAEE,2BAAA;EtEimVR;EsE/lVM;;IAEE,6BAAA;EtEimVR;EsE/lVM;;IAEE,8BAAA;EtEimVR;EsE/lVM;;IAEE,4BAAA;EtEimVR;EsEhnVM;IAAwB,yBAAA;EtEmnV9B;EsElnVM;;IAEE,6BAAA;EtEonVR;EsElnVM;;IAEE,+BAAA;EtEonVR;EsElnVM;;IAEE,gCAAA;EtEonVR;EsElnVM;;IAEE,8BAAA;EtEonVR;EsEnoVM;IAAwB,0BAAA;EtEsoV9B;EsEroVM;;IAEE,8BAAA;EtEuoVR;EsEroVM;;IAEE,gCAAA;EtEuoVR;EsEroVM;;IAEE,iCAAA;EtEuoVR;EsEroVM;;IAEE,+BAAA;EtEuoVR;EsEtpVM;IAAwB,0BAAA;EtEypV9B;EsExpVM;;IAEE,8BAAA;EtE0pVR;EsExpVM;;IAEE,gCAAA;EtE0pVR;EsExpVM;;IAEE,iCAAA;EtE0pVR;EsExpVM;;IAEE,+BAAA;EtE0pVR;EsEzqVM;IAAwB,wBAAA;EtE4qV9B;EsE3qVM;;IAEE,4BAAA;EtE6qVR;EsE3qVM;;IAEE,8BAAA;EtE6qVR;EsE3qVM;;IAEE,+BAAA;EtE6qVR;EsE3qVM;;IAEE,6BAAA;EtE6qVR;EsE5rVM;IAAwB,wBAAA;EtE+rV9B;EsE9rVM;;IAEE,4BAAA;EtEgsVR;EsE9rVM;;IAEE,8BAAA;EtEgsVR;EsE9rVM;;IAEE,+BAAA;EtEgsVR;EsE9rVM;;IAEE,6BAAA;EtEgsVR;EsE/sVM;IAAwB,yBAAA;EtEktV9B;EsEjtVM;;IAEE,6BAAA;EtEmtVR;EsEjtVM;;IAEE,+BAAA;EtEmtVR;EsEjtVM;;IAEE,gCAAA;EtEmtVR;EsEjtVM;;IAEE,8BAAA;EtEmtVR;EsE7sVE;IAAmB,uBAAA;EtEgtVrB;EsE/sVE;;IAEE,2BAAA;EtEitVJ;EsE/sVE;;IAEE,6BAAA;EtEitVJ;EsE/sVE;;IAEE,8BAAA;EtEitVJ;EsE/sVE;;IAEE,4BAAA;EtEitVJ;AACF;AgB3tVI;EsDlDI;IAAgC,oBAAA;EtEixVtC;EsEhxVM;;IAEE,wBAAA;EtEkxVR;EsEhxVM;;IAEE,0BAAA;EtEkxVR;EsEhxVM;;IAEE,2BAAA;EtEkxVR;EsEhxVM;;IAEE,yBAAA;EtEkxVR;EsEjyVM;IAAgC,0BAAA;EtEoyVtC;EsEnyVM;;IAEE,8BAAA;EtEqyVR;EsEnyVM;;IAEE,gCAAA;EtEqyVR;EsEnyVM;;IAEE,iCAAA;EtEqyVR;EsEnyVM;;IAEE,+BAAA;EtEqyVR;EsEpzVM;IAAgC,yBAAA;EtEuzVtC;EsEtzVM;;IAEE,6BAAA;EtEwzVR;EsEtzVM;;IAEE,+BAAA;EtEwzVR;EsEtzVM;;IAEE,gCAAA;EtEwzVR;EsEtzVM;;IAEE,8BAAA;EtEwzVR;EsEv0VM;IAAgC,uBAAA;EtE00VtC;EsEz0VM;;IAEE,2BAAA;EtE20VR;EsEz0VM;;IAEE,6BAAA;EtE20VR;EsEz0VM;;IAEE,8BAAA;EtE20VR;EsEz0VM;;IAEE,4BAAA;EtE20VR;EsE11VM;IAAgC,yBAAA;EtE61VtC;EsE51VM;;IAEE,6BAAA;EtE81VR;EsE51VM;;IAEE,+BAAA;EtE81VR;EsE51VM;;IAEE,gCAAA;EtE81VR;EsE51VM;;IAEE,8BAAA;EtE81VR;EsE72VM;IAAgC,uBAAA;EtEg3VtC;EsE/2VM;;IAEE,2BAAA;EtEi3VR;EsE/2VM;;IAEE,6BAAA;EtEi3VR;EsE/2VM;;IAEE,8BAAA;EtEi3VR;EsE/2VM;;IAEE,4BAAA;EtEi3VR;EsEh4VM;IAAgC,yBAAA;EtEm4VtC;EsEl4VM;;IAEE,6BAAA;EtEo4VR;EsEl4VM;;IAEE,+BAAA;EtEo4VR;EsEl4VM;;IAEE,gCAAA;EtEo4VR;EsEl4VM;;IAEE,8BAAA;EtEo4VR;EsEn5VM;IAAgC,wBAAA;EtEs5VtC;EsEr5VM;;IAEE,4BAAA;EtEu5VR;EsEr5VM;;IAEE,8BAAA;EtEu5VR;EsEr5VM;;IAEE,+BAAA;EtEu5VR;EsEr5VM;;IAEE,6BAAA;EtEu5VR;EsEt6VM;IAAgC,wBAAA;EtEy6VtC;EsEx6VM;;IAEE,4BAAA;EtE06VR;EsEx6VM;;IAEE,8BAAA;EtE06VR;EsEx6VM;;IAEE,+BAAA;EtE06VR;EsEx6VM;;IAEE,6BAAA;EtE06VR;EsEz7VM;IAAgC,0BAAA;EtE47VtC;EsE37VM;;IAEE,8BAAA;EtE67VR;EsE37VM;;IAEE,gCAAA;EtE67VR;EsE37VM;;IAEE,iCAAA;EtE67VR;EsE37VM;;IAEE,+BAAA;EtE67VR;EsE58VM;IAAgC,wBAAA;EtE+8VtC;EsE98VM;;IAEE,4BAAA;EtEg9VR;EsE98VM;;IAEE,8BAAA;EtEg9VR;EsE98VM;;IAEE,+BAAA;EtEg9VR;EsE98VM;;IAEE,6BAAA;EtEg9VR;EsE/9VM;IAAgC,0BAAA;EtEk+VtC;EsEj+VM;;IAEE,8BAAA;EtEm+VR;EsEj+VM;;IAEE,gCAAA;EtEm+VR;EsEj+VM;;IAEE,iCAAA;EtEm+VR;EsEj+VM;;IAEE,+BAAA;EtEm+VR;EsEl/VM;IAAgC,wBAAA;EtEq/VtC;EsEp/VM;;IAEE,4BAAA;EtEs/VR;EsEp/VM;;IAEE,8BAAA;EtEs/VR;EsEp/VM;;IAEE,+BAAA;EtEs/VR;EsEp/VM;;IAEE,6BAAA;EtEs/VR;EsErgWM;IAAgC,0BAAA;EtEwgWtC;EsEvgWM;;IAEE,8BAAA;EtEygWR;EsEvgWM;;IAEE,gCAAA;EtEygWR;EsEvgWM;;IAEE,iCAAA;EtEygWR;EsEvgWM;;IAEE,+BAAA;EtEygWR;EsExhWM;IAAgC,2BAAA;EtE2hWtC;EsE1hWM;;IAEE,+BAAA;EtE4hWR;EsE1hWM;;IAEE,iCAAA;EtE4hWR;EsE1hWM;;IAEE,kCAAA;EtE4hWR;EsE1hWM;;IAEE,gCAAA;EtE4hWR;EsE3iWM;IAAgC,yBAAA;EtE8iWtC;EsE7iWM;;IAEE,6BAAA;EtE+iWR;EsE7iWM;;IAEE,+BAAA;EtE+iWR;EsE7iWM;;IAEE,gCAAA;EtE+iWR;EsE7iWM;;IAEE,8BAAA;EtE+iWR;EsE9jWM;IAAgC,uBAAA;EtEikWtC;EsEhkWM;;IAEE,2BAAA;EtEkkWR;EsEhkWM;;IAEE,6BAAA;EtEkkWR;EsEhkWM;;IAEE,8BAAA;EtEkkWR;EsEhkWM;;IAEE,4BAAA;EtEkkWR;EsEjlWM;IAAgC,uBAAA;EtEolWtC;EsEnlWM;;IAEE,2BAAA;EtEqlWR;EsEnlWM;;IAEE,6BAAA;EtEqlWR;EsEnlWM;;IAEE,8BAAA;EtEqlWR;EsEnlWM;;IAEE,4BAAA;EtEqlWR;EsEpmWM;IAAgC,wBAAA;EtEumWtC;EsEtmWM;;IAEE,4BAAA;EtEwmWR;EsEtmWM;;IAEE,8BAAA;EtEwmWR;EsEtmWM;;IAEE,+BAAA;EtEwmWR;EsEtmWM;;IAEE,6BAAA;EtEwmWR;EsEvnWM;IAAgC,qBAAA;EtE0nWtC;EsEznWM;;IAEE,yBAAA;EtE2nWR;EsEznWM;;IAEE,2BAAA;EtE2nWR;EsEznWM;;IAEE,4BAAA;EtE2nWR;EsEznWM;;IAEE,0BAAA;EtE2nWR;EsE1oWM;IAAgC,2BAAA;EtE6oWtC;EsE5oWM;;IAEE,+BAAA;EtE8oWR;EsE5oWM;;IAEE,iCAAA;EtE8oWR;EsE5oWM;;IAEE,kCAAA;EtE8oWR;EsE5oWM;;IAEE,gCAAA;EtE8oWR;EsE7pWM;IAAgC,0BAAA;EtEgqWtC;EsE/pWM;;IAEE,8BAAA;EtEiqWR;EsE/pWM;;IAEE,gCAAA;EtEiqWR;EsE/pWM;;IAEE,iCAAA;EtEiqWR;EsE/pWM;;IAEE,+BAAA;EtEiqWR;EsEhrWM;IAAgC,wBAAA;EtEmrWtC;EsElrWM;;IAEE,4BAAA;EtEorWR;EsElrWM;;IAEE,8BAAA;EtEorWR;EsElrWM;;IAEE,+BAAA;EtEorWR;EsElrWM;;IAEE,6BAAA;EtEorWR;EsEnsWM;IAAgC,0BAAA;EtEssWtC;EsErsWM;;IAEE,8BAAA;EtEusWR;EsErsWM;;IAEE,gCAAA;EtEusWR;EsErsWM;;IAEE,iCAAA;EtEusWR;EsErsWM;;IAEE,+BAAA;EtEusWR;EsEttWM;IAAgC,wBAAA;EtEytWtC;EsExtWM;;IAEE,4BAAA;EtE0tWR;EsExtWM;;IAEE,8BAAA;EtE0tWR;EsExtWM;;IAEE,+BAAA;EtE0tWR;EsExtWM;;IAEE,6BAAA;EtE0tWR;EsEzuWM;IAAgC,0BAAA;EtE4uWtC;EsE3uWM;;IAEE,8BAAA;EtE6uWR;EsE3uWM;;IAEE,gCAAA;EtE6uWR;EsE3uWM;;IAEE,iCAAA;EtE6uWR;EsE3uWM;;IAEE,+BAAA;EtE6uWR;EsE5vWM;IAAgC,yBAAA;EtE+vWtC;EsE9vWM;;IAEE,6BAAA;EtEgwWR;EsE9vWM;;IAEE,+BAAA;EtEgwWR;EsE9vWM;;IAEE,gCAAA;EtEgwWR;EsE9vWM;;IAEE,8BAAA;EtEgwWR;EsE/wWM;IAAgC,yBAAA;EtEkxWtC;EsEjxWM;;IAEE,6BAAA;EtEmxWR;EsEjxWM;;IAEE,+BAAA;EtEmxWR;EsEjxWM;;IAEE,gCAAA;EtEmxWR;EsEjxWM;;IAEE,8BAAA;EtEmxWR;EsElyWM;IAAgC,2BAAA;EtEqyWtC;EsEpyWM;;IAEE,+BAAA;EtEsyWR;EsEpyWM;;IAEE,iCAAA;EtEsyWR;EsEpyWM;;IAEE,kCAAA;EtEsyWR;EsEpyWM;;IAEE,gCAAA;EtEsyWR;EsErzWM;IAAgC,yBAAA;EtEwzWtC;EsEvzWM;;IAEE,6BAAA;EtEyzWR;EsEvzWM;;IAEE,+BAAA;EtEyzWR;EsEvzWM;;IAEE,gCAAA;EtEyzWR;EsEvzWM;;IAEE,8BAAA;EtEyzWR;EsEx0WM;IAAgC,2BAAA;EtE20WtC;EsE10WM;;IAEE,+BAAA;EtE40WR;EsE10WM;;IAEE,iCAAA;EtE40WR;EsE10WM;;IAEE,kCAAA;EtE40WR;EsE10WM;;IAEE,gCAAA;EtE40WR;EsE31WM;IAAgC,yBAAA;EtE81WtC;EsE71WM;;IAEE,6BAAA;EtE+1WR;EsE71WM;;IAEE,+BAAA;EtE+1WR;EsE71WM;;IAEE,gCAAA;EtE+1WR;EsE71WM;;IAEE,8BAAA;EtE+1WR;EsE92WM;IAAgC,2BAAA;EtEi3WtC;EsEh3WM;;IAEE,+BAAA;EtEk3WR;EsEh3WM;;IAEE,iCAAA;EtEk3WR;EsEh3WM;;IAEE,kCAAA;EtEk3WR;EsEh3WM;;IAEE,gCAAA;EtEk3WR;EsEj4WM;IAAgC,4BAAA;EtEo4WtC;EsEn4WM;;IAEE,gCAAA;EtEq4WR;EsEn4WM;;IAEE,kCAAA;EtEq4WR;EsEn4WM;;IAEE,mCAAA;EtEq4WR;EsEn4WM;;IAEE,iCAAA;EtEq4WR;EsEp5WM;IAAgC,0BAAA;EtEu5WtC;EsEt5WM;;IAEE,8BAAA;EtEw5WR;EsEt5WM;;IAEE,gCAAA;EtEw5WR;EsEt5WM;;IAEE,iCAAA;EtEw5WR;EsEt5WM;;IAEE,+BAAA;EtEw5WR;EsEv6WM;IAAgC,wBAAA;EtE06WtC;EsEz6WM;;IAEE,4BAAA;EtE26WR;EsEz6WM;;IAEE,8BAAA;EtE26WR;EsEz6WM;;IAEE,+BAAA;EtE26WR;EsEz6WM;;IAEE,6BAAA;EtE26WR;EsE17WM;IAAgC,wBAAA;EtE67WtC;EsE57WM;;IAEE,4BAAA;EtE87WR;EsE57WM;;IAEE,8BAAA;EtE87WR;EsE57WM;;IAEE,+BAAA;EtE87WR;EsE57WM;;IAEE,6BAAA;EtE87WR;EsE78WM;IAAgC,yBAAA;EtEg9WtC;EsE/8WM;;IAEE,6BAAA;EtEi9WR;EsE/8WM;;IAEE,+BAAA;EtEi9WR;EsE/8WM;;IAEE,gCAAA;EtEi9WR;EsE/8WM;;IAEE,8BAAA;EtEi9WR;EsEz8WM;IAAwB,2BAAA;EtE48W9B;EsE38WM;;IAEE,+BAAA;EtE68WR;EsE38WM;;IAEE,iCAAA;EtE68WR;EsE38WM;;IAEE,kCAAA;EtE68WR;EsE38WM;;IAEE,gCAAA;EtE68WR;EsE59WM;IAAwB,0BAAA;EtE+9W9B;EsE99WM;;IAEE,8BAAA;EtEg+WR;EsE99WM;;IAEE,gCAAA;EtEg+WR;EsE99WM;;IAEE,iCAAA;EtEg+WR;EsE99WM;;IAEE,+BAAA;EtEg+WR;EsE/+WM;IAAwB,wBAAA;EtEk/W9B;EsEj/WM;;IAEE,4BAAA;EtEm/WR;EsEj/WM;;IAEE,8BAAA;EtEm/WR;EsEj/WM;;IAEE,+BAAA;EtEm/WR;EsEj/WM;;IAEE,6BAAA;EtEm/WR;EsElgXM;IAAwB,0BAAA;EtEqgX9B;EsEpgXM;;IAEE,8BAAA;EtEsgXR;EsEpgXM;;IAEE,gCAAA;EtEsgXR;EsEpgXM;;IAEE,iCAAA;EtEsgXR;EsEpgXM;;IAEE,+BAAA;EtEsgXR;EsErhXM;IAAwB,wBAAA;EtEwhX9B;EsEvhXM;;IAEE,4BAAA;EtEyhXR;EsEvhXM;;IAEE,8BAAA;EtEyhXR;EsEvhXM;;IAEE,+BAAA;EtEyhXR;EsEvhXM;;IAEE,6BAAA;EtEyhXR;EsExiXM;IAAwB,wBAAA;EtE2iX9B;EsE1iXM;;IAEE,4BAAA;EtE4iXR;EsE1iXM;;IAEE,8BAAA;EtE4iXR;EsE1iXM;;IAEE,+BAAA;EtE4iXR;EsE1iXM;;IAEE,6BAAA;EtE4iXR;EsE3jXM;IAAwB,uBAAA;EtE8jX9B;EsE7jXM;;IAEE,2BAAA;EtE+jXR;EsE7jXM;;IAEE,6BAAA;EtE+jXR;EsE7jXM;;IAEE,8BAAA;EtE+jXR;EsE7jXM;;IAEE,4BAAA;EtE+jXR;EsE9kXM;IAAwB,uBAAA;EtEilX9B;EsEhlXM;;IAEE,2BAAA;EtEklXR;EsEhlXM;;IAEE,6BAAA;EtEklXR;EsEhlXM;;IAEE,8BAAA;EtEklXR;EsEhlXM;;IAEE,4BAAA;EtEklXR;EsEjmXM;IAAwB,yBAAA;EtEomX9B;EsEnmXM;;IAEE,6BAAA;EtEqmXR;EsEnmXM;;IAEE,+BAAA;EtEqmXR;EsEnmXM;;IAEE,gCAAA;EtEqmXR;EsEnmXM;;IAEE,8BAAA;EtEqmXR;EsEpnXM;IAAwB,uBAAA;EtEunX9B;EsEtnXM;;IAEE,2BAAA;EtEwnXR;EsEtnXM;;IAEE,6BAAA;EtEwnXR;EsEtnXM;;IAEE,8BAAA;EtEwnXR;EsEtnXM;;IAEE,4BAAA;EtEwnXR;EsEvoXM;IAAwB,yBAAA;EtE0oX9B;EsEzoXM;;IAEE,6BAAA;EtE2oXR;EsEzoXM;;IAEE,+BAAA;EtE2oXR;EsEzoXM;;IAEE,gCAAA;EtE2oXR;EsEzoXM;;IAEE,8BAAA;EtE2oXR;EsE1pXM;IAAwB,uBAAA;EtE6pX9B;EsE5pXM;;IAEE,2BAAA;EtE8pXR;EsE5pXM;;IAEE,6BAAA;EtE8pXR;EsE5pXM;;IAEE,8BAAA;EtE8pXR;EsE5pXM;;IAEE,4BAAA;EtE8pXR;EsE7qXM;IAAwB,yBAAA;EtEgrX9B;EsE/qXM;;IAEE,6BAAA;EtEirXR;EsE/qXM;;IAEE,+BAAA;EtEirXR;EsE/qXM;;IAEE,gCAAA;EtEirXR;EsE/qXM;;IAEE,8BAAA;EtEirXR;EsEhsXM;IAAwB,0BAAA;EtEmsX9B;EsElsXM;;IAEE,8BAAA;EtEosXR;EsElsXM;;IAEE,gCAAA;EtEosXR;EsElsXM;;IAEE,iCAAA;EtEosXR;EsElsXM;;IAEE,+BAAA;EtEosXR;EsEntXM;IAAwB,0BAAA;EtEstX9B;EsErtXM;;IAEE,8BAAA;EtEutXR;EsErtXM;;IAEE,gCAAA;EtEutXR;EsErtXM;;IAEE,iCAAA;EtEutXR;EsErtXM;;IAEE,+BAAA;EtEutXR;EsEtuXM;IAAwB,wBAAA;EtEyuX9B;EsExuXM;;IAEE,4BAAA;EtE0uXR;EsExuXM;;IAEE,8BAAA;EtE0uXR;EsExuXM;;IAEE,+BAAA;EtE0uXR;EsExuXM;;IAEE,6BAAA;EtE0uXR;EsEzvXM;IAAwB,wBAAA;EtE4vX9B;EsE3vXM;;IAEE,4BAAA;EtE6vXR;EsE3vXM;;IAEE,8BAAA;EtE6vXR;EsE3vXM;;IAEE,+BAAA;EtE6vXR;EsE3vXM;;IAEE,6BAAA;EtE6vXR;EsE5wXM;IAAwB,yBAAA;EtE+wX9B;EsE9wXM;;IAEE,6BAAA;EtEgxXR;EsE9wXM;;IAEE,+BAAA;EtEgxXR;EsE9wXM;;IAEE,gCAAA;EtEgxXR;EsE9wXM;;IAEE,8BAAA;EtEgxXR;EsE1wXE;IAAmB,uBAAA;EtE6wXrB;EsE5wXE;;IAEE,2BAAA;EtE8wXJ;EsE5wXE;;IAEE,6BAAA;EtE8wXJ;EsE5wXE;;IAEE,8BAAA;EtE8wXJ;EsE5wXE;;IAEE,4BAAA;EtE8wXJ;AACF;AgBxxXI;EsDlDI;IAAgC,oBAAA;EtE80XtC;EsE70XM;;IAEE,wBAAA;EtE+0XR;EsE70XM;;IAEE,0BAAA;EtE+0XR;EsE70XM;;IAEE,2BAAA;EtE+0XR;EsE70XM;;IAEE,yBAAA;EtE+0XR;EsE91XM;IAAgC,0BAAA;EtEi2XtC;EsEh2XM;;IAEE,8BAAA;EtEk2XR;EsEh2XM;;IAEE,gCAAA;EtEk2XR;EsEh2XM;;IAEE,iCAAA;EtEk2XR;EsEh2XM;;IAEE,+BAAA;EtEk2XR;EsEj3XM;IAAgC,yBAAA;EtEo3XtC;EsEn3XM;;IAEE,6BAAA;EtEq3XR;EsEn3XM;;IAEE,+BAAA;EtEq3XR;EsEn3XM;;IAEE,gCAAA;EtEq3XR;EsEn3XM;;IAEE,8BAAA;EtEq3XR;EsEp4XM;IAAgC,uBAAA;EtEu4XtC;EsEt4XM;;IAEE,2BAAA;EtEw4XR;EsEt4XM;;IAEE,6BAAA;EtEw4XR;EsEt4XM;;IAEE,8BAAA;EtEw4XR;EsEt4XM;;IAEE,4BAAA;EtEw4XR;EsEv5XM;IAAgC,yBAAA;EtE05XtC;EsEz5XM;;IAEE,6BAAA;EtE25XR;EsEz5XM;;IAEE,+BAAA;EtE25XR;EsEz5XM;;IAEE,gCAAA;EtE25XR;EsEz5XM;;IAEE,8BAAA;EtE25XR;EsE16XM;IAAgC,uBAAA;EtE66XtC;EsE56XM;;IAEE,2BAAA;EtE86XR;EsE56XM;;IAEE,6BAAA;EtE86XR;EsE56XM;;IAEE,8BAAA;EtE86XR;EsE56XM;;IAEE,4BAAA;EtE86XR;EsE77XM;IAAgC,yBAAA;EtEg8XtC;EsE/7XM;;IAEE,6BAAA;EtEi8XR;EsE/7XM;;IAEE,+BAAA;EtEi8XR;EsE/7XM;;IAEE,gCAAA;EtEi8XR;EsE/7XM;;IAEE,8BAAA;EtEi8XR;EsEh9XM;IAAgC,wBAAA;EtEm9XtC;EsEl9XM;;IAEE,4BAAA;EtEo9XR;EsEl9XM;;IAEE,8BAAA;EtEo9XR;EsEl9XM;;IAEE,+BAAA;EtEo9XR;EsEl9XM;;IAEE,6BAAA;EtEo9XR;EsEn+XM;IAAgC,wBAAA;EtEs+XtC;EsEr+XM;;IAEE,4BAAA;EtEu+XR;EsEr+XM;;IAEE,8BAAA;EtEu+XR;EsEr+XM;;IAEE,+BAAA;EtEu+XR;EsEr+XM;;IAEE,6BAAA;EtEu+XR;EsEt/XM;IAAgC,0BAAA;EtEy/XtC;EsEx/XM;;IAEE,8BAAA;EtE0/XR;EsEx/XM;;IAEE,gCAAA;EtE0/XR;EsEx/XM;;IAEE,iCAAA;EtE0/XR;EsEx/XM;;IAEE,+BAAA;EtE0/XR;EsEzgYM;IAAgC,wBAAA;EtE4gYtC;EsE3gYM;;IAEE,4BAAA;EtE6gYR;EsE3gYM;;IAEE,8BAAA;EtE6gYR;EsE3gYM;;IAEE,+BAAA;EtE6gYR;EsE3gYM;;IAEE,6BAAA;EtE6gYR;EsE5hYM;IAAgC,0BAAA;EtE+hYtC;EsE9hYM;;IAEE,8BAAA;EtEgiYR;EsE9hYM;;IAEE,gCAAA;EtEgiYR;EsE9hYM;;IAEE,iCAAA;EtEgiYR;EsE9hYM;;IAEE,+BAAA;EtEgiYR;EsE/iYM;IAAgC,wBAAA;EtEkjYtC;EsEjjYM;;IAEE,4BAAA;EtEmjYR;EsEjjYM;;IAEE,8BAAA;EtEmjYR;EsEjjYM;;IAEE,+BAAA;EtEmjYR;EsEjjYM;;IAEE,6BAAA;EtEmjYR;EsElkYM;IAAgC,0BAAA;EtEqkYtC;EsEpkYM;;IAEE,8BAAA;EtEskYR;EsEpkYM;;IAEE,gCAAA;EtEskYR;EsEpkYM;;IAEE,iCAAA;EtEskYR;EsEpkYM;;IAEE,+BAAA;EtEskYR;EsErlYM;IAAgC,2BAAA;EtEwlYtC;EsEvlYM;;IAEE,+BAAA;EtEylYR;EsEvlYM;;IAEE,iCAAA;EtEylYR;EsEvlYM;;IAEE,kCAAA;EtEylYR;EsEvlYM;;IAEE,gCAAA;EtEylYR;EsExmYM;IAAgC,yBAAA;EtE2mYtC;EsE1mYM;;IAEE,6BAAA;EtE4mYR;EsE1mYM;;IAEE,+BAAA;EtE4mYR;EsE1mYM;;IAEE,gCAAA;EtE4mYR;EsE1mYM;;IAEE,8BAAA;EtE4mYR;EsE3nYM;IAAgC,uBAAA;EtE8nYtC;EsE7nYM;;IAEE,2BAAA;EtE+nYR;EsE7nYM;;IAEE,6BAAA;EtE+nYR;EsE7nYM;;IAEE,8BAAA;EtE+nYR;EsE7nYM;;IAEE,4BAAA;EtE+nYR;EsE9oYM;IAAgC,uBAAA;EtEipYtC;EsEhpYM;;IAEE,2BAAA;EtEkpYR;EsEhpYM;;IAEE,6BAAA;EtEkpYR;EsEhpYM;;IAEE,8BAAA;EtEkpYR;EsEhpYM;;IAEE,4BAAA;EtEkpYR;EsEjqYM;IAAgC,wBAAA;EtEoqYtC;EsEnqYM;;IAEE,4BAAA;EtEqqYR;EsEnqYM;;IAEE,8BAAA;EtEqqYR;EsEnqYM;;IAEE,+BAAA;EtEqqYR;EsEnqYM;;IAEE,6BAAA;EtEqqYR;EsEprYM;IAAgC,qBAAA;EtEurYtC;EsEtrYM;;IAEE,yBAAA;EtEwrYR;EsEtrYM;;IAEE,2BAAA;EtEwrYR;EsEtrYM;;IAEE,4BAAA;EtEwrYR;EsEtrYM;;IAEE,0BAAA;EtEwrYR;EsEvsYM;IAAgC,2BAAA;EtE0sYtC;EsEzsYM;;IAEE,+BAAA;EtE2sYR;EsEzsYM;;IAEE,iCAAA;EtE2sYR;EsEzsYM;;IAEE,kCAAA;EtE2sYR;EsEzsYM;;IAEE,gCAAA;EtE2sYR;EsE1tYM;IAAgC,0BAAA;EtE6tYtC;EsE5tYM;;IAEE,8BAAA;EtE8tYR;EsE5tYM;;IAEE,gCAAA;EtE8tYR;EsE5tYM;;IAEE,iCAAA;EtE8tYR;EsE5tYM;;IAEE,+BAAA;EtE8tYR;EsE7uYM;IAAgC,wBAAA;EtEgvYtC;EsE/uYM;;IAEE,4BAAA;EtEivYR;EsE/uYM;;IAEE,8BAAA;EtEivYR;EsE/uYM;;IAEE,+BAAA;EtEivYR;EsE/uYM;;IAEE,6BAAA;EtEivYR;EsEhwYM;IAAgC,0BAAA;EtEmwYtC;EsElwYM;;IAEE,8BAAA;EtEowYR;EsElwYM;;IAEE,gCAAA;EtEowYR;EsElwYM;;IAEE,iCAAA;EtEowYR;EsElwYM;;IAEE,+BAAA;EtEowYR;EsEnxYM;IAAgC,wBAAA;EtEsxYtC;EsErxYM;;IAEE,4BAAA;EtEuxYR;EsErxYM;;IAEE,8BAAA;EtEuxYR;EsErxYM;;IAEE,+BAAA;EtEuxYR;EsErxYM;;IAEE,6BAAA;EtEuxYR;EsEtyYM;IAAgC,0BAAA;EtEyyYtC;EsExyYM;;IAEE,8BAAA;EtE0yYR;EsExyYM;;IAEE,gCAAA;EtE0yYR;EsExyYM;;IAEE,iCAAA;EtE0yYR;EsExyYM;;IAEE,+BAAA;EtE0yYR;EsEzzYM;IAAgC,yBAAA;EtE4zYtC;EsE3zYM;;IAEE,6BAAA;EtE6zYR;EsE3zYM;;IAEE,+BAAA;EtE6zYR;EsE3zYM;;IAEE,gCAAA;EtE6zYR;EsE3zYM;;IAEE,8BAAA;EtE6zYR;EsE50YM;IAAgC,yBAAA;EtE+0YtC;EsE90YM;;IAEE,6BAAA;EtEg1YR;EsE90YM;;IAEE,+BAAA;EtEg1YR;EsE90YM;;IAEE,gCAAA;EtEg1YR;EsE90YM;;IAEE,8BAAA;EtEg1YR;EsE/1YM;IAAgC,2BAAA;EtEk2YtC;EsEj2YM;;IAEE,+BAAA;EtEm2YR;EsEj2YM;;IAEE,iCAAA;EtEm2YR;EsEj2YM;;IAEE,kCAAA;EtEm2YR;EsEj2YM;;IAEE,gCAAA;EtEm2YR;EsEl3YM;IAAgC,yBAAA;EtEq3YtC;EsEp3YM;;IAEE,6BAAA;EtEs3YR;EsEp3YM;;IAEE,+BAAA;EtEs3YR;EsEp3YM;;IAEE,gCAAA;EtEs3YR;EsEp3YM;;IAEE,8BAAA;EtEs3YR;EsEr4YM;IAAgC,2BAAA;EtEw4YtC;EsEv4YM;;IAEE,+BAAA;EtEy4YR;EsEv4YM;;IAEE,iCAAA;EtEy4YR;EsEv4YM;;IAEE,kCAAA;EtEy4YR;EsEv4YM;;IAEE,gCAAA;EtEy4YR;EsEx5YM;IAAgC,yBAAA;EtE25YtC;EsE15YM;;IAEE,6BAAA;EtE45YR;EsE15YM;;IAEE,+BAAA;EtE45YR;EsE15YM;;IAEE,gCAAA;EtE45YR;EsE15YM;;IAEE,8BAAA;EtE45YR;EsE36YM;IAAgC,2BAAA;EtE86YtC;EsE76YM;;IAEE,+BAAA;EtE+6YR;EsE76YM;;IAEE,iCAAA;EtE+6YR;EsE76YM;;IAEE,kCAAA;EtE+6YR;EsE76YM;;IAEE,gCAAA;EtE+6YR;EsE97YM;IAAgC,4BAAA;EtEi8YtC;EsEh8YM;;IAEE,gCAAA;EtEk8YR;EsEh8YM;;IAEE,kCAAA;EtEk8YR;EsEh8YM;;IAEE,mCAAA;EtEk8YR;EsEh8YM;;IAEE,iCAAA;EtEk8YR;EsEj9YM;IAAgC,0BAAA;EtEo9YtC;EsEn9YM;;IAEE,8BAAA;EtEq9YR;EsEn9YM;;IAEE,gCAAA;EtEq9YR;EsEn9YM;;IAEE,iCAAA;EtEq9YR;EsEn9YM;;IAEE,+BAAA;EtEq9YR;EsEp+YM;IAAgC,wBAAA;EtEu+YtC;EsEt+YM;;IAEE,4BAAA;EtEw+YR;EsEt+YM;;IAEE,8BAAA;EtEw+YR;EsEt+YM;;IAEE,+BAAA;EtEw+YR;EsEt+YM;;IAEE,6BAAA;EtEw+YR;EsEv/YM;IAAgC,wBAAA;EtE0/YtC;EsEz/YM;;IAEE,4BAAA;EtE2/YR;EsEz/YM;;IAEE,8BAAA;EtE2/YR;EsEz/YM;;IAEE,+BAAA;EtE2/YR;EsEz/YM;;IAEE,6BAAA;EtE2/YR;EsE1gZM;IAAgC,yBAAA;EtE6gZtC;EsE5gZM;;IAEE,6BAAA;EtE8gZR;EsE5gZM;;IAEE,+BAAA;EtE8gZR;EsE5gZM;;IAEE,gCAAA;EtE8gZR;EsE5gZM;;IAEE,8BAAA;EtE8gZR;EsEtgZM;IAAwB,2BAAA;EtEygZ9B;EsExgZM;;IAEE,+BAAA;EtE0gZR;EsExgZM;;IAEE,iCAAA;EtE0gZR;EsExgZM;;IAEE,kCAAA;EtE0gZR;EsExgZM;;IAEE,gCAAA;EtE0gZR;EsEzhZM;IAAwB,0BAAA;EtE4hZ9B;EsE3hZM;;IAEE,8BAAA;EtE6hZR;EsE3hZM;;IAEE,gCAAA;EtE6hZR;EsE3hZM;;IAEE,iCAAA;EtE6hZR;EsE3hZM;;IAEE,+BAAA;EtE6hZR;EsE5iZM;IAAwB,wBAAA;EtE+iZ9B;EsE9iZM;;IAEE,4BAAA;EtEgjZR;EsE9iZM;;IAEE,8BAAA;EtEgjZR;EsE9iZM;;IAEE,+BAAA;EtEgjZR;EsE9iZM;;IAEE,6BAAA;EtEgjZR;EsE/jZM;IAAwB,0BAAA;EtEkkZ9B;EsEjkZM;;IAEE,8BAAA;EtEmkZR;EsEjkZM;;IAEE,gCAAA;EtEmkZR;EsEjkZM;;IAEE,iCAAA;EtEmkZR;EsEjkZM;;IAEE,+BAAA;EtEmkZR;EsEllZM;IAAwB,wBAAA;EtEqlZ9B;EsEplZM;;IAEE,4BAAA;EtEslZR;EsEplZM;;IAEE,8BAAA;EtEslZR;EsEplZM;;IAEE,+BAAA;EtEslZR;EsEplZM;;IAEE,6BAAA;EtEslZR;EsErmZM;IAAwB,wBAAA;EtEwmZ9B;EsEvmZM;;IAEE,4BAAA;EtEymZR;EsEvmZM;;IAEE,8BAAA;EtEymZR;EsEvmZM;;IAEE,+BAAA;EtEymZR;EsEvmZM;;IAEE,6BAAA;EtEymZR;EsExnZM;IAAwB,uBAAA;EtE2nZ9B;EsE1nZM;;IAEE,2BAAA;EtE4nZR;EsE1nZM;;IAEE,6BAAA;EtE4nZR;EsE1nZM;;IAEE,8BAAA;EtE4nZR;EsE1nZM;;IAEE,4BAAA;EtE4nZR;EsE3oZM;IAAwB,uBAAA;EtE8oZ9B;EsE7oZM;;IAEE,2BAAA;EtE+oZR;EsE7oZM;;IAEE,6BAAA;EtE+oZR;EsE7oZM;;IAEE,8BAAA;EtE+oZR;EsE7oZM;;IAEE,4BAAA;EtE+oZR;EsE9pZM;IAAwB,yBAAA;EtEiqZ9B;EsEhqZM;;IAEE,6BAAA;EtEkqZR;EsEhqZM;;IAEE,+BAAA;EtEkqZR;EsEhqZM;;IAEE,gCAAA;EtEkqZR;EsEhqZM;;IAEE,8BAAA;EtEkqZR;EsEjrZM;IAAwB,uBAAA;EtEorZ9B;EsEnrZM;;IAEE,2BAAA;EtEqrZR;EsEnrZM;;IAEE,6BAAA;EtEqrZR;EsEnrZM;;IAEE,8BAAA;EtEqrZR;EsEnrZM;;IAEE,4BAAA;EtEqrZR;EsEpsZM;IAAwB,yBAAA;EtEusZ9B;EsEtsZM;;IAEE,6BAAA;EtEwsZR;EsEtsZM;;IAEE,+BAAA;EtEwsZR;EsEtsZM;;IAEE,gCAAA;EtEwsZR;EsEtsZM;;IAEE,8BAAA;EtEwsZR;EsEvtZM;IAAwB,uBAAA;EtE0tZ9B;EsEztZM;;IAEE,2BAAA;EtE2tZR;EsEztZM;;IAEE,6BAAA;EtE2tZR;EsEztZM;;IAEE,8BAAA;EtE2tZR;EsEztZM;;IAEE,4BAAA;EtE2tZR;EsE1uZM;IAAwB,yBAAA;EtE6uZ9B;EsE5uZM;;IAEE,6BAAA;EtE8uZR;EsE5uZM;;IAEE,+BAAA;EtE8uZR;EsE5uZM;;IAEE,gCAAA;EtE8uZR;EsE5uZM;;IAEE,8BAAA;EtE8uZR;EsE7vZM;IAAwB,0BAAA;EtEgwZ9B;EsE/vZM;;IAEE,8BAAA;EtEiwZR;EsE/vZM;;IAEE,gCAAA;EtEiwZR;EsE/vZM;;IAEE,iCAAA;EtEiwZR;EsE/vZM;;IAEE,+BAAA;EtEiwZR;EsEhxZM;IAAwB,0BAAA;EtEmxZ9B;EsElxZM;;IAEE,8BAAA;EtEoxZR;EsElxZM;;IAEE,gCAAA;EtEoxZR;EsElxZM;;IAEE,iCAAA;EtEoxZR;EsElxZM;;IAEE,+BAAA;EtEoxZR;EsEnyZM;IAAwB,wBAAA;EtEsyZ9B;EsEryZM;;IAEE,4BAAA;EtEuyZR;EsEryZM;;IAEE,8BAAA;EtEuyZR;EsEryZM;;IAEE,+BAAA;EtEuyZR;EsEryZM;;IAEE,6BAAA;EtEuyZR;EsEtzZM;IAAwB,wBAAA;EtEyzZ9B;EsExzZM;;IAEE,4BAAA;EtE0zZR;EsExzZM;;IAEE,8BAAA;EtE0zZR;EsExzZM;;IAEE,+BAAA;EtE0zZR;EsExzZM;;IAEE,6BAAA;EtE0zZR;EsEz0ZM;IAAwB,yBAAA;EtE40Z9B;EsE30ZM;;IAEE,6BAAA;EtE60ZR;EsE30ZM;;IAEE,+BAAA;EtE60ZR;EsE30ZM;;IAEE,gCAAA;EtE60ZR;EsE30ZM;;IAEE,8BAAA;EtE60ZR;EsEv0ZE;IAAmB,uBAAA;EtE00ZrB;EsEz0ZE;;IAEE,2BAAA;EtE20ZJ;EsEz0ZE;;IAEE,6BAAA;EtE20ZJ;EsEz0ZE;;IAEE,8BAAA;EtE20ZJ;EsEz0ZE;;IAEE,4BAAA;EtE20ZJ;AACF;AuE54ZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AvE44ZJ;;AwEt5ZA;EAAkB,4GAAA;AxE05ZlB;;AwEt5ZA;EAAiB,8BAAA;AxE05ZjB;;AwEz5ZA;EAAiB,8BAAA;AxE65ZjB;;AwE55ZA;EAAiB,8BAAA;AxEg6ZjB;;AwE/5ZA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzE46ZF;;AwE75ZI;EAAwB,2BAAA;AxEi6Z5B;;AwEh6ZI;EAAwB,4BAAA;AxEo6Z5B;;AwEn6ZI;EAAwB,6BAAA;AxEu6Z5B;;AgBl4ZI;EwDvCA;IAAwB,2BAAA;ExE86Z1B;EwE76ZE;IAAwB,4BAAA;ExEg7Z1B;EwE/6ZE;IAAwB,6BAAA;ExEk7Z1B;AACF;AgB94ZI;EwDvCA;IAAwB,2BAAA;ExEy7Z1B;EwEx7ZE;IAAwB,4BAAA;ExE27Z1B;EwE17ZE;IAAwB,6BAAA;ExE67Z1B;AACF;AgBz5ZI;EwDvCA;IAAwB,2BAAA;ExEo8Z1B;EwEn8ZE;IAAwB,4BAAA;ExEs8Z1B;EwEr8ZE;IAAwB,6BAAA;ExEw8Z1B;AACF;AgBp6ZI;EwDvCA;IAAwB,2BAAA;ExE+8Z1B;EwE98ZE;IAAwB,4BAAA;ExEi9Z1B;EwEh9ZE;IAAwB,6BAAA;ExEm9Z1B;AACF;AwE98ZA;EAAmB,oCAAA;AxEi9ZnB;;AwEh9ZA;EAAmB,oCAAA;AxEo9ZnB;;AwEn9ZA;EAAmB,qCAAA;AxEu9ZnB;;AwEn9ZA;EAAuB,2BAAA;AxEu9ZvB;;AwEt9ZA;EAAuB,+BAAA;AxE09ZvB;;AwEz9ZA;EAAuB,2BAAA;AxE69ZvB;;AwE59ZA;EAAuB,2BAAA;AxEg+ZvB;;AwE/9ZA;EAAuB,8BAAA;AxEm+ZvB;;AwEl+ZA;EAAuB,6BAAA;AxEs+ZvB;;AwEl+ZA;EAAc,sBAAA;AxEs+Zd;;A0E7gaE;EACE,yBAAA;A1EghaJ;;AMtgaE;EoELM,yBAAA;A1E+gaR;;A0ErhaE;EACE,yBAAA;A1EwhaJ;;AM9gaE;EoELM,yBAAA;A1EuhaR;;A0E7haE;EACE,yBAAA;A1EgiaJ;;AMthaE;EoELM,yBAAA;A1E+haR;;A0EriaE;EACE,yBAAA;A1EwiaJ;;AM9haE;EoELM,yBAAA;A1EuiaR;;A0E7iaE;EACE,yBAAA;A1EgjaJ;;AMtiaE;EoELM,yBAAA;A1E+iaR;;A0ErjaE;EACE,yBAAA;A1EwjaJ;;AM9iaE;EoELM,yBAAA;A1EujaR;;A0E7jaE;EACE,yBAAA;A1EgkaJ;;AMtjaE;EoELM,yBAAA;A1E+jaR;;A0ErkaE;EACE,yBAAA;A1EwkaJ;;AM9jaE;EoELM,uBAAA;A1EukaR;;A0E7kaE;EACE,yBAAA;A1EglaJ;;AMtkaE;EoELM,yBAAA;A1E+kaR;;A0ErlaE;EACE,sBAAA;A1EwlaJ;;AM9kaE;EoELM,yBAAA;A1EulaR;;A0E7laE;EACE,sBAAA;A1EgmaJ;;AMtlaE;EoELM,yBAAA;A1E+laR;;A0ErmaE;EACE,uBAAA;A1EwmaJ;;AM9laE;EoELM,uBAAA;A1EumaR;;AwEhkaA;EAAa,yBAAA;AxEokab;;AwEnkaA;EAAc,yBAAA;AxEukad;;AwErkaA;EAAiB,oCAAA;AxEykajB;;AwExkaA;EAAiB,0CAAA;AxE4kajB;;AwExkaA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A3EmoaF;;AwE5kaA;EAAwB,gCAAA;AxEglaxB;;AwE9kaA;EACE,iCAAA;EACA,gCAAA;AxEilaF;;AwE5kaA;EAAc,yBAAA;AxEglad;;A4EjpaA;EACE,8BAAA;A5EopaF;;A4EjpaA;EACE,6BAAA;A5EopaF;;A6EppaE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E7EopaJ;E6EhpaI;IACE,0BAAA;E7EkpaN;E6EzoaE;IACE,6BAAA;E7E2oaJ;E6E7naE;IACE,gCAAA;E7E+naJ;E6E7naE;;IAEE,yBAAA;IACA,wBAAA;E7E+naJ;E6E5naE;;IAEE,wBAAA;E7E8naJ;E6E3naE;;;IAGE,UAAA;IACA,SAAA;E7E6naJ;E6E1naE;;IAEE,uBAAA;E7E4naJ;E6EpnaE;IACE,QxE2iC8B;EL2kYlC;E6EpnaE;IACE,2BAAA;E7EsnaJ;E6EpnaE;IACE,2BAAA;E7EsnaJ;E6ElnaE;IACE,aAAA;E7EonaJ;E6ElnaE;IACE,sBAAA;E7EonaJ;E6EjnaE;IACE,oCAAA;E7EmnaJ;E6EjnaI;;IAEE,iCAAA;E7EmnaN;E6E9maI;;IAEE,oCAAA;E7EgnaN;E6E5maE;IACE,cAAA;E7E8maJ;E6E5maI;;;;IAIE,qB1EzEG;EHuraT;E6E1maE;IACE,cAAA;IACA,qB1E/EK;EH2raT;AACF;A8E3uaA;EACI,SAAA;A9E6uaJ;;A8E1uaA;;;EAGI,cAAA;A9E6uaJ;;A8E1uaA;EACI,gBAAA;A9E6uaJ;;AwDtvaI;EACI,oCAAA;EACA,yDAAA;AxDyvaR;;AM7uaE;;;EkDPU,oCAAA;AxD0vaZ;;AwDjwaI;EACI,oCAAA;EACA,yDAAA;AxDowaR;;AMxvaE;;;EkDPU,oCAAA;AxDqwaZ;;AwD5waI;EACI,oCAAA;EACA,yDAAA;AxD+waR;;AMnwaE;;;EkDPU,oCAAA;AxDgxaZ;;AwDvxaI;EACI,oCAAA;EACA,yDAAA;AxD0xaR;;AM9waE;;;EkDPU,oCAAA;AxD2xaZ;;AwDlyaI;EACI,oCAAA;EACA,yDAAA;AxDqyaR;;AMzxaE;;;EkDPU,oCAAA;AxDsyaZ;;AwD7yaI;EACI,oCAAA;EACA,yDAAA;AxDgzaR;;AMpyaE;;;EkDPU,oCAAA;AxDizaZ;;AwDxzaI;EACI,oCAAA;EACA,yDAAA;AxD2zaR;;AM/yaE;;;EkDPU,oCAAA;AxD4zaZ;;AwDn0aI;EACI,oCAAA;EACA,yDAAA;AxDs0aR;;AM1zaE;;;EkDPU,oCAAA;AxDu0aZ;;AwD90aI;EACI,oCAAA;EACA,yDAAA;AxDi1aR;;AMr0aE;;;EkDPU,oCAAA;AxDk1aZ;;AwDz1aI;EACI,oCAAA;EACA,yDAAA;AxD41aR;;AMh1aE;;;EkDPU,oCAAA;AxD61aZ;;AwDp2aI;EACI,iCAAA;EACA,yDAAA;AxDu2aR;;AM31aE;;;EkDPU,oCAAA;AxDw2aZ;;AwD/2aI;EACI,oCAAA;EACA,yDAAA;AxDk3aR;;AMt2aE;;;EkDPU,oCAAA;AxDm3aZ;;AwD13aI;EACI,oCAAA;EACA,yDAAA;AxD63aR;;AMj3aE;;;EkDPU,oCAAA;AxD83aZ;;AwDr4aI;EACI,oCAAA;EACA,yDAAA;AxDw4aR;;AM53aE;;;EkDPU,oCAAA;AxDy4aZ;;AwDh5aI;EACI,oCAAA;EACA,yDAAA;AxDm5aR;;AMv4aE;;;EkDPU,oCAAA;AxDo5aZ;;AwD94aI;EACI,sEAAA;AxDi5aR;;AwDl5aI;EACI,sEAAA;AxDq5aR;;AwDt5aI;EACI,sEAAA;AxDy5aR;;AwD15aI;EACI,sEAAA;AxD65aR;;AwD95aI;EACI,sEAAA;AxDi6aR;;AwDl6aI;EACI,sEAAA;AxDq6aR;;AwDt6aI;EACI,sEAAA;AxDy6aR;;AwD16aI;EACI,sEAAA;AxD66aR;;AwD96aI;EACI,sEAAA;AxDi7aR;;AwDl7aI;EACI,iEAAA;AxDq7aR;;AwDt7aI;EACI,iEAAA;AxDy7aR;;AwD17aI;EACI,kEAAA;AxD67aR;;AwD97aI;EACI,sEAAA;AxDi8aR;;AwDl8aI;EACI,sEAAA;AxDq8aR;;AwDt8aI;EACI,sEAAA;AxDy8aR;;AwD18aI;EACI,sEAAA;AxD68aR;;AwD98aI;EACI,sEAAA;AxDi9aR;;AwDl9aI;EACI,sEAAA;AxDq9aR;;AwDt9aI;EACI,sEAAA;AxDy9aR;;AwD19aI;EACI,sEAAA;AxD69aR;;AwD99aI;EACI,sEAAA;AxDi+aR;;AwDl+aI;EACI,sEAAA;AxDq+aR;;AwDt+aI;EACI,iEAAA;AxDy+aR;;AwD1+aI;EACI,sEAAA;AxD6+aR;;AwD9+aI;EACI,sEAAA;AxDi/aR;;AwDl/aI;EACI,sEAAA;AxDq/aR;;AwDt/aI;EACI,sEAAA;AxDy/aR;;AwDp/aI;EACI,mDAAA;AxDu/aR;;AM7/aE;;;EkDWU,mDAAA;AxDw/aZ;;AwD9/aI;EACI,qDAAA;AxDigbR;;AMvgbE;;;EkDWU,qDAAA;AxDkgbZ;;AwDxgbI;EACI,oDAAA;AxD2gbR;;AMjhbE;;;EkDWU,oDAAA;AxD4gbZ;;AwDlhbI;EACI,oDAAA;AxDqhbR;;AM3hbE;;;EkDWU,oDAAA;AxDshbZ;;AwD5hbI;EACI,mDAAA;AxD+hbR;;AMribE;;;EkDWU,kDAAA;AxDgibZ;;AwDtibI;EACI,mDAAA;AxDyibR;;AM/ibE;;;EkDWU,mDAAA;AxD0ibZ;;AwDhjbI;EACI,qDAAA;AxDmjbR;;AMzjbE;;;EkDWU,qDAAA;AxDojbZ;;AwD1jbI;EACI,kDAAA;AxD6jbR;;AMnkbE;;;EkDWU,+CAAA;AxD8jbZ;;AwDpkbI;EACI,kDAAA;AxDukbR;;AM7kbE;;;EkDWU,iDAAA;AxDwkbZ;;AwD9kbI;EACI,qDAAA;AxDilbR;;AMvlbE;;;EkDWU,qDAAA;AxDklbZ;;AwDxlbI;EACI,qDAAA;AxD2lbR;;AMjmbE;;;EkDWU,qDAAA;AxD4lbZ;;AwDlmbI;EACI,+CAAA;AxDqmbR;;AM3mbE;;;EkDWU,+CAAA;AxDsmbZ;;AwD/nbI;EACI,oCAAA;EACA,yDAAA;AxDkobR;;AMtnbE;;;EkDPU,oCAAA;AxDmobZ;;AwD1obI;EACI,oCAAA;EACA,yDAAA;AxD6obR;;AMjobE;;;EkDPU,oCAAA;AxD8obZ;;AwDrpbI;EACI,oCAAA;EACA,yDAAA;AxDwpbR;;AM5obE;;;EkDPU,oCAAA;AxDypbZ;;AwDhqbI;EACI,oCAAA;EACA,yDAAA;AxDmqbR;;AMvpbE;;;EkDPU,oCAAA;AxDoqbZ;;AwD3qbI;EACI,kCAAA;EACA,yDAAA;AxD8qbR;;AMlqbE;;;EkDPU,kCAAA;AxD+qbZ;;AwDzqbI;EACI,sEAAA;AxD4qbR;;AwD7qbI;EACI,sEAAA;AxDgrbR;;AwDjrbI;EACI,sEAAA;AxDorbR;;AwDrrbI;EACI,sEAAA;AxDwrbR;;AwDzrbI;EACI,sEAAA;AxD4rbR;;AwD7rbI;EACI,sEAAA;AxDgsbR;;AwDjsbI;EACI,sEAAA;AxDosbR;;AwDrsbI;EACI,sEAAA;AxDwsbR;;AwDzsbI;EACI,sEAAA;AxD4sbR;;AwD7sbI;EACI,iEAAA;AxDgtbR;;AwDjtbI;EACI,iEAAA;AxDotbR;;AwDrtbI;EACI,kEAAA;AxDwtbR;;A+EjsbI;EACI,a1EoCO;ALgqbf;;A+EjsbI;EACI,e1EgCO;ALoqbf;;A+EzsbI;EACI,a1EoCO;ALwqbf;;A+EzsbI;EACI,e1EgCO;AL4qbf;;A+EjtbI;EACI,a1EoCO;ALgrbf;;A+EjtbI;EACI,e1EgCO;ALorbf;;A+EztbI;EACI,a1EoCO;ALwrbf;;A+EztbI;EACI,e1EgCO;AL4rbf;;A+EjubI;EACI,a1EoCO;ALgsbf;;A+EjubI;EACI,e1EgCO;ALosbf;;A+EzubI;EACI,a1EoCO;ALwsbf;;A+EzubI;EACI,e1EgCO;AL4sbf;;A+EjvbI;EACI,a1EoCO;ALgtbf;;A+EjvbI;EACI,e1EgCO;ALotbf;;A+EzvbI;EACI,a1EoCO;ALwtbf;;A+EzvbI;EACI,e1EgCO;AL4tbf;;A+EjwbI;EACI,a1EoCO;ALgubf;;A+EjwbI;EACI,e1EgCO;ALoubf;;A+EzwbI;EACI,U1EoCO;ALwubf;;A+EzwbI;EACI,Y1EgCO;AL4ubf;;A+EjxbI;EACI,U1EoCO;ALgvbf;;A+EjxbI;EACI,Y1EgCO;ALovbf;;A+EzxbI;EACI,W1EoCO;ALwvbf;;A+EzxbI;EACI,a1EgCO;AL4vbf;;A+ExxbA;EACC,iBAAA;A/E2xbD;;AgFt0bA;EACC,oCAAA;EACA,sBAAA;AhFy0bD;AgFv0bC;EACO,4BAAA;AhFy0bR;;AgFl0bA;EACC,uCAAA;AhFq0bD;;AgFl0bA;EACC,uCAAA;AhFq0bD;;AgF/zbA;EACI;IACI,0BAAA;EhFk0bN;EgFh0bE;IACI,2BAAA;EhFk0bN;EgFh0bE;IACI,0BAAA;EhFk0bN;AACF;AgF/zbA;EACI;IACI,0BAAA;EhFi0bN;EgF/zbE;IACI,2BAAA;EhFi0bN;EgF/zbE;IACI,0BAAA;EhFi0bN;AACF;AgF9zbA;EACI;IACI,0BAAA;EhFg0bN;EgF9zbE;IACI,0BAAA;EhFg0bN;EgF9zbE;IACI,0BAAA;EhFg0bN;AACF;AiFr3bI;EAEI,WAAA;EACA,cAAA;AjFs3bR;AiFp3bI;EACI,WAAA;AjFs3bR;;AkFj4bA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;AlFo4bJ;;AmFt4bA;EACI,uBAAA;AnFy4bJ;;AmFv4bA;EACI,uBAAA;AnF04bJ;;AmFx4bA;EACI,uBAAA;AnF24bJ;;AmFz4bA;EACI,uBAAA;AnF44bJ;;AmF14bA;EACI,uBAAA;AnF64bJ;;AmF34bA;EACI,uBAAA;AnF84bJ;;AmF54bA;EACI,uBAAA;AnF+4bJ;;AmF74bA;EACI,uBAAA;AnFg5bJ;;AmF94bA;EACI,uBAAA;AnFi5bJ;;AmF/4bA;EACI,qBAAA;AnFk5bJ;;AoF/6bA;EACI,4BAAA;ApFk7bJ;;AoF/6bA;EACI,2BAAA;ApFk7bJ;;AqFp7bC;EACC,MhFiIQ;ALszbV;;AqFr7bC;EACC,QhF8HQ;AL0zbV;;AqFt7bC;EACC,ShF2HQ;AL8zbV;;AqFv7bC;EACC,OhFwHQ;ALk0bV;;AqFp8bC;EACC,YhFiIQ;ALs0bV;;AqFr8bC;EACC,chF8HQ;AL00bV;;AqFt8bC;EACC,ehF2HQ;AL80bV;;AqFv8bC;EACC,ahFwHQ;ALk1bV;;AqFp9bC;EACC,WhFiIQ;ALs1bV;;AqFr9bC;EACC,ahF8HQ;AL01bV;;AqFt9bC;EACC,chF2HQ;AL81bV;;AqFv9bC;EACC,YhFwHQ;ALk2bV;;AqFp+bC;EACC,ShFiIQ;ALs2bV;;AqFr+bC;EACC,WhF8HQ;AL02bV;;AqFt+bC;EACC,YhF2HQ;AL82bV;;AqFv+bC;EACC,UhFwHQ;ALk3bV;;AqFp/bC;EACC,WhFiIQ;ALs3bV;;AqFr/bC;EACC,ahF8HQ;AL03bV;;AqFt/bC;EACC,chF2HQ;AL83bV;;AqFv/bC;EACC,YhFwHQ;ALk4bV;;AqFpgcC;EACC,ShFiIQ;ALs4bV;;AqFrgcC;EACC,WhF8HQ;AL04bV;;AqFtgcC;EACC,YhF2HQ;AL84bV;;AqFvgcC;EACC,UhFwHQ;ALk5bV;;AqFphcC;EACC,WhFiIQ;ALs5bV;;AqFrhcC;EACC,ahF8HQ;AL05bV;;AqFthcC;EACC,chF2HQ;AL85bV;;AqFvhcC;EACC,YhFwHQ;ALk6bV;;AqFpicC;EACC,UhFiIQ;ALs6bV;;AqFricC;EACC,YhF8HQ;AL06bV;;AqFticC;EACC,ahF2HQ;AL86bV;;AqFvicC;EACC,WhFwHQ;ALk7bV;;AqFpjcC;EACC,UhFiIQ;ALs7bV;;AqFrjcC;EACC,YhF8HQ;AL07bV;;AqFtjcC;EACC,ahF2HQ;AL87bV;;AqFvjcC;EACC,WhFwHQ;ALk8bV;;AqFpkcC;EACC,YhFiIQ;ALs8bV;;AqFrkcC;EACC,chF8HQ;AL08bV;;AqFtkcC;EACC,ehF2HQ;AL88bV;;AqFvkcC;EACC,ahFwHQ;ALk9bV;;AqFplcC;EACC,UhFiIQ;ALs9bV;;AqFrlcC;EACC,YhF8HQ;AL09bV;;AqFtlcC;EACC,ahF2HQ;AL89bV;;AqFvlcC;EACC,WhFwHQ;ALk+bV;;AqFpmcC;EACC,YhFiIQ;ALs+bV;;AqFrmcC;EACC,chF8HQ;AL0+bV;;AqFtmcC;EACC,ehF2HQ;AL8+bV;;AqFvmcC;EACC,ahFwHQ;ALk/bV;;AqFpncC;EACC,UhFiIQ;ALs/bV;;AqFrncC;EACC,YhF8HQ;AL0/bV;;AqFtncC;EACC,ahF2HQ;AL8/bV;;AqFvncC;EACC,WhFwHQ;ALkgcV;;AqFpocC;EACC,YhFiIQ;ALsgcV;;AqFrocC;EACC,chF8HQ;AL0gcV;;AqFtocC;EACC,ehF2HQ;AL8gcV;;AqFvocC;EACC,ahFwHQ;ALkhcV;;AqFppcC;EACC,ahFiIQ;ALshcV;;AqFrpcC;EACC,ehF8HQ;AL0hcV;;AqFtpcC;EACC,gBhF2HQ;AL8hcV;;AqFvpcC;EACC,chFwHQ;ALkicV;;AqFpqcC;EACC,WhFiIQ;ALsicV;;AqFrqcC;EACC,ahF8HQ;AL0icV;;AqFtqcC;EACC,chF2HQ;AL8icV;;AqFvqcC;EACC,YhFwHQ;ALkjcV;;AqFprcC;EACC,ShFiIQ;ALsjcV;;AqFrrcC;EACC,WhF8HQ;AL0jcV;;AqFtrcC;EACC,YhF2HQ;AL8jcV;;AqFvrcC;EACC,UhFwHQ;ALkkcV;;AqFpscC;EACC,ShFiIQ;ALskcV;;AqFrscC;EACC,WhF8HQ;AL0kcV;;AqFtscC;EACC,YhF2HQ;AL8kcV;;AqFvscC;EACC,UhFwHQ;ALklcV;;AqFptcC;EACC,UhFiIQ;ALslcV;;AqFrtcC;EACC,YhF8HQ;AL0lcV;;AqFttcC;EACC,ahF2HQ;AL8lcV;;AqFvtcC;EACC,WhFwHQ;ALkmcV;;AqFttcA;EACC,SAAA;EACA,2BAAA;ArFytcD;;AsF5ucA;EACC,wBAAA;AtF+ucD;;AuFhvcA;EACI,gBAAA;AvFmvcJ;;AgB5rcI;EuEnDA;IACI,aAAA;EvFmvcN;AACF;AgBlscI;EuE9CA;IACI,aAAA;EvFmvcN;AACF;AgBvscI;EuEzCA;IACI,aAAA;EvFmvcN;AACF;AuFhvcA;EACI,gBAAA;AvFkvcJ;;AuF5ucA;EAWI;IACI,6BAAA;EvFqucN;EuFnucE;IACI,+BAAA;EvFqucN;EuFnucE;IACI,gCAAA;EvFqucN;EuFnucE;IACI,8BAAA;EvFqucN;EuFnucE;IACI,6BAAA;EvFqucN;EuFnucE;IACI,gCAAA;EvFqucN;EuFnucE;IACI,6BAAA;EvFqucN;EuFnucE;IACI,gCAAA;EvFqucN;EuFnucE;IACI,6BAAA;EvFqucN;EuFnucE;IACI,gCAAA;EvFqucN;EuF/tcE;IACI,6BAAA;EvFiucN;EuF/tcE;IACI,gCAAA;EvFiucN;EuF/tcE;IACI,6BAAA;EvFiucN;EuF/tcE;IACI,gCAAA;EvFiucN;EuF/tcE;IACI,6BAAA;EvFiucN;EuF/tcE;IACI,gCAAA;EvFiucN;EuF/tcE;IACI,6BAAA;EvFiucN;EuF/tcE;IACI,gCAAA;EvFiucN;EuF/tcE;IACI,6BAAA;EvFiucN;EuF/tcE;IACI,gCAAA;EvFiucN;AACF;AwFr0cA;EAEQ,0BrF+UsB;AHu/b9B;;AwFh0cA;EACC,4DAAA;AxFm0cD;;AwFh0cA;EACC,2DAAA;AxFm0cD;;AwFh0cA;EACC,0DAAA;AxFm0cD;;AwFh0cA;EACC,2BAAA;AxFm0cD;;AyF31cA;EAAmB,2BAAA;AzF+1cnB;;AyF91cA;EAAmB,2BAAA;AzFk2cnB;;AyFj2cA;EAAmB,2BAAA;AzFq2cnB;;AyFp2cA;EAAmB,2BAAA;AzFw2cnB;;AyFv2cA;EAAmB,2BAAA;AzF22cnB;;AyF12cA;EAAmB,2BAAA;AzF82cnB;;AyF72cA;EAAmB,2BAAA;AzFi3cnB;;AyF52cA;EAAkB,0BAAA;AzFg3clB;;AyF/2cA;EAAgB,6BAAA;AzFm3chB;;AyF92cA;EAAW,6BAAA;AzFk3cX;;AyFj3cA;EAAW,8BAAA;AzFq3cX;;AyFp3cA;EAAW,6BAAA;AzFw3cX;;AyFv3cA;EAAW,4BAAA;AzF23cX;;AyFt3cA;EAAU,cAAA;AzF03cV;;AyFz3cA;EAAU,gBAAA;AzF63cV;;AyF53cA;EAAU,gBAAA;AzFg4cV;;AyF/3cA;EAAU,gBAAA;AzFm4cV;;AyFl4cA;EAAU,gBAAA;AzFs4cV;;AyFr4cA;EAAU,gBAAA;AzFy4cV;;AyFx4cA;EAAU,gBAAA;AzF44cV;;AyF34cA;EAAU,gBAAA;AzF+4cV;;AyF94cA;EAAU,gBAAA;AzFk5cV;;AyF74cA;EAAQ,yBAAA;AzFi5cR;;AyFh5cA;EAAS,0BAAA;AzFo5cT;;AyFn5cA;EAAQ,wBAAA;AzFu5cR;;A0E57cE;EACE,yBAAA;A1E+7cJ;;AMr7cE;EoELM,yBAAA;A1E87cR;;A0Ep8cE;EACE,yBAAA;A1Eu8cJ;;AM77cE;EoELM,yBAAA;A1Es8cR;;A0E58cE;EACE,yBAAA;A1E+8cJ;;AMr8cE;EoELM,yBAAA;A1E88cR;;A0Ep9cE;EACE,yBAAA;A1Eu9cJ;;AM78cE;EoELM,yBAAA;A1Es9cR;;A0E59cE;EACE,yBAAA;A1E+9cJ;;AMr9cE;EoELM,yBAAA;A1E89cR;;A0Ep+cE;EACE,yBAAA;A1Eu+cJ;;AM79cE;EoELM,yBAAA;A1Es+cR;;A0E5+cE;EACE,yBAAA;A1E++cJ;;AMr+cE;EoELM,yBAAA;A1E8+cR;;A0Ep/cE;EACE,yBAAA;A1Eu/cJ;;AM7+cE;EoELM,yBAAA;A1Es/cR;;A0E5/cE;EACE,yBAAA;A1E+/cJ;;AMr/cE;EoELM,yBAAA;A1E8/cR;;A0EpgdE;EACE,yBAAA;A1EugdJ;;AM7/cE;EoELM,yBAAA;A1EsgdR;;A0E5gdE;EACE,sBAAA;A1E+gdJ;;AMrgdE;EoELM,yBAAA;A1E8gdR;;A0EphdE;EACE,yBAAA;A1EuhdJ;;AM7gdE;EoELM,yBAAA;A1EshdR;;A0E5hdE;EACE,yBAAA;A1E+hdJ;;AMrhdE;EoELM,yBAAA;A1E8hdR;;A0EpidE;EACE,yBAAA;A1EuidJ;;AM7hdE;EoELM,yBAAA;A1EsidR;;A0E5idE;EACE,yBAAA;A1E+idJ;;AMridE;EoELM,yBAAA;A1E8idR;;AgB7/cI;E0EtDH;IACC,kFAAA;E1FujdA;E0FrjdD;IACC,kFAAA;E1FujdA;AACF;A2F9jdA;EACI,mBxF8V0B;AHkuc9B;;A2F3jdA;EACI,gBxF6V0B;EwF5V1B,oBxFuW0B;EwFtW1B,mBAAA;A3F8jdJ;;A2FzjdA;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;A3F4jdJ;A2F1jdI;EACI,kBAAA;EACA,QAAA;A3F4jdR;;A2FtjdA;EACI,qBAAA;EACA,sBAAA;A3FyjdJ;;A2FljdI;EACI,WxFGG;EwFFH,kDAAA;A3FqjdR;;A4F3ldI;EACI,QAAA;EACA,azFsxBU;EyFrxBV,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,UAAA;A5F8ldR;A4F5ldQ;EAEI,+BAAA;EACA,qBAAA;A5F6ldZ;AgBpidI;E4EpEA;IAeQ,SAAA;IACA,aAAA;E5F6ldV;AACF;A4F3ldQ;EACI,iBAAA;EACA,6BAAA;EACA,+BAAA;A5F6ldZ;A4FxldY;EACI,6BAAA;EACA,+BAAA;A5F0ldhB;;A6FtndA;EACC,W1FsCU;E0FrCV,yB1F0CU;E0FzCV,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;A7FyndD;A6FvndI;EACC,WAAA;EACA,kBAAA;A7FyndL;A6FtndI;EACC,qBAAA;EACA,oBAAA;A7FwndL;;A6FjndA;EACC,WAAA;EACA,YAAA;EACA,mB1FiU6B;AHmzc9B;;A6FjndA;EACC,WAAA;EACA,YAAA;EACA,mB1F2T6B;AHyzc9B;;A8FrpdC;EACC,kBAAA;EACA,UAAA;EACA,sBAAA;A9FwpdF;A8FtpdE;EACC,UAAA;A9FwpdH;A8FppdC;EACC,kBAAA;A9FspdF;;A+FjqdA;EACI,yB5Fk2BgC;AHk0bpC;A+FlqdI;EACI,W5FkCG;AHkodX;;A+F7pdA;EACI,mBAAA;A/FgqdJ;;A+F7pdA;EACI,uBAAA;A/FgqdJ;;A+F1pdA;EACI,sBAAA;A/F6pdJ;A+F3pdI;EACI,QAAA;EACA,kBAAA;A/F6pdR;A+F3pdQ;EACI,0BAAA;A/F6pdZ;;A+FnpdQ;EACI,mBAAA;A/FspdZ;A+FppdQ;EACI,oBAAA;A/FspdZ;;AgGlsdA;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AhGqsdJ;;AiG7sdA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gB9F4V0B;E8F3V1B,mB9FuV0B;E8FtV1B,oBAAA;AjGgtdJ;AiG9sdI;EACI,c9FqCG;AH2qdX;AiG7sdI;EACI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AjG+sdR;AiG3sdQ;EACI,aAAA;EACA,cAAA;AjG6sdZ;AiGxsdQ;EACI,eAAA;EACA,gBAAA;AjG0sdZ;;AkG1udA;EACG,kBAAA;EACA,oB/F+f2B;E+F9f3B,0B/F6U2B;E+F5U3B,uB/FggB2B;E+F/f3B,mB/Fue2B;E+Fte3B,sBAAA;AlG6udH;AkG3udG;EtFEG,2EsFDA;EACA,2BAAA;AlG6udN;AkG1udG;EACG,oBAAA;AlG4udN;AkGtudG;;EAEG,mBAAA;AlGwudN;AkGrudG;;EAEG,oBAAA;AlGuudN;;AkG9tdG;;EACG,eAAA;EACA,wBAAA;AlGkudN;;AkG3tdA;EACG,kB/F6b2B;AHiyc9B;;AkG3tdA;EACG,mB/F2b8B;AHmycjC;;AkGvtdA;EACG,iBAAA;AlG0tdH;;AkGvtdA;EACG,cAAA;AlG0tdH;;AkGttdG;EACG,kBAAA;EACA,QAAA;AlGytdN;;AkGrtdA;EACG,gB/Fsb2B;E+Frb3B,gBAAA;AlGwtdH;AkGttdG;EACG,gBAAA;EACA,eAAA;AlGwtdN;;AkGptdA;EACG,cAAA;AlGutdH;;AmG1ydQ;EACI,WAAA;AnG6ydZ;AmGzydG;EACI,mBAAA;AnG2ydP;AmGxydG;EACI,oBAAA;AnG0ydP;;AmGnydA;EACI,eAAA;EACA,gBAAA;EACA,UAAA;AnGsydJ;;AmGnydA;EACI,gBAAA;AnGsydJ;;AmGnydA;EACI,WAAA;EACA,YAAA;AnGsydJ;;AmG7xdA;EACI,SAAA;EACA,eAAA;EACA,ehGiT0B;EgGhT1B,gBhGuT0B;EgGtT1B,iBAAA;EACA,chGGO;EgGFP,yBhGLO;EgGMP,uBhG+Q0B;EgG9Q1B,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AnGgydJ;AmG9xdI;EACI,sBhGpBG;EgGqBH,uEAAA;AnGgydR;AmG7xdI;EACI,mBAAA;EACA,aAAA;AnG+xdR;AmG5xdI;EACI,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AnG8xdR;AmG3xdI;EACI,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AnG6xdR;;AoG92dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBy3dJ;AMj3dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBk4dvG;AyBt3dI;EAIQ,2GAAA;AzBq3dZ;AyB/2dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHiwdf;AyB72dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB+4d1L;AyBx2dQ;EAGQ,gDAAA;AzBw2dhB;;AoG14dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBq5dJ;AM74dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB85dvG;AyBl5dI;EAIQ,4GAAA;AzBi5dZ;AyB34dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH6xdf;AyBz4dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB26d1L;AyBp4dQ;EAGQ,iDAAA;AzBo4dhB;;AoGt6dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBi7dJ;AMz6dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB07dvG;AyB96dI;EAIQ,2GAAA;AzB66dZ;AyBv6dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHyzdf;AyBr6dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBu8d1L;AyBh6dQ;EAGQ,gDAAA;AzBg6dhB;;AoGl8dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB68dJ;AMr8dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBs9dvG;AyB18dI;EAIQ,2GAAA;AzBy8dZ;AyBn8dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHq1df;AyBj8dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBm+d1L;AyB57dQ;EAGQ,gDAAA;AzB47dhB;;AoG99dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBy+dJ;AMj+dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBk/dvG;AyBt+dI;EAIQ,0GAAA;AzBq+dZ;AyB/9dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHi3df;AyB79dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB+/d1L;AyBx9dQ;EAGQ,+CAAA;AzBw9dhB;;AoG1/dI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBqgeJ;AM7/dE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB8gevG;AyBlgeI;EAIQ,2GAAA;AzBigeZ;AyB3/dI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AH64df;AyBz/dI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB2he1L;AyBp/dQ;EAGQ,gDAAA;AzBo/dhB;;AoGtheI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzBiieJ;AMzheE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzB0ievG;AyB9heI;EAIQ,4GAAA;AzB6heZ;AyBvheI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHy6df;AyBrheI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBuje1L;AyBhheQ;EAGQ,iDAAA;AzBghehB;;AoGljeI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzB6jeJ;AMrjeE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBskevG;AyB1jeI;EAIQ,4GAAA;AzByjeZ;AyBnjeI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHq8df;AyBjjeI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzBmle1L;AyB5ieQ;EAGQ,iDAAA;AzB4iehB;;AoG9keI;E3EPA,WAAA;EFKA,yBpBmIW;EsBtIX,qBtBsIW;ESzHT,2EaZF;AzByleJ;AMjleE;EmBLM,WAAA;EFDJ,yBEN2D;EASvD,qBAT+F;AzBkmevG;AyBtleI;EAIQ,0GAAA;AzBqleZ;AyB/keI;EAEI,WAAA;EACA,yBtBgHO;EsB/GP,qBtB+GO;AHi+df;AyB7keI;EAGI,WAAA;EACA,yBAjCwI;EAqCxI,qBArCkL;AzB+me1L;AyBxkeQ;EAGQ,+CAAA;AzBwkehB;;AqG7meA;EACI,yCAAA;ArGgneJ;;AsGlneA;EACI,kBAAA;AtGqneJ;AsGnneI;EACI,gBAAA;EACA,uBnG0TsB;EmGxTtB,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,0BnGwUsB;AH4yd9B;AsGlneQ;EACI,gCAAA;AtGoneZ;;AsG/meA;EACI,eAAA;AtGkneJ;AsGhneI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AtGkneR;AsGhneQ;EACI,eAAA;AtGkneZ;AsG/meQ;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;AtGineZ;AsG/meQ;EACI,mBAAA;EACA,cnGSD;AHwmeX;;AsG5meA;EACI,iBAAA;AtG+meJ;;AuGzpeI;EACI,4BAAA;ElFUF,0BkFTE;AvG4peR;AqB/oeM;EkFfF;IlFgBI,gBAAA;ErBkpeN;AACF;;AwGnqeI;EACI,oBAAA;AxGsqeR;AwGnqeI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;AxGqqeR;;AyG9qeA;EACI,kBAAA;EACA,atGqoBW;AH4idf;;AyG3qeA;EACI,atG+nBc;AH+idlB;;AyGxqeA;EACI,aAAA;EACA,uBAAA;EACA,kBtGwnBsB;EsGvnBtB,mBtG4U0B;EsG3U1B,kBAAA;EACA,ctG0BO;AHipeX;;AyGxqeA;EACI,oBAAA;EACA,mBAAA;AzG2qeJ;AyGzqeI;EACI,iBAAA;AzG2qeR;;AyGvqeA;EACI,qBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AzG0qeJ;;AyGpqeA;EACI,UAAA;AzGuqeJ;AyGrqeI;EACI,SAAA;EACA,SAAA;EACA,+CAAA;AzGuqeR;;AyGhqeA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AzGmqeF;;A0GlueA;EAEQ,0BvGgVsB;AHo5d9B;A0GjueI;EACI,6BvGwzB4B;EuGvzB5B,yBvGyzB4B;EuGxzB5B,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEI,0BvGmUkB;AH+5d9B;A0G9teI;EAEI,6BvG0yB4B;EuGzyB5B,yBvG2yB4B;EuG1yB5B,aAAA;A1G+teR;A0G7teQ;EACI,6BvGqyBwB;AH07cpC;;A2G7veA;EACI,kBAAA;A3GgweJ;A2G7veI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;A3G+veR;AgB/seI;E2F5CA;IAEQ,6BAAA;IACA,8BAAA;E3G6veV;AACF;;A2G5uegB;EACI,kBxG8tBI;AHihdxB;A2G7uegB;EACI,mBxG2tBI;AHohdxB;AgB5teI;E2FvBY;IACI,kBxG8tBI;EHwhdtB;E2Gpvec;IACI,mBxG2tBI;EH2hdtB;AACF;AgBpueI;E2FvBY;IACI,kBxG8tBI;EHgidtB;E2G5vec;IACI,mBxG2tBI;EHmidtB;AACF;AgB5ueI;E2FvBY;IACI,kBxG8tBI;EHwidtB;E2Gpwec;IACI,mBxG2tBI;EH2idtB;AACF;AgBpveI;E2FvBY;IACI,kBxG8tBI;EHgjdtB;E2G5wec;IACI,mBxG2tBI;EHmjdtB;AACF;;A4GnzeI;EACI,eAAA;EACA,mBzG4VsB;AH09d9B;A4GhzegB;EACI,qBzGgUY;AHk/dhC;A4GhzegB;EACI,yDvG2hB4B;ALuxdhD;A4G3yegB;EACI,qBzGsBT;AHuxeX;A4GxyegB;EACI,qCzG6kB4B;AH6tdhD;;A6Gl0eI;EACI,yBAAA;EAEI,2D1GqjB4B;AH+wdxC;A6Gh0eI;EACI,kBAAA;EACA,QAAA;A7Gk0eR;;A6G9zeA;EACI,gBAAA;A7Gi0eJ;;A6GxzeQ;EACI,SAAA;EACA,yE1G4gB4B;AH+ydxC;A6GpzegB;EACI,2E1GqgBoB;AHizdxC;A6GjzeQ;EAEI,yE1G6f4B;AHqzdxC;;A8G51eI;EACI,eAAA;EACA,mB3G4VsB;AHmge9B;A8Gz1egB;EACI,qB3GgUY;AH2hehC;A8Gz1egB;EACI,yDzG2hB4B;ALg0dhD;A8Gp1egB;EACI,qB3GsBT;AHg0eX;A8Gj1egB;EACI,qC3G6kB4B;AHswdhD;;A+G72eI;EACI,eAAA;EACA,mB5G4VsB;AHohe9B;A+G12egB;EACI,qB5GgUY;AH4iehC;A+G12egB;EACI,0D1GoiB4B;ALw0dhD;A+Gr2egB;EACI,qB5GsBT;AHi1eX;A+Gl2egB;EACI,qC5G6kB4B;AHuxdhD;;AgH/3eA;EACI,kBAAA;EACA,qBAAA;EACA,W7G+mB4B;E6G9mB5B,cAAA;AhHk4eJ;AgHh4eI;EACI,aAAA;AhHk4eR;AgH/3ea;EACG,yBAAA;AhHi4ehB;AgH/3egB;EACI,mB7GsmBY;E6GrmBZ,+BAAA;AhHi4epB;AgH33eY;EACI,yBAAA;AhH63ehB;AgHz3egB;EACI,yBAAA;AhH23epB;AgHz3eoB;EACI,yBAAA;AhH23exB;;AgHn3eA;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;AhHs3eJ;AgHn3eI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yB7GfG;E6GgBH,2D7GggBgC;AHq3dxC;;AiH96eA;;;;EAII,qBAAA;AjHi7eJ;;AiH96eA;EACI,gBAAA;AjHi7eJ;AiH/6eI;EACI,oBAAA;EACA,mB9GiVsB;AHgme9B;AiHh7eQ;;EAEI,kBAAA;EACA,eAAA;EACA,oBAAA;AjHk7eZ;;AiH76eA;EACI,kBAAA;EACA,mBAAA;EACA,c9GeO;E8GdP,mBAAA;EACA,yBAAA;EACA,gBAAA;AjHg7eJ;;AiHt6eY;EACI,cAAA;AjHy6ehB;AiHr6eQ;EACI,c9GCD;AHs6eX;AiHn6eY;;EAEI,yBAAA;AjHq6ehB;;AiH55eA;EACI,gBAAA;EACA,iB9GkQ0B;AH6pe9B;;AiH55eA;EACI,gBAAA;EACA,wB9G6P0B;AHkqe9B;;AiH55eA;EACI,gBAAA;EACA,wB9GwP0B;AHuqe9B;;AkHr+eA;EACI,mB/G+9BQ;E+G99BR,iBAAA;AlHw+eJ;AkHr+eQ;EACI,c/GsCD;E+GrCC,iBAAA;EACA,mB/GoVkB;E+GnVlB,yBAAA;EACA,gB/GuVkB;E+GtVlB,mBAAA;AlHu+eZ;AkHn+eI;;EAEI,yBAAA;AlHq+eR;AkHn+eQ;;EACI,yBAAA;AlHs+eZ;AkHl+eI;EACI,qBAAA;EACA,mBAAA;EACA,c/GiBG;E+GhBH,kB/Gm8BgB;AHiidxB;AkHl+eQ;EACI,c/GcD;AHs9eX;AkHh+eI;EACI,mB/GwTsB;AH0qe9B;;AkH19eI;EACI,W/GPG;AHo+eX;;AkHr9eI;EACI,mB/GsSsB;AHkre9B;AkHp9eQ;EACI,gBAAA;AlHs9eZ;;AkH98eA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;AlHi9eJ;AkH/8eI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AlHi9eR;AkH98eI;EACI,oBAAA;EACA,kBAAA;AlHg9eR;;AmHxifA;EACI,chH4CO;EgH3CP,mBhH0V0B;EgHzV1B,gBhH8V0B;AH6se9B;;AmHrifA;EACI,mBhHie0B;AHuke9B;AmHrifQ;EACI,chH6BD;AH0gfX;;AmH/hfA;EACI,uBAAA;AnHkifJ;;AmH/hfA;EACI,uBAAA;AnHkifJ;;AmH/hfA;EACI,2BAAA;AnHkifJ;;AmH/hfA;EACI,6BAAA;AnHkifJ;;AmH1hfA;EACI,yBhHsfoC;EgHrfpC,qBhHqfoC;EgHpfpC,gBAAA;AnH6hfJ;AmH3hfI;EACI,yBhHkfgC;AH2iexC;;AmHthfA;EACI,yEhH4eoC;EgH3epC,SAAA;EACA,iCAAA;AnHyhfJ;AmHvhfI;EACI,2EhHwegC;AHijexC;;AmHnhfA;EACI,ehHoR0B;AHkwe9B;;AoH5lfA;;EAEI,kBAAA;ApH+lfJ;AoH7lfI;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;ApHgmfR;;AoH3lfI;EACI,gBAAA;EACA,0BAAA;EACA,yBjH6lByB;AHigejC;AoH3lfI;EACI,sBjHUG;AHmlfX;AoH3lfQ;EACI,sCjH+gB4B;AH8kexC;AoHvlfQ;EACI,cjHglBqB;AHygejC;;AoHnlfI;EACI,gBAAA;EACA,0BAAA;EACA,yBjHwkByB;AH8gejC;AoHnlfI;EACI,sBjHbG;AHkmfX;AoHnlfQ;EACI,sCjHwf4B;AH6lexC;AoHhlfQ;EACI,cjH4jBqB;AHshejC;;AqHjpfA;EACC,gBlH6iBuC;EkH5iBvC,uBlH6T6B;EkH5T7B,0BlH+U6B;AHq0e9B;AqHlpfC;EACC,gBAAA;ArHopfF;AqHlpfE;EACI,cAAA;EACA,eAAA;ArHopfN;AqHlpfE;EACC,eAAA;EACA,gBAAA;ArHopfH;AqHlpfE;EACC,gBAAA;ArHopfH;;AqH/ofA;EACI,2DlHoiBoC;AH8mexC;;AqH3ofA;EACI,yElHygBoC;EkHxgBpC,SAAA;EACA,iCAAA;ArH8ofJ;AqH5ofI;;EAEI,SAAA;EACA,gBAAA;ArH8ofR;;AqHzofC;EACO,sFAAA;ArH4ofR;;AqHpofC;EACC,gBlH+fsC;AHwoexC;AqHpofC;EACI,clHVM;EkHWN,sBlHjBM;EkHkBN,sClHsfmC;AHgpexC;AqHnofC;EACC,sClHkfsC;AHmpexC;;AsHpsfA;EACI,kBAAA;AtHusfJ;;AuHxsfA;EACC,WpHibW;EoHhbX,YpHgbW;AH2xeZ;AuHzsfC;EACC,kBAAA;AvH2sfF;AuHxsfI;EACC,kBAAA;EACA,4BAAA;AvH0sfL;;AuHnsfA;EACC,WpHiac;EoHhad,YpHgac;AHsyef;AuHpsfC;EACC,kBAAA;AvHssfF;AuHnsfI;EACC,4BAAA;AvHqsfL;;AuH9rfA;EACC,WpHkZc;EoHjZd,YpHiZc;AHgzef;AuH/rfC;EACC,kBAAA;AvHisfF;AuH9rfI;EACC,4BAAA;AvHgsfL;;AuHzrfA;EACC,WpHmYc;EoHlYd,YpHkYc;AH0zef;AuH1rfC;EACC,kBAAA;AvH4rfF;AuHzrfI;EACC,4BAAA;AvH2rfL;;AwHpvfA;EACC,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxHuvfD;AwHpvfC;EACC,kBAAA;AxHsvfF;AwHlvfE;EACC,mBAAA;AxHovfH;AwH/ufE;EACC,mBAAA;AxHivfH;AwH7ufC;EACC,WAAA;EACA,YAAA;AxH+ufF;;AwHzufC;ECrCG,cAAA;EACA,0CAAA;AzHkxfJ;;AwH9ufC;ECrCG,cAAA;EACA,0CAAA;AzHuxfJ;;AwHnvfC;ECrCG,cAAA;EACA,yCAAA;AzH4xfJ;;AwHxvfC;ECrCG,cAAA;EACA,yCAAA;AzHiyfJ;;AwH7vfC;ECrCG,cAAA;EACA,0CAAA;AzHsyfJ;;AwHlwfC;ECrCG,cAAA;EACA,0CAAA;AzH2yfJ;;AwHvwfC;ECrCG,cAAA;EACA,0CAAA;AzHgzfJ;;AwH5wfC;ECrCG,cAAA;EACA,uCAAA;AzHqzfJ;;AwHjxfC;ECrCG,cAAA;EACA,wCAAA;AzH0zfJ;;AwHtxfC;ECrCG,cAAA;EACA,0CAAA;AzH+zfJ;;AwH3xfC;ECrCG,cAAA;EACA,0CAAA;AzHo0fJ;;AwHhyfC;ECrCG,YAAA;EACA,uCAAA;AzHy0fJ;;AqHv0fA;EACC,gBlH6iBuC;EkH5iBvC,uBlH6T6B;EkH5T7B,0BlH+U6B;AH2/e9B;AqHx0fC;EACC,gBAAA;ArH00fF;AqHx0fE;EACI,cAAA;EACA,eAAA;ArH00fN;AqHx0fE;EACC,eAAA;EACA,gBAAA;ArH00fH;AqHx0fE;EACC,gBAAA;ArH00fH;;AqHr0fA;EACI,2DlHoiBoC;AHoyexC;;AqHj0fA;EACI,yElHygBoC;EkHxgBpC,SAAA;EACA,iCAAA;ArHo0fJ;AqHl0fI;;EAEI,SAAA;EACA,gBAAA;ArHo0fR;;AqH/zfC;EACO,sFAAA;ArHk0fR;;AqH1zfC;EACC,gBlH+fsC;AH8zexC;AqH1zfC;EACI,clHVM;EkHWN,sBlHjBM;EkHkBN,sClHsfmC;AHs0exC;AqHzzfC;EACC,sClHkfsC;AHy0exC;;A0Ht3fI;EACI,qBAAA;E/GSJ,uBAAA;AXi3fJ;;A0Hl3fA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;A1Hq3fJ;;A0Hl3fA;EACI,SAAA;EACA,YAAA;A1Hq3fJ;A0Hn3fI;EACG,cvHoBI;EuHnBJ,gBAAA;EACA,kBAAA;A1Hq3fP;;A0Hj3fA;EACI,evH2T0B;EuH1T1B,cvHeO;AHq2fX;A0Hl3fI;EACG,YAAA;EACA,cvHQI;EuHPJ,gBAAA;A1Ho3fP;;A2H35fA;EACI,kBAAA;EACA,WAAA;EACA,axHgpBS;EwH/oBT,uBxH2T0B;AHmmf9B;;A4Hl6fA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EvGOE,0BuGNF;A5Hq6fJ;AqB35fM;EuGhBN;IvGiBQ,gBAAA;ErB85fN;AACF;;A6H56fI;EACI,aAAA;EACA,gBAAA;A7H+6fR;A6H76fI;EACI,gBAAA;A7H+6fR;;A8H37fC;EACC,WAAA;A9H87fF;A8H57fC;;EAEC,wCAAA;A9H87fF;A8H57fC;EACC,yBzHmEa;EyHlEb,WAAA;A9H87fF;A8H57fE;EACC,WAAA;A9H87fH;A8Hz7fK;EACC,W3H0BK;AHi6fX;;A8H78fC;EACC,cAAA;A9Hg9fF;A8H98fC;;EAEC,qCAAA;A9Hg9fF;A8H98fC;EACC,yBzHmEa;EyHlEb,cAAA;A9Hg9fF;A8H98fE;EACC,cAAA;A9Hg9fH;A8H38fK;EACC,W3H0BK;AHm7fX;;A8H/9fC;EACC,WAAA;A9Hk+fF;A8Hh+fC;;EAEC,wCAAA;A9Hk+fF;A8Hh+fC;EACC,yBzHmEa;EyHlEb,WAAA;A9Hk+fF;A8Hh+fE;EACC,WAAA;A9Hk+fH;A8H79fK;EACC,W3H0BK;AHq8fX;;A8Hj/fC;EACC,WAAA;A9Ho/fF;A8Hl/fC;;EAEC,wCAAA;A9Ho/fF;A8Hl/fC;EACC,yBzHmEa;EyHlEb,WAAA;A9Ho/fF;A8Hl/fE;EACC,WAAA;A9Ho/fH;A8H/+fK;EACC,W3H0BK;AHu9fX;;A8HnggBC;EACC,WAAA;A9HsggBF;A8HpggBC;;EAEC,wCAAA;A9HsggBF;A8HpggBC;EACC,yBzHmEa;EyHlEb,WAAA;A9HsggBF;A8HpggBE;EACC,WAAA;A9HsggBH;A8HjggBK;EACC,W3H0BK;AHy+fX;;A8HrhgBC;EACC,WAAA;A9HwhgBF;A8HthgBC;;EAEC,wCAAA;A9HwhgBF;A8HthgBC;EACC,yBzHmEa;EyHlEb,WAAA;A9HwhgBF;A8HthgBE;EACC,WAAA;A9HwhgBH;A8HnhgBK;EACC,W3H0BK;AH2/fX;;A8HvigBC;EACC,WAAA;A9H0igBF;A8HxigBC;;EAEC,wCAAA;A9H0igBF;A8HxigBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H0igBF;A8HxigBE;EACC,WAAA;A9H0igBH;A8HrigBK;EACC,W3H0BK;AH6ggBX;;A8HzjgBC;EACC,WAAA;A9H4jgBF;A8H1jgBC;;EAEC,wCAAA;A9H4jgBF;A8H1jgBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H4jgBF;A8H1jgBE;EACC,WAAA;A9H4jgBH;A8HvjgBK;EACC,W3H0BK;AH+hgBX;;A8H3kgBC;EACC,WAAA;A9H8kgBF;A8H5kgBC;;EAEC,wCAAA;A9H8kgBF;A8H5kgBC;EACC,yBzHmEa;EyHlEb,WAAA;A9H8kgBF;A8H5kgBE;EACC,WAAA;A9H8kgBH;A8HzkgBK;EACC,W3H0BK;AHijgBX;;A8H7lgBC;EACC,cAAA;A9HgmgBF;A8H9lgBC;;EAEC,qCAAA;A9HgmgBF;A8H9lgBC;EACC,sBzHmEa;EyHlEb,cAAA;A9HgmgBF;A8H9lgBE;EACC,cAAA;A9HgmgBH;A8H3lgBK;EACC,W3H0BK;AHmkgBX;;A8H/mgBC;EACC,cAAA;A9HkngBF;A8HhngBC;;EAEC,qCAAA;A9HkngBF;A8HhngBC;EACC,sBzHmEa;EyHlEb,cAAA;A9HkngBF;A8HhngBE;EACC,cAAA;A9HkngBH;A8H7mgBK;EACC,W3H0BK;AHqlgBX;;A8HjogBC;EACC,WAAA;A9HoogBF;A8HlogBC;;EAEC,wCAAA;A9HoogBF;A8HlogBC;EACC,uBzHmEa;EyHlEb,WAAA;A9HoogBF;A8HlogBE;EACC,WAAA;A9HoogBH;A8H/ngBK;EACC,W3H0BK;AHumgBX;;A+H5ogBA;EACI,eAAA;EpHkBA,gCAAA;EACA,iCAAA;AX8ngBJ;A+H9ogBI;EpHeA,yBAAA;EACA,0BAAA;EAaA,oCAAA;EACA,mCAAA;AXsngBJ;;A+H3ogBA;EACI,c5H8BO;AHgngBX;A+H5ogBI;EACI,c5HkqB4B;AH4+epC;A+H3ogBI;EACI,kBAAA;EACA,QAAA;A/H6ogBR;;A+HzogBA;EACE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mB5HOK;EHqogBT;AACF;AgI5qgBI;EACI,mB7HwrB4B;AHs/epC;AgI3qgBI;EACC,qBAAA;EACG,c7H0rB4B;E6HzrB5B,gBAAA;EACA,mB7HmVsB;E6HlVtB,2E7H0fsB;E6HzftB,sB7H2BG;E6H1BH,0B7HmUsB;AH02f9B;AgI3qgBQ;EACC,c7HmrB2B;AH0/epC;AgIzqgBI;;EAEI,W7H8qB4B;E6H7qB5B,yB7H8qB4B;AH6/epC;AgB/ngBI;EgHxCI;IACI,mB7HqPH;EHq7fP;AACF;;AgBpogBI;EgHhCI;IACI,gBAAA;EhIwqgBV;AACF;AgIhqgBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AhIkqgBR;AgI9pgBQ;EACI,eAAA;AhIgqgBZ;;AiIrtgBQ;EACI,iB9H6sBwB;E8H5sBxB,gB9H6sBwB;E8H5sBxB,sB9H6sBwB;E8H5sBxB,iB9H6sBwB;EkB1sB9B,4B4GFM;AjIwtgBZ;AqBltgBM;E4GXE;I5GYA,gBAAA;ErBqtgBN;AACF;AiI3tgBY;EACI,oBAAA;AjI6tgBhB;AiIrtgBI;EACI,mB9HyUsB;E8HxUtB,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AjIutgBR;AiIrtgBQ;EACI,YAAA;AjIutgBZ;AiIltgBQ;EACI,W9HMD;AH8sgBX;AiI/sgBQ;EACI,c9HQD;AHysgBX;AiI3sgBQ;EACE,qBAAA;AjI6sgBV;AgBrsgBI;EiHDQ;IACI,oBAAA;EjIysgBd;EiIvsgBc;IACI,0B9HuRU;EHk7f5B;EiIrsgBkB;IACI,yBAAA;EjIusgBtB;EiInsgBU;IACI,iB9H4oBoB;I8H3oBpB,oB9H2oBoB;I8H1oBpB,uB9HwPc;EH68f5B;EiInsgBc;IACI,sBAAA;EjIqsgBlB;EiIjsgBU;IACI,+BAAA;IACA,gCAAA;IACA,eAAA;IACA,uB9H6Oc;EHs9f5B;EiIjsgBc;IACI,eAAA;EjImsgBlB;AACF;AiI3rgBI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AjI6rgBR;AiI3rgBQ;EACI,yBAAA;AjI6rgBZ;AiI1rgBQ;EACI,yBAAA;AjI4rgBZ;AiIzrgBQ;EACI,0D5HgnBwB;AL2kfpC;AgBnvgBI;EiH+DY;IACI,gC9H0mBgB;EH6kflC;EMnygBA;I2H+GsB,gC9HwmBY;EH+kflC;EiIprgBkB;IACI,gC9HsmBY;EHglflC;EiIlrgBc;;;;IAII,gC9H6lBgB;EHulflC;EiIhrgBU;IACI,gC9HslBoB;EH4lflC;EMlzgBA;I2HmIkB,gC9HmlBgB;EH+lflC;AACF;;AkI/zgBA;EACE,2D/H2vB2B;AHukf7B;AkIh0gBE;EACE,uBAAA;EACA,mBAAA;AlIk0gBJ;AkI7zgBE;EACE,6B/H+tBgC;E+H9tBhC,qB/H2BO;AHoygBX;AkI1zgBE;EACE,eAAA;AlI4zgBJ;AkIzzgBE;;EAEE,eAAA;EACA,iBAAA;AlI2zgBJ;AgB9xgBI;EkHvBA;IACE,kBAAA;IACA,mBAAA;IACA,kB/H0qB8B;I+HzqB9B,mB/HyqB8B;EH+oflC;AACF;AkInzgBE;EACE,kBAAA;EACA,mBAAA;AlIqzgBJ;AkIjzgBI;EACE,kB/H4pB8B;E+H3pB9B,mB/H2pB8B;E+H1pB9B,iB/H+pB8B;AHopfpC;AkIjzgBM;EACE,kBAAA;AlImzgBR;AkIjzgBQ;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,Y/HunB0B;E+HtnB1B,e/HsnB0B;E+HrnB1B,8BAAA;AlImzgBV;AkI7ygBM;EACE,kB/H+rBgB;E+H9rBhB,oBAAA;EACA,mBAAA;AlI+ygBR;AkI1ygBM;EACE,YAAA;AlI4ygBR;AkI1ygBQ;EACE,oBAAA;AlI4ygBV;AkIrygBE;EACE,aAAA;EACA,mBAAA;AlIuygBJ;AkInygBI;EACE,qBAAA;EACA,kBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,c/HzDK;E+H0DL,0B/HyOwB;AH4jgB9B;AkIlygBM;EACE,wBAAA;AlIoygBR;AkI9xgBE;EACE,qBAAA;AlIgygBJ;AkI5xgBE;EACE,qBAAA;AlI8xgBJ;AkI1xgBE;EACE,oB/HsjBgC;E+HrjBhC,uB/HqjBgC;E+HpjBhC,kB/HgO0B;E+H/N1B,yBAAA;EACA,sBAAA;AlI4xgBJ;AkItxgBM;EAEI,cAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,gB/HinBc;E+HhnBd,oB/HinBkB;E+HhnBlB,qB/HgnBkB;E+H9mBlB,gBAAA;AlIsxgBV;AkInxgBU;EACE,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AlIqxgBZ;AkIpxgBY;EANF;IAQI,gBAAA;IACA,YAAA;ElIsxgBZ;AACF;AkIlxgBU;EACE,OAAA;EACA,uBAAA;AlIoxgBZ;AkIhxgBU;EACE,QAAA;EACA,uBAAA;AlIkxgBZ;AkI9wgBU;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oB/H0kBgB;E+HzkBhB,qB/HykBgB;AHusf5B;AkI9wgBY;EACE,eAAA;AlIgxgBd;AkI3wgBU;EACE,sBAAA;EACA,oBAAA;EACA,qBAAA;AlI6wgBZ;AkI1wgBU;EACE,uBAAA;AlI4wgBZ;AkIxwgBc;EACE,Y/HweoB;E+HvepB,e/HueoB;E+HtepB,OAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AlI0wgBhB;AkIpwgBU;EACE,qBAAA;AlIswgBZ;AkIlwgBU;EACE,oBAAA;AlIowgBZ;AkI/vgBU;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AlIiwgBZ;AkI9vgBU;EACE,iBAAA;AlIgwgBZ;AkI5vgBU;EACE,oBAAA;EACA,qBAAA;EACA,iB/HkCH;E+HjCG,oBAAA;EACA,oB/H8gBgB;E+H7gBhB,qB/H6gBgB;E+H5gBhB,6BAAA;AlI8vgBZ;AkI3vgBY;EACE,SAAA;EACA,2BAAA;AlI6vgBd;AgB/7gBI;EkHgFE;IAEI,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/HinBc;I+HhnBd,oB/HinBkB;I+HhnBlB,qB/HgnBkB;I+H9mBlB,gBAAA;ElIg3gBR;EkI72gBQ;IACE,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElI+2gBV;AACF;AkI/2gBY;EANF;IAQI,gBAAA;IACA,YAAA;ElIi3gBZ;AACF;AgBz9gBI;EkH4GM;IACE,OAAA;IACA,uBAAA;ElIg3gBV;EkI52gBQ;IACE,QAAA;IACA,uBAAA;ElI82gBV;EkI12gBQ;IACE,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/H0kBgB;I+HzkBhB,qB/HykBgB;EHmyf1B;EkI12gBU;IACE,eAAA;ElI42gBZ;EkIv2gBQ;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIy2gBV;EkIt2gBQ;IACE,uBAAA;ElIw2gBV;EkIp2gBY;IACE,Y/HweoB;I+HvepB,e/HueoB;I+HtepB,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElIs2gBd;EkIh2gBQ;IACE,qBAAA;ElIk2gBV;EkI91gBQ;IACE,oBAAA;ElIg2gBV;EkI31gBQ;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElI61gBV;EkI11gBQ;IACE,iBAAA;ElI41gBV;EkIx1gBQ;IACE,oBAAA;IACA,qBAAA;IACA,iB/HkCH;I+HjCG,oBAAA;IACA,oB/H8gBgB;I+H7gBhB,qB/H6gBgB;I+H5gBhB,6BAAA;ElI01gBV;EkIv1gBU;IACE,SAAA;IACA,2BAAA;ElIy1gBZ;AACF;AgB5hhBI;EkHgFE;IAEI,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/HinBc;I+HhnBd,oB/HinBkB;I+HhnBlB,qB/HgnBkB;I+H9mBlB,gBAAA;ElI68gBR;EkI18gBQ;IACE,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElI48gBV;AACF;AkI58gBY;EANF;IAQI,gBAAA;IACA,YAAA;ElI88gBZ;AACF;AgBtjhBI;EkH4GM;IACE,OAAA;IACA,uBAAA;ElI68gBV;EkIz8gBQ;IACE,QAAA;IACA,uBAAA;ElI28gBV;EkIv8gBQ;IACE,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/H0kBgB;I+HzkBhB,qB/HykBgB;EHg4f1B;EkIv8gBU;IACE,eAAA;ElIy8gBZ;EkIp8gBQ;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIs8gBV;EkIn8gBQ;IACE,uBAAA;ElIq8gBV;EkIj8gBY;IACE,Y/HweoB;I+HvepB,e/HueoB;I+HtepB,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElIm8gBd;EkI77gBQ;IACE,qBAAA;ElI+7gBV;EkI37gBQ;IACE,oBAAA;ElI67gBV;EkIx7gBQ;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElI07gBV;EkIv7gBQ;IACE,iBAAA;ElIy7gBV;EkIr7gBQ;IACE,oBAAA;IACA,qBAAA;IACA,iB/HkCH;I+HjCG,oBAAA;IACA,oB/H8gBgB;I+H7gBhB,qB/H6gBgB;I+H5gBhB,6BAAA;ElIu7gBV;EkIp7gBU;IACE,SAAA;IACA,2BAAA;ElIs7gBZ;AACF;AgBznhBI;EkHgFE;IAEI,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/HinBc;I+HhnBd,oB/HinBkB;I+HhnBlB,qB/HgnBkB;I+H9mBlB,gBAAA;ElI0ihBR;EkIvihBQ;IACE,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElIyihBV;AACF;AkIzihBY;EANF;IAQI,gBAAA;IACA,YAAA;ElI2ihBZ;AACF;AgBnphBI;EkH4GM;IACE,OAAA;IACA,uBAAA;ElI0ihBV;EkItihBQ;IACE,QAAA;IACA,uBAAA;ElIwihBV;EkIpihBQ;IACE,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/H0kBgB;I+HzkBhB,qB/HykBgB;EH69f1B;EkIpihBU;IACE,eAAA;ElIsihBZ;EkIjihBQ;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;ElImihBV;EkIhihBQ;IACE,uBAAA;ElIkihBV;EkI9hhBY;IACE,Y/HweoB;I+HvepB,e/HueoB;I+HtepB,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElIgihBd;EkI1hhBQ;IACE,qBAAA;ElI4hhBV;EkIxhhBQ;IACE,oBAAA;ElI0hhBV;EkIrhhBQ;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElIuhhBV;EkIphhBQ;IACE,iBAAA;ElIshhBV;EkIlhhBQ;IACE,oBAAA;IACA,qBAAA;IACA,iB/HkCH;I+HjCG,oBAAA;IACA,oB/H8gBgB;I+H7gBhB,qB/H6gBgB;I+H5gBhB,6BAAA;ElIohhBV;EkIjhhBU;IACE,SAAA;IACA,2BAAA;ElImhhBZ;AACF;AgBtthBI;EkHgFE;IAEI,cAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,gB/HinBc;I+HhnBd,oB/HinBkB;I+HhnBlB,qB/HgnBkB;I+H9mBlB,gBAAA;ElIuohBR;EkIpohBQ;IACE,sBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ElIsohBV;AACF;AkItohBY;EANF;IAQI,gBAAA;IACA,YAAA;ElIwohBZ;AACF;AgBhvhBI;EkH4GM;IACE,OAAA;IACA,uBAAA;ElIuohBV;EkInohBQ;IACE,QAAA;IACA,uBAAA;ElIqohBV;EkIjohBQ;IACE,SAAA;IACA,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,qBAAA;IACA,oB/H0kBgB;I+HzkBhB,qB/HykBgB;EH0jgB1B;EkIjohBU;IACE,eAAA;ElImohBZ;EkI9nhBQ;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;ElIgohBV;EkI7nhBQ;IACE,uBAAA;ElI+nhBV;EkI3nhBY;IACE,Y/HweoB;I+HvepB,e/HueoB;I+HtepB,OAAA;IACA,WAAA;IACA,8BAAA;IACA,gBAAA;ElI6nhBd;EkIvnhBQ;IACE,qBAAA;ElIynhBV;EkIrnhBQ;IACE,oBAAA;ElIunhBV;EkIlnhBQ;IACE,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,oBAAA;ElIonhBV;EkIjnhBQ;IACE,iBAAA;ElImnhBV;EkI/mhBQ;IACE,oBAAA;IACA,qBAAA;IACA,iB/HkCH;I+HjCG,oBAAA;IACA,oB/H8gBgB;I+H7gBhB,qB/H6gBgB;I+H5gBhB,6BAAA;ElIinhBV;EkI9mhBU;IACE,SAAA;IACA,2BAAA;ElIgnhBZ;AACF;;AkIxmhBA;EACE,kBAAA;AlI2mhBF;AkI1mhBE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AlI4mhBJ;AkI1mhBE;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;AlI4mhBJ;;AmI53hBI;EACI,mBhI0tB4B;EgIztB5B,iBAAA;EACA,6BAAA;AnI+3hBR;AmI73hBQ;EACI,6BAAA;EACA,kBAAA;AnI+3hBZ;AmI33hBI;EACI,YhI4sB4B;EgI3sB5B,6BAAA;AnI63hBR;;AmIx3hBI;EACI,sChIotB4B;AHuqgBpC;AmIx3hBI;EACI,+BhIitB4B;AHyqgBpC;AmIv3hBI;EACI,+BhI+sB4B;AH0qgBpC;AmIv3hBQ;EACI,+BhI0sBwB;AH+qgBpC;AmIp3hBQ;EACI,sChIqsB4B;AHirgBxC;;AmIh3hBI;EACI,gChI2sB4B;AHwqgBpC;AmIh3hBI;EACI,yBhIwsB6B;AH0qgBrC;AmI/2hBI;EACI,yBhIssB6B;AH2qgBrC;AmI/2hBQ;EACI,yBhIisByB;AHgrgBrC;AmI52hBQ;EACI,gChI4rB6B;AHkrgBzC;;AgBn3hBI;EoHxDI;IACI,UAAA;IACA,oBAAA;IACA,SAAA;EpI+6hBV;EoI36hBU;IACI,gBjIiCL;IiIhCK,gBAAA;IACA,WAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,kBAAA;IACA,YAAA;IACA,0CAAA;IACA,WAAA;IACA,kBAAA;EpI66hBd;EoIx6hBU;IACI,WAAA;IACA,UAAA;EpI06hBd;EoIp6hBc;IACI,UAAA;IACA,oBAAA;IACA,mDAAA;EpIs6hBlB;EoIn6hBc;IACI,cAAA;IACA,oDAAA;EpIq6hBlB;EoI/5hBU;IACI,UAAA;IACA,cAAA;IACA,oBAAA;IACA,+DAAA;IACA,4DAAA;EpIi6hBd;EoI95hBU;IACI,cAAA;IACA,UAAA;IACA,oBAAA;IACA,mBAAA;IACA,0BAAA;IACA,eAAA;EpIg6hBd;EoI55hBM;IACI,kBAAA;IACA,aAAA;EpI85hBV;EoIx5hBM;IACI;MACI,UAAA;MACA,+DAAA;MACA,4DAAA;IpI05hBZ;IoIv5hBQ;MACI,0BAAA;MACA,UAAA;IpIy5hBZ;EACF;EoIt5hBM;IACI;MACI,UAAA;IpIw5hBZ;IoIr5hBQ;MACI,UAAA;MACA,6BAAA;IpIu5hBZ;EACF;AACF;AqIn/hBA;EACI,aAAA;ArIq/hBJ;;AgBn7hBI;EqH7DI;IACI,mBAAA;IACA,yBAAA;ErIo/hBV;EqIj/hBM;IACI,gBAAA;IACA,eAAA;ErIm/hBV;EqIh/hBc;IACI,WAAA;ErIk/hBlB;EqI5+hBE;IACI,0BAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;ErI8+hBN;EqI5+hBM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;IACA,UAAA;ErI8+hBV;EqI5+hBU;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;ErI8+hBd;EqI3+hBU;IACI,yBAAA;ErI6+hBd;EqI1+hBU;IACI,0BAAA;ErI4+hBd;EqIx+hBM;IACI,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,2CAAA;ErI0+hBV;EqIt+hBU;IACI,YAAA;ErIw+hBd;EqIp+hBM;IACI,iBAAA;ErIs+hBV;EqIl+hBE;;IAEI,eAAA;IACA,uBlI0OsB;IkIzOtB,gBAAA;IACA,iHAAA;IACA,kDAAA;ErIo+hBN;EqIj+hBE;IACI,kDAAA;ErIm+hBN;AACF;AqIh+hBA;EACI;IACI,UAAA;IACA,sBAAA;IACA,wBAAA;ErIk+hBN;EqI/9hBE;IACI,UAAA;IACA,mBAAA;ErIi+hBN;AACF;AqI99hBA;EACI;IACI,UAAA;IACA,mBAAA;IACA,wBAAA;ErIg+hBN;EqI79hBE;IACI,UAAA;IACA,sBAAA;ErI+9hBN;AACF;AsIpliBI;EACI,2EnIqgBsB;AHilhB9B;AsInliBI;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACN,YAAA;EACA,mBnI+U4B;AHswhB9B;;AsI5kiBQ;;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AtI+kiBZ;;AsIxkiBQ;;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AtI2kiBZ;;AuIlniBA;EACI,SAAA;AvIqniBJ;;AuIlniBA;EACC,gBpI8V6B;AHuxhB9B;;AuI9miBI;ECfH,yBnI0Ec;ALujiBf;AwI/niBC;EACC,yBnIuEa;EmItEb,WAAA;AxIioiBF;AwI9niBC;EACC,WAAA;AxIgoiBF;AwI9niBC;EACC,sCAAA;AxIgoiBF;AwI7niBE;EACC,yBnI2DY;ALokiBf;AwI3niBE;EACC,2BnIsDY;ALukiBf;AwIzniBE;EACC,4BnIiDY;AL0kiBf;AwIvniBE;EACC,0BnI4CY;AL6kiBf;;AuIxoiBI;ECfH,yBnI0Ec;ALiliBf;AwIzpiBC;EACC,yBnIuEa;EmItEb,cAAA;AxI2piBF;AwIxpiBC;EACC,cAAA;AxI0piBF;AwIxpiBC;EACC,mCAAA;AxI0piBF;AwIvpiBE;EACC,yBnI2DY;AL8liBf;AwIrpiBE;EACC,2BnIsDY;ALimiBf;AwInpiBE;EACC,4BnIiDY;ALomiBf;AwIjpiBE;EACC,0BnI4CY;ALumiBf;;AuIlqiBI;ECfH,yBnI0Ec;AL2miBf;AwInriBC;EACC,yBnIuEa;EmItEb,WAAA;AxIqriBF;AwIlriBC;EACC,WAAA;AxIoriBF;AwIlriBC;EACC,sCAAA;AxIoriBF;AwIjriBE;EACC,yBnI2DY;ALwniBf;AwI/qiBE;EACC,2BnIsDY;AL2niBf;AwI7qiBE;EACC,4BnIiDY;AL8niBf;AwI3qiBE;EACC,0BnI4CY;ALioiBf;;AuI5riBI;ECfH,yBnI0Ec;ALqoiBf;AwI7siBC;EACC,yBnIuEa;EmItEb,WAAA;AxI+siBF;AwI5siBC;EACC,WAAA;AxI8siBF;AwI5siBC;EACC,sCAAA;AxI8siBF;AwI3siBE;EACC,yBnI2DY;ALkpiBf;AwIzsiBE;EACC,2BnIsDY;ALqpiBf;AwIvsiBE;EACC,4BnIiDY;ALwpiBf;AwIrsiBE;EACC,0BnI4CY;AL2piBf;;AuIttiBI;ECfH,yBnI0Ec;AL+piBf;AwIvuiBC;EACC,yBnIuEa;EmItEb,WAAA;AxIyuiBF;AwItuiBC;EACC,WAAA;AxIwuiBF;AwItuiBC;EACC,sCAAA;AxIwuiBF;AwIruiBE;EACC,yBnI2DY;AL4qiBf;AwInuiBE;EACC,2BnIsDY;AL+qiBf;AwIjuiBE;EACC,4BnIiDY;ALkriBf;AwI/tiBE;EACC,0BnI4CY;ALqriBf;;AuIhviBI;ECfH,yBnI0Ec;ALyriBf;AwIjwiBC;EACC,yBnIuEa;EmItEb,WAAA;AxImwiBF;AwIhwiBC;EACC,WAAA;AxIkwiBF;AwIhwiBC;EACC,sCAAA;AxIkwiBF;AwI/viBE;EACC,yBnI2DY;ALssiBf;AwI7viBE;EACC,2BnIsDY;ALysiBf;AwI3viBE;EACC,4BnIiDY;AL4siBf;AwIzviBE;EACC,0BnI4CY;AL+siBf;;AuI1wiBI;ECfH,yBnI0Ec;ALmtiBf;AwI3xiBC;EACC,yBnIuEa;EmItEb,WAAA;AxI6xiBF;AwI1xiBC;EACC,WAAA;AxI4xiBF;AwI1xiBC;EACC,sCAAA;AxI4xiBF;AwIzxiBE;EACC,yBnI2DY;ALguiBf;AwIvxiBE;EACC,2BnIsDY;ALmuiBf;AwIrxiBE;EACC,4BnIiDY;ALsuiBf;AwInxiBE;EACC,0BnI4CY;ALyuiBf;;AuIpyiBI;ECfH,yBnI0Ec;AL6uiBf;AwIrziBC;EACC,yBnIuEa;EmItEb,WAAA;AxIuziBF;AwIpziBC;EACC,WAAA;AxIsziBF;AwIpziBC;EACC,sCAAA;AxIsziBF;AwInziBE;EACC,yBnI2DY;AL0viBf;AwIjziBE;EACC,2BnIsDY;AL6viBf;AwI/yiBE;EACC,4BnIiDY;ALgwiBf;AwI7yiBE;EACC,0BnI4CY;ALmwiBf;;AuI9ziBI;ECfH,yBnI0Ec;ALuwiBf;AwI/0iBC;EACC,yBnIuEa;EmItEb,WAAA;AxIi1iBF;AwI90iBC;EACC,WAAA;AxIg1iBF;AwI90iBC;EACC,sCAAA;AxIg1iBF;AwI70iBE;EACC,yBnI2DY;ALoxiBf;AwI30iBE;EACC,2BnIsDY;ALuxiBf;AwIz0iBE;EACC,4BnIiDY;AL0xiBf;AwIv0iBE;EACC,0BnI4CY;AL6xiBf;;AuIx1iBI;ECfH,sBnI0Ec;ALiyiBf;AwIz2iBC;EACC,sBnIuEa;EmItEb,cAAA;AxI22iBF;AwIx2iBC;EACC,cAAA;AxI02iBF;AwIx2iBC;EACC,mCAAA;AxI02iBF;AwIv2iBE;EACC,sBnI2DY;AL8yiBf;AwIr2iBE;EACC,wBnIsDY;ALiziBf;AwIn2iBE;EACC,yBnIiDY;ALoziBf;AwIj2iBE;EACC,uBnI4CY;ALuziBf;;AuIl3iBI;ECfH,sBnI0Ec;AL2ziBf;AwIn4iBC;EACC,sBnIuEa;EmItEb,cAAA;AxIq4iBF;AwIl4iBC;EACC,cAAA;AxIo4iBF;AwIl4iBC;EACC,mCAAA;AxIo4iBF;AwIj4iBE;EACC,sBnI2DY;ALw0iBf;AwI/3iBE;EACC,wBnIsDY;AL20iBf;AwI73iBE;EACC,yBnIiDY;AL80iBf;AwI33iBE;EACC,uBnI4CY;ALi1iBf;;AuI54iBI;ECfH,uBnI0Ec;ALq1iBf;AwI75iBC;EACC,uBnIuEa;EmItEb,WAAA;AxI+5iBF;AwI55iBC;EACC,WAAA;AxI85iBF;AwI55iBC;EACC,sCAAA;AxI85iBF;AwI35iBE;EACC,uBnI2DY;ALk2iBf;AwIz5iBE;EACC,yBnIsDY;ALq2iBf;AwIv5iBE;EACC,0BnIiDY;ALw2iBf;AwIr5iBE;EACC,wBnI4CY;AL22iBf;;AyIh7iBA;EACI,kBAAA;EACA,mBAAA;AzIm7iBJ;;AyI76iBA;EACI,WAAA;EACA,mBtIsQK;EsIrQL,gBAAA;EACA,sBtImT0B;EsIlT1B,yBtI2BO;EsI1BP,8CAAA;AzIg7iBJ;AyI96iBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AzIg7iBR;;AyIz6iBA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AzI46iBJ;;AyIz6iBA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;AzI46iBJ;;AyIz6iBA;EACI,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AzI46iBJ;;AyIx6iBI;EACI,qBAAA;EACA,ctIyCQ;EsIxCR,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AzI26iBR;;AyIv6iBA;EACI,iBAAA;AzI06iBJ;AyIz6iBI;EACI,qBAAA;EACA,ctIvBG;EsIwBH,mBAAA;EACA,gBAAA;AzI26iBR;;A0Ij/iBA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;A1Io/iBJ;A0Il/iBI;EACI,kBAAA;EACA,oBAAA;A1Io/iBR;;A0Ih/iBA;EACI,MAAA;EACA,YAAA;A1Im/iBJ;A0Ij/iBI;EACI,MAAA;A1Im/iBR;;A0I/+iBA;EACI,SAAA;EACA,SAAA;A1Ik/iBJ;A0Ih/iBI;EACI,SAAA;A1Ik/iBR;;A0I9+iBA;EACI,yBAAA;A1Ii/iBJ;;A0I5+iBA;EACI,YAAA;A1I++iBJ;AgBn+iBI;E0HbJ;IAIQ,YAAA;E1Ig/iBN;AACF;;A2I7hjBE;EACE,oBxImc0B;EwIlc1B,uBxIkc0B;EwIjc1B,kBxImc0B;EwIlc1B,yBxIoc0B;EwInc1B,mBxIoc0B;EwInc1B,gCAAA;A3IgijBJ;A2I7hjBE;EACE,gBxIuV0B;AHwsiB9B;A2I3hjBI;EACE,WAAA;EACA,YAAA;EACA,SAAA;A3I6hjBN;A2IzhjBE;;EAEE,oBxIob0B;EwInb1B,mBAAA;A3I2hjBJ;A2IrhjBI;;EAEE,sBAAA;A3IuhjBN;A2IhhjBI;EACE,yBxI2awB;EwI1axB,cxI2awB;AHumiB9B;A2I3gjBI;EACE,yBxIVK;EwIWL,cxINK;AHmhjBX;;A2IrgjBE;EtHjDI,0BsHkDF;A3IwgjBJ;AqBtjjBM;EsH6CJ;ItH5CM,gBAAA;ErByjjBN;AACF;;A2ItgjBE;;EAEE,cAAA;EACA,eAAA;A3IygjBJ;A2IngjBQ;;EAEE,aAAA;A3IqgjBV;A2IhgjBQ;;EAEE,gBAAA;A3IkgjBV;;A2Ix/iBE;EACE,gBAAA;A3I2/iBJ;A2Iz/iBI;;EAEE,oBxIyyB8B;EwIxyB9B,qBxIwyB8B;EwIvyB9B,yBAAA;A3I2/iBN;;A4IhmjBA;EACC,ezIgZ6B;EyI/Y7B,gBzIgZ6B;EyI/Y7B,gBzIgZ6B;AHmtiB9B;;A4IhmjBA;EACC,kBzI8Y6B;EyI7Y3B,gBzI8Y2B;EyI7Y7B,gBzI0Y6B;EyIzY7B,kBAAA;A5ImmjBD;A4IjmjBC;EACC,gBAAA;A5ImmjBF;;A4I/ljBA;EACC,mBzI0U6B;AHwxiB9B;;A6IpnjBA;EACC,uB1IsX6B;E0IrX7B,kB1IsX6B;E0IrX7B,yB1IsX6B;E0IrX7B,gB1I6V6B;AH0xiB9B;;A6IjnjBA;EACC,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;A7IonjBD;;A6IjnjBA;EACC,uB1IyWmC;E0IxWnC,mB1IyWmC;E0IxWnC,gB1I4U6B;E0I3U7B,yB1IyWmC;AH2wiBpC;;A6IjnjBA;EACC,uB1IuWqC;E0ItWrC,mB1IuWqC;E0ItWrC,gB1IqU6B;E0IpU7B,yB1IuWqC;AH6wiBtC;A6IlnjBC;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;A7IonjBF;A6IhnjBE;EACC,iBAAA;EACA,kBAAA;A7IknjBH;;A8IzpjBC;;;;EACC,cAAA;EACA,gB3I2V4B;AHo0iB9B;;A+IrqjBC;;EAEC,gBAAA;A/IwqjBF;A+IrqjBC;EACC,qBAAA;A/IuqjBF;A+IpqjBC;EACC,cAAA;A/IsqjBF;A+InqjBC;EACC,aAAA;A/IqqjBF;;AgJnrjBA;EACI,uB7I6T0B;E6IvT1B,cAAA;AhJirjBJ;AgJrrjBI;EACI,YAAA;AhJurjBR;AgJlrjBI;EACI,cAAA;AhJorjBR;AgJnrjBQ;EACI,UAAA;AhJqrjBZ;AgJnrjBQ;EACI,YAAA;AhJqrjBZ;AgJjrjBI;EACI,MAAA;EACA,OAAA;EACA,kB7Iy6BsB;ESp7BxB,iHoIYE;AhJmrjBR;AgJjrjBQ;EACI,SAAA;AhJmrjBZ;AgJjrjBQ;EACI,SAAA;AhJmrjBZ;AgJjrjBQ;EACI,UAAA;AhJmrjBZ;AgJjrjBQ;EACI,UAAA;AhJmrjBZ;AgJjrjBQ;EACI,SAAA;AhJmrjBZ;AgJjrjBQ;EACI,SAAA;AhJmrjBZ;AgJhrjBQ;EACI,YAAA;EACA,gBAAA;EACA,2BAAA;AhJkrjBZ;AgJ/qjBQ;EACI,YAAA;EACA,gBAAA;EACA,0BAAA;AhJirjBZ;AgJ7qjBI;EACI,SAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AhJ+qjBR;AgJ5qjBY;EACI,kB7Im4BgB;AH2yhBhC;AgJ3qjBY;EACI,uB7I0Pc;E6IzPd,gBAAA;AhJ6qjBhB;AgJ1qjBY;;EAEI,0B7IuQc;E6ItQd,W7Iy3BQ;E6Ix3BR,Y7Iy3BS;E6Ix3BT,YAAA;EACA,kBAAA;EACA,mB7I+Qc;AH65iB9B;AgJpqjBQ;;EAEI,6BAAA;AhJsqjBZ;AgJjqjBQ;EAEI,c7InDD;AHqtjBX;AgJ/pjBQ;EAEI,iB7I61BuB;E6I51BvB,eAAA;AhJgqjBZ;AgJ7pjBQ;EAEI,gBAAA;EACA,c7IjED;E6IkEC,eAAA;AhJ8pjBZ;AgJ3pjBQ;EACI,gBAAA;AhJ6pjBZ;AgJ3pjBY;EACI,mB7Iy1Be;AHo0hB/B;AgJ1pjBY;EAEI,mB7Io1Be;E6In1Bf,c7I9EL;AHyujBX;AgJvpjBQ;EACI,iBAAA;AhJypjBZ;AgJxpjBY;EACI,iBAAA;AhJ0pjBhB;AgJvpjBY;EAEI,iBAAA;EACA,c7IzFL;AHivjBX;AgJnpjBQ;EACI,mB7Im0BkB;E6Il0BlB,W7ItGD;E6IuGC,gBAAA;AhJqpjBZ;AgJnpjBY;EACI,mBAAA;AhJqpjBhB;AgJlpjBY;EAGI,mBAAA;EACA,cAAA;AhJkpjBhB;AgJ7ojBY;EACI,mBAAA;AhJ+ojBhB;AgJ5ojBY;EAEI,mB7I1HL;E6I2HK,c7I1HL;AHuwjBX;AgJxojBY;EAEI,mB7I3GN;E6I4GM,W7IrIL;AH8wjBX;AgJrojBQ;EACI,0BAAA;EACA,6BAAA;AhJuojBZ;AgJpojBQ;EACI,yBAAA;EACA,4BAAA;AhJsojBZ;AgJnojBQ;EACI,kB7IuwBoB;AH83hBhC;AgJlojBQ;EAKI,mB7IywBmB;E6IxwBnB,W7I7JD;AH6xjBX;AgJ7njBQ;EAII,mB7IiwBmB;E6IhwBnB,W7IrKD;E6IsKC,gB7IgwBwB;AH43hBpC;AgJznjBQ;EACI,cAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AhJ2njBZ;AgJznjBY;EAEI,mB7InLL;AH6yjBX;AgJvnjBY;EAEI,gBAAA;EACA,c7IxLL;E6IyLK,eAAA;AhJwnjBhB;AgJrnjBY;EAII,yCAAA;AhJonjBhB;AgJjnjBY;EAEI,c7IlML;AHozjBX;AgJ7mjBI;EACI,YAAA;AhJ+mjBR;AgJ5mjBI;;;;EAII,eAAA;AhJ8mjBR;AgJ7mjBQ;;;;EACI,mB7IrND;AHu0jBX;AgJ5mjBQ;;EACI,kBAAA;AhJ+mjBZ;AgJ1mjBI;EACI,eAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AhJ4mjBR;;AiJh4jBA,qCAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AjJm4jBF;;AiJj4jBA;EACE,kBAAA;EACA,cAAA;AjJo4jBF;;AiJl4jBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AjJq4jBF;;AiJn4jBA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AjJs4jBF;;AiJp4jBA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AjJu4jBF;;AiJr4jBA;EACE,YAAA;EACA,WAAA;AjJw4jBF;;AiJt4jBA;EACE,WAAA;EACA,UAAA;AjJy4jBF;;AiJv4jBA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AjJ04jBF;;AiJx4jBA;;EAAA;AAGA;EACE,QAAA;AjJ24jBF;;AiJz4jBA;EACE,SAAA;AjJ44jBF;;AiJ14jBA;EACE,mCAAA;EACA,2BAAA;EACA,kBAAA;AjJ64jBF;;AiJ34jBA;EACE,YAAA;EACA,WAAA;AjJ84jBF;;AiJ54jBA;;EAGE,0BAAA;AjJ+4jBF;;AiJ74jBA;EACE,0BAAA;AjJg5jBF;;AiJ94jBA;EAAA;AAEA;EACE,YAAA;AjJi5jBF;;AiJ/4jBA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AjJk5jBF;;AiJh5jBA;EACE,WAAA;AjJm5jBF;;AiJj5jBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AjJo5jBF;;AiJl5jBA;EACE,YAAA;EACA,UAAA;AjJq5jBF;;AiJn5jBA;;EAAA;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wDAAA;AjJs5jBF;;AiJp5jBA;EACE,kBAAA;AjJu5jBF;;AiJr5jBA;EACE,mBAAA;AjJw5jBF;;AiJt5jBA;EAAA;AAEA;EACE,iBAAA;AjJy5jBF;;AiJv5jBA;EACE,iBAAA;AjJ05jBF;;AiJx5jBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;AjJ25jBF;;AiJz5jBA;EACE,yEAAA;AjJ45jBF;;AiJ15jBA;EAAA;AAEA;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AjJ65jBF;;AiJ35jBA;EACE,UAAA;AjJ85jBF;;AiJ55jBA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AjJ+5jBF;;AiJ75jBA;EACE,SAAA;AjJg6jBF;;AiJ95jBA;EAAA;AAEA;EACE,mBAAA;AjJi6jBF;;AiJ/5jBA;;;EAGE,mBAAA;AjJk6jBF;;AiJh6jBA;;EAAA;AAGA;;EAGE,sBAAA;AjJm6jBF;;AiJj6jBA;EACE,kBAAA;EACA,WAAA;AjJo6jBF;;AiJl6jBA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AjJq6jBF;;AiJn6jBA;EACE,WAAA;EACA,eAAA;AjJs6jBF;;AiJp6jBA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AjJu6jBF;;AiJr6jBA;EACE,gBAAA;AjJw6jBF;;AiJt6jBA;EACE,gBAAA;AjJy6jBF;;AiJv6jBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AjJ06jBF;;AiJx6jBA;EAEE,+BAAA;AjJ26jBF;;AiJz6jBA;EAEE,8BAAA;AjJ46jBF;;AiJ16jBA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AjJ66jBF;;AiJ36jBA;EACE,YAAA;AjJ86jBF;;AiJ56jBA;EACE,YAAA;AjJ+6jBF;;AiJ76jBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AjJg7jBF;;AiJ96jBA;EAEE,6BAAA;EACA,kBAAA;AjJi7jBF;;AiJ/6jBA;EAEE,4BAAA;AjJk7jBF;;AiJh7jBA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AjJm7jBF;;AiJj7jBA;EACE,WAAA;AjJo7jBF;;AiJl7jBA;EACE,WAAA;AjJq7jBF;;AiJn7jBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AjJs7jBF;;AiJp7jBA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AjJu7jBF;;AiJr7jBA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AjJw7jBF;;AiJj7jBA;EACI,mB9I2W8B;E8I1W9B,kB9I4W8B;E8I3W9B,SAAA;EACA,kD9I4W8B;E8I3W9B,cAAA;EACA,eAAA;AjJo7jBJ;;AiJj7jBA;EACI,W9ImW8B;AHiljBlC;;AiJj7jBA;EACI,YAAA;AjJo7jBJ;;AiJj7jBA;EACI,U9I2V8B;AHyljBlC;;AiJj7jBA;EACI,mBAAA;EACA,gBAAA;AjJo7jBJ;;AiJh7jBE;EACE,aAAA;AjJm7jBJ;AiJh7jBE;EACE,aAAA;AjJk7jBJ;;AiJ96jBA;;EAEI,SAAA;EACA,W9I8U8B;E8I7U9B,Y9I6U8B;E8I5U9B,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yB9I0U8B;E8IzU9B,S9I0U8B;E8IzU9B,6CAAA;AjJi7jBJ;;AiJ96jBA;;EAEI,mCAAA;AjJi7jBJ;;AiJ96jBA;EACI,mB9IxRM;AHyskBV;;AiJ76jBA,mBAAA;AAEA;;EAEI,mB9IoT8B;AH2njBlC;;AiJ56jBA;;EAEI,mBAAA;AjJ+6jBJ;;AiJ56jBA,8BAAA;AAEA;EACI,kB9ItB0B;E8IuB1B,gBAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;AjJ86jBJ;;AiJ36jBA;EACI,gBAAA;EACA,kBAAA;AjJ86jBJ;;AiJ36jBA;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AjJ86jBJ;;AiJ36jBA;EACI,YAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AjJ86jBJ;;AiJ36jBA;EACI,UAAA;EACA,WAAA;AjJ86jBJ;;AiJ36jBA;EACI,WAAA;EACA,UAAA;AjJ86jBJ;;AkJj1kBA;EACI,YAAA;AlJo1kBJ;AkJl1kBI;EACI,UAAA;AlJo1kBR;AkJj1kBI;EACI,yBAAA;EACA,iBAAA;AlJm1kBR;AkJj1kBQ;;EAEI,kCAAA;AlJm1kBZ;AkJh1kBQ;EACI,6BAAA;AlJk1kBZ;AkJ90kBI;EACI,UAAA;EACA,QAAA;AlJg1kBR;AkJ70kBI;EACI,WAAA;EACA,SAAA;AlJ+0kBR;;AmJ52kBA;EACI,yBCHgB;EDIhB,oDAAA;EACA,mBAAA;EACA,sBAAA;AnJ+2kBJ;AgB7ykBI;EmItEJ;IAOQ,qBAAA;IACA,oBAAA;EnJg3kBN;EmJ92kBM;IACI,eAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IACA,mBAAA;EnJg3kBV;EmJ92kBU;IACI,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iCAAA;EnJg3kBd;AACF;AgB70kBI;EmI9BI;IA3BR;MA4BY,wBAAA;MAAA,gBAAA;MACA,MAAA;MACA,aAAA;InJ+2kBR;EACF;AACF;AmJ52kBQ;EACI,qBAAA;EACA,oBAAA;EACA,0CAAA;AnJ82kBZ;AmJ52kBY;EAEI,sBAAA;EACA,wCAAA;AnJ62kBhB;AmJ12kBY;EACI,gBAAA;AnJ42kBhB;AmJv2kBI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AnJy2kBR;AmJt2kBI;EACI,mBAAA;AnJw2kBR;AmJr2kBI;EACI,gBAAA;EACA,chJdG;EgJeH,6BAAA;EACA,0DAAA;EACA,4BAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;AnJu2kBR;;AmJl2kBA;EACI,eAAA;EACA,QAAA;EACA,aAAA;AnJq2kBJ;AmJl2kBQ;EACI,yCAAA;AnJo2kBZ;AmJh2kBI;EACI,UhJ9CG;EgJ+CH,cC3FY;ApJ67kBpB;;AmJ91kBA;EACI;IAEI,oBAAA;EnJg2kBN;EmJ91kBE;IAEI,yBAAA;EnJ+1kBN;EmJ71kBE;IAEI,wBAAA;EnJ81kBN;AACF;AqJt8kBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;ArJw8kBF;AqJt8kBE;EACE,aAAA;ArJw8kBJ;;AqJp8kBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,yBD1BkB;ApJi+kBpB;AqJr8kBE;EACE,WAAA;EACA,yBAAA;ArJu8kBJ;;AqJn8kBA;EACE;IACE,cAAA;ErJs8kBF;AACF;AsJl+kBM;;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,+EAAA;EACA,mBnJmVsB;EmJlVtB,sBAAA;EACA,cAAA;AtJq+kBR;AsJ79kBM;;EACE,gBAAA;AtJg+kBR;AsJ39kBE;;;EAGE,gBAAA;EACA,sCAAA;AtJ69kBJ;;AsJz9kBA;EACE,iBAAA;EACA,sCAAA;AtJ49kBF;AsJ19kBE;EACE,gBAAA;AtJ49kBJ;;AsJx9kBA;EACE,0CAAA;EACA,0CAAA;AtJ29kBF;;AsJv9kBA;EACE,YAAA;EvInDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Af8glBF;;AsJ39kBA;EvI/CE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Af8glBF;;AsJ99kBA;EvIlCE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;AfiglBF;AgBz+kBI;EsIIJ;IvIxBE,aAAA;IAIA,cAAA;Ef8/kBA;AACF;AgB/+kBI;EsIIJ;IvIxBE,sBAAA;IAIA,uBAAA;EfoglBA;AACF;;AsJr+kBA;EvI9CE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;AfohlBF;AgB5/kBI;EsIgBJ;IvIpCE,aAAA;IAIA,cAAA;EfihlBA;AACF;AgBlglBI;EsIgBJ;IvIpCE,sBAAA;IAIA,uBAAA;EfuhlBA;AACF;;AsJv+kBA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AtJ0+kBF;;AsJv+kBA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;AtJ0+kBF;;AsJv+kBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;AtJ0+kBF;;AsJv+kBA;EACE,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AtJ0+kBF;;AsJv+kBA;EACE,eAAA;AtJ0+kBF;;AsJl+kBA;EACE,kBAAA;EACA,oBAAA;AtJq+kBF;AsDzmlBE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD2mlBJ;AgBnjlBI;EsIuEJ;IAMI,eAAA;IACA,cAAA;EtJ0+kBF;AACF;AsJx+kBE;;EAEE,aAAA;AtJ0+kBJ;AsJv+kBE;EACE,gBAAA;AtJy+kBJ;AsJt+kBE;EACE,kBAAA;EACA,aAAA;AtJw+kBJ;AgBpklBI;EsI0FF;IAKI,eAAA;EtJy+kBJ;AACF;AsJt+kBE;EACE,iBAAA;AtJw+kBJ;AsJp+kBI;EACE,kBAAA;AtJs+kBN;AsJl+kBE;;;;;;;EAOE,kBAAA;EACA,qBAAA;AtJo+kBJ;AsJj+kBE;EACE,kBAAA;EACA,qBAAA;AtJm+kBJ;AsJl+kBI;EACE,SAAA;AtJo+kBN;AsJh+kBE;EACE,SAAA;AtJk+kBJ;AsJh+kBI;EACE,mBAAA;AtJk+kBN;AsJ99kBE;EACE,oBAAA;AtJg+kBJ;AsJ79kBE;EACE,gBAAA;EACA,cAAA;AtJ+9kBJ;AsJ59kBE;EACE,gBAAA;AtJ89kBJ;AsJ39kBE;EACE,WAAA;AtJ69kBJ;;AsJt9kBI;EACE,WAAA;EACA,sBAAA;AtJy9kBN;AsJv9kBI;EACE,eAAA;EACA,kBAAA;AtJy9kBN;AsJv9kBI;EACE,aAAA;AtJy9kBN;AsJr9kBE;;;;;;EAME,aAAA;EACA,gBAAA;AtJu9kBJ;;AsJl9kBA;EACE,aAAA;AtJq9kBF;;AsJh9kBE;EACE,mBAAA;AtJm9kBJ;;AsJ78kBE;EACE,mBAAA;EACA,sBAAA;AtJg9kBJ;AsJ98kBE;EACE,kBAAA;AtJg9kBJ;;AsJ38kBA;;EAEE,kBAAA;AtJ88kBF;;AsJ58kBA;EACE,qBAAA;AtJ+8kBF;;AsJ78kBA;EACE,gBAAA;AtJg9kBF;;AsJ58kBA;EACE,gBAAA;AtJ+8kBF;;AsJ18kBE;;EAEE,gBAAA;EACA,wBAAA;AtJ68kBJ;AsJ38kBE;EACE,gBAAA;EACA,wBAAA;AtJ68kBJ;AgBnrlBI;EsI0OA;;IAEE,4BAAA;EtJ48kBJ;EsJ18kBE;IACE,4BAAA;EtJ48kBJ;AACF;;AsJv8kBA;EACE,kBAAA;EACA,qBAAA;AtJ08kBF;;AsJt8kBA;EACE,aAAA;AtJy8kBF;AsJv8kBE;;EAEE,aAAA;AtJy8kBJ;;AsJr8kBA;EACE,aAAA;AtJw8kBF;;AsJr8kBA;EACE,yBAAA;AtJw8kBF;AsJt8kBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AtJw8kBJ;AsJr8kBE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;AtJu8kBJ;;AsJl8kBA;EACE,mBAAA;AtJq8kBF;;AsJj8kBA;EACE,sBAAA;EACA,yBAAA;AtJo8kBF;AsJl8kBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AtJo8kBJ;;AsJ/7kBA;EACE,mBAAA;AtJk8kBF;;AsJ/7kBA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AtJk8kBF;;AsJ97kBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AtJi8kBF;;AsJ97kBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AtJi8kBF;;AsJ77kBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AtJg8kBJ;;AsJ37kBE;EACE,yBAAA;AtJ87kBJ;;AsJt7kBA;EACE,UAAA;EACA,gBAAA;EAGA,4CAAA;AtJu7kBF;AgBzxlBI;EsI6VJ;IAQI,UAAA;EtJw7kBF;AACF;;AsJr7kBA;EACE,mBAAA;EACA,kBAAA;AtJw7kBF;AgBnylBI;EsIyWJ;IAKI,eAAA;IACA,cAAA;EtJy7kBF;AACF;;AsJl7kBA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AtJq7kBF;AsJl7kBI;EACI,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AtJo7kBR;AsJh7kBE;EACE,uBAAA;AtJk7kBJ;AsJh7kBI;EACE,mBAAA;AtJk7kBN;AsJh7kBM;EAEE,cFxcY;ApJy3lBpB;;AsJ16kBA;EACE,gBAAA;AtJ66kBF;;AsJ36kBA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AtJ86kBF;AsJ56kBE;EACE,oCAAA;EACA,+EAAA;AtJ86kBJ;AsJ36kBE;EACE,mBAAA;EACA,aAAA;AtJ66kBJ;AsJ16kBE;EACE,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AtJ46kBJ;AsJz6kBE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AtJ26kBJ;;AuJ56lBA;;EAEI,wOAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,WAAA;EACA,qBAAA;EAGA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AvJ+6lBJ;;AuJp6lBA;;;;EAII,iBAAA;EACA,mBAAA;AvJ+6lBJ;;AuJ36lBA,gBAAA;AAEA;EACI,gBAAA;EACA,SAAA;EACA,cAAA;AvJ66lBJ;;AuJz6lBA,gBAAA;AAEA;EACI,cAAA;EACA,oBAAA;AvJ26lBJ;;AuJx6lBA;;;;EAII,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,YAAA;AvJ26lBJ;;AuJx6lBA;;;EAGI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;;;;EAII,cAAA;AvJ26lBJ;;AuJx6lBA;;;;;EAKI,cAAA;AvJ26lBJ;;AuJx6lBA;;;EAGI,cAAA;AvJ26lBJ;;AuJx6lBA;;EAEI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,6BAAA;AvJ26lBJ;;AuJx6lBA;EACI,iCAAA;EACA,qBAAA;AvJ26lBJ;;AuJx6lBA;EACI,kBAAA;AvJ26lBJ;;AuJx6lBA;;EAEI,iBAAA;AvJ26lBJ;;AuJx6lBA;EACI,cAAA;AvJ26lBJ;;AuJx6lBA;EACI,YAAA;AvJ26lBJ;;AuJx6lBA;EACI,4BAAA;EACA,qBAAA;AvJ26lBJ;;AuJv6lBA;;EAAA;AAIA;EACI,2BAAA;AvJy6lBJ;;AuJt6lBA;EACI,cAAA;AvJy6lBJ;;AuJr6lBA;;EAAA;AAIA;EACI,oCAAA;EAEA,2FAAA;AvJu6lBJ;;AwJrlmBA;EACI,gBAAA;AxJwlmBJ;AwJtlmBI;EACI,eAAA;EACA,gBrJmWsB;AHqvlB9B;;AwJplmBA;EACI,QAAA;AxJulmBJ;AwJrlmBI;;;EAGI,oBAAA;AxJulmBR;AwJrlmBQ;;;;;;EAEI,oBAAA;AxJ2lmBZ;AwJxlmBQ;;;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AxJ4lmBZ;AwJxlmBI;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AxJ0lmBR;AgBnjmBI;EwI1CA;IAMQ,cAAA;IACA,gBAAA;IACA,4CAAA;ExJ2lmBV;EwJ1lmBU;IACI,SAAA;ExJ4lmBd;AACF;AwJtlmBgB;;;;;;EAEI,arJ4YU;EqJ3YV,mBAAA;EACA,yBAAA;AxJ4lmBpB;AwJ1lmBoB;;;;;;EACI,gBAAA;AxJimmBxB;AwJ5lmBQ;EACI,mBAAA;AxJ8lmBZ;;AwJrlmBI;EACI,gBAAA;EACA,iBAAA;EACA,gBrJ+RsB;AHyzlB9B;AwJrlmBI;EACI,kBAAA;EACA,kBAAA;EACA,gBrJyRsB;AH8zlB9B;AwJplmBI;;EAEI,sBAAA;AxJslmBR;AgB9mmBI;EwI4BI;;;IAGI,cAAA;ExJqlmBV;AACF;;AwJjlmBA;EACI,qBAAA;EACA,8BAAA;EACA,qBAAA;AxJolmBJ;;AwJjlmBA;EACI,gBAAA;EACA,qBAAA;EACA,gBAAA;AxJolmBJ;AgBjomBI;EwI0CJ;IAMQ,iBAAA;IACA,gBrJ2PsB;EH01lB5B;AACF;;AwJllmBA;EACI,sBAAA;EACA,gBAAA;AxJqlmBJ;AgB5omBI;EwIqDJ;IAKQ,cAAA;IACA,mBAAA;IACA,mBAAA;ExJslmBN;AACF;;AwJnlmBA;EACI,cJ5HgB;ApJktmBpB;;AwJnlmBA;EACI,cJ/HgB;ApJqtmBpB;;AwJjlmBI;EACI,iBAAA;AxJolmBR;;AwJ/kmBA;EACI,cAAA;EACA,sBAAA;EACA,yBAAA;AxJklmBJ;;AwJ/kmBA;EACI,YAAA;EACA,cAAA;EACA,WAAA;AxJklmBJ;;AwJ/kmBA;EACI,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,6BAAA;AxJklmBJ;;AwJ/kmBA;EACI,qBAAA;AxJklmBJ;;AwJ/kmBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AxJklmBJ;;AwJ/kmBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EAGA,2BAAA;AxJklmBJ;;AwJ/kmBA;EACI,qBAAA;EACA,cAAA;AxJklmBJ;;AwJ/kmBA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AxJklmBJ;;AwJ/kmBA;EACI,WAAA;AxJklmBJ;;AwJ/kmBA;EACI,eAAA;AxJklmBJ;;AwJ/kmBA;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJklmBJ;;AwJ/kmBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EAGA,2BAAA;AxJklmBJ;;AwJ/kmBA;EACI,WAAA;EACA,eAAA;EACA,eAAA;AxJklmBJ;;AwJ/kmBA;EACI,eAAA;AxJklmBJ;;AwJ/kmBA;EACI,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;AxJklmBJ;;AwJ/kmBA;EACI,eAAA;AxJklmBJ;;AwJ/kmBA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AxJklmBJ;;AwJ/kmBA;;;;;;EAMI,oCJ3PgB;EI4PhB,2CAAA;EACA,aAAA;AxJklmBJ;;AwJ/kmBA;;EAEI,mBAAA;AxJklmBJ;;AwJ/kmBA;;EAEI,iBAAA;AxJklmBJ;;AwJ/kmBA;;EAEI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;AxJklmBJ;;AwJ/kmBA;;EAEI,qBAAA;AxJklmBJ;;AwJ/kmBA;;EAEI,WAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJklmBJ;;AyJx3mBA;EAOI,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AzJq3mBJ;AyJ93mBI;EADJ;IAEQ,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,0BAAA;IACA,gBAAA;EzJi4mBN;AACF;;AyJ13mBA;EACI,eAAA;EACA,2BAAA;AzJ63mBJ;AyJ33mBI;EACI,kBAAA;AzJ63mBR;AyJ33mBQ;EACI,aAAA;AzJ63mBZ;;AyJx3mBA;EACI,cAAA;EACA,eAAA;AzJ23mBJ;AyJz3mBI;EACI,cAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AzJ23mBR;AyJz3mBQ;EACI,ctJ6BF;EsJ5BE,qBAAA;AzJ23mBZ;;AyJn3mBA;EACI,QAAA;EACA,gCAAA;EACA,yBL3CY;ApJi6mBhB;AgB/2mBI;EyIVJ;IAYQ,+BAAA;EzJi3mBN;EyJv3mBM;IANR;MAOY,wBAAA;MAAA,gBAAA;MACA,SAAA;MACA,aAAA;MACA,0BAAA;IzJ03mBR;EACF;AACF;AgB53mBI;EyIVJ;IAgBQ,eAAA;EzJ03mBN;AACF;;AyJv3mBA;EACI,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AzJ03mBJ;AgBx4mBI;EyIiBI;IAPR;MAQY,8BAAA;MACA,gBAAA;IzJ23mBR;EACF;AACF;AgBh5mBI;EyIUJ;IAaQ,yBAAA;EzJ63mBN;AACF;;AyJ13mBA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;AzJ63mBJ;AyJ33mBI;EACI,qBL7FY;EK8FZ,+CAAA;AzJ63mBR;;AyJz3mBA;EACI,cAAA;EACA,ctJhDO;AH46mBX;;AyJz3mBA;EACI,aAAA;AzJ43mBJ;;AyJz3mBA;EACI,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AzJ43mBJ;AyJ13mBI;EACI,0BAAA;EACA,qBAAA;AzJ43mBR;;AyJv3mBI;EACI,mBAAA;AzJ03mBR;AyJx3mBQ;EACI,gBAAA;AzJ03mBZ;AyJv3mBQ;EACI,0BAAA;AzJy3mBZ;AyJv3mBY;EACI,6BAAA;AzJy3mBhB;AyJr3mBQ;EACI,cAAA;AzJu3mBZ;;AyJj3mBA;EACI,cAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AzJo3mBJ;;AyJj3mBA;EACI,0BAAA;EACA,qBAAA;EACA,6BAAA;AzJo3mBJ;;AyJj3mBA;EACI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AzJo3mBJ;AyJl3mBI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;AzJo3mBR;;AyJh3mBA;EACI,cAAA;AzJm3mBJ;;AyJ/2mBA;EACI,YAAA;AzJk3mBJ;AyJh3mBI;EACI,UAAA;AzJk3mBR;AyJ/2mBI;EACI,yBAAA;EACA,iBAAA;AzJi3mBR;AyJ/2mBQ;;EAEI,kCAAA;AzJi3mBZ;AyJ92mBQ;EACI,6BAAA;AzJg3mBZ;AyJ52mBI;EACI,UAAA;EACA,QAAA;AzJ82mBR;AyJ32mBI;EACI,WAAA;EACA,SAAA;AzJ62mBR;;A0J5jnBA;EACI,cAAA;EACA,kBAAA;EACA,yBAAA;A1J+jnBJ;A0J7jnBI;EACI,gBAAA;EACA,cvJ0CG;AHqhnBX;A0J7jnBQ;EAEI,cvJuFI;AHu+mBhB;A0J1jnBI;EACI,gBAAA;A1J4jnBR;AgBnhnBI;E0IzDJ;IAoBQ,gBAAA;E1J4jnBN;AACF;;A0JzjnBA;EACI,eAAA;EACA,mBAAA;A1J4jnBJ;A0J1jnBI;EACI,qBAAA;A1J4jnBR;A0J1jnBQ;EACI,iBAAA;A1J4jnBZ;;A2J3lnBA;EACE;IAAK,yBAAA;E3J+lnBL;AACF;A2J7lnBA;EACE,qBAAA;EACA,WtJskCwB;EsJrkCxB,YtJqkCwB;EsJpkCxB,wBtJskCwB;EsJrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A3J8lnBF;;A2J3lnBA;EACE,WtJgkCwB;EsJ/jCxB,YtJ+jCwB;EsJ9jCxB,mBtJgkCwB;AL8hlB1B;;A2JvlnBA;EACE;IACE,mBAAA;E3J0lnBF;E2JxlnBA;IACE,UAAA;IACA,eAAA;E3J0lnBF;AACF;A2JvlnBA;EACE,qBAAA;EACA,WtJsiCwB;EsJriCxB,YtJqiCwB;EsJpiCxB,wBtJsiCwB;EsJriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A3JwlnBF;;A2JrlnBA;EACE,WtJgiCwB;EsJ/hCxB,YtJ+hCwB;ALyjlB1B;;A2JplnBE;EACE;;IAEE,wBAAA;E3JulnBJ;AACF;A4JrpnBA;;CAAA;AAGA;EACE,kBAAA;A5JupnBF;A4JrpnBE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A5JupnBJ;A4JppnBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;A5JspnBN;;A4JlpnBA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;A5JqpnBF;A4JnpnBE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A5JqpnBJ;A4JnpnBE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A5JqpnBJ;;A4JjpnBA;EACE,cAAA;EACA,SAAA;A5JopnBF;;A4JlpnBA;EACE,gBAAA;EACA,gBAAA;A5JqpnBF;;A4JlpnBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;A5JqpnBF;A4JppnBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;A5JspnBJ;;A4JlpnBA;EACE,WAAA;EACA,SAAA;EACA,6BAAA;A5JqpnBF;;A4JnpnBA;;EAEE,kBAAA;EACA,YAAA;A5JspnBF;;A4JppnBA;EACE,eAAA;A5JupnBF;;A4JrpnBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A5JwpnBF;A4JvpnBE;EASE,oCAAA;EACA,sBAAA;A5JipnBJ;A4J/onBE;EACE,0BAAA;EACA,6BAAA;A5JipnBJ;A4J/onBE;EACE,gBAAA;A5JipnBJ;A4J/onBE;EACE,yBAAA;EACA,4BAAA;A5JipnBJ;;A4J5onBI;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;A5J+onBN;A4J7onBI;EACE,czJxGK;EyJyGL,mBAAA;A5J+onBN;A4J9onBM;EAEE,czJ9GG;EyJ+GH,gBAAA;A5J+onBR;;A4JzonBA;;;;;;EAME,mBAAA;EACA,eAAA;A5J4onBF;;A4J1onBA;EACE,kBAAA;A5J6onBF;;A4J3onBA;EACE,yBAAA;A5J8onBF;;A4J5onBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5J+onBF;;A4J5onBA;EACE,cAAA;A5J+onBF;;A4J7onBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JgpnBF;;A4J9onBA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EAAa,gBAAA;EACb,uBAAA;A5JkpnBF;;A4JhpnBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;A5JmpnBF;;A4JjpnBA;;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;A5JopnBF;;A4JhpnBE;;;;;EAKE,czJzLO;AH40nBX;;A4J/onBA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5JkpnBF;;A4J/onBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JkpnBF;;A4JhpnBA;EACE,eAAA;A5JmpnBF;;A4JjpnBA;EACE,mBAAA;A5JopnBF;;A4JjpnBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A5JopnBF;;A4JlpnBA;EACE,sBAAA;A5JqpnBF;;A4JlpnBA;EACE,WAAA;EACA,YAAA;A5JqpnBF;;A4JlpnBA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;A5JqpnBF;;A4JnpnBA;;EAEE,gBAAA;A5JspnBF;;A4JnpnBA;EACE,qBAAA;A5JspnBF;;A4JlpnBE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A5JqpnBJ;A4JnpnBE;EACE,QAAA;EACA,6BAAA;A5JqpnBJ;;A4JjpnBA;EACE,aAAA;A5JopnBF;;A4JjpnBA;EACE,WAAA;A5JopnBF;A4JnpnBE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;A5JqpnBJ;;A4JhpnBI;EACE,czJrPI;EyJsPJ,kBAAA;EACA,yBAAA;A5JmpnBN;;A4J9onBA;EACE,YAAA;EACA,kBAAA;A5JipnBF;;A4J/onBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,czJjSS;EyJsST,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5JipnBF;;A4J/onBA;EACE,gBAAA;EACA,cAAA;A5JkpnBF;;A4JhpnBA;EACE,kBAAA;EACA,iBAAA;A5JmpnBF;;A4JhpnBA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;A5JmpnBF;;A4JhpnBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;A5JmpnBF;;A4JjpnBA;;EAEE,oBAAA;A5JopnBF;A4JnpnBE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A5JupnBJ;A4JrpnBI;;;;;;;;;;;;;EAIE,oCAAA;EACA,WzJ3VK;AH2/nBX;;A4J5pnBA;EACE,yBAAA;EACA,4BAAA;A5J+pnBF;;A4J7pnBA;EACE,yBAAA;EACA,4BAAA;A5JgqnBF;;A4J9pnBA;EACE,0BAAA;EACA,6BAAA;A5JiqnBF;;A4J9pnBA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;A5JiqnBF;;A6J5joBE;EACE,iBAAA;A7J+joBJ;;A6J5joBA;EACE,gBAAA;A7J+joBF;;A8JrkoBA;EACE,aAAA;A9JwkoBF;;A+JzkoBA;EACE;IACE,UAAA;IACA,2CAAA;E/J4koBF;E+J1koBA;IACE,UAAA;E/J4koBF;AACF;AgKnloBA;EACE,oBAAA;AhKqloBF;;AgKnloBA;EACE,iBAAA;AhKsloBF;;AiKzloBE;EAEE,iBAAA;AjK2loBJ;AiKzloBE;EACE,kBAAA;AjK2loBJ","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --blue: #5e72e4;\n  --indigo: #5603ad;\n  --purple: #8965e0;\n  --pink: #f3a4b5;\n  --red: #f5365c;\n  --orange: #fb6340;\n  --yellow: #ffd600;\n  --green: #2dce89;\n  --teal: #11cdef;\n  --cyan: #2bffc6;\n  --white: #fff;\n  --gray: #8898aa;\n  --gray-dark: #32325d;\n  --light: #ced4da;\n  --lighter: #e9ecef;\n  --primary: #5e72e4;\n  --secondary: #f7fafc;\n  --success: #2dce89;\n  --info: #11cdef;\n  --warning: #fb6340;\n  --danger: #f5365c;\n  --light: #adb5bd;\n  --dark: #212529;\n  --default: #172b4d;\n  --white: #fff;\n  --neutral: #fff;\n  --darker: black;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: Open Sans, sans-serif;\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: Open Sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #525f7f;\n  text-align: left;\n  background-color: #f8f9fe;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #5e72e4;\n  text-decoration: none;\n  background-color: transparent;\n}\na:hover {\n  color: #233dd2;\n  text-decoration: none;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  color: #8898aa;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #32325d;\n}\n\nh1, .h1 {\n  font-size: 1.625rem;\n}\n\nh2, .h2 {\n  font-size: 1.25rem;\n}\n\nh3, .h3 {\n  font-size: 1.0625rem;\n}\n\nh4, .h4 {\n  font-size: 0.9375rem;\n}\n\nh5, .h5 {\n  font-size: 0.8125rem;\n}\n\nh6, .h6 {\n  font-size: 0.625rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 3.3rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-2 {\n  font-size: 2.75rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-3 {\n  font-size: 2.1875rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-4 {\n  font-size: 1.6275rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\nhr {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #8898aa;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #f8f9fe;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #8898aa;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #f3a4b5;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.25rem;\n  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 600;\n  box-shadow: none;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-xl,\n.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,\n.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,\n.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,\n.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,\n.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.33333333%;\n  max-width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.66666667%;\n  max-width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.33333333%;\n  max-width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.66666667%;\n  max-width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.33333333%;\n  max-width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.66666667%;\n  max-width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.33333333%;\n  max-width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.66666667%;\n  max-width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-sm-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    order: -1;\n  }\n  .order-sm-last {\n    order: 13;\n  }\n  .order-sm-0 {\n    order: 0;\n  }\n  .order-sm-1 {\n    order: 1;\n  }\n  .order-sm-2 {\n    order: 2;\n  }\n  .order-sm-3 {\n    order: 3;\n  }\n  .order-sm-4 {\n    order: 4;\n  }\n  .order-sm-5 {\n    order: 5;\n  }\n  .order-sm-6 {\n    order: 6;\n  }\n  .order-sm-7 {\n    order: 7;\n  }\n  .order-sm-8 {\n    order: 8;\n  }\n  .order-sm-9 {\n    order: 9;\n  }\n  .order-sm-10 {\n    order: 10;\n  }\n  .order-sm-11 {\n    order: 11;\n  }\n  .order-sm-12 {\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-md-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    order: -1;\n  }\n  .order-md-last {\n    order: 13;\n  }\n  .order-md-0 {\n    order: 0;\n  }\n  .order-md-1 {\n    order: 1;\n  }\n  .order-md-2 {\n    order: 2;\n  }\n  .order-md-3 {\n    order: 3;\n  }\n  .order-md-4 {\n    order: 4;\n  }\n  .order-md-5 {\n    order: 5;\n  }\n  .order-md-6 {\n    order: 6;\n  }\n  .order-md-7 {\n    order: 7;\n  }\n  .order-md-8 {\n    order: 8;\n  }\n  .order-md-9 {\n    order: 9;\n  }\n  .order-md-10 {\n    order: 10;\n  }\n  .order-md-11 {\n    order: 11;\n  }\n  .order-md-12 {\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-lg-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    order: -1;\n  }\n  .order-lg-last {\n    order: 13;\n  }\n  .order-lg-0 {\n    order: 0;\n  }\n  .order-lg-1 {\n    order: 1;\n  }\n  .order-lg-2 {\n    order: 2;\n  }\n  .order-lg-3 {\n    order: 3;\n  }\n  .order-lg-4 {\n    order: 4;\n  }\n  .order-lg-5 {\n    order: 5;\n  }\n  .order-lg-6 {\n    order: 6;\n  }\n  .order-lg-7 {\n    order: 7;\n  }\n  .order-lg-8 {\n    order: 8;\n  }\n  .order-lg-9 {\n    order: 9;\n  }\n  .order-lg-10 {\n    order: 10;\n  }\n  .order-lg-11 {\n    order: 11;\n  }\n  .order-lg-12 {\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-xl-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    order: -1;\n  }\n  .order-xl-last {\n    order: 13;\n  }\n  .order-xl-0 {\n    order: 0;\n  }\n  .order-xl-1 {\n    order: 1;\n  }\n  .order-xl-2 {\n    order: 2;\n  }\n  .order-xl-3 {\n    order: 3;\n  }\n  .order-xl-4 {\n    order: 4;\n  }\n  .order-xl-5 {\n    order: 5;\n  }\n  .order-xl-6 {\n    order: 6;\n  }\n  .order-xl-7 {\n    order: 7;\n  }\n  .order-xl-8 {\n    order: 8;\n  }\n  .order-xl-9 {\n    order: 9;\n  }\n  .order-xl-10 {\n    order: 10;\n  }\n  .order-xl-11 {\n    order: 11;\n  }\n  .order-xl-12 {\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n}\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #525f7f;\n  background-color: transparent;\n}\n.table th,\n.table td {\n  padding: 1rem;\n  vertical-align: top;\n  border-top: 1px solid #e9ecef;\n}\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e9ecef;\n}\n.table tbody + tbody {\n  border-top: 2px solid #e9ecef;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.5rem;\n}\n\n.table-bordered {\n  border: 1px solid #e9ecef;\n}\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #e9ecef;\n}\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  color: #525f7f;\n  background-color: #f6f9fc;\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #d2d8f7;\n}\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #abb6f1;\n}\n\n.table-hover .table-primary:hover {\n  background-color: #bcc5f3;\n}\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: #bcc5f3;\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #fdfefe;\n}\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #fbfcfd;\n}\n\n.table-hover .table-secondary:hover {\n  background-color: #ecf6f6;\n}\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: #ecf6f6;\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #c4f1de;\n}\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #92e6c2;\n}\n\n.table-hover .table-success:hover {\n  background-color: #afecd2;\n}\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: #afecd2;\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #bcf1fb;\n}\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #83e5f7;\n}\n\n.table-hover .table-info:hover {\n  background-color: #a4ecfa;\n}\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: #a4ecfa;\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #fed3ca;\n}\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #fdae9c;\n}\n\n.table-hover .table-warning:hover {\n  background-color: #febeb1;\n}\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: #febeb1;\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #fcc7d1;\n}\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #fa96aa;\n}\n\n.table-hover .table-danger:hover {\n  background-color: #fbafbd;\n}\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: #fbafbd;\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #e8eaed;\n}\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #d4d9dd;\n}\n\n.table-hover .table-light:hover {\n  background-color: #dadde2;\n}\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: #dadde2;\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c1c2c3;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #8c8e90;\n}\n\n.table-hover .table-dark:hover {\n  background-color: #b4b5b6;\n}\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: #b4b5b6;\n}\n\n.table-default,\n.table-default > th,\n.table-default > td {\n  background-color: #bec4cd;\n}\n.table-default th,\n.table-default td,\n.table-default thead th,\n.table-default tbody + tbody {\n  border-color: #8691a2;\n}\n\n.table-hover .table-default:hover {\n  background-color: #b0b7c2;\n}\n.table-hover .table-default:hover > td,\n.table-hover .table-default:hover > th {\n  background-color: #b0b7c2;\n}\n\n.table-white,\n.table-white > th,\n.table-white > td {\n  background-color: white;\n}\n.table-white th,\n.table-white td,\n.table-white thead th,\n.table-white tbody + tbody {\n  border-color: white;\n}\n\n.table-hover .table-white:hover {\n  background-color: #f2f2f2;\n}\n.table-hover .table-white:hover > td,\n.table-hover .table-white:hover > th {\n  background-color: #f2f2f2;\n}\n\n.table-neutral,\n.table-neutral > th,\n.table-neutral > td {\n  background-color: white;\n}\n.table-neutral th,\n.table-neutral td,\n.table-neutral thead th,\n.table-neutral tbody + tbody {\n  border-color: white;\n}\n\n.table-hover .table-neutral:hover {\n  background-color: #f2f2f2;\n}\n.table-hover .table-neutral:hover > td,\n.table-hover .table-neutral:hover > th {\n  background-color: #f2f2f2;\n}\n\n.table-darker,\n.table-darker > th,\n.table-darker > td {\n  background-color: #b8b8b8;\n}\n.table-darker th,\n.table-darker td,\n.table-darker thead th,\n.table-darker tbody + tbody {\n  border-color: #7a7a7a;\n}\n\n.table-hover .table-darker:hover {\n  background-color: #ababab;\n}\n.table-hover .table-darker:hover > td,\n.table-hover .table-darker:hover > th {\n  background-color: #ababab;\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: #f6f9fc;\n}\n\n.table-hover .table-active:hover {\n  background-color: #e3ecf6;\n}\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: #e3ecf6;\n}\n\n.table .thead-dark th {\n  color: #f8f9fe;\n  background-color: #172b4d;\n  border-color: #1f3a68;\n}\n.table .thead-light th {\n  color: #8898aa;\n  background-color: #f6f9fc;\n  border-color: #e9ecef;\n}\n\n.table-dark {\n  color: #f8f9fe;\n  background-color: #172b4d;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: #1f3a68;\n}\n.table-dark.table-bordered {\n  border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n  color: #f8f9fe;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: none;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n  outline: 0;\n  box-shadow: none, none;\n}\n.form-control::placeholder {\n  color: #adb5bd;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\ninput[type=date].form-control,\ninput[type=time].form-control,\ninput[type=datetime-local].form-control,\ninput[type=month].form-control {\n  appearance: none;\n}\n\nselect.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #8898aa;\n}\nselect.form-control:focus::-ms-value {\n  color: #8898aa;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.625rem + 1px);\n  padding-bottom: calc(0.625rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.875rem + 1px);\n  padding-bottom: calc(0.875rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.625rem 0;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #525f7f;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 1.75rem + 2px);\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  color: #8898aa;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #2dce89;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(45, 206, 137, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid,\n.was-validated .custom-select:valid,\n.custom-select.is-valid {\n  border-color: #2dce89;\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus,\n.was-validated .custom-select:valid:focus,\n.custom-select.is-valid:focus {\n  border-color: #2dce89;\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip,\n.was-validated .custom-select:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-tooltip,\n.custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #2dce89;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #2dce89;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  background-color: #93e7c3;\n  border-color: #93e7c3;\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: #54daa1;\n  border-color: #93e7c3;\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(45, 206, 137, 0.25);\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #2dce89;\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #fb6340;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(251, 99, 64, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid,\n.was-validated .custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #fb6340;\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,\n.was-validated .custom-select:invalid:focus,\n.custom-select.is-invalid:focus {\n  border-color: #fb6340;\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\n.custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #fb6340;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #fb6340;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  background-color: #fec9bd;\n  border-color: #fec9bd;\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: #fc8c72;\n  border-color: #fec9bd;\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #fb6340;\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 600;\n  color: #525f7f;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.625rem 1.25rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.375rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #525f7f;\n  text-decoration: none;\n}\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.btn-primary:focus, .btn-primary.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(94, 114, 228, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #324cdd;\n  border-color: #5e72e4;\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(94, 114, 228, 0.5);\n}\n\n.btn-secondary {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-secondary:hover {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #212529;\n  background-color: #d2e3ee;\n  border-color: #f7fafc;\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #2dce89;\n  border-color: #2dce89;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #2dce89;\n  border-color: #2dce89;\n}\n.btn-success:focus, .btn-success.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(45, 206, 137, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #2dce89;\n  border-color: #2dce89;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #24a46d;\n  border-color: #2dce89;\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(45, 206, 137, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #11cdef;\n  border-color: #11cdef;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: #11cdef;\n  border-color: #11cdef;\n}\n.btn-info:focus, .btn-info.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(17, 205, 239, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #11cdef;\n  border-color: #11cdef;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #0da5c0;\n  border-color: #11cdef;\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(17, 205, 239, 0.5);\n}\n\n.btn-warning {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-warning:focus, .btn-warning.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #fa3a0e;\n  border-color: #fb6340;\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-danger:focus, .btn-danger.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #ec0c38;\n  border-color: #f5365c;\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n\n.btn-light {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-light:hover {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-light:focus, .btn-light.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #fff;\n  background-color: #919ca6;\n  border-color: #adb5bd;\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-dark:focus, .btn-dark.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #0a0c0d;\n  border-color: #212529;\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n\n.btn-default {\n  color: #fff;\n  background-color: #172b4d;\n  border-color: #172b4d;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-default:hover {\n  color: #fff;\n  background-color: #172b4d;\n  border-color: #172b4d;\n}\n.btn-default:focus, .btn-default.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(23, 43, 77, 0.5);\n}\n.btn-default.disabled, .btn-default:disabled {\n  color: #fff;\n  background-color: #172b4d;\n  border-color: #172b4d;\n}\n.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {\n  color: #fff;\n  background-color: #0b1526;\n  border-color: #172b4d;\n}\n.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(23, 43, 77, 0.5);\n}\n\n.btn-white {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-white:hover {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.btn-white:focus, .btn-white.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-white.disabled, .btn-white:disabled {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {\n  color: #212529;\n  background-color: #e6e6e6;\n  border-color: white;\n}\n.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-neutral {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-neutral:hover {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.btn-neutral:focus, .btn-neutral.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-neutral.disabled, .btn-neutral:disabled {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {\n  color: #212529;\n  background-color: #e6e6e6;\n  border-color: white;\n}\n.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-darker {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-darker:hover {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:focus, .btn-darker.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n.btn-darker.disabled, .btn-darker:disabled {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-outline-primary {\n  color: #5e72e4;\n  background-color: transparent;\n  background-image: none;\n  border-color: #5e72e4;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #5e72e4;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(94, 114, 228, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #f7fafc;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:hover {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #f7fafc;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n\n.btn-outline-success {\n  color: #2dce89;\n  background-color: transparent;\n  background-image: none;\n  border-color: #2dce89;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #2dce89;\n  border-color: #2dce89;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #2dce89;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #2dce89;\n  border-color: #2dce89;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.5);\n}\n\n.btn-outline-info {\n  color: #11cdef;\n  background-color: transparent;\n  background-image: none;\n  border-color: #11cdef;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #11cdef;\n  border-color: #11cdef;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #11cdef;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #11cdef;\n  border-color: #11cdef;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(17, 205, 239, 0.5);\n}\n\n.btn-outline-warning {\n  color: #fb6340;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fb6340;\n}\n.btn-outline-warning:hover {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #fb6340;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n\n.btn-outline-danger {\n  color: #f5365c;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f5365c;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #f5365c;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n\n.btn-outline-light {\n  color: #adb5bd;\n  background-color: transparent;\n  background-image: none;\n  border-color: #adb5bd;\n}\n.btn-outline-light:hover {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #adb5bd;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n\n.btn-outline-dark {\n  color: #212529;\n  background-color: transparent;\n  background-image: none;\n  border-color: #212529;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #212529;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n\n.btn-outline-default {\n  color: #172b4d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #172b4d;\n}\n.btn-outline-default:hover {\n  color: #fff;\n  background-color: #172b4d;\n  border-color: #172b4d;\n}\n.btn-outline-default:focus, .btn-outline-default.focus {\n  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);\n}\n.btn-outline-default.disabled, .btn-outline-default:disabled {\n  color: #172b4d;\n  background-color: transparent;\n}\n.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {\n  color: #fff;\n  background-color: #172b4d;\n  border-color: #172b4d;\n}\n.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(23, 43, 77, 0.5);\n}\n\n.btn-outline-white {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n}\n.btn-outline-white:hover {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-white:focus, .btn-outline-white.focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-outline-white.disabled, .btn-outline-white:disabled {\n  color: #fff;\n  background-color: transparent;\n}\n.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-neutral {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n}\n.btn-outline-neutral:hover {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-neutral:focus, .btn-outline-neutral.focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {\n  color: #fff;\n  background-color: transparent;\n}\n.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-darker {\n  color: black;\n  background-color: transparent;\n  background-image: none;\n  border-color: black;\n}\n.btn-outline-darker:hover {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-outline-darker:focus, .btn-outline-darker.focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n.btn-outline-darker.disabled, .btn-outline-darker:disabled {\n  color: black;\n  background-color: transparent;\n}\n.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #5e72e4;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: #233dd2;\n  text-decoration: none;\n}\n.btn-link:focus, .btn-link.focus {\n  text-decoration: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #8898aa;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.375rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=submit].btn-block,\ninput[type=reset].btn-block,\ninput[type=button].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.width {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.width {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #525f7f;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.4375rem;\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: #16181b;\n  text-decoration: none;\n  background-color: #e9ecef;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #5e72e4;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #8898aa;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: none;\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=radio],\n.btn-group-toggle > .btn input[type=checkbox],\n.btn-group-toggle > .btn-group > .btn input[type=radio],\n.btn-group-toggle > .btn-group > .btn input[type=checkbox] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group:not(.has-validation) > .form-control:not(:last-child),\n.input-group:not(.has-validation) > .custom-select:not(:last-child),\n.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,\n.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > .form-control:nth-last-child(n+3),\n.input-group.has-validation > .custom-select:nth-last-child(n+3),\n.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,\n.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.625rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #adb5bd;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #fff;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n}\n.input-group-text input[type=radio],\n.input-group-text input[type=checkbox] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1.75rem + 2px);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 3rem;\n  print-color-adjust: exact;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1.25rem;\n  height: 1.375rem;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #5e72e4;\n  background-color: #5e72e4;\n  box-shadow: none;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: none, none;\n}\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n  box-shadow: none;\n}\n.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n  color: #8898aa;\n}\n.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n.custom-control-label::before {\n  position: absolute;\n  top: 0.125rem;\n  left: -3rem;\n  display: block;\n  width: 1.25rem;\n  height: 1.25rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: 1px solid #cad1d7;\n  box-shadow: none;\n}\n.custom-control-label::after {\n  position: absolute;\n  top: 0.125rem;\n  left: -3rem;\n  display: block;\n  width: 1.25rem;\n  height: 1.25rem;\n  content: \"\";\n  background: 50%/50% 50% no-repeat;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #5e72e4;\n  background-color: #5e72e4;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(94, 114, 228, 0.5);\n}\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-switch {\n  padding-left: 3.9375rem;\n}\n.custom-switch .custom-control-label::before {\n  left: -3.9375rem;\n  width: 2.1875rem;\n  pointer-events: all;\n  border-radius: 0.625rem;\n}\n.custom-switch .custom-control-label::after {\n  top: calc(0.125rem + 2px);\n  left: calc(-3.9375rem + 2px);\n  width: calc(1.25rem - 4px);\n  height: calc(1.25rem - 4px);\n  background-color: #cad1d7;\n  border-radius: 0.625rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  transform: translateX(0.9375rem);\n}\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 1.75rem 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2332325d' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  appearance: none;\n}\n.custom-select:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n  outline: 0;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #5e72e4;\n}\n.custom-select:focus::-ms-value {\n  color: #8898aa;\n  background-color: #fff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.custom-select:disabled {\n  color: #8898aa;\n  background-color: #e9ecef;\n}\n.custom-select::-ms-expand {\n  display: none;\n}\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #8898aa;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 1.75rem + 2px);\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n  padding-left: 1rem;\n  font-size: 0.875rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: rgba(50, 151, 211, 0.25);\n  box-shadow: none;\n}\n.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {\n  background-color: #e9ecef;\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 0.75rem;\n  overflow: hidden;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  background-color: #fff;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: none;\n}\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 1.25rem);\n  padding: 0.625rem 0.75rem;\n  line-height: 1.5;\n  color: #8898aa;\n  content: \"Browse\";\n  background-color: #fff;\n  border-left: inherit;\n  border-radius: 0 0.375rem 0.375rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.custom-range:focus {\n  outline: 0;\n}\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #5e72e4;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #f7f8fe;\n}\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #5e72e4;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.custom-range::-moz-range-thumb:active {\n  background-color: #f7f8fe;\n}\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0;\n  margin-left: 0;\n  background-color: #5e72e4;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n.custom-range::-ms-thumb:active {\n  background-color: #f7f8fe;\n}\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.25rem 0.75rem;\n}\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n.nav-link.disabled {\n  color: #8898aa;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.disabled {\n  color: #8898aa;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #525f7f;\n  background-color: #f8f9fe;\n  border-color: #dee2e6 #dee2e6 #f8f9fe;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.375rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #5e72e4;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n.navbar .container,\n.navbar .container-fluid,\n.navbar .container-sm,\n.navbar .container-md,\n.navbar .container-lg,\n.navbar .container-xl {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.0625rem;\n  padding-bottom: 0.0625rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.375rem;\n}\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50%/100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid,\n  .navbar-expand-sm > .container-sm,\n  .navbar-expand-sm > .container-md,\n  .navbar-expand-sm > .container-lg,\n  .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid,\n  .navbar-expand-sm > .container-sm,\n  .navbar-expand-sm > .container-md,\n  .navbar-expand-sm > .container-lg,\n  .navbar-expand-sm > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid,\n  .navbar-expand-md > .container-sm,\n  .navbar-expand-md > .container-md,\n  .navbar-expand-md > .container-lg,\n  .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid,\n  .navbar-expand-md > .container-sm,\n  .navbar-expand-md > .container-md,\n  .navbar-expand-md > .container-lg,\n  .navbar-expand-md > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid,\n  .navbar-expand-lg > .container-sm,\n  .navbar-expand-lg > .container-md,\n  .navbar-expand-lg > .container-lg,\n  .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid,\n  .navbar-expand-lg > .container-sm,\n  .navbar-expand-lg > .container-md,\n  .navbar-expand-lg > .container-lg,\n  .navbar-expand-lg > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid,\n  .navbar-expand-xl > .container-sm,\n  .navbar-expand-xl > .container-md,\n  .navbar-expand-xl > .container-lg,\n  .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid,\n  .navbar-expand-xl > .container-sm,\n  .navbar-expand-xl > .container-md,\n  .navbar-expand-xl > .container-lg,\n  .navbar-expand-xl > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl {\n  flex-wrap: nowrap;\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: transparent;\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.95);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.95);\n  border-color: transparent;\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.95%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.95);\n}\n.navbar-dark .navbar-text a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 0.375rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.375rem - 1px);\n  border-top-right-radius: calc(0.375rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.375rem - 1px);\n  border-bottom-left-radius: calc(0.375rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.5rem;\n}\n\n.card-title {\n  margin-bottom: 1.25rem;\n}\n\n.card-subtitle {\n  margin-top: -0.625rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.5rem;\n}\n\n.card-header {\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.card-header:first-child {\n  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 1.25rem 1.5rem;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.75rem;\n  margin-bottom: -1.25rem;\n  margin-left: -0.75rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.75rem;\n  margin-left: -0.75rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.375rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.375rem - 1px);\n  border-top-right-radius: calc(0.375rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.375rem - 1px);\n  border-bottom-left-radius: calc(0.375rem - 1px);\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group > .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 1.25rem;\n}\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n.accordion > .card {\n  overflow: hidden;\n}\n.accordion > .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.accordion > .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.accordion > .card > .card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.375rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #8898aa;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #8898aa;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.375rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #8898aa;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.page-link:hover {\n  z-index: 2;\n  color: #8898aa;\n  text-decoration: none;\n  background-color: #dee2e6;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: none;\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.page-item.disabled .page-link {\n  color: #8898aa;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.4375rem;\n  border-bottom-left-radius: 0.4375rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.4375rem;\n  border-bottom-right-radius: 0.4375rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.35rem 0.375rem;\n  font-size: 66%;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.375rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.875em;\n  padding-left: 0.875em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #2643e9;\n  background-color: rgba(203, 210, 246, 0.5);\n}\n.badge-primary[href]:hover, .badge-primary[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #324cdd;\n}\n\n.badge-secondary {\n  color: #cfe3f1;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-secondary[href]:hover, .badge-secondary[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: #d2e3ee;\n}\n\n.badge-success {\n  color: #1aae6f;\n  background-color: rgba(147, 231, 195, 0.5);\n}\n.badge-success[href]:hover, .badge-success[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #24a46d;\n}\n\n.badge-info {\n  color: #03acca;\n  background-color: rgba(136, 230, 247, 0.5);\n}\n.badge-info[href]:hover, .badge-info[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #0da5c0;\n}\n\n.badge-warning {\n  color: #ff3709;\n  background-color: rgba(254, 201, 189, 0.5);\n}\n.badge-warning[href]:hover, .badge-warning[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #fa3a0e;\n}\n\n.badge-danger {\n  color: #f80031;\n  background-color: rgba(251, 175, 190, 0.5);\n}\n.badge-danger[href]:hover, .badge-danger[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #ec0c38;\n}\n\n.badge-light {\n  color: #879cb0;\n  background-color: rgba(244, 245, 246, 0.5);\n}\n.badge-light[href]:hover, .badge-light[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #919ca6;\n}\n\n.badge-dark {\n  color: #090c0e;\n  background-color: rgba(90, 101, 112, 0.5);\n}\n.badge-dark[href]:hover, .badge-dark[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #0a0c0d;\n}\n\n.badge-default {\n  color: #091428;\n  background-color: rgba(52, 98, 175, 0.5);\n}\n.badge-default[href]:hover, .badge-default[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: #0b1526;\n}\n\n.badge-white {\n  color: #e8e3e3;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-white[href]:hover, .badge-white[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: #e6e6e6;\n}\n\n.badge-neutral {\n  color: #e8e3e3;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-neutral[href]:hover, .badge-neutral[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: #e6e6e6;\n}\n\n.badge-darker {\n  color: black;\n  background-color: rgba(57, 64, 71, 0.5);\n}\n.badge-darker[href]:hover, .badge-darker[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: black;\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.4375rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 1rem 1.5rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.375rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n}\n\n.alert-dismissible {\n  padding-right: 4.5rem;\n}\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1rem 1.5rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #fff;\n  background-color: #7889e8;\n  border-color: #7889e8;\n}\n.alert-primary hr {\n  border-top-color: #6276e4;\n}\n.alert-primary .alert-link {\n  color: #324cdd;\n}\n\n.alert-secondary {\n  color: #212529;\n  background-color: #f8fbfc;\n  border-color: #f8fbfc;\n}\n.alert-secondary hr {\n  border-top-color: #e6f1f4;\n}\n.alert-secondary .alert-link {\n  color: #d2e3ee;\n}\n\n.alert-success {\n  color: #fff;\n  background-color: #4fd69c;\n  border-color: #4fd69c;\n}\n.alert-success hr {\n  border-top-color: #3ad190;\n}\n.alert-success .alert-link {\n  color: #24a46d;\n}\n\n.alert-info {\n  color: #fff;\n  background-color: #37d5f2;\n  border-color: #37d5f2;\n}\n.alert-info hr {\n  border-top-color: #1fd0f0;\n}\n.alert-info .alert-link {\n  color: #0da5c0;\n}\n\n.alert-warning {\n  color: #fff;\n  background-color: #fc7c5f;\n  border-color: #fc7c5f;\n}\n.alert-warning hr {\n  border-top-color: #fc6846;\n}\n.alert-warning .alert-link {\n  color: #fa3a0e;\n}\n\n.alert-danger {\n  color: #fff;\n  background-color: #f75676;\n  border-color: #f75676;\n}\n.alert-danger hr {\n  border-top-color: #f63e62;\n}\n.alert-danger .alert-link {\n  color: #ec0c38;\n}\n\n.alert-light {\n  color: #fff;\n  background-color: #bac1c8;\n  border-color: #bac1c8;\n}\n.alert-light hr {\n  border-top-color: #acb4bd;\n}\n.alert-light .alert-link {\n  color: #919ca6;\n}\n\n.alert-dark {\n  color: #fff;\n  background-color: #45484b;\n  border-color: #45484b;\n}\n.alert-dark hr {\n  border-top-color: #393b3e;\n}\n.alert-dark .alert-link {\n  color: #0a0c0d;\n}\n\n.alert-default {\n  color: #fff;\n  background-color: #3c4d69;\n  border-color: #3c4d69;\n}\n.alert-default hr {\n  border-top-color: #334159;\n}\n.alert-default .alert-link {\n  color: #0b1526;\n}\n\n.alert-white {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.alert-white hr {\n  border-top-color: #f2f2f2;\n}\n.alert-white .alert-link {\n  color: #e6e6e6;\n}\n\n.alert-neutral {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.alert-neutral hr {\n  border-top-color: #f2f2f2;\n}\n.alert-neutral .alert-link {\n  color: #e6e6e6;\n}\n\n.alert-darker {\n  color: #fff;\n  background-color: #292929;\n  border-color: #292929;\n}\n.alert-darker hr {\n  border-top-color: #1c1c1c;\n}\n.alert-darker .alert-link {\n  color: black;\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.375rem;\n  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #5e72e4;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.375rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #525f7f;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #525f7f;\n  text-decoration: none;\n  background-color: #f6f9fc;\n}\n.list-group-item-action:active {\n  color: #525f7f;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 1rem 1rem;\n  background-color: #fff;\n  border: 1px solid #e9ecef;\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #8898aa;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #5e72e4;\n  border-color: #5e72e4;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.375rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.375rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: #313b77;\n  background-color: #d2d8f7;\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: #313b77;\n  background-color: #bcc5f3;\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #313b77;\n  border-color: #313b77;\n}\n\n.list-group-item-secondary {\n  color: #808283;\n  background-color: #fdfefe;\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: #808283;\n  background-color: #ecf6f6;\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #808283;\n  border-color: #808283;\n}\n\n.list-group-item-success {\n  color: #176b47;\n  background-color: #c4f1de;\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: #176b47;\n  background-color: #afecd2;\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #176b47;\n  border-color: #176b47;\n}\n\n.list-group-item-info {\n  color: #096b7c;\n  background-color: #bcf1fb;\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: #096b7c;\n  background-color: #a4ecfa;\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #096b7c;\n  border-color: #096b7c;\n}\n\n.list-group-item-warning {\n  color: #833321;\n  background-color: #fed3ca;\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: #833321;\n  background-color: #febeb1;\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #833321;\n  border-color: #833321;\n}\n\n.list-group-item-danger {\n  color: #7f1c30;\n  background-color: #fcc7d1;\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: #7f1c30;\n  background-color: #fbafbd;\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #7f1c30;\n  border-color: #7f1c30;\n}\n\n.list-group-item-light {\n  color: #5a5e62;\n  background-color: #e8eaed;\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: #5a5e62;\n  background-color: #dadde2;\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #5a5e62;\n  border-color: #5a5e62;\n}\n\n.list-group-item-dark {\n  color: #111315;\n  background-color: #c1c2c3;\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: #111315;\n  background-color: #b4b5b6;\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #111315;\n  border-color: #111315;\n}\n\n.list-group-item-default {\n  color: #0c1628;\n  background-color: #bec4cd;\n}\n.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {\n  color: #0c1628;\n  background-color: #b0b7c2;\n}\n.list-group-item-default.list-group-item-action.active {\n  color: #fff;\n  background-color: #0c1628;\n  border-color: #0c1628;\n}\n\n.list-group-item-white {\n  color: #858585;\n  background-color: white;\n}\n.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {\n  color: #858585;\n  background-color: #f2f2f2;\n}\n.list-group-item-white.list-group-item-action.active {\n  color: #fff;\n  background-color: #858585;\n  border-color: #858585;\n}\n\n.list-group-item-neutral {\n  color: #858585;\n  background-color: white;\n}\n.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {\n  color: #858585;\n  background-color: #f2f2f2;\n}\n.list-group-item-neutral.list-group-item-action.active {\n  color: #fff;\n  background-color: #858585;\n  border-color: #858585;\n}\n\n.list-group-item-darker {\n  color: black;\n  background-color: #b8b8b8;\n}\n.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {\n  color: black;\n  background-color: #ababab;\n}\n.list-group-item-darker.list-group-item-action.active {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.6);\n  text-shadow: none;\n  opacity: 0.5;\n}\n.close:hover {\n  color: rgba(0, 0, 0, 0.6);\n  text-decoration: none;\n}\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: 0.75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  flex-shrink: 0;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: min-content;\n  content: \"\";\n}\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.4375rem;\n  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.16;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.25rem;\n  border-bottom: 0 solid #e9ecef;\n  border-top-left-radius: 0.4375rem;\n  border-top-right-radius: 0.4375rem;\n}\n.modal-header .close {\n  padding: 1.25rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.1;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1.25rem;\n  border-top: 0 solid #e9ecef;\n  border-bottom-right-radius: 0.4375rem;\n  border-bottom-left-radius: 0.4375rem;\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: min-content;\n  }\n  .modal-content {\n    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\n  }\n  .modal-sm {\n    max-width: 380px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.375rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 0.4375rem;\n  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1.5rem;\n  height: 0.75rem;\n  margin: 0 0.4375rem;\n}\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=top] {\n  margin-bottom: 0.75rem;\n}\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {\n  bottom: calc(-0.75rem - 1px);\n}\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {\n  bottom: 0;\n  border-width: 0.75rem 0.75rem 0;\n  border-top-color: transparent;\n}\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {\n  bottom: 1px;\n  border-width: 0.75rem 0.75rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=right] {\n  margin-left: 0.75rem;\n}\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {\n  left: calc(-0.75rem - 1px);\n  width: 0.75rem;\n  height: 1.5rem;\n  margin: 0.4375rem 0;\n}\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {\n  left: 0;\n  border-width: 0.75rem 0.75rem 0.75rem 0;\n  border-right-color: transparent;\n}\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {\n  left: 1px;\n  border-width: 0.75rem 0.75rem 0.75rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {\n  margin-top: 0.75rem;\n}\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {\n  top: calc(-0.75rem - 1px);\n}\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {\n  top: 0;\n  border-width: 0 0.75rem 0.75rem 0.75rem;\n  border-bottom-color: transparent;\n}\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {\n  top: 1px;\n  border-width: 0 0.75rem 0.75rem 0.75rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1.5rem;\n  margin-left: -0.75rem;\n  content: \"\";\n  border-bottom: 1px solid #fff;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=left] {\n  margin-right: 0.75rem;\n}\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {\n  right: calc(-0.75rem - 1px);\n  width: 0.75rem;\n  height: 1.5rem;\n  margin: 0.4375rem 0;\n}\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {\n  right: 0;\n  border-width: 0.75rem 0 0.75rem 0.75rem;\n  border-left-color: transparent;\n}\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {\n  right: 1px;\n  border-width: 0.75rem 0 0.75rem 0.75rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.95rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: #32325d;\n  background-color: #fff;\n  border-bottom: 1px solid #f2f2f2;\n  border-top-left-radius: calc(0.4375rem - 1px);\n  border-top-right-radius: calc(0.4375rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.95rem;\n  color: #525f7f;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: 50%/100% 100% no-repeat;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #5e72e4 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #324cdd !important;\n}\n\n.bg-secondary {\n  background-color: #f7fafc !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #d2e3ee !important;\n}\n\n.bg-success {\n  background-color: #2dce89 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #24a46d !important;\n}\n\n.bg-info {\n  background-color: #11cdef !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #0da5c0 !important;\n}\n\n.bg-warning {\n  background-color: #fb6340 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #fa3a0e !important;\n}\n\n.bg-danger {\n  background-color: #f5365c !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #ec0c38 !important;\n}\n\n.bg-light {\n  background-color: #adb5bd !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #919ca6 !important;\n}\n\n.bg-dark {\n  background-color: #212529 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #0a0c0d !important;\n}\n\n.bg-default {\n  background-color: #172b4d !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-default:hover, a.bg-default:focus,\nbutton.bg-default:hover,\nbutton.bg-default:focus {\n  background-color: #0b1526 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-white:hover, a.bg-white:focus,\nbutton.bg-white:hover,\nbutton.bg-white:focus {\n  background-color: #e6e6e6 !important;\n}\n\n.bg-neutral {\n  background-color: #fff !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-neutral:hover, a.bg-neutral:focus,\nbutton.bg-neutral:hover,\nbutton.bg-neutral:focus {\n  background-color: #e6e6e6 !important;\n}\n\n.bg-darker {\n  background-color: black !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-darker:hover, a.bg-darker:focus,\nbutton.bg-darker:hover,\nbutton.bg-darker:focus {\n  background-color: black !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #e9ecef !important;\n}\n\n.border-top {\n  border-top: 1px solid #e9ecef !important;\n}\n\n.border-right {\n  border-right: 1px solid #e9ecef !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #e9ecef !important;\n}\n\n.border-left {\n  border-left: 1px solid #e9ecef !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #5e72e4 !important;\n}\n\n.border-secondary {\n  border-color: #f7fafc !important;\n}\n\n.border-success {\n  border-color: #2dce89 !important;\n}\n\n.border-info {\n  border-color: #11cdef !important;\n}\n\n.border-warning {\n  border-color: #fb6340 !important;\n}\n\n.border-danger {\n  border-color: #f5365c !important;\n}\n\n.border-light {\n  border-color: #adb5bd !important;\n}\n\n.border-dark {\n  border-color: #212529 !important;\n}\n\n.border-default {\n  border-color: #172b4d !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-neutral {\n  border-color: #fff !important;\n}\n\n.border-darker {\n  border-color: black !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.25rem !important;\n}\n\n.rounded {\n  border-radius: 0.375rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.375rem !important;\n  border-top-right-radius: 0.375rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.375rem !important;\n  border-bottom-right-radius: 0.375rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.375rem !important;\n  border-bottom-left-radius: 0.375rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.375rem !important;\n  border-bottom-left-radius: 0.375rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.4375rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714286%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\n}\n\n.shadow, .card-profile-image img {\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.m--9 {\n  margin: -10rem !important;\n}\n\n.mt--9,\n.my--9 {\n  margin-top: -10rem !important;\n}\n\n.mr--9,\n.mx--9 {\n  margin-right: -10rem !important;\n}\n\n.mb--9,\n.my--9 {\n  margin-bottom: -10rem !important;\n}\n\n.ml--9,\n.mx--9 {\n  margin-left: -10rem !important;\n}\n\n.m--8 {\n  margin: -8rem !important;\n}\n\n.mt--8,\n.my--8 {\n  margin-top: -8rem !important;\n}\n\n.mr--8,\n.mx--8 {\n  margin-right: -8rem !important;\n}\n\n.mb--8,\n.my--8 {\n  margin-bottom: -8rem !important;\n}\n\n.ml--8,\n.mx--8 {\n  margin-left: -8rem !important;\n}\n\n.m--7 {\n  margin: -6rem !important;\n}\n\n.mt--7,\n.my--7 {\n  margin-top: -6rem !important;\n}\n\n.mr--7,\n.mx--7 {\n  margin-right: -6rem !important;\n}\n\n.mb--7,\n.my--7 {\n  margin-bottom: -6rem !important;\n}\n\n.ml--7,\n.mx--7 {\n  margin-left: -6rem !important;\n}\n\n.m--6 {\n  margin: -4.5rem !important;\n}\n\n.mt--6,\n.my--6 {\n  margin-top: -4.5rem !important;\n}\n\n.mr--6,\n.mx--6 {\n  margin-right: -4.5rem !important;\n}\n\n.mb--6,\n.my--6 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ml--6,\n.mx--6 {\n  margin-left: -4.5rem !important;\n}\n\n.m--5 {\n  margin: -3rem !important;\n}\n\n.mt--5,\n.my--5 {\n  margin-top: -3rem !important;\n}\n\n.mr--5,\n.mx--5 {\n  margin-right: -3rem !important;\n}\n\n.mb--5,\n.my--5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml--5,\n.mx--5 {\n  margin-left: -3rem !important;\n}\n\n.m--4 {\n  margin: -1.5rem !important;\n}\n\n.mt--4,\n.my--4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr--4,\n.mx--4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb--4,\n.my--4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml--4,\n.mx--4 {\n  margin-left: -1.5rem !important;\n}\n\n.m--3 {\n  margin: -1rem !important;\n}\n\n.mt--3,\n.my--3 {\n  margin-top: -1rem !important;\n}\n\n.mr--3,\n.mx--3 {\n  margin-right: -1rem !important;\n}\n\n.mb--3,\n.my--3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml--3,\n.mx--3 {\n  margin-left: -1rem !important;\n}\n\n.m--2 {\n  margin: -0.5rem !important;\n}\n\n.mt--2,\n.my--2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr--2,\n.mx--2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb--2,\n.my--2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml--2,\n.mx--2 {\n  margin-left: -0.5rem !important;\n}\n\n.m--1 {\n  margin: -0.25rem !important;\n}\n\n.mt--1,\n.my--1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr--1,\n.mx--1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb--1,\n.my--1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml--1,\n.mx--1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-6 {\n  margin: 4.5rem !important;\n}\n\n.mt-6,\n.my-6 {\n  margin-top: 4.5rem !important;\n}\n\n.mr-6,\n.mx-6 {\n  margin-right: 4.5rem !important;\n}\n\n.mb-6,\n.my-6 {\n  margin-bottom: 4.5rem !important;\n}\n\n.ml-6,\n.mx-6 {\n  margin-left: 4.5rem !important;\n}\n\n.m-7 {\n  margin: 6rem !important;\n}\n\n.mt-7,\n.my-7 {\n  margin-top: 6rem !important;\n}\n\n.mr-7,\n.mx-7 {\n  margin-right: 6rem !important;\n}\n\n.mb-7,\n.my-7 {\n  margin-bottom: 6rem !important;\n}\n\n.ml-7,\n.mx-7 {\n  margin-left: 6rem !important;\n}\n\n.m-8 {\n  margin: 8rem !important;\n}\n\n.mt-8,\n.my-8 {\n  margin-top: 8rem !important;\n}\n\n.mr-8,\n.mx-8 {\n  margin-right: 8rem !important;\n}\n\n.mb-8,\n.my-8 {\n  margin-bottom: 8rem !important;\n}\n\n.ml-8,\n.mx-8 {\n  margin-left: 8rem !important;\n}\n\n.m-9 {\n  margin: 10rem !important;\n}\n\n.mt-9,\n.my-9 {\n  margin-top: 10rem !important;\n}\n\n.mr-9,\n.mx-9 {\n  margin-right: 10rem !important;\n}\n\n.mb-9,\n.my-9 {\n  margin-bottom: 10rem !important;\n}\n\n.ml-9,\n.mx-9 {\n  margin-left: 10rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.p--9 {\n  padding: -10rem !important;\n}\n\n.pt--9,\n.py--9 {\n  padding-top: -10rem !important;\n}\n\n.pr--9,\n.px--9 {\n  padding-right: -10rem !important;\n}\n\n.pb--9,\n.py--9 {\n  padding-bottom: -10rem !important;\n}\n\n.pl--9,\n.px--9 {\n  padding-left: -10rem !important;\n}\n\n.p--8 {\n  padding: -8rem !important;\n}\n\n.pt--8,\n.py--8 {\n  padding-top: -8rem !important;\n}\n\n.pr--8,\n.px--8 {\n  padding-right: -8rem !important;\n}\n\n.pb--8,\n.py--8 {\n  padding-bottom: -8rem !important;\n}\n\n.pl--8,\n.px--8 {\n  padding-left: -8rem !important;\n}\n\n.p--7 {\n  padding: -6rem !important;\n}\n\n.pt--7,\n.py--7 {\n  padding-top: -6rem !important;\n}\n\n.pr--7,\n.px--7 {\n  padding-right: -6rem !important;\n}\n\n.pb--7,\n.py--7 {\n  padding-bottom: -6rem !important;\n}\n\n.pl--7,\n.px--7 {\n  padding-left: -6rem !important;\n}\n\n.p--6 {\n  padding: -4.5rem !important;\n}\n\n.pt--6,\n.py--6 {\n  padding-top: -4.5rem !important;\n}\n\n.pr--6,\n.px--6 {\n  padding-right: -4.5rem !important;\n}\n\n.pb--6,\n.py--6 {\n  padding-bottom: -4.5rem !important;\n}\n\n.pl--6,\n.px--6 {\n  padding-left: -4.5rem !important;\n}\n\n.p--5 {\n  padding: -3rem !important;\n}\n\n.pt--5,\n.py--5 {\n  padding-top: -3rem !important;\n}\n\n.pr--5,\n.px--5 {\n  padding-right: -3rem !important;\n}\n\n.pb--5,\n.py--5 {\n  padding-bottom: -3rem !important;\n}\n\n.pl--5,\n.px--5 {\n  padding-left: -3rem !important;\n}\n\n.p--4 {\n  padding: -1.5rem !important;\n}\n\n.pt--4,\n.py--4 {\n  padding-top: -1.5rem !important;\n}\n\n.pr--4,\n.px--4 {\n  padding-right: -1.5rem !important;\n}\n\n.pb--4,\n.py--4 {\n  padding-bottom: -1.5rem !important;\n}\n\n.pl--4,\n.px--4 {\n  padding-left: -1.5rem !important;\n}\n\n.p--3 {\n  padding: -1rem !important;\n}\n\n.pt--3,\n.py--3 {\n  padding-top: -1rem !important;\n}\n\n.pr--3,\n.px--3 {\n  padding-right: -1rem !important;\n}\n\n.pb--3,\n.py--3 {\n  padding-bottom: -1rem !important;\n}\n\n.pl--3,\n.px--3 {\n  padding-left: -1rem !important;\n}\n\n.p--2 {\n  padding: -0.5rem !important;\n}\n\n.pt--2,\n.py--2 {\n  padding-top: -0.5rem !important;\n}\n\n.pr--2,\n.px--2 {\n  padding-right: -0.5rem !important;\n}\n\n.pb--2,\n.py--2 {\n  padding-bottom: -0.5rem !important;\n}\n\n.pl--2,\n.px--2 {\n  padding-left: -0.5rem !important;\n}\n\n.p--1 {\n  padding: -0.25rem !important;\n}\n\n.pt--1,\n.py--1 {\n  padding-top: -0.25rem !important;\n}\n\n.pr--1,\n.px--1 {\n  padding-right: -0.25rem !important;\n}\n\n.pb--1,\n.py--1 {\n  padding-bottom: -0.25rem !important;\n}\n\n.pl--1,\n.px--1 {\n  padding-left: -0.25rem !important;\n}\n\n.p-6 {\n  padding: 4.5rem !important;\n}\n\n.pt-6,\n.py-6 {\n  padding-top: 4.5rem !important;\n}\n\n.pr-6,\n.px-6 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-6,\n.py-6 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pl-6,\n.px-6 {\n  padding-left: 4.5rem !important;\n}\n\n.p-7 {\n  padding: 6rem !important;\n}\n\n.pt-7,\n.py-7 {\n  padding-top: 6rem !important;\n}\n\n.pr-7,\n.px-7 {\n  padding-right: 6rem !important;\n}\n\n.pb-7,\n.py-7 {\n  padding-bottom: 6rem !important;\n}\n\n.pl-7,\n.px-7 {\n  padding-left: 6rem !important;\n}\n\n.p-8 {\n  padding: 8rem !important;\n}\n\n.pt-8,\n.py-8 {\n  padding-top: 8rem !important;\n}\n\n.pr-8,\n.px-8 {\n  padding-right: 8rem !important;\n}\n\n.pb-8,\n.py-8 {\n  padding-bottom: 8rem !important;\n}\n\n.pl-8,\n.px-8 {\n  padding-left: 8rem !important;\n}\n\n.p-9 {\n  padding: 10rem !important;\n}\n\n.pt-9,\n.py-9 {\n  padding-top: 10rem !important;\n}\n\n.pr-9,\n.px-9 {\n  padding-right: 10rem !important;\n}\n\n.pb-9,\n.py-9 {\n  padding-bottom: 10rem !important;\n}\n\n.pl-9,\n.px-9 {\n  padding-left: 10rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important;\n}\n\n.m-n-9 {\n  margin: 10rem !important;\n}\n\n.mt-n-9,\n.my-n-9 {\n  margin-top: 10rem !important;\n}\n\n.mr-n-9,\n.mx-n-9 {\n  margin-right: 10rem !important;\n}\n\n.mb-n-9,\n.my-n-9 {\n  margin-bottom: 10rem !important;\n}\n\n.ml-n-9,\n.mx-n-9 {\n  margin-left: 10rem !important;\n}\n\n.m-n-8 {\n  margin: 8rem !important;\n}\n\n.mt-n-8,\n.my-n-8 {\n  margin-top: 8rem !important;\n}\n\n.mr-n-8,\n.mx-n-8 {\n  margin-right: 8rem !important;\n}\n\n.mb-n-8,\n.my-n-8 {\n  margin-bottom: 8rem !important;\n}\n\n.ml-n-8,\n.mx-n-8 {\n  margin-left: 8rem !important;\n}\n\n.m-n-7 {\n  margin: 6rem !important;\n}\n\n.mt-n-7,\n.my-n-7 {\n  margin-top: 6rem !important;\n}\n\n.mr-n-7,\n.mx-n-7 {\n  margin-right: 6rem !important;\n}\n\n.mb-n-7,\n.my-n-7 {\n  margin-bottom: 6rem !important;\n}\n\n.ml-n-7,\n.mx-n-7 {\n  margin-left: 6rem !important;\n}\n\n.m-n-6 {\n  margin: 4.5rem !important;\n}\n\n.mt-n-6,\n.my-n-6 {\n  margin-top: 4.5rem !important;\n}\n\n.mr-n-6,\n.mx-n-6 {\n  margin-right: 4.5rem !important;\n}\n\n.mb-n-6,\n.my-n-6 {\n  margin-bottom: 4.5rem !important;\n}\n\n.ml-n-6,\n.mx-n-6 {\n  margin-left: 4.5rem !important;\n}\n\n.m-n-5 {\n  margin: 3rem !important;\n}\n\n.mt-n-5,\n.my-n-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-n-5,\n.mx-n-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-n-5,\n.my-n-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-n-5,\n.mx-n-5 {\n  margin-left: 3rem !important;\n}\n\n.m-n-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-n-4,\n.my-n-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-n-4,\n.mx-n-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-n-4,\n.my-n-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-n-4,\n.mx-n-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-n-3 {\n  margin: 1rem !important;\n}\n\n.mt-n-3,\n.my-n-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-n-3,\n.mx-n-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-n-3,\n.my-n-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-n-3,\n.mx-n-3 {\n  margin-left: 1rem !important;\n}\n\n.m-n-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-n-2,\n.my-n-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-n-2,\n.mx-n-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-n-2,\n.my-n-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-n-2,\n.mx-n-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-n-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-n-1,\n.my-n-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-n-1,\n.mx-n-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-n-1,\n.my-n-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-n-1,\n.mx-n-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-n6 {\n  margin: -4.5rem !important;\n}\n\n.mt-n6,\n.my-n6 {\n  margin-top: -4.5rem !important;\n}\n\n.mr-n6,\n.mx-n6 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n6,\n.my-n6 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ml-n6,\n.mx-n6 {\n  margin-left: -4.5rem !important;\n}\n\n.m-n7 {\n  margin: -6rem !important;\n}\n\n.mt-n7,\n.my-n7 {\n  margin-top: -6rem !important;\n}\n\n.mr-n7,\n.mx-n7 {\n  margin-right: -6rem !important;\n}\n\n.mb-n7,\n.my-n7 {\n  margin-bottom: -6rem !important;\n}\n\n.ml-n7,\n.mx-n7 {\n  margin-left: -6rem !important;\n}\n\n.m-n8 {\n  margin: -8rem !important;\n}\n\n.mt-n8,\n.my-n8 {\n  margin-top: -8rem !important;\n}\n\n.mr-n8,\n.mx-n8 {\n  margin-right: -8rem !important;\n}\n\n.mb-n8,\n.my-n8 {\n  margin-bottom: -8rem !important;\n}\n\n.ml-n8,\n.mx-n8 {\n  margin-left: -8rem !important;\n}\n\n.m-n9 {\n  margin: -10rem !important;\n}\n\n.mt-n9,\n.my-n9 {\n  margin-top: -10rem !important;\n}\n\n.mr-n9,\n.mx-n9 {\n  margin-right: -10rem !important;\n}\n\n.mb-n9,\n.my-n9 {\n  margin-bottom: -10rem !important;\n}\n\n.ml-n9,\n.mx-n9 {\n  margin-left: -10rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .m-sm--9 {\n    margin: -10rem !important;\n  }\n  .mt-sm--9,\n  .my-sm--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-sm--9,\n  .mx-sm--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-sm--9,\n  .my-sm--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-sm--9,\n  .mx-sm--9 {\n    margin-left: -10rem !important;\n  }\n  .m-sm--8 {\n    margin: -8rem !important;\n  }\n  .mt-sm--8,\n  .my-sm--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-sm--8,\n  .mx-sm--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-sm--8,\n  .my-sm--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-sm--8,\n  .mx-sm--8 {\n    margin-left: -8rem !important;\n  }\n  .m-sm--7 {\n    margin: -6rem !important;\n  }\n  .mt-sm--7,\n  .my-sm--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-sm--7,\n  .mx-sm--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-sm--7,\n  .my-sm--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-sm--7,\n  .mx-sm--7 {\n    margin-left: -6rem !important;\n  }\n  .m-sm--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-sm--6,\n  .my-sm--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-sm--6,\n  .mx-sm--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm--6,\n  .my-sm--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-sm--6,\n  .mx-sm--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-sm--5 {\n    margin: -3rem !important;\n  }\n  .mt-sm--5,\n  .my-sm--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm--5,\n  .mx-sm--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm--5,\n  .my-sm--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm--5,\n  .mx-sm--5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm--4,\n  .my-sm--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm--4,\n  .mx-sm--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm--4,\n  .my-sm--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm--4,\n  .mx-sm--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm--3 {\n    margin: -1rem !important;\n  }\n  .mt-sm--3,\n  .my-sm--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm--3,\n  .mx-sm--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm--3,\n  .my-sm--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm--3,\n  .mx-sm--3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm--2,\n  .my-sm--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm--2,\n  .mx-sm--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm--2,\n  .my-sm--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm--2,\n  .mx-sm--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm--1,\n  .my-sm--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm--1,\n  .mx-sm--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm--1,\n  .my-sm--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm--1,\n  .mx-sm--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-sm-6,\n  .my-sm-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-sm-6,\n  .mx-sm-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-sm-6,\n  .my-sm-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-sm-6,\n  .mx-sm-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-sm-7 {\n    margin: 6rem !important;\n  }\n  .mt-sm-7,\n  .my-sm-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-sm-7,\n  .mx-sm-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-sm-7,\n  .my-sm-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-sm-7,\n  .mx-sm-7 {\n    margin-left: 6rem !important;\n  }\n  .m-sm-8 {\n    margin: 8rem !important;\n  }\n  .mt-sm-8,\n  .my-sm-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-sm-8,\n  .mx-sm-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-sm-8,\n  .my-sm-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-sm-8,\n  .mx-sm-8 {\n    margin-left: 8rem !important;\n  }\n  .m-sm-9 {\n    margin: 10rem !important;\n  }\n  .mt-sm-9,\n  .my-sm-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-sm-9,\n  .mx-sm-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-sm-9,\n  .my-sm-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-sm-9,\n  .mx-sm-9 {\n    margin-left: 10rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .p-sm--9 {\n    padding: -10rem !important;\n  }\n  .pt-sm--9,\n  .py-sm--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-sm--9,\n  .px-sm--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-sm--9,\n  .py-sm--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-sm--9,\n  .px-sm--9 {\n    padding-left: -10rem !important;\n  }\n  .p-sm--8 {\n    padding: -8rem !important;\n  }\n  .pt-sm--8,\n  .py-sm--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-sm--8,\n  .px-sm--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-sm--8,\n  .py-sm--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-sm--8,\n  .px-sm--8 {\n    padding-left: -8rem !important;\n  }\n  .p-sm--7 {\n    padding: -6rem !important;\n  }\n  .pt-sm--7,\n  .py-sm--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-sm--7,\n  .px-sm--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-sm--7,\n  .py-sm--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-sm--7,\n  .px-sm--7 {\n    padding-left: -6rem !important;\n  }\n  .p-sm--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-sm--6,\n  .py-sm--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-sm--6,\n  .px-sm--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-sm--6,\n  .py-sm--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-sm--6,\n  .px-sm--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-sm--5 {\n    padding: -3rem !important;\n  }\n  .pt-sm--5,\n  .py-sm--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-sm--5,\n  .px-sm--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-sm--5,\n  .py-sm--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-sm--5,\n  .px-sm--5 {\n    padding-left: -3rem !important;\n  }\n  .p-sm--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-sm--4,\n  .py-sm--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-sm--4,\n  .px-sm--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-sm--4,\n  .py-sm--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-sm--4,\n  .px-sm--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-sm--3 {\n    padding: -1rem !important;\n  }\n  .pt-sm--3,\n  .py-sm--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-sm--3,\n  .px-sm--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-sm--3,\n  .py-sm--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-sm--3,\n  .px-sm--3 {\n    padding-left: -1rem !important;\n  }\n  .p-sm--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-sm--2,\n  .py-sm--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-sm--2,\n  .px-sm--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-sm--2,\n  .py-sm--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-sm--2,\n  .px-sm--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-sm--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-sm--1,\n  .py-sm--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-sm--1,\n  .px-sm--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-sm--1,\n  .py-sm--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-sm--1,\n  .px-sm--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-sm-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-sm-6,\n  .py-sm-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-sm-6,\n  .px-sm-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-6,\n  .py-sm-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-sm-6,\n  .px-sm-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-sm-7 {\n    padding: 6rem !important;\n  }\n  .pt-sm-7,\n  .py-sm-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-sm-7,\n  .px-sm-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-sm-7,\n  .py-sm-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-sm-7,\n  .px-sm-7 {\n    padding-left: 6rem !important;\n  }\n  .p-sm-8 {\n    padding: 8rem !important;\n  }\n  .pt-sm-8,\n  .py-sm-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-sm-8,\n  .px-sm-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-sm-8,\n  .py-sm-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-sm-8,\n  .px-sm-8 {\n    padding-left: 8rem !important;\n  }\n  .p-sm-9 {\n    padding: 10rem !important;\n  }\n  .pt-sm-9,\n  .py-sm-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-sm-9,\n  .px-sm-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-sm-9,\n  .py-sm-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-sm-9,\n  .px-sm-9 {\n    padding-left: 10rem !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-sm-n-9,\n  .my-sm-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-sm-n-9,\n  .mx-sm-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-sm-n-9,\n  .my-sm-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-sm-n-9,\n  .mx-sm-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-sm-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-sm-n-8,\n  .my-sm-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-sm-n-8,\n  .mx-sm-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-sm-n-8,\n  .my-sm-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-sm-n-8,\n  .mx-sm-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-sm-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-sm-n-7,\n  .my-sm-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-sm-n-7,\n  .mx-sm-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-sm-n-7,\n  .my-sm-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-sm-n-7,\n  .mx-sm-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-sm-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-sm-n-6,\n  .my-sm-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-sm-n-6,\n  .mx-sm-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-sm-n-6,\n  .my-sm-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-sm-n-6,\n  .mx-sm-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-sm-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-n-5,\n  .my-sm-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-n-5,\n  .mx-sm-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-n-5,\n  .my-sm-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-n-5,\n  .mx-sm-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-sm-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-n-4,\n  .my-sm-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-n-4,\n  .mx-sm-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-n-4,\n  .my-sm-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-n-4,\n  .mx-sm-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-n-3,\n  .my-sm-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-n-3,\n  .mx-sm-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-n-3,\n  .my-sm-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-n-3,\n  .mx-sm-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-n-2,\n  .my-sm-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-n-2,\n  .mx-sm-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-n-2,\n  .my-sm-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-n-2,\n  .mx-sm-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-n-1,\n  .my-sm-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-n-1,\n  .mx-sm-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-n-1,\n  .my-sm-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-n-1,\n  .mx-sm-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-sm-n6,\n  .my-sm-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-sm-n6,\n  .mx-sm-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n6,\n  .my-sm-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-sm-n6,\n  .mx-sm-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-sm-n7 {\n    margin: -6rem !important;\n  }\n  .mt-sm-n7,\n  .my-sm-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-sm-n7,\n  .mx-sm-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-sm-n7,\n  .my-sm-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-sm-n7,\n  .mx-sm-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-sm-n8 {\n    margin: -8rem !important;\n  }\n  .mt-sm-n8,\n  .my-sm-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-sm-n8,\n  .mx-sm-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-sm-n8,\n  .my-sm-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-sm-n8,\n  .mx-sm-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-sm-n9 {\n    margin: -10rem !important;\n  }\n  .mt-sm-n9,\n  .my-sm-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-sm-n9,\n  .mx-sm-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-sm-n9,\n  .my-sm-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-sm-n9,\n  .mx-sm-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .m-md--9 {\n    margin: -10rem !important;\n  }\n  .mt-md--9,\n  .my-md--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-md--9,\n  .mx-md--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-md--9,\n  .my-md--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-md--9,\n  .mx-md--9 {\n    margin-left: -10rem !important;\n  }\n  .m-md--8 {\n    margin: -8rem !important;\n  }\n  .mt-md--8,\n  .my-md--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-md--8,\n  .mx-md--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-md--8,\n  .my-md--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-md--8,\n  .mx-md--8 {\n    margin-left: -8rem !important;\n  }\n  .m-md--7 {\n    margin: -6rem !important;\n  }\n  .mt-md--7,\n  .my-md--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-md--7,\n  .mx-md--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-md--7,\n  .my-md--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-md--7,\n  .mx-md--7 {\n    margin-left: -6rem !important;\n  }\n  .m-md--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-md--6,\n  .my-md--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-md--6,\n  .mx-md--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md--6,\n  .my-md--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-md--6,\n  .mx-md--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-md--5 {\n    margin: -3rem !important;\n  }\n  .mt-md--5,\n  .my-md--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md--5,\n  .mx-md--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md--5,\n  .my-md--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md--5,\n  .mx-md--5 {\n    margin-left: -3rem !important;\n  }\n  .m-md--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md--4,\n  .my-md--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md--4,\n  .mx-md--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md--4,\n  .my-md--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md--4,\n  .mx-md--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md--3 {\n    margin: -1rem !important;\n  }\n  .mt-md--3,\n  .my-md--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md--3,\n  .mx-md--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md--3,\n  .my-md--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md--3,\n  .mx-md--3 {\n    margin-left: -1rem !important;\n  }\n  .m-md--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md--2,\n  .my-md--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md--2,\n  .mx-md--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md--2,\n  .my-md--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md--2,\n  .mx-md--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md--1,\n  .my-md--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md--1,\n  .mx-md--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md--1,\n  .my-md--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md--1,\n  .mx-md--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-md-6,\n  .my-md-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-md-6,\n  .mx-md-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-md-6,\n  .my-md-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-md-6,\n  .mx-md-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-md-7 {\n    margin: 6rem !important;\n  }\n  .mt-md-7,\n  .my-md-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-md-7,\n  .mx-md-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-md-7,\n  .my-md-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-md-7,\n  .mx-md-7 {\n    margin-left: 6rem !important;\n  }\n  .m-md-8 {\n    margin: 8rem !important;\n  }\n  .mt-md-8,\n  .my-md-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-md-8,\n  .mx-md-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-md-8,\n  .my-md-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-md-8,\n  .mx-md-8 {\n    margin-left: 8rem !important;\n  }\n  .m-md-9 {\n    margin: 10rem !important;\n  }\n  .mt-md-9,\n  .my-md-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-md-9,\n  .mx-md-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-md-9,\n  .my-md-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-md-9,\n  .mx-md-9 {\n    margin-left: 10rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .p-md--9 {\n    padding: -10rem !important;\n  }\n  .pt-md--9,\n  .py-md--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-md--9,\n  .px-md--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-md--9,\n  .py-md--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-md--9,\n  .px-md--9 {\n    padding-left: -10rem !important;\n  }\n  .p-md--8 {\n    padding: -8rem !important;\n  }\n  .pt-md--8,\n  .py-md--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-md--8,\n  .px-md--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-md--8,\n  .py-md--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-md--8,\n  .px-md--8 {\n    padding-left: -8rem !important;\n  }\n  .p-md--7 {\n    padding: -6rem !important;\n  }\n  .pt-md--7,\n  .py-md--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-md--7,\n  .px-md--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-md--7,\n  .py-md--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-md--7,\n  .px-md--7 {\n    padding-left: -6rem !important;\n  }\n  .p-md--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-md--6,\n  .py-md--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-md--6,\n  .px-md--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-md--6,\n  .py-md--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-md--6,\n  .px-md--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-md--5 {\n    padding: -3rem !important;\n  }\n  .pt-md--5,\n  .py-md--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-md--5,\n  .px-md--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-md--5,\n  .py-md--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-md--5,\n  .px-md--5 {\n    padding-left: -3rem !important;\n  }\n  .p-md--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-md--4,\n  .py-md--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-md--4,\n  .px-md--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-md--4,\n  .py-md--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-md--4,\n  .px-md--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-md--3 {\n    padding: -1rem !important;\n  }\n  .pt-md--3,\n  .py-md--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-md--3,\n  .px-md--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-md--3,\n  .py-md--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-md--3,\n  .px-md--3 {\n    padding-left: -1rem !important;\n  }\n  .p-md--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-md--2,\n  .py-md--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-md--2,\n  .px-md--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-md--2,\n  .py-md--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-md--2,\n  .px-md--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-md--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-md--1,\n  .py-md--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-md--1,\n  .px-md--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-md--1,\n  .py-md--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-md--1,\n  .px-md--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-md-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-md-6,\n  .py-md-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-md-6,\n  .px-md-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-6,\n  .py-md-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-md-6,\n  .px-md-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-md-7 {\n    padding: 6rem !important;\n  }\n  .pt-md-7,\n  .py-md-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-md-7,\n  .px-md-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-md-7,\n  .py-md-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-md-7,\n  .px-md-7 {\n    padding-left: 6rem !important;\n  }\n  .p-md-8 {\n    padding: 8rem !important;\n  }\n  .pt-md-8,\n  .py-md-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-md-8,\n  .px-md-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-md-8,\n  .py-md-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-md-8,\n  .px-md-8 {\n    padding-left: 8rem !important;\n  }\n  .p-md-9 {\n    padding: 10rem !important;\n  }\n  .pt-md-9,\n  .py-md-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-md-9,\n  .px-md-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-md-9,\n  .py-md-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-md-9,\n  .px-md-9 {\n    padding-left: 10rem !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-md-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-md-n-9,\n  .my-md-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-md-n-9,\n  .mx-md-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-md-n-9,\n  .my-md-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-md-n-9,\n  .mx-md-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-md-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-md-n-8,\n  .my-md-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-md-n-8,\n  .mx-md-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-md-n-8,\n  .my-md-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-md-n-8,\n  .mx-md-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-md-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-md-n-7,\n  .my-md-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-md-n-7,\n  .mx-md-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-md-n-7,\n  .my-md-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-md-n-7,\n  .mx-md-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-md-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-md-n-6,\n  .my-md-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-md-n-6,\n  .mx-md-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-md-n-6,\n  .my-md-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-md-n-6,\n  .mx-md-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-md-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-n-5,\n  .my-md-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-n-5,\n  .mx-md-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-n-5,\n  .my-md-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-n-5,\n  .mx-md-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-md-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-n-4,\n  .my-md-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-n-4,\n  .mx-md-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-n-4,\n  .my-md-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-n-4,\n  .mx-md-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-n-3,\n  .my-md-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-n-3,\n  .mx-md-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-n-3,\n  .my-md-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-n-3,\n  .mx-md-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-n-2,\n  .my-md-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-n-2,\n  .mx-md-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-n-2,\n  .my-md-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-n-2,\n  .mx-md-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-n-1,\n  .my-md-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-n-1,\n  .mx-md-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-n-1,\n  .my-md-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-n-1,\n  .mx-md-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-md-n6,\n  .my-md-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-md-n6,\n  .mx-md-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n6,\n  .my-md-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-md-n6,\n  .mx-md-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-md-n7 {\n    margin: -6rem !important;\n  }\n  .mt-md-n7,\n  .my-md-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-md-n7,\n  .mx-md-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-md-n7,\n  .my-md-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-md-n7,\n  .mx-md-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-md-n8 {\n    margin: -8rem !important;\n  }\n  .mt-md-n8,\n  .my-md-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-md-n8,\n  .mx-md-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-md-n8,\n  .my-md-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-md-n8,\n  .mx-md-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-md-n9 {\n    margin: -10rem !important;\n  }\n  .mt-md-n9,\n  .my-md-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-md-n9,\n  .mx-md-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-md-n9,\n  .my-md-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-md-n9,\n  .mx-md-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .m-lg--9 {\n    margin: -10rem !important;\n  }\n  .mt-lg--9,\n  .my-lg--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-lg--9,\n  .mx-lg--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-lg--9,\n  .my-lg--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-lg--9,\n  .mx-lg--9 {\n    margin-left: -10rem !important;\n  }\n  .m-lg--8 {\n    margin: -8rem !important;\n  }\n  .mt-lg--8,\n  .my-lg--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-lg--8,\n  .mx-lg--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-lg--8,\n  .my-lg--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-lg--8,\n  .mx-lg--8 {\n    margin-left: -8rem !important;\n  }\n  .m-lg--7 {\n    margin: -6rem !important;\n  }\n  .mt-lg--7,\n  .my-lg--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-lg--7,\n  .mx-lg--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-lg--7,\n  .my-lg--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-lg--7,\n  .mx-lg--7 {\n    margin-left: -6rem !important;\n  }\n  .m-lg--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-lg--6,\n  .my-lg--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-lg--6,\n  .mx-lg--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg--6,\n  .my-lg--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-lg--6,\n  .mx-lg--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-lg--5 {\n    margin: -3rem !important;\n  }\n  .mt-lg--5,\n  .my-lg--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg--5,\n  .mx-lg--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg--5,\n  .my-lg--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg--5,\n  .mx-lg--5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg--4,\n  .my-lg--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg--4,\n  .mx-lg--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg--4,\n  .my-lg--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg--4,\n  .mx-lg--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg--3 {\n    margin: -1rem !important;\n  }\n  .mt-lg--3,\n  .my-lg--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg--3,\n  .mx-lg--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg--3,\n  .my-lg--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg--3,\n  .mx-lg--3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg--2,\n  .my-lg--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg--2,\n  .mx-lg--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg--2,\n  .my-lg--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg--2,\n  .mx-lg--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg--1,\n  .my-lg--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg--1,\n  .mx-lg--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg--1,\n  .my-lg--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg--1,\n  .mx-lg--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-lg-6,\n  .my-lg-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-lg-6,\n  .mx-lg-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-lg-6,\n  .my-lg-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-lg-6,\n  .mx-lg-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-lg-7 {\n    margin: 6rem !important;\n  }\n  .mt-lg-7,\n  .my-lg-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-lg-7,\n  .mx-lg-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-lg-7,\n  .my-lg-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-lg-7,\n  .mx-lg-7 {\n    margin-left: 6rem !important;\n  }\n  .m-lg-8 {\n    margin: 8rem !important;\n  }\n  .mt-lg-8,\n  .my-lg-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-lg-8,\n  .mx-lg-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-lg-8,\n  .my-lg-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-lg-8,\n  .mx-lg-8 {\n    margin-left: 8rem !important;\n  }\n  .m-lg-9 {\n    margin: 10rem !important;\n  }\n  .mt-lg-9,\n  .my-lg-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-lg-9,\n  .mx-lg-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-lg-9,\n  .my-lg-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-lg-9,\n  .mx-lg-9 {\n    margin-left: 10rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .p-lg--9 {\n    padding: -10rem !important;\n  }\n  .pt-lg--9,\n  .py-lg--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-lg--9,\n  .px-lg--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-lg--9,\n  .py-lg--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-lg--9,\n  .px-lg--9 {\n    padding-left: -10rem !important;\n  }\n  .p-lg--8 {\n    padding: -8rem !important;\n  }\n  .pt-lg--8,\n  .py-lg--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-lg--8,\n  .px-lg--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-lg--8,\n  .py-lg--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-lg--8,\n  .px-lg--8 {\n    padding-left: -8rem !important;\n  }\n  .p-lg--7 {\n    padding: -6rem !important;\n  }\n  .pt-lg--7,\n  .py-lg--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-lg--7,\n  .px-lg--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-lg--7,\n  .py-lg--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-lg--7,\n  .px-lg--7 {\n    padding-left: -6rem !important;\n  }\n  .p-lg--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-lg--6,\n  .py-lg--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-lg--6,\n  .px-lg--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-lg--6,\n  .py-lg--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-lg--6,\n  .px-lg--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-lg--5 {\n    padding: -3rem !important;\n  }\n  .pt-lg--5,\n  .py-lg--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-lg--5,\n  .px-lg--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-lg--5,\n  .py-lg--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-lg--5,\n  .px-lg--5 {\n    padding-left: -3rem !important;\n  }\n  .p-lg--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-lg--4,\n  .py-lg--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-lg--4,\n  .px-lg--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-lg--4,\n  .py-lg--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-lg--4,\n  .px-lg--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-lg--3 {\n    padding: -1rem !important;\n  }\n  .pt-lg--3,\n  .py-lg--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-lg--3,\n  .px-lg--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-lg--3,\n  .py-lg--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-lg--3,\n  .px-lg--3 {\n    padding-left: -1rem !important;\n  }\n  .p-lg--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-lg--2,\n  .py-lg--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-lg--2,\n  .px-lg--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-lg--2,\n  .py-lg--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-lg--2,\n  .px-lg--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-lg--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-lg--1,\n  .py-lg--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-lg--1,\n  .px-lg--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-lg--1,\n  .py-lg--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-lg--1,\n  .px-lg--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-lg-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-lg-6,\n  .py-lg-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-lg-6,\n  .px-lg-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-6,\n  .py-lg-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-lg-6,\n  .px-lg-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-lg-7 {\n    padding: 6rem !important;\n  }\n  .pt-lg-7,\n  .py-lg-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-lg-7,\n  .px-lg-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-lg-7,\n  .py-lg-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-lg-7,\n  .px-lg-7 {\n    padding-left: 6rem !important;\n  }\n  .p-lg-8 {\n    padding: 8rem !important;\n  }\n  .pt-lg-8,\n  .py-lg-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-lg-8,\n  .px-lg-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-lg-8,\n  .py-lg-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-lg-8,\n  .px-lg-8 {\n    padding-left: 8rem !important;\n  }\n  .p-lg-9 {\n    padding: 10rem !important;\n  }\n  .pt-lg-9,\n  .py-lg-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-lg-9,\n  .px-lg-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-lg-9,\n  .py-lg-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-lg-9,\n  .px-lg-9 {\n    padding-left: 10rem !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-lg-n-9,\n  .my-lg-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-lg-n-9,\n  .mx-lg-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-lg-n-9,\n  .my-lg-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-lg-n-9,\n  .mx-lg-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-lg-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-lg-n-8,\n  .my-lg-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-lg-n-8,\n  .mx-lg-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-lg-n-8,\n  .my-lg-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-lg-n-8,\n  .mx-lg-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-lg-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-lg-n-7,\n  .my-lg-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-lg-n-7,\n  .mx-lg-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-lg-n-7,\n  .my-lg-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-lg-n-7,\n  .mx-lg-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-lg-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-lg-n-6,\n  .my-lg-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-lg-n-6,\n  .mx-lg-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-lg-n-6,\n  .my-lg-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-lg-n-6,\n  .mx-lg-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-lg-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-n-5,\n  .my-lg-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-n-5,\n  .mx-lg-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-n-5,\n  .my-lg-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-n-5,\n  .mx-lg-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-lg-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-n-4,\n  .my-lg-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-n-4,\n  .mx-lg-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-n-4,\n  .my-lg-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-n-4,\n  .mx-lg-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-n-3,\n  .my-lg-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-n-3,\n  .mx-lg-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-n-3,\n  .my-lg-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-n-3,\n  .mx-lg-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-n-2,\n  .my-lg-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-n-2,\n  .mx-lg-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-n-2,\n  .my-lg-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-n-2,\n  .mx-lg-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-n-1,\n  .my-lg-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-n-1,\n  .mx-lg-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-n-1,\n  .my-lg-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-n-1,\n  .mx-lg-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-lg-n6,\n  .my-lg-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-lg-n6,\n  .mx-lg-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n6,\n  .my-lg-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-lg-n6,\n  .mx-lg-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-lg-n7 {\n    margin: -6rem !important;\n  }\n  .mt-lg-n7,\n  .my-lg-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-lg-n7,\n  .mx-lg-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-lg-n7,\n  .my-lg-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-lg-n7,\n  .mx-lg-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-lg-n8 {\n    margin: -8rem !important;\n  }\n  .mt-lg-n8,\n  .my-lg-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-lg-n8,\n  .mx-lg-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-lg-n8,\n  .my-lg-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-lg-n8,\n  .mx-lg-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-lg-n9 {\n    margin: -10rem !important;\n  }\n  .mt-lg-n9,\n  .my-lg-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-lg-n9,\n  .mx-lg-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-lg-n9,\n  .my-lg-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-lg-n9,\n  .mx-lg-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .m-xl--9 {\n    margin: -10rem !important;\n  }\n  .mt-xl--9,\n  .my-xl--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-xl--9,\n  .mx-xl--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-xl--9,\n  .my-xl--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-xl--9,\n  .mx-xl--9 {\n    margin-left: -10rem !important;\n  }\n  .m-xl--8 {\n    margin: -8rem !important;\n  }\n  .mt-xl--8,\n  .my-xl--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-xl--8,\n  .mx-xl--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-xl--8,\n  .my-xl--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-xl--8,\n  .mx-xl--8 {\n    margin-left: -8rem !important;\n  }\n  .m-xl--7 {\n    margin: -6rem !important;\n  }\n  .mt-xl--7,\n  .my-xl--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-xl--7,\n  .mx-xl--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-xl--7,\n  .my-xl--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-xl--7,\n  .mx-xl--7 {\n    margin-left: -6rem !important;\n  }\n  .m-xl--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-xl--6,\n  .my-xl--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-xl--6,\n  .mx-xl--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl--6,\n  .my-xl--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-xl--6,\n  .mx-xl--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-xl--5 {\n    margin: -3rem !important;\n  }\n  .mt-xl--5,\n  .my-xl--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl--5,\n  .mx-xl--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl--5,\n  .my-xl--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl--5,\n  .mx-xl--5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl--4,\n  .my-xl--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl--4,\n  .mx-xl--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl--4,\n  .my-xl--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl--4,\n  .mx-xl--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl--3 {\n    margin: -1rem !important;\n  }\n  .mt-xl--3,\n  .my-xl--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl--3,\n  .mx-xl--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl--3,\n  .my-xl--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl--3,\n  .mx-xl--3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl--2,\n  .my-xl--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl--2,\n  .mx-xl--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl--2,\n  .my-xl--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl--2,\n  .mx-xl--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl--1,\n  .my-xl--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl--1,\n  .mx-xl--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl--1,\n  .my-xl--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl--1,\n  .mx-xl--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-xl-6,\n  .my-xl-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-xl-6,\n  .mx-xl-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-xl-6,\n  .my-xl-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-xl-6,\n  .mx-xl-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-xl-7 {\n    margin: 6rem !important;\n  }\n  .mt-xl-7,\n  .my-xl-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-xl-7,\n  .mx-xl-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-xl-7,\n  .my-xl-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-xl-7,\n  .mx-xl-7 {\n    margin-left: 6rem !important;\n  }\n  .m-xl-8 {\n    margin: 8rem !important;\n  }\n  .mt-xl-8,\n  .my-xl-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-xl-8,\n  .mx-xl-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-xl-8,\n  .my-xl-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-xl-8,\n  .mx-xl-8 {\n    margin-left: 8rem !important;\n  }\n  .m-xl-9 {\n    margin: 10rem !important;\n  }\n  .mt-xl-9,\n  .my-xl-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-xl-9,\n  .mx-xl-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-xl-9,\n  .my-xl-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-xl-9,\n  .mx-xl-9 {\n    margin-left: 10rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .p-xl--9 {\n    padding: -10rem !important;\n  }\n  .pt-xl--9,\n  .py-xl--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-xl--9,\n  .px-xl--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-xl--9,\n  .py-xl--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-xl--9,\n  .px-xl--9 {\n    padding-left: -10rem !important;\n  }\n  .p-xl--8 {\n    padding: -8rem !important;\n  }\n  .pt-xl--8,\n  .py-xl--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-xl--8,\n  .px-xl--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-xl--8,\n  .py-xl--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-xl--8,\n  .px-xl--8 {\n    padding-left: -8rem !important;\n  }\n  .p-xl--7 {\n    padding: -6rem !important;\n  }\n  .pt-xl--7,\n  .py-xl--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-xl--7,\n  .px-xl--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-xl--7,\n  .py-xl--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-xl--7,\n  .px-xl--7 {\n    padding-left: -6rem !important;\n  }\n  .p-xl--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-xl--6,\n  .py-xl--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-xl--6,\n  .px-xl--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-xl--6,\n  .py-xl--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-xl--6,\n  .px-xl--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-xl--5 {\n    padding: -3rem !important;\n  }\n  .pt-xl--5,\n  .py-xl--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-xl--5,\n  .px-xl--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-xl--5,\n  .py-xl--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-xl--5,\n  .px-xl--5 {\n    padding-left: -3rem !important;\n  }\n  .p-xl--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-xl--4,\n  .py-xl--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-xl--4,\n  .px-xl--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-xl--4,\n  .py-xl--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-xl--4,\n  .px-xl--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-xl--3 {\n    padding: -1rem !important;\n  }\n  .pt-xl--3,\n  .py-xl--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-xl--3,\n  .px-xl--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-xl--3,\n  .py-xl--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-xl--3,\n  .px-xl--3 {\n    padding-left: -1rem !important;\n  }\n  .p-xl--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-xl--2,\n  .py-xl--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-xl--2,\n  .px-xl--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-xl--2,\n  .py-xl--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-xl--2,\n  .px-xl--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-xl--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-xl--1,\n  .py-xl--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-xl--1,\n  .px-xl--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-xl--1,\n  .py-xl--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-xl--1,\n  .px-xl--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-xl-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-xl-6,\n  .py-xl-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-xl-6,\n  .px-xl-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-6,\n  .py-xl-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-xl-6,\n  .px-xl-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-xl-7 {\n    padding: 6rem !important;\n  }\n  .pt-xl-7,\n  .py-xl-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-xl-7,\n  .px-xl-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-xl-7,\n  .py-xl-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-xl-7,\n  .px-xl-7 {\n    padding-left: 6rem !important;\n  }\n  .p-xl-8 {\n    padding: 8rem !important;\n  }\n  .pt-xl-8,\n  .py-xl-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-xl-8,\n  .px-xl-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-xl-8,\n  .py-xl-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-xl-8,\n  .px-xl-8 {\n    padding-left: 8rem !important;\n  }\n  .p-xl-9 {\n    padding: 10rem !important;\n  }\n  .pt-xl-9,\n  .py-xl-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-xl-9,\n  .px-xl-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-xl-9,\n  .py-xl-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-xl-9,\n  .px-xl-9 {\n    padding-left: 10rem !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-xl-n-9,\n  .my-xl-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-xl-n-9,\n  .mx-xl-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-xl-n-9,\n  .my-xl-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-xl-n-9,\n  .mx-xl-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-xl-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-xl-n-8,\n  .my-xl-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-xl-n-8,\n  .mx-xl-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-xl-n-8,\n  .my-xl-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-xl-n-8,\n  .mx-xl-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-xl-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-xl-n-7,\n  .my-xl-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-xl-n-7,\n  .mx-xl-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-xl-n-7,\n  .my-xl-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-xl-n-7,\n  .mx-xl-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-xl-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-xl-n-6,\n  .my-xl-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-xl-n-6,\n  .mx-xl-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-xl-n-6,\n  .my-xl-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-xl-n-6,\n  .mx-xl-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-xl-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-n-5,\n  .my-xl-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-n-5,\n  .mx-xl-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-n-5,\n  .my-xl-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-n-5,\n  .mx-xl-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-xl-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-n-4,\n  .my-xl-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-n-4,\n  .mx-xl-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-n-4,\n  .my-xl-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-n-4,\n  .mx-xl-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-n-3,\n  .my-xl-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-n-3,\n  .mx-xl-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-n-3,\n  .my-xl-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-n-3,\n  .mx-xl-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-n-2,\n  .my-xl-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-n-2,\n  .mx-xl-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-n-2,\n  .my-xl-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-n-2,\n  .mx-xl-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-n-1,\n  .my-xl-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-n-1,\n  .mx-xl-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-n-1,\n  .my-xl-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-n-1,\n  .mx-xl-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-xl-n6,\n  .my-xl-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-xl-n6,\n  .mx-xl-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n6,\n  .my-xl-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-xl-n6,\n  .mx-xl-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-xl-n7 {\n    margin: -6rem !important;\n  }\n  .mt-xl-n7,\n  .my-xl-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-xl-n7,\n  .mx-xl-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-xl-n7,\n  .my-xl-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-xl-n7,\n  .mx-xl-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-xl-n8 {\n    margin: -8rem !important;\n  }\n  .mt-xl-n8,\n  .my-xl-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-xl-n8,\n  .mx-xl-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-xl-n8,\n  .my-xl-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-xl-n8,\n  .mx-xl-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-xl-n9 {\n    margin: -10rem !important;\n  }\n  .mt-xl-n9,\n  .my-xl-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-xl-n9,\n  .mx-xl-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-xl-n9,\n  .my-xl-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-xl-n9,\n  .mx-xl-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 600 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #5e72e4 !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: #233dd2 !important;\n}\n\n.text-secondary {\n  color: #f7fafc !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #bfd7e7 !important;\n}\n\n.text-success {\n  color: #2dce89 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: #1f8f5f !important;\n}\n\n.text-info {\n  color: #11cdef !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: #0b90a8 !important;\n}\n\n.text-warning {\n  color: #fb6340 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: #ea3005 !important;\n}\n\n.text-danger {\n  color: #f5365c !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: #d40b33 !important;\n}\n\n.text-light {\n  color: #adb5bd !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: #838f9b !important;\n}\n\n.text-dark {\n  color: #212529 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: black !important;\n}\n\n.text-default {\n  color: #172b4d !important;\n}\n\na.text-default:hover, a.text-default:focus {\n  color: #050a12 !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\na.text-white:hover, a.text-white:focus {\n  color: #d9d9d9 !important;\n}\n\n.text-neutral {\n  color: #fff !important;\n}\n\na.text-neutral:hover, a.text-neutral:focus {\n  color: #d9d9d9 !important;\n}\n\n.text-darker {\n  color: black !important;\n}\n\na.text-darker:hover, a.text-darker:focus {\n  color: black !important;\n}\n\n.text-body {\n  color: #525f7f !important;\n}\n\n.text-muted {\n  color: #8898aa !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .badge {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important;\n  }\n  .table-dark {\n    color: inherit;\n  }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th,\n  .table-dark tbody + tbody {\n    border-color: #e9ecef;\n  }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #e9ecef;\n  }\n}\niframe {\n  border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n  display: block;\n}\n\nmain {\n  overflow: hidden;\n}\n\n.bg-blue {\n  background-color: #5e72e4 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-blue:hover, a.bg-blue:focus,\nbutton.bg-blue:hover,\nbutton.bg-blue:focus {\n  background-color: #324cdd !important;\n}\n\n.bg-indigo {\n  background-color: #5603ad !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-indigo:hover, a.bg-indigo:focus,\nbutton.bg-indigo:hover,\nbutton.bg-indigo:focus {\n  background-color: #3d027b !important;\n}\n\n.bg-purple {\n  background-color: #8965e0 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-purple:hover, a.bg-purple:focus,\nbutton.bg-purple:hover,\nbutton.bg-purple:focus {\n  background-color: #683bd7 !important;\n}\n\n.bg-pink {\n  background-color: #f3a4b5 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-pink:hover, a.bg-pink:focus,\nbutton.bg-pink:hover,\nbutton.bg-pink:focus {\n  background-color: #ed7790 !important;\n}\n\n.bg-red {\n  background-color: #f5365c !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-red:hover, a.bg-red:focus,\nbutton.bg-red:hover,\nbutton.bg-red:focus {\n  background-color: #ec0c38 !important;\n}\n\n.bg-orange {\n  background-color: #fb6340 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-orange:hover, a.bg-orange:focus,\nbutton.bg-orange:hover,\nbutton.bg-orange:focus {\n  background-color: #fa3a0e !important;\n}\n\n.bg-yellow {\n  background-color: #ffd600 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-yellow:hover, a.bg-yellow:focus,\nbutton.bg-yellow:hover,\nbutton.bg-yellow:focus {\n  background-color: #ccab00 !important;\n}\n\n.bg-green {\n  background-color: #2dce89 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-green:hover, a.bg-green:focus,\nbutton.bg-green:hover,\nbutton.bg-green:focus {\n  background-color: #24a46d !important;\n}\n\n.bg-teal {\n  background-color: #11cdef !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-teal:hover, a.bg-teal:focus,\nbutton.bg-teal:hover,\nbutton.bg-teal:focus {\n  background-color: #0da5c0 !important;\n}\n\n.bg-cyan {\n  background-color: #2bffc6 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-cyan:hover, a.bg-cyan:focus,\nbutton.bg-cyan:hover,\nbutton.bg-cyan:focus {\n  background-color: #00f7b5 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-white:hover, a.bg-white:focus,\nbutton.bg-white:hover,\nbutton.bg-white:focus {\n  background-color: #e6e6e6 !important;\n}\n\n.bg-gray {\n  background-color: #8898aa !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-gray:hover, a.bg-gray:focus,\nbutton.bg-gray:hover,\nbutton.bg-gray:focus {\n  background-color: #6a7e95 !important;\n}\n\n.bg-gray-dark {\n  background-color: #32325d !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-gray-dark:hover, a.bg-gray-dark:focus,\nbutton.bg-gray-dark:hover,\nbutton.bg-gray-dark:focus {\n  background-color: #20203c !important;\n}\n\n.bg-light {\n  background-color: #ced4da !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #b1bbc4 !important;\n}\n\n.bg-lighter {\n  background-color: #e9ecef !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.bg-lighter:hover, a.bg-lighter:focus,\nbutton.bg-lighter:hover,\nbutton.bg-lighter:focus {\n  background-color: #cbd3da !important;\n}\n\n.bg-gradient-primary {\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\n}\n\n.bg-gradient-secondary {\n  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;\n}\n\n.bg-gradient-success {\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\n}\n\n.bg-gradient-info {\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\n}\n\n.bg-gradient-warning {\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\n}\n\n.bg-gradient-danger {\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;\n}\n\n.bg-gradient-dark {\n  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;\n}\n\n.bg-gradient-default {\n  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-neutral {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-darker {\n  background: linear-gradient(87deg, black 0, black 100%) !important;\n}\n\n.bg-gradient-blue {\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\n}\n\n.bg-gradient-indigo {\n  background: linear-gradient(87deg, #5603ad 0, #9d03ad 100%) !important;\n}\n\n.bg-gradient-purple {\n  background: linear-gradient(87deg, #8965e0 0, #bc65e0 100%) !important;\n}\n\n.bg-gradient-pink {\n  background: linear-gradient(87deg, #f3a4b5 0, #f3b4a4 100%) !important;\n}\n\n.bg-gradient-red {\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\n}\n\n.bg-gradient-orange {\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\n}\n\n.bg-gradient-yellow {\n  background: linear-gradient(87deg, #ffd600 0, #beff00 100%) !important;\n}\n\n.bg-gradient-green {\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\n}\n\n.bg-gradient-teal {\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\n}\n\n.bg-gradient-cyan {\n  background: linear-gradient(87deg, #2bffc6 0, #2be0ff 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-gray {\n  background: linear-gradient(87deg, #8898aa 0, #888aaa 100%) !important;\n}\n\n.bg-gradient-gray-dark {\n  background: linear-gradient(87deg, #32325d 0, #44325d 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #ced4da 0, #cecfda 100%) !important;\n}\n\n.bg-gradient-lighter {\n  background: linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important;\n}\n\n.bg-translucent-primary {\n  background-color: rgba(63, 87, 223, 0.6) !important;\n}\n\na.bg-translucent-primary:hover, a.bg-translucent-primary:focus,\nbutton.bg-translucent-primary:hover,\nbutton.bg-translucent-primary:focus {\n  background-color: rgba(42, 68, 219, 0.6) !important;\n}\n\n.bg-translucent-secondary {\n  background-color: rgba(221, 234, 242, 0.6) !important;\n}\n\na.bg-translucent-secondary:hover, a.bg-translucent-secondary:focus,\nbutton.bg-translucent-secondary:hover,\nbutton.bg-translucent-secondary:focus {\n  background-color: rgba(202, 222, 235, 0.6) !important;\n}\n\n.bg-translucent-success {\n  background-color: rgba(39, 177, 118, 0.6) !important;\n}\n\na.bg-translucent-success:hover, a.bg-translucent-success:focus,\nbutton.bg-translucent-success:hover,\nbutton.bg-translucent-success:focus {\n  background-color: rgba(34, 156, 104, 0.6) !important;\n}\n\n.bg-translucent-info {\n  background-color: rgba(14, 177, 206, 0.6) !important;\n}\n\na.bg-translucent-info:hover, a.bg-translucent-info:focus,\nbutton.bg-translucent-info:hover,\nbutton.bg-translucent-info:focus {\n  background-color: rgba(12, 156, 183, 0.6) !important;\n}\n\n.bg-translucent-warning {\n  background-color: rgba(250, 70, 29, 0.6) !important;\n}\n\na.bg-translucent-warning:hover, a.bg-translucent-warning:focus,\nbutton.bg-translucent-warning:hover,\nbutton.bg-translucent-warning:focus {\n  background-color: rgba(249, 51, 5, 0.6) !important;\n}\n\n.bg-translucent-danger {\n  background-color: rgba(243, 20, 64, 0.6) !important;\n}\n\na.bg-translucent-danger:hover, a.bg-translucent-danger:focus,\nbutton.bg-translucent-danger:hover,\nbutton.bg-translucent-danger:focus {\n  background-color: rgba(227, 11, 54, 0.6) !important;\n}\n\n.bg-translucent-light {\n  background-color: rgba(153, 163, 173, 0.6) !important;\n}\n\na.bg-translucent-light:hover, a.bg-translucent-light:focus,\nbutton.bg-translucent-light:hover,\nbutton.bg-translucent-light:focus {\n  background-color: rgba(139, 150, 162, 0.6) !important;\n}\n\n.bg-translucent-dark {\n  background-color: rgba(17, 19, 21, 0.6) !important;\n}\n\na.bg-translucent-dark:hover, a.bg-translucent-dark:focus,\nbutton.bg-translucent-dark:hover,\nbutton.bg-translucent-dark:focus {\n  background-color: rgba(6, 6, 7, 0.6) !important;\n}\n\n.bg-translucent-default {\n  background-color: rgba(15, 28, 50, 0.6) !important;\n}\n\na.bg-translucent-default:hover, a.bg-translucent-default:focus,\nbutton.bg-translucent-default:hover,\nbutton.bg-translucent-default:focus {\n  background-color: rgba(9, 17, 30, 0.6) !important;\n}\n\n.bg-translucent-white {\n  background-color: rgba(237, 237, 237, 0.6) !important;\n}\n\na.bg-translucent-white:hover, a.bg-translucent-white:focus,\nbutton.bg-translucent-white:hover,\nbutton.bg-translucent-white:focus {\n  background-color: rgba(224, 224, 224, 0.6) !important;\n}\n\n.bg-translucent-neutral {\n  background-color: rgba(237, 237, 237, 0.6) !important;\n}\n\na.bg-translucent-neutral:hover, a.bg-translucent-neutral:focus,\nbutton.bg-translucent-neutral:hover,\nbutton.bg-translucent-neutral:focus {\n  background-color: rgba(224, 224, 224, 0.6) !important;\n}\n\n.bg-translucent-darker {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n}\n\na.bg-translucent-darker:hover, a.bg-translucent-darker:focus,\nbutton.bg-translucent-darker:hover,\nbutton.bg-translucent-darker:focus {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n}\n\n.section-primary {\n  background-color: #f8f9fe !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.section-primary:hover, a.section-primary:focus,\nbutton.section-primary:hover,\nbutton.section-primary:focus {\n  background-color: #cbd3f8 !important;\n}\n\n.section-secondary {\n  background-color: #f7fafc !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.section-secondary:hover, a.section-secondary:focus,\nbutton.section-secondary:hover,\nbutton.section-secondary:focus {\n  background-color: #d2e3ee !important;\n}\n\n.section-light {\n  background-color: #ced4da !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.section-light:hover, a.section-light:focus,\nbutton.section-light:hover,\nbutton.section-light:focus {\n  background-color: #b1bbc4 !important;\n}\n\n.section-dark {\n  background-color: #212529 !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.section-dark:hover, a.section-dark:focus,\nbutton.section-dark:hover,\nbutton.section-dark:focus {\n  background-color: #0a0c0d !important;\n}\n\n.section-darker {\n  background-color: black !important;\n  background-image: url(../../../../img/brand/background-oillusion.png);\n}\n\na.section-darker:hover, a.section-darker:focus,\nbutton.section-darker:hover,\nbutton.section-darker:focus {\n  background-color: black !important;\n}\n\n.bg-gradient-primary {\n  background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%) !important;\n}\n\n.bg-gradient-secondary {\n  background: linear-gradient(87deg, #f7fafc 0, #f7f8fc 100%) !important;\n}\n\n.bg-gradient-success {\n  background: linear-gradient(87deg, #2dce89 0, #2dcecc 100%) !important;\n}\n\n.bg-gradient-info {\n  background: linear-gradient(87deg, #11cdef 0, #1171ef 100%) !important;\n}\n\n.bg-gradient-warning {\n  background: linear-gradient(87deg, #fb6340 0, #fbb140 100%) !important;\n}\n\n.bg-gradient-danger {\n  background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #adb5bd 0, #adaebd 100%) !important;\n}\n\n.bg-gradient-dark {\n  background: linear-gradient(87deg, #212529 0, #212229 100%) !important;\n}\n\n.bg-gradient-default {\n  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-neutral {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-darker {\n  background: linear-gradient(87deg, black 0, black 100%) !important;\n}\n\n.fill-primary {\n  fill: #5e72e4;\n}\n\n.stroke-primary {\n  stroke: #5e72e4;\n}\n\n.fill-secondary {\n  fill: #f7fafc;\n}\n\n.stroke-secondary {\n  stroke: #f7fafc;\n}\n\n.fill-success {\n  fill: #2dce89;\n}\n\n.stroke-success {\n  stroke: #2dce89;\n}\n\n.fill-info {\n  fill: #11cdef;\n}\n\n.stroke-info {\n  stroke: #11cdef;\n}\n\n.fill-warning {\n  fill: #fb6340;\n}\n\n.stroke-warning {\n  stroke: #fb6340;\n}\n\n.fill-danger {\n  fill: #f5365c;\n}\n\n.stroke-danger {\n  stroke: #f5365c;\n}\n\n.fill-light {\n  fill: #adb5bd;\n}\n\n.stroke-light {\n  stroke: #adb5bd;\n}\n\n.fill-dark {\n  fill: #212529;\n}\n\n.stroke-dark {\n  stroke: #212529;\n}\n\n.fill-default {\n  fill: #172b4d;\n}\n\n.stroke-default {\n  stroke: #172b4d;\n}\n\n.fill-white {\n  fill: #fff;\n}\n\n.stroke-white {\n  stroke: #fff;\n}\n\n.fill-neutral {\n  fill: #fff;\n}\n\n.stroke-neutral {\n  stroke: #fff;\n}\n\n.fill-darker {\n  fill: black;\n}\n\n.stroke-darker {\n  stroke: black;\n}\n\n.fill-opacity-8 {\n  fill-opacity: 0.8;\n}\n\n.floating {\n  animation: floating 3s ease infinite;\n  will-change: transform;\n}\n.floating:hover {\n  animation-play-state: paused;\n}\n\n.floating-lg {\n  animation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n  animation: floating-sm 3s ease infinite;\n}\n\n@keyframes floating-lg {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(15px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes floating {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes floating-sm {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(5px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.floatfix:before, .floatfix:after {\n  content: \"\";\n  display: table;\n}\n.floatfix:after {\n  clear: both;\n}\n\n.img-center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-8 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.top-1 {\n  top: 0.25rem;\n}\n\n.right-1 {\n  right: 0.25rem;\n}\n\n.bottom-1 {\n  bottom: 0.25rem;\n}\n\n.left-1 {\n  left: 0.25rem;\n}\n\n.top-2 {\n  top: 0.5rem;\n}\n\n.right-2 {\n  right: 0.5rem;\n}\n\n.bottom-2 {\n  bottom: 0.5rem;\n}\n\n.left-2 {\n  left: 0.5rem;\n}\n\n.top-3 {\n  top: 1rem;\n}\n\n.right-3 {\n  right: 1rem;\n}\n\n.bottom-3 {\n  bottom: 1rem;\n}\n\n.left-3 {\n  left: 1rem;\n}\n\n.top-4 {\n  top: 1.5rem;\n}\n\n.right-4 {\n  right: 1.5rem;\n}\n\n.bottom-4 {\n  bottom: 1.5rem;\n}\n\n.left-4 {\n  left: 1.5rem;\n}\n\n.top-5 {\n  top: 3rem;\n}\n\n.right-5 {\n  right: 3rem;\n}\n\n.bottom-5 {\n  bottom: 3rem;\n}\n\n.left-5 {\n  left: 3rem;\n}\n\n.top--9 {\n  top: -10rem;\n}\n\n.right--9 {\n  right: -10rem;\n}\n\n.bottom--9 {\n  bottom: -10rem;\n}\n\n.left--9 {\n  left: -10rem;\n}\n\n.top--8 {\n  top: -8rem;\n}\n\n.right--8 {\n  right: -8rem;\n}\n\n.bottom--8 {\n  bottom: -8rem;\n}\n\n.left--8 {\n  left: -8rem;\n}\n\n.top--7 {\n  top: -6rem;\n}\n\n.right--7 {\n  right: -6rem;\n}\n\n.bottom--7 {\n  bottom: -6rem;\n}\n\n.left--7 {\n  left: -6rem;\n}\n\n.top--6 {\n  top: -4.5rem;\n}\n\n.right--6 {\n  right: -4.5rem;\n}\n\n.bottom--6 {\n  bottom: -4.5rem;\n}\n\n.left--6 {\n  left: -4.5rem;\n}\n\n.top--5 {\n  top: -3rem;\n}\n\n.right--5 {\n  right: -3rem;\n}\n\n.bottom--5 {\n  bottom: -3rem;\n}\n\n.left--5 {\n  left: -3rem;\n}\n\n.top--4 {\n  top: -1.5rem;\n}\n\n.right--4 {\n  right: -1.5rem;\n}\n\n.bottom--4 {\n  bottom: -1.5rem;\n}\n\n.left--4 {\n  left: -1.5rem;\n}\n\n.top--3 {\n  top: -1rem;\n}\n\n.right--3 {\n  right: -1rem;\n}\n\n.bottom--3 {\n  bottom: -1rem;\n}\n\n.left--3 {\n  left: -1rem;\n}\n\n.top--2 {\n  top: -0.5rem;\n}\n\n.right--2 {\n  right: -0.5rem;\n}\n\n.bottom--2 {\n  bottom: -0.5rem;\n}\n\n.left--2 {\n  left: -0.5rem;\n}\n\n.top--1 {\n  top: -0.25rem;\n}\n\n.right--1 {\n  right: -0.25rem;\n}\n\n.bottom--1 {\n  bottom: -0.25rem;\n}\n\n.left--1 {\n  left: -0.25rem;\n}\n\n.top-6 {\n  top: 4.5rem;\n}\n\n.right-6 {\n  right: 4.5rem;\n}\n\n.bottom-6 {\n  bottom: 4.5rem;\n}\n\n.left-6 {\n  left: 4.5rem;\n}\n\n.top-7 {\n  top: 6rem;\n}\n\n.right-7 {\n  right: 6rem;\n}\n\n.bottom-7 {\n  bottom: 6rem;\n}\n\n.left-7 {\n  left: 6rem;\n}\n\n.top-8 {\n  top: 8rem;\n}\n\n.right-8 {\n  right: 8rem;\n}\n\n.bottom-8 {\n  bottom: 8rem;\n}\n\n.left-8 {\n  left: 8rem;\n}\n\n.top-9 {\n  top: 10rem;\n}\n\n.right-9 {\n  right: 10rem;\n}\n\n.bottom-9 {\n  bottom: 10rem;\n}\n\n.left-9 {\n  left: 10rem;\n}\n\n.center {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.h-100vh {\n  height: 100vh !important;\n}\n\n.row.row-grid > [class*=col-] + [class*=col-] {\n  margin-top: 3rem;\n}\n\n@media (min-width: 992px) {\n  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {\n    margin-top: 0;\n  }\n}\n@media (min-width: 768px) {\n  .row.row-grid > [class*=col-md-] + [class*=col-md-] {\n    margin-top: 0;\n  }\n}\n@media (min-width: 576px) {\n  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {\n    margin-top: 0;\n  }\n}\n.row-grid + .row-grid {\n  margin-top: 3rem;\n}\n\n@media (min-width: 992px) {\n  .mt--100 {\n    margin-top: -100px !important;\n  }\n  .mr--100 {\n    margin-right: -100px !important;\n  }\n  .mb--100 {\n    margin-bottom: -100px !important;\n  }\n  .ml--100 {\n    margin-left: -100px !important;\n  }\n  .mt--150 {\n    margin-top: -150px !important;\n  }\n  .mb--150 {\n    margin-bottom: -150px !important;\n  }\n  .mt--200 {\n    margin-top: -200px !important;\n  }\n  .mb--200 {\n    margin-bottom: -200px !important;\n  }\n  .mt--300 {\n    margin-top: -300px !important;\n  }\n  .mb--300 {\n    margin-bottom: -300px !important;\n  }\n  .pt-100 {\n    padding-top: 100px !important;\n  }\n  .pb-100 {\n    padding-bottom: 100px !important;\n  }\n  .pt-150 {\n    padding-top: 150px !important;\n  }\n  .pb-150 {\n    padding-bottom: 150px !important;\n  }\n  .pt-200 {\n    padding-top: 200px !important;\n  }\n  .pb-200 {\n    padding-bottom: 200px !important;\n  }\n  .pt-250 {\n    padding-top: 250px !important;\n  }\n  .pb-250 {\n    padding-bottom: 250px !important;\n  }\n  .pt-300 {\n    padding-top: 300px !important;\n  }\n  .pb-300 {\n    padding-bottom: 300px !important;\n  }\n}\n[class*=shadow] {\n  transition: all 0.15s ease;\n}\n\n.shadow-sm--hover:hover {\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\n}\n\n.shadow--hover:hover {\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n}\n\n.shadow-lg--hover:hover {\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\n}\n\n.shadow-none--hover:hover {\n  box-shadow: none !important;\n}\n\n.font-weight-300 {\n  font-weight: 300 !important;\n}\n\n.font-weight-400 {\n  font-weight: 400 !important;\n}\n\n.font-weight-500 {\n  font-weight: 500 !important;\n}\n\n.font-weight-600 {\n  font-weight: 600 !important;\n}\n\n.font-weight-700 {\n  font-weight: 700 !important;\n}\n\n.font-weight-800 {\n  font-weight: 800 !important;\n}\n\n.font-weight-900 {\n  font-weight: 900 !important;\n}\n\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-through {\n  text-decoration: line-through;\n}\n\n.text-xs {\n  font-size: 0.75rem !important;\n}\n\n.text-sm {\n  font-size: 0.875rem !important;\n}\n\n.text-lg {\n  font-size: 1.25rem !important;\n}\n\n.text-xl {\n  font-size: 1.5rem !important;\n}\n\n.lh-100 {\n  line-height: 1;\n}\n\n.lh-110 {\n  line-height: 1.1;\n}\n\n.lh-120 {\n  line-height: 1.2;\n}\n\n.lh-130 {\n  line-height: 1.3;\n}\n\n.lh-140 {\n  line-height: 1.4;\n}\n\n.lh-150 {\n  line-height: 1.5;\n}\n\n.lh-160 {\n  line-height: 1.6;\n}\n\n.lh-170 {\n  line-height: 1.7;\n}\n\n.lh-180 {\n  line-height: 1.8;\n}\n\n.ls-1 {\n  letter-spacing: 0.0625rem;\n}\n\n.ls-15 {\n  letter-spacing: 0.09375rem;\n}\n\n.ls-2 {\n  letter-spacing: 0.125rem;\n}\n\n.text-blue {\n  color: #5e72e4 !important;\n}\n\na.text-blue:hover, a.text-blue:focus {\n  color: #233dd2 !important;\n}\n\n.text-indigo {\n  color: #5603ad !important;\n}\n\na.text-indigo:hover, a.text-indigo:focus {\n  color: #310262 !important;\n}\n\n.text-purple {\n  color: #8965e0 !important;\n}\n\na.text-purple:hover, a.text-purple:focus {\n  color: #5a2acf !important;\n}\n\n.text-pink {\n  color: #f3a4b5 !important;\n}\n\na.text-pink:hover, a.text-pink:focus {\n  color: #ea607e !important;\n}\n\n.text-red {\n  color: #f5365c !important;\n}\n\na.text-red:hover, a.text-red:focus {\n  color: #d40b33 !important;\n}\n\n.text-orange {\n  color: #fb6340 !important;\n}\n\na.text-orange:hover, a.text-orange:focus {\n  color: #ea3005 !important;\n}\n\n.text-yellow {\n  color: #ffd600 !important;\n}\n\na.text-yellow:hover, a.text-yellow:focus {\n  color: #b39600 !important;\n}\n\n.text-green {\n  color: #2dce89 !important;\n}\n\na.text-green:hover, a.text-green:focus {\n  color: #1f8f5f !important;\n}\n\n.text-teal {\n  color: #11cdef !important;\n}\n\na.text-teal:hover, a.text-teal:focus {\n  color: #0b90a8 !important;\n}\n\n.text-cyan {\n  color: #2bffc6 !important;\n}\n\na.text-cyan:hover, a.text-cyan:focus {\n  color: #00dea2 !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\na.text-white:hover, a.text-white:focus {\n  color: #d9d9d9 !important;\n}\n\n.text-gray {\n  color: #8898aa !important;\n}\n\na.text-gray:hover, a.text-gray:focus {\n  color: #607286 !important;\n}\n\n.text-gray-dark {\n  color: #32325d !important;\n}\n\na.text-gray-dark:hover, a.text-gray-dark:focus {\n  color: #17172b !important;\n}\n\n.text-light {\n  color: #ced4da !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: #a2aeb9 !important;\n}\n\n.text-lighter {\n  color: #e9ecef !important;\n}\n\na.text-lighter:hover, a.text-lighter:focus {\n  color: #bdc6cf !important;\n}\n\n@media (min-width: 992px) {\n  .transform-perspective-right {\n    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\n  }\n  .transform-perspective-left {\n    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);\n  }\n}\n.alert {\n  font-size: 0.875rem;\n}\n\n.alert-heading {\n  font-weight: 600;\n  font-size: 0.9375rem;\n  margin-top: 0.15rem;\n}\n\n.alert-icon {\n  font-size: 1.25rem;\n  margin-right: 1.25rem;\n  display: inline-block;\n  vertical-align: middle;\n}\n.alert-icon i.ni {\n  position: relative;\n  top: 1px;\n}\n\n.alert-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n[class*=alert-] .alert-link {\n  color: #fff;\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);\n}\n\n.alert-dismissible .close {\n  top: 50%;\n  right: 1.5rem;\n  padding: 0;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.6);\n  opacity: 1;\n}\n.alert-dismissible .close:hover, .alert-dismissible .close:focus {\n  color: rgba(255, 255, 255, 0.9);\n  opacity: 1 !important;\n}\n@media (max-width: 575.98px) {\n  .alert-dismissible .close {\n    top: 1rem;\n    right: 0.5rem;\n  }\n}\n.alert-dismissible .close > span:not(.sr-only) {\n  font-size: 1.5rem;\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.6);\n}\n.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.avatar {\n  color: #fff;\n  background-color: #adb5bd;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n}\n.avatar img {\n  width: 100%;\n  border-radius: 50%;\n}\n.avatar + .avatar-content {\n  display: inline-block;\n  margin-left: 0.75rem;\n}\n\n.avatar-lg {\n  width: 58px;\n  height: 58px;\n  font-size: 0.875rem;\n}\n\n.avatar-sm {\n  width: 36px;\n  height: 36px;\n  font-size: 0.875rem;\n}\n\n.avatar-group .avatar {\n  position: relative;\n  z-index: 2;\n  border: 2px solid #fff;\n}\n.avatar-group .avatar:hover {\n  z-index: 3;\n}\n.avatar-group .avatar + .avatar {\n  margin-left: -1rem;\n}\n\n.badge {\n  text-transform: uppercase;\n}\n.badge a {\n  color: #fff;\n}\n\n.badge-md {\n  padding: 0.65em 1em;\n}\n\n.badge-lg {\n  padding: 0.85em 1.375em;\n}\n\n.badge-inline {\n  margin-right: 0.625rem;\n}\n.badge-inline + span {\n  top: 2px;\n  position: relative;\n}\n.badge-inline + span > a {\n  text-decoration: underline;\n}\n\n.btn .badge:not(:first-child) {\n  margin-left: 0.5rem;\n}\n.btn .badge:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.badge-circle {\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n}\n\n.badge-dot {\n  padding-left: 0;\n  padding-right: 0;\n  background: transparent;\n  font-weight: 400;\n  font-size: 0.875rem;\n  text-transform: none;\n}\n.badge-dot strong {\n  color: #32325d;\n}\n.badge-dot i {\n  display: inline-block;\n  vertical-align: middle;\n  width: 0.375rem;\n  height: 0.375rem;\n  border-radius: 50%;\n  margin-right: 0.375rem;\n}\n.badge-dot.badge-md i {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n.badge-dot.badge-lg i {\n  width: 0.625rem;\n  height: 0.625rem;\n}\n\n.btn {\n  position: relative;\n  text-transform: none;\n  transition: all 0.15s ease;\n  letter-spacing: 0.025em;\n  font-size: 0.875rem;\n  will-change: transform;\n}\n.btn:hover {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n.btn:not(:last-child) {\n  margin-right: 0.5rem;\n}\n.btn i:not(:first-child),\n.btn svg:not(:first-child) {\n  margin-left: 0.5rem;\n}\n.btn i:not(:last-child),\n.btn svg:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.btn-group .btn,\n.input-group .btn {\n  margin-right: 0;\n  transform: translateY(0);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  font-size: 0.75rem;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  font-size: 0.875rem;\n}\n\n[class*=btn-outline-] {\n  border-width: 1px;\n}\n\n.btn-outline-secondary {\n  color: #4385b1;\n}\n\n.btn-inner--icon i:not(.fa) {\n  position: relative;\n  top: 2px;\n}\n\n.btn-link {\n  font-weight: 600;\n  box-shadow: none;\n}\n.btn-link:hover {\n  box-shadow: none;\n  transform: none;\n}\n\n.btn-neutral {\n  color: #5e72e4;\n}\n\n.btn-icon .btn-inner--icon img {\n  width: 20px;\n}\n.btn-icon .btn-inner--text:not(:first-child) {\n  margin-left: 0.75em;\n}\n.btn-icon .btn-inner--text:not(:last-child) {\n  margin-right: 0.75em;\n}\n\n.btn-icon-only {\n  width: 2.375rem;\n  height: 2.375rem;\n  padding: 0;\n}\n\na.btn-icon-only {\n  line-height: 2.5;\n}\n\n.btn-icon-only.btn-sm, .btn-group-sm > .btn-icon-only.btn {\n  width: 2rem;\n  height: 2rem;\n}\n\n.btn-icon-clipboard {\n  margin: 0;\n  padding: 1.5rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #32325d;\n  background-color: #f6f9fc;\n  border-radius: 0.375rem;\n  border: 0;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n}\n.btn-icon-clipboard:hover {\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;\n}\n.btn-icon-clipboard > div {\n  align-items: center;\n  display: flex;\n}\n.btn-icon-clipboard i {\n  box-sizing: content-box;\n  color: #5e72e4;\n  vertical-align: middle;\n  font-size: 1.5rem;\n}\n.btn-icon-clipboard span {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  margin-left: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n.btn-facebook {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-facebook:hover {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n}\n.btn-facebook:focus, .btn-facebook.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 89, 153, 0.5);\n}\n.btn-facebook.disabled, .btn-facebook:disabled {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n}\n.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {\n  color: #fff;\n  background-color: #2d4474;\n  border-color: #3b5999;\n}\n.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);\n}\n\n.btn-twitter {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-twitter:hover {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n}\n.btn-twitter:focus, .btn-twitter.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 161, 242, 0.5);\n}\n.btn-twitter.disabled, .btn-twitter:disabled {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n}\n.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {\n  color: #fff;\n  background-color: #0c85d0;\n  border-color: #1da1f2;\n}\n.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);\n}\n\n.btn-google-plus {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-google-plus:hover {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n}\n.btn-google-plus:focus, .btn-google-plus.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(221, 75, 57, 0.5);\n}\n.btn-google-plus.disabled, .btn-google-plus:disabled {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n}\n.btn-google-plus:not(:disabled):not(.disabled):active, .btn-google-plus:not(:disabled):not(.disabled).active, .show > .btn-google-plus.dropdown-toggle {\n  color: #fff;\n  background-color: #c23321;\n  border-color: #dd4b39;\n}\n.btn-google-plus:not(:disabled):not(.disabled):active:focus, .btn-google-plus:not(:disabled):not(.disabled).active:focus, .show > .btn-google-plus.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);\n}\n\n.btn-instagram {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-instagram:hover {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n}\n.btn-instagram:focus, .btn-instagram.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(228, 64, 95, 0.5);\n}\n.btn-instagram.disabled, .btn-instagram:disabled {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n}\n.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {\n  color: #fff;\n  background-color: #d31e40;\n  border-color: #e4405f;\n}\n.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);\n}\n\n.btn-pinterest {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-pinterest:hover {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n}\n.btn-pinterest:focus, .btn-pinterest.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(189, 8, 28, 0.5);\n}\n.btn-pinterest.disabled, .btn-pinterest:disabled {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {\n  color: #fff;\n  background-color: #8c0615;\n  border-color: #bd081c;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);\n}\n\n.btn-youtube {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-youtube:hover {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n}\n.btn-youtube:focus, .btn-youtube.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(205, 32, 31, 0.5);\n}\n.btn-youtube.disabled, .btn-youtube:disabled {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n}\n.btn-youtube:not(:disabled):not(.disabled):active, .btn-youtube:not(:disabled):not(.disabled).active, .show > .btn-youtube.dropdown-toggle {\n  color: #fff;\n  background-color: #a11918;\n  border-color: #cd201f;\n}\n.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn-youtube:not(:disabled):not(.disabled).active:focus, .show > .btn-youtube.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);\n}\n\n.btn-slack {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-slack:hover {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n}\n.btn-slack:focus, .btn-slack.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 175, 133, 0.5);\n}\n.btn-slack.disabled, .btn-slack:disabled {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n}\n.btn-slack:not(:disabled):not(.disabled):active, .btn-slack:not(:disabled):not(.disabled).active, .show > .btn-slack.dropdown-toggle {\n  color: #fff;\n  background-color: #2d8968;\n  border-color: #3aaf85;\n}\n.btn-slack:not(:disabled):not(.disabled):active:focus, .btn-slack:not(:disabled):not(.disabled).active:focus, .show > .btn-slack.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);\n}\n\n.btn-dribbble {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-dribbble:hover {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n}\n.btn-dribbble:focus, .btn-dribbble.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(234, 76, 137, 0.5);\n}\n.btn-dribbble.disabled, .btn-dribbble:disabled {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n}\n.btn-dribbble:not(:disabled):not(.disabled):active, .btn-dribbble:not(:disabled):not(.disabled).active, .show > .btn-dribbble.dropdown-toggle {\n  color: #fff;\n  background-color: #e51e6b;\n  border-color: #ea4c89;\n}\n.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn-dribbble:not(:disabled):not(.disabled).active:focus, .show > .btn-dribbble.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);\n}\n\n.btn-github {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-github:hover {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n}\n.btn-github:focus, .btn-github.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(34, 34, 34, 0.5);\n}\n.btn-github.disabled, .btn-github:disabled {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n}\n.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {\n  color: #fff;\n  background-color: #090909;\n  border-color: #222222;\n}\n.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);\n}\n\n.card-translucent {\n  background-color: rgba(18, 91, 152, 0.08);\n}\n\n.card-profile-image {\n  position: relative;\n}\n.card-profile-image img {\n  max-width: 180px;\n  border-radius: 0.375rem;\n  transform: translate(-50%, -30%);\n  position: absolute;\n  left: 50%;\n  transition: all 0.15s ease;\n}\n.card-profile-image img:hover {\n  transform: translate(-50%, -33%);\n}\n\n.card-profile-stats {\n  padding: 1rem 0;\n}\n.card-profile-stats > div {\n  text-align: center;\n  margin-right: 1rem;\n  padding: 0.875rem;\n}\n.card-profile-stats > div:last-child {\n  margin-right: 0;\n}\n.card-profile-stats > div .heading {\n  font-size: 1.1rem;\n  font-weight: bold;\n  display: block;\n}\n.card-profile-stats > div .description {\n  font-size: 0.875rem;\n  color: #adb5bd;\n}\n\n.card-profile-actions {\n  padding: 0.875rem;\n}\n\n.card-lift--hover:hover {\n  transform: translateY(-20px);\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .card-lift--hover:hover {\n    transition: none;\n  }\n}\n\n.card-stats .card-body {\n  padding: 1rem 1.5rem;\n}\n.card-stats .card-status-bullet {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n}\n\n.chart {\n  position: relative;\n  height: 350px;\n}\n\n.chart-sm {\n  height: 230px;\n}\n\n.chart-legend {\n  display: flex;\n  justify-content: center;\n  margin-top: 2.5rem;\n  font-size: 0.875rem;\n  text-align: center;\n  color: #8898aa;\n}\n\n.chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n}\n.chart-legend-item + .chart-legend-item {\n  margin-left: 1rem;\n}\n\n.chart-legend-indicator {\n  display: inline-block;\n  width: 0.5rem;\n  height: 0.5rem;\n  margin-right: 0.375rem;\n  border-radius: 50%;\n}\n\n#chart-tooltip {\n  z-index: 0;\n}\n#chart-tooltip .arrow {\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateX(-0.5rem);\n}\n\n.chart-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  max-width: 350px;\n  padding: 20px;\n  z-index: 1;\n}\n\n.close {\n  transition: all 0.15s ease;\n}\n.close > span:not(.sr-only) {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 17px;\n  height: 1.25rem;\n  width: 1.25rem;\n  border-radius: 50%;\n  font-size: 1.25rem;\n  display: block;\n  transition: all 0.15s ease;\n}\n.close:hover, .close:focus {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.9);\n  outline: none;\n}\n.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {\n  background-color: transparent;\n}\n\n.main-content {\n  position: relative;\n}\n.main-content .navbar-top {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  background-color: transparent;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n@media (min-width: 768px) {\n  .main-content .container-fluid, .main-content .container-sm, .main-content .container-md, .main-content .container-lg, .main-content .container-xl {\n    padding-left: 39px !important;\n    padding-right: 39px !important;\n  }\n}\n\n.navbar-vertical.navbar-expand-xs.fixed-left + .main-content {\n  margin-left: 250px;\n}\n.navbar-vertical.navbar-expand-xs.fixed-right + .main-content {\n  margin-right: 250px;\n}\n@media (min-width: 576px) {\n  .navbar-vertical.navbar-expand-sm.fixed-left + .main-content {\n    margin-left: 250px;\n  }\n  .navbar-vertical.navbar-expand-sm.fixed-right + .main-content {\n    margin-right: 250px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-vertical.navbar-expand-md.fixed-left + .main-content {\n    margin-left: 250px;\n  }\n  .navbar-vertical.navbar-expand-md.fixed-right + .main-content {\n    margin-right: 250px;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-vertical.navbar-expand-lg.fixed-left + .main-content {\n    margin-left: 250px;\n  }\n  .navbar-vertical.navbar-expand-lg.fixed-right + .main-content {\n    margin-right: 250px;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-vertical.navbar-expand-xl.fixed-left + .main-content {\n    margin-left: 250px;\n  }\n  .navbar-vertical.navbar-expand-xl.fixed-right + .main-content {\n    margin-right: 250px;\n  }\n}\n\n.custom-checkbox .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #5e72e4;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\n}\n.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-checkbox .custom-control-input:disabled:checked::before {\n  border-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-control-label::before {\n  border: 1px solid #cad1d7;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.custom-control-label span {\n  position: relative;\n  top: 2px;\n}\n\n.custom-control-label {\n  margin-bottom: 0;\n}\n\n.custom-control-alternative .custom-control-label::before {\n  border: 0;\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n}\n.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n}\n\n.custom-checkbox .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #5e72e4;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\n}\n.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-checkbox .custom-control-input:disabled:checked::before {\n  border-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-radio .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #5e72e4;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#fff'/></svg>\");\n}\n.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-radio .custom-control-input:disabled:checked::before {\n  border-color: rgba(94, 114, 228, 0.5);\n}\n\n.custom-toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 1.5rem;\n}\n.custom-toggle input {\n  display: none;\n}\n.custom-toggle input:checked + .custom-toggle-slider {\n  border: 1px solid #5e72e4;\n}\n.custom-toggle input:checked + .custom-toggle-slider:before {\n  background: #5e72e4;\n  transform: translateX(1.625rem);\n}\n.custom-toggle input:disabled + .custom-toggle-slider {\n  border: 1px solid #e9ecef;\n}\n.custom-toggle input:disabled:checked + .custom-toggle-slider {\n  border: 1px solid #e9ecef;\n}\n.custom-toggle input:disabled:checked + .custom-toggle-slider:before {\n  background-color: #8a98eb;\n}\n\n.custom-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1px solid #cad1d7;\n  border-radius: 34px !important;\n  background-color: transparent;\n}\n.custom-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  border-radius: 50% !important;\n  background-color: #e9ecef;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n  display: inline-block;\n}\n\n.dropdown-menu {\n  min-width: 12rem;\n}\n.dropdown-menu .dropdown-item {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n.dropdown-menu .dropdown-item > i,\n.dropdown-menu .dropdown-item > svg {\n  margin-right: 1rem;\n  font-size: 1rem;\n  vertical-align: -17%;\n}\n\n.dropdown-header {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  color: #f6f9fc;\n  font-size: 0.625rem;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.dropdown-menu a.media > div:first-child {\n  line-height: 1;\n}\n.dropdown-menu a.media p {\n  color: #8898aa;\n}\n.dropdown-menu a.media:hover .heading,\n.dropdown-menu a.media:hover p {\n  color: #172b4d !important;\n}\n\n.dropdown-menu-sm {\n  min-width: 100px;\n  border: 0.4375rem;\n}\n\n.dropdown-menu-lg {\n  min-width: 260px;\n  border-radius: 0.4375rem;\n}\n\n.dropdown-menu-xl {\n  min-width: 450px;\n  border-radius: 0.4375rem;\n}\n\n.footer {\n  background: #f7fafc;\n  padding: 2.5rem 0;\n}\n.footer .col-footer .heading {\n  color: #8898aa;\n  letter-spacing: 0;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.footer .nav .nav-item .nav-link,\n.footer .footer-link {\n  color: #8898aa !important;\n}\n.footer .nav .nav-item .nav-link:hover,\n.footer .footer-link:hover {\n  color: #525f7f !important;\n}\n.footer .list-unstyled li a {\n  display: inline-block;\n  padding: 0.125rem 0;\n  color: #8898aa;\n  font-size: 0.85rem;\n}\n.footer .list-unstyled li a:hover {\n  color: #525f7f;\n}\n.footer .copyright {\n  font-size: 0.875rem;\n}\n\n.footer-dark .col-footer .heading {\n  color: #fff;\n}\n\n.nav-footer .nav-link {\n  font-size: 0.875rem;\n}\n.nav-footer .nav-item:last-child .nav-link {\n  padding-right: 0;\n}\n\n.footer.has-cards {\n  overflow: hidden;\n  padding-top: 500px;\n  margin-top: -420px;\n  position: relative;\n  background: transparent;\n  pointer-events: none;\n}\n.footer.has-cards:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 600px;\n  height: 2000px;\n  background: #f7fafc;\n  transform: skew(0, -8deg);\n}\n.footer.has-cards .container {\n  pointer-events: auto;\n  position: relative;\n}\n\n.form-control-label {\n  color: #525f7f;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.form-control {\n  font-size: 0.875rem;\n}\n.form-control:focus::placeholder {\n  color: #adb5bd;\n}\n\ntextarea[resize=none] {\n  resize: none !important;\n}\n\ntextarea[resize=both] {\n  resize: both !important;\n}\n\ntextarea[resize=vertical] {\n  resize: vertical !important;\n}\n\ntextarea[resize=horizontal] {\n  resize: horizontal !important;\n}\n\n.form-control-muted {\n  background-color: #F7FAFE;\n  border-color: #F7FAFE;\n  box-shadow: none;\n}\n.form-control-muted:focus {\n  background-color: #fcfdff;\n}\n\n.form-control-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.form-control-alternative:focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.form-control-lg {\n  font-size: 1rem;\n}\n\n.has-success,\n.has-danger {\n  position: relative;\n}\n.has-success:after,\n.has-danger:after {\n  width: 19px;\n  height: 19px;\n  line-height: 19px;\n  text-align: center;\n  font-family: \"NucleoIcons\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n  top: 2px;\n  transform: translateY(50%);\n  border-radius: 50%;\n  font-size: 9px;\n  opacity: 1;\n}\n\n.has-success:after {\n  content: \"\\ea26\";\n  color: daken(#2dce89, 18%);\n  background-color: #69deac;\n}\n.has-success .form-control {\n  background-color: #fff;\n}\n.has-success .form-control:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.has-success .form-control::placeholder {\n  color: #2dce89;\n}\n\n.has-danger:after {\n  content: \"\\ea53\";\n  color: daken(#fb6340, 18%);\n  background-color: #fda08b;\n}\n.has-danger .form-control {\n  background-color: #fff;\n}\n.has-danger .form-control:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.has-danger .form-control::placeholder {\n  color: #fb6340;\n}\n\n.input-group {\n  box-shadow: none;\n  border-radius: 0.375rem;\n  transition: all 0.15s ease;\n}\n.input-group .form-control {\n  box-shadow: none;\n}\n.input-group .form-control:not(:first-child) {\n  border-left: 0;\n  padding-left: 0;\n}\n.input-group .form-control:not(:last-child) {\n  border-right: 0;\n  padding-right: 0;\n}\n.input-group .form-control:focus {\n  box-shadow: none;\n}\n\n.input-group-text {\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.input-group-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.input-group-alternative .form-control,\n.input-group-alternative .input-group-text {\n  border: 0;\n  box-shadow: none;\n}\n\n.focused .input-group-alternative {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.focused .input-group {\n  box-shadow: none;\n}\n.focused .input-group-text {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.focused .form-control {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n\n.header {\n  position: relative;\n}\n\n.icon {\n  width: 3rem;\n  height: 3rem;\n}\n.icon i, .icon svg {\n  font-size: 2.25rem;\n}\n.icon + .icon-text {\n  padding-left: 1rem;\n  width: calc(100% - 3rem - 1);\n}\n\n.icon-xl {\n  width: 5rem;\n  height: 5rem;\n}\n.icon-xl i, .icon-xl svg {\n  font-size: 4.25rem;\n}\n.icon-xl + .icon-text {\n  width: calc(100% - 5rem - 1);\n}\n\n.icon-lg {\n  width: 4rem;\n  height: 4rem;\n}\n.icon-lg i, .icon-lg svg {\n  font-size: 3.25rem;\n}\n.icon-lg + .icon-text {\n  width: calc(100% - 4rem - 1);\n}\n\n.icon-sm {\n  width: 2rem;\n  height: 2rem;\n}\n.icon-sm i, .icon-sm svg {\n  font-size: 1.25rem;\n}\n.icon-sm + .icon-text {\n  width: calc(100% - 2rem - 1);\n}\n\n.icon-shape {\n  padding: 12px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n.icon-shape i, .icon-shape svg {\n  font-size: 1.25rem;\n}\n.icon-shape.icon-lg i, .icon-shape.icon-lg svg {\n  font-size: 1.625rem;\n}\n.icon-shape.icon-sm i, .icon-shape.icon-sm svg {\n  font-size: 0.875rem;\n}\n.icon-shape svg {\n  width: 30px;\n  height: 30px;\n}\n\n.icon-shape-primary {\n  color: #2643e9;\n  background-color: rgba(138, 152, 235, 0.5);\n}\n\n.icon-shape-secondary {\n  color: #cfe3f1;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-success {\n  color: #1aae6f;\n  background-color: rgba(84, 218, 161, 0.5);\n}\n\n.icon-shape-info {\n  color: #03acca;\n  background-color: rgba(65, 215, 242, 0.5);\n}\n\n.icon-shape-warning {\n  color: #ff3709;\n  background-color: rgba(252, 140, 114, 0.5);\n}\n\n.icon-shape-danger {\n  color: #f80031;\n  background-color: rgba(247, 103, 131, 0.5);\n}\n\n.icon-shape-light {\n  color: #879cb0;\n  background-color: rgba(201, 207, 212, 0.5);\n}\n\n.icon-shape-dark {\n  color: #090c0e;\n  background-color: rgba(56, 63, 69, 0.5);\n}\n\n.icon-shape-default {\n  color: #091428;\n  background-color: rgba(35, 65, 116, 0.5);\n}\n\n.icon-shape-white {\n  color: #e8e3e3;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-neutral {\n  color: #e8e3e3;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-darker {\n  color: black;\n  background-color: rgba(23, 26, 28, 0.5);\n}\n\n.input-group {\n  box-shadow: none;\n  border-radius: 0.375rem;\n  transition: all 0.15s ease;\n}\n.input-group .form-control {\n  box-shadow: none;\n}\n.input-group .form-control:not(:first-child) {\n  border-left: 0;\n  padding-left: 0;\n}\n.input-group .form-control:not(:last-child) {\n  border-right: 0;\n  padding-right: 0;\n}\n.input-group .form-control:focus {\n  box-shadow: none;\n}\n\n.input-group-text {\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.input-group-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.input-group-alternative .form-control,\n.input-group-alternative .input-group-text {\n  border: 0;\n  box-shadow: none;\n}\n\n.focused .input-group-alternative {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.focused .input-group {\n  box-shadow: none;\n}\n.focused .input-group-text {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.focused .form-control {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n\n.list-group-space .list-group-item {\n  margin-bottom: 1.5rem;\n  border-radius: 0.375rem;\n}\n\n.list-group-img {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  vertical-align: top;\n  margin: -0.1rem 1.2rem 0 -0.2rem;\n}\n\n.list-group-content {\n  flex: 1;\n  min-width: 0;\n}\n.list-group-content > p {\n  color: #adb5bd;\n  line-height: 1.5;\n  margin: 0.2rem 0 0;\n}\n\n.list-group-heading {\n  font-size: 1rem;\n  color: #32325d;\n}\n.list-group-heading > small {\n  float: right;\n  color: #adb5bd;\n  font-weight: 500;\n}\n\n.map-canvas {\n  position: relative;\n  width: 100%;\n  height: 500px;\n  border-radius: 0.375rem;\n}\n\n.mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .mask {\n    transition: none;\n  }\n}\n\n.modal-fluid .modal-dialog {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.modal-fluid .modal-content {\n  border-radius: 0;\n}\n\n.modal-primary .modal-title {\n  color: #fff;\n}\n.modal-primary .modal-header,\n.modal-primary .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-primary .modal-content {\n  background-color: #5e72e4;\n  color: #fff;\n}\n.modal-primary .modal-content .heading {\n  color: #fff;\n}\n.modal-primary .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-secondary .modal-title {\n  color: #212529;\n}\n.modal-secondary .modal-header,\n.modal-secondary .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-secondary .modal-content {\n  background-color: #f7fafc;\n  color: #212529;\n}\n.modal-secondary .modal-content .heading {\n  color: #212529;\n}\n.modal-secondary .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-success .modal-title {\n  color: #fff;\n}\n.modal-success .modal-header,\n.modal-success .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-success .modal-content {\n  background-color: #2dce89;\n  color: #fff;\n}\n.modal-success .modal-content .heading {\n  color: #fff;\n}\n.modal-success .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-info .modal-title {\n  color: #fff;\n}\n.modal-info .modal-header,\n.modal-info .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-info .modal-content {\n  background-color: #11cdef;\n  color: #fff;\n}\n.modal-info .modal-content .heading {\n  color: #fff;\n}\n.modal-info .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-warning .modal-title {\n  color: #fff;\n}\n.modal-warning .modal-header,\n.modal-warning .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-warning .modal-content {\n  background-color: #fb6340;\n  color: #fff;\n}\n.modal-warning .modal-content .heading {\n  color: #fff;\n}\n.modal-warning .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-danger .modal-title {\n  color: #fff;\n}\n.modal-danger .modal-header,\n.modal-danger .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-danger .modal-content {\n  background-color: #f5365c;\n  color: #fff;\n}\n.modal-danger .modal-content .heading {\n  color: #fff;\n}\n.modal-danger .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-light .modal-title {\n  color: #fff;\n}\n.modal-light .modal-header,\n.modal-light .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-light .modal-content {\n  background-color: #adb5bd;\n  color: #fff;\n}\n.modal-light .modal-content .heading {\n  color: #fff;\n}\n.modal-light .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-dark .modal-title {\n  color: #fff;\n}\n.modal-dark .modal-header,\n.modal-dark .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-dark .modal-content {\n  background-color: #212529;\n  color: #fff;\n}\n.modal-dark .modal-content .heading {\n  color: #fff;\n}\n.modal-dark .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-default .modal-title {\n  color: #fff;\n}\n.modal-default .modal-header,\n.modal-default .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-default .modal-content {\n  background-color: #172b4d;\n  color: #fff;\n}\n.modal-default .modal-content .heading {\n  color: #fff;\n}\n.modal-default .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-white .modal-title {\n  color: #212529;\n}\n.modal-white .modal-header,\n.modal-white .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-white .modal-content {\n  background-color: #fff;\n  color: #212529;\n}\n.modal-white .modal-content .heading {\n  color: #212529;\n}\n.modal-white .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-neutral .modal-title {\n  color: #212529;\n}\n.modal-neutral .modal-header,\n.modal-neutral .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-neutral .modal-content {\n  background-color: #fff;\n  color: #212529;\n}\n.modal-neutral .modal-content .heading {\n  color: #212529;\n}\n.modal-neutral .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-darker .modal-title {\n  color: #fff;\n}\n.modal-darker .modal-header,\n.modal-darker .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-darker .modal-content {\n  background-color: black;\n  color: #fff;\n}\n.modal-darker .modal-content .heading {\n  color: #fff;\n}\n.modal-darker .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.nav-wrapper {\n  padding: 1rem 0;\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n.nav-wrapper + .card {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n\n.nav-link {\n  color: #525f7f;\n}\n.nav-link:hover {\n  color: #5e72e4;\n}\n.nav-link i.ni {\n  position: relative;\n  top: 2px;\n}\n\n@media (min-width: 992px) {\n  .nav-item.active-pro {\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n    background: #f6f9fc;\n  }\n}\n.nav-pills .nav-item:not(:last-child) {\n  padding-right: 1rem;\n}\n.nav-pills .nav-link {\n  padding: 0.75rem 1rem;\n  color: #5e72e4;\n  font-weight: 500;\n  font-size: 0.875rem;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  background-color: #fff;\n  transition: all 0.15s ease;\n}\n.nav-pills .nav-link:hover {\n  color: #485fe0;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #5e72e4;\n}\n@media (max-width: 575.98px) {\n  .nav-pills .nav-item {\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .nav-pills:not(.nav-pills-circle) .nav-item {\n    padding-right: 0;\n  }\n}\n.nav-pills-circle .nav-link {\n  text-align: center;\n  height: 60px;\n  width: 60px;\n  padding: 0;\n  line-height: 60px;\n  border-radius: 50%;\n}\n.nav-pills-circle .nav-link-icon i, .nav-pills-circle .nav-link-icon svg {\n  font-size: 1rem;\n}\n\n.navbar-horizontal .navbar-nav .nav-link {\n  font-size: 0.9rem;\n  font-weight: 400;\n  text-transform: normal;\n  letter-spacing: 0;\n  transition: all 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-horizontal .navbar-nav .nav-link {\n    transition: none;\n  }\n}\n.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {\n  margin-left: 0.25rem;\n}\n.navbar-horizontal .navbar-brand {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.875rem;\n  letter-spacing: 0.05px;\n}\n.navbar-horizontal .navbar-brand img {\n  height: 30px;\n}\n.navbar-horizontal .navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-horizontal .navbar-light .navbar-brand {\n  color: #32325d;\n}\n.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n@media (min-width: 992px) {\n  .navbar-horizontal .navbar-nav .nav-item {\n    margin-right: 0.5rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-item [data-toggle=dropdown]::after {\n    transition: all 0.15s ease;\n  }\n  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=dropdown]::after {\n    transform: rotate(180deg);\n  }\n  .navbar-horizontal .navbar-nav .nav-link {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    border-radius: 0.375rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link i {\n    margin-right: 0.625rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link-icon {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n    font-size: 1rem;\n    border-radius: 0.375rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link-icon i {\n    margin-right: 0;\n  }\n}\n.navbar-horizontal .navbar-transparent {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n}\n.navbar-horizontal .navbar-transparent .navbar-brand {\n  color: rgb(255, 255, 255);\n}\n.navbar-horizontal .navbar-transparent .navbar-toggler {\n  color: rgb(255, 255, 255);\n}\n.navbar-horizontal .navbar-transparent .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 0.95)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n}\n@media (min-width: 768px) {\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, 0.95);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:hover, .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .show > .nav-link,\n  .navbar-horizontal .navbar-transparent .navbar-nav .active > .nav-link,\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.show,\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.active {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-brand {\n    color: rgba(255, 255, 255, 0.95);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-brand:hover, .navbar-horizontal .navbar-transparent .navbar-brand:focus {\n    color: rgba(255, 255, 255, 0.95);\n  }\n}\n\n.navbar-vertical {\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n}\n.navbar-vertical .navbar {\n  border-width: 0 0 1px 0;\n  border-style: solid;\n}\n.navbar-vertical .navbar-light {\n  background-color: transparent;\n  border-color: #f6f9fc;\n}\n.navbar-vertical .navbar-brand {\n  margin-right: 0;\n}\n.navbar-vertical .navbar-brand-img,\n.navbar-vertical .navbar-brand > img {\n  max-width: 100%;\n  max-height: 20rem;\n}\n@media (min-width: 768px) {\n  .navbar-vertical .navbar-collapse {\n    margin-left: -1rem;\n    margin-right: -1rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n.navbar-vertical .navbar-nav {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.navbar-vertical .navbar-nav .nav-link {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-size: 0.9rem;\n}\n.navbar-vertical .navbar-nav .nav-link.active {\n  position: relative;\n}\n.navbar-vertical .navbar-nav .nav-link.active:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.25rem;\n  bottom: 0.25rem;\n  border-left: 2px solid #5e72e4;\n}\n.navbar-vertical .navbar-nav .nav-link > i {\n  min-width: 2.25rem;\n  font-size: 0.9375rem;\n  line-height: 1.5rem;\n}\n.navbar-vertical .navbar-nav .nav-link .dropdown-menu {\n  border: none;\n}\n.navbar-vertical .navbar-nav .nav-link .dropdown-menu .dropdown-menu {\n  margin-left: 0.75rem;\n}\n.navbar-vertical .navbar-nav .nav-link {\n  display: flex;\n  align-items: center;\n}\n.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse]:after {\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 700;\n  content: \"\\f105\";\n  margin-left: auto;\n  color: #8898aa;\n  transition: all 0.15s ease;\n}\n.navbar-vertical .navbar-nav .nav-link[data-toggle=collapse][aria-expanded=true]:after {\n  transform: rotate(90deg);\n}\n.navbar-vertical .navbar-nav .nav .nav-link {\n  padding-left: 3.25rem;\n}\n.navbar-vertical .navbar-nav .nav .nav .nav-link {\n  padding-left: 3.75rem;\n}\n.navbar-vertical .navbar-heading {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.navbar-vertical.navbar-expand-xs {\n  display: block;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  max-width: 250px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  overflow-y: auto;\n}\n.navbar-vertical.navbar-expand-xs > [class*=container] {\n  flex-direction: column;\n  align-items: stretch;\n  min-height: 100%;\n  padding-left: 0;\n  padding-right: 0;\n}\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .navbar-vertical.navbar-expand-xs > [class*=container] {\n    min-height: none;\n    height: 100%;\n  }\n}\n.navbar-vertical.navbar-expand-xs.fixed-left {\n  left: 0;\n  border-width: 0 1px 0 0;\n}\n.navbar-vertical.navbar-expand-xs.fixed-right {\n  right: 0;\n  border-width: 0 0 0 1px;\n}\n.navbar-vertical.navbar-expand-xs .navbar-collapse {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-collapse > * {\n  min-width: 100%;\n}\n.navbar-vertical.navbar-expand-xs .navbar-nav {\n  flex-direction: column;\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {\n  padding: 0.65rem 1.5rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link.active:before {\n  top: 0.25rem;\n  bottom: 0.25rem;\n  left: 0;\n  right: auto;\n  border-left: 2px solid #5e72e4;\n  border-bottom: 0;\n}\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav-link {\n  padding-left: 3.75rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-nav .nav .nav .nav-link {\n  padding-left: 4.5rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-brand {\n  display: block;\n  text-align: center;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-brand-img {\n  max-height: 40rem;\n}\n.navbar-vertical.navbar-expand-xs .navbar-user {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  padding-top: 1rem;\n  padding-bottom: 0rem;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  border-top: 1px solid #e9ecef;\n}\n.navbar-vertical.navbar-expand-xs .navbar-user .dropup .dropdown-menu {\n  left: 50%;\n  transform: translateX(-50%);\n}\n@media (min-width: 576px) {\n  .navbar-vertical.navbar-expand-sm {\n    display: block;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 250px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    overflow-y: auto;\n  }\n  .navbar-vertical.navbar-expand-sm > [class*=container] {\n    flex-direction: column;\n    align-items: stretch;\n    min-height: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 576px) and (-ms-high-contrast: none), (min-width: 576px) and (-ms-high-contrast: active) {\n  .navbar-vertical.navbar-expand-sm > [class*=container] {\n    min-height: none;\n    height: 100%;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-vertical.navbar-expand-sm.fixed-left {\n    left: 0;\n    border-width: 0 1px 0 0;\n  }\n  .navbar-vertical.navbar-expand-sm.fixed-right {\n    right: 0;\n    border-width: 0 0 0 1px;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-collapse {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-collapse > * {\n    min-width: 100%;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-nav {\n    flex-direction: column;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link {\n    padding: 0.65rem 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav-link.active:before {\n    top: 0.25rem;\n    bottom: 0.25rem;\n    left: 0;\n    right: auto;\n    border-left: 2px solid #5e72e4;\n    border-bottom: 0;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav-link {\n    padding-left: 3.75rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-nav .nav .nav .nav-link {\n    padding-left: 4.5rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-brand {\n    display: block;\n    text-align: center;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-brand-img {\n    max-height: 40rem;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-user {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-top: 1rem;\n    padding-bottom: 0rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    border-top: 1px solid #e9ecef;\n  }\n  .navbar-vertical.navbar-expand-sm .navbar-user .dropup .dropdown-menu {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n@media (min-width: 768px) {\n  .navbar-vertical.navbar-expand-md {\n    display: block;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 250px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    overflow-y: auto;\n  }\n  .navbar-vertical.navbar-expand-md > [class*=container] {\n    flex-direction: column;\n    align-items: stretch;\n    min-height: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 768px) and (-ms-high-contrast: none), (min-width: 768px) and (-ms-high-contrast: active) {\n  .navbar-vertical.navbar-expand-md > [class*=container] {\n    min-height: none;\n    height: 100%;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-vertical.navbar-expand-md.fixed-left {\n    left: 0;\n    border-width: 0 1px 0 0;\n  }\n  .navbar-vertical.navbar-expand-md.fixed-right {\n    right: 0;\n    border-width: 0 0 0 1px;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-collapse {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-collapse > * {\n    min-width: 100%;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-nav {\n    flex-direction: column;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link {\n    padding: 0.65rem 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav-link.active:before {\n    top: 0.25rem;\n    bottom: 0.25rem;\n    left: 0;\n    right: auto;\n    border-left: 2px solid #5e72e4;\n    border-bottom: 0;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav-link {\n    padding-left: 3.75rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-nav .nav .nav .nav-link {\n    padding-left: 4.5rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-brand {\n    display: block;\n    text-align: center;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-brand-img {\n    max-height: 40rem;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-user {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-top: 1rem;\n    padding-bottom: 0rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    border-top: 1px solid #e9ecef;\n  }\n  .navbar-vertical.navbar-expand-md .navbar-user .dropup .dropdown-menu {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n@media (min-width: 992px) {\n  .navbar-vertical.navbar-expand-lg {\n    display: block;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 250px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    overflow-y: auto;\n  }\n  .navbar-vertical.navbar-expand-lg > [class*=container] {\n    flex-direction: column;\n    align-items: stretch;\n    min-height: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 992px) and (-ms-high-contrast: none), (min-width: 992px) and (-ms-high-contrast: active) {\n  .navbar-vertical.navbar-expand-lg > [class*=container] {\n    min-height: none;\n    height: 100%;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-vertical.navbar-expand-lg.fixed-left {\n    left: 0;\n    border-width: 0 1px 0 0;\n  }\n  .navbar-vertical.navbar-expand-lg.fixed-right {\n    right: 0;\n    border-width: 0 0 0 1px;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-collapse {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-collapse > * {\n    min-width: 100%;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-nav {\n    flex-direction: column;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link {\n    padding: 0.65rem 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav-link.active:before {\n    top: 0.25rem;\n    bottom: 0.25rem;\n    left: 0;\n    right: auto;\n    border-left: 2px solid #5e72e4;\n    border-bottom: 0;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav-link {\n    padding-left: 3.75rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-nav .nav .nav .nav-link {\n    padding-left: 4.5rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-brand {\n    display: block;\n    text-align: center;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-brand-img {\n    max-height: 40rem;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-user {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-top: 1rem;\n    padding-bottom: 0rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    border-top: 1px solid #e9ecef;\n  }\n  .navbar-vertical.navbar-expand-lg .navbar-user .dropup .dropdown-menu {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-vertical.navbar-expand-xl {\n    display: block;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 250px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    overflow-y: auto;\n  }\n  .navbar-vertical.navbar-expand-xl > [class*=container] {\n    flex-direction: column;\n    align-items: stretch;\n    min-height: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 1200px) and (-ms-high-contrast: none), (min-width: 1200px) and (-ms-high-contrast: active) {\n  .navbar-vertical.navbar-expand-xl > [class*=container] {\n    min-height: none;\n    height: 100%;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-vertical.navbar-expand-xl.fixed-left {\n    left: 0;\n    border-width: 0 1px 0 0;\n  }\n  .navbar-vertical.navbar-expand-xl.fixed-right {\n    right: 0;\n    border-width: 0 0 0 1px;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-collapse {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-collapse > * {\n    min-width: 100%;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-nav {\n    flex-direction: column;\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link {\n    padding: 0.65rem 1.5rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav-link.active:before {\n    top: 0.25rem;\n    bottom: 0.25rem;\n    left: 0;\n    right: auto;\n    border-left: 2px solid #5e72e4;\n    border-bottom: 0;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav-link {\n    padding-left: 3.75rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-nav .nav .nav .nav-link {\n    padding-left: 4.5rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-brand {\n    display: block;\n    text-align: center;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-brand-img {\n    max-height: 40rem;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-user {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n    padding-top: 1rem;\n    padding-bottom: 0rem;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    border-top: 1px solid #e9ecef;\n  }\n  .navbar-vertical.navbar-expand-xl .navbar-user .dropup .dropdown-menu {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n.search-container {\n  position: relative;\n}\n.search-container input {\n  width: 200px;\n  padding-right: 40px;\n  padding-left: 15px;\n}\n.search-container .search_btn {\n  position: absolute;\n  padding: 5px;\n  background-color: transparent;\n  box-shadow: none;\n  border: 0;\n  right: 10px;\n  top: 5px;\n}\n\n.navbar-search .input-group {\n  border-radius: 2rem;\n  border: 2px solid;\n  background-color: transparent;\n}\n.navbar-search .input-group .input-group-text {\n  background-color: transparent;\n  padding-left: 1rem;\n}\n.navbar-search .form-control {\n  width: 270px;\n  background-color: transparent;\n}\n\n.navbar-search-dark .input-group {\n  border-color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .input-group-text {\n  color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .form-control {\n  color: rgba(255, 255, 255, 0.9);\n}\n.navbar-search-dark .form-control::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .focused .input-group {\n  border-color: rgba(255, 255, 255, 0.9);\n}\n\n.navbar-search-light .input-group {\n  border-color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .input-group-text {\n  color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .form-control {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-search-light .form-control::placeholder {\n  color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .focused .input-group {\n  border-color: rgba(0, 0, 0, 0.9);\n}\n\n@media (min-width: 768px) {\n  .navbar .dropdown-menu {\n    opacity: 0;\n    pointer-events: none;\n    margin: 0;\n  }\n  .navbar .dropdown-menu-arrow:before {\n    background: #fff;\n    box-shadow: none;\n    content: \"\";\n    display: block;\n    height: 12px;\n    width: 12px;\n    left: 20px;\n    position: absolute;\n    bottom: 100%;\n    transform: rotate(-45deg) translateY(12px);\n    z-index: -5;\n    border-radius: 2px;\n  }\n  .navbar .dropdown-menu-right:before {\n    right: 20px;\n    left: auto;\n  }\n  .navbar:not(.navbar-nav-hover) .dropdown-menu.show {\n    opacity: 1;\n    pointer-events: auto;\n    animation: show-navbar-dropdown 0.25s ease forwards;\n  }\n  .navbar:not(.navbar-nav-hover) .dropdown-menu.close {\n    display: block;\n    animation: hide-navbar-dropdown 0.15s ease backwards;\n  }\n  .navbar.navbar-nav-hover .dropdown-menu {\n    opacity: 0;\n    display: block;\n    pointer-events: none;\n    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n  }\n  .navbar.navbar-nav-hover .nav-item.dropdown:hover > .dropdown-menu {\n    display: block;\n    opacity: 1;\n    pointer-events: auto;\n    visibility: visible;\n    transform: translate(0, 0);\n    animation: none;\n  }\n  .navbar .dropdown-menu-inner {\n    position: relative;\n    padding: 1rem;\n  }\n  @keyframes show-navbar-dropdown {\n    0% {\n      opacity: 0;\n      transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n      transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n    }\n    100% {\n      transform: translate(0, 0);\n      opacity: 1;\n    }\n  }\n  @keyframes hide-navbar-dropdown {\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0;\n      transform: translate(0, 10px);\n    }\n  }\n}\n.navbar-collapse-header {\n  display: none;\n}\n\n@media (max-width: 767.98px) {\n  .navbar-nav .nav-link {\n    padding: 0.625rem 0;\n    color: #172b4d !important;\n  }\n  .navbar-nav .dropdown-menu {\n    box-shadow: none;\n    min-width: auto;\n  }\n  .navbar-nav .dropdown-menu .media svg {\n    width: 30px;\n  }\n  .navbar-collapse {\n    width: calc(100% - 1.4rem);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1050;\n    margin: 0.7rem;\n    overflow-y: auto;\n    height: auto !important;\n    opacity: 0;\n  }\n  .navbar-collapse .navbar-toggler {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    padding: 0;\n  }\n  .navbar-collapse .navbar-toggler span {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    border-radius: 2px;\n    opacity: 1;\n    background: #283448;\n  }\n  .navbar-collapse .navbar-toggler :nth-child(1) {\n    transform: rotate(135deg);\n  }\n  .navbar-collapse .navbar-toggler :nth-child(2) {\n    transform: rotate(-135deg);\n  }\n  .navbar-collapse .navbar-collapse-header {\n    display: block;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  }\n  .navbar-collapse .collapse-brand img {\n    height: 36px;\n  }\n  .navbar-collapse .collapse-close {\n    text-align: right;\n  }\n  .navbar-collapse.collapsing,\n  .navbar-collapse.show {\n    padding: 1.5rem;\n    border-radius: 0.375rem;\n    background: #FFF;\n    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n    animation: show-navbar-collapse 0.2s ease forwards;\n  }\n  .navbar-collapse.collapsing-out {\n    animation: hide-navbar-collapse 0.2s ease forwards;\n  }\n}\n@keyframes show-navbar-collapse {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n    transform-origin: 100% 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes hide-navbar-collapse {\n  from {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 100% 0;\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n.page-item.active .page-link {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n.page-item .page-link,\n.page-item span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0 3px;\n  border-radius: 50% !important;\n  width: 36px;\n  height: 36px;\n  font-size: 0.875rem;\n}\n\n.pagination-lg .page-item .page-link,\n.pagination-lg .page-item span {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n\n.pagination-sm .page-item .page-link,\n.pagination-sm .page-item span {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n\n.popover {\n  border: 0;\n}\n\n.popover-header {\n  font-weight: 600;\n}\n\n.popover-primary {\n  background-color: #5e72e4;\n}\n.popover-primary .popover-header {\n  background-color: #5e72e4;\n  color: #fff;\n}\n.popover-primary .popover-body {\n  color: #fff;\n}\n.popover-primary .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #5e72e4;\n}\n.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #5e72e4;\n}\n.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #5e72e4;\n}\n.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #5e72e4;\n}\n\n.popover-secondary {\n  background-color: #f7fafc;\n}\n.popover-secondary .popover-header {\n  background-color: #f7fafc;\n  color: #212529;\n}\n.popover-secondary .popover-body {\n  color: #212529;\n}\n.popover-secondary .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #f7fafc;\n}\n.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #f7fafc;\n}\n.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #f7fafc;\n}\n.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #f7fafc;\n}\n\n.popover-success {\n  background-color: #2dce89;\n}\n.popover-success .popover-header {\n  background-color: #2dce89;\n  color: #fff;\n}\n.popover-success .popover-body {\n  color: #fff;\n}\n.popover-success .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #2dce89;\n}\n.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #2dce89;\n}\n.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #2dce89;\n}\n.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #2dce89;\n}\n\n.popover-info {\n  background-color: #11cdef;\n}\n.popover-info .popover-header {\n  background-color: #11cdef;\n  color: #fff;\n}\n.popover-info .popover-body {\n  color: #fff;\n}\n.popover-info .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #11cdef;\n}\n.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #11cdef;\n}\n.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #11cdef;\n}\n.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #11cdef;\n}\n\n.popover-warning {\n  background-color: #fb6340;\n}\n.popover-warning .popover-header {\n  background-color: #fb6340;\n  color: #fff;\n}\n.popover-warning .popover-body {\n  color: #fff;\n}\n.popover-warning .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fb6340;\n}\n.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fb6340;\n}\n.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fb6340;\n}\n.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fb6340;\n}\n\n.popover-danger {\n  background-color: #f5365c;\n}\n.popover-danger .popover-header {\n  background-color: #f5365c;\n  color: #fff;\n}\n.popover-danger .popover-body {\n  color: #fff;\n}\n.popover-danger .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #f5365c;\n}\n.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #f5365c;\n}\n.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #f5365c;\n}\n.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #f5365c;\n}\n\n.popover-light {\n  background-color: #adb5bd;\n}\n.popover-light .popover-header {\n  background-color: #adb5bd;\n  color: #fff;\n}\n.popover-light .popover-body {\n  color: #fff;\n}\n.popover-light .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #adb5bd;\n}\n.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #adb5bd;\n}\n.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #adb5bd;\n}\n.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #adb5bd;\n}\n\n.popover-dark {\n  background-color: #212529;\n}\n.popover-dark .popover-header {\n  background-color: #212529;\n  color: #fff;\n}\n.popover-dark .popover-body {\n  color: #fff;\n}\n.popover-dark .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #212529;\n}\n.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #212529;\n}\n.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #212529;\n}\n.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #212529;\n}\n\n.popover-default {\n  background-color: #172b4d;\n}\n.popover-default .popover-header {\n  background-color: #172b4d;\n  color: #fff;\n}\n.popover-default .popover-body {\n  color: #fff;\n}\n.popover-default .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #172b4d;\n}\n.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #172b4d;\n}\n.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #172b4d;\n}\n.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #172b4d;\n}\n\n.popover-white {\n  background-color: #fff;\n}\n.popover-white .popover-header {\n  background-color: #fff;\n  color: #212529;\n}\n.popover-white .popover-body {\n  color: #212529;\n}\n.popover-white .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fff;\n}\n.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fff;\n}\n.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fff;\n}\n.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fff;\n}\n\n.popover-neutral {\n  background-color: #fff;\n}\n.popover-neutral .popover-header {\n  background-color: #fff;\n  color: #212529;\n}\n.popover-neutral .popover-body {\n  color: #212529;\n}\n.popover-neutral .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fff;\n}\n.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fff;\n}\n.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fff;\n}\n.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fff;\n}\n\n.popover-darker {\n  background-color: black;\n}\n.popover-darker .popover-header {\n  background-color: black;\n  color: #fff;\n}\n.popover-darker .popover-body {\n  color: #fff;\n}\n.popover-darker .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: black;\n}\n.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: black;\n}\n.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: black;\n}\n.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: black;\n}\n\n.progress-wrapper {\n  position: relative;\n  padding-top: 1.5rem;\n}\n\n.progress {\n  height: 8px;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  border-radius: 0.25rem;\n  background-color: #e9ecef;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.progress .sr-only {\n  width: auto;\n  height: 20px;\n  margin: 0 0 0 30px;\n  left: 0;\n  clip: auto;\n  line-height: 20px;\n  font-size: 13px;\n}\n\n.progress-heading {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 2px;\n  padding: 0;\n}\n\n.progress-bar {\n  box-shadow: none;\n  border-radius: 0;\n  height: auto;\n}\n\n.progress-info {\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.progress-label span {\n  display: inline-block;\n  color: #5e72e4;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: rgba(94, 114, 228, 0.1);\n  padding: 0.25rem 1rem;\n  border-radius: 30px;\n}\n\n.progress-percentage {\n  text-align: right;\n}\n.progress-percentage span {\n  display: inline-block;\n  color: #8898aa;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.separator {\n  position: absolute;\n  top: auto;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 150px;\n  transform: translateZ(0);\n  overflow: hidden;\n  pointer-events: none;\n}\n.separator svg {\n  position: absolute;\n  pointer-events: none;\n}\n\n.separator-top {\n  top: 0;\n  bottom: auto;\n}\n.separator-top svg {\n  top: 0;\n}\n\n.separator-bottom {\n  top: auto;\n  bottom: 0;\n}\n.separator-bottom svg {\n  bottom: 0;\n}\n\n.separator-inverse {\n  transform: rotate(180deg);\n}\n\n.separator-skew {\n  height: 60px;\n}\n@media (min-width: 1200px) {\n  .separator-skew {\n    height: 70px;\n  }\n}\n\n.table thead th {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-bottom: 1px solid #e9ecef;\n}\n.table th {\n  font-weight: 600;\n}\n.table td .progress {\n  height: 3px;\n  width: 120px;\n  margin: 0;\n}\n.table td,\n.table th {\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n.table.align-items-center td,\n.table.align-items-center th {\n  vertical-align: middle;\n}\n.table .thead-dark th {\n  background-color: #1c345d;\n  color: #4d7bca;\n}\n.table .thead-light th {\n  background-color: #f6f9fc;\n  color: #8898aa;\n}\n\n.table-hover tr {\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .table-hover tr {\n    transition: none;\n  }\n}\n\n.table-flush td,\n.table-flush th {\n  border-left: 0;\n  border-right: 0;\n}\n.table-flush tbody tr:first-child td,\n.table-flush tbody tr:first-child th {\n  border-top: 0;\n}\n.table-flush tbody tr:last-child td,\n.table-flush tbody tr:last-child th {\n  border-bottom: 0;\n}\n\n.card .table {\n  margin-bottom: 0;\n}\n.card .table td,\n.card .table th {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  white-space: break-spaces;\n}\n\np {\n  font-size: 1rem;\n  font-weight: 300;\n  line-height: 1.7;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n  line-height: 1.7;\n  margin-top: 1.5rem;\n}\n.lead + .btn-wrapper {\n  margin-top: 3rem;\n}\n\n.description {\n  font-size: 0.875rem;\n}\n\n.heading {\n  letter-spacing: 0.025em;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.heading-small {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.heading-title {\n  letter-spacing: 0.025em;\n  font-size: 1.375rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.heading-section {\n  letter-spacing: 0.025em;\n  font-size: 1.375rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.heading-section img {\n  display: block;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 1.5rem;\n}\n.heading-section.text-center img {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.display-1 span,\n.display-2 span,\n.display-3 span,\n.display-4 span {\n  display: block;\n  font-weight: 300;\n}\n\narticle h4:not(:first-child),\narticle h5:not(:first-child) {\n  margin-top: 3rem;\n}\narticle h4, article h5 {\n  margin-bottom: 1.5rem;\n}\narticle figure {\n  margin: 3rem 0;\n}\narticle h5 + figure {\n  margin-top: 0;\n}\n\n.datepicker {\n  border-radius: 0.375rem;\n  direction: ltr;\n}\n.datepicker-inline {\n  width: 220px;\n}\n.datepicker-rtl {\n  direction: rtl;\n}\n.datepicker-rtl.dropdown-menu {\n  left: auto;\n}\n.datepicker-rtl table tr td span {\n  float: right;\n}\n.datepicker-dropdown {\n  top: 0;\n  left: 0;\n  padding: 20px 22px;\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n.datepicker-dropdown.datepicker-orient-left:before {\n  left: 6px;\n}\n.datepicker-dropdown.datepicker-orient-left:after {\n  left: 7px;\n}\n.datepicker-dropdown.datepicker-orient-right:before {\n  right: 6px;\n}\n.datepicker-dropdown.datepicker-orient-right:after {\n  right: 7px;\n}\n.datepicker-dropdown.datepicker-orient-bottom:before {\n  top: -7px;\n}\n.datepicker-dropdown.datepicker-orient-bottom:after {\n  top: -6px;\n}\n.datepicker-dropdown.datepicker-orient-top:before {\n  bottom: -7px;\n  border-bottom: 0;\n  border-top: 7px solid white;\n}\n.datepicker-dropdown.datepicker-orient-top:after {\n  bottom: -6px;\n  border-bottom: 0;\n  border-top: 6px solid #fff;\n}\n.datepicker table {\n  margin: 0;\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n.datepicker table tr td {\n  border-radius: 50%;\n}\n.datepicker table tr th {\n  border-radius: 0.375rem;\n  font-weight: 500;\n}\n.datepicker table tr td,\n.datepicker table tr th {\n  transition: all 0.15s ease;\n  width: 36px;\n  height: 36px;\n  border: none;\n  text-align: center;\n  font-size: 0.875rem;\n}\n.table-striped .datepicker table tr td,\n.table-striped .datepicker table tr th {\n  background-color: transparent;\n}\n.datepicker table tr td.old, .datepicker table tr td.new {\n  color: #adb5bd;\n}\n.datepicker table tr td.day:hover, .datepicker table tr td.focused {\n  background: white;\n  cursor: pointer;\n}\n.datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: default;\n}\n.datepicker table tr td.highlighted {\n  border-radius: 0;\n}\n.datepicker table tr td.highlighted.focused {\n  background: #5e72e4;\n}\n.datepicker table tr td.highlighted.disabled, .datepicker table tr td.highlighted.disabled:active {\n  background: #5e72e4;\n  color: #ced4da;\n}\n.datepicker table tr td.today {\n  background: white;\n}\n.datepicker table tr td.today.focused {\n  background: white;\n}\n.datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:active {\n  background: white;\n  color: #8898aa;\n}\n.datepicker table tr td.range {\n  background: #5e72e4;\n  color: #fff;\n  border-radius: 0;\n}\n.datepicker table tr td.range.focused {\n  background: #3b53de;\n}\n.datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:active, .datepicker table tr td.range.day.disabled:hover {\n  background: #324cdd;\n  color: #8a98eb;\n}\n.datepicker table tr td.range.highlighted.focused {\n  background: #cbd3da;\n}\n.datepicker table tr td.range.highlighted.disabled, .datepicker table tr td.range.highlighted.disabled:active {\n  background: #e9ecef;\n  color: #dee2e6;\n}\n.datepicker table tr td.range.today.disabled, .datepicker table tr td.range.today.disabled:active {\n  background: #5e72e4;\n  color: #fff;\n}\n.datepicker table tr td.day.range-start {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.datepicker table tr td.day.range-end {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.datepicker table tr td.day.range-start.range-end {\n  border-radius: 50%;\n}\n.datepicker table tr td.selected, .datepicker table tr td.selected.highlighted, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.highlighted:hover, .datepicker table tr td.day.range:hover {\n  background: #5e72e4;\n  color: #fff;\n}\n.datepicker table tr td.active, .datepicker table tr td.active.highlighted, .datepicker table tr td.active:hover, .datepicker table tr td.active.highlighted:hover {\n  background: #5e72e4;\n  color: #fff;\n  box-shadow: none;\n}\n.datepicker table tr td span {\n  display: block;\n  width: 23%;\n  height: 54px;\n  line-height: 54px;\n  float: left;\n  margin: 1%;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.datepicker table tr td span:hover, .datepicker table tr td span.focused {\n  background: #e9ecef;\n}\n.datepicker table tr td span.disabled, .datepicker table tr td span.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: default;\n}\n.datepicker table tr td span.active, .datepicker table tr td span.active:hover, .datepicker table tr td span.active.disabled, .datepicker table tr td span.active.disabled:hover {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.datepicker table tr td span.old, .datepicker table tr td span.new {\n  color: #8898aa;\n}\n.datepicker .datepicker-switch {\n  width: 145px;\n}\n.datepicker .datepicker-switch,\n.datepicker .prev,\n.datepicker .next,\n.datepicker tfoot tr th {\n  cursor: pointer;\n}\n.datepicker .datepicker-switch:hover,\n.datepicker .prev:hover,\n.datepicker .next:hover,\n.datepicker tfoot tr th:hover {\n  background: #e9ecef;\n}\n.datepicker .prev.disabled,\n.datepicker .next.disabled {\n  visibility: hidden;\n}\n.datepicker .cw {\n  font-size: 10px;\n  width: 12px;\n  padding: 0 2px 0 5px;\n  vertical-align: middle;\n}\n\n/*! nouislider - 14.0.1 - 6/21/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n\n/* Offset direction\n */\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  left: -17px;\n  top: -6px;\n}\n\n.noUi-vertical {\n  width: 18px;\n}\n\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n  right: -17px;\n  left: auto;\n}\n\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n  border: 1px solid #D3D3D3;\n  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n\n.noUi-connects {\n  border-radius: 3px;\n}\n\n.noUi-connect {\n  background: #3FB8AF;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n\n.noUi-handle {\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #E8E7E6;\n  left: 14px;\n  top: 6px;\n}\n\n.noUi-handle:after {\n  left: 17px;\n}\n\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n\n.noUi-marker-sub {\n  background: #AAA;\n}\n\n.noUi-marker-large {\n  background: #AAA;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.noUi-target {\n  background: #eceeef;\n  border-radius: 5px;\n  border: 0;\n  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);\n  margin: 15px 0;\n  cursor: pointer;\n}\n\n.noUi-horizontal {\n  height: 5px;\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n  right: -10px;\n}\n\n.noUi-vertical {\n  width: 5px;\n}\n\n.noUi-connect {\n  background: #5e72e4;\n  box-shadow: none;\n}\n\n.noUi-handle:after, .noUi-handle:before {\n  content: none;\n}\n.noUi-handle:focus {\n  outline: none;\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n  top: -5px;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  box-shadow: none;\n  cursor: pointer;\n  background-color: #5e72e4;\n  border: 0;\n  transition: box-shadow 0.15s, transform 0.15s;\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n  box-shadow: 0px 0px 0px 2px #5e72e4;\n}\n\n.input-slider--cyan .noUi-connect {\n  background: #2bffc6;\n}\n\n/* Disabled state */\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n  background: #b2b2b2;\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n  cursor: not-allowed;\n}\n\n/* Range slider value labels */\n.range-slider-value {\n  font-size: 0.75rem;\n  font-weight: 500;\n  background-color: rgba(33, 37, 41, 0.7);\n  color: #fff;\n  border-radius: 10px;\n  padding: 0.4em 0.8em 0.3em 0.85em;\n}\n\n.range-slider-wrapper .upper-info {\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.input-slider-value-output {\n  background: #333;\n  color: #fff;\n  padding: 4px 8px;\n  position: relative;\n  top: 12px;\n  font-size: 11px;\n  border-radius: 2px;\n}\n\n.input-slider-value-output:after {\n  bottom: 100%;\n  left: 10px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(136, 183, 213, 0);\n  border-bottom-color: #333;\n  border-width: 4px;\n  margin-left: -4px;\n}\n\n.input-slider-value-output.left:after {\n  left: 10px;\n  right: auto;\n}\n\n.input-slider-value-output.right:after {\n  right: 10px;\n  left: auto;\n}\n\n.scrollbar-inner {\n  height: 100%;\n}\n.scrollbar-inner:not(:hover) .scroll-element {\n  opacity: 0;\n}\n.scrollbar-inner .scroll-element {\n  transition: opacity 300ms;\n  margin-right: 2px;\n}\n.scrollbar-inner .scroll-element .scroll-bar,\n.scrollbar-inner .scroll-element .scroll-element_track {\n  transition: background-color 300ms;\n}\n.scrollbar-inner .scroll-element .scroll-element_track {\n  background-color: transparent;\n}\n.scrollbar-inner .scroll-element.scroll-y {\n  width: 3px;\n  right: 0;\n}\n.scrollbar-inner .scroll-element.scroll-x {\n  height: 3px;\n  bottom: 0;\n}\n\n.ct-navbar {\n  background-color: #5e72e4;\n  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n@media (max-width: 991.98px) {\n  .ct-navbar {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .ct-navbar .navbar-nav-scroll {\n    max-width: 100%;\n    height: 2.5rem;\n    margin-top: 0.25rem;\n    overflow: hidden;\n    font-size: 0.875rem;\n  }\n  .ct-navbar .navbar-nav-scroll .navbar-nav {\n    padding-bottom: 2rem;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (min-width: 768px) {\n  @supports (position: sticky) {\n    .ct-navbar {\n      position: sticky;\n      top: 0;\n      z-index: 1071;\n    }\n  }\n}\n.ct-navbar .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n.ct-navbar .navbar-nav .nav-link.active, .ct-navbar .navbar-nav .nav-link:hover {\n  color: #fff !important;\n  background-color: transparent !important;\n}\n.ct-navbar .navbar-nav .nav-link.active {\n  font-weight: 500;\n}\n.ct-navbar .navbar-nav-svg {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  vertical-align: text-top;\n}\n.ct-navbar .dropdown-menu {\n  font-size: 0.875rem;\n}\n.ct-navbar .dropdown-item.active {\n  font-weight: 500;\n  color: #212529;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23292b2c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 0.4rem 0.87rem;\n  background-size: 0.75rem 0.75rem;\n  padding-left: 25px;\n}\n\n.github-corner {\n  position: fixed;\n  right: 0;\n  z-index: 1080;\n}\n.github-corner:hover .octo-arm {\n  animation: octocat-wave 560ms ease-in-out;\n}\n.github-corner svg {\n  fill: #fff;\n  color: #5e72e4;\n}\n\n@keyframes octocat-wave {\n  0%, 100% {\n    transform: rotate(0);\n  }\n  20%, 60% {\n    transform: rotate(-25deg);\n  }\n  40%, 80% {\n    transform: rotate(10deg);\n  }\n}\n.ct-clipboard {\n  position: relative;\n  display: none;\n  float: right;\n}\n.ct-clipboard + .highlight {\n  margin-top: 0;\n}\n\n.btn-clipboard {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  display: block;\n  padding: 0.25rem 0.5rem;\n  font-size: 75%;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #fff;\n  background-color: #5e72e4;\n}\n.btn-clipboard:hover {\n  color: #fff;\n  background-color: #324cdd;\n}\n\n@media (min-width: 768px) {\n  .ct-clipboard {\n    display: block;\n  }\n}\n.ct-example-row .row > .col span,\n.ct-example-row .row > [class^=col-] span {\n  display: block;\n  padding: 0.75rem;\n  color: rgb(57, 63, 73);\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n  margin: 1rem 0;\n}\n.ct-example-row .no-gutters > .col span,\n.ct-example-row .no-gutters > [class^=col-] span {\n  border-radius: 0;\n}\n.ct-example-row .flex-items-top,\n.ct-example-row .flex-items-middle,\n.ct-example-row .flex-items-bottom {\n  min-height: 6rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.ct-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.ct-example-row-flex-cols .row + .row {\n  margin-top: 1rem;\n}\n\n.ct-highlight {\n  background-color: rgba(94, 114, 228, 0.15);\n  border: 1px solid rgba(94, 114, 228, 0.15);\n}\n\n.example-container {\n  width: 800px;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.example-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.example-content-main {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n  .example-content-main {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-main {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n}\n\n.example-content-secondary {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n  .example-content-secondary {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-secondary {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n}\n\n.ct-example-container {\n  min-width: 16rem;\n  max-width: 25rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-container-header {\n  height: 3rem;\n  margin-bottom: 0.5rem;\n  background-color: white;\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-sidebar {\n  float: right;\n  width: 4rem;\n  height: 8rem;\n  background-color: #cbd2f6;\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-body {\n  height: 8rem;\n  margin-right: 4.5rem;\n  background-color: #cbd2f6;\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-fluid {\n  max-width: none;\n}\n\n.ct-example {\n  position: relative;\n  margin: 1rem -15px 0;\n}\n.ct-example::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n@media (min-width: 576px) {\n  .ct-example {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.ct-example + .highlight,\n.ct-example + .clipboard + .highlight {\n  margin-top: 0;\n}\n.ct-example + p {\n  margin-top: 2rem;\n}\n.ct-example .pos-f-t {\n  position: relative;\n  margin: -1rem;\n}\n@media (min-width: 576px) {\n  .ct-example .pos-f-t {\n    margin: -1.5rem;\n  }\n}\n.ct-example .custom-file-input:lang(es) ~ .custom-file-label::after {\n  content: \"Elegir\";\n}\n.ct-example > .form-control + .form-control {\n  margin-top: 0.5rem;\n}\n.ct-example > .nav + .nav,\n.ct-example > .alert + .alert,\n.ct-example > .navbar + .navbar,\n.ct-example > .progress + .progress,\n.ct-example > .progress + .btn,\n.ct-example .badge,\n.ct-example .btn {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.ct-example .btn-group {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.ct-example .btn-group .btn {\n  margin: 0;\n}\n.ct-example .alert {\n  margin: 0;\n}\n.ct-example .alert + .alert {\n  margin-top: 1.25rem;\n}\n.ct-example .badge {\n  margin-right: 0.5rem;\n}\n.ct-example > .dropdown-menu:first-child {\n  position: static;\n  display: block;\n}\n.ct-example > .form-group:last-child {\n  margin-bottom: 0;\n}\n.ct-example > .close {\n  float: none;\n}\n\n.ct-example-type .table .type-info {\n  color: #999;\n  vertical-align: middle;\n}\n.ct-example-type .table td {\n  padding: 1rem 0;\n  border-color: #eee;\n}\n.ct-example-type .table tr:first-child td {\n  border-top: 0;\n}\n.ct-example-type h1,\n.ct-example-type h2,\n.ct-example-type h3,\n.ct-example-type h4,\n.ct-example-type h5,\n.ct-example-type h6 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ct-example-bg-classes p {\n  padding: 1rem;\n}\n\n.ct-example > img + img {\n  margin-left: 0.5rem;\n}\n\n.ct-example > .btn-group {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.ct-example > .btn-toolbar + .btn-toolbar {\n  margin-top: 0.5rem;\n}\n\n.ct-example-control-sizing select,\n.ct-example-control-sizing input[type=text] + input[type=text] {\n  margin-top: 0.5rem;\n}\n\n.ct-example-form .input-group {\n  margin-bottom: 0.5rem;\n}\n\n.ct-example > textarea.form-control {\n  resize: vertical;\n}\n\n.ct-example > .list-group {\n  max-width: 400px;\n}\n\n.ct-example .fixed-top,\n.ct-example .sticky-top {\n  position: static;\n  margin: -1rem -1rem 1rem;\n}\n.ct-example .fixed-bottom {\n  position: static;\n  margin: 1rem -1rem -1rem;\n}\n@media (min-width: 576px) {\n  .ct-example .fixed-top,\n  .ct-example .sticky-top {\n    margin: -1.5rem -1.5rem 1rem;\n  }\n  .ct-example .fixed-bottom {\n    margin: 1rem -1.5rem -1.5rem;\n  }\n}\n\n.ct-example .pagination {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal {\n  z-index: 1072;\n}\n.modal .tooltip,\n.modal .popover {\n  z-index: 1073;\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.ct-example-modal {\n  background-color: #fafafa;\n}\n.ct-example-modal .modal {\n  position: relative;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  z-index: 1;\n  display: block;\n}\n.ct-example-modal .modal-dialog {\n  left: auto;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n.ct-example-popover-static {\n  padding-bottom: 1.5rem;\n  background-color: #f9f9f9;\n}\n.ct-example-popover-static .popover {\n  position: relative;\n  display: block;\n  float: left;\n  width: 260px;\n  margin: 1.25rem;\n}\n\n.tooltip-demo a {\n  white-space: nowrap;\n}\n\n.ct-example-tooltip-static .tooltip {\n  position: relative;\n  display: inline-block;\n  margin: 10px 20px;\n  opacity: 1;\n}\n\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: 0.5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 350px;\n  overflow: auto;\n}\n\n.ct-example-border-utils [class^=border] {\n  display: inline-block;\n  width: 5rem;\n  height: 5rem;\n  margin: 0.25rem;\n  background-color: #f5f5f5;\n}\n\n.ct-example-border-utils-0 [class^=border] {\n  border: 1px solid #e9ecef;\n}\n\n.highlight {\n  padding: 0;\n  margin-top: 1rem;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n@media (min-width: 576px) {\n  .highlight {\n    padding: 0;\n  }\n}\n\n.ct-content .highlight {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 576px) {\n  .ct-content .highlight {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n.ct-example {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #e9ecef;\n}\n.ct-example .tab-content .tab-example-result {\n  background-color: #f5f7f9;\n  border: 1px solid #e6ecf1;\n  padding: 1.25rem;\n  border-radius: 0.25rem;\n}\n.ct-example .nav-tabs-code {\n  margin-bottom: 0.375rem;\n}\n.ct-example .nav-tabs-code .nav-link {\n  font-size: 0.875rem;\n}\n.ct-example .nav-tabs-code .nav-link:active, .ct-example .nav-tabs-code .nav-link.active {\n  color: #5e72e4;\n}\n\n.icon-examples {\n  margin-top: 1rem;\n}\n\n.btn-icon-clipboard {\n  margin: 0px;\n  padding: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: rgb(57, 63, 73);\n  background-color: rgb(248, 249, 250);\n  border-radius: 4px;\n  border: 0px none;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n}\n.btn-icon-clipboard:hover {\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n}\n.btn-icon-clipboard > div {\n  align-items: center;\n  display: flex;\n}\n.btn-icon-clipboard i {\n  box-sizing: content-box;\n  color: rgb(57, 63, 73);\n  vertical-align: middle;\n  font-size: 1.5rem;\n}\n.btn-icon-clipboard span {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: rgb(57, 63, 73);\n  margin-left: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  font-family: Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace;\n  font-size: 14px;\n  line-height: 1.375;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n  background: #f5f7ff;\n  color: #5e6687;\n  border-radius: 0.25rem;\n}\n\npre[class*=language-]::-moz-selection,\npre[class*=language-] ::-moz-selection,\ncode[class*=language-]::-moz-selection,\ncode[class*=language-] ::-moz-selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\npre[class*=language-]::selection,\npre[class*=language-] ::selection,\ncode[class*=language-]::selection,\ncode[class*=language-] ::selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\n/* Code blocks */\npre[class*=language-] {\n  padding: 1.25rem;\n  margin: 0;\n  overflow: auto;\n}\n\n/* Inline code */\n:not(pre) > code[class*=language-] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #898ea4;\n}\n\n.token.punctuation {\n  color: #5e6687;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.operator,\n.token.boolean,\n.token.number {\n  color: #c76b29;\n}\n\n.token.property {\n  color: #c08b30;\n}\n\n.token.tag {\n  color: #3d8fd1;\n}\n\n.token.string {\n  color: #22a2c9;\n}\n\n.token.selector {\n  color: #6679cc;\n}\n\n.token.attr-name {\n  color: #c76b29;\n}\n\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #22a2c9;\n}\n\n.token.attr-value,\n.token.keyword,\n.token.control,\n.token.directive,\n.token.unit {\n  color: #ac9739;\n}\n\n.token.statement,\n.token.regex,\n.token.atrule {\n  color: #22a2c9;\n}\n\n.token.placeholder,\n.token.variable {\n  color: #3d8fd1;\n}\n\n.token.deleted {\n  text-decoration: line-through;\n}\n\n.token.inserted {\n  border-bottom: 1px dotted #202746;\n  text-decoration: none;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.important {\n  color: #c94922;\n}\n\n.token.entity {\n  cursor: help;\n}\n\npre > code.highlight {\n  outline: 0.4em solid #c94922;\n  outline-offset: 0.4em;\n}\n\n/* overrides color-values for the Line Numbers plugin\n * http://prismjs.com/plugins/line-numbers/\n */\n.line-numbers .line-numbers-rows {\n  border-right-color: #dfe2f1;\n}\n\n.line-numbers-rows > span:before {\n  color: #979db4;\n}\n\n/* overrides color-values for the Line Highlight plugin\n * http://prismjs.com/plugins/line-highlight/\n */\n.line-highlight {\n  background: rgba(107, 115, 148, 0.2);\n  background: -webkit-linear-gradient(left, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n  background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n}\n\n.docs {\n  background: #FFF;\n}\n.docs h6 {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.ct-content {\n  order: 1;\n}\n.ct-content > h2[id],\n.ct-content > h3[id],\n.ct-content > h4[id] {\n  pointer-events: none;\n}\n.ct-content > h2[id] > div,\n.ct-content > h2[id] > a,\n.ct-content > h3[id] > div,\n.ct-content > h3[id] > a,\n.ct-content > h4[id] > div,\n.ct-content > h4[id] > a {\n  pointer-events: auto;\n}\n.ct-content > h2[id]::before,\n.ct-content > h3[id]::before,\n.ct-content > h4[id]::before {\n  display: block;\n  height: 6rem;\n  margin-top: -6rem;\n  visibility: hidden;\n  content: \"\";\n}\n.ct-content > table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n}\n@media (max-width: 991.98px) {\n  .ct-content > table {\n    display: block;\n    overflow-x: auto;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .ct-content > table.table-bordered {\n    border: 0;\n  }\n}\n.ct-content > table > thead > tr > th,\n.ct-content > table > thead > tr > td,\n.ct-content > table > tbody > tr > th,\n.ct-content > table > tbody > tr > td,\n.ct-content > table > tfoot > tr > th,\n.ct-content > table > tfoot > tr > td {\n  padding: 1rem;\n  vertical-align: top;\n  border: 1px solid #e9ecef;\n}\n.ct-content > table > thead > tr > th > p:last-child,\n.ct-content > table > thead > tr > td > p:last-child,\n.ct-content > table > tbody > tr > th > p:last-child,\n.ct-content > table > tbody > tr > td > p:last-child,\n.ct-content > table > tfoot > tr > th > p:last-child,\n.ct-content > table > tfoot > tr > td > p:last-child {\n  margin-bottom: 0;\n}\n.ct-content > table td:first-child > code {\n  white-space: nowrap;\n}\n\n.ct-content > h2:not(:first-child) {\n  margin-top: 3rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n.ct-content > h3 {\n  margin-top: 2.5rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n.ct-content > ul li,\n.ct-content > ol li {\n  margin-bottom: 0.25rem;\n}\n@media (min-width: 992px) {\n  .ct-content > ul,\n  .ct-content > ol,\n  .ct-content > p {\n    max-width: 80%;\n  }\n}\n\n.ct-page-title {\n  padding-left: 1.25rem;\n  border-left: 2px solid #5e72e4;\n  margin-bottom: 1.5rem;\n}\n\n.ct-title {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  font-weight: 300;\n}\n@media (min-width: 576px) {\n  .ct-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.ct-lead {\n  color: rgb(59, 69, 78);\n  font-weight: 500;\n}\n@media (min-width: 576px) {\n  .ct-lead {\n    max-width: 80%;\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n  }\n}\n\n.ct-text-purple {\n  color: #5e72e4;\n}\n\n.ct-text-purple-bright {\n  color: #9da9f2;\n}\n\n.ct-tabs-example .nav-link i {\n  margin-right: 5px;\n}\n\n.color-swatch {\n  margin: 1rem 0;\n  border-radius: 0.25rem;\n  background-color: #F4F5F7;\n}\n\n.color-swatch:after {\n  content: \" \";\n  display: table;\n  clear: both;\n}\n\n.color-swatch-header {\n  position: relative;\n  height: 0;\n  padding-bottom: 50%;\n  border-radius: 0.25rem 0.25rem 0 0;\n  border: 1px solid transparent;\n}\n\n.color-swatch-header.is-light {\n  border-color: #C1C7D0;\n}\n\n.color-swatch-header .pass-fail {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.color-swatch-header .pass-fail-item-wrap {\n  position: relative;\n  float: left;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-header .pass-fail-item-group {\n  display: inline-block;\n  padding: 0 5px;\n}\n\n.color-swatch-header .pass-fail-item {\n  float: left;\n  display: inline-block;\n  text-align: center;\n  padding: 2px;\n}\n\n.color-swatch-header .pass-fail-item.white .example {\n  color: #fff;\n}\n\n.color-swatch-header .pass-fail-item.small .example {\n  font-size: 10px;\n}\n\n.color-swatch-header .pass-fail-item .lozenge {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #000;\n  color: #fff;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.color-swatch-body {\n  position: relative;\n  left: 50%;\n  float: left;\n  padding: 10px 0;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-body .prop-item-wrap {\n  float: left;\n  padding: 0 15px;\n  min-width: 65px;\n}\n\n.color-swatch-body .prop-item {\n  padding: 15px 0;\n}\n\n.color-swatch-body .prop-item .label {\n  font-size: 11px;\n  color: #62748C;\n  text-transform: uppercase;\n  line-height: 16px;\n}\n\n.color-swatch-body .prop-item .value {\n  font-size: 14px;\n}\n\n.table-colors {\n  font-weight: 600;\n  font-size: 16px;\n  width: 100%;\n}\n\n.table-colors td,\n.table-colors:first-child td,\n.table-colors td:first-child,\n.table-colors:first-child td:first-child,\n.table-colors td:last-child,\n.table-colors:first-child td:last-child {\n  background: rgba(255, 255, 255, 0.9);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.table-colors tr:last-child td,\n.table-colors:first-child tr:last-child td {\n  border-bottom: none;\n}\n\n.table-colors td:nth-child(1),\n.table-colors:first-child td:nth-child(1) {\n  line-height: 40px;\n}\n\n.table-colors .swatch,\n.table-colors:first-child .swatch {\n  float: left;\n  height: 40px;\n  width: 40px;\n  margin-right: 20px;\n  display: inline-block;\n  border-radius: 4px;\n  border: 1px solid transparent;\n}\n\n.table-colors .swatch.is-light,\n.table-colors:first-child .swatch.is-light {\n  border-color: #C1C7D0;\n}\n\n.table-colors .lozenge,\n.table-colors:first-child .lozenge {\n  float: left;\n  margin: 5px 10px 0 0;\n  font-size: 10px;\n  display: inline-block;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #97A0AF;\n  color: #042A53;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.ct-toc {\n  order: 2;\n  padding-top: 2rem;\n  padding-bottom: 1.5rem;\n  font-size: 0.875rem;\n}\n@supports (position: sticky) {\n  .ct-toc {\n    position: sticky;\n    top: 4rem;\n    height: calc(100vh - 4rem);\n    overflow-y: auto;\n  }\n}\n\n.section-nav {\n  padding-left: 0;\n  border-left: 1px solid #eee;\n}\n.section-nav ul {\n  padding-left: 1rem;\n}\n.section-nav ul ul {\n  display: none;\n}\n\n.toc-entry {\n  display: block;\n  font-size: 1rem;\n}\n.toc-entry a {\n  display: block;\n  padding: 0.125rem 1.5rem;\n  color: #99979c;\n  font-size: 90%;\n}\n.toc-entry a:hover {\n  color: #5e72e4;\n  text-decoration: none;\n}\n\n.ct-sidebar {\n  order: 0;\n  border-bottom: 1px solid #e6ecf1;\n  background-color: #f5f7f9;\n}\n@media (min-width: 768px) {\n  .ct-sidebar {\n    border-right: 1px solid #e6ecf1;\n  }\n  @supports (position: sticky) {\n    .ct-sidebar {\n      position: sticky;\n      top: 4rem;\n      z-index: 1000;\n      height: calc(100vh - 4rem);\n    }\n  }\n}\n@media (min-width: 1200px) {\n  .ct-sidebar {\n    flex: 0 1 320px;\n  }\n}\n\n.ct-links {\n  padding-top: 2rem;\n  padding-bottom: 1rem;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  @supports (position: sticky) {\n    .ct-links {\n      max-height: calc(100vh - 5rem);\n      overflow-y: auto;\n    }\n  }\n}\n@media (min-width: 768px) {\n  .ct-links {\n    display: block !important;\n  }\n}\n\n.ct-search {\n  position: relative;\n  padding: 1rem 15px;\n  margin-right: -15px;\n  margin-left: -15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ct-search .form-control:focus {\n  border-color: #9da9f2;\n  box-shadow: 0 0 0 3px rgba(157, 169, 242, 0.25);\n}\n\n.ct-search-docs-toggle {\n  line-height: 1;\n  color: #212529;\n}\n\n.ct-sidenav {\n  display: none;\n}\n\n.ct-toc-link {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #0d2b3e;\n}\n.ct-toc-link:hover {\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n}\n\n.ct-toc-item.active {\n  margin-bottom: 1rem;\n}\n.ct-toc-item.active:not(:first-child) {\n  margin-top: 1rem;\n}\n.ct-toc-item.active > .ct-toc-link {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ct-toc-item.active > .ct-toc-link:hover {\n  background-color: transparent;\n}\n.ct-toc-item.active > .ct-sidenav {\n  display: block;\n}\n\n.ct-sidebar .nav > li > a {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-size: 84%;\n  color: #4c555a;\n}\n\n.ct-sidebar .nav > li > a:hover {\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.ct-sidebar .nav > .active > a {\n  font-weight: 500;\n  color: #0099e5;\n  background-color: transparent;\n  padding-left: 2rem;\n  position: relative;\n}\n.ct-sidebar .nav > .active > a:before {\n  content: \"\";\n  position: absolute;\n  height: 16px;\n  width: 2px;\n  background-color: #0099e5;\n  top: 50%;\n  left: 1.5rem;\n  transform: translateY(-50%);\n}\n\n.ct-sidebar .nav > .active:hover > a {\n  color: #0099e5;\n}\n\n.scrollbar-inner {\n  height: 100%;\n}\n.scrollbar-inner:not(:hover) .scroll-element {\n  opacity: 0;\n}\n.scrollbar-inner .scroll-element {\n  transition: opacity 300ms;\n  margin-right: 2px;\n}\n.scrollbar-inner .scroll-element .scroll-bar,\n.scrollbar-inner .scroll-element .scroll-element_track {\n  transition: background-color 300ms;\n}\n.scrollbar-inner .scroll-element .scroll-element_track {\n  background-color: transparent;\n}\n.scrollbar-inner .scroll-element.scroll-y {\n  width: 3px;\n  right: 0;\n}\n.scrollbar-inner .scroll-element.scroll-x {\n  height: 3px;\n  bottom: 0;\n}\n\n.ct-footer {\n  font-size: 85%;\n  text-align: center;\n  background-color: #f7f7f7;\n}\n.ct-footer a {\n  font-weight: 500;\n  color: #525f7f;\n}\n.ct-footer a:hover, .ct-footer a:focus {\n  color: #5e72e4;\n}\n.ct-footer p {\n  margin-bottom: 0;\n}\n@media (min-width: 576px) {\n  .ct-footer {\n    text-align: left;\n  }\n}\n\n.ct-footer-links {\n  padding-left: 0;\n  margin-bottom: 1rem;\n}\n.ct-footer-links li {\n  display: inline-block;\n}\n.ct-footer-links li + li {\n  margin-left: 1rem;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentcolor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentcolor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    animation-duration: 1.5s;\n  }\n}\n/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n}\n.rdt .rdtPicker {\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n  margin-top: -20px;\n  visibility: hidden;\n  display: block;\n  opacity: 0;\n}\n.rdt.rdtOpen .rdtPicker {\n  opacity: 1;\n  visibility: visible;\n  margin-top: 0;\n}\n\n.rdtPicker {\n  display: none;\n  position: absolute;\n  padding: 20px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.375rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n}\n.rdtPicker:before {\n  display: inline-block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  content: \"\";\n  top: -5px;\n  left: 10px;\n  right: auto;\n  color: #ffffff;\n  border-bottom: 0.4em solid;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n}\n.rdtPicker:after {\n  border-bottom: 0.4em solid #ffffff;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: -5px;\n  left: 10px;\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n}\n.rdtPicker .rdtTimeToggle:before {\n  visibility: visible;\n  width: 100%;\n  height: 100%;\n  border-radius: 3px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font: normal normal normal 1em/1 \"Nucleo\";\n  font-size: 18px;\n  content: \"\\ea5e\";\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: #fff !important;\n}\n\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n\n.rdtPicker td {\n  cursor: pointer;\n}\n\n.rdtDay {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 50%;\n}\n.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover, .rdtDay.start-date, .rdtDay.end-date, .rdtDay.middle-date, .rdtDay.start-date:hover, .rdtDay.end-date:hover, .rdtDay.middle-date:hover {\n  background-color: #11cdef !important;\n  color: #fff !important;\n}\n.rdtDay.start-date {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rdtDay.middle-date {\n  border-radius: 0;\n}\n.rdtDay.end-date {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rdtDays tr .dow {\n  text-align: center;\n  font-size: 12px;\n  font-weight: inherit;\n  padding-bottom: 5px;\n  padding-top: 10px;\n  font-weight: 300;\n  font-size: 0.875rem;\n  width: 20px;\n  height: 20px;\n}\n.rdtDays tr .rdtDay {\n  color: #525f7f;\n  font-size: 0.875rem;\n}\n.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {\n  color: #adb5bd;\n  font-weight: 300;\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker tr .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  font-weight: 500;\n  border-radius: 0.375rem;\n}\n\n.rdtPicker th.rdtSwitch {\n  font-weight: 500;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  width: 145px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n}\n\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.rdtPicker .dow,\n.rdtPicker th.rdtSwitch,\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev,\n.rdtPicker .rdtTimeToggle {\n  color: #525f7f;\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\n\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters > div {\n  float: left;\n  width: 40px;\n  font-weight: inherit;\n  margin: 3px;\n  border-radius: 50%;\n}\n.rdtCounters .rdtCounterSeparator {\n  width: 0;\n  border: 1px solid transparent;\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n}\n.rdtCounter .rdtCount {\n  padding: 7px;\n  height: 40px;\n  border: 1px solid transparent;\n}\n\n.rdtCounters .rdtCounter:last-child .rdtCount {\n  color: #11cdef;\n  border-radius: 50%;\n  border: 1px solid #11cdef;\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: #adb5bd;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n}\n.rdtMonths .rdtMonth,\n.rdtMonths .rdtYear,\n.rdtYears .rdtMonth,\n.rdtYears .rdtYear {\n  display: inline-block;\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  margin: 3px 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n.rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtMonth.start-date, .rdtMonths .rdtMonth.end-date, .rdtMonths .rdtMonth.middle-date,\n.rdtMonths .rdtYear.rdtActive,\n.rdtMonths .rdtYear.start-date,\n.rdtMonths .rdtYear.end-date,\n.rdtMonths .rdtYear.middle-date,\n.rdtYears .rdtMonth.rdtActive,\n.rdtYears .rdtMonth.start-date,\n.rdtYears .rdtMonth.end-date,\n.rdtYears .rdtMonth.middle-date,\n.rdtYears .rdtYear.rdtActive,\n.rdtYears .rdtYear.start-date,\n.rdtYears .rdtYear.end-date,\n.rdtYears .rdtYear.middle-date {\n  background-color: #11cdef !important;\n  color: #fff;\n}\n\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .rdt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-group .rdt {\n  width: 1%;\n  margin-bottom: 0;\n  flex: 1 1 auto;\n}\n\n.btn .btn-inner--icon {\n  margin-right: 4px;\n}\n\n.btn + .btn {\n  margin-left: 4px;\n}\n\nbutton:focus, :focus {\n  outline: none;\n}\n\n@keyframes show-navbar-dropdown {\n  0% {\n    opacity: 0;\n    transition: visibility 0.25s, opacity 0.25s;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.navbar .collapsing .navbar-toggler {\n  pointer-events: none;\n}\n\n.navbar .nav-item .nav-link-icon.nav-link i {\n  margin-right: 4px;\n}\n\n.table .avatar-group .avatar {\n  margin-right: 4px;\n}\n.table .badge i {\n  margin-right: 10px;\n}",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n//\n// Variables\n//\n\n// Global settings\n\n$enable-caret:              true !default;\n$enable-rounded:            true !default;\n$enable-shadows:            true !default;\n$enable-gradients:          false !default;\n$enable-transitions:        true !default;\n$enable-grid-classes:       true !default;\n$enable-print-styles:       true !default;\n\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f6f9fc !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #8898aa !default;   // Line footer color\n$gray-700: #525f7f !default;   // Line p color\n$gray-800: #32325d !default;   // Line heading color\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge((\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n), $grays);\n\n$blue:    #5e72e4 !default;\n$indigo:  #5603ad !default;\n$purple:  #8965e0 !default;\n$pink:    #f3a4b5 !default;\n$red:     #f5365c !default;\n$orange:  #fb6340 !default;\n$yellow:  #ffd600 !default;\n$green:   #2dce89 !default;\n$teal:    #11cdef !default;\n$cyan:    #2bffc6 !default;\n\n$colors: () !default;\n$colors: map-merge((\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"light\":      $gray-400,\n  \"lighter\":    $gray-200,\n  \"gray-dark\":  $gray-800\n), $colors);\n\n$default:       #172b4d !default;\n$primary:       #5e72e4 !default;\n$secondary:     #f7fafc !default;\n$success:       $green !default;\n$info:          $teal !default;\n$warning:       $orange !default;\n$danger:        $red !default;\n$light:         $gray-500 !default;\n$dark:          $gray-900 !default;\n$darker:        darken($gray-900, 15%) !default;\n\n$facebook:      #3b5999 !default;\n$twitter:       #1da1f2 !default;\n$google-plus:   #dd4b39 !default;\n$instagram:     #e4405f !default;\n$pinterest:     #bd081c !default;\n$youtube:       #cd201f !default;\n$slack:         #3aaf85 !default;\n$dribbble:      #ea4c89 !default;\n$github:        #222222 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge((\n  \"default\":      $default,\n  \"primary\":      $primary,\n  \"secondary\":    $secondary,\n  \"success\":      $success,\n  \"info\":         $info,\n  \"warning\":      $warning,\n  \"danger\":       $danger,\n  \"white\":        $white,\n  \"neutral\":      $white,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $theme-colors);\n\n$brand-colors: () !default;\n$brand-colors: map-merge((\n  \"facebook\":     $facebook,\n  \"twitter\":      $twitter,\n  \"google-plus\":  $google-plus,\n  \"instagram\":    $instagram,\n  \"pinterest\":    $pinterest,\n  \"youtube\":      $youtube,\n  \"slack\":        $slack,\n  \"dribbble\":     $dribbble,\n  \"github\":       $github\n), $brand-colors);\n\n$shape-colors: () !default;\n$shape-colors: map-merge((\n  \"default\":      #32325d,\n  \"primary\":      #5533ff,\n  \"secondary\":    #24b47e,\n  \"neutral\":      #e9ecef,\n  \"blue-gray\":    #b2cbe1,\n\n), $shape-colors);\n\n$shapes-primary-colors: () !default;\n$shapes-primary-colors: map-merge((\n  \"step-1-gradient-bg\":         #281483,\n  \"step-2-gradient-bg\":         #8f6ed5,\n  \"step-3-gradient-bg\":         #d782d9,\n  \"span-1-bg\":                  #53f,\n  \"span-2-bg\":                  #4553ff,\n  \"span-3-bg\":                  #4f40ff,\n  \"span-4-bg\":                  #25ddf5,\n  \"span-5-bg\":                  #1fa2ff\n), $shapes-primary-colors);\n\n$shapes-default-colors: () !default;\n$shapes-default-colors: map-merge((\n  \"step-1-gradient-bg\":         #7795f8,\n  \"step-2-gradient-bg\":         #6772e5,\n  \"step-3-gradient-bg\":         #555abf,\n  \"span-1-bg\":                  #7795f8,\n  \"span-2-bg\":                  #7b9aff,\n  \"span-3-bg\":                  #6f8ff8,\n  \"span-4-bg\":                  #76eea7,\n  \"span-5-bg\":                  #6adaff\n), $shapes-default-colors);\n\n$shapes-light-colors: () !default;\n$shapes-light-colors: map-merge((\n  \"step-1-gradient-bg\":         #b2cbe1,\n  \"step-2-gradient-bg\":         #f6f9fc,\n  \"step-3-gradient-bg\":         #f6f9fc,\n  \"span-1-bg\":                  #b4cce1,\n  \"span-2-bg\":                  #c5dbef,\n  \"span-3-bg\":                  #b9d5ed,\n  \"span-4-bg\":                  #74e4a2,\n  \"span-5-bg\":                  #008169\n), $shapes-light-colors);\n\n$shapes-dark-colors: () !default;\n$shapes-dark-colors: map-merge((\n  \"step-1-gradient-bg\":         #32325d,\n  \"step-2-gradient-bg\":         #32325d,\n  \"step-3-gradient-bg\":         #32325d,\n  \"span-1-bg\":                  #2e2e57,\n  \"span-2-bg\":                  #2b2b58,\n  \"span-3-bg\":                  #25254d,\n  \"span-4-bg\":                  #d782d9,\n  \"span-5-bg\":                  #008169\n), $shapes-dark-colors);\n\n\n// Translucent color variations\n$translucent-color-opacity: .6 !default;\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  200 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Action colors\n\n$star-rating-color: $gray-400 !default;\n$star-rating-color-active: $yellow !default;\n\n$favorite-color: $yellow !default;\n$like-color: $blue !default;\n$love-color: $red !default;\n\n\n// Body\n\n\n$body-bg: #f8f9fe !default;\n$body-color: $gray-700 !default;\n\n\n\n// Sections\n\n$section-colors: () !default;\n$section-colors: map-merge((\n  \"primary\":      $body-bg,\n  \"secondary\":    $secondary,\n  \"light\":        $gray-400,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $section-colors);\n\n// Links\n\n$link-color:                $primary !default;\n$link-decoration:           none !default;\n$link-hover-color:          darken($link-color, 15%) !default;\n$link-hover-decoration:     none !default;\n\n// Grid breakpoints\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n\n\n// Spacing\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge((\n  -9: -($spacer * 10),\n  -8: -($spacer * 8),\n  -7: -($spacer * 6),\n  -6: -($spacer * 4.5),\n  -5: -($spacer * 3),\n  -4: -($spacer * 1.5),\n  -3: -$spacer,\n  -2: -($spacer * .5),\n  -1: -($spacer * .25),\n  0: 0,\n  1: ($spacer * .25),\n  2: ($spacer * .5),\n  3: $spacer,\n  4: ($spacer * 1.5),\n  5: ($spacer * 3),\n  6: ($spacer * 4.5),\n  7: ($spacer * 6),\n  8: ($spacer * 8),\n  9: ($spacer * 10)\n), $spacers);\n\n\n// This variable affects the `.h-*` and `.w-*` classes.\n\n$sizes: () !default;\n$sizes: map-merge((\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n), $sizes);\n\n// Components\n\n$shape-height-xl:              1.5 !default;\n$shape-height-lg:              1.5 !default;\n$shape-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-200 !default;\n\n$border-radius:               .375rem !default;\n$border-radius-xl:            .5rem !default;\n$border-radius-lg:            .4375rem !default;\n$border-radius-sm:            .25rem !default;\n\n$box-shadow-sm:               0 0 .5rem rgba($gray-600, .075) !default;\n$box-shadow:                  0 0 2rem 0 rgba($gray-600, .15) !default;\n$box-shadow-lg:               0 0 3rem rgba($gray-600, .175) !default;\n\n$component-active-color:        $white !default;\n$component-active-bg:           theme-color(\"primary\") !default;\n$component-active-border-color: theme-color(\"primary\") !default;\n\n$component-hover-color:        $gray-300 !default;\n$component-hover-bg:           $gray-300 !default;\n$component-hover-border-color: $gray-300 !default;\n\n$caret-width:                 .3em !default;\n\n$transition-base:             all .15s ease !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n\n// Fonts\n\n$font-family-sans-serif: Open Sans, sans-serif !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-xl:                ($font-size-base * 1.5);\n$font-size-lg:                ($font-size-base * 1.25);\n$font-size-sm:                ($font-size-base * .875);\n$font-size-xs:                ($font-size-base * .75);\n\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            600 !default;\n$font-weight-extra-bold:      700 !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n$shape-height-base:           1.5 !default;\n\n\n$h1-font-size:                $font-size-base * 1.625 !default;\n$h2-font-size:                $font-size-base * 1.25 !default;\n$h3-font-size:                $font-size-base * 1.0625 !default;\n$h4-font-size:                $font-size-base * .9375 !default;\n$h5-font-size:                $font-size-base * .8125 !default;\n$h6-font-size:                $font-size-base * .625 !default;\n\n\n$headings-margin-bottom:      ($spacer / 2);\n$headings-font-family:        inherit !default;\n$headings-font-weight:        $font-weight-bold !default;\n$headings-line-height:        1.5 !default;\n$headings-color:              $gray-800 !default;\n\n$heading-letter-spacing:      .025em !default;\n$heading-font-size:           .95rem !default;\n$heading-text-transform:      uppercase !default;\n$heading-font-weight:         $headings-font-weight !default;\n\n$heading-title-letter-spacing:      .025em !default;\n$heading-title-font-size:           1.375rem !default;\n$heading-title-font-weight:         $font-weight-bold !default;\n$heading-title-text-transform:      uppercase !default;\n\n$heading-section-letter-spacing:      .025em !default;\n$heading-section-font-size:           1.375rem !default;\n$heading-section-font-weight:         $font-weight-bold !default;\n$heading-section-text-transform:      uppercase !default;\n\n$display1-size:               3.3rem !default;\n$display2-size:               2.75rem !default;\n$display3-size:               2.1875rem !default;\n$display4-size:               1.6275rem !default;\n\n$display1-weight:             $font-weight-bold !default;\n$display2-weight:             $font-weight-bold !default;\n$display3-weight:             $font-weight-bold !default;\n$display4-weight:             $font-weight-bold !default;\n$display-line-height:         $headings-line-height !default;\n\n$paragraph-font-size:         1rem !default;\n$paragraph-font-weight:       300 !default;\n$paragraph-line-height:       1.7 !default;\n\n$lead-font-size:              ($paragraph-font-size * 1.25) !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-font-size:        ($font-size-base * 1.25) !default;\n\n$hr-border-color:             rgba($black, .1);\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer * 2 !default;\n\n\n// Icons\n\n$icon-size: 3rem !default;\n$icon-size-xl: 5rem !default;\n$icon-size-lg: 4rem !default;\n$icon-size-sm: 2rem !default;\n\n\n// Tables\n\n$table-cell-padding:          1rem !default;\n$table-cell-padding-sm:       .5rem !default;\n\n$table-bg:                    transparent !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-bg:              $gray-100 !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $gray-200 !default;\n\n$table-head-bg:               $gray-100 !default;\n$table-head-color:            $gray-600 !default;\n$table-head-spacer-y:         .75rem !default;\n\n$table-head-font-size:        .65rem !default;\n$table-head-font-weight:      $font-weight-bold !default;\n$table-head-text-transform:   uppercase !default;\n$table-head-letter-spacing:   1px !default;\n\n$table-body-font-size:        .8125rem !default;\n\n$table-dark-bg:               theme-color(\"default\") !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten(theme-color(\"default\"), 7%) !default;\n$table-dark-color:            $body-bg !default;\n\n$table-dark-head-bg:          lighten(theme-color(\"default\"), 4%) !default;\n$table-dark-head-color:       lighten(theme-color(\"default\"), 35%) !default;\n\n// Buttons + Forms\n\n$input-btn-padding-y:         .625rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-line-height:       $shape-height-base !default;\n\n$input-btn-focus-width:       0 !default;\n$input-btn-focus-color:       rgba($component-active-bg, 1) !default;\n$input-btn-focus-box-shadow:  none !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-line-height-sm:    $shape-height-sm !default;\n\n$input-btn-padding-y-lg:      .875rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-line-height-lg:    $shape-height-lg !default;\n\n$input-btn-border-width:      1px !default;\n\n$input-btn-font-size-sm:      .75rem !default;\n$input-btn-font-size:         .875rem !default;\n$input-btn-font-size-lg:         .875rem !default;\n\n// Buttons\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x + 0.5 !default;\n$btn-line-height:             $input-btn-line-height !default;\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             600 !default;\n\n$btn-text-transform:          none !default;\n\n\n$btn-letter-spacing:          .025em !default;\n$btn-box-shadow:              0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08) !default;\n$btn-hover-box-shadow:        0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08) !default;\n$btn-focus-box-shadow:        $btn-hover-box-shadow !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-active-box-shadow:       none !default;\n\n$btn-hover-translate-y:       -1px !default;\n\n// Forms\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-xl:                $border-radius-xl !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-muted-bg:                        #F7FAFE !default;\n$input-focus-muted-bg:                  lighten($input-muted-bg, 1%) !default;\n\n$input-alternative-box-shadow:          0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02) !default;\n$input-focus-alternative-box-shadow:    0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08) !default;\n\n$input-color:                           $gray-600 !default;\n$input-border-color:                    #cad1d7 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      none !default; // 0 1px 3px 0 $gray-400 !default;\n\n$input-focus-bg:                        $white !default;\n$input-focus-border-color:              rgba(50,151,211,.25) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     0 !default;\n$input-focus-box-shadow:                none !default; //0 1px 3px 0 $gray-500 !default;\n\n$input-placeholder-color:               $gray-500 !default;\n$input-focus-placeholder-color:         $gray-500 !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-transition:                      all .2s cubic-bezier(0.68, -0.55, 0.265, 1.55) !default;\n\n\n// Input groups\n\n$input-group-addon-color:               $input-placeholder-color !default;\n$input-group-addon-bg:                  $input-bg !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$input-group-addon-focus-color:               $input-focus-color !default;\n$input-group-addon-focus-bg:                  $input-focus-bg !default;\n$input-group-addon-focus-border-color:        $input-focus-border-color !default;\n\n\n// Form group\n\n$form-group-margin-bottom:              1.5rem !default;\n\n\n// Custom forms\n\n$custom-control-gutter:                 1.75rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-indicator-size:         1.25rem !default;\n\n$custom-control-indicator-bg:                   $input-bg !default;\n$custom-control-indicator-border-width:         1px !default;\n$custom-control-indicator-border-color:         $input-border-color !default;\n$custom-control-indicator-box-shadow:           none !default;\n\n$custom-control-indicator-focus-box-shadow:     $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-hover-color:         $component-hover-color !default;\n$custom-control-indicator-hover-bg:            $component-hover-bg !default;\n$custom-control-indicator-hover-border-color:  $component-hover-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            $component-active-bg !default;\n$custom-control-indicator-active-border-color:  $component-active-border-color !default;\n$custom-control-indicator-active-box-shadow:    $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\n$custom-control-indicator-checked-box-shadow:   $custom-control-indicator-box-shadow !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius-sm !default;\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n// Custom toggle\n\n$custom-toggle-width:           50px !default;\n$custom-toggle-slider-bg:       $gray-200 !default;\n$custom-toggle-checked-bg:      theme-color(\"primary\") !default;\n\n// Form validation\n\n$form-feedback-valid-bg:         lighten($success, 15%) !default;\n$form-feedback-valid-color:      theme-color(\"success\") !default;\n$form-feedback-invalid-bg:       lighten($warning, 15%) !default;\n$form-feedback-invalid-color:    theme-color(\"warning\") !default;\n\n\n// Allows for customizing button radius independently from global border radius\n\n$btn-border-radius:           $input-border-radius !default;\n$btn-border-radius-xl:        $input-border-radius-xl !default;\n$btn-border-radius-lg:        $input-border-radius-lg !default;\n$btn-border-radius-sm:        $input-border-radius !default;\n\n\n\n$chart-height: 350px !default;\n$chart-height-sm: 230px !default;\n\n$chart-legend-margin-top: 2.5rem !default;\n$chart-legend-font-size: $font-size-sm !default;\n$chart-legend-color: $text-muted !default;\n$chart-legend-height: $chart-legend-margin-top + $chart-legend-font-size * $line-height-base !default;\n\n\n\n\n// Map\n$map-height: 500px !default;\n\n\n// No UI Slider\n\n$noui-target-bg:                  #eceeef !default;\n$noui-target-thickness:           5px !default;\n$noui-target-border-radius:       5px !default;\n$noui-target-border-color:        0 !default;\n$noui-target-box-shadow:          inset 0 1px 2px rgba(90,97,105,.1) !default;\n\n$noui-slider-connect-bg:          $primary !default;\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\n\n$noui-handle-width:               15px !default;\n$noui-handle-bg:                  theme-color(\"primary\") !default;\n$noui-handle-border:              0 !default;\n$noui-handle-border-radius:       100% !default;\n\n$noui-origin-border-radius:       2px !default;\n\n\n// Dropdown\n\n$dropdown-bg:                    $white !default;\n$dropdown-border-width:          0 !default;\n$dropdown-border-color:          rgba($black, .15) !default;\n$dropdown-border-radius:         $border-radius-lg !default;\n$dropdown-box-shadow:            0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1) !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .25rem !default;\n$nav-link-padding-x:                .75rem !default;\n$nav-link-color:                    $gray-700 !default;\n$nav-link-hover-color:              theme-color(\"primary\") !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-pills-padding-y:               .75rem !default;\n$nav-pills-padding-x:               1rem !default;\n\n$nav-pills-space-x:                 1rem !default;\n\n$nav-pills-bg:                      $white !default;\n$nav-pills-border-width:            1px !default;\n$nav-pills-border-color:            theme-color(\"primary\") !default;\n$nav-pills-border-radius:           $border-radius !default;\n\n$nav-pills-link-color:              theme-color(\"primary\") !default;\n$nav-pills-link-hover-color:        darken(theme-color(\"primary\"), 5%) !default;\n$nav-pills-link-active-color:       color-yiq(theme-color(\"primary\")) !default;\n$nav-pills-link-active-bg:          theme-color(\"primary\") !default;\n$nav-pills-box-shadow:              $btn-box-shadow !default;\n\n// Navbar\n\n$navbar-transition:                 all .15s linear !default;\n$navbar-padding-y:                  1rem !default;\n$navbar-padding-x:                  1rem !default;\n\n$navbar-nav-link-padding-x:         1rem !default;\n$navbar-nav-link-padding-y:         1rem !default;\n\n$navbar-nav-link-font-size:         .9rem !default;\n$navbar-nav-link-font-weight:       400 !default;\n$navbar-nav-link-text-transform:    normal !default;\n$navbar-nav-link-letter-spacing:    0 !default;\n$navbar-nav-link-border-radius:     $border-radius !default;\n\n$navbar-search-width:               270px !default;\n$navbar-search-bg:                  transparent !default;\n\n$navbar-search-border-radius:       2rem !default;\n$navbar-search-border-width:        2px !default;\n\n$navbar-dark-bg:                    transparent !default;\n$navbar-dark-hover-bg:              rgba(255, 255, 255, .1) !default;\n$navbar-dark-active-bg:             rgba(255, 255, 255, .1) !default;\n$navbar-dark-color:                 rgba($white, .95) !default;\n$navbar-dark-hover-color:           rgba($white, .65) !default;\n$navbar-dark-active-color:          rgba($white, .65) !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-border-color:  transparent !default;\n\n$navbar-search-dark-border-color:   rgba(255, 255, 255, .6) !default;\n$navbar-search-dark-color:          rgba(255, 255, 255, .6) !default;\n$navbar-search-dark-focus-border-color: rgba(255, 255, 255, .9) !default;\n$navbar-search-dark-focus-color:    rgba(255, 255, 255, .9) !default;\n\n$navbar-light-bg:                   transparent !default;\n$navbar-light-hover-bg:             rgba(0, 0, 0, .1) !default;\n$navbar-light-active-bg:            rgba(0, 0, 0, .1) !default;\n$navbar-light-border-color:         $gray-100 !default;\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-border-color: transparent !default;\n\n$navbar-search-light-border-color:  rgba(0, 0, 0, .6) !default;\n$navbar-search-light-color:          rgba(0, 0, 0, .6) !default;\n$navbar-search-light-focus-border-color: rgba(0, 0, 0, .9) !default;\n$navbar-search-light-focus-color:    rgba(0, 0, 0, .9) !default;\n\n\n\n// Vertical navbar\n$navbar-vertical-box-shadow: 0 0 2rem 0 rgba(136, 152, 170, .15) !important;\n$navbar-vertical-width: 250px !default;\n$navbar-vertical-padding-x: 1.5rem !default;\n$navbar-vertical-nav-link-padding-x:  1.5rem !default;\n$navbar-vertical-nav-link-padding-y:  .65rem !default;\n\n$navbar-icon-min-width: 2.25rem !default;\n\n$navbar-breadcrumb-padding-y: $nav-link-padding-y !default;\n$navbar-breadcrumb-padding-x: 0 !default;\n\n$navbar-light-bg: $white !default;\n$navbar-light-border-color: $border-color !default;\n\n\n\n\n// Main content\n\n$main-content-padding-y: 40px !default;\n$main-content-padding-x: 24px !default; // in px to combine with $grid-gutter-width\n\n\n// Alerts\n\n$alert-padding-y: 1rem !default;\n$alert-padding-x: 1.5rem !default;\n$alert-border-radius: $border-radius !default;\n\n$alert-bg-level: -2 !default;\n$alert-border-level: -2 !default;\n$alert-color-level: 0 !default;\n\n\n// List group\n\n$list-group-bg:                     $white !default;\n$list-group-border-color:           $border-color !default; //rgba($black, .125);\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         1rem !default;\n$list-group-item-padding-x:         1rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $list-group-action-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-bg:                          transparent !default;\n$close-hover-bg:                    transparent !default;\n$close-color:                       rgba(0, 0, 0, .6) !default !default;\n$close-hover-color:                 rgba(0, 0, 0, .9) !default;\n$close-text-shadow:                 none !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              1px !default;\n$popover-border-color:              rgba($black, .05) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0px .5rem 2rem 0px rgba($black, .2) !default;\n\n$popover-header-bg:                 $popover-bg !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .95rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1.5rem !default;\n$popover-arrow-height:              .75rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         transparent !default;\n\n\n// Badges\n\n$badge-font-size:                   66% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .35rem !default;\n$badge-padding-x:                   .375rem !default;\n$badge-border-radius:               $border-radius !default;\n$badge-text-transfom:               uppercase;\n\n$badge-pill-padding-x:              .875em !default;\n$badge-pill-border-radius:          10rem !default;\n\n$badge-circle-size:                 2rem !default;\n\n// Pagination\n\n// $pagination-padding-y:              .5rem !default;\n// $pagination-padding-x:              .75rem !default;\n// $pagination-padding-y-sm:           .25rem !default;\n// $pagination-padding-x-sm:           .5rem !default;\n// $pagination-padding-y-lg:           .75rem !default;\n// $pagination-padding-x-lg:           1.5rem !default;\n// $pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $gray-600 !default;\n$pagination-bg:                     $white  !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\n\n$pagination-hover-color:            $gray-600 !default;\n$pagination-hover-bg:               $gray-300 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n$pagination-active-box-shadow:      $btn-hover-box-shadow !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Cards\n\n$card-spacer-y:                     1.25rem !default;\n$card-spacer-x:                     1.5rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .05) !default;\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\n$card-cap-bg:                       $white !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n//$card-group-margin:                 ($grid-gutter-width / 2);\n//$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n\n// Modals\n\n$modal-inner-padding:               1.5rem !default;\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          380px !default;\n\n$modal-title-line-height:           1.1;\n\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        0 !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-box-shadow-xs:       0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n$modal-content-box-shadow-sm-up:    0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n\n$modal-backdrop-bg:           $black !default;\n$modal-backdrop-opacity:      .16 !default;\n$modal-header-border-color:   $gray-200 !default;\n$modal-footer-border-color:   $modal-header-border-color !default;\n$modal-header-border-width:   $modal-content-border-width !default;\n$modal-footer-border-width:   $modal-header-border-width !default;\n$modal-header-padding:        1.25rem !default;\n\n// Datepicker\n\n$datepicker-border-radius: $card-border-radius !default;\n$datepicker-dropdown-padding: 20px 22px !default;\n\n$datepicker-cell-transition: $transition-base !default;\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\n$datepicker-cell-border-radius: 50% !default;\n$datepicker-cell-width: 36px !default;\n$datepicker-cell-height: 36px !default;\n\n$datepicker-disabled-cell-color: $gray-300 !default;\n$datepicker-disabled-old-new-color: $gray-500 !default;\n\n$datepicker-header-cell-border-radius: $border-radius !default;\n\n$datepicker-active-color: $white !default;\n$datepicker-active-background: theme-color(\"primary\") !default;\n$datepicker-active-box-shadow:      none !default;\n\n$datepicker-range-background: theme-color(\"primary\") !default;\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\n$datepicker-range-color: $white !default;\n$datepicker-range-highlighted-bg: $gray-200 !default;\n\n$datepicker-dropdown-border: lighten($gray-400, 40%);\n$datepicker-dropdown-bg: $white !default;\n$datepicker-highlighted-bg: $datepicker-active-background !default;\n\n\n// Footer\n\n\n$footer-padding-y:              2.5rem;\n$footer-padding-x:              0;\n\n\n$footer-link-font-size: .85rem !default;\n$footer-bg: theme-color(\"secondary\") !default;\n$footer-color: $gray-600 !default;\n$footer-link-color: $gray-600 !default;\n$footer-link-hover-color: $gray-700 !default;\n$footer-heading-color: $gray-600 !default;\n$footer-heading-font-size: $font-size-sm !default;\n\n// Import Bootstrap variable defaults\n\n@import \"~bootstrap/scss/variables\";\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @if (length($shadow) == 1) {\n      // We can pass `@include box-shadow(none);`\n      $result: $shadow;\n    } @else {\n      // Filter to avoid invalid properties for example `box-shadow: none, 1px 1px black;`\n      @for $i from 1 through length($shadow) {\n        @if nth($shadow, $i) != \"none\" {\n          $result: append($result, nth($shadow, $i), \"comma\");\n        }\n      }\n    }\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@mixin form-control-focus($ignore-warning) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    font-size: $form-feedback-font-size;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1;\n    color: #fff;\n    background-color: rgba($color, .8);\n    border-radius: .2rem;\n  }\n\n  .form-control,\n  .custom-select {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      &:focus {\n        border-color: $color;\n        //box-shadow: 0 1px $input-focus-width 0 rgba($color, .75);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-check-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          background-color: lighten($color, 25%);\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          @include gradient-bg(lighten($color, 10%));\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-file-label {\n        border-color: $color;\n\n        &::before { border-color: inherit; }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n    @include box-shadow($btn-box-shadow);\n\n    @include hover {\n        color: color-yiq($hover-background);\n        @include gradient-bg($hover-background);\n        border-color: $hover-border;\n    }\n\n    &:focus,\n    &.focus {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        @if $enable-shadows {\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n        @else {\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n    } // Disabled comes first so active can properly restyle\n    &.disabled,\n    &:disabled {\n        color: color-yiq($background);\n        background-color: $background;\n        border-color: $border;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        @if $enable-gradients {\n            background-image: none; // Remove the gradient for the pressed/active state\n        }\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n        }\n    }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n    color: $color;\n    background-color: transparent;\n    background-image: none;\n    border-color: $color;\n\n    &:hover {\n        color: $color-hover;\n        background-color: $active-background;\n        border-color: $active-border;\n    }\n\n    &:focus,\n    &.focus {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n    }\n\n    &.disabled,\n    &:disabled {\n        color: $color;\n        background-color: transparent;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows and $btn-active-box-shadow !=none {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n        }\n    }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n    padding: $padding-y $padding-x;\n    font-size: $font-size;\n    line-height: $line-height; // Manually declare to provide an override to the browser default\n    @if $enable-rounded {\n        border-radius: $border-radius;\n    }\n    @else {\n        border-radius: 0;\n    }\n}",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n\tcolor: saturate(darken($bg, 10%), 10);\n    background-color: transparentize(lighten($bg, 25%), .5);\n\n  \t&[href] {\n\t    @include hover-focus {\n\t        color: color-yiq($bg);\n\t        text-decoration: none;\n\t        background-color: darken($bg, 10%);\n\t    }\n\t}\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n\n    hr {\n        border-top-color: darken($border, 5%);\n    }\n\n    .alert-link {\n        color: darken($color, 10%);\n    }\n}","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// Contextual backgrounds\n@mixin bg-variant($parent, $color, $ignore-warning: true) {\n    #{$parent} {\n        background-color: $color !important;\n        background-image: url(../../../../img/brand/background-oillusion.png);\n    }\n    a#{$parent},\n    button#{$parent} {\n        @include hover-focus {\n            background-color: darken($color, 10%) !important;\n        }\n    }\n}\n\n@mixin bg-gradient-variant($parent, $color) {\n    #{$parent} {\n        background: linear-gradient(87deg, $color 0, adjust-hue($color, 25%) 100%) !important;\n    }\n}\n\n@mixin bg-translucent-variant($parent, $color) {\n    #{$parent} {\n        background-color: darken(rgba($color, $translucent-color-opacity), 7%) !important;\n    }\n    a#{$parent},\n    button#{$parent} {\n        @include hover-focus {\n            background-color: darken(rgba($color, $translucent-color-opacity), 12%) !important;\n        }\n    }\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","iframe {\n    border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n    display: block;\n}\n\nmain {\n    overflow: hidden;\n}\n","//\n// Backgrounds\n//\n\n\n@each $color, $value in $colors {\n\t@include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n@each $color, $value in $colors {\n\t@include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n\n// Background colors with transparency\n\n@each $color, $value in $theme-colors {\n    @include bg-translucent-variant(\".bg-translucent-#{$color}\", $value);\n}\n\n\n// Sections backgrounds\n\n@each $color, $value in $section-colors {\n    @include bg-variant(\".section-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n\n// Shape (svg) fill colors\n\n@each $color, $value in $theme-colors {\n    .fill-#{$color}  {\n        fill: $value;\n    }\n\n    .stroke-#{$color}  {\n        stroke: $value;\n    }\n}\n\n.fill-opacity-8 {\n\tfill-opacity: .8;\n}\n","//\n// Floating\n// floating animation utility class\n//\n\n\n.floating {\n\tanimation: floating 3s ease infinite;\n\twill-change: transform;\n\n\t&:hover {\n        animation-play-state: paused;\n    }\n}\n\n\n// Size variations\n\n.floating-lg {\n\tanimation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n\tanimation: floating-sm 3s ease infinite;\n}\n\n\n// Keyframes\n\n@keyframes floating-lg {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(15px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(10px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n\n@keyframes floating-sm {\n    0% {\n        transform: translateY(0px)\n    }\n    50% {\n        transform: translateY(5px)\n    }\n    100% {\n        transform: translateY(0px)\n    }\n}\n","//\n// Helper\n// helper classes for different cases\n//\n\n\n// Clearfix for sections that use float property\n\n.floatfix {\n    &:before,\n    &:after {\n        content: '';\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n}\n","//\n// Image\n//\n\n.img-center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n","//\n// Opacity\n// modify the transparency of an element with this quick modifier classes\n//\n\n.opacity-1 {\n    opacity: .1 !important;\n}\n.opacity-2 {\n    opacity: .2 !important;\n}\n.opacity-3 {\n    opacity: .3 !important;\n}\n.opacity-4 {\n    opacity: .4 !important;\n}\n.opacity-5 {\n    opacity: .5 !important;\n}\n.opacity-6 {\n    opacity: .6 !important;\n}\n.opacity-7 {\n    opacity: .7 !important;\n}\n.opacity-8 {\n    opacity: .8 !important;\n}\n.opacity-8 {\n    opacity: .9 !important;\n}\n.opacity-10 {\n    opacity: 1 !important;\n}\n","//\n// Overflow\n//\n\n.overflow-visible {\n    overflow: visible !important;\n}\n\n.overflow-hidden {\n    overflow: hidden !important;\n}\n","//\n// Position\n// modifier classes to be applied on an abosolute positioned element\n// use it next to .position-absolute class\n//\n\n@each $size, $value in $spacers {\n\t.top-#{$size} {\n\t\ttop: $value;\n\t}\n\t.right-#{$size} {\n\t\tright: $value;\n\t}\n\t.bottom-#{$size} {\n\t\tbottom: $value;\n\t}\n\t.left-#{$size} {\n\t\tleft: $value;\n\t}\n}\n\n.center {\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n","//\n// Height\n//\n\n.h-100vh {\n\theight: 100vh !important;\n}\n","//\n// Spacing\n//\n\n.row.row-grid > [class*=\"col-\"] + [class*=\"col-\"] {\n    margin-top: 3rem;\n}\n\n@include media-breakpoint-up(lg) {\n    .row.row-grid > [class*=\"col-lg-\"] + [class*=\"col-lg-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(md) {\n    .row.row-grid > [class*=\"col-md-\"] + [class*=\"col-md-\"] {\n        margin-top: 0;\n    }\n}\n@include media-breakpoint-up(sm) {\n    .row.row-grid > [class*=\"col-sm-\"] + [class*=\"col-sm-\"] {\n        margin-top: 0;\n    }\n}\n\n.row-grid + .row-grid {\n    margin-top: 3rem;\n}\n\n\n// Negative margins and paddings\n\n@media(min-width: 992px) {\n    [class*=\"mt--\"],\n    [class*=\"mr--\"],\n    [class*=\"mb--\"],\n    [class*=\"ml--\"] {\n        \n    }\n\n\n    // Large negative margins in pixels\n\n    .mt--100 {\n        margin-top: -100px !important;\n    }\n    .mr--100 {\n        margin-right: -100px !important;\n    }\n    .mb--100 {\n        margin-bottom: -100px !important;\n    }\n    .ml--100 {\n        margin-left: -100px !important;\n    }\n    .mt--150 {\n        margin-top: -150px !important;\n    }\n    .mb--150 {\n        margin-bottom: -150px !important;\n    }\n    .mt--200 {\n        margin-top: -200px !important;\n    }\n    .mb--200 {\n        margin-bottom: -200px !important;\n    }\n    .mt--300 {\n        margin-top: -300px !important;\n    }\n    .mb--300 {\n        margin-bottom: -300px !important;\n    }\n\n\n    // Large margins in pixels\n\n    .pt-100 {\n        padding-top: 100px !important;\n    }\n    .pb-100 {\n        padding-bottom: 100px !important;\n    }\n    .pt-150 {\n        padding-top: 150px !important;\n    }\n    .pb-150 {\n        padding-bottom: 150px !important;\n    }\n    .pt-200 {\n        padding-top: 200px !important;\n    }\n    .pb-200 {\n        padding-bottom: 200px !important;\n    }\n    .pt-250 {\n        padding-top: 250px !important;\n    }\n    .pb-250 {\n        padding-bottom: 250px !important;\n    }\n    .pt-300 {\n        padding-top: 300px!important;\n    }\n    .pb-300 {\n        padding-bottom: 300px!important;\n    }\n}\n","//\n// Shadows\n//\n\n// General styles\n[class*=\"shadow\"] {\n\t@if $enable-transitions {\n        transition: $transition-base;\n    }\n}\n\n\n// Size variations\n.shadow-sm--hover:hover {\n\tbox-shadow: $box-shadow-sm !important;\n}\n\n.shadow--hover:hover {\n\tbox-shadow: $box-shadow !important;\n}\n\n.shadow-lg--hover:hover {\n\tbox-shadow: $box-shadow-lg !important;\n}\n\n.shadow-none--hover:hover {\n\tbox-shadow: none !important;\n}\n","// Weight and italics\n\n.font-weight-300 { font-weight: 300 !important; }\n.font-weight-400 { font-weight: 400 !important; }\n.font-weight-500 { font-weight: 500 !important; }\n.font-weight-600 { font-weight: 600 !important; }\n.font-weight-700 { font-weight: 700 !important; }\n.font-weight-800 { font-weight: 800 !important; }\n.font-weight-900 { font-weight: 900 !important; }\n\n\n// Text decorations\n\n.text-underline { text-decoration: underline; }\n.text-through { text-decoration: line-through; }\n\n\n// Text size\n\n.text-xs { font-size: $font-size-xs !important; }\n.text-sm { font-size: $font-size-sm !important; }\n.text-lg { font-size: $font-size-lg !important; }\n.text-xl { font-size: $font-size-xl !important; }\n\n\n// Line heights\n\n.lh-100 { line-height: 1; }\n.lh-110 { line-height: 1.1; }\n.lh-120 { line-height: 1.2; }\n.lh-130 { line-height: 1.3; }\n.lh-140 { line-height: 1.4; }\n.lh-150 { line-height: 1.5; }\n.lh-160 { line-height: 1.6; }\n.lh-170 { line-height: 1.7; }\n.lh-180 { line-height: 1.8; }\n\n\n// Letter spacings\n\n.ls-1 { letter-spacing: .0625rem; }\n.ls-15 { letter-spacing: .09375rem; }\n.ls-2 { letter-spacing: 0.125rem; }\n\n// Color variations\n\n@each $color, $value in $colors {\n\t@include text-emphasis-variant(\".text-#{$color}\", $value, $ignore-warning: true);\n}\n","//\n// Tranform\n//\n\n\n@include media-breakpoint-up(lg) {\n\t.transform-perspective-right {\n\t\ttransform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\n\t}\n\t.transform-perspective-left{\n\t\ttransform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg)\n\t}\n}\n","//\n// Alert\n//\n\n.alert {\n    font-size: $font-size-sm;\n}\n\n// Alert heading\n\n.alert-heading {\n    font-weight: $font-weight-bold;\n    font-size: $h4-font-size;\n    margin-top: .15rem;\n}\n\n\n// Alert icon\n.alert-icon {\n    font-size: 1.25rem;\n    margin-right: 1.25rem;\n    display: inline-block;\n    vertical-align: middle;\n\n    i.ni {\n        position: relative;\n        top: 1px;\n    }\n}\n\n\n// Alert text next to an alert icon\n.alert-text {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n\n// Alert links\n\n[class*=\"alert-\"] {\n    .alert-link {\n        color: $white;\n        border-bottom: 1px dotted rgba($white, .5);\n    }\n}\n","//\n// Dismissible alert\n//\n\n.alert-dismissible {\n    .close {\n        top: 50%;\n        right: $alert-padding-x;\n        padding: 0;\n        transform: translateY(-50%);\n        color: rgba($white, .6);\n        opacity: 1;\n\n        &:hover,\n        &:focus {\n            color: rgba($white, .9);\n            opacity: 1 !important;\n        }\n\n        @include media-breakpoint-down(xs) {\n            top: 1rem;\n            right: .5rem;\n        }\n\n        &>span:not(.sr-only) {\n            font-size: 1.5rem;\n            background-color: transparent;\n            color: rgba($white, .6);\n        }\n\n        &:hover,\n        &:focus {\n            &>span:not(.sr-only) {\n                background-color: transparent;\n                color: rgba($white, .9);\n            }\n        }\n    }\n}\n","//\n// Avatar\n//\n\n// General styles\n\n.avatar {\n\tcolor: $white;\n\tbackground-color: $gray-500;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 1rem;\n\tborder-radius: 50%;\n\theight: 48px;\n\twidth: 48px;\n\n    img {\n    \twidth: 100%;\n    \tborder-radius: 50%;\n    }\n\n    + .avatar-content {\n    \tdisplay: inline-block;\n    \tmargin-left: .75rem;\n    }\n}\n\n\n// Avatar size variations\n\n.avatar-lg {\n\twidth: 58px;\n\theight: 58px;\n\tfont-size: $font-size-sm;\n}\n\n.avatar-sm {\n\twidth: 36px;\n\theight: 36px;\n\tfont-size: $font-size-sm;\n}\n","//\n// Avatar group\n//\n\n// General styles\n\n.avatar-group {\n\t.avatar {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\tborder: 2px solid $card-bg;\n\n\t\t&:hover {\n\t\t\tz-index: 3;\n\t\t}\n\t}\n\n\t.avatar + .avatar {\n\t\tmargin-left: -1rem;\n\n\t}\n}\n","//\n// Badge\n//\n\n\n// General styles\n\n.badge {\n    text-transform: $badge-text-transfom;\n\n    a {\n        color: $white;\n    }\n}\n\n\n// Size variations\n\n.badge-md {\n    padding: .65em 1em;\n}\n\n.badge-lg {\n    padding: .85em 1.375em;\n}\n\n\n// Multiple inline badges\n\n.badge-inline {\n    margin-right: .625rem;\n\n    + span {\n        top: 2px;\n        position: relative;\n\n        > a {\n            text-decoration: underline;\n        }\n    }\n}\n\n\n// Badge spacing inside a btn with some text\n\n.btn {\n    .badge {\n        &:not(:first-child) {\n            margin-left: .5rem;\n        }\n        &:not(:last-child) {\n            margin-right: .5rem;\n        }\n    }\n}\n","//\n// Circle badge\n//\n\n\n// General styles\n\n.badge-circle {\n    text-align: center;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    width: 2rem;\n    height: 2rem;\n    font-size: .875rem;\n}\n","//\n// Dot badge\n//\n\n\n// General styles\n\n.badge-dot {\n    padding-left: 0;\n    padding-right: 0;\n    background: transparent;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-sm;\n    text-transform: none;\n\n    strong {\n        color: $gray-800;\n    }\n\n    i {\n        display: inline-block;\n        vertical-align: middle;\n        width: .375rem;\n        height: .375rem;\n        border-radius: 50%;\n        margin-right: .375rem;\n    }\n\n    &.badge-md {\n        i {\n            width: .5rem;\n            height: .5rem;\n        }\n    }\n\n    &.badge-lg {\n        i {\n            width: .625rem;\n            height: .625rem;\n        }\n    }\n}\n","//\n// Icon buttons\n//\n\n// General styles\n\n.btn {\n   position: relative;\n   text-transform: $btn-text-transform;\n   transition: $transition-base;\n   letter-spacing: $btn-letter-spacing;\n   font-size: $input-btn-font-size;\n   will-change: transform;\n\n   &:hover {\n      @include box-shadow($btn-hover-box-shadow);\n      transform: translateY($btn-hover-translate-y);\n   }\n\n   &:not(:last-child) {\n      margin-right: .5rem;\n   }\n\n\n   // Icons\n\n   i:not(:first-child),\n   svg:not(:first-child) {\n      margin-left: .5rem;\n   }\n\n   i:not(:last-child),\n   svg:not(:last-child) {\n      margin-right: .5rem;\n   }\n}\n\n\n// Remove translateY and margin animation when btn is included in a btn-group or input-group\n\n.btn-group,\n.input-group {\n   .btn {\n      margin-right: 0;\n      transform: translateY(0);\n   }\n}\n\n\n// Size variations\n\n.btn-sm {\n   font-size: $input-btn-font-size-sm;\n}\n\n.btn-lg {\n   font-size: $input-btn-font-size-lg;\n}\n\n\n// Some quick fixes (to revise)\n\n// Fixes\n[class*=\"btn-outline-\"] {\n   border-width: 1px;\n}\n\n.btn-outline-secondary {\n   color: darken(theme-color(\"secondary\"), 50%);\n}\n\n.btn-inner--icon {\n   i:not(.fa) {\n      position: relative;\n      top: 2px;\n   }\n}\n\n.btn-link {\n   font-weight: $btn-font-weight;\n   box-shadow: none;\n\n   &:hover {\n      box-shadow: none;\n      transform: none;\n   }\n}\n\n.btn-neutral {\n   color: theme-color(\"primary\");\n}\n","//\n// Icon buttons\n//\n\n.btn-icon {\n    .btn-inner--icon {\n        img {\n            width: 20px;\n        }\n   }\n\n   .btn-inner--text:not(:first-child) {\n       margin-left: 0.75em;\n   }\n\n   .btn-inner--text:not(:last-child) {\n       margin-right: 0.75em;\n   }\n}\n\n\n// Button only with icon and NO text\n\n.btn-icon-only {\n    width: 2.375rem;\n    height: 2.375rem;\n    padding: 0;\n}\n\na.btn-icon-only {\n    line-height: 2.5;\n}\n\n.btn-icon-only.btn-sm {\n    width: 2rem;\n    height: 2rem;\n}\n\n\n//\n// Clipboard button\n// dedicated element for copying icons\n//\n\n.btn-icon-clipboard {\n    margin: 0;\n    padding: 1.5rem;\n    font-size: $font-size-base;\n    font-weight: $font-weight-normal;\n    line-height: 1.25;\n    color: $gray-800;\n    background-color: $gray-100;\n    border-radius: $border-radius;\n    border: 0;\n    text-align: left;\n    font-family: inherit;\n    display: inline-block;\n    vertical-align: middle;\n    text-decoration: none;\n    -moz-appearance: none;\n    cursor: pointer;\n    width: 100%;\n    margin: .5rem 0;\n\n    &:hover {\n        background-color: $white;\n        box-shadow: rgba(0, 0, 0, .1) 0 0 0 1px, rgba(0, 0, 0, .1) 0 4px 16px;\n    }\n\n    > div {\n        align-items: center;\n        display: flex;\n    }\n\n    i {\n        box-sizing: content-box;\n        color: theme-color(\"primary\");\n        vertical-align: middle;\n        font-size: 1.5rem;\n    }\n\n    span {\n        display: inline-block;\n        font-size: 0.875rem;\n        line-height: 1.5;\n        margin-left: 16px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        vertical-align: middle;\n    }\n}\n","//\n// Brand buttons\n//\n\n\n// Color variations\n\n@each $color, $value in $brand-colors {\n    .btn-#{$color} {\n        @include button-variant($value, $value);\n    }\n}\n","//\n// Card\n//\n\n\n.card-translucent {\n    background-color: rgba(18, 91, 152, 0.08);\n}\n","//\n// Profile card\n//\n\n.card-profile-image {\n    position: relative;\n\n    img {\n        max-width: 180px;\n        border-radius: $border-radius;\n        @extend .shadow;\n        transform: translate(-50%,-30%);\n        position: absolute;\n        left: 50%;\n        transition: $transition-base;\n\n        &:hover {\n            transform: translate(-50%, -33%);\n        }\n    }\n}\n\n.card-profile-stats {\n    padding: 1rem 0;\n\n    > div {\n        text-align: center;\n        margin-right: 1rem;\n        padding: .875rem;\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        .heading {\n            font-size: 1.1rem;\n            font-weight: bold;\n            display: block;\n        }\n        .description {\n            font-size: .875rem;\n            color: $gray-500;\n        }\n    }\n}\n\n.card-profile-actions {\n    padding: .875rem;\n}\n","//\n// Card with hover animations\n//\n\n.card-lift--hover {\n    &:hover {\n        transform: translateY(-20px);\n        @include transition($transition-base);\n    }\n}\n","//\n// Card stats\n//\n\n.card-stats {\n    .card-body {\n        padding: 1rem 1.5rem;\n    }\n\n    .card-status-bullet {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%, -50%);\n    }\n}\n","//\n// Chart\n//\n\n.chart {\n    position: relative;\n    height: $chart-height;\n}\n\n\n// Size variations\n\n.chart-sm {\n    height: $chart-height-sm;\n}\n\n\n// Legend\n\n.chart-legend {\n    display: flex;\n    justify-content: center;\n    margin-top: $chart-legend-margin-top;\n    font-size: $chart-legend-font-size;\n    text-align: center;\n    color: $chart-legend-color;\n}\n\n.chart-legend-item {\n    display: inline-flex;\n    align-items: center;\n\n    + .chart-legend-item {\n        margin-left: 1rem;\n    }\n}\n\n.chart-legend-indicator {\n    display: inline-block;\n    width: 0.5rem;\n    height: 0.5rem;\n    margin-right: 0.375rem;\n    border-radius: 50%;\n}\n\n\n// Tooltip\n\n#chart-tooltip {\n    z-index: 0;\n\n    .arrow {\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%) translateX(-.5rem);\n    }\n}\n\n\n// Chart info overlay\n\n.chart-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  max-width: 350px;\n  padding: 20px;\n  z-index: 1;\n}\n","//\n// Close\n//\n\n.close {\n    @if $enable-transitions {\n        transition: $transition-base;\n    }\n    \n    &>span:not(.sr-only) {\n        background-color: $close-bg;\n        color: $close-color;\n        line-height: 17px;\n        height: 1.25rem;\n        width: 1.25rem;\n        border-radius: 50%;\n        font-size: 1.25rem;\n        display: block;\n        @if $enable-transitions {\n            transition: $transition-base;\n        }\n    }\n\n    &:hover,\n    &:focus {\n        background-color: $close-hover-bg;\n        color: $close-hover-color;\n        outline: none;\n\n        span:not(.sr-only) {\n            background-color: $close-hover-bg;\n        }\n    }\n}\n",".main-content {\n    position: relative;\n\n    // Navbar\n    .navbar-top {\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        z-index: 1;\n        background-color: transparent;\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n\n    // Container\n    .container-fluid {\n        @include media-breakpoint-up(md) {\n            padding-left: ($main-content-padding-x + $grid-gutter-width / 2) !important;\n            padding-right: ($main-content-padding-x + $grid-gutter-width / 2) !important;\n        }\n    }\n}\n\n\n// Offsets the main content depending on the sidebar positioning\n\n.navbar-vertical.navbar-expand {\n\n    @each $breakpoint,\n    $dimension in $grid-breakpoints {\n\n        &-#{$breakpoint} {\n\n            @include media-breakpoint-up(#{$breakpoint}) {\n\n                // Left\n                &.fixed-left + .main-content {\n                    margin-left: $navbar-vertical-width;\n                } // Right\n                &.fixed-right + .main-content {\n                    margin-right: $navbar-vertical-width;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-checkbox-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom control\n// additional styles for custom checkboxes, radios and other\n//\n\n.custom-control-label {\n    // Background-color and (when enabled) gradient\n    &::before {\n        border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n        @if $enable-transitions {\n            transition: $input-transition;\n        }\n    }\n\n    span {\n        position: relative;\n        top: 2px;\n    }\n}\n\n.custom-control-label {\n    margin-bottom: 0;\n}\n\n\n// Alternative style\n\n.custom-control-alternative {\n    .custom-control-label {\n        // Background-color and (when enabled) gradient\n        &::before {\n            border: 0;\n            box-shadow: $input-alternative-box-shadow;\n        }\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    box-shadow: $input-focus-alternative-box-shadow;\n                }\n            }\n        }\n\n        &:active~.custom-control-label::before,\n        &:focus~.custom-control-label::before {\n            box-shadow: $input-alternative-box-shadow;\n        }\n    }\n}\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-checkbox-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom radio\n//\n\n.custom-radio {\n    .custom-control-input ~ .custom-control-label {\n        cursor: pointer;\n        font-size: $font-size-sm;\n    }\n\n    .custom-control-input {\n        &:checked {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-checked-border-color;\n                }\n                &::after {\n                    background-image: $custom-radio-indicator-icon-checked;\n                }\n            }\n        }\n\n        &:disabled {\n            ~ .custom-control-label {\n                &::before {\n                    border-color: $custom-control-indicator-disabled-bg;\n                }\n            }\n\n            &:checked {\n                &::before {\n                    border-color: $custom-control-indicator-checked-disabled-bg;\n                }\n            }\n        }\n    }\n}\n","//\n// Custom toggle\n//\n\n.custom-toggle {\n    position: relative;\n    display: inline-block;\n    width: $custom-toggle-width;\n    height: 1.5rem;\n\n    input {\n        display: none;\n\n        &:checked {\n             + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-checked-border-color;\n\n                &:before {\n                    background: $custom-toggle-checked-bg;\n                    transform: translateX(1.625rem);\n                }\n            }\n        }\n\n        &:disabled {\n            + .custom-toggle-slider {\n                border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n            }\n\n            &:checked {\n                + .custom-toggle-slider {\n                    border: $custom-control-indicator-border-width solid $custom-control-indicator-disabled-bg;\n\n                    &:before {\n                        background-color: lighten($custom-control-indicator-checked-bg, 10%);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.custom-toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: $custom-control-indicator-border-width solid $input-border-color;\n    border-radius: 34px !important;\n    background-color: transparent;\n\n\n    &:before {\n        position: absolute;\n        content: \"\";\n        height: 18px;\n        width: 18px;\n        left: 2px;\n        bottom: 2px;\n        border-radius: 50% !important;\n        background-color: $custom-toggle-slider-bg;\n        transition: $input-transition;\n    }\n}\n","//\n// Dropdown\n//\n\n// General styles\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n    display: inline-block;\n}\n\n.dropdown-menu {\n    min-width: 12rem;\n\n    .dropdown-item {\n        padding: .5rem 1rem;\n        font-size: $font-size-sm;\n        > i,\n        > svg {\n            margin-right: 1rem;\n            font-size: 1rem;\n            vertical-align: -17%;\n        }\n    }\n}\n\n.dropdown-header {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: $gray-100;\n    font-size: .625rem;\n    text-transform: uppercase;\n    font-weight: 700;\n}\n\n\n// Media components inside dropdown link\n\n.dropdown-menu {\n    a.media {\n\n        > div {\n            &:first-child {\n                line-height: 1;\n            }\n        }\n\n        p {\n            color: $gray-600;\n        }\n\n        &:hover {\n            .heading,\n            p {\n                color: theme-color(\"default\") !important;\n            }\n        }\n    }\n}\n\n\n// Size variations\n\n.dropdown-menu-sm {\n    min-width: 100px;\n    border: $border-radius-lg;\n}\n\n.dropdown-menu-lg {\n    min-width: 260px;\n    border-radius: $border-radius-lg;\n}\n\n.dropdown-menu-xl {\n    min-width: 450px;\n    border-radius: $border-radius-lg;\n}\n","//\n// Footer\n//\n\n\n// General styles\n\n.footer {\n    background: $footer-bg;\n    padding: $footer-padding-y $footer-padding-x;\n\n    .col-footer {\n        .heading {\n            color: $footer-heading-color;\n            letter-spacing: 0;\n            font-size: $footer-heading-font-size;\n            text-transform: uppercase;\n            font-weight: $font-weight-bold;\n            margin-bottom: 1rem;\n        }\n    }\n\n    .nav .nav-item .nav-link,\n    .footer-link {\n        color: $footer-link-color !important;\n\n        &:hover {\n            color: $footer-link-hover-color !important;\n        }\n    }\n\n    .list-unstyled li a {\n        display: inline-block;\n        padding: .125rem 0;\n        color: $footer-link-color;\n        font-size: $footer-link-font-size;\n\n        &:hover {\n            color: $footer-link-hover-color;\n        }\n    }\n\n    .copyright {\n        font-size: $font-size-sm;\n    }\n}\n\n\n// Dark footer\n\n.footer-dark {\n    .col-footer .heading {\n        color: $white;\n    }\n}\n\n\n// Footer nav used for copyright and some links, but not limited to this\n\n.nav-footer {\n    .nav-link {\n        font-size: $font-size-sm;\n    }\n\n    .nav-item:last-child {\n        .nav-link {\n            padding-right: 0;\n        }\n    }\n}\n\n\n// Footer with cards over\n\n.footer.has-cards {\n    overflow: hidden;\n    padding-top: 500px;\n    margin-top: -420px;\n    position: relative;\n    background: transparent;\n    pointer-events: none;\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 600px;\n        height: 2000px;\n        background: theme-color(\"secondary\");\n        transform: skew(0,-8deg);\n    }\n\n    .container {\n        pointer-events: auto;\n        position: relative;\n    }\n}\n","//\n// Forms\n//\n\n\n// Labels\n\n.form-control-label {\n    color: $gray-700;\n    font-size: $font-size-sm;\n    font-weight: $font-weight-bold;\n}\n\n\n// Text inputs\n\n.form-control {\n    font-size: $input-btn-font-size;\n\n    &:focus {\n        &::placeholder {\n            color: $input-focus-placeholder-color;\n        }\n    }\n}\n\n\n// Textarea\n\ntextarea[resize=\"none\"] {\n    resize: none!important;\n}\n\ntextarea[resize=\"both\"] {\n    resize: both!important;\n}\n\ntextarea[resize=\"vertical\"] {\n    resize: vertical!important;\n}\n\ntextarea[resize=\"horizontal\"] {\n    resize: horizontal!important;\n}\n\n\n// Form input variations\n\n// Muted input\n\n.form-control-muted {\n    background-color: $input-muted-bg;\n    border-color: $input-muted-bg;\n    box-shadow: none;\n\n    &:focus {\n        background-color: $input-focus-muted-bg;\n    }\n}\n\n\n// Alternative input\n\n.form-control-alternative {\n    box-shadow: $input-alternative-box-shadow;\n    border: 0;\n    transition: box-shadow .15s ease;\n\n    &:focus {\n        box-shadow: $input-focus-alternative-box-shadow;\n    }\n}\n\n// Size variations: Fixes to the bootstrap defaults\n\n.form-control-lg {\n    font-size: $font-size-base;\n}\n","//\n// Form validation\n//\n\n// Validation\n\n.has-success,\n.has-danger {\n    position: relative;\n\n    &:after, {\n        width: 19px;\n        height: 19px;\n        line-height: 19px;\n        text-align: center;\n        font-family: 'NucleoIcons';\n        display: inline-block;\n        position: absolute;\n        right: 15px;\n        top: 2px;\n        transform: translateY(50%);\n        border-radius: 50%;\n        font-size: 9px;\n        opacity: 1;\n    }\n}\n\n.has-success {\n    &:after {\n        content: \"\\ea26\";\n        color: daken($form-feedback-valid-color, 18%);\n        background-color: $form-feedback-valid-bg;\n    }\n    \n    .form-control {\n        background-color: $input-focus-bg;\n\n        &:focus {\n            border-color: $input-focus-border-color;\n        }\n\n\n        // Placeholder\n\n        &::placeholder {\n            color: $form-feedback-valid-color;\n        }\n    }\n}\n\n.has-danger {\n    &:after {\n        content: \"\\ea53\";\n        color: daken($form-feedback-invalid-color, 18%);\n        background-color: $form-feedback-invalid-bg;\n    }\n\n    .form-control {\n        background-color: $input-focus-bg;\n\n        &:focus {\n            border-color: $input-focus-border-color;\n        }\n\n        // Placeholder\n\n        &::placeholder {\n            color: $form-feedback-invalid-color;\n        }\n    }\n}\n","//\n// Input group\n//\n\n.input-group {\n\tbox-shadow: $input-box-shadow;\n\tborder-radius: $input-border-radius;\n\ttransition: $transition-base;\n\n\t.form-control {\n\t\tbox-shadow: none;\n\n\t\t&:not(:first-child) {\n\t\t    border-left: 0;\n\t\t    padding-left: 0;\n\t\t}\n\t\t&:not(:last-child) {\n\t\t\tborder-right: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n}\n\n.input-group-text {\n    transition: $input-transition;\n}\n\n\n// Alternative input groups related to .form-control-alternative\n\n\n.input-group-alternative {\n    box-shadow: $input-alternative-box-shadow;\n    border: 0;\n    transition: box-shadow .15s ease;\n\n    .form-control,\n    .input-group-text {\n        border: 0;\n        box-shadow: none;\n    }\n}\n\n.focused {\n\t.input-group-alternative {\n        box-shadow: $input-focus-alternative-box-shadow !important;\n    }\n}\n\n\n// .focus class is applied dinamycally from theme.js\n\n.focused {\n\t.input-group {\n\t\tbox-shadow: $input-focus-box-shadow;\n\t}\n\n\t.input-group-text {\n\t    color: $input-group-addon-focus-color;\n\t    background-color: $input-group-addon-focus-bg;\n\t    border-color: $input-group-addon-focus-border-color;\n\t}\n\n\t.form-control {\n\t\tborder-color: $input-group-addon-focus-border-color;\n\t}\n}\n","//\n// Header\n//\n\n.header {\n    position: relative;\n}\n","//\n// Icon\n//\n\n.icon {\n\twidth: $icon-size;\n\theight: $icon-size;\n\n\ti, svg {\n\t\tfont-size: $icon-size - .75;\n\t}\n\n    + .icon-text {\n    \tpadding-left: 1rem;\n    \twidth: calc(100% - #{$icon-size} - 1);\n    }\n}\n\n\n// Extra large icons\n\n.icon-xl {\n\twidth: $icon-size-xl;\n\theight: $icon-size-xl;\n\n\ti, svg {\n\t\tfont-size: $icon-size-xl - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-xl} - 1);\n    }\n}\n\n\n// Large icons\n\n.icon-lg {\n\twidth: $icon-size-lg;\n\theight: $icon-size-lg;\n\n\ti, svg {\n\t\tfont-size: $icon-size-lg - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-lg} - 1);\n    }\n}\n\n\n// Small icon\n\n.icon-sm {\n\twidth: $icon-size-sm;\n\theight: $icon-size-sm;\n\n\ti, svg {\n\t\tfont-size: $icon-size-sm - .75;\n\t}\n\n    + .icon-text {\n    \twidth: calc(100% - #{$icon-size-sm} - 1);\n    }\n}\n","//\n// Icon shape\n//\n\n\n.icon-shape {\n\tpadding: 12px;\n\ttext-align: center;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\n\n\ti, svg {\n\t\tfont-size: 1.25rem;\n\t}\n\n\t&.icon-lg {\n\t\ti, svg {\n\t\t\tfont-size: 1.625rem;\n\t\t}\n\t}\n\n\t&.icon-sm {\n\t\ti, svg {\n\t\t\tfont-size: .875rem;\n\t\t}\n\t}\n\n\tsvg {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\n}\n\n@each $color, $value in $theme-colors {\n\t.icon-shape-#{$color} {\n\t\t@include icon-shape-variant(theme-color($color));\n\t}\n}\n","@mixin icon-shape-variant($color) {\n    color: saturate(darken($color, 10%), 10);\n    background-color: transparentize(lighten($color, 10%), .5);\n}","//\n// List group\n//\n\n\n// Space list items\n\n.list-group-space {\n    .list-group-item {\n        margin-bottom: 1.5rem;\n        @include border-radius($list-group-border-radius);\n    }\n}\n\n\n// Extended list group components\n\n.list-group-img {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 50%;\n    vertical-align: top;\n    margin: -.1rem 1.2rem 0 -.2rem;\n}\n\n.list-group-content {\n    flex: 1;\n    min-width: 0;\n\n    > p {\n       color: $gray-500;\n       line-height: 1.5;\n       margin: .2rem 0 0;\n   }\n}\n\n.list-group-heading {\n    font-size: $font-size-base;\n    color: $gray-800;\n\n    > small {\n       float: right;\n       color: $gray-500;\n       font-weight: 500;\n   }\n}\n","//\n// Map\n//\n\n.map-canvas {\n    position: relative;\n    width: 100%;\n    height: $map-height;\n    border-radius: $border-radius;\n}\n","//\n// Mask\n//\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    @include transition($transition-base);\n}\n","//\n// Modal\n//\n\n\n// Fluid modal\n\n.modal-fluid {\n    .modal-dialog {\n        margin-top: 0;\n        margin-bottom: 0;\n    }\n    .modal-content {\n        border-radius: 0;\n    }\n}\n\n\n// Background color variations\n\n@each $color, $value in $theme-colors {\n    .modal-#{$color} {\n        @include modal-variant($value);\n    }\n}\n","@mixin modal-variant($background) {\n\t.modal-title {\n\t\tcolor: color-yiq($background);\n\t}\n\t.modal-header,\n\t.modal-footer {\n\t\tborder-color: rgba(color-yiq($background), .075);\n\t}\n\t.modal-content {\n\t\tbackground-color: $background;\n\t\tcolor: color-yiq($background);\n\n\t\t.heading {\n\t\t\tcolor: color-yiq($background);\n\t\t}\n\t}\n\n\t.close { \n    \t&>span:not(.sr-only) {\n    \t\tcolor: $white;\n    \t}\n    }\n}","//\n// Nav\n//\n\n\n// Nav wrapper (container)\n\n// Nav wrapper\n.nav-wrapper {\n    padding: 1rem 0;\n    @include border-top-radius($card-border-radius);\n\n    + .card {\n        @include border-top-radius(0);\n        @include border-bottom-radius($card-border-radius);\n    }\n}\n\n\n// Nav links\n\n.nav-link {\n    color: $nav-link-color;\n\n    &:hover {\n        color: $nav-link-hover-color;\n    }\n\n    i.ni {\n        position: relative;\n        top: 2px;\n    }\n}\n\n@media (min-width: 992px){\n  .nav-item.active-pro {\n      position: absolute;\n      width: 100%;\n      bottom: 10px;\n      background:  $table-head-bg;\n  }\n}\n","//\n// Nav pills\n//\n\n\n// General styles\n\n.nav-pills {\n    .nav-item:not(:last-child) {\n        padding-right: $nav-pills-space-x;\n    }\n\n    .nav-link {\n    \tpadding: $nav-pills-padding-y $nav-pills-padding-x;\n        color: $nav-pills-link-color;\n        font-weight: 500;\n        font-size: $font-size-sm;\n        box-shadow: $nav-pills-box-shadow;\n        background-color: $nav-pills-bg;\n        transition: $transition-base;\n\n        &:hover {\n        \tcolor: $nav-pills-link-hover-color;\n        }\n    }\n\n    .nav-link.active,\n    .show > .nav-link {\n        color: $nav-pills-link-active-color;\n        background-color: $nav-pills-link-active-bg;\n    }\n\n    @include media-breakpoint-down(xs) {\n        .nav-item {\n            margin-bottom: $spacer;\n        }\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .nav-pills:not(.nav-pills-circle) {\n        .nav-item {\n            padding-right: 0;\n        }\n    }\n}\n\n\n// Rounded circle nav pills\n\n.nav-pills-circle {\n    .nav-link {\n        text-align: center;\n        height: 60px;\n        width: 60px;\n        padding: 0;\n        line-height: 60px;\n        border-radius: 50%;\n    }\n\n    .nav-link-icon {\n        i, svg {\n            font-size: 1rem;\n        }\n    }\n}\n","//\n// Navbar\n//\n\n\n// Navbar links\n\n.navbar-horizontal {\n    .navbar-nav {\n        .nav-link {\n            font-size: $navbar-nav-link-font-size;\n            font-weight: $navbar-nav-link-font-weight;\n            text-transform: $navbar-nav-link-text-transform;\n            letter-spacing: $navbar-nav-link-letter-spacing;\n            @include transition($navbar-transition);\n\n            .nav-link-inner--text {\n                margin-left: .25rem;\n            }\n        }\n    }\n\n\n    // Navbar brand (logo)\n\n    .navbar-brand {\n        font-size: $font-size-sm;\n        font-weight: 600;\n        text-transform: uppercase;\n        font-size: .875rem;\n        letter-spacing: .05px;\n\n        img {\n            height: 30px;\n        }\n    }\n\n    .navbar-dark {\n        .navbar-brand {\n            color: $white;\n        }\n    }\n\n    .navbar-light {\n        .navbar-brand {\n            color: $gray-800;\n        }\n    }\n\n    .navbar-nav {\n      .nav-item {\n        .media:not(:last-child){\n          margin-bottom: 1.5rem;\n        }\n      }\n    }\n\n    @include media-breakpoint-up(lg) {\n        .navbar-nav {\n            .nav-item {\n                margin-right: .5rem;\n\n                [data-toggle=\"dropdown\"]::after {\n                    transition: $transition-base;\n                }\n\n                &.show {\n                    [data-toggle=\"dropdown\"]::after {\n                        transform: rotate(180deg);\n                    }\n                }\n            }\n            .nav-link {\n                padding-top: $navbar-nav-link-padding-y;\n                padding-bottom: $navbar-nav-link-padding-y;\n                border-radius: $navbar-nav-link-border-radius;\n\n                i {\n                    margin-right: .625rem;\n                }\n            }\n\n            .nav-link-icon {\n                padding-left: .5rem !important;\n                padding-right: .5rem !important;\n                font-size: 1rem;\n                border-radius: $navbar-nav-link-border-radius;\n\n                i {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n\n\n    // Transparent navbar\n\n    .navbar-transparent {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: 100;\n        background-color: transparent;\n        border: 0;\n        box-shadow: none;\n\n        .navbar-brand {\n            color: rgba(255, 255, 255, 1);\n        }\n\n        .navbar-toggler {\n            color: rgba(255, 255, 255, 1);\n        }\n\n        .navbar-toggler-icon {\n            background-image: $navbar-dark-toggler-icon-bg;\n        }\n    }\n\n    @include media-breakpoint-up(md) {\n        .navbar-transparent {\n            .navbar-nav {\n                .nav-link {\n                    color: $navbar-dark-color;\n\n                    @include hover-focus {\n                        color: $navbar-dark-hover-color;\n                    }\n\n                    &.disabled {\n                        color: $navbar-dark-disabled-color;\n                    }\n                }\n\n                .show > .nav-link,\n                .active > .nav-link,\n                .nav-link.show,\n                .nav-link.active {\n                    color: $navbar-dark-active-color;\n                }\n            }\n\n            .navbar-brand {\n                color: $navbar-dark-color;\n\n                @include hover-focus {\n                    color: $navbar-dark-color;\n                }\n            }\n        }\n    }\n}\n","//\n// Vertical navbar\n//\n\n// Vertical\n//\n// Creates a vertically aligned version of the navbar\n.navbar-vertical {\n  box-shadow: $navbar-vertical-box-shadow;\n\n  .navbar {\n    border-width: 0 0 1px 0;\n    border-style: solid;\n  }\n\n  // Navbar light\n\n  .navbar-light {\n    background-color: $navbar-light-bg;\n    border-color: $navbar-light-border-color;\n  }\n\n  // Navbar brand\n\n  .navbar-brand {\n    margin-right: 0;\n  }\n\n  .navbar-brand-img,\n  .navbar-brand > img {\n    max-width: 100%;\n    max-height: 20rem;\n  }\n\n  // Navbar collapse\n\n  @include media-breakpoint-up(md) {\n    .navbar-collapse {\n      margin-left: -$navbar-padding-x;\n      margin-right: -$navbar-padding-x;\n      padding-left: $navbar-padding-x;\n      padding-right: $navbar-padding-x;\n    }\n  }\n\n  // Navbar navigaton\n\n  .navbar-nav {\n    margin-left: -$navbar-padding-x;\n    margin-right: -$navbar-padding-x;\n\n    // Navbar link\n\n    .nav-link {\n      padding-left: $navbar-padding-x;\n      padding-right: $navbar-padding-x;\n      font-size: $navbar-nav-link-font-size;\n\n      &.active {\n        position: relative;\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          left: 0;\n          top: $nav-link-padding-y;\n          bottom: $nav-link-padding-y;\n          border-left: 2px solid $primary;\n        }\n      }\n\n      // Icon\n\n      > i {\n        min-width: $navbar-icon-min-width;\n        font-size: 0.9375rem;\n        line-height: ($font-size-base * $line-height-base);\n      }\n\n      // Dropdown\n\n      .dropdown-menu {\n        border: none;\n\n        .dropdown-menu {\n          margin-left: $dropdown-item-padding-x / 2;\n        }\n      }\n    }\n  }\n\n  // Navbar navigation\n  .navbar-nav .nav-link {\n    display: flex;\n    align-items: center;\n  }\n\n  .navbar-nav .nav-link[data-toggle=\"collapse\"] {\n    &:after {\n      display: inline-block;\n      font-style: normal;\n      font-variant: normal;\n      text-rendering: auto;\n      -webkit-font-smoothing: antialiased;\n      font-family: \"Font Awesome 5 Free\";\n      font-weight: 700;\n      content: \"\\f105\";\n      margin-left: auto;\n      color: $text-muted;\n      transition: $transition-base;\n    } // Expanded\n    &[aria-expanded=\"true\"] {\n      &:after {\n        transform: rotate(90deg);\n      }\n    }\n  }\n\n  // Second level\n  .navbar-nav .nav .nav-link {\n    padding-left: $navbar-padding-x + $navbar-icon-min-width;\n  }\n\n  // Third level\n  .navbar-nav .nav .nav .nav-link {\n    padding-left: $navbar-padding-x * 1.5 + $navbar-icon-min-width;\n  }\n\n  // Navbar heading\n  .navbar-heading {\n    padding-top: $nav-link-padding-y;\n    padding-bottom: $nav-link-padding-y;\n    font-size: $font-size-xs;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  // Expanded navbar specific styles\n  &.navbar-expand {\n    @each $breakpoint, $dimension in $grid-breakpoints {\n      &-#{$breakpoint} {\n        @include media-breakpoint-up(#{$breakpoint}) {\n          display: block;\n          position: fixed;\n          top: 0;\n          bottom: 0;\n          width: 100%;\n          max-width: $navbar-vertical-width;\n          padding-left: $navbar-vertical-padding-x;\n          padding-right: $navbar-vertical-padding-x;\n\n          overflow-y: auto;\n\n          // Container\n          > [class*=\"container\"] {\n            flex-direction: column;\n            align-items: stretch;\n            min-height: 100%;\n            padding-left: 0;\n            padding-right: 0; // Target IE 10 & 11\n            @media all and (-ms-high-contrast: none),\n              (-ms-high-contrast: active) {\n              min-height: none;\n              height: 100%;\n            }\n          }\n\n          // Fixes the vertical navbar to the left\n          &.fixed-left {\n            left: 0;\n            border-width: 0 1px 0 0;\n          }\n\n          // Fixed the vertical navbar to the right\n          &.fixed-right {\n            right: 0;\n            border-width: 0 0 0 1px;\n          }\n\n          // Navbar collapse\n          .navbar-collapse {\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n            align-items: stretch;\n            margin-left: -$navbar-vertical-padding-x;\n            margin-right: -$navbar-vertical-padding-x;\n            padding-left: $navbar-vertical-padding-x;\n            padding-right: $navbar-vertical-padding-x;\n\n            > * {\n              min-width: 100%;\n            }\n          }\n\n          // Navbar navigation\n          .navbar-nav {\n            flex-direction: column;\n            margin-left: -$navbar-vertical-padding-x;\n            margin-right: -$navbar-vertical-padding-x;\n          }\n\n          .navbar-nav .nav-link {\n            padding: $navbar-vertical-nav-link-padding-y\n              $navbar-vertical-nav-link-padding-x;\n\n            &.active {\n              &:before {\n                top: $nav-link-padding-y;\n                bottom: $nav-link-padding-y;\n                left: 0;\n                right: auto;\n                border-left: 2px solid $primary;\n                border-bottom: 0;\n              }\n            }\n          }\n\n          // Second level\n          .navbar-nav .nav .nav-link {\n            padding-left: $navbar-vertical-padding-x + $navbar-icon-min-width;\n          }\n\n          // Third level\n          .navbar-nav .nav .nav .nav-link {\n            padding-left: $navbar-vertical-padding-x * 1.5 +\n              $navbar-icon-min-width;\n          }\n\n          // Navbar brand\n          .navbar-brand {\n            display: block;\n            text-align: center;\n            padding-top: (2rem - $navbar-padding-y);\n            padding-bottom: (2rem - $navbar-padding-y);\n          }\n\n          .navbar-brand-img {\n            max-height: 40rem;\n          }\n\n          // Navbar user\n          .navbar-user {\n            margin-left: -$navbar-vertical-padding-x;\n            margin-right: -$navbar-vertical-padding-x;\n            padding-top: $spacer;\n            padding-bottom: $spacer - $navbar-padding-y;\n            padding-left: $navbar-vertical-padding-x;\n            padding-right: $navbar-vertical-padding-x;\n            border-top: 1px solid $border-color;\n\n            // Dropup menu\n            .dropup .dropdown-menu {\n              left: 50%;\n              transform: translateX(-50%);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.search-container {\n  position: relative;\n  input {\n    width: 200px;\n    padding-right: 40px;\n    padding-left: 15px;\n  }\n  .search_btn {\n    position: absolute;\n    padding: 5px;\n    background-color: transparent;\n    box-shadow: none;\n    border: 0;\n    right: 10px;\n    top: 5px;\n  }\n}\n","//\n// Navbar search\n//\n\n.navbar-search {\n    .input-group {\n        border-radius: $navbar-search-border-radius;\n        border: $navbar-search-border-width solid;\n        background-color: transparent;\n\n        .input-group-text {\n            background-color: transparent;\n            padding-left: 1rem;\n        }\n    }\n\n    .form-control {\n        width: $navbar-search-width;\n        background-color: transparent;\n    }\n}\n\n.navbar-search-dark {\n    .input-group {\n        border-color: $navbar-search-dark-border-color;\n    }\n\n    .input-group-text {\n        color: $navbar-search-dark-color;\n    }\n\n    .form-control {\n        color: $navbar-search-dark-focus-color;\n\n        &::placeholder {\n            color: $navbar-search-dark-color;\n        }\n    }\n\n    .focused {\n        .input-group {\n            border-color: $navbar-search-dark-focus-border-color;\n        }\n    }\n}\n\n.navbar-search-light {\n    .input-group {\n        border-color: $navbar-search-light-border-color;\n    }\n\n    .input-group-text {\n        color: $navbar-search-light-color;\n    }\n\n    .form-control {\n        color: $navbar-search-light-focus-color;\n\n        &::placeholder {\n            color: $navbar-search-light-color;\n        }\n    }\n\n    .focused {\n        .input-group {\n            border-color: $navbar-search-light-focus-border-color;\n        }\n    }\n}\n","// Dropdown menu\n\n@include media-breakpoint-up(md) {\n    .navbar {\n        .dropdown-menu {\n            opacity: 0;\n            pointer-events: none;\n            margin: 0;\n        }\n\n        .dropdown-menu-arrow {\n            &:before {\n                background: $dropdown-bg;\n                box-shadow: none;\n                content: '';\n                display: block;\n                height: 12px;\n                width: 12px;\n                left: 20px;\n                position: absolute;\n                bottom: 100%;\n                transform: rotate(-45deg) translateY(12px);\n                z-index: -5;\n                border-radius: 2px;\n            }\n        }\n\n        .dropdown-menu-right {\n            &:before {\n                right: 20px;\n                left: auto;\n            }\n        }\n\n        &:not(.navbar-nav-hover) {\n            .dropdown-menu {\n                &.show {\n                    opacity: 1;\n                    pointer-events: auto;\n                    animation: show-navbar-dropdown .25s ease forwards;\n                }\n\n                &.close {\n                    display: block;\n                    animation: hide-navbar-dropdown .15s ease backwards;\n                }\n            }\n        }\n\n        &.navbar-nav-hover {\n            .dropdown-menu {\n                opacity: 0;\n                display: block;\n                pointer-events: none;\n                transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n                transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n            }\n\n            .nav-item.dropdown:hover > .dropdown-menu {\n                display: block;\n                opacity: 1;\n                pointer-events: auto;\n                visibility: visible;\n                transform: translate(0, 0);\n                animation: none;\n            }\n        }\n\n        .dropdown-menu-inner {\n            position: relative;\n            padding: 1rem;\n        }\n\n\n        // Keyframes\n\n        @keyframes show-navbar-dropdown {\n            0% {\n                opacity: 0;\n                transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n                transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n            }\n\n            100% {\n                transform: translate(0, 0);\n                opacity: 1;\n            }\n        }\n\n        @keyframes hide-navbar-dropdown {\n            from {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n                transform: translate(0, 10px);\n            }\n        }\n    }\n}\n","//\n// Navabar collapse\n//\n\n// Collapse\n\n.navbar-collapse-header {\n    display: none;\n}\n\n@include media-breakpoint-down(sm) {\n    .navbar-nav {\n        .nav-link {\n            padding: .625rem 0;\n            color: theme-color(\"default\") !important;\n        }\n\n        .dropdown-menu {\n            box-shadow: none;\n            min-width: auto;\n\n            .media {\n                svg {\n                    width: 30px;\n                }\n            }\n        }\n    }\n\n    .navbar-collapse {\n        width: calc(100% - 1.4rem);\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 1050;\n        margin: .7rem;\n        overflow-y: auto;\n        height: auto !important;\n        opacity: 0;\n\n        .navbar-toggler {\n            width: 20px;\n            height: 20px;\n            position: relative;\n            cursor: pointer;\n            display: inline-block;\n            padding: 0;\n\n            span {\n                display: block;\n                position: absolute;\n                width: 100%;\n                height: 2px;\n                border-radius: 2px;\n                opacity: 1;\n                background: #283448;\n            }\n\n            :nth-child(1) {\n                transform: rotate(135deg);\n            }\n\n            :nth-child(2) {\n                transform: rotate(-135deg);\n            }\n        }\n\n        .navbar-collapse-header {\n            display: block;\n            padding-bottom: 1rem;\n            margin-bottom: 1rem;\n            border-bottom: 1px solid rgba(0, 0, 0, .1);\n        }\n\n        .collapse-brand {\n            img {\n                height: 36px;\n            }\n        }\n\n        .collapse-close {\n            text-align: right;\n        }\n    }\n\n    .navbar-collapse.collapsing,\n    .navbar-collapse.show {\n        padding: 1.5rem;\n        border-radius: $border-radius;\n        background: #FFF;\n        box-shadow: 0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1);\n        animation: show-navbar-collapse .2s ease forwards;\n    }\n\n    .navbar-collapse.collapsing-out {\n        animation: hide-navbar-collapse .2s ease forwards;\n    }\n}\n\n@keyframes show-navbar-collapse {\n    0% {\n        opacity: 0;\n        transform: scale(.95);\n        transform-origin: 100% 0;\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes hide-navbar-collapse {\n    from {\n        opacity: 1;\n        transform: scale(1);\n        transform-origin: 100% 0;\n    }\n\n    to {\n        opacity: 0;\n        transform: scale(.95);\n    }\n}\n","//\n// Pagination\n//\n\n\n.page-item {\n    &.active .page-link {\n        box-shadow: $pagination-active-box-shadow;\n    }\n\n    .page-link,\n    span {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 50% !important;\n        width: 36px;\n\t\theight: 36px;\n\t\tfont-size: $font-size-sm;\n    }\n}\n\n\n// Size variations\n\n.pagination-lg {\n    .page-item {\n        .page-link,\n        span {\n            width: 46px;\n            height: 46px;\n            line-height: 46px;\n        }\n    }\n}\n\n.pagination-sm {\n    .page-item {\n        .page-link,\n        span {\n            width: 30px;\n            height: 30px;\n            line-height: 30px;\n        }\n    }\n}\n","//\n// Popover\n//\n\n\n.popover {\n    border: 0;\n}\n\n.popover-header {\n\tfont-weight: $font-weight-bold;\n}\n\n\n// Alternative colors\n\n@each $color, $value in $theme-colors {\n    .popover-#{$color} {\n        @include popover-variant($value);\n    }\n}\n","@mixin popover-variant($background) {\n\n\tbackground-color: $background;\n\n\t.popover-header {\n\t\tbackground-color: $background;\n\t\tcolor: color-yiq($background);\n\t}\n\n\t.popover-body {\n\t\tcolor: color-yiq($background);\n\t}\n\t.popover-header{\n\t\tborder-color: rgba(color-yiq($background), .2);\n\t}\n\t&.bs-popover-top {\n\t\t.arrow::after {\n\t\t\tborder-top-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-right {\n\t\t.arrow::after {\n\t\t\tborder-right-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-bottom {\n\t\t.arrow::after {\n\t\t\tborder-bottom-color: $background;\n\t\t}\n\t}\n\t&.bs-popover-left {\n\t\t.arrow::after {\n\t\t\tborder-left-color: $background;\n\t\t}\n\t}\n}","//\n// Progress\n//\n\n\n// Progress container\n\n.progress-wrapper {\n    position: relative;\n    padding-top: 1.5rem;\n}\n\n\n// General styles\n\n.progress {\n    height: 8px;\n    margin-bottom: $spacer;\n    overflow: hidden;\n    border-radius: $border-radius-sm;\n    background-color: $progress-bg;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    .sr-only {\n        width: auto;\n        height: 20px;\n        margin: 0 0 0 30px;\n        left: 0;\n        clip: auto;\n        line-height: 20px;\n        font-size: 13px;\n    }\n}\n\n\n// Progress inner elements\n\n.progress-heading {\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0 0 2px;\n    padding: 0;\n}\n\n.progress-bar {\n    box-shadow: none;\n    border-radius: 0;\n    height: auto;\n}\n\n.progress-info{\n    margin-bottom: .5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.progress-label {\n    span {\n        display: inline-block;\n        color: $primary;\n        font-size: .625rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        background: rgba($primary, .1);\n        padding: .25rem 1rem;\n        border-radius: 30px;\n    }\n}\n\n.progress-percentage {\n    text-align: right;\n    span {\n        display: inline-block;\n        color: $gray-600;\n        font-size: .875rem;\n        font-weight: 600;\n    }\n}\n","//\n// Separator\n// add svg on top or bottom of a section for a more stylish visual\n//\n\n\n.separator {\n    position: absolute;\n    top: auto;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 150px;\n    transform: translateZ(0);\n    overflow: hidden;\n    pointer-events: none;\n\n    svg {\n        position: absolute;\n        pointer-events: none;\n    }\n}\n\n.separator-top {\n    top: 0;\n    bottom: auto;\n\n    svg {\n        top: 0;\n    }\n}\n\n.separator-bottom {\n    top: auto;\n    bottom: 0;\n\n    svg {\n        bottom: 0;\n    }\n}\n\n.separator-inverse {\n    transform: rotate(180deg);\n}\n\n// Styles\n\n.separator-skew {\n    height: 60px;\n\n    @include media-breakpoint-up(xl) {\n        height: 70px;\n    }\n}\n","//\n// Table\n//\n\n// General styles\n\n.table {\n  thead th {\n    padding-top: $table-head-spacer-y;\n    padding-bottom: $table-head-spacer-y;\n    font-size: $table-head-font-size;\n    text-transform: $table-head-text-transform;\n    letter-spacing: $table-head-letter-spacing;\n    border-bottom: $table-border-width solid $table-border-color;\n  }\n\n  th {\n    font-weight: $table-head-font-weight;\n  }\n\n  td {\n    .progress {\n      height: 3px;\n      width: 120px;\n      margin: 0;\n    }\n  }\n\n  td,\n  th {\n    font-size: $table-body-font-size;\n    white-space: nowrap;\n  }\n\n  // Vetical align table content\n\n  &.align-items-center {\n    td,\n    th {\n      vertical-align: middle;\n    }\n  }\n\n  // Styles for dark table\n\n  .thead-dark {\n    th {\n      background-color: $table-dark-head-bg;\n      color: $table-dark-head-color;\n    }\n  }\n\n  // Styles for light table\n\n  .thead-light {\n    th {\n      background-color: $table-head-bg;\n      color: $table-head-color;\n    }\n  }\n}\n\n// Add transition for hover state\n\n.table-hover {\n  tr {\n    @include transition($transition-base);\n  }\n}\n\n// Flush tables\n\n.table-flush {\n  td,\n  th {\n    border-left: 0;\n    border-right: 0;\n  }\n\n  tbody {\n    tr {\n      &:first-child {\n        td,\n        th {\n          border-top: 0;\n        }\n      }\n\n      &:last-child {\n        td,\n        th {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n// Tables inside cards\n\n.card {\n  .table {\n    margin-bottom: 0;\n\n    td,\n    th {\n      padding-left: $card-spacer-x;\n      padding-right: $card-spacer-x;\n      white-space: break-spaces;\n    }\n  }\n}\n","//\n// Type\n//\n\n\n// Paragraphs\n\np {\n\tfont-size: $paragraph-font-size;\n\tfont-weight: $paragraph-font-weight;\n\tline-height: $paragraph-line-height;\n}\n\n.lead {\n\tfont-size: $lead-font-size;\n  \tfont-weight: $lead-font-weight;\n\tline-height: $paragraph-line-height;\n\tmargin-top: 1.5rem;\n\n\t+ .btn-wrapper {\n\t\tmargin-top: 3rem;\n\t}\n}\n\n.description {\n\tfont-size: $font-size-sm;\n}\n","//\n// Heading\n//\n\n\n// General styles\n\n.heading {\n\tletter-spacing: $heading-letter-spacing;\n\tfont-size: $heading-font-size;\n\ttext-transform: $heading-text-transform;\n\tfont-weight: $heading-font-weight;\n}\n\n\n// Heading variations\n\n.heading-small {\n\tpadding-top: .25rem;\n\tpadding-bottom: .25rem;\n\tfont-size: .75rem;\n\ttext-transform: uppercase;\n\tletter-spacing: .04em;\n}\n\n.heading-title {\n\tletter-spacing: $heading-title-letter-spacing;\n\tfont-size: $heading-title-font-size;\n\tfont-weight: $heading-title-font-weight;\n\ttext-transform: $heading-title-text-transform;\n}\n\n.heading-section {\n\tletter-spacing: $heading-section-letter-spacing;\n\tfont-size: $heading-section-font-size;\n\tfont-weight: $heading-section-font-weight;\n\ttext-transform: $heading-section-text-transform;\n\n\timg {\n\t\tdisplay: block;\n\t\twidth: 72px;\n\t\theight: 72px;\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\t&.text-center {\n\t\timg {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n}\n","//\n// Display\n//\n\n\n.display-1,\n.display-2,\n.display-3,\n.display-4 {\n\tspan {\n\t\tdisplay: block;\n\t\tfont-weight: $font-weight-light;\n\t}\n}\n","//\n// Article\n// \n\narticle {\n\th4:not(:first-child),\n\th5:not(:first-child) {\n\t\tmargin-top: 3rem;\n\t}\n\n\th4, h5 {\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\tfigure {\n\t\tmargin: 3rem 0;\n\t}\n\n\th5 + figure {\n\t\tmargin-top: 0;\n\t}\n}\n","//\n// Bootstrap datepicker\n//\n\n\n.datepicker {\n    border-radius: $datepicker-border-radius;\n\n    &-inline {\n        width: 220px;\n    }\n\n    direction: ltr;\n\n    &-rtl {\n        direction: rtl;\n        &.dropdown-menu {\n            left: auto;\n        }\n        table tr td span {\n            float: right;\n        }\n    }\n\n    &-dropdown {\n        top: 0;\n        left: 0;\n        padding: $datepicker-dropdown-padding;\n        @include box-shadow($dropdown-box-shadow);\n\n        &.datepicker-orient-left:before {\n            left: 6px;\n        }\n        &.datepicker-orient-left:after {\n            left: 7px;\n        }\n        &.datepicker-orient-right:before {\n            right: 6px;\n        }\n        &.datepicker-orient-right:after {\n            right: 7px;\n        }\n        &.datepicker-orient-bottom:before {\n            top: -7px;\n        }\n        &.datepicker-orient-bottom:after {\n            top: -6px;\n        }\n\n        &.datepicker-orient-top:before {\n            bottom: -7px;\n            border-bottom: 0;\n            border-top: 7px solid $datepicker-dropdown-border;\n        }\n\n        &.datepicker-orient-top:after {\n            bottom: -6px;\n            border-bottom: 0;\n            border-top: 6px solid $datepicker-dropdown-bg;\n        }\n    }\n\n    table {\n        margin: 0;\n        -webkit-touch-callout: none;\n        user-select: none;\n\n        tr {\n            td {\n                border-radius: $datepicker-cell-border-radius;\n            }\n\n            th {\n                border-radius: $datepicker-header-cell-border-radius;\n                font-weight: 500;\n            }\n\n            td,\n            th {\n                transition: $datepicker-cell-transition;\n                width: $datepicker-cell-width;\n                height: $datepicker-cell-height;\n                border: none;\n                text-align: center;\n                font-size: $font-size-sm;\n            }\n        }\n    }\n\n    // Inline display inside a table presents some problems with\n    // border and background colors.\n    .table-striped & table tr {\n        td,\n        th {\n            background-color: transparent;\n        }\n    }\n\n    table tr td {\n        &.old,\n        &.new {\n            color: $datepicker-disabled-old-new-color;\n        }\n\n        &.day:hover,\n        &.focused {\n            background: $datepicker-cell-hover-background;\n            cursor: pointer;\n        }\n\n        &.disabled,\n        &.disabled:hover {\n            background: none;\n            color: $datepicker-disabled-cell-color;\n            cursor: default;\n        }\n\n        &.highlighted {\n            border-radius: 0;\n\n            &.focused {\n                background: $datepicker-highlighted-bg\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: $datepicker-highlighted-bg;\n                color: $gray-400;\n            }\n        }\n\n        &.today {\n            background: lighten($datepicker-active-background, 45%);\n            &.focused {\n                background: lighten($gray-400, 58%);\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: lighten($gray-400, 58%);\n                color: $btn-link-disabled-color;\n            }\n        }\n\n        // Range selection\n        &.range {\n            background: $datepicker-range-background;\n            color: $datepicker-range-color;\n            border-radius: 0;\n\n            &.focused {\n                background: darken($datepicker-range-cell-focused-background, 3%);\n            }\n\n            &.disabled,\n            &.disabled:active,\n            &.day.disabled:hover {\n                background: darken($datepicker-active-background, 10%);\n                color: lighten($datepicker-active-background, 10%);\n            }\n        }\n\n        &.range.highlighted {\n            &.focused {\n                background: darken($datepicker-range-highlighted-bg, 10%);\n            }\n\n            &.disabled,\n            &.disabled:active {\n                background: $datepicker-range-highlighted-bg;\n                color: $datepicker-disabled-cell-color;\n            }\n        }\n\n        &.range.today {\n            &.disabled,\n            &.disabled:active {\n                background: $blue;\n                color: $white;\n            }\n        }\n\n        &.day.range-start {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n\n        &.day.range-end {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        &.day.range-start.range-end {\n            border-radius: $datepicker-cell-border-radius;\n        }\n\n        &.selected,\n        &.selected.highlighted,\n        &.selected:hover,\n        &.selected.highlighted:hover,\n        &.day.range:hover {\n            background: $datepicker-active-background;\n            color: $datepicker-active-color;\n        }\n\n        &.active,\n        &.active.highlighted,\n        &.active:hover,\n        &.active.highlighted:hover {\n            background: $datepicker-active-background;\n            color: $datepicker-active-color;\n            box-shadow: $datepicker-active-box-shadow;\n        }\n\n        span {\n            display: block;\n            width: 23%;\n            height: 54px;\n            line-height: 54px;\n            float: left;\n            margin: 1%;\n            cursor: pointer;\n            border-radius: 4px;\n\n            &:hover,\n            &.focused {\n                background: $gray-200;\n            }\n\n            &.disabled,\n            &.disabled:hover {\n                background: none;\n                color: $datepicker-disabled-cell-color;\n                cursor: default;\n            }\n\n            &.active,\n            &.active:hover,\n            &.active.disabled,\n            &.active.disabled:hover {\n                text-shadow: 0 -1px 0 rgba(0, 0, 0, .25);\n            }\n\n            &.old,\n            &.new {\n                color: $btn-link-disabled-color;\n            }\n        }\n    }\n\n    .datepicker-switch {\n        width: 145px;\n    }\n\n    .datepicker-switch,\n    .prev,\n    .next,\n    tfoot tr th {\n        cursor: pointer;\n        &:hover {\n            background: $gray-200;\n        }\n    }\n\n    .prev,\n    .next {\n        &.disabled {\n            visibility: hidden;\n        }\n    }\n\n    // Basic styling for calendar-week cells\n    .cw {\n        font-size: 10px;\n        width: 12px;\n        padding: 0 2px 0 5px;\n        vertical-align: middle;\n    }\n}\n","/*! nouislider - 14.0.1 - 6/21/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  left: -17px;\n  top: -6px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -17px;\n  left: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n  border: 1px solid #D3D3D3;\n  box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #E8E7E6;\n  left: 14px;\n  top: 6px;\n}\n.noUi-handle:after {\n  left: 17px;\n}\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n\n\n//  Custom styles\n\n.noUi-target {\n    background: $noui-target-bg;\n    border-radius: $noui-target-border-radius;\n    border: 0;\n    box-shadow: $noui-target-box-shadow;\n    margin: 15px 0;\n    cursor: pointer;\n}\n\n.noUi-horizontal {\n    height: $noui-target-thickness;\n}\n\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n    right: -10px;\n}\n\n.noUi-vertical {\n    width: $noui-target-thickness;\n}\n\n.noUi-connect {\n    background: theme-color(\"primary\");\n    box-shadow: none;\n}\n\n.noUi-handle {\n  &:after,&:before{\n    content: none;\n  }\n\n  &:focus{\n    outline: none;\n  }\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n    top: -$noui-target-thickness;\n    width: $noui-handle-width;\n    height: $noui-handle-width;\n    border-radius: 100%;\n    box-shadow: none;\n    cursor: pointer;\n    background-color: $noui-handle-bg;\n    border: $noui-handle-border;\n    transition: box-shadow .15s, transform .15s;\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n    box-shadow: 0px 0px 0px 2px rgba($noui-handle-bg, 1);\n}\n\n.input-slider--cyan .noUi-connect {\n    background: $cyan;\n}\n\n\n/* Disabled state */\n\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n    background: $noui-slider-connect-disabled-bg;\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n    cursor: not-allowed;\n}\n\n/* Range slider value labels */\n\n.range-slider-value {\n    font-size: $font-size-xs;\n    font-weight: 500;\n    background-color: rgba($dark, .7);\n    color: color-yiq($dark);\n    border-radius: 10px;\n    padding: .4em .8em .3em .85em;\n}\n\n.range-slider-wrapper .upper-info {\n    font-weight: 400;\n    margin-bottom: 5px;\n}\n\n.input-slider-value-output {\n    background: #333;\n    color: #fff;\n    padding: 4px 8px;\n    position: relative;\n    top: 12px;\n    font-size: 11px;\n    border-radius: 2px;\n}\n\n.input-slider-value-output:after {\n    bottom: 100%;\n    left: 10px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(136, 183, 213, 0);\n    border-bottom-color: #333;\n    border-width: 4px;\n    margin-left: -4px;\n}\n\n.input-slider-value-output.left:after {\n    left: 10px;\n    right: auto;\n}\n\n.input-slider-value-output.right:after {\n    right: 10px;\n    left: auto;\n}\n","//\n// Custom scrollbar\n//\n\n.scrollbar-inner {\n    height: 100%;\n\n    &:not(:hover) .scroll-element {\n        opacity: 0;\n    }\n\n    .scroll-element {\n        transition: opacity 300ms;\n        margin-right: 2px;\n\n        .scroll-bar,\n        .scroll-element_track {\n            transition: background-color 300ms;\n        }\n\n        .scroll-element_track {\n            background-color: transparent;\n        }\n    }\n\n    .scroll-element.scroll-y {\n        width: 3px;\n        right: 0;\n    }\n\n    .scroll-element.scroll-x {\n        height: 3px;\n        bottom: 0;\n    }\n}\n","//\n// Main navbar\n//\n.ct-navbar {\n    background-color: $ct-primary;\n    box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    \n    @include media-breakpoint-down(md) {\n        padding-right: .5rem;\n        padding-left: .5rem;\n\n        .navbar-nav-scroll {\n            max-width: 100%;\n            height: 2.5rem;\n            margin-top: .25rem;\n            overflow: hidden;\n            font-size: .875rem;\n\n            .navbar-nav {\n                padding-bottom: 2rem;\n                overflow-x: auto;\n                white-space: nowrap;\n                -webkit-overflow-scrolling: touch;\n            }\n        }\n    }\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            position: sticky;\n            top: 0;\n            z-index: 1071; // over everything in bootstrap\n        }\n    }\n\n    .navbar-nav {\n        .nav-link {\n            padding-right: .5rem;\n            padding-left: .5rem;\n            color: $ct-primary-light !important;\n\n            &.active,\n            &:hover {\n                color: #fff !important;\n                background-color: transparent !important;\n            }\n\n            &.active {\n                font-weight: 500;\n            }\n        }\n    }\n\n    .navbar-nav-svg {\n        display: inline-block;\n        width: 1rem;\n        height: 1rem;\n        vertical-align: text-top;\n    }\n\n    .dropdown-menu {\n        font-size: .875rem;\n    }\n\n    .dropdown-item.active {\n        font-weight: 500;\n        color: $gray-900;\n        background-color: transparent;\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23292b2c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n        background-repeat: no-repeat;\n        background-position: .4rem .87rem;\n        background-size: .75rem .75rem;\n        padding-left: 25px;\n    }\n}\n\n// Github corner\n.github-corner {\n    position: fixed;\n    right: 0;\n    z-index: 1080;\n\n    &:hover {\n        .octo-arm {\n            animation: octocat-wave 560ms ease-in-out\n        }\n    }\n\n    svg {\n        fill: $white;\n        color: $ct-primary;\n    }\n}\n\n@keyframes octocat-wave {\n    0%,\n    100% {\n        transform: rotate(0)\n    }\n    20%,\n    60% {\n        transform: rotate(-25deg)\n    }\n    40%,\n    80% {\n        transform: rotate(10deg)\n    }\n}\n","// Local docs variables\n$ct-primary:        theme-color(\"primary\") !default;\n$ct-primary-bright: lighten(saturate($ct-primary, 5%), 15%) !default;\n$ct-primary-light:  rgba(255, 255, 255, .9) !default;\n$ct-dark:          \t#2a2730 !default;\n$ct-download:      \t#ffe484 !default;\n$ct-info:          \t#5bc0de !default;\n$ct-warning:       \t#f0ad4e !default;\n$ct-danger:        \t#d9534f !default;\n\n$ct-sidebar-bg:\t#f5f7f9;\n$ct-sidebar-border-color: #e6ecf1;\n\n","// clipboard.js\n//\n// JS-based `Copy` buttons for code snippets.\n\n.ct-clipboard {\n  position: relative;\n  display: none;\n  float: right;\n\n  + .highlight {\n    margin-top: 0;\n  }\n}\n\n.btn-clipboard {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  display: block;\n  padding: .25rem .5rem;\n  font-size: 75%;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  border-radius: .25rem;\n  color: #fff;\n  background-color: $ct-primary;\n\n  &:hover {\n    color: #fff;\n    background-color: darken($ct-primary, 10%);\n  }\n}\n\n@media (min-width: 768px) {\n  .ct-clipboard {\n    display: block;\n  }\n}\n","// stylelint-disable no-duplicate-selectors, selector-no-qualifying-type\n\n//\n// Grid examples\n//\n\n.ct-example-row {\n  .row {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        display: block;\n        padding: .75rem;\n        color: rgb(57, 63, 73);\n        background-color: rgb(255, 255, 255);\n        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n        font-size: $font-size-sm;\n        border-radius: .25rem;\n        margin: 1rem 0;\n      }\n    }\n  }\n\n  .no-gutters {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        border-radius: 0;\n      }\n    }\n  }\n\n  .flex-items-top,\n  .flex-items-middle,\n  .flex-items-bottom {\n    min-height: 6rem;\n    background-color: rgba(255, 0, 0, .1);\n  }\n}\n\n.ct-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, .1);\n\n  & + .row {\n    margin-top: 1rem;\n  }\n}\n\n.ct-highlight {\n  background-color: rgba($ct-primary, .15);\n  border: 1px solid rgba($ct-primary, .15);\n}\n\n// Grid mixins\n.example-container {\n  width: 800px;\n  @include make-container();\n}\n\n.example-row {\n  @include make-row();\n}\n\n.example-content-main {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(8);\n  }\n}\n\n.example-content-secondary {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(4);\n  }\n}\n\n\n//\n// Container illustrations\n//\n\n.ct-example-container {\n  min-width: 16rem;\n  max-width: 25rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-container-header {\n  height: 3rem;\n  margin-bottom: .5rem;\n  background-color: lighten($blue, 50%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-sidebar {\n  float: right;\n  width: 4rem;\n  height: 8rem;\n  background-color: lighten($blue, 25%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-body {\n  height: 8rem;\n  margin-right: 4.5rem;\n  background-color: lighten($ct-primary, 25%);\n  border-radius: .25rem;\n}\n\n.ct-example-container-fluid {\n  max-width: none;\n}\n\n\n//\n// Docs examples\n//\n\n.ct-example {\n  position: relative;\n  margin: 1rem (-$grid-gutter-width / 2) 0;\n  @include clearfix();\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  + .highlight,\n  + .clipboard + .highlight {\n    margin-top: 0;\n  }\n\n  + p {\n    margin-top: 2rem;\n  }\n\n  .pos-f-t {\n    position: relative;\n    margin: -1rem;\n\n    @include media-breakpoint-up(sm) {\n      margin: -1.5rem;\n    }\n  }\n\n  .custom-file-input:lang(es) ~ .custom-file-label::after {\n    content: \"Elegir\";\n  }\n\n  > .form-control {\n    + .form-control {\n      margin-top: .5rem;\n    }\n  }\n\n  > .nav + .nav,\n  > .alert + .alert,\n  > .navbar + .navbar,\n  > .progress + .progress,\n  > .progress + .btn,\n  .badge,\n  .btn {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n  }\n\n  .btn-group {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n    .btn {\n      margin: 0;\n    }\n  }\n\n  .alert {\n    margin: 0;\n\n    + .alert {\n      margin-top: 1.25rem;\n    }\n  }\n\n  .badge {\n    margin-right: .5rem;\n  }\n\n  > .dropdown-menu:first-child {\n    position: static;\n    display: block;\n  }\n\n  > .form-group:last-child {\n    margin-bottom: 0;\n  }\n\n  > .close {\n    float: none;\n  }\n}\n\n// Typography\n.ct-example-type {\n  .table {\n    .type-info {\n      color: #999;\n      vertical-align: middle;\n    }\n    td {\n      padding: 1rem 0;\n      border-color: #eee;\n    }\n    tr:first-child td {\n      border-top: 0;\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n// Contextual background colors\n.ct-example-bg-classes p {\n  padding: 1rem;\n}\n\n// Images\n.ct-example > img {\n  + img {\n    margin-left: .5rem;\n  }\n}\n\n// Buttons\n.ct-example {\n  > .btn-group {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n  }\n  > .btn-toolbar + .btn-toolbar {\n    margin-top: .5rem;\n  }\n}\n\n// Forms\n.ct-example-control-sizing select,\n.ct-example-control-sizing input[type=\"text\"] + input[type=\"text\"] {\n  margin-top: .5rem;\n}\n.ct-example-form .input-group {\n  margin-bottom: .5rem;\n}\n.ct-example > textarea.form-control {\n  resize: vertical;\n}\n\n// List groups\n.ct-example > .list-group {\n  max-width: 400px;\n}\n\n// Navbars\n.ct-example {\n  .fixed-top,\n  .sticky-top {\n    position: static;\n    margin: -1rem -1rem 1rem;\n  }\n  .fixed-bottom {\n    position: static;\n    margin: 1rem -1rem -1rem;\n  }\n\n  @include media-breakpoint-up(sm) {\n    .fixed-top,\n    .sticky-top {\n      margin: -1.5rem -1.5rem 1rem;\n    }\n    .fixed-bottom {\n      margin: 1rem -1.5rem -1.5rem;\n    }\n  }\n}\n\n// Pagination\n.ct-example .pagination {\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n}\n\n// Example modals\n.modal {\n  z-index: 1072;\n\n  .tooltip,\n  .popover {\n    z-index: 1073;\n  }\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.ct-example-modal {\n  background-color: #fafafa;\n\n  .modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n  .modal-dialog {\n    left: auto;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n// Example tabbable tabs\n.ct-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n// Popovers\n.ct-example-popover-static {\n  padding-bottom: 1.5rem;\n  background-color: #f9f9f9;\n\n  .popover {\n    position: relative;\n    display: block;\n    float: left;\n    width: 260px;\n    margin: 1.25rem;\n  }\n}\n\n// Tooltips\n.tooltip-demo a {\n  white-space: nowrap;\n}\n\n.ct-example-tooltip-static .tooltip {\n  position: relative;\n  display: inline-block;\n  margin: 10px 20px;\n  opacity: 1;\n}\n\n// Scrollspy demo on fixed height div\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: .5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 350px;\n  overflow: auto;\n}\n\n.ct-example-border-utils {\n  [class^=\"border\"] {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: .25rem;\n    background-color: #f5f5f5;\n  }\n}\n\n.ct-example-border-utils-0 {\n  [class^=\"border\"] {\n    border: 1px solid $border-color;\n  }\n}\n\n//\n// Code snippets\n//\n\n.highlight {\n  padding: 0;\n  margin-top: 1rem;\n  //margin-bottom: 3rem;\n  //background-color: $gray-100;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  @include media-breakpoint-up(sm) {\n    padding: 0;\n  }\n}\n\n.ct-content .highlight {\n  margin-right: (-$grid-gutter-width / 2);\n  margin-left: (-$grid-gutter-width / 2);\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n//\n// Component-Code tabs\n//\n\n.ct-example {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid $gray-200;\n\n  .tab-content {\n    .tab-example-result {\n        background-color: #f5f7f9;\n        border: 1px solid #e6ecf1;\n        padding: 1.25rem;\n        border-radius: .25rem;\n    }\n  }\n\n  .nav-tabs-code {\n    margin-bottom: .375rem;\n\n    .nav-link {\n      font-size: .875rem;\n\n      &:active,\n      &.active {\n        color: $ct-primary;\n      }\n    }\n  }\n}\n\n// Icon examples\n.icon-examples {\n  margin-top: 1rem;\n}\n.btn-icon-clipboard {\n  margin: 0px;\n  padding: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: rgb(57, 63, 73);\n  background-color: rgb(248, 249, 250);\n  border-radius: 4px;\n  border: 0px none;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: .5rem 0;\n\n  &:hover {\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n  }\n\n  > div {\n    align-items: center;\n    display: flex;\n  }\n\n  i {\n    box-sizing: content-box;\n    color: rgb(57, 63, 73);\n    vertical-align: middle;\n    font-size: 1.5rem;\n  }\n\n  span {\n    display: inline-block;\n    font-size: .875rem;\n    line-height: 1.5;\n    color: rgb(57, 63, 73);\n    margin-left: 16px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n  }\n}\n","code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    font-family: Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace;\n    font-size: 14px;\n    line-height: 1.375;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n    background: #f5f7ff;\n    color: #5e6687;\n    border-radius: .25rem;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n    text-shadow: none;\n    background: #dfe2f1;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #dfe2f1;\n}\n\n\n/* Code blocks */\n\npre[class*=\"language-\"] {\n    padding: 1.25rem;\n    margin: 0;\n    overflow: auto;\n}\n\n\n/* Inline code */\n\n:not(pre)>code[class*=\"language-\"] {\n    padding: .1em;\n    border-radius: .3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: #898ea4;\n}\n\n.token.punctuation {\n    color: #5e6687;\n}\n\n.token.namespace {\n    opacity: .7;\n}\n\n.token.operator,\n.token.boolean,\n.token.number {\n    color: #c76b29;\n}\n\n.token.property {\n    color: #c08b30;\n}\n\n.token.tag {\n    color: #3d8fd1;\n}\n\n.token.string {\n    color: #22a2c9;\n}\n\n.token.selector {\n    color: #6679cc;\n}\n\n.token.attr-name {\n    color: #c76b29;\n}\n\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #22a2c9;\n}\n\n.token.attr-value,\n.token.keyword,\n.token.control,\n.token.directive,\n.token.unit {\n    color: #ac9739;\n}\n\n.token.statement,\n.token.regex,\n.token.atrule {\n    color: #22a2c9;\n}\n\n.token.placeholder,\n.token.variable {\n    color: #3d8fd1;\n}\n\n.token.deleted {\n    text-decoration: line-through;\n}\n\n.token.inserted {\n    border-bottom: 1px dotted #202746;\n    text-decoration: none;\n}\n\n.token.italic {\n    font-style: italic;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n\n.token.important {\n    color: #c94922;\n}\n\n.token.entity {\n    cursor: help;\n}\n\npre>code.highlight {\n    outline: 0.4em solid #c94922;\n    outline-offset: .4em;\n}\n\n\n/* overrides color-values for the Line Numbers plugin\n * http://prismjs.com/plugins/line-numbers/\n */\n\n.line-numbers .line-numbers-rows {\n    border-right-color: #dfe2f1;\n}\n\n.line-numbers-rows>span:before {\n    color: #979db4;\n}\n\n\n/* overrides color-values for the Line Highlight plugin\n * http://prismjs.com/plugins/line-highlight/\n */\n\n.line-highlight {\n    background: rgba(107, 115, 148, 0.2);\n    background: -webkit-linear-gradient(left, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n    background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n}",".docs {\n    background: #FFF;\n\n    h6 {\n        font-size: 1rem;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.ct-content {\n    order: 1;\n\n    >h2[id],\n    >h3[id],\n    >h4[id] {\n        pointer-events: none;\n\n        >div,\n        >a {\n            pointer-events: auto;\n        }\n\n        &::before {\n            display: block;\n            height: 6rem;\n            margin-top: -6rem;\n            visibility: hidden;\n            content: \"\";\n        }\n    }\n\n    >table {\n        width: 100%;\n        max-width: 100%;\n        margin-bottom: 1rem;\n\n        @include media-breakpoint-down(md) {\n            display: block;\n            overflow-x: auto;\n            -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\n            &.table-bordered {\n                border: 0;\n            }\n        } // Cells\n        >thead,\n        >tbody,\n        >tfoot {\n            >tr {\n                >th,\n                >td {\n                    padding: $table-cell-padding;\n                    vertical-align: top;\n                    border: 1px solid $table-border-color;\n\n                    >p:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        } // Prevent breaking of code (e.g., Grunt tasks list)\n        td:first-child>code {\n            white-space: nowrap;\n        }\n    }\n}\n\n//\n// Docs sections\n//\n.ct-content {\n    >h2:not(:first-child) {\n        margin-top: 3rem;\n        font-size: 1.5rem;\n        font-weight: $font-weight-bold;\n    }\n\n    >h3 {\n        margin-top: 2.5rem;\n        font-size: 1.25rem;\n        font-weight: $font-weight-bold;\n    }\n\n    >ul li,\n    >ol li {\n        margin-bottom: .25rem;\n    }\n\n    @include media-breakpoint-up(lg) {\n        >ul,\n        >ol,\n        >p {\n            max-width: 80%;\n        }\n    }\n}\n\n.ct-page-title {\n    padding-left: 1.25rem;\n    border-left: 2px solid $ct-primary;\n    margin-bottom: 1.5rem;\n}\n\n.ct-title {\n    margin-top: 1rem;\n    margin-bottom: .5rem;\n    font-weight: 300;\n\n    @include media-breakpoint-up(sm) {\n        font-size: 1.5rem;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.ct-lead {\n    color: rgb(59, 69, 78);\n    font-weight: 500;\n\n    @include media-breakpoint-up(sm) {\n        max-width: 80%;\n        margin-bottom: 1rem;\n        font-size: .875rem;\n    }\n}\n\n.ct-text-purple {\n    color: $ct-primary;\n}\n\n.ct-text-purple-bright {\n    color: $ct-primary-bright;\n}\n\n// Docs code example tabs\n.ct-tabs-example {\n    .nav-link i {\n        margin-right: 5px;\n    }\n}\n\n// Color swatches\n.color-swatch {\n    margin: 1rem 0;\n    border-radius: .25rem;\n    background-color: #F4F5F7;\n}\n\n.color-swatch:after {\n    content: \" \";\n    display: table;\n    clear: both;\n}\n\n.color-swatch-header {\n    position: relative;\n    height: 0;\n    padding-bottom: 50%;\n    border-radius: .25rem .25rem 0 0;\n    border: 1px solid transparent;\n}\n\n.color-swatch-header.is-light {\n    border-color: #C1C7D0;\n}\n\n.color-swatch-header .pass-fail {\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n}\n\n.color-swatch-header .pass-fail-item-wrap {\n    position: relative;\n    float: left;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.color-swatch-header .pass-fail-item-group {\n    display: inline-block;\n    padding: 0 5px;\n}\n\n.color-swatch-header .pass-fail-item {\n    float: left;\n    display: inline-block;\n    text-align: center;\n    padding: 2px;\n}\n\n.color-swatch-header .pass-fail-item.white .example {\n    color: #fff;\n}\n\n.color-swatch-header .pass-fail-item.small .example {\n    font-size: 10px;\n}\n\n.color-swatch-header .pass-fail-item .lozenge {\n    font-size: 11px;\n    text-transform: uppercase;\n    font-weight: 600;\n    background: #000;\n    color: #fff;\n    padding: 2px 4px;\n    line-height: 10px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n}\n\n.color-swatch-body {\n    position: relative;\n    left: 50%;\n    float: left;\n    padding: 10px 0;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.color-swatch-body .prop-item-wrap {\n    float: left;\n    padding: 0 15px;\n    min-width: 65px;\n}\n\n.color-swatch-body .prop-item {\n    padding: 15px 0;\n}\n\n.color-swatch-body .prop-item .label {\n    font-size: 11px;\n    color: #62748C;\n    text-transform: uppercase;\n    line-height: 16px;\n}\n\n.color-swatch-body .prop-item .value {\n    font-size: 14px;\n}\n\n.table-colors {\n    font-weight: 600;\n    font-size: 16px;\n    width: 100%;\n}\n\n.table-colors td,\n.table-colors:first-child td,\n.table-colors td:first-child,\n.table-colors:first-child td:first-child,\n.table-colors td:last-child,\n.table-colors:first-child td:last-child {\n    background: $ct-primary-light;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    padding: 10px;\n}\n\n.table-colors tr:last-child td,\n.table-colors:first-child tr:last-child td {\n    border-bottom: none;\n}\n\n.table-colors td:nth-child(1),\n.table-colors:first-child td:nth-child(1) {\n    line-height: 40px;\n}\n\n.table-colors .swatch,\n.table-colors:first-child .swatch {\n    float: left;\n    height: 40px;\n    width: 40px;\n    margin-right: 20px;\n    display: inline-block;\n    border-radius: 4px;\n    border: 1px solid transparent;\n}\n\n.table-colors .swatch.is-light,\n.table-colors:first-child .swatch.is-light {\n    border-color: #C1C7D0;\n}\n\n.table-colors .lozenge,\n.table-colors:first-child .lozenge {\n    float: left;\n    margin: 5px 10px 0 0;\n    font-size: 10px;\n    display: inline-block;\n    text-transform: uppercase;\n    font-weight: 600;\n    background: #97A0AF;\n    color: #042A53;\n    padding: 2px 4px;\n    line-height: 10px;\n    border-radius: 4px;\n    letter-spacing: 0.05em;\n}\n","// stylelint-disable declaration-no-important\n//\n// Right side table of contents\n//\n.ct-toc {\n    @supports (position: sticky) {\n        position: sticky;\n        top: 4rem;\n        height: calc(100vh - 4rem);\n        overflow-y: auto;\n    }\n    order: 2;\n    padding-top: 2rem;\n    padding-bottom: 1.5rem;\n    font-size: .875rem;\n}\n\n.section-nav {\n    padding-left: 0;\n    border-left: 1px solid #eee;\n\n    ul {\n        padding-left: 1rem;\n\n        ul {\n            display: none;\n        }\n    }\n}\n\n.toc-entry {\n    display: block;\n    font-size: 1rem;\n\n    a {\n        display: block;\n        padding: .125rem 1.5rem;\n        color: #99979c;\n        font-size: 90%;\n\n        &:hover {\n            color: $blue;\n            text-decoration: none;\n        }\n    }\n}\n\n//\n// Left side navigation\n//\n.ct-sidebar {\n    order: 0; // background-color: #f5f2f9;\n    border-bottom: 1px solid $ct-sidebar-border-color;\n    background-color: $ct-sidebar-bg;\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            position: sticky;\n            top: 4rem;\n            z-index: 1000;\n            height: calc(100vh - 4rem);\n        }\n        border-right: 1px solid $ct-sidebar-border-color;\n    }\n\n    @include media-breakpoint-up(xl) {\n        flex: 0 1 320px;\n    }\n}\n\n.ct-links {\n    padding-top: 2rem;\n    padding-bottom: 1rem;\n    margin-right: -15px;\n    margin-left: -15px;\n\n    @include media-breakpoint-up(md) {\n        @supports (position: sticky) {\n            max-height: calc(100vh - 5rem);\n            overflow-y: auto;\n        }\n    } // Override collapse behaviors\n    @include media-breakpoint-up(md) {\n        display: block !important;\n    }\n}\n\n.ct-search {\n    position: relative; // To contain the Algolia search\n    padding: 1rem 15px;\n    margin-right: -15px;\n    margin-left: -15px;\n    border-bottom: 1px solid rgba(0, 0, 0, .05);\n\n    .form-control:focus {\n        border-color: $ct-primary-bright;\n        box-shadow: 0 0 0 3px rgba($ct-primary-bright, .25);\n    }\n}\n\n.ct-search-docs-toggle {\n    line-height: 1;\n    color: $gray-900;\n}\n\n.ct-sidenav {\n    display: none;\n}\n\n.ct-toc-link {\n    display: block;\n    padding: .25rem 1.5rem;\n    font-weight: 600;\n    font-size: .875rem;\n    color: #0d2b3e;\n\n    &:hover {\n        color: rgba(0, 0, 0, .85);\n        text-decoration: none;\n    }\n}\n\n.ct-toc-item {\n    &.active {\n        margin-bottom: 1rem;\n\n        &:not(:first-child) {\n            margin-top: 1rem;\n        }\n\n        >.ct-toc-link {\n            color: rgba(0, 0, 0, .85);\n\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        >.ct-sidenav {\n            display: block;\n        }\n    }\n}\n\n// All levels of nav\n.ct-sidebar .nav>li>a {\n    display: block;\n    padding: .25rem 1.5rem;\n    font-size: 84%;\n    color: #4c555a;\n}\n\n.ct-sidebar .nav>li>a:hover {\n    color: rgba(0, 0, 0, .85);\n    text-decoration: none;\n    background-color: transparent;\n}\n\n.ct-sidebar .nav>.active>a {\n    font-weight: 500;\n    color: #0099e5;\n    background-color: transparent;\n    padding-left: 2rem;\n    position: relative;\n\n    &:before {\n        content: '';\n        position: absolute;\n        height: 16px;\n        width: 2px;\n        background-color: #0099e5;\n        top: 50%;\n        left: 1.5rem;\n        transform: translateY(-50%);\n    }\n}\n\n.ct-sidebar .nav>.active:hover>a {\n    color: #0099e5\n}\n\n\n.scrollbar-inner {\n    height: 100%;\n\n    &:not(:hover) .scroll-element {\n        opacity: 0;\n    }\n\n    .scroll-element {\n        transition: opacity 300ms;\n        margin-right: 2px;\n\n        .scroll-bar,\n        .scroll-element_track {\n            transition: background-color 300ms;\n        }\n\n        .scroll-element_track {\n            background-color: transparent;\n        }\n    }\n\n    .scroll-element.scroll-y {\n        width: 3px;\n        right: 0;\n    }\n\n    .scroll-element.scroll-x {\n        height: 3px;\n        bottom: 0;\n    }\n}\n","//\n// Footer\n//\n.ct-footer {\n    font-size: 85%;\n    text-align: center;\n    background-color: #f7f7f7;\n\n    a {\n        font-weight: 500;\n        color: $gray-700;\n\n        &:hover,\n        &:focus {\n            color: $link-color;\n        }\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    @include media-breakpoint-up(sm) {\n        text-align: left;\n    }\n}\n\n.ct-footer-links {\n    padding-left: 0;\n    margin-bottom: 1rem;\n\n    li {\n        display: inline-block;\n\n        +li {\n            margin-left: 1rem;\n        }\n    }\n}","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  padding: 20px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: .375rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: #ffffff;\n    border-bottom: 0.4em solid;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n  }\n  &:after {\n    border-bottom: 0.4em solid #ffffff;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: -5px;\n    left: 10px;\n  }\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n  &:before {\n    visibility: visible;\n    width: 100%;\n    height: 100%;\n    border-radius: 3px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font: normal normal normal 1em/1 \"Nucleo\";\n    font-size: 18px;\n    content: \"\\EA5E\";\n  }\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover,\n  &.start-date,\n  &.end-date,\n  &.middle-date,\n  &.start-date:hover,\n  &.end-date:hover,\n  &.middle-date:hover {\n    background-color: $info !important;\n    color: $white !important;\n  }\n  &.start-date{\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  &.middle-date{\n    border-radius: 0;\n  }\n  &.end-date{\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      font-size: 12px;\n      font-weight: inherit;\n      padding-bottom: 5px;\n      padding-top: 10px;\n      font-weight: 300;\n      font-size: .875rem;\n      width: 20px;\n      height: 20px;\n    }\n    .rdtDay {\n      color: $gray-700;\n      font-size: .875rem;\n      &.rdtOld,\n      &.rdtNew {\n        color: $gray-500;\n        font-weight: 300;\n      }\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker tr .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;font-weight: 500;\n  border-radius: .375rem;\n}\n.rdtPicker th.rdtSwitch {\n  font-weight: 500;\n  border-radius: .375rem;\n  font-size: .875rem;\n  width: 145px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: .875rem;\n  width: 36px;\n  height: 36px;\n  transition: all .15s ease;\n  text-align: center;\n  border: none;\n  border-radius: .375rem;\n  cursor: pointer;\n}\n\n.rdtPicker {\n  .dow,\n  th.rdtSwitch,\n  th.rdtNext,\n  th.rdtPrev,\n  .rdtTimeToggle {\n    color: $gray-700;\n  }\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: inherit;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $info;\n      border-radius: 50%;\n      border: 1px solid $info;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $gray-500;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive,\n    &.start-date,\n    &.end-date,\n    &.middle-date {\n      background-color: $info !important;\n      color: $white;\n    }\n  }\n}\n.input-group .input-group-prepend + .rdt .form-control{\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group .input-group-prepend + .rdt .form-control{\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rdt:not(:last-child) .form-control{\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-group .rdt {\n  width: 1%;\n  margin-bottom: 0;\n  flex: 1 1 auto;\n}\n",".btn{\n  .btn-inner--icon{\n    margin-right: 4px;\n  }\n}\n.btn + .btn {\n  margin-left: 4px;\n}\n","button:focus, :focus {\n  outline: none;\n}\n","@keyframes show-navbar-dropdown {\n  0% {\n    opacity: 0;\n    transition: visibility 0.25s, opacity 0.25s;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n",".navbar .collapsing .navbar-toggler{\n  pointer-events: none;\n}\n.navbar .nav-item .nav-link-icon.nav-link i{\n  margin-right: 4px;\n}\n",".table {\n  .avatar-group .avatar\n  {\n    margin-right: 4px;\n  }\n  .badge i{\n    margin-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
